import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  _bigint: any;
  _bytea: any;
  _citext: any;
  _float8: any;
  _jsonb: any;
  _timestamp: any;
  _timestamptz: any;
  _uuid: any;
  bigint: any;
  bytea: any;
  citext: any;
  date: any;
  float8: any;
  json: any;
  jsonb: any;
  numeric: any;
  timestamp: any;
  timestamptz: any;
  uuid: any;
};

/** Boolean expression to filter rows from the table "Account". All fields are combined with a logical 'AND'. */
export type Account_bool_exp = {
  API_Access__c?: InputMaybe<Boolean_comparison_exp>;
  API_NPS__c?: InputMaybe<float8_comparison_exp>;
  ATS_ARR__c?: InputMaybe<float8_comparison_exp>;
  ATS__c?: InputMaybe<Boolean_comparison_exp>;
  AWARDview_ARR__c?: InputMaybe<float8_comparison_exp>;
  AWARDview_Engagement_Manager__c?: InputMaybe<String_comparison_exp>;
  AWARDview_PS_Team__c?: InputMaybe<String_comparison_exp>;
  AWARDview_Renewal_Date__c?: InputMaybe<date_comparison_exp>;
  AWARDview_Start_Date__c?: InputMaybe<date_comparison_exp>;
  AWARDview_Support_Hours__c?: InputMaybe<float8_comparison_exp>;
  AWARDview__c?: InputMaybe<Boolean_comparison_exp>;
  AccountSource?: InputMaybe<String_comparison_exp>;
  Account_Id__c?: InputMaybe<String_comparison_exp>;
  Account_Manager__c?: InputMaybe<String_comparison_exp>;
  Account_Notes__c?: InputMaybe<String_comparison_exp>;
  Account_Status_Auto__c?: InputMaybe<String_comparison_exp>;
  AnnualRevenue?: InputMaybe<float8_comparison_exp>;
  Annual_Support_Hours__c?: InputMaybe<String_comparison_exp>;
  Auto_Renewal_2__c?: InputMaybe<Boolean_comparison_exp>;
  Auto_Renewal__c?: InputMaybe<Boolean_comparison_exp>;
  Average_NPS__c?: InputMaybe<float8_comparison_exp>;
  Base_Licenses__c?: InputMaybe<float8_comparison_exp>;
  BillingAddress?: InputMaybe<json_comparison_exp>;
  BillingCity?: InputMaybe<String_comparison_exp>;
  BillingCountry?: InputMaybe<String_comparison_exp>;
  BillingGeocodeAccuracy?: InputMaybe<String_comparison_exp>;
  BillingLatitude?: InputMaybe<float8_comparison_exp>;
  BillingLongitude?: InputMaybe<float8_comparison_exp>;
  BillingPostalCode?: InputMaybe<String_comparison_exp>;
  BillingState?: InputMaybe<String_comparison_exp>;
  BillingStreet?: InputMaybe<String_comparison_exp>;
  Billing_Amount_2__c?: InputMaybe<String_comparison_exp>;
  Billing_Amount__c?: InputMaybe<String_comparison_exp>;
  Billing_Currency__c?: InputMaybe<String_comparison_exp>;
  Billing_ETC__c?: InputMaybe<String_comparison_exp>;
  Billing_Notes__c?: InputMaybe<String_comparison_exp>;
  Billing_Terms_2__c?: InputMaybe<String_comparison_exp>;
  Billing_Terms__c?: InputMaybe<String_comparison_exp>;
  COMPview_ARR__c?: InputMaybe<float8_comparison_exp>;
  COMPview_Engagement_Manager__c?: InputMaybe<String_comparison_exp>;
  COMPview_PS_Team__c?: InputMaybe<String_comparison_exp>;
  COMPview_Renewal_Date__c?: InputMaybe<date_comparison_exp>;
  COMPview_Start_Date__c?: InputMaybe<date_comparison_exp>;
  COMPview_Support_Hours__c?: InputMaybe<float8_comparison_exp>;
  COMPview__c?: InputMaybe<Boolean_comparison_exp>;
  CONTENTview_ARR__c?: InputMaybe<float8_comparison_exp>;
  CONTENTview_Engagement_Manager__c?: InputMaybe<String_comparison_exp>;
  CONTENTview_PS_Team__c?: InputMaybe<String_comparison_exp>;
  CONTENTview_Renewal_Date__c?: InputMaybe<date_comparison_exp>;
  CONTENTview_Start_Date__c?: InputMaybe<date_comparison_exp>;
  CONTENTview_Support_Hours__c?: InputMaybe<float8_comparison_exp>;
  CONTENTview__c?: InputMaybe<Boolean_comparison_exp>;
  Churn_Date__c?: InputMaybe<date_comparison_exp>;
  Client_Number__c?: InputMaybe<String_comparison_exp>;
  Client_Self_Service__c?: InputMaybe<float8_comparison_exp>;
  Client_Start_Date__c?: InputMaybe<date_comparison_exp>;
  Close_Date__c?: InputMaybe<date_comparison_exp>;
  Compensation_System_in_Place__c?: InputMaybe<String_comparison_exp>;
  Configurability__c?: InputMaybe<float8_comparison_exp>;
  Contract_ETC__c?: InputMaybe<Boolean_comparison_exp>;
  Contract_Start_Date__c?: InputMaybe<date_comparison_exp>;
  Contract_Total_Value__c?: InputMaybe<String_comparison_exp>;
  Contract_UAT_Delivery_Estimate__c?: InputMaybe<timestamp_comparison_exp>;
  CreatedById?: InputMaybe<String_comparison_exp>;
  CreatedDate?: InputMaybe<timestamp_comparison_exp>;
  Current_Active__c?: InputMaybe<float8_comparison_exp>;
  Current_End_Date__c?: InputMaybe<date_comparison_exp>;
  Customer_Lifecycle_Stage__c?: InputMaybe<String_comparison_exp>;
  Data_Center_Location__c?: InputMaybe<String_comparison_exp>;
  Data_Feeds__c?: InputMaybe<float8_comparison_exp>;
  Date_las__c?: InputMaybe<date_comparison_exp>;
  Delivery_Assurance__c?: InputMaybe<float8_comparison_exp>;
  Description?: InputMaybe<String_comparison_exp>;
  Domain__c?: InputMaybe<String_comparison_exp>;
  Founded_Year__c?: InputMaybe<String_comparison_exp>;
  G2_Buyer_Intent_Details__c?: InputMaybe<String_comparison_exp>;
  G2_Intent__c?: InputMaybe<Boolean_comparison_exp>;
  G2_Survey_1__c?: InputMaybe<date_comparison_exp>;
  G2_Survey_2__c?: InputMaybe<date_comparison_exp>;
  HRIS_Version__c?: InputMaybe<String_comparison_exp>;
  HRIS__c?: InputMaybe<String_comparison_exp>;
  HR_Tech__c?: InputMaybe<String_comparison_exp>;
  Health_Score__c?: InputMaybe<String_comparison_exp>;
  HubSpot_Company_Id__c?: InputMaybe<String_comparison_exp>;
  HubSpot_Owner_Id__c?: InputMaybe<String_comparison_exp>;
  HubSpot_Owner_Name__c?: InputMaybe<String_comparison_exp>;
  INCENTview_ARR__c?: InputMaybe<float8_comparison_exp>;
  INCENTview_Engagement_Manager__c?: InputMaybe<String_comparison_exp>;
  INCENTview_PS_Team__c?: InputMaybe<String_comparison_exp>;
  INCENTview_Renewal_Date__c?: InputMaybe<date_comparison_exp>;
  INCENTview_Start_Date__c?: InputMaybe<date_comparison_exp>;
  INCENTview_Support_Hours__c?: InputMaybe<float8_comparison_exp>;
  Id?: InputMaybe<String_comparison_exp>;
  Incent__c?: InputMaybe<Boolean_comparison_exp>;
  Industry?: InputMaybe<String_comparison_exp>;
  International_Global__c?: InputMaybe<Boolean_comparison_exp>;
  IsDeleted?: InputMaybe<Boolean_comparison_exp>;
  Is_Public__c?: InputMaybe<Boolean_comparison_exp>;
  Jigsaw?: InputMaybe<String_comparison_exp>;
  JigsawCompanyId?: InputMaybe<String_comparison_exp>;
  Language_Paks_ARR__c?: InputMaybe<float8_comparison_exp>;
  Language_Paks__c?: InputMaybe<Boolean_comparison_exp>;
  LastActivityDate?: InputMaybe<date_comparison_exp>;
  LastModifiedById?: InputMaybe<String_comparison_exp>;
  LastModifiedDate?: InputMaybe<timestamp_comparison_exp>;
  LastReferencedDate?: InputMaybe<timestamp_comparison_exp>;
  LastViewedDate?: InputMaybe<timestamp_comparison_exp>;
  Last_After_Action_Review__c?: InputMaybe<date_comparison_exp>;
  Lifecycle_Stage__c?: InputMaybe<String_comparison_exp>;
  LinkedIn_Company_Page__c?: InputMaybe<String_comparison_exp>;
  MODELview_ARR__c?: InputMaybe<float8_comparison_exp>;
  MODELview_Engagement_Manager__c?: InputMaybe<String_comparison_exp>;
  MODELview_PS_Team__c?: InputMaybe<String_comparison_exp>;
  MODELview_Renewal_Date__c?: InputMaybe<date_comparison_exp>;
  MODELview_Start_Date__c?: InputMaybe<date_comparison_exp>;
  MODELview_Support_Hours__c?: InputMaybe<float8_comparison_exp>;
  MODELview__c?: InputMaybe<Boolean_comparison_exp>;
  MasterRecordId?: InputMaybe<String_comparison_exp>;
  Naics_Industry_Detail__c?: InputMaybe<String_comparison_exp>;
  Naics_Industry_Title__c?: InputMaybe<String_comparison_exp>;
  Naics__c?: InputMaybe<float8_comparison_exp>;
  Name?: InputMaybe<String_comparison_exp>;
  NumberOfEmployees?: InputMaybe<Int_comparison_exp>;
  Number_of_Users__c?: InputMaybe<String_comparison_exp>;
  OLS_ARR__c?: InputMaybe<float8_comparison_exp>;
  OLS__c?: InputMaybe<Boolean_comparison_exp>;
  OnlineStatements__c?: InputMaybe<Boolean_comparison_exp>;
  Online_Statements_ARR__c?: InputMaybe<float8_comparison_exp>;
  Overall_Satisfaction__c?: InputMaybe<float8_comparison_exp>;
  OwnerId?: InputMaybe<String_comparison_exp>;
  PAYview_ARR__c?: InputMaybe<float8_comparison_exp>;
  PAYview_Engagement_Manager__c?: InputMaybe<String_comparison_exp>;
  PAYview_PS_Team__c?: InputMaybe<String_comparison_exp>;
  PAYview_Renewal_Date__c?: InputMaybe<date_comparison_exp>;
  PAYview_Start_Date__c?: InputMaybe<date_comparison_exp>;
  PAYview_Support_Hours__c?: InputMaybe<float8_comparison_exp>;
  PAYview__c?: InputMaybe<Boolean_comparison_exp>;
  PERFORMview_ARR__c?: InputMaybe<float8_comparison_exp>;
  PERFORMview_Engagement_Manager__c?: InputMaybe<String_comparison_exp>;
  PERFORMview_PS_Team__c?: InputMaybe<String_comparison_exp>;
  PERFORMview_Renewal_Date__c?: InputMaybe<date_comparison_exp>;
  PERFORMview_Start_Date__c?: InputMaybe<date_comparison_exp>;
  PERFORMview_Support_Hours__c?: InputMaybe<float8_comparison_exp>;
  PERFORMview__c?: InputMaybe<Boolean_comparison_exp>;
  ParentId?: InputMaybe<String_comparison_exp>;
  PartnerContact__c?: InputMaybe<String_comparison_exp>;
  Performance__c?: InputMaybe<float8_comparison_exp>;
  Phone?: InputMaybe<String_comparison_exp>;
  PhotoUrl?: InputMaybe<String_comparison_exp>;
  Platform_Version__c?: InputMaybe<String_comparison_exp>;
  Predict_Proba__c?: InputMaybe<float8_comparison_exp>;
  Price_Value_Satisfaction__c?: InputMaybe<float8_comparison_exp>;
  Professional_Services_Package_Program__c?: InputMaybe<Boolean_comparison_exp>;
  Professional_Services_Rate_per_hr__c?: InputMaybe<float8_comparison_exp>;
  RECRUITview_ARR__c?: InputMaybe<float8_comparison_exp>;
  RECRUITview_Engagement_Manager__c?: InputMaybe<String_comparison_exp>;
  RECRUITview_PS_Team__c?: InputMaybe<String_comparison_exp>;
  RECRUITview_Renewal_Date__c?: InputMaybe<date_comparison_exp>;
  RECRUITview_Start_Date__c?: InputMaybe<date_comparison_exp>;
  RECRUITview_Support_Hours__c?: InputMaybe<float8_comparison_exp>;
  RECRUITview__c?: InputMaybe<Boolean_comparison_exp>;
  REWARDview_ARR__c?: InputMaybe<float8_comparison_exp>;
  REWARDview_Engagement_Manager__c?: InputMaybe<String_comparison_exp>;
  REWARDview_PS_Team__c?: InputMaybe<String_comparison_exp>;
  REWARDview_Renewal_Date__c?: InputMaybe<date_comparison_exp>;
  REWARDview_Start_Date__c?: InputMaybe<date_comparison_exp>;
  REWARDview_Support_Hours__c?: InputMaybe<float8_comparison_exp>;
  REWARDview__c?: InputMaybe<Boolean_comparison_exp>;
  Reference_N__c?: InputMaybe<String_comparison_exp>;
  Referenceable__c?: InputMaybe<Boolean_comparison_exp>;
  Renewal_Date_2__c?: InputMaybe<date_comparison_exp>;
  Renewal_Date__c?: InputMaybe<date_comparison_exp>;
  Renewal_Risk__c?: InputMaybe<String_comparison_exp>;
  Reporting__c?: InputMaybe<float8_comparison_exp>;
  Retention_Confidence__c?: InputMaybe<float8_comparison_exp>;
  Retention_Risk_Reasons__c?: InputMaybe<String_comparison_exp>;
  RevTron_ICP_Score_Formatted__c?: InputMaybe<float8_comparison_exp>;
  SSO_Provider__c?: InputMaybe<String_comparison_exp>;
  Security__c?: InputMaybe<float8_comparison_exp>;
  Segment__c?: InputMaybe<String_comparison_exp>;
  Self_Admin_Certified__c?: InputMaybe<Boolean_comparison_exp>;
  ShippingAddress?: InputMaybe<json_comparison_exp>;
  ShippingCity?: InputMaybe<String_comparison_exp>;
  ShippingCountry?: InputMaybe<String_comparison_exp>;
  ShippingGeocodeAccuracy?: InputMaybe<String_comparison_exp>;
  ShippingLatitude?: InputMaybe<float8_comparison_exp>;
  ShippingLongitude?: InputMaybe<float8_comparison_exp>;
  ShippingPostalCode?: InputMaybe<String_comparison_exp>;
  ShippingState?: InputMaybe<String_comparison_exp>;
  ShippingStreet?: InputMaybe<String_comparison_exp>;
  SicDesc?: InputMaybe<String_comparison_exp>;
  Support_Hours_Reset_Date__c?: InputMaybe<date_comparison_exp>;
  SystemModstamp?: InputMaybe<timestamp_comparison_exp>;
  Team_Collaboration__c?: InputMaybe<float8_comparison_exp>;
  Territory__c?: InputMaybe<String_comparison_exp>;
  TickerSymbol?: InputMaybe<String_comparison_exp>;
  Total_ARR__c?: InputMaybe<float8_comparison_exp>;
  Total_Money_Raised__c?: InputMaybe<String_comparison_exp>;
  Total_Support_Hours__c?: InputMaybe<float8_comparison_exp>;
  Type?: InputMaybe<String_comparison_exp>;
  UI_UX__c?: InputMaybe<float8_comparison_exp>;
  User_Conference_Attended__c?: InputMaybe<String_comparison_exp>;
  Website?: InputMaybe<String_comparison_exp>;
  _and?: InputMaybe<Array<Account_bool_exp>>;
  _not?: InputMaybe<Account_bool_exp>;
  _or?: InputMaybe<Array<Account_bool_exp>>;
  account_module_static?: InputMaybe<account_module_static_bool_exp>;
  to_Opportunity?: InputMaybe<Opportunity_bool_exp>;
  to_Opportunity_aggregate?: InputMaybe<Opportunity_aggregate_bool_exp>;
  to_icp_scores?: InputMaybe<ml_icp_account_bool_exp>;
  to_icp_scores_aggregate?: InputMaybe<ml_icp_account_aggregate_bool_exp>;
  to_revtron?: InputMaybe<crm_to_revtron_account_bool_exp>;
  to_revtron_testing?: InputMaybe<crm_to_revtron_account_bool_exp>;
  to_revtron_testing_aggregate?: InputMaybe<crm_to_revtron_account_aggregate_bool_exp>;
};

/** unique or primary key constraints on table "Account" */
export enum Account_constraint {
  /** unique or primary key constraint on columns "Id" */
  Account_pkey = "Account_pkey",
}

/** input type for incrementing numeric columns in table "Account" */
export type Account_inc_input = {
  API_NPS__c?: InputMaybe<Scalars["float8"]>;
  ATS_ARR__c?: InputMaybe<Scalars["float8"]>;
  AWARDview_ARR__c?: InputMaybe<Scalars["float8"]>;
  AWARDview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  AnnualRevenue?: InputMaybe<Scalars["float8"]>;
  Average_NPS__c?: InputMaybe<Scalars["float8"]>;
  Base_Licenses__c?: InputMaybe<Scalars["float8"]>;
  BillingLatitude?: InputMaybe<Scalars["float8"]>;
  BillingLongitude?: InputMaybe<Scalars["float8"]>;
  COMPview_ARR__c?: InputMaybe<Scalars["float8"]>;
  COMPview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  CONTENTview_ARR__c?: InputMaybe<Scalars["float8"]>;
  CONTENTview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  Client_Self_Service__c?: InputMaybe<Scalars["float8"]>;
  Configurability__c?: InputMaybe<Scalars["float8"]>;
  Current_Active__c?: InputMaybe<Scalars["float8"]>;
  Data_Feeds__c?: InputMaybe<Scalars["float8"]>;
  Delivery_Assurance__c?: InputMaybe<Scalars["float8"]>;
  INCENTview_ARR__c?: InputMaybe<Scalars["float8"]>;
  INCENTview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  Language_Paks_ARR__c?: InputMaybe<Scalars["float8"]>;
  MODELview_ARR__c?: InputMaybe<Scalars["float8"]>;
  MODELview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  Naics__c?: InputMaybe<Scalars["float8"]>;
  NumberOfEmployees?: InputMaybe<Scalars["Int"]>;
  OLS_ARR__c?: InputMaybe<Scalars["float8"]>;
  Online_Statements_ARR__c?: InputMaybe<Scalars["float8"]>;
  Overall_Satisfaction__c?: InputMaybe<Scalars["float8"]>;
  PAYview_ARR__c?: InputMaybe<Scalars["float8"]>;
  PAYview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  PERFORMview_ARR__c?: InputMaybe<Scalars["float8"]>;
  PERFORMview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  Performance__c?: InputMaybe<Scalars["float8"]>;
  Predict_Proba__c?: InputMaybe<Scalars["float8"]>;
  Price_Value_Satisfaction__c?: InputMaybe<Scalars["float8"]>;
  Professional_Services_Rate_per_hr__c?: InputMaybe<Scalars["float8"]>;
  RECRUITview_ARR__c?: InputMaybe<Scalars["float8"]>;
  RECRUITview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  REWARDview_ARR__c?: InputMaybe<Scalars["float8"]>;
  REWARDview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  Reporting__c?: InputMaybe<Scalars["float8"]>;
  Retention_Confidence__c?: InputMaybe<Scalars["float8"]>;
  RevTron_ICP_Score_Formatted__c?: InputMaybe<Scalars["float8"]>;
  Security__c?: InputMaybe<Scalars["float8"]>;
  ShippingLatitude?: InputMaybe<Scalars["float8"]>;
  ShippingLongitude?: InputMaybe<Scalars["float8"]>;
  Team_Collaboration__c?: InputMaybe<Scalars["float8"]>;
  Total_ARR__c?: InputMaybe<Scalars["float8"]>;
  Total_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  UI_UX__c?: InputMaybe<Scalars["float8"]>;
};

/** input type for inserting data into table "Account" */
export type Account_insert_input = {
  API_Access__c?: InputMaybe<Scalars["Boolean"]>;
  API_NPS__c?: InputMaybe<Scalars["float8"]>;
  ATS_ARR__c?: InputMaybe<Scalars["float8"]>;
  ATS__c?: InputMaybe<Scalars["Boolean"]>;
  AWARDview_ARR__c?: InputMaybe<Scalars["float8"]>;
  AWARDview_Engagement_Manager__c?: InputMaybe<Scalars["String"]>;
  AWARDview_PS_Team__c?: InputMaybe<Scalars["String"]>;
  AWARDview_Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  AWARDview_Start_Date__c?: InputMaybe<Scalars["date"]>;
  AWARDview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  AWARDview__c?: InputMaybe<Scalars["Boolean"]>;
  AccountSource?: InputMaybe<Scalars["String"]>;
  Account_Id__c?: InputMaybe<Scalars["String"]>;
  Account_Manager__c?: InputMaybe<Scalars["String"]>;
  Account_Notes__c?: InputMaybe<Scalars["String"]>;
  Account_Status_Auto__c?: InputMaybe<Scalars["String"]>;
  AnnualRevenue?: InputMaybe<Scalars["float8"]>;
  Annual_Support_Hours__c?: InputMaybe<Scalars["String"]>;
  Auto_Renewal_2__c?: InputMaybe<Scalars["Boolean"]>;
  Auto_Renewal__c?: InputMaybe<Scalars["Boolean"]>;
  Average_NPS__c?: InputMaybe<Scalars["float8"]>;
  Base_Licenses__c?: InputMaybe<Scalars["float8"]>;
  BillingAddress?: InputMaybe<Scalars["json"]>;
  BillingCity?: InputMaybe<Scalars["String"]>;
  BillingCountry?: InputMaybe<Scalars["String"]>;
  BillingGeocodeAccuracy?: InputMaybe<Scalars["String"]>;
  BillingLatitude?: InputMaybe<Scalars["float8"]>;
  BillingLongitude?: InputMaybe<Scalars["float8"]>;
  BillingPostalCode?: InputMaybe<Scalars["String"]>;
  BillingState?: InputMaybe<Scalars["String"]>;
  BillingStreet?: InputMaybe<Scalars["String"]>;
  Billing_Amount_2__c?: InputMaybe<Scalars["String"]>;
  Billing_Amount__c?: InputMaybe<Scalars["String"]>;
  Billing_Currency__c?: InputMaybe<Scalars["String"]>;
  Billing_ETC__c?: InputMaybe<Scalars["String"]>;
  Billing_Notes__c?: InputMaybe<Scalars["String"]>;
  Billing_Terms_2__c?: InputMaybe<Scalars["String"]>;
  Billing_Terms__c?: InputMaybe<Scalars["String"]>;
  COMPview_ARR__c?: InputMaybe<Scalars["float8"]>;
  COMPview_Engagement_Manager__c?: InputMaybe<Scalars["String"]>;
  COMPview_PS_Team__c?: InputMaybe<Scalars["String"]>;
  COMPview_Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  COMPview_Start_Date__c?: InputMaybe<Scalars["date"]>;
  COMPview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  COMPview__c?: InputMaybe<Scalars["Boolean"]>;
  CONTENTview_ARR__c?: InputMaybe<Scalars["float8"]>;
  CONTENTview_Engagement_Manager__c?: InputMaybe<Scalars["String"]>;
  CONTENTview_PS_Team__c?: InputMaybe<Scalars["String"]>;
  CONTENTview_Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  CONTENTview_Start_Date__c?: InputMaybe<Scalars["date"]>;
  CONTENTview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  CONTENTview__c?: InputMaybe<Scalars["Boolean"]>;
  Churn_Date__c?: InputMaybe<Scalars["date"]>;
  Client_Number__c?: InputMaybe<Scalars["String"]>;
  Client_Self_Service__c?: InputMaybe<Scalars["float8"]>;
  Client_Start_Date__c?: InputMaybe<Scalars["date"]>;
  Close_Date__c?: InputMaybe<Scalars["date"]>;
  Compensation_System_in_Place__c?: InputMaybe<Scalars["String"]>;
  Configurability__c?: InputMaybe<Scalars["float8"]>;
  Contract_ETC__c?: InputMaybe<Scalars["Boolean"]>;
  Contract_Start_Date__c?: InputMaybe<Scalars["date"]>;
  Contract_Total_Value__c?: InputMaybe<Scalars["String"]>;
  Contract_UAT_Delivery_Estimate__c?: InputMaybe<Scalars["timestamp"]>;
  CreatedById?: InputMaybe<Scalars["String"]>;
  CreatedDate?: InputMaybe<Scalars["timestamp"]>;
  Current_Active__c?: InputMaybe<Scalars["float8"]>;
  Current_End_Date__c?: InputMaybe<Scalars["date"]>;
  Customer_Lifecycle_Stage__c?: InputMaybe<Scalars["String"]>;
  Data_Center_Location__c?: InputMaybe<Scalars["String"]>;
  Data_Feeds__c?: InputMaybe<Scalars["float8"]>;
  Date_las__c?: InputMaybe<Scalars["date"]>;
  Delivery_Assurance__c?: InputMaybe<Scalars["float8"]>;
  Description?: InputMaybe<Scalars["String"]>;
  Domain__c?: InputMaybe<Scalars["String"]>;
  Founded_Year__c?: InputMaybe<Scalars["String"]>;
  G2_Buyer_Intent_Details__c?: InputMaybe<Scalars["String"]>;
  G2_Intent__c?: InputMaybe<Scalars["Boolean"]>;
  G2_Survey_1__c?: InputMaybe<Scalars["date"]>;
  G2_Survey_2__c?: InputMaybe<Scalars["date"]>;
  HRIS_Version__c?: InputMaybe<Scalars["String"]>;
  HRIS__c?: InputMaybe<Scalars["String"]>;
  HR_Tech__c?: InputMaybe<Scalars["String"]>;
  Health_Score__c?: InputMaybe<Scalars["String"]>;
  HubSpot_Company_Id__c?: InputMaybe<Scalars["String"]>;
  HubSpot_Owner_Id__c?: InputMaybe<Scalars["String"]>;
  HubSpot_Owner_Name__c?: InputMaybe<Scalars["String"]>;
  INCENTview_ARR__c?: InputMaybe<Scalars["float8"]>;
  INCENTview_Engagement_Manager__c?: InputMaybe<Scalars["String"]>;
  INCENTview_PS_Team__c?: InputMaybe<Scalars["String"]>;
  INCENTview_Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  INCENTview_Start_Date__c?: InputMaybe<Scalars["date"]>;
  INCENTview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  Id?: InputMaybe<Scalars["String"]>;
  Incent__c?: InputMaybe<Scalars["Boolean"]>;
  Industry?: InputMaybe<Scalars["String"]>;
  International_Global__c?: InputMaybe<Scalars["Boolean"]>;
  IsDeleted?: InputMaybe<Scalars["Boolean"]>;
  Is_Public__c?: InputMaybe<Scalars["Boolean"]>;
  Jigsaw?: InputMaybe<Scalars["String"]>;
  JigsawCompanyId?: InputMaybe<Scalars["String"]>;
  Language_Paks_ARR__c?: InputMaybe<Scalars["float8"]>;
  Language_Paks__c?: InputMaybe<Scalars["Boolean"]>;
  LastActivityDate?: InputMaybe<Scalars["date"]>;
  LastModifiedById?: InputMaybe<Scalars["String"]>;
  LastModifiedDate?: InputMaybe<Scalars["timestamp"]>;
  LastReferencedDate?: InputMaybe<Scalars["timestamp"]>;
  LastViewedDate?: InputMaybe<Scalars["timestamp"]>;
  Last_After_Action_Review__c?: InputMaybe<Scalars["date"]>;
  Lifecycle_Stage__c?: InputMaybe<Scalars["String"]>;
  LinkedIn_Company_Page__c?: InputMaybe<Scalars["String"]>;
  MODELview_ARR__c?: InputMaybe<Scalars["float8"]>;
  MODELview_Engagement_Manager__c?: InputMaybe<Scalars["String"]>;
  MODELview_PS_Team__c?: InputMaybe<Scalars["String"]>;
  MODELview_Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  MODELview_Start_Date__c?: InputMaybe<Scalars["date"]>;
  MODELview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  MODELview__c?: InputMaybe<Scalars["Boolean"]>;
  MasterRecordId?: InputMaybe<Scalars["String"]>;
  Naics_Industry_Detail__c?: InputMaybe<Scalars["String"]>;
  Naics_Industry_Title__c?: InputMaybe<Scalars["String"]>;
  Naics__c?: InputMaybe<Scalars["float8"]>;
  Name?: InputMaybe<Scalars["String"]>;
  NumberOfEmployees?: InputMaybe<Scalars["Int"]>;
  Number_of_Users__c?: InputMaybe<Scalars["String"]>;
  OLS_ARR__c?: InputMaybe<Scalars["float8"]>;
  OLS__c?: InputMaybe<Scalars["Boolean"]>;
  OnlineStatements__c?: InputMaybe<Scalars["Boolean"]>;
  Online_Statements_ARR__c?: InputMaybe<Scalars["float8"]>;
  Overall_Satisfaction__c?: InputMaybe<Scalars["float8"]>;
  OwnerId?: InputMaybe<Scalars["String"]>;
  PAYview_ARR__c?: InputMaybe<Scalars["float8"]>;
  PAYview_Engagement_Manager__c?: InputMaybe<Scalars["String"]>;
  PAYview_PS_Team__c?: InputMaybe<Scalars["String"]>;
  PAYview_Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  PAYview_Start_Date__c?: InputMaybe<Scalars["date"]>;
  PAYview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  PAYview__c?: InputMaybe<Scalars["Boolean"]>;
  PERFORMview_ARR__c?: InputMaybe<Scalars["float8"]>;
  PERFORMview_Engagement_Manager__c?: InputMaybe<Scalars["String"]>;
  PERFORMview_PS_Team__c?: InputMaybe<Scalars["String"]>;
  PERFORMview_Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  PERFORMview_Start_Date__c?: InputMaybe<Scalars["date"]>;
  PERFORMview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  PERFORMview__c?: InputMaybe<Scalars["Boolean"]>;
  ParentId?: InputMaybe<Scalars["String"]>;
  PartnerContact__c?: InputMaybe<Scalars["String"]>;
  Performance__c?: InputMaybe<Scalars["float8"]>;
  Phone?: InputMaybe<Scalars["String"]>;
  PhotoUrl?: InputMaybe<Scalars["String"]>;
  Platform_Version__c?: InputMaybe<Scalars["String"]>;
  Predict_Proba__c?: InputMaybe<Scalars["float8"]>;
  Price_Value_Satisfaction__c?: InputMaybe<Scalars["float8"]>;
  Professional_Services_Package_Program__c?: InputMaybe<Scalars["Boolean"]>;
  Professional_Services_Rate_per_hr__c?: InputMaybe<Scalars["float8"]>;
  RECRUITview_ARR__c?: InputMaybe<Scalars["float8"]>;
  RECRUITview_Engagement_Manager__c?: InputMaybe<Scalars["String"]>;
  RECRUITview_PS_Team__c?: InputMaybe<Scalars["String"]>;
  RECRUITview_Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  RECRUITview_Start_Date__c?: InputMaybe<Scalars["date"]>;
  RECRUITview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  RECRUITview__c?: InputMaybe<Scalars["Boolean"]>;
  REWARDview_ARR__c?: InputMaybe<Scalars["float8"]>;
  REWARDview_Engagement_Manager__c?: InputMaybe<Scalars["String"]>;
  REWARDview_PS_Team__c?: InputMaybe<Scalars["String"]>;
  REWARDview_Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  REWARDview_Start_Date__c?: InputMaybe<Scalars["date"]>;
  REWARDview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  REWARDview__c?: InputMaybe<Scalars["Boolean"]>;
  Reference_N__c?: InputMaybe<Scalars["String"]>;
  Referenceable__c?: InputMaybe<Scalars["Boolean"]>;
  Renewal_Date_2__c?: InputMaybe<Scalars["date"]>;
  Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  Renewal_Risk__c?: InputMaybe<Scalars["String"]>;
  Reporting__c?: InputMaybe<Scalars["float8"]>;
  Retention_Confidence__c?: InputMaybe<Scalars["float8"]>;
  Retention_Risk_Reasons__c?: InputMaybe<Scalars["String"]>;
  RevTron_ICP_Score_Formatted__c?: InputMaybe<Scalars["float8"]>;
  SSO_Provider__c?: InputMaybe<Scalars["String"]>;
  Security__c?: InputMaybe<Scalars["float8"]>;
  Segment__c?: InputMaybe<Scalars["String"]>;
  Self_Admin_Certified__c?: InputMaybe<Scalars["Boolean"]>;
  ShippingAddress?: InputMaybe<Scalars["json"]>;
  ShippingCity?: InputMaybe<Scalars["String"]>;
  ShippingCountry?: InputMaybe<Scalars["String"]>;
  ShippingGeocodeAccuracy?: InputMaybe<Scalars["String"]>;
  ShippingLatitude?: InputMaybe<Scalars["float8"]>;
  ShippingLongitude?: InputMaybe<Scalars["float8"]>;
  ShippingPostalCode?: InputMaybe<Scalars["String"]>;
  ShippingState?: InputMaybe<Scalars["String"]>;
  ShippingStreet?: InputMaybe<Scalars["String"]>;
  SicDesc?: InputMaybe<Scalars["String"]>;
  Support_Hours_Reset_Date__c?: InputMaybe<Scalars["date"]>;
  SystemModstamp?: InputMaybe<Scalars["timestamp"]>;
  Team_Collaboration__c?: InputMaybe<Scalars["float8"]>;
  Territory__c?: InputMaybe<Scalars["String"]>;
  TickerSymbol?: InputMaybe<Scalars["String"]>;
  Total_ARR__c?: InputMaybe<Scalars["float8"]>;
  Total_Money_Raised__c?: InputMaybe<Scalars["String"]>;
  Total_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  Type?: InputMaybe<Scalars["String"]>;
  UI_UX__c?: InputMaybe<Scalars["float8"]>;
  User_Conference_Attended__c?: InputMaybe<Scalars["String"]>;
  Website?: InputMaybe<Scalars["String"]>;
  account_module_static?: InputMaybe<account_module_static_obj_rel_insert_input>;
  to_Opportunity?: InputMaybe<Opportunity_arr_rel_insert_input>;
  to_icp_scores?: InputMaybe<ml_icp_account_arr_rel_insert_input>;
  to_revtron?: InputMaybe<crm_to_revtron_account_obj_rel_insert_input>;
  to_revtron_testing?: InputMaybe<crm_to_revtron_account_arr_rel_insert_input>;
};

/** on_conflict condition type for table "Account" */
export type Account_on_conflict = {
  constraint: Account_constraint;
  update_columns?: Array<Account_update_column>;
  where?: InputMaybe<Account_bool_exp>;
};

/** Ordering options when selecting data from "Account". */
export type Account_order_by = {
  API_Access__c?: InputMaybe<order_by>;
  API_NPS__c?: InputMaybe<order_by>;
  ATS_ARR__c?: InputMaybe<order_by>;
  ATS__c?: InputMaybe<order_by>;
  AWARDview_ARR__c?: InputMaybe<order_by>;
  AWARDview_Engagement_Manager__c?: InputMaybe<order_by>;
  AWARDview_PS_Team__c?: InputMaybe<order_by>;
  AWARDview_Renewal_Date__c?: InputMaybe<order_by>;
  AWARDview_Start_Date__c?: InputMaybe<order_by>;
  AWARDview_Support_Hours__c?: InputMaybe<order_by>;
  AWARDview__c?: InputMaybe<order_by>;
  AccountSource?: InputMaybe<order_by>;
  Account_Id__c?: InputMaybe<order_by>;
  Account_Manager__c?: InputMaybe<order_by>;
  Account_Notes__c?: InputMaybe<order_by>;
  Account_Status_Auto__c?: InputMaybe<order_by>;
  AnnualRevenue?: InputMaybe<order_by>;
  Annual_Support_Hours__c?: InputMaybe<order_by>;
  Auto_Renewal_2__c?: InputMaybe<order_by>;
  Auto_Renewal__c?: InputMaybe<order_by>;
  Average_NPS__c?: InputMaybe<order_by>;
  Base_Licenses__c?: InputMaybe<order_by>;
  BillingAddress?: InputMaybe<order_by>;
  BillingCity?: InputMaybe<order_by>;
  BillingCountry?: InputMaybe<order_by>;
  BillingGeocodeAccuracy?: InputMaybe<order_by>;
  BillingLatitude?: InputMaybe<order_by>;
  BillingLongitude?: InputMaybe<order_by>;
  BillingPostalCode?: InputMaybe<order_by>;
  BillingState?: InputMaybe<order_by>;
  BillingStreet?: InputMaybe<order_by>;
  Billing_Amount_2__c?: InputMaybe<order_by>;
  Billing_Amount__c?: InputMaybe<order_by>;
  Billing_Currency__c?: InputMaybe<order_by>;
  Billing_ETC__c?: InputMaybe<order_by>;
  Billing_Notes__c?: InputMaybe<order_by>;
  Billing_Terms_2__c?: InputMaybe<order_by>;
  Billing_Terms__c?: InputMaybe<order_by>;
  COMPview_ARR__c?: InputMaybe<order_by>;
  COMPview_Engagement_Manager__c?: InputMaybe<order_by>;
  COMPview_PS_Team__c?: InputMaybe<order_by>;
  COMPview_Renewal_Date__c?: InputMaybe<order_by>;
  COMPview_Start_Date__c?: InputMaybe<order_by>;
  COMPview_Support_Hours__c?: InputMaybe<order_by>;
  COMPview__c?: InputMaybe<order_by>;
  CONTENTview_ARR__c?: InputMaybe<order_by>;
  CONTENTview_Engagement_Manager__c?: InputMaybe<order_by>;
  CONTENTview_PS_Team__c?: InputMaybe<order_by>;
  CONTENTview_Renewal_Date__c?: InputMaybe<order_by>;
  CONTENTview_Start_Date__c?: InputMaybe<order_by>;
  CONTENTview_Support_Hours__c?: InputMaybe<order_by>;
  CONTENTview__c?: InputMaybe<order_by>;
  Churn_Date__c?: InputMaybe<order_by>;
  Client_Number__c?: InputMaybe<order_by>;
  Client_Self_Service__c?: InputMaybe<order_by>;
  Client_Start_Date__c?: InputMaybe<order_by>;
  Close_Date__c?: InputMaybe<order_by>;
  Compensation_System_in_Place__c?: InputMaybe<order_by>;
  Configurability__c?: InputMaybe<order_by>;
  Contract_ETC__c?: InputMaybe<order_by>;
  Contract_Start_Date__c?: InputMaybe<order_by>;
  Contract_Total_Value__c?: InputMaybe<order_by>;
  Contract_UAT_Delivery_Estimate__c?: InputMaybe<order_by>;
  CreatedById?: InputMaybe<order_by>;
  CreatedDate?: InputMaybe<order_by>;
  Current_Active__c?: InputMaybe<order_by>;
  Current_End_Date__c?: InputMaybe<order_by>;
  Customer_Lifecycle_Stage__c?: InputMaybe<order_by>;
  Data_Center_Location__c?: InputMaybe<order_by>;
  Data_Feeds__c?: InputMaybe<order_by>;
  Date_las__c?: InputMaybe<order_by>;
  Delivery_Assurance__c?: InputMaybe<order_by>;
  Description?: InputMaybe<order_by>;
  Domain__c?: InputMaybe<order_by>;
  Founded_Year__c?: InputMaybe<order_by>;
  G2_Buyer_Intent_Details__c?: InputMaybe<order_by>;
  G2_Intent__c?: InputMaybe<order_by>;
  G2_Survey_1__c?: InputMaybe<order_by>;
  G2_Survey_2__c?: InputMaybe<order_by>;
  HRIS_Version__c?: InputMaybe<order_by>;
  HRIS__c?: InputMaybe<order_by>;
  HR_Tech__c?: InputMaybe<order_by>;
  Health_Score__c?: InputMaybe<order_by>;
  HubSpot_Company_Id__c?: InputMaybe<order_by>;
  HubSpot_Owner_Id__c?: InputMaybe<order_by>;
  HubSpot_Owner_Name__c?: InputMaybe<order_by>;
  INCENTview_ARR__c?: InputMaybe<order_by>;
  INCENTview_Engagement_Manager__c?: InputMaybe<order_by>;
  INCENTview_PS_Team__c?: InputMaybe<order_by>;
  INCENTview_Renewal_Date__c?: InputMaybe<order_by>;
  INCENTview_Start_Date__c?: InputMaybe<order_by>;
  INCENTview_Support_Hours__c?: InputMaybe<order_by>;
  Id?: InputMaybe<order_by>;
  Incent__c?: InputMaybe<order_by>;
  Industry?: InputMaybe<order_by>;
  International_Global__c?: InputMaybe<order_by>;
  IsDeleted?: InputMaybe<order_by>;
  Is_Public__c?: InputMaybe<order_by>;
  Jigsaw?: InputMaybe<order_by>;
  JigsawCompanyId?: InputMaybe<order_by>;
  Language_Paks_ARR__c?: InputMaybe<order_by>;
  Language_Paks__c?: InputMaybe<order_by>;
  LastActivityDate?: InputMaybe<order_by>;
  LastModifiedById?: InputMaybe<order_by>;
  LastModifiedDate?: InputMaybe<order_by>;
  LastReferencedDate?: InputMaybe<order_by>;
  LastViewedDate?: InputMaybe<order_by>;
  Last_After_Action_Review__c?: InputMaybe<order_by>;
  Lifecycle_Stage__c?: InputMaybe<order_by>;
  LinkedIn_Company_Page__c?: InputMaybe<order_by>;
  MODELview_ARR__c?: InputMaybe<order_by>;
  MODELview_Engagement_Manager__c?: InputMaybe<order_by>;
  MODELview_PS_Team__c?: InputMaybe<order_by>;
  MODELview_Renewal_Date__c?: InputMaybe<order_by>;
  MODELview_Start_Date__c?: InputMaybe<order_by>;
  MODELview_Support_Hours__c?: InputMaybe<order_by>;
  MODELview__c?: InputMaybe<order_by>;
  MasterRecordId?: InputMaybe<order_by>;
  Naics_Industry_Detail__c?: InputMaybe<order_by>;
  Naics_Industry_Title__c?: InputMaybe<order_by>;
  Naics__c?: InputMaybe<order_by>;
  Name?: InputMaybe<order_by>;
  NumberOfEmployees?: InputMaybe<order_by>;
  Number_of_Users__c?: InputMaybe<order_by>;
  OLS_ARR__c?: InputMaybe<order_by>;
  OLS__c?: InputMaybe<order_by>;
  OnlineStatements__c?: InputMaybe<order_by>;
  Online_Statements_ARR__c?: InputMaybe<order_by>;
  Overall_Satisfaction__c?: InputMaybe<order_by>;
  OwnerId?: InputMaybe<order_by>;
  PAYview_ARR__c?: InputMaybe<order_by>;
  PAYview_Engagement_Manager__c?: InputMaybe<order_by>;
  PAYview_PS_Team__c?: InputMaybe<order_by>;
  PAYview_Renewal_Date__c?: InputMaybe<order_by>;
  PAYview_Start_Date__c?: InputMaybe<order_by>;
  PAYview_Support_Hours__c?: InputMaybe<order_by>;
  PAYview__c?: InputMaybe<order_by>;
  PERFORMview_ARR__c?: InputMaybe<order_by>;
  PERFORMview_Engagement_Manager__c?: InputMaybe<order_by>;
  PERFORMview_PS_Team__c?: InputMaybe<order_by>;
  PERFORMview_Renewal_Date__c?: InputMaybe<order_by>;
  PERFORMview_Start_Date__c?: InputMaybe<order_by>;
  PERFORMview_Support_Hours__c?: InputMaybe<order_by>;
  PERFORMview__c?: InputMaybe<order_by>;
  ParentId?: InputMaybe<order_by>;
  PartnerContact__c?: InputMaybe<order_by>;
  Performance__c?: InputMaybe<order_by>;
  Phone?: InputMaybe<order_by>;
  PhotoUrl?: InputMaybe<order_by>;
  Platform_Version__c?: InputMaybe<order_by>;
  Predict_Proba__c?: InputMaybe<order_by>;
  Price_Value_Satisfaction__c?: InputMaybe<order_by>;
  Professional_Services_Package_Program__c?: InputMaybe<order_by>;
  Professional_Services_Rate_per_hr__c?: InputMaybe<order_by>;
  RECRUITview_ARR__c?: InputMaybe<order_by>;
  RECRUITview_Engagement_Manager__c?: InputMaybe<order_by>;
  RECRUITview_PS_Team__c?: InputMaybe<order_by>;
  RECRUITview_Renewal_Date__c?: InputMaybe<order_by>;
  RECRUITview_Start_Date__c?: InputMaybe<order_by>;
  RECRUITview_Support_Hours__c?: InputMaybe<order_by>;
  RECRUITview__c?: InputMaybe<order_by>;
  REWARDview_ARR__c?: InputMaybe<order_by>;
  REWARDview_Engagement_Manager__c?: InputMaybe<order_by>;
  REWARDview_PS_Team__c?: InputMaybe<order_by>;
  REWARDview_Renewal_Date__c?: InputMaybe<order_by>;
  REWARDview_Start_Date__c?: InputMaybe<order_by>;
  REWARDview_Support_Hours__c?: InputMaybe<order_by>;
  REWARDview__c?: InputMaybe<order_by>;
  Reference_N__c?: InputMaybe<order_by>;
  Referenceable__c?: InputMaybe<order_by>;
  Renewal_Date_2__c?: InputMaybe<order_by>;
  Renewal_Date__c?: InputMaybe<order_by>;
  Renewal_Risk__c?: InputMaybe<order_by>;
  Reporting__c?: InputMaybe<order_by>;
  Retention_Confidence__c?: InputMaybe<order_by>;
  Retention_Risk_Reasons__c?: InputMaybe<order_by>;
  RevTron_ICP_Score_Formatted__c?: InputMaybe<order_by>;
  SSO_Provider__c?: InputMaybe<order_by>;
  Security__c?: InputMaybe<order_by>;
  Segment__c?: InputMaybe<order_by>;
  Self_Admin_Certified__c?: InputMaybe<order_by>;
  ShippingAddress?: InputMaybe<order_by>;
  ShippingCity?: InputMaybe<order_by>;
  ShippingCountry?: InputMaybe<order_by>;
  ShippingGeocodeAccuracy?: InputMaybe<order_by>;
  ShippingLatitude?: InputMaybe<order_by>;
  ShippingLongitude?: InputMaybe<order_by>;
  ShippingPostalCode?: InputMaybe<order_by>;
  ShippingState?: InputMaybe<order_by>;
  ShippingStreet?: InputMaybe<order_by>;
  SicDesc?: InputMaybe<order_by>;
  Support_Hours_Reset_Date__c?: InputMaybe<order_by>;
  SystemModstamp?: InputMaybe<order_by>;
  Team_Collaboration__c?: InputMaybe<order_by>;
  Territory__c?: InputMaybe<order_by>;
  TickerSymbol?: InputMaybe<order_by>;
  Total_ARR__c?: InputMaybe<order_by>;
  Total_Money_Raised__c?: InputMaybe<order_by>;
  Total_Support_Hours__c?: InputMaybe<order_by>;
  Type?: InputMaybe<order_by>;
  UI_UX__c?: InputMaybe<order_by>;
  User_Conference_Attended__c?: InputMaybe<order_by>;
  Website?: InputMaybe<order_by>;
  account_module_static?: InputMaybe<account_module_static_order_by>;
  to_Opportunity_aggregate?: InputMaybe<Opportunity_aggregate_order_by>;
  to_icp_scores_aggregate?: InputMaybe<ml_icp_account_aggregate_order_by>;
  to_revtron?: InputMaybe<crm_to_revtron_account_order_by>;
  to_revtron_testing_aggregate?: InputMaybe<crm_to_revtron_account_aggregate_order_by>;
};

/** primary key columns input for table: Account */
export type Account_pk_columns_input = {
  Id: Scalars["String"];
};

/** select columns of table "Account" */
export enum Account_select_column {
  /** column name */
  API_Access__c = "API_Access__c",
  /** column name */
  API_NPS__c = "API_NPS__c",
  /** column name */
  ATS_ARR__c = "ATS_ARR__c",
  /** column name */
  ATS__c = "ATS__c",
  /** column name */
  AWARDview_ARR__c = "AWARDview_ARR__c",
  /** column name */
  AWARDview_Engagement_Manager__c = "AWARDview_Engagement_Manager__c",
  /** column name */
  AWARDview_PS_Team__c = "AWARDview_PS_Team__c",
  /** column name */
  AWARDview_Renewal_Date__c = "AWARDview_Renewal_Date__c",
  /** column name */
  AWARDview_Start_Date__c = "AWARDview_Start_Date__c",
  /** column name */
  AWARDview_Support_Hours__c = "AWARDview_Support_Hours__c",
  /** column name */
  AWARDview__c = "AWARDview__c",
  /** column name */
  AccountSource = "AccountSource",
  /** column name */
  Account_Id__c = "Account_Id__c",
  /** column name */
  Account_Manager__c = "Account_Manager__c",
  /** column name */
  Account_Notes__c = "Account_Notes__c",
  /** column name */
  Account_Status_Auto__c = "Account_Status_Auto__c",
  /** column name */
  AnnualRevenue = "AnnualRevenue",
  /** column name */
  Annual_Support_Hours__c = "Annual_Support_Hours__c",
  /** column name */
  Auto_Renewal_2__c = "Auto_Renewal_2__c",
  /** column name */
  Auto_Renewal__c = "Auto_Renewal__c",
  /** column name */
  Average_NPS__c = "Average_NPS__c",
  /** column name */
  Base_Licenses__c = "Base_Licenses__c",
  /** column name */
  BillingAddress = "BillingAddress",
  /** column name */
  BillingCity = "BillingCity",
  /** column name */
  BillingCountry = "BillingCountry",
  /** column name */
  BillingGeocodeAccuracy = "BillingGeocodeAccuracy",
  /** column name */
  BillingLatitude = "BillingLatitude",
  /** column name */
  BillingLongitude = "BillingLongitude",
  /** column name */
  BillingPostalCode = "BillingPostalCode",
  /** column name */
  BillingState = "BillingState",
  /** column name */
  BillingStreet = "BillingStreet",
  /** column name */
  Billing_Amount_2__c = "Billing_Amount_2__c",
  /** column name */
  Billing_Amount__c = "Billing_Amount__c",
  /** column name */
  Billing_Currency__c = "Billing_Currency__c",
  /** column name */
  Billing_ETC__c = "Billing_ETC__c",
  /** column name */
  Billing_Notes__c = "Billing_Notes__c",
  /** column name */
  Billing_Terms_2__c = "Billing_Terms_2__c",
  /** column name */
  Billing_Terms__c = "Billing_Terms__c",
  /** column name */
  COMPview_ARR__c = "COMPview_ARR__c",
  /** column name */
  COMPview_Engagement_Manager__c = "COMPview_Engagement_Manager__c",
  /** column name */
  COMPview_PS_Team__c = "COMPview_PS_Team__c",
  /** column name */
  COMPview_Renewal_Date__c = "COMPview_Renewal_Date__c",
  /** column name */
  COMPview_Start_Date__c = "COMPview_Start_Date__c",
  /** column name */
  COMPview_Support_Hours__c = "COMPview_Support_Hours__c",
  /** column name */
  COMPview__c = "COMPview__c",
  /** column name */
  CONTENTview_ARR__c = "CONTENTview_ARR__c",
  /** column name */
  CONTENTview_Engagement_Manager__c = "CONTENTview_Engagement_Manager__c",
  /** column name */
  CONTENTview_PS_Team__c = "CONTENTview_PS_Team__c",
  /** column name */
  CONTENTview_Renewal_Date__c = "CONTENTview_Renewal_Date__c",
  /** column name */
  CONTENTview_Start_Date__c = "CONTENTview_Start_Date__c",
  /** column name */
  CONTENTview_Support_Hours__c = "CONTENTview_Support_Hours__c",
  /** column name */
  CONTENTview__c = "CONTENTview__c",
  /** column name */
  Churn_Date__c = "Churn_Date__c",
  /** column name */
  Client_Number__c = "Client_Number__c",
  /** column name */
  Client_Self_Service__c = "Client_Self_Service__c",
  /** column name */
  Client_Start_Date__c = "Client_Start_Date__c",
  /** column name */
  Close_Date__c = "Close_Date__c",
  /** column name */
  Compensation_System_in_Place__c = "Compensation_System_in_Place__c",
  /** column name */
  Configurability__c = "Configurability__c",
  /** column name */
  Contract_ETC__c = "Contract_ETC__c",
  /** column name */
  Contract_Start_Date__c = "Contract_Start_Date__c",
  /** column name */
  Contract_Total_Value__c = "Contract_Total_Value__c",
  /** column name */
  Contract_UAT_Delivery_Estimate__c = "Contract_UAT_Delivery_Estimate__c",
  /** column name */
  CreatedById = "CreatedById",
  /** column name */
  CreatedDate = "CreatedDate",
  /** column name */
  Current_Active__c = "Current_Active__c",
  /** column name */
  Current_End_Date__c = "Current_End_Date__c",
  /** column name */
  Customer_Lifecycle_Stage__c = "Customer_Lifecycle_Stage__c",
  /** column name */
  Data_Center_Location__c = "Data_Center_Location__c",
  /** column name */
  Data_Feeds__c = "Data_Feeds__c",
  /** column name */
  Date_las__c = "Date_las__c",
  /** column name */
  Delivery_Assurance__c = "Delivery_Assurance__c",
  /** column name */
  Description = "Description",
  /** column name */
  Domain__c = "Domain__c",
  /** column name */
  Founded_Year__c = "Founded_Year__c",
  /** column name */
  G2_Buyer_Intent_Details__c = "G2_Buyer_Intent_Details__c",
  /** column name */
  G2_Intent__c = "G2_Intent__c",
  /** column name */
  G2_Survey_1__c = "G2_Survey_1__c",
  /** column name */
  G2_Survey_2__c = "G2_Survey_2__c",
  /** column name */
  HRIS_Version__c = "HRIS_Version__c",
  /** column name */
  HRIS__c = "HRIS__c",
  /** column name */
  HR_Tech__c = "HR_Tech__c",
  /** column name */
  Health_Score__c = "Health_Score__c",
  /** column name */
  HubSpot_Company_Id__c = "HubSpot_Company_Id__c",
  /** column name */
  HubSpot_Owner_Id__c = "HubSpot_Owner_Id__c",
  /** column name */
  HubSpot_Owner_Name__c = "HubSpot_Owner_Name__c",
  /** column name */
  INCENTview_ARR__c = "INCENTview_ARR__c",
  /** column name */
  INCENTview_Engagement_Manager__c = "INCENTview_Engagement_Manager__c",
  /** column name */
  INCENTview_PS_Team__c = "INCENTview_PS_Team__c",
  /** column name */
  INCENTview_Renewal_Date__c = "INCENTview_Renewal_Date__c",
  /** column name */
  INCENTview_Start_Date__c = "INCENTview_Start_Date__c",
  /** column name */
  INCENTview_Support_Hours__c = "INCENTview_Support_Hours__c",
  /** column name */
  Id = "Id",
  /** column name */
  Incent__c = "Incent__c",
  /** column name */
  Industry = "Industry",
  /** column name */
  International_Global__c = "International_Global__c",
  /** column name */
  IsDeleted = "IsDeleted",
  /** column name */
  Is_Public__c = "Is_Public__c",
  /** column name */
  Jigsaw = "Jigsaw",
  /** column name */
  JigsawCompanyId = "JigsawCompanyId",
  /** column name */
  Language_Paks_ARR__c = "Language_Paks_ARR__c",
  /** column name */
  Language_Paks__c = "Language_Paks__c",
  /** column name */
  LastActivityDate = "LastActivityDate",
  /** column name */
  LastModifiedById = "LastModifiedById",
  /** column name */
  LastModifiedDate = "LastModifiedDate",
  /** column name */
  LastReferencedDate = "LastReferencedDate",
  /** column name */
  LastViewedDate = "LastViewedDate",
  /** column name */
  Last_After_Action_Review__c = "Last_After_Action_Review__c",
  /** column name */
  Lifecycle_Stage__c = "Lifecycle_Stage__c",
  /** column name */
  LinkedIn_Company_Page__c = "LinkedIn_Company_Page__c",
  /** column name */
  MODELview_ARR__c = "MODELview_ARR__c",
  /** column name */
  MODELview_Engagement_Manager__c = "MODELview_Engagement_Manager__c",
  /** column name */
  MODELview_PS_Team__c = "MODELview_PS_Team__c",
  /** column name */
  MODELview_Renewal_Date__c = "MODELview_Renewal_Date__c",
  /** column name */
  MODELview_Start_Date__c = "MODELview_Start_Date__c",
  /** column name */
  MODELview_Support_Hours__c = "MODELview_Support_Hours__c",
  /** column name */
  MODELview__c = "MODELview__c",
  /** column name */
  MasterRecordId = "MasterRecordId",
  /** column name */
  Naics_Industry_Detail__c = "Naics_Industry_Detail__c",
  /** column name */
  Naics_Industry_Title__c = "Naics_Industry_Title__c",
  /** column name */
  Naics__c = "Naics__c",
  /** column name */
  Name = "Name",
  /** column name */
  NumberOfEmployees = "NumberOfEmployees",
  /** column name */
  Number_of_Users__c = "Number_of_Users__c",
  /** column name */
  OLS_ARR__c = "OLS_ARR__c",
  /** column name */
  OLS__c = "OLS__c",
  /** column name */
  OnlineStatements__c = "OnlineStatements__c",
  /** column name */
  Online_Statements_ARR__c = "Online_Statements_ARR__c",
  /** column name */
  Overall_Satisfaction__c = "Overall_Satisfaction__c",
  /** column name */
  OwnerId = "OwnerId",
  /** column name */
  PAYview_ARR__c = "PAYview_ARR__c",
  /** column name */
  PAYview_Engagement_Manager__c = "PAYview_Engagement_Manager__c",
  /** column name */
  PAYview_PS_Team__c = "PAYview_PS_Team__c",
  /** column name */
  PAYview_Renewal_Date__c = "PAYview_Renewal_Date__c",
  /** column name */
  PAYview_Start_Date__c = "PAYview_Start_Date__c",
  /** column name */
  PAYview_Support_Hours__c = "PAYview_Support_Hours__c",
  /** column name */
  PAYview__c = "PAYview__c",
  /** column name */
  PERFORMview_ARR__c = "PERFORMview_ARR__c",
  /** column name */
  PERFORMview_Engagement_Manager__c = "PERFORMview_Engagement_Manager__c",
  /** column name */
  PERFORMview_PS_Team__c = "PERFORMview_PS_Team__c",
  /** column name */
  PERFORMview_Renewal_Date__c = "PERFORMview_Renewal_Date__c",
  /** column name */
  PERFORMview_Start_Date__c = "PERFORMview_Start_Date__c",
  /** column name */
  PERFORMview_Support_Hours__c = "PERFORMview_Support_Hours__c",
  /** column name */
  PERFORMview__c = "PERFORMview__c",
  /** column name */
  ParentId = "ParentId",
  /** column name */
  PartnerContact__c = "PartnerContact__c",
  /** column name */
  Performance__c = "Performance__c",
  /** column name */
  Phone = "Phone",
  /** column name */
  PhotoUrl = "PhotoUrl",
  /** column name */
  Platform_Version__c = "Platform_Version__c",
  /** column name */
  Predict_Proba__c = "Predict_Proba__c",
  /** column name */
  Price_Value_Satisfaction__c = "Price_Value_Satisfaction__c",
  /** column name */
  Professional_Services_Package_Program__c = "Professional_Services_Package_Program__c",
  /** column name */
  Professional_Services_Rate_per_hr__c = "Professional_Services_Rate_per_hr__c",
  /** column name */
  RECRUITview_ARR__c = "RECRUITview_ARR__c",
  /** column name */
  RECRUITview_Engagement_Manager__c = "RECRUITview_Engagement_Manager__c",
  /** column name */
  RECRUITview_PS_Team__c = "RECRUITview_PS_Team__c",
  /** column name */
  RECRUITview_Renewal_Date__c = "RECRUITview_Renewal_Date__c",
  /** column name */
  RECRUITview_Start_Date__c = "RECRUITview_Start_Date__c",
  /** column name */
  RECRUITview_Support_Hours__c = "RECRUITview_Support_Hours__c",
  /** column name */
  RECRUITview__c = "RECRUITview__c",
  /** column name */
  REWARDview_ARR__c = "REWARDview_ARR__c",
  /** column name */
  REWARDview_Engagement_Manager__c = "REWARDview_Engagement_Manager__c",
  /** column name */
  REWARDview_PS_Team__c = "REWARDview_PS_Team__c",
  /** column name */
  REWARDview_Renewal_Date__c = "REWARDview_Renewal_Date__c",
  /** column name */
  REWARDview_Start_Date__c = "REWARDview_Start_Date__c",
  /** column name */
  REWARDview_Support_Hours__c = "REWARDview_Support_Hours__c",
  /** column name */
  REWARDview__c = "REWARDview__c",
  /** column name */
  Reference_N__c = "Reference_N__c",
  /** column name */
  Referenceable__c = "Referenceable__c",
  /** column name */
  Renewal_Date_2__c = "Renewal_Date_2__c",
  /** column name */
  Renewal_Date__c = "Renewal_Date__c",
  /** column name */
  Renewal_Risk__c = "Renewal_Risk__c",
  /** column name */
  Reporting__c = "Reporting__c",
  /** column name */
  Retention_Confidence__c = "Retention_Confidence__c",
  /** column name */
  Retention_Risk_Reasons__c = "Retention_Risk_Reasons__c",
  /** column name */
  RevTron_ICP_Score_Formatted__c = "RevTron_ICP_Score_Formatted__c",
  /** column name */
  SSO_Provider__c = "SSO_Provider__c",
  /** column name */
  Security__c = "Security__c",
  /** column name */
  Segment__c = "Segment__c",
  /** column name */
  Self_Admin_Certified__c = "Self_Admin_Certified__c",
  /** column name */
  ShippingAddress = "ShippingAddress",
  /** column name */
  ShippingCity = "ShippingCity",
  /** column name */
  ShippingCountry = "ShippingCountry",
  /** column name */
  ShippingGeocodeAccuracy = "ShippingGeocodeAccuracy",
  /** column name */
  ShippingLatitude = "ShippingLatitude",
  /** column name */
  ShippingLongitude = "ShippingLongitude",
  /** column name */
  ShippingPostalCode = "ShippingPostalCode",
  /** column name */
  ShippingState = "ShippingState",
  /** column name */
  ShippingStreet = "ShippingStreet",
  /** column name */
  SicDesc = "SicDesc",
  /** column name */
  Support_Hours_Reset_Date__c = "Support_Hours_Reset_Date__c",
  /** column name */
  SystemModstamp = "SystemModstamp",
  /** column name */
  Team_Collaboration__c = "Team_Collaboration__c",
  /** column name */
  Territory__c = "Territory__c",
  /** column name */
  TickerSymbol = "TickerSymbol",
  /** column name */
  Total_ARR__c = "Total_ARR__c",
  /** column name */
  Total_Money_Raised__c = "Total_Money_Raised__c",
  /** column name */
  Total_Support_Hours__c = "Total_Support_Hours__c",
  /** column name */
  Type = "Type",
  /** column name */
  UI_UX__c = "UI_UX__c",
  /** column name */
  User_Conference_Attended__c = "User_Conference_Attended__c",
  /** column name */
  Website = "Website",
}

/** input type for updating data in table "Account" */
export type Account_set_input = {
  API_Access__c?: InputMaybe<Scalars["Boolean"]>;
  API_NPS__c?: InputMaybe<Scalars["float8"]>;
  ATS_ARR__c?: InputMaybe<Scalars["float8"]>;
  ATS__c?: InputMaybe<Scalars["Boolean"]>;
  AWARDview_ARR__c?: InputMaybe<Scalars["float8"]>;
  AWARDview_Engagement_Manager__c?: InputMaybe<Scalars["String"]>;
  AWARDview_PS_Team__c?: InputMaybe<Scalars["String"]>;
  AWARDview_Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  AWARDview_Start_Date__c?: InputMaybe<Scalars["date"]>;
  AWARDview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  AWARDview__c?: InputMaybe<Scalars["Boolean"]>;
  AccountSource?: InputMaybe<Scalars["String"]>;
  Account_Id__c?: InputMaybe<Scalars["String"]>;
  Account_Manager__c?: InputMaybe<Scalars["String"]>;
  Account_Notes__c?: InputMaybe<Scalars["String"]>;
  Account_Status_Auto__c?: InputMaybe<Scalars["String"]>;
  AnnualRevenue?: InputMaybe<Scalars["float8"]>;
  Annual_Support_Hours__c?: InputMaybe<Scalars["String"]>;
  Auto_Renewal_2__c?: InputMaybe<Scalars["Boolean"]>;
  Auto_Renewal__c?: InputMaybe<Scalars["Boolean"]>;
  Average_NPS__c?: InputMaybe<Scalars["float8"]>;
  Base_Licenses__c?: InputMaybe<Scalars["float8"]>;
  BillingAddress?: InputMaybe<Scalars["json"]>;
  BillingCity?: InputMaybe<Scalars["String"]>;
  BillingCountry?: InputMaybe<Scalars["String"]>;
  BillingGeocodeAccuracy?: InputMaybe<Scalars["String"]>;
  BillingLatitude?: InputMaybe<Scalars["float8"]>;
  BillingLongitude?: InputMaybe<Scalars["float8"]>;
  BillingPostalCode?: InputMaybe<Scalars["String"]>;
  BillingState?: InputMaybe<Scalars["String"]>;
  BillingStreet?: InputMaybe<Scalars["String"]>;
  Billing_Amount_2__c?: InputMaybe<Scalars["String"]>;
  Billing_Amount__c?: InputMaybe<Scalars["String"]>;
  Billing_Currency__c?: InputMaybe<Scalars["String"]>;
  Billing_ETC__c?: InputMaybe<Scalars["String"]>;
  Billing_Notes__c?: InputMaybe<Scalars["String"]>;
  Billing_Terms_2__c?: InputMaybe<Scalars["String"]>;
  Billing_Terms__c?: InputMaybe<Scalars["String"]>;
  COMPview_ARR__c?: InputMaybe<Scalars["float8"]>;
  COMPview_Engagement_Manager__c?: InputMaybe<Scalars["String"]>;
  COMPview_PS_Team__c?: InputMaybe<Scalars["String"]>;
  COMPview_Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  COMPview_Start_Date__c?: InputMaybe<Scalars["date"]>;
  COMPview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  COMPview__c?: InputMaybe<Scalars["Boolean"]>;
  CONTENTview_ARR__c?: InputMaybe<Scalars["float8"]>;
  CONTENTview_Engagement_Manager__c?: InputMaybe<Scalars["String"]>;
  CONTENTview_PS_Team__c?: InputMaybe<Scalars["String"]>;
  CONTENTview_Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  CONTENTview_Start_Date__c?: InputMaybe<Scalars["date"]>;
  CONTENTview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  CONTENTview__c?: InputMaybe<Scalars["Boolean"]>;
  Churn_Date__c?: InputMaybe<Scalars["date"]>;
  Client_Number__c?: InputMaybe<Scalars["String"]>;
  Client_Self_Service__c?: InputMaybe<Scalars["float8"]>;
  Client_Start_Date__c?: InputMaybe<Scalars["date"]>;
  Close_Date__c?: InputMaybe<Scalars["date"]>;
  Compensation_System_in_Place__c?: InputMaybe<Scalars["String"]>;
  Configurability__c?: InputMaybe<Scalars["float8"]>;
  Contract_ETC__c?: InputMaybe<Scalars["Boolean"]>;
  Contract_Start_Date__c?: InputMaybe<Scalars["date"]>;
  Contract_Total_Value__c?: InputMaybe<Scalars["String"]>;
  Contract_UAT_Delivery_Estimate__c?: InputMaybe<Scalars["timestamp"]>;
  CreatedById?: InputMaybe<Scalars["String"]>;
  CreatedDate?: InputMaybe<Scalars["timestamp"]>;
  Current_Active__c?: InputMaybe<Scalars["float8"]>;
  Current_End_Date__c?: InputMaybe<Scalars["date"]>;
  Customer_Lifecycle_Stage__c?: InputMaybe<Scalars["String"]>;
  Data_Center_Location__c?: InputMaybe<Scalars["String"]>;
  Data_Feeds__c?: InputMaybe<Scalars["float8"]>;
  Date_las__c?: InputMaybe<Scalars["date"]>;
  Delivery_Assurance__c?: InputMaybe<Scalars["float8"]>;
  Description?: InputMaybe<Scalars["String"]>;
  Domain__c?: InputMaybe<Scalars["String"]>;
  Founded_Year__c?: InputMaybe<Scalars["String"]>;
  G2_Buyer_Intent_Details__c?: InputMaybe<Scalars["String"]>;
  G2_Intent__c?: InputMaybe<Scalars["Boolean"]>;
  G2_Survey_1__c?: InputMaybe<Scalars["date"]>;
  G2_Survey_2__c?: InputMaybe<Scalars["date"]>;
  HRIS_Version__c?: InputMaybe<Scalars["String"]>;
  HRIS__c?: InputMaybe<Scalars["String"]>;
  HR_Tech__c?: InputMaybe<Scalars["String"]>;
  Health_Score__c?: InputMaybe<Scalars["String"]>;
  HubSpot_Company_Id__c?: InputMaybe<Scalars["String"]>;
  HubSpot_Owner_Id__c?: InputMaybe<Scalars["String"]>;
  HubSpot_Owner_Name__c?: InputMaybe<Scalars["String"]>;
  INCENTview_ARR__c?: InputMaybe<Scalars["float8"]>;
  INCENTview_Engagement_Manager__c?: InputMaybe<Scalars["String"]>;
  INCENTview_PS_Team__c?: InputMaybe<Scalars["String"]>;
  INCENTview_Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  INCENTview_Start_Date__c?: InputMaybe<Scalars["date"]>;
  INCENTview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  Id?: InputMaybe<Scalars["String"]>;
  Incent__c?: InputMaybe<Scalars["Boolean"]>;
  Industry?: InputMaybe<Scalars["String"]>;
  International_Global__c?: InputMaybe<Scalars["Boolean"]>;
  IsDeleted?: InputMaybe<Scalars["Boolean"]>;
  Is_Public__c?: InputMaybe<Scalars["Boolean"]>;
  Jigsaw?: InputMaybe<Scalars["String"]>;
  JigsawCompanyId?: InputMaybe<Scalars["String"]>;
  Language_Paks_ARR__c?: InputMaybe<Scalars["float8"]>;
  Language_Paks__c?: InputMaybe<Scalars["Boolean"]>;
  LastActivityDate?: InputMaybe<Scalars["date"]>;
  LastModifiedById?: InputMaybe<Scalars["String"]>;
  LastModifiedDate?: InputMaybe<Scalars["timestamp"]>;
  LastReferencedDate?: InputMaybe<Scalars["timestamp"]>;
  LastViewedDate?: InputMaybe<Scalars["timestamp"]>;
  Last_After_Action_Review__c?: InputMaybe<Scalars["date"]>;
  Lifecycle_Stage__c?: InputMaybe<Scalars["String"]>;
  LinkedIn_Company_Page__c?: InputMaybe<Scalars["String"]>;
  MODELview_ARR__c?: InputMaybe<Scalars["float8"]>;
  MODELview_Engagement_Manager__c?: InputMaybe<Scalars["String"]>;
  MODELview_PS_Team__c?: InputMaybe<Scalars["String"]>;
  MODELview_Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  MODELview_Start_Date__c?: InputMaybe<Scalars["date"]>;
  MODELview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  MODELview__c?: InputMaybe<Scalars["Boolean"]>;
  MasterRecordId?: InputMaybe<Scalars["String"]>;
  Naics_Industry_Detail__c?: InputMaybe<Scalars["String"]>;
  Naics_Industry_Title__c?: InputMaybe<Scalars["String"]>;
  Naics__c?: InputMaybe<Scalars["float8"]>;
  Name?: InputMaybe<Scalars["String"]>;
  NumberOfEmployees?: InputMaybe<Scalars["Int"]>;
  Number_of_Users__c?: InputMaybe<Scalars["String"]>;
  OLS_ARR__c?: InputMaybe<Scalars["float8"]>;
  OLS__c?: InputMaybe<Scalars["Boolean"]>;
  OnlineStatements__c?: InputMaybe<Scalars["Boolean"]>;
  Online_Statements_ARR__c?: InputMaybe<Scalars["float8"]>;
  Overall_Satisfaction__c?: InputMaybe<Scalars["float8"]>;
  OwnerId?: InputMaybe<Scalars["String"]>;
  PAYview_ARR__c?: InputMaybe<Scalars["float8"]>;
  PAYview_Engagement_Manager__c?: InputMaybe<Scalars["String"]>;
  PAYview_PS_Team__c?: InputMaybe<Scalars["String"]>;
  PAYview_Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  PAYview_Start_Date__c?: InputMaybe<Scalars["date"]>;
  PAYview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  PAYview__c?: InputMaybe<Scalars["Boolean"]>;
  PERFORMview_ARR__c?: InputMaybe<Scalars["float8"]>;
  PERFORMview_Engagement_Manager__c?: InputMaybe<Scalars["String"]>;
  PERFORMview_PS_Team__c?: InputMaybe<Scalars["String"]>;
  PERFORMview_Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  PERFORMview_Start_Date__c?: InputMaybe<Scalars["date"]>;
  PERFORMview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  PERFORMview__c?: InputMaybe<Scalars["Boolean"]>;
  ParentId?: InputMaybe<Scalars["String"]>;
  PartnerContact__c?: InputMaybe<Scalars["String"]>;
  Performance__c?: InputMaybe<Scalars["float8"]>;
  Phone?: InputMaybe<Scalars["String"]>;
  PhotoUrl?: InputMaybe<Scalars["String"]>;
  Platform_Version__c?: InputMaybe<Scalars["String"]>;
  Predict_Proba__c?: InputMaybe<Scalars["float8"]>;
  Price_Value_Satisfaction__c?: InputMaybe<Scalars["float8"]>;
  Professional_Services_Package_Program__c?: InputMaybe<Scalars["Boolean"]>;
  Professional_Services_Rate_per_hr__c?: InputMaybe<Scalars["float8"]>;
  RECRUITview_ARR__c?: InputMaybe<Scalars["float8"]>;
  RECRUITview_Engagement_Manager__c?: InputMaybe<Scalars["String"]>;
  RECRUITview_PS_Team__c?: InputMaybe<Scalars["String"]>;
  RECRUITview_Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  RECRUITview_Start_Date__c?: InputMaybe<Scalars["date"]>;
  RECRUITview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  RECRUITview__c?: InputMaybe<Scalars["Boolean"]>;
  REWARDview_ARR__c?: InputMaybe<Scalars["float8"]>;
  REWARDview_Engagement_Manager__c?: InputMaybe<Scalars["String"]>;
  REWARDview_PS_Team__c?: InputMaybe<Scalars["String"]>;
  REWARDview_Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  REWARDview_Start_Date__c?: InputMaybe<Scalars["date"]>;
  REWARDview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  REWARDview__c?: InputMaybe<Scalars["Boolean"]>;
  Reference_N__c?: InputMaybe<Scalars["String"]>;
  Referenceable__c?: InputMaybe<Scalars["Boolean"]>;
  Renewal_Date_2__c?: InputMaybe<Scalars["date"]>;
  Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  Renewal_Risk__c?: InputMaybe<Scalars["String"]>;
  Reporting__c?: InputMaybe<Scalars["float8"]>;
  Retention_Confidence__c?: InputMaybe<Scalars["float8"]>;
  Retention_Risk_Reasons__c?: InputMaybe<Scalars["String"]>;
  RevTron_ICP_Score_Formatted__c?: InputMaybe<Scalars["float8"]>;
  SSO_Provider__c?: InputMaybe<Scalars["String"]>;
  Security__c?: InputMaybe<Scalars["float8"]>;
  Segment__c?: InputMaybe<Scalars["String"]>;
  Self_Admin_Certified__c?: InputMaybe<Scalars["Boolean"]>;
  ShippingAddress?: InputMaybe<Scalars["json"]>;
  ShippingCity?: InputMaybe<Scalars["String"]>;
  ShippingCountry?: InputMaybe<Scalars["String"]>;
  ShippingGeocodeAccuracy?: InputMaybe<Scalars["String"]>;
  ShippingLatitude?: InputMaybe<Scalars["float8"]>;
  ShippingLongitude?: InputMaybe<Scalars["float8"]>;
  ShippingPostalCode?: InputMaybe<Scalars["String"]>;
  ShippingState?: InputMaybe<Scalars["String"]>;
  ShippingStreet?: InputMaybe<Scalars["String"]>;
  SicDesc?: InputMaybe<Scalars["String"]>;
  Support_Hours_Reset_Date__c?: InputMaybe<Scalars["date"]>;
  SystemModstamp?: InputMaybe<Scalars["timestamp"]>;
  Team_Collaboration__c?: InputMaybe<Scalars["float8"]>;
  Territory__c?: InputMaybe<Scalars["String"]>;
  TickerSymbol?: InputMaybe<Scalars["String"]>;
  Total_ARR__c?: InputMaybe<Scalars["float8"]>;
  Total_Money_Raised__c?: InputMaybe<Scalars["String"]>;
  Total_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  Type?: InputMaybe<Scalars["String"]>;
  UI_UX__c?: InputMaybe<Scalars["float8"]>;
  User_Conference_Attended__c?: InputMaybe<Scalars["String"]>;
  Website?: InputMaybe<Scalars["String"]>;
};

/** Streaming cursor of the table "Account" */
export type Account_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: Account_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Account_stream_cursor_value_input = {
  API_Access__c?: InputMaybe<Scalars["Boolean"]>;
  API_NPS__c?: InputMaybe<Scalars["float8"]>;
  ATS_ARR__c?: InputMaybe<Scalars["float8"]>;
  ATS__c?: InputMaybe<Scalars["Boolean"]>;
  AWARDview_ARR__c?: InputMaybe<Scalars["float8"]>;
  AWARDview_Engagement_Manager__c?: InputMaybe<Scalars["String"]>;
  AWARDview_PS_Team__c?: InputMaybe<Scalars["String"]>;
  AWARDview_Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  AWARDview_Start_Date__c?: InputMaybe<Scalars["date"]>;
  AWARDview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  AWARDview__c?: InputMaybe<Scalars["Boolean"]>;
  AccountSource?: InputMaybe<Scalars["String"]>;
  Account_Id__c?: InputMaybe<Scalars["String"]>;
  Account_Manager__c?: InputMaybe<Scalars["String"]>;
  Account_Notes__c?: InputMaybe<Scalars["String"]>;
  Account_Status_Auto__c?: InputMaybe<Scalars["String"]>;
  AnnualRevenue?: InputMaybe<Scalars["float8"]>;
  Annual_Support_Hours__c?: InputMaybe<Scalars["String"]>;
  Auto_Renewal_2__c?: InputMaybe<Scalars["Boolean"]>;
  Auto_Renewal__c?: InputMaybe<Scalars["Boolean"]>;
  Average_NPS__c?: InputMaybe<Scalars["float8"]>;
  Base_Licenses__c?: InputMaybe<Scalars["float8"]>;
  BillingAddress?: InputMaybe<Scalars["json"]>;
  BillingCity?: InputMaybe<Scalars["String"]>;
  BillingCountry?: InputMaybe<Scalars["String"]>;
  BillingGeocodeAccuracy?: InputMaybe<Scalars["String"]>;
  BillingLatitude?: InputMaybe<Scalars["float8"]>;
  BillingLongitude?: InputMaybe<Scalars["float8"]>;
  BillingPostalCode?: InputMaybe<Scalars["String"]>;
  BillingState?: InputMaybe<Scalars["String"]>;
  BillingStreet?: InputMaybe<Scalars["String"]>;
  Billing_Amount_2__c?: InputMaybe<Scalars["String"]>;
  Billing_Amount__c?: InputMaybe<Scalars["String"]>;
  Billing_Currency__c?: InputMaybe<Scalars["String"]>;
  Billing_ETC__c?: InputMaybe<Scalars["String"]>;
  Billing_Notes__c?: InputMaybe<Scalars["String"]>;
  Billing_Terms_2__c?: InputMaybe<Scalars["String"]>;
  Billing_Terms__c?: InputMaybe<Scalars["String"]>;
  COMPview_ARR__c?: InputMaybe<Scalars["float8"]>;
  COMPview_Engagement_Manager__c?: InputMaybe<Scalars["String"]>;
  COMPview_PS_Team__c?: InputMaybe<Scalars["String"]>;
  COMPview_Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  COMPview_Start_Date__c?: InputMaybe<Scalars["date"]>;
  COMPview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  COMPview__c?: InputMaybe<Scalars["Boolean"]>;
  CONTENTview_ARR__c?: InputMaybe<Scalars["float8"]>;
  CONTENTview_Engagement_Manager__c?: InputMaybe<Scalars["String"]>;
  CONTENTview_PS_Team__c?: InputMaybe<Scalars["String"]>;
  CONTENTview_Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  CONTENTview_Start_Date__c?: InputMaybe<Scalars["date"]>;
  CONTENTview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  CONTENTview__c?: InputMaybe<Scalars["Boolean"]>;
  Churn_Date__c?: InputMaybe<Scalars["date"]>;
  Client_Number__c?: InputMaybe<Scalars["String"]>;
  Client_Self_Service__c?: InputMaybe<Scalars["float8"]>;
  Client_Start_Date__c?: InputMaybe<Scalars["date"]>;
  Close_Date__c?: InputMaybe<Scalars["date"]>;
  Compensation_System_in_Place__c?: InputMaybe<Scalars["String"]>;
  Configurability__c?: InputMaybe<Scalars["float8"]>;
  Contract_ETC__c?: InputMaybe<Scalars["Boolean"]>;
  Contract_Start_Date__c?: InputMaybe<Scalars["date"]>;
  Contract_Total_Value__c?: InputMaybe<Scalars["String"]>;
  Contract_UAT_Delivery_Estimate__c?: InputMaybe<Scalars["timestamp"]>;
  CreatedById?: InputMaybe<Scalars["String"]>;
  CreatedDate?: InputMaybe<Scalars["timestamp"]>;
  Current_Active__c?: InputMaybe<Scalars["float8"]>;
  Current_End_Date__c?: InputMaybe<Scalars["date"]>;
  Customer_Lifecycle_Stage__c?: InputMaybe<Scalars["String"]>;
  Data_Center_Location__c?: InputMaybe<Scalars["String"]>;
  Data_Feeds__c?: InputMaybe<Scalars["float8"]>;
  Date_las__c?: InputMaybe<Scalars["date"]>;
  Delivery_Assurance__c?: InputMaybe<Scalars["float8"]>;
  Description?: InputMaybe<Scalars["String"]>;
  Domain__c?: InputMaybe<Scalars["String"]>;
  Founded_Year__c?: InputMaybe<Scalars["String"]>;
  G2_Buyer_Intent_Details__c?: InputMaybe<Scalars["String"]>;
  G2_Intent__c?: InputMaybe<Scalars["Boolean"]>;
  G2_Survey_1__c?: InputMaybe<Scalars["date"]>;
  G2_Survey_2__c?: InputMaybe<Scalars["date"]>;
  HRIS_Version__c?: InputMaybe<Scalars["String"]>;
  HRIS__c?: InputMaybe<Scalars["String"]>;
  HR_Tech__c?: InputMaybe<Scalars["String"]>;
  Health_Score__c?: InputMaybe<Scalars["String"]>;
  HubSpot_Company_Id__c?: InputMaybe<Scalars["String"]>;
  HubSpot_Owner_Id__c?: InputMaybe<Scalars["String"]>;
  HubSpot_Owner_Name__c?: InputMaybe<Scalars["String"]>;
  INCENTview_ARR__c?: InputMaybe<Scalars["float8"]>;
  INCENTview_Engagement_Manager__c?: InputMaybe<Scalars["String"]>;
  INCENTview_PS_Team__c?: InputMaybe<Scalars["String"]>;
  INCENTview_Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  INCENTview_Start_Date__c?: InputMaybe<Scalars["date"]>;
  INCENTview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  Id?: InputMaybe<Scalars["String"]>;
  Incent__c?: InputMaybe<Scalars["Boolean"]>;
  Industry?: InputMaybe<Scalars["String"]>;
  International_Global__c?: InputMaybe<Scalars["Boolean"]>;
  IsDeleted?: InputMaybe<Scalars["Boolean"]>;
  Is_Public__c?: InputMaybe<Scalars["Boolean"]>;
  Jigsaw?: InputMaybe<Scalars["String"]>;
  JigsawCompanyId?: InputMaybe<Scalars["String"]>;
  Language_Paks_ARR__c?: InputMaybe<Scalars["float8"]>;
  Language_Paks__c?: InputMaybe<Scalars["Boolean"]>;
  LastActivityDate?: InputMaybe<Scalars["date"]>;
  LastModifiedById?: InputMaybe<Scalars["String"]>;
  LastModifiedDate?: InputMaybe<Scalars["timestamp"]>;
  LastReferencedDate?: InputMaybe<Scalars["timestamp"]>;
  LastViewedDate?: InputMaybe<Scalars["timestamp"]>;
  Last_After_Action_Review__c?: InputMaybe<Scalars["date"]>;
  Lifecycle_Stage__c?: InputMaybe<Scalars["String"]>;
  LinkedIn_Company_Page__c?: InputMaybe<Scalars["String"]>;
  MODELview_ARR__c?: InputMaybe<Scalars["float8"]>;
  MODELview_Engagement_Manager__c?: InputMaybe<Scalars["String"]>;
  MODELview_PS_Team__c?: InputMaybe<Scalars["String"]>;
  MODELview_Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  MODELview_Start_Date__c?: InputMaybe<Scalars["date"]>;
  MODELview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  MODELview__c?: InputMaybe<Scalars["Boolean"]>;
  MasterRecordId?: InputMaybe<Scalars["String"]>;
  Naics_Industry_Detail__c?: InputMaybe<Scalars["String"]>;
  Naics_Industry_Title__c?: InputMaybe<Scalars["String"]>;
  Naics__c?: InputMaybe<Scalars["float8"]>;
  Name?: InputMaybe<Scalars["String"]>;
  NumberOfEmployees?: InputMaybe<Scalars["Int"]>;
  Number_of_Users__c?: InputMaybe<Scalars["String"]>;
  OLS_ARR__c?: InputMaybe<Scalars["float8"]>;
  OLS__c?: InputMaybe<Scalars["Boolean"]>;
  OnlineStatements__c?: InputMaybe<Scalars["Boolean"]>;
  Online_Statements_ARR__c?: InputMaybe<Scalars["float8"]>;
  Overall_Satisfaction__c?: InputMaybe<Scalars["float8"]>;
  OwnerId?: InputMaybe<Scalars["String"]>;
  PAYview_ARR__c?: InputMaybe<Scalars["float8"]>;
  PAYview_Engagement_Manager__c?: InputMaybe<Scalars["String"]>;
  PAYview_PS_Team__c?: InputMaybe<Scalars["String"]>;
  PAYview_Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  PAYview_Start_Date__c?: InputMaybe<Scalars["date"]>;
  PAYview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  PAYview__c?: InputMaybe<Scalars["Boolean"]>;
  PERFORMview_ARR__c?: InputMaybe<Scalars["float8"]>;
  PERFORMview_Engagement_Manager__c?: InputMaybe<Scalars["String"]>;
  PERFORMview_PS_Team__c?: InputMaybe<Scalars["String"]>;
  PERFORMview_Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  PERFORMview_Start_Date__c?: InputMaybe<Scalars["date"]>;
  PERFORMview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  PERFORMview__c?: InputMaybe<Scalars["Boolean"]>;
  ParentId?: InputMaybe<Scalars["String"]>;
  PartnerContact__c?: InputMaybe<Scalars["String"]>;
  Performance__c?: InputMaybe<Scalars["float8"]>;
  Phone?: InputMaybe<Scalars["String"]>;
  PhotoUrl?: InputMaybe<Scalars["String"]>;
  Platform_Version__c?: InputMaybe<Scalars["String"]>;
  Predict_Proba__c?: InputMaybe<Scalars["float8"]>;
  Price_Value_Satisfaction__c?: InputMaybe<Scalars["float8"]>;
  Professional_Services_Package_Program__c?: InputMaybe<Scalars["Boolean"]>;
  Professional_Services_Rate_per_hr__c?: InputMaybe<Scalars["float8"]>;
  RECRUITview_ARR__c?: InputMaybe<Scalars["float8"]>;
  RECRUITview_Engagement_Manager__c?: InputMaybe<Scalars["String"]>;
  RECRUITview_PS_Team__c?: InputMaybe<Scalars["String"]>;
  RECRUITview_Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  RECRUITview_Start_Date__c?: InputMaybe<Scalars["date"]>;
  RECRUITview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  RECRUITview__c?: InputMaybe<Scalars["Boolean"]>;
  REWARDview_ARR__c?: InputMaybe<Scalars["float8"]>;
  REWARDview_Engagement_Manager__c?: InputMaybe<Scalars["String"]>;
  REWARDview_PS_Team__c?: InputMaybe<Scalars["String"]>;
  REWARDview_Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  REWARDview_Start_Date__c?: InputMaybe<Scalars["date"]>;
  REWARDview_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  REWARDview__c?: InputMaybe<Scalars["Boolean"]>;
  Reference_N__c?: InputMaybe<Scalars["String"]>;
  Referenceable__c?: InputMaybe<Scalars["Boolean"]>;
  Renewal_Date_2__c?: InputMaybe<Scalars["date"]>;
  Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  Renewal_Risk__c?: InputMaybe<Scalars["String"]>;
  Reporting__c?: InputMaybe<Scalars["float8"]>;
  Retention_Confidence__c?: InputMaybe<Scalars["float8"]>;
  Retention_Risk_Reasons__c?: InputMaybe<Scalars["String"]>;
  RevTron_ICP_Score_Formatted__c?: InputMaybe<Scalars["float8"]>;
  SSO_Provider__c?: InputMaybe<Scalars["String"]>;
  Security__c?: InputMaybe<Scalars["float8"]>;
  Segment__c?: InputMaybe<Scalars["String"]>;
  Self_Admin_Certified__c?: InputMaybe<Scalars["Boolean"]>;
  ShippingAddress?: InputMaybe<Scalars["json"]>;
  ShippingCity?: InputMaybe<Scalars["String"]>;
  ShippingCountry?: InputMaybe<Scalars["String"]>;
  ShippingGeocodeAccuracy?: InputMaybe<Scalars["String"]>;
  ShippingLatitude?: InputMaybe<Scalars["float8"]>;
  ShippingLongitude?: InputMaybe<Scalars["float8"]>;
  ShippingPostalCode?: InputMaybe<Scalars["String"]>;
  ShippingState?: InputMaybe<Scalars["String"]>;
  ShippingStreet?: InputMaybe<Scalars["String"]>;
  SicDesc?: InputMaybe<Scalars["String"]>;
  Support_Hours_Reset_Date__c?: InputMaybe<Scalars["date"]>;
  SystemModstamp?: InputMaybe<Scalars["timestamp"]>;
  Team_Collaboration__c?: InputMaybe<Scalars["float8"]>;
  Territory__c?: InputMaybe<Scalars["String"]>;
  TickerSymbol?: InputMaybe<Scalars["String"]>;
  Total_ARR__c?: InputMaybe<Scalars["float8"]>;
  Total_Money_Raised__c?: InputMaybe<Scalars["String"]>;
  Total_Support_Hours__c?: InputMaybe<Scalars["float8"]>;
  Type?: InputMaybe<Scalars["String"]>;
  UI_UX__c?: InputMaybe<Scalars["float8"]>;
  User_Conference_Attended__c?: InputMaybe<Scalars["String"]>;
  Website?: InputMaybe<Scalars["String"]>;
};

/** update columns of table "Account" */
export enum Account_update_column {
  /** column name */
  API_Access__c = "API_Access__c",
  /** column name */
  API_NPS__c = "API_NPS__c",
  /** column name */
  ATS_ARR__c = "ATS_ARR__c",
  /** column name */
  ATS__c = "ATS__c",
  /** column name */
  AWARDview_ARR__c = "AWARDview_ARR__c",
  /** column name */
  AWARDview_Engagement_Manager__c = "AWARDview_Engagement_Manager__c",
  /** column name */
  AWARDview_PS_Team__c = "AWARDview_PS_Team__c",
  /** column name */
  AWARDview_Renewal_Date__c = "AWARDview_Renewal_Date__c",
  /** column name */
  AWARDview_Start_Date__c = "AWARDview_Start_Date__c",
  /** column name */
  AWARDview_Support_Hours__c = "AWARDview_Support_Hours__c",
  /** column name */
  AWARDview__c = "AWARDview__c",
  /** column name */
  AccountSource = "AccountSource",
  /** column name */
  Account_Id__c = "Account_Id__c",
  /** column name */
  Account_Manager__c = "Account_Manager__c",
  /** column name */
  Account_Notes__c = "Account_Notes__c",
  /** column name */
  Account_Status_Auto__c = "Account_Status_Auto__c",
  /** column name */
  AnnualRevenue = "AnnualRevenue",
  /** column name */
  Annual_Support_Hours__c = "Annual_Support_Hours__c",
  /** column name */
  Auto_Renewal_2__c = "Auto_Renewal_2__c",
  /** column name */
  Auto_Renewal__c = "Auto_Renewal__c",
  /** column name */
  Average_NPS__c = "Average_NPS__c",
  /** column name */
  Base_Licenses__c = "Base_Licenses__c",
  /** column name */
  BillingAddress = "BillingAddress",
  /** column name */
  BillingCity = "BillingCity",
  /** column name */
  BillingCountry = "BillingCountry",
  /** column name */
  BillingGeocodeAccuracy = "BillingGeocodeAccuracy",
  /** column name */
  BillingLatitude = "BillingLatitude",
  /** column name */
  BillingLongitude = "BillingLongitude",
  /** column name */
  BillingPostalCode = "BillingPostalCode",
  /** column name */
  BillingState = "BillingState",
  /** column name */
  BillingStreet = "BillingStreet",
  /** column name */
  Billing_Amount_2__c = "Billing_Amount_2__c",
  /** column name */
  Billing_Amount__c = "Billing_Amount__c",
  /** column name */
  Billing_Currency__c = "Billing_Currency__c",
  /** column name */
  Billing_ETC__c = "Billing_ETC__c",
  /** column name */
  Billing_Notes__c = "Billing_Notes__c",
  /** column name */
  Billing_Terms_2__c = "Billing_Terms_2__c",
  /** column name */
  Billing_Terms__c = "Billing_Terms__c",
  /** column name */
  COMPview_ARR__c = "COMPview_ARR__c",
  /** column name */
  COMPview_Engagement_Manager__c = "COMPview_Engagement_Manager__c",
  /** column name */
  COMPview_PS_Team__c = "COMPview_PS_Team__c",
  /** column name */
  COMPview_Renewal_Date__c = "COMPview_Renewal_Date__c",
  /** column name */
  COMPview_Start_Date__c = "COMPview_Start_Date__c",
  /** column name */
  COMPview_Support_Hours__c = "COMPview_Support_Hours__c",
  /** column name */
  COMPview__c = "COMPview__c",
  /** column name */
  CONTENTview_ARR__c = "CONTENTview_ARR__c",
  /** column name */
  CONTENTview_Engagement_Manager__c = "CONTENTview_Engagement_Manager__c",
  /** column name */
  CONTENTview_PS_Team__c = "CONTENTview_PS_Team__c",
  /** column name */
  CONTENTview_Renewal_Date__c = "CONTENTview_Renewal_Date__c",
  /** column name */
  CONTENTview_Start_Date__c = "CONTENTview_Start_Date__c",
  /** column name */
  CONTENTview_Support_Hours__c = "CONTENTview_Support_Hours__c",
  /** column name */
  CONTENTview__c = "CONTENTview__c",
  /** column name */
  Churn_Date__c = "Churn_Date__c",
  /** column name */
  Client_Number__c = "Client_Number__c",
  /** column name */
  Client_Self_Service__c = "Client_Self_Service__c",
  /** column name */
  Client_Start_Date__c = "Client_Start_Date__c",
  /** column name */
  Close_Date__c = "Close_Date__c",
  /** column name */
  Compensation_System_in_Place__c = "Compensation_System_in_Place__c",
  /** column name */
  Configurability__c = "Configurability__c",
  /** column name */
  Contract_ETC__c = "Contract_ETC__c",
  /** column name */
  Contract_Start_Date__c = "Contract_Start_Date__c",
  /** column name */
  Contract_Total_Value__c = "Contract_Total_Value__c",
  /** column name */
  Contract_UAT_Delivery_Estimate__c = "Contract_UAT_Delivery_Estimate__c",
  /** column name */
  CreatedById = "CreatedById",
  /** column name */
  CreatedDate = "CreatedDate",
  /** column name */
  Current_Active__c = "Current_Active__c",
  /** column name */
  Current_End_Date__c = "Current_End_Date__c",
  /** column name */
  Customer_Lifecycle_Stage__c = "Customer_Lifecycle_Stage__c",
  /** column name */
  Data_Center_Location__c = "Data_Center_Location__c",
  /** column name */
  Data_Feeds__c = "Data_Feeds__c",
  /** column name */
  Date_las__c = "Date_las__c",
  /** column name */
  Delivery_Assurance__c = "Delivery_Assurance__c",
  /** column name */
  Description = "Description",
  /** column name */
  Domain__c = "Domain__c",
  /** column name */
  Founded_Year__c = "Founded_Year__c",
  /** column name */
  G2_Buyer_Intent_Details__c = "G2_Buyer_Intent_Details__c",
  /** column name */
  G2_Intent__c = "G2_Intent__c",
  /** column name */
  G2_Survey_1__c = "G2_Survey_1__c",
  /** column name */
  G2_Survey_2__c = "G2_Survey_2__c",
  /** column name */
  HRIS_Version__c = "HRIS_Version__c",
  /** column name */
  HRIS__c = "HRIS__c",
  /** column name */
  HR_Tech__c = "HR_Tech__c",
  /** column name */
  Health_Score__c = "Health_Score__c",
  /** column name */
  HubSpot_Company_Id__c = "HubSpot_Company_Id__c",
  /** column name */
  HubSpot_Owner_Id__c = "HubSpot_Owner_Id__c",
  /** column name */
  HubSpot_Owner_Name__c = "HubSpot_Owner_Name__c",
  /** column name */
  INCENTview_ARR__c = "INCENTview_ARR__c",
  /** column name */
  INCENTview_Engagement_Manager__c = "INCENTview_Engagement_Manager__c",
  /** column name */
  INCENTview_PS_Team__c = "INCENTview_PS_Team__c",
  /** column name */
  INCENTview_Renewal_Date__c = "INCENTview_Renewal_Date__c",
  /** column name */
  INCENTview_Start_Date__c = "INCENTview_Start_Date__c",
  /** column name */
  INCENTview_Support_Hours__c = "INCENTview_Support_Hours__c",
  /** column name */
  Id = "Id",
  /** column name */
  Incent__c = "Incent__c",
  /** column name */
  Industry = "Industry",
  /** column name */
  International_Global__c = "International_Global__c",
  /** column name */
  IsDeleted = "IsDeleted",
  /** column name */
  Is_Public__c = "Is_Public__c",
  /** column name */
  Jigsaw = "Jigsaw",
  /** column name */
  JigsawCompanyId = "JigsawCompanyId",
  /** column name */
  Language_Paks_ARR__c = "Language_Paks_ARR__c",
  /** column name */
  Language_Paks__c = "Language_Paks__c",
  /** column name */
  LastActivityDate = "LastActivityDate",
  /** column name */
  LastModifiedById = "LastModifiedById",
  /** column name */
  LastModifiedDate = "LastModifiedDate",
  /** column name */
  LastReferencedDate = "LastReferencedDate",
  /** column name */
  LastViewedDate = "LastViewedDate",
  /** column name */
  Last_After_Action_Review__c = "Last_After_Action_Review__c",
  /** column name */
  Lifecycle_Stage__c = "Lifecycle_Stage__c",
  /** column name */
  LinkedIn_Company_Page__c = "LinkedIn_Company_Page__c",
  /** column name */
  MODELview_ARR__c = "MODELview_ARR__c",
  /** column name */
  MODELview_Engagement_Manager__c = "MODELview_Engagement_Manager__c",
  /** column name */
  MODELview_PS_Team__c = "MODELview_PS_Team__c",
  /** column name */
  MODELview_Renewal_Date__c = "MODELview_Renewal_Date__c",
  /** column name */
  MODELview_Start_Date__c = "MODELview_Start_Date__c",
  /** column name */
  MODELview_Support_Hours__c = "MODELview_Support_Hours__c",
  /** column name */
  MODELview__c = "MODELview__c",
  /** column name */
  MasterRecordId = "MasterRecordId",
  /** column name */
  Naics_Industry_Detail__c = "Naics_Industry_Detail__c",
  /** column name */
  Naics_Industry_Title__c = "Naics_Industry_Title__c",
  /** column name */
  Naics__c = "Naics__c",
  /** column name */
  Name = "Name",
  /** column name */
  NumberOfEmployees = "NumberOfEmployees",
  /** column name */
  Number_of_Users__c = "Number_of_Users__c",
  /** column name */
  OLS_ARR__c = "OLS_ARR__c",
  /** column name */
  OLS__c = "OLS__c",
  /** column name */
  OnlineStatements__c = "OnlineStatements__c",
  /** column name */
  Online_Statements_ARR__c = "Online_Statements_ARR__c",
  /** column name */
  Overall_Satisfaction__c = "Overall_Satisfaction__c",
  /** column name */
  OwnerId = "OwnerId",
  /** column name */
  PAYview_ARR__c = "PAYview_ARR__c",
  /** column name */
  PAYview_Engagement_Manager__c = "PAYview_Engagement_Manager__c",
  /** column name */
  PAYview_PS_Team__c = "PAYview_PS_Team__c",
  /** column name */
  PAYview_Renewal_Date__c = "PAYview_Renewal_Date__c",
  /** column name */
  PAYview_Start_Date__c = "PAYview_Start_Date__c",
  /** column name */
  PAYview_Support_Hours__c = "PAYview_Support_Hours__c",
  /** column name */
  PAYview__c = "PAYview__c",
  /** column name */
  PERFORMview_ARR__c = "PERFORMview_ARR__c",
  /** column name */
  PERFORMview_Engagement_Manager__c = "PERFORMview_Engagement_Manager__c",
  /** column name */
  PERFORMview_PS_Team__c = "PERFORMview_PS_Team__c",
  /** column name */
  PERFORMview_Renewal_Date__c = "PERFORMview_Renewal_Date__c",
  /** column name */
  PERFORMview_Start_Date__c = "PERFORMview_Start_Date__c",
  /** column name */
  PERFORMview_Support_Hours__c = "PERFORMview_Support_Hours__c",
  /** column name */
  PERFORMview__c = "PERFORMview__c",
  /** column name */
  ParentId = "ParentId",
  /** column name */
  PartnerContact__c = "PartnerContact__c",
  /** column name */
  Performance__c = "Performance__c",
  /** column name */
  Phone = "Phone",
  /** column name */
  PhotoUrl = "PhotoUrl",
  /** column name */
  Platform_Version__c = "Platform_Version__c",
  /** column name */
  Predict_Proba__c = "Predict_Proba__c",
  /** column name */
  Price_Value_Satisfaction__c = "Price_Value_Satisfaction__c",
  /** column name */
  Professional_Services_Package_Program__c = "Professional_Services_Package_Program__c",
  /** column name */
  Professional_Services_Rate_per_hr__c = "Professional_Services_Rate_per_hr__c",
  /** column name */
  RECRUITview_ARR__c = "RECRUITview_ARR__c",
  /** column name */
  RECRUITview_Engagement_Manager__c = "RECRUITview_Engagement_Manager__c",
  /** column name */
  RECRUITview_PS_Team__c = "RECRUITview_PS_Team__c",
  /** column name */
  RECRUITview_Renewal_Date__c = "RECRUITview_Renewal_Date__c",
  /** column name */
  RECRUITview_Start_Date__c = "RECRUITview_Start_Date__c",
  /** column name */
  RECRUITview_Support_Hours__c = "RECRUITview_Support_Hours__c",
  /** column name */
  RECRUITview__c = "RECRUITview__c",
  /** column name */
  REWARDview_ARR__c = "REWARDview_ARR__c",
  /** column name */
  REWARDview_Engagement_Manager__c = "REWARDview_Engagement_Manager__c",
  /** column name */
  REWARDview_PS_Team__c = "REWARDview_PS_Team__c",
  /** column name */
  REWARDview_Renewal_Date__c = "REWARDview_Renewal_Date__c",
  /** column name */
  REWARDview_Start_Date__c = "REWARDview_Start_Date__c",
  /** column name */
  REWARDview_Support_Hours__c = "REWARDview_Support_Hours__c",
  /** column name */
  REWARDview__c = "REWARDview__c",
  /** column name */
  Reference_N__c = "Reference_N__c",
  /** column name */
  Referenceable__c = "Referenceable__c",
  /** column name */
  Renewal_Date_2__c = "Renewal_Date_2__c",
  /** column name */
  Renewal_Date__c = "Renewal_Date__c",
  /** column name */
  Renewal_Risk__c = "Renewal_Risk__c",
  /** column name */
  Reporting__c = "Reporting__c",
  /** column name */
  Retention_Confidence__c = "Retention_Confidence__c",
  /** column name */
  Retention_Risk_Reasons__c = "Retention_Risk_Reasons__c",
  /** column name */
  RevTron_ICP_Score_Formatted__c = "RevTron_ICP_Score_Formatted__c",
  /** column name */
  SSO_Provider__c = "SSO_Provider__c",
  /** column name */
  Security__c = "Security__c",
  /** column name */
  Segment__c = "Segment__c",
  /** column name */
  Self_Admin_Certified__c = "Self_Admin_Certified__c",
  /** column name */
  ShippingAddress = "ShippingAddress",
  /** column name */
  ShippingCity = "ShippingCity",
  /** column name */
  ShippingCountry = "ShippingCountry",
  /** column name */
  ShippingGeocodeAccuracy = "ShippingGeocodeAccuracy",
  /** column name */
  ShippingLatitude = "ShippingLatitude",
  /** column name */
  ShippingLongitude = "ShippingLongitude",
  /** column name */
  ShippingPostalCode = "ShippingPostalCode",
  /** column name */
  ShippingState = "ShippingState",
  /** column name */
  ShippingStreet = "ShippingStreet",
  /** column name */
  SicDesc = "SicDesc",
  /** column name */
  Support_Hours_Reset_Date__c = "Support_Hours_Reset_Date__c",
  /** column name */
  SystemModstamp = "SystemModstamp",
  /** column name */
  Team_Collaboration__c = "Team_Collaboration__c",
  /** column name */
  Territory__c = "Territory__c",
  /** column name */
  TickerSymbol = "TickerSymbol",
  /** column name */
  Total_ARR__c = "Total_ARR__c",
  /** column name */
  Total_Money_Raised__c = "Total_Money_Raised__c",
  /** column name */
  Total_Support_Hours__c = "Total_Support_Hours__c",
  /** column name */
  Type = "Type",
  /** column name */
  UI_UX__c = "UI_UX__c",
  /** column name */
  User_Conference_Attended__c = "User_Conference_Attended__c",
  /** column name */
  Website = "Website",
}

export type Account_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Account_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Account_set_input>;
  where: Account_bool_exp;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_comparison_exp = {
  _eq?: InputMaybe<Scalars["Boolean"]>;
  _gt?: InputMaybe<Scalars["Boolean"]>;
  _gte?: InputMaybe<Scalars["Boolean"]>;
  _in?: InputMaybe<Array<Scalars["Boolean"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["Boolean"]>;
  _lte?: InputMaybe<Scalars["Boolean"]>;
  _neq?: InputMaybe<Scalars["Boolean"]>;
  _nin?: InputMaybe<Array<Scalars["Boolean"]>>;
};

/** Boolean expression to filter rows from the table "COMPANY". All fields are combined with a logical 'AND'. */
export type COMPANY_bool_exp_remote_rel_crm_revtron_indexesto_revtron_company =
  {
    CITY?: InputMaybe<_String_comparison_exp>;
    COMPANYTYPE?: InputMaybe<_String_comparison_exp>;
    COUNTRY?: InputMaybe<_String_comparison_exp>;
    COUNTRYCODE?: InputMaybe<_String_comparison_exp>;
    CRUNCHBASE?: InputMaybe<_String_comparison_exp>;
    DATE_OF_RAISE?: InputMaybe<_String_comparison_exp>;
    DESCRIPTION?: InputMaybe<_String_comparison_exp>;
    DOMAIN?: InputMaybe<_String_comparison_exp>;
    FACEBOOK?: InputMaybe<_String_comparison_exp>;
    FOUNDINGYEAR?: InputMaybe<_float8_comparison_exp>;
    ID?: InputMaybe<bigint_comparison_exp_remote_rel_crm_revtron_indexesto_revtron_company>;
    INFORMALNAME?: InputMaybe<_String_comparison_exp>;
    LINKEDIN?: InputMaybe<_String_comparison_exp>;
    LOADDATE?: InputMaybe<_String_comparison_exp>;
    MODIFIEDDATE?: InputMaybe<_String_comparison_exp>;
    MOST_RECENT_EMPLOYEE_COUNT?: InputMaybe<_float8_comparison_exp>;
    NAME?: InputMaybe<_String_comparison_exp>;
    NOLONGERINBUSINESS?: InputMaybe<_Boolean_comparison_exp>;
    NOLONGERINBUSINESSDATE?: InputMaybe<_String_comparison_exp>;
    NOLONGERINBUSINESSREASON?: InputMaybe<_float8_comparison_exp>;
    PARENTCOMPANY?: InputMaybe<_String_comparison_exp>;
    PARENTID?: InputMaybe<_float8_comparison_exp>;
    PHONENUMBER?: InputMaybe<_String_comparison_exp>;
    POSTALCODE?: InputMaybe<_String_comparison_exp>;
    RAISE_AMOUNT?: InputMaybe<_float8_comparison_exp>;
    RAISE_ROUND?: InputMaybe<_float8_comparison_exp>;
    RAISE_TRANSACTION_TYPE?: InputMaybe<_float8_comparison_exp>;
    RAISE_VALUATION?: InputMaybe<_float8_comparison_exp>;
    SOURCECITED?: InputMaybe<_String_comparison_exp>;
    SPECIALTIES?: InputMaybe<_String_comparison_exp>;
    STATE?: InputMaybe<_String_comparison_exp>;
    STATECODE?: InputMaybe<_String_comparison_exp>;
    SUB_INDUSTRY_CATEGORY_NAME?: InputMaybe<_String_comparison_exp>;
    TOTALAMOUNTINVESTED?: InputMaybe<_float8_comparison_exp>;
    TWITTER?: InputMaybe<_String_comparison_exp>;
    WEBSITE?: InputMaybe<_String_comparison_exp>;
    _and?: InputMaybe<Array<_COMPANY_bool_exp>>;
    _not?: InputMaybe<_COMPANY_bool_exp>;
    _or?: InputMaybe<Array<_COMPANY_bool_exp>>;
    index?: InputMaybe<_bigint_comparison_exp>;
  };

/** Boolean expression to filter rows from the table "Contact". All fields are combined with a logical 'AND'. */
export type Contact_bool_exp = {
  AccountId?: InputMaybe<String_comparison_exp>;
  Account_Status_Auto__c?: InputMaybe<String_comparison_exp>;
  Campaign__c?: InputMaybe<String_comparison_exp>;
  Contact__c?: InputMaybe<String_comparison_exp>;
  CreatedById?: InputMaybe<String_comparison_exp>;
  CreatedDate?: InputMaybe<timestamp_comparison_exp>;
  Department?: InputMaybe<String_comparison_exp>;
  Description?: InputMaybe<String_comparison_exp>;
  Email?: InputMaybe<String_comparison_exp>;
  EmailBouncedDate?: InputMaybe<timestamp_comparison_exp>;
  EmailBouncedReason?: InputMaybe<String_comparison_exp>;
  Fax?: InputMaybe<String_comparison_exp>;
  FirstName?: InputMaybe<String_comparison_exp>;
  HasOptedOutOfEmail?: InputMaybe<Boolean_comparison_exp>;
  HubSpot_Company_Id__c?: InputMaybe<String_comparison_exp>;
  HubSpot_Contact_Id__c?: InputMaybe<String_comparison_exp>;
  HubSpot_Owner_Id__c?: InputMaybe<String_comparison_exp>;
  HubSpot_Owner_Name__c?: InputMaybe<String_comparison_exp>;
  Id?: InputMaybe<String_comparison_exp>;
  Inactive__c?: InputMaybe<Boolean_comparison_exp>;
  IsDeleted?: InputMaybe<Boolean_comparison_exp>;
  IsEmailBounced?: InputMaybe<Boolean_comparison_exp>;
  Jigsaw?: InputMaybe<String_comparison_exp>;
  JigsawContactId?: InputMaybe<String_comparison_exp>;
  LastActivityDate?: InputMaybe<date_comparison_exp>;
  LastCURequestDate?: InputMaybe<timestamp_comparison_exp>;
  LastCUUpdateDate?: InputMaybe<timestamp_comparison_exp>;
  LastModifiedById?: InputMaybe<String_comparison_exp>;
  LastModifiedDate?: InputMaybe<timestamp_comparison_exp>;
  LastName?: InputMaybe<String_comparison_exp>;
  LastReferencedDate?: InputMaybe<timestamp_comparison_exp>;
  LastViewedDate?: InputMaybe<timestamp_comparison_exp>;
  LeadSource?: InputMaybe<String_comparison_exp>;
  Lifecycle_Stage__c?: InputMaybe<String_comparison_exp>;
  Linkedin_URL__c?: InputMaybe<String_comparison_exp>;
  MailingAddress?: InputMaybe<json_comparison_exp>;
  MailingCity?: InputMaybe<String_comparison_exp>;
  MailingCountry?: InputMaybe<String_comparison_exp>;
  MailingGeocodeAccuracy?: InputMaybe<String_comparison_exp>;
  MailingLatitude?: InputMaybe<float8_comparison_exp>;
  MailingLongitude?: InputMaybe<float8_comparison_exp>;
  MailingPostalCode?: InputMaybe<String_comparison_exp>;
  MailingState?: InputMaybe<String_comparison_exp>;
  MailingStreet?: InputMaybe<String_comparison_exp>;
  MasterRecordId?: InputMaybe<String_comparison_exp>;
  Micro_Theme__c?: InputMaybe<String_comparison_exp>;
  MiddleName?: InputMaybe<String_comparison_exp>;
  MobilePhone?: InputMaybe<String_comparison_exp>;
  Name?: InputMaybe<String_comparison_exp>;
  Outreach_Actively_Being_Sequenced__c?: InputMaybe<Boolean_comparison_exp>;
  Outreach_Current_Sequence_ID__c?: InputMaybe<String_comparison_exp>;
  Outreach_Current_Sequence_Name__c?: InputMaybe<String_comparison_exp>;
  Outreach_Current_Sequence_Status__c?: InputMaybe<String_comparison_exp>;
  Outreach_Current_Sequence_Step_Number__c?: InputMaybe<float8_comparison_exp>;
  Outreach_Current_Sequence_Step_Type__c?: InputMaybe<String_comparison_exp>;
  Outreach_Current_Sequence_Task_Due_Date__c?: InputMaybe<timestamp_comparison_exp>;
  Outreach_Current_Sequence_User_ID__c?: InputMaybe<String_comparison_exp>;
  Outreach_Date_Added_to_Sequence__c?: InputMaybe<date_comparison_exp>;
  Outreach_Finished_Sequences__c?: InputMaybe<String_comparison_exp>;
  Outreach_Number_of_Active_Sequences__c?: InputMaybe<String_comparison_exp>;
  Outreach_Number_of_Active_Tasks__c?: InputMaybe<float8_comparison_exp>;
  OwnerId?: InputMaybe<String_comparison_exp>;
  Phone?: InputMaybe<String_comparison_exp>;
  PhotoUrl?: InputMaybe<String_comparison_exp>;
  ReportsToId?: InputMaybe<String_comparison_exp>;
  Role__c?: InputMaybe<String_comparison_exp>;
  Salutation?: InputMaybe<String_comparison_exp>;
  Status__c?: InputMaybe<String_comparison_exp>;
  Suffix?: InputMaybe<String_comparison_exp>;
  SystemModstamp?: InputMaybe<timestamp_comparison_exp>;
  Title?: InputMaybe<String_comparison_exp>;
  _and?: InputMaybe<Array<Contact_bool_exp>>;
  _not?: InputMaybe<Contact_bool_exp>;
  _or?: InputMaybe<Array<Contact_bool_exp>>;
};

/** unique or primary key constraints on table "Contact" */
export enum Contact_constraint {
  /** unique or primary key constraint on columns "Id" */
  Contact_pkey = "Contact_pkey",
}

/** input type for incrementing numeric columns in table "Contact" */
export type Contact_inc_input = {
  MailingLatitude?: InputMaybe<Scalars["float8"]>;
  MailingLongitude?: InputMaybe<Scalars["float8"]>;
  Outreach_Current_Sequence_Step_Number__c?: InputMaybe<Scalars["float8"]>;
  Outreach_Number_of_Active_Tasks__c?: InputMaybe<Scalars["float8"]>;
};

/** input type for inserting data into table "Contact" */
export type Contact_insert_input = {
  AccountId?: InputMaybe<Scalars["String"]>;
  Account_Status_Auto__c?: InputMaybe<Scalars["String"]>;
  Campaign__c?: InputMaybe<Scalars["String"]>;
  Contact__c?: InputMaybe<Scalars["String"]>;
  CreatedById?: InputMaybe<Scalars["String"]>;
  CreatedDate?: InputMaybe<Scalars["timestamp"]>;
  Department?: InputMaybe<Scalars["String"]>;
  Description?: InputMaybe<Scalars["String"]>;
  Email?: InputMaybe<Scalars["String"]>;
  EmailBouncedDate?: InputMaybe<Scalars["timestamp"]>;
  EmailBouncedReason?: InputMaybe<Scalars["String"]>;
  Fax?: InputMaybe<Scalars["String"]>;
  FirstName?: InputMaybe<Scalars["String"]>;
  HasOptedOutOfEmail?: InputMaybe<Scalars["Boolean"]>;
  HubSpot_Company_Id__c?: InputMaybe<Scalars["String"]>;
  HubSpot_Contact_Id__c?: InputMaybe<Scalars["String"]>;
  HubSpot_Owner_Id__c?: InputMaybe<Scalars["String"]>;
  HubSpot_Owner_Name__c?: InputMaybe<Scalars["String"]>;
  Id?: InputMaybe<Scalars["String"]>;
  Inactive__c?: InputMaybe<Scalars["Boolean"]>;
  IsDeleted?: InputMaybe<Scalars["Boolean"]>;
  IsEmailBounced?: InputMaybe<Scalars["Boolean"]>;
  Jigsaw?: InputMaybe<Scalars["String"]>;
  JigsawContactId?: InputMaybe<Scalars["String"]>;
  LastActivityDate?: InputMaybe<Scalars["date"]>;
  LastCURequestDate?: InputMaybe<Scalars["timestamp"]>;
  LastCUUpdateDate?: InputMaybe<Scalars["timestamp"]>;
  LastModifiedById?: InputMaybe<Scalars["String"]>;
  LastModifiedDate?: InputMaybe<Scalars["timestamp"]>;
  LastName?: InputMaybe<Scalars["String"]>;
  LastReferencedDate?: InputMaybe<Scalars["timestamp"]>;
  LastViewedDate?: InputMaybe<Scalars["timestamp"]>;
  LeadSource?: InputMaybe<Scalars["String"]>;
  Lifecycle_Stage__c?: InputMaybe<Scalars["String"]>;
  Linkedin_URL__c?: InputMaybe<Scalars["String"]>;
  MailingAddress?: InputMaybe<Scalars["json"]>;
  MailingCity?: InputMaybe<Scalars["String"]>;
  MailingCountry?: InputMaybe<Scalars["String"]>;
  MailingGeocodeAccuracy?: InputMaybe<Scalars["String"]>;
  MailingLatitude?: InputMaybe<Scalars["float8"]>;
  MailingLongitude?: InputMaybe<Scalars["float8"]>;
  MailingPostalCode?: InputMaybe<Scalars["String"]>;
  MailingState?: InputMaybe<Scalars["String"]>;
  MailingStreet?: InputMaybe<Scalars["String"]>;
  MasterRecordId?: InputMaybe<Scalars["String"]>;
  Micro_Theme__c?: InputMaybe<Scalars["String"]>;
  MiddleName?: InputMaybe<Scalars["String"]>;
  MobilePhone?: InputMaybe<Scalars["String"]>;
  Name?: InputMaybe<Scalars["String"]>;
  Outreach_Actively_Being_Sequenced__c?: InputMaybe<Scalars["Boolean"]>;
  Outreach_Current_Sequence_ID__c?: InputMaybe<Scalars["String"]>;
  Outreach_Current_Sequence_Name__c?: InputMaybe<Scalars["String"]>;
  Outreach_Current_Sequence_Status__c?: InputMaybe<Scalars["String"]>;
  Outreach_Current_Sequence_Step_Number__c?: InputMaybe<Scalars["float8"]>;
  Outreach_Current_Sequence_Step_Type__c?: InputMaybe<Scalars["String"]>;
  Outreach_Current_Sequence_Task_Due_Date__c?: InputMaybe<Scalars["timestamp"]>;
  Outreach_Current_Sequence_User_ID__c?: InputMaybe<Scalars["String"]>;
  Outreach_Date_Added_to_Sequence__c?: InputMaybe<Scalars["date"]>;
  Outreach_Finished_Sequences__c?: InputMaybe<Scalars["String"]>;
  Outreach_Number_of_Active_Sequences__c?: InputMaybe<Scalars["String"]>;
  Outreach_Number_of_Active_Tasks__c?: InputMaybe<Scalars["float8"]>;
  OwnerId?: InputMaybe<Scalars["String"]>;
  Phone?: InputMaybe<Scalars["String"]>;
  PhotoUrl?: InputMaybe<Scalars["String"]>;
  ReportsToId?: InputMaybe<Scalars["String"]>;
  Role__c?: InputMaybe<Scalars["String"]>;
  Salutation?: InputMaybe<Scalars["String"]>;
  Status__c?: InputMaybe<Scalars["String"]>;
  Suffix?: InputMaybe<Scalars["String"]>;
  SystemModstamp?: InputMaybe<Scalars["timestamp"]>;
  Title?: InputMaybe<Scalars["String"]>;
};

/** on_conflict condition type for table "Contact" */
export type Contact_on_conflict = {
  constraint: Contact_constraint;
  update_columns?: Array<Contact_update_column>;
  where?: InputMaybe<Contact_bool_exp>;
};

/** Ordering options when selecting data from "Contact". */
export type Contact_order_by = {
  AccountId?: InputMaybe<order_by>;
  Account_Status_Auto__c?: InputMaybe<order_by>;
  Campaign__c?: InputMaybe<order_by>;
  Contact__c?: InputMaybe<order_by>;
  CreatedById?: InputMaybe<order_by>;
  CreatedDate?: InputMaybe<order_by>;
  Department?: InputMaybe<order_by>;
  Description?: InputMaybe<order_by>;
  Email?: InputMaybe<order_by>;
  EmailBouncedDate?: InputMaybe<order_by>;
  EmailBouncedReason?: InputMaybe<order_by>;
  Fax?: InputMaybe<order_by>;
  FirstName?: InputMaybe<order_by>;
  HasOptedOutOfEmail?: InputMaybe<order_by>;
  HubSpot_Company_Id__c?: InputMaybe<order_by>;
  HubSpot_Contact_Id__c?: InputMaybe<order_by>;
  HubSpot_Owner_Id__c?: InputMaybe<order_by>;
  HubSpot_Owner_Name__c?: InputMaybe<order_by>;
  Id?: InputMaybe<order_by>;
  Inactive__c?: InputMaybe<order_by>;
  IsDeleted?: InputMaybe<order_by>;
  IsEmailBounced?: InputMaybe<order_by>;
  Jigsaw?: InputMaybe<order_by>;
  JigsawContactId?: InputMaybe<order_by>;
  LastActivityDate?: InputMaybe<order_by>;
  LastCURequestDate?: InputMaybe<order_by>;
  LastCUUpdateDate?: InputMaybe<order_by>;
  LastModifiedById?: InputMaybe<order_by>;
  LastModifiedDate?: InputMaybe<order_by>;
  LastName?: InputMaybe<order_by>;
  LastReferencedDate?: InputMaybe<order_by>;
  LastViewedDate?: InputMaybe<order_by>;
  LeadSource?: InputMaybe<order_by>;
  Lifecycle_Stage__c?: InputMaybe<order_by>;
  Linkedin_URL__c?: InputMaybe<order_by>;
  MailingAddress?: InputMaybe<order_by>;
  MailingCity?: InputMaybe<order_by>;
  MailingCountry?: InputMaybe<order_by>;
  MailingGeocodeAccuracy?: InputMaybe<order_by>;
  MailingLatitude?: InputMaybe<order_by>;
  MailingLongitude?: InputMaybe<order_by>;
  MailingPostalCode?: InputMaybe<order_by>;
  MailingState?: InputMaybe<order_by>;
  MailingStreet?: InputMaybe<order_by>;
  MasterRecordId?: InputMaybe<order_by>;
  Micro_Theme__c?: InputMaybe<order_by>;
  MiddleName?: InputMaybe<order_by>;
  MobilePhone?: InputMaybe<order_by>;
  Name?: InputMaybe<order_by>;
  Outreach_Actively_Being_Sequenced__c?: InputMaybe<order_by>;
  Outreach_Current_Sequence_ID__c?: InputMaybe<order_by>;
  Outreach_Current_Sequence_Name__c?: InputMaybe<order_by>;
  Outreach_Current_Sequence_Status__c?: InputMaybe<order_by>;
  Outreach_Current_Sequence_Step_Number__c?: InputMaybe<order_by>;
  Outreach_Current_Sequence_Step_Type__c?: InputMaybe<order_by>;
  Outreach_Current_Sequence_Task_Due_Date__c?: InputMaybe<order_by>;
  Outreach_Current_Sequence_User_ID__c?: InputMaybe<order_by>;
  Outreach_Date_Added_to_Sequence__c?: InputMaybe<order_by>;
  Outreach_Finished_Sequences__c?: InputMaybe<order_by>;
  Outreach_Number_of_Active_Sequences__c?: InputMaybe<order_by>;
  Outreach_Number_of_Active_Tasks__c?: InputMaybe<order_by>;
  OwnerId?: InputMaybe<order_by>;
  Phone?: InputMaybe<order_by>;
  PhotoUrl?: InputMaybe<order_by>;
  ReportsToId?: InputMaybe<order_by>;
  Role__c?: InputMaybe<order_by>;
  Salutation?: InputMaybe<order_by>;
  Status__c?: InputMaybe<order_by>;
  Suffix?: InputMaybe<order_by>;
  SystemModstamp?: InputMaybe<order_by>;
  Title?: InputMaybe<order_by>;
};

/** primary key columns input for table: Contact */
export type Contact_pk_columns_input = {
  Id: Scalars["String"];
};

/** select columns of table "Contact" */
export enum Contact_select_column {
  /** column name */
  AccountId = "AccountId",
  /** column name */
  Account_Status_Auto__c = "Account_Status_Auto__c",
  /** column name */
  Campaign__c = "Campaign__c",
  /** column name */
  Contact__c = "Contact__c",
  /** column name */
  CreatedById = "CreatedById",
  /** column name */
  CreatedDate = "CreatedDate",
  /** column name */
  Department = "Department",
  /** column name */
  Description = "Description",
  /** column name */
  Email = "Email",
  /** column name */
  EmailBouncedDate = "EmailBouncedDate",
  /** column name */
  EmailBouncedReason = "EmailBouncedReason",
  /** column name */
  Fax = "Fax",
  /** column name */
  FirstName = "FirstName",
  /** column name */
  HasOptedOutOfEmail = "HasOptedOutOfEmail",
  /** column name */
  HubSpot_Company_Id__c = "HubSpot_Company_Id__c",
  /** column name */
  HubSpot_Contact_Id__c = "HubSpot_Contact_Id__c",
  /** column name */
  HubSpot_Owner_Id__c = "HubSpot_Owner_Id__c",
  /** column name */
  HubSpot_Owner_Name__c = "HubSpot_Owner_Name__c",
  /** column name */
  Id = "Id",
  /** column name */
  Inactive__c = "Inactive__c",
  /** column name */
  IsDeleted = "IsDeleted",
  /** column name */
  IsEmailBounced = "IsEmailBounced",
  /** column name */
  Jigsaw = "Jigsaw",
  /** column name */
  JigsawContactId = "JigsawContactId",
  /** column name */
  LastActivityDate = "LastActivityDate",
  /** column name */
  LastCURequestDate = "LastCURequestDate",
  /** column name */
  LastCUUpdateDate = "LastCUUpdateDate",
  /** column name */
  LastModifiedById = "LastModifiedById",
  /** column name */
  LastModifiedDate = "LastModifiedDate",
  /** column name */
  LastName = "LastName",
  /** column name */
  LastReferencedDate = "LastReferencedDate",
  /** column name */
  LastViewedDate = "LastViewedDate",
  /** column name */
  LeadSource = "LeadSource",
  /** column name */
  Lifecycle_Stage__c = "Lifecycle_Stage__c",
  /** column name */
  Linkedin_URL__c = "Linkedin_URL__c",
  /** column name */
  MailingAddress = "MailingAddress",
  /** column name */
  MailingCity = "MailingCity",
  /** column name */
  MailingCountry = "MailingCountry",
  /** column name */
  MailingGeocodeAccuracy = "MailingGeocodeAccuracy",
  /** column name */
  MailingLatitude = "MailingLatitude",
  /** column name */
  MailingLongitude = "MailingLongitude",
  /** column name */
  MailingPostalCode = "MailingPostalCode",
  /** column name */
  MailingState = "MailingState",
  /** column name */
  MailingStreet = "MailingStreet",
  /** column name */
  MasterRecordId = "MasterRecordId",
  /** column name */
  Micro_Theme__c = "Micro_Theme__c",
  /** column name */
  MiddleName = "MiddleName",
  /** column name */
  MobilePhone = "MobilePhone",
  /** column name */
  Name = "Name",
  /** column name */
  Outreach_Actively_Being_Sequenced__c = "Outreach_Actively_Being_Sequenced__c",
  /** column name */
  Outreach_Current_Sequence_ID__c = "Outreach_Current_Sequence_ID__c",
  /** column name */
  Outreach_Current_Sequence_Name__c = "Outreach_Current_Sequence_Name__c",
  /** column name */
  Outreach_Current_Sequence_Status__c = "Outreach_Current_Sequence_Status__c",
  /** column name */
  Outreach_Current_Sequence_Step_Number__c = "Outreach_Current_Sequence_Step_Number__c",
  /** column name */
  Outreach_Current_Sequence_Step_Type__c = "Outreach_Current_Sequence_Step_Type__c",
  /** column name */
  Outreach_Current_Sequence_Task_Due_Date__c = "Outreach_Current_Sequence_Task_Due_Date__c",
  /** column name */
  Outreach_Current_Sequence_User_ID__c = "Outreach_Current_Sequence_User_ID__c",
  /** column name */
  Outreach_Date_Added_to_Sequence__c = "Outreach_Date_Added_to_Sequence__c",
  /** column name */
  Outreach_Finished_Sequences__c = "Outreach_Finished_Sequences__c",
  /** column name */
  Outreach_Number_of_Active_Sequences__c = "Outreach_Number_of_Active_Sequences__c",
  /** column name */
  Outreach_Number_of_Active_Tasks__c = "Outreach_Number_of_Active_Tasks__c",
  /** column name */
  OwnerId = "OwnerId",
  /** column name */
  Phone = "Phone",
  /** column name */
  PhotoUrl = "PhotoUrl",
  /** column name */
  ReportsToId = "ReportsToId",
  /** column name */
  Role__c = "Role__c",
  /** column name */
  Salutation = "Salutation",
  /** column name */
  Status__c = "Status__c",
  /** column name */
  Suffix = "Suffix",
  /** column name */
  SystemModstamp = "SystemModstamp",
  /** column name */
  Title = "Title",
}

/** input type for updating data in table "Contact" */
export type Contact_set_input = {
  AccountId?: InputMaybe<Scalars["String"]>;
  Account_Status_Auto__c?: InputMaybe<Scalars["String"]>;
  Campaign__c?: InputMaybe<Scalars["String"]>;
  Contact__c?: InputMaybe<Scalars["String"]>;
  CreatedById?: InputMaybe<Scalars["String"]>;
  CreatedDate?: InputMaybe<Scalars["timestamp"]>;
  Department?: InputMaybe<Scalars["String"]>;
  Description?: InputMaybe<Scalars["String"]>;
  Email?: InputMaybe<Scalars["String"]>;
  EmailBouncedDate?: InputMaybe<Scalars["timestamp"]>;
  EmailBouncedReason?: InputMaybe<Scalars["String"]>;
  Fax?: InputMaybe<Scalars["String"]>;
  FirstName?: InputMaybe<Scalars["String"]>;
  HasOptedOutOfEmail?: InputMaybe<Scalars["Boolean"]>;
  HubSpot_Company_Id__c?: InputMaybe<Scalars["String"]>;
  HubSpot_Contact_Id__c?: InputMaybe<Scalars["String"]>;
  HubSpot_Owner_Id__c?: InputMaybe<Scalars["String"]>;
  HubSpot_Owner_Name__c?: InputMaybe<Scalars["String"]>;
  Id?: InputMaybe<Scalars["String"]>;
  Inactive__c?: InputMaybe<Scalars["Boolean"]>;
  IsDeleted?: InputMaybe<Scalars["Boolean"]>;
  IsEmailBounced?: InputMaybe<Scalars["Boolean"]>;
  Jigsaw?: InputMaybe<Scalars["String"]>;
  JigsawContactId?: InputMaybe<Scalars["String"]>;
  LastActivityDate?: InputMaybe<Scalars["date"]>;
  LastCURequestDate?: InputMaybe<Scalars["timestamp"]>;
  LastCUUpdateDate?: InputMaybe<Scalars["timestamp"]>;
  LastModifiedById?: InputMaybe<Scalars["String"]>;
  LastModifiedDate?: InputMaybe<Scalars["timestamp"]>;
  LastName?: InputMaybe<Scalars["String"]>;
  LastReferencedDate?: InputMaybe<Scalars["timestamp"]>;
  LastViewedDate?: InputMaybe<Scalars["timestamp"]>;
  LeadSource?: InputMaybe<Scalars["String"]>;
  Lifecycle_Stage__c?: InputMaybe<Scalars["String"]>;
  Linkedin_URL__c?: InputMaybe<Scalars["String"]>;
  MailingAddress?: InputMaybe<Scalars["json"]>;
  MailingCity?: InputMaybe<Scalars["String"]>;
  MailingCountry?: InputMaybe<Scalars["String"]>;
  MailingGeocodeAccuracy?: InputMaybe<Scalars["String"]>;
  MailingLatitude?: InputMaybe<Scalars["float8"]>;
  MailingLongitude?: InputMaybe<Scalars["float8"]>;
  MailingPostalCode?: InputMaybe<Scalars["String"]>;
  MailingState?: InputMaybe<Scalars["String"]>;
  MailingStreet?: InputMaybe<Scalars["String"]>;
  MasterRecordId?: InputMaybe<Scalars["String"]>;
  Micro_Theme__c?: InputMaybe<Scalars["String"]>;
  MiddleName?: InputMaybe<Scalars["String"]>;
  MobilePhone?: InputMaybe<Scalars["String"]>;
  Name?: InputMaybe<Scalars["String"]>;
  Outreach_Actively_Being_Sequenced__c?: InputMaybe<Scalars["Boolean"]>;
  Outreach_Current_Sequence_ID__c?: InputMaybe<Scalars["String"]>;
  Outreach_Current_Sequence_Name__c?: InputMaybe<Scalars["String"]>;
  Outreach_Current_Sequence_Status__c?: InputMaybe<Scalars["String"]>;
  Outreach_Current_Sequence_Step_Number__c?: InputMaybe<Scalars["float8"]>;
  Outreach_Current_Sequence_Step_Type__c?: InputMaybe<Scalars["String"]>;
  Outreach_Current_Sequence_Task_Due_Date__c?: InputMaybe<Scalars["timestamp"]>;
  Outreach_Current_Sequence_User_ID__c?: InputMaybe<Scalars["String"]>;
  Outreach_Date_Added_to_Sequence__c?: InputMaybe<Scalars["date"]>;
  Outreach_Finished_Sequences__c?: InputMaybe<Scalars["String"]>;
  Outreach_Number_of_Active_Sequences__c?: InputMaybe<Scalars["String"]>;
  Outreach_Number_of_Active_Tasks__c?: InputMaybe<Scalars["float8"]>;
  OwnerId?: InputMaybe<Scalars["String"]>;
  Phone?: InputMaybe<Scalars["String"]>;
  PhotoUrl?: InputMaybe<Scalars["String"]>;
  ReportsToId?: InputMaybe<Scalars["String"]>;
  Role__c?: InputMaybe<Scalars["String"]>;
  Salutation?: InputMaybe<Scalars["String"]>;
  Status__c?: InputMaybe<Scalars["String"]>;
  Suffix?: InputMaybe<Scalars["String"]>;
  SystemModstamp?: InputMaybe<Scalars["timestamp"]>;
  Title?: InputMaybe<Scalars["String"]>;
};

/** Streaming cursor of the table "Contact" */
export type Contact_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: Contact_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Contact_stream_cursor_value_input = {
  AccountId?: InputMaybe<Scalars["String"]>;
  Account_Status_Auto__c?: InputMaybe<Scalars["String"]>;
  Campaign__c?: InputMaybe<Scalars["String"]>;
  Contact__c?: InputMaybe<Scalars["String"]>;
  CreatedById?: InputMaybe<Scalars["String"]>;
  CreatedDate?: InputMaybe<Scalars["timestamp"]>;
  Department?: InputMaybe<Scalars["String"]>;
  Description?: InputMaybe<Scalars["String"]>;
  Email?: InputMaybe<Scalars["String"]>;
  EmailBouncedDate?: InputMaybe<Scalars["timestamp"]>;
  EmailBouncedReason?: InputMaybe<Scalars["String"]>;
  Fax?: InputMaybe<Scalars["String"]>;
  FirstName?: InputMaybe<Scalars["String"]>;
  HasOptedOutOfEmail?: InputMaybe<Scalars["Boolean"]>;
  HubSpot_Company_Id__c?: InputMaybe<Scalars["String"]>;
  HubSpot_Contact_Id__c?: InputMaybe<Scalars["String"]>;
  HubSpot_Owner_Id__c?: InputMaybe<Scalars["String"]>;
  HubSpot_Owner_Name__c?: InputMaybe<Scalars["String"]>;
  Id?: InputMaybe<Scalars["String"]>;
  Inactive__c?: InputMaybe<Scalars["Boolean"]>;
  IsDeleted?: InputMaybe<Scalars["Boolean"]>;
  IsEmailBounced?: InputMaybe<Scalars["Boolean"]>;
  Jigsaw?: InputMaybe<Scalars["String"]>;
  JigsawContactId?: InputMaybe<Scalars["String"]>;
  LastActivityDate?: InputMaybe<Scalars["date"]>;
  LastCURequestDate?: InputMaybe<Scalars["timestamp"]>;
  LastCUUpdateDate?: InputMaybe<Scalars["timestamp"]>;
  LastModifiedById?: InputMaybe<Scalars["String"]>;
  LastModifiedDate?: InputMaybe<Scalars["timestamp"]>;
  LastName?: InputMaybe<Scalars["String"]>;
  LastReferencedDate?: InputMaybe<Scalars["timestamp"]>;
  LastViewedDate?: InputMaybe<Scalars["timestamp"]>;
  LeadSource?: InputMaybe<Scalars["String"]>;
  Lifecycle_Stage__c?: InputMaybe<Scalars["String"]>;
  Linkedin_URL__c?: InputMaybe<Scalars["String"]>;
  MailingAddress?: InputMaybe<Scalars["json"]>;
  MailingCity?: InputMaybe<Scalars["String"]>;
  MailingCountry?: InputMaybe<Scalars["String"]>;
  MailingGeocodeAccuracy?: InputMaybe<Scalars["String"]>;
  MailingLatitude?: InputMaybe<Scalars["float8"]>;
  MailingLongitude?: InputMaybe<Scalars["float8"]>;
  MailingPostalCode?: InputMaybe<Scalars["String"]>;
  MailingState?: InputMaybe<Scalars["String"]>;
  MailingStreet?: InputMaybe<Scalars["String"]>;
  MasterRecordId?: InputMaybe<Scalars["String"]>;
  Micro_Theme__c?: InputMaybe<Scalars["String"]>;
  MiddleName?: InputMaybe<Scalars["String"]>;
  MobilePhone?: InputMaybe<Scalars["String"]>;
  Name?: InputMaybe<Scalars["String"]>;
  Outreach_Actively_Being_Sequenced__c?: InputMaybe<Scalars["Boolean"]>;
  Outreach_Current_Sequence_ID__c?: InputMaybe<Scalars["String"]>;
  Outreach_Current_Sequence_Name__c?: InputMaybe<Scalars["String"]>;
  Outreach_Current_Sequence_Status__c?: InputMaybe<Scalars["String"]>;
  Outreach_Current_Sequence_Step_Number__c?: InputMaybe<Scalars["float8"]>;
  Outreach_Current_Sequence_Step_Type__c?: InputMaybe<Scalars["String"]>;
  Outreach_Current_Sequence_Task_Due_Date__c?: InputMaybe<Scalars["timestamp"]>;
  Outreach_Current_Sequence_User_ID__c?: InputMaybe<Scalars["String"]>;
  Outreach_Date_Added_to_Sequence__c?: InputMaybe<Scalars["date"]>;
  Outreach_Finished_Sequences__c?: InputMaybe<Scalars["String"]>;
  Outreach_Number_of_Active_Sequences__c?: InputMaybe<Scalars["String"]>;
  Outreach_Number_of_Active_Tasks__c?: InputMaybe<Scalars["float8"]>;
  OwnerId?: InputMaybe<Scalars["String"]>;
  Phone?: InputMaybe<Scalars["String"]>;
  PhotoUrl?: InputMaybe<Scalars["String"]>;
  ReportsToId?: InputMaybe<Scalars["String"]>;
  Role__c?: InputMaybe<Scalars["String"]>;
  Salutation?: InputMaybe<Scalars["String"]>;
  Status__c?: InputMaybe<Scalars["String"]>;
  Suffix?: InputMaybe<Scalars["String"]>;
  SystemModstamp?: InputMaybe<Scalars["timestamp"]>;
  Title?: InputMaybe<Scalars["String"]>;
};

/** update columns of table "Contact" */
export enum Contact_update_column {
  /** column name */
  AccountId = "AccountId",
  /** column name */
  Account_Status_Auto__c = "Account_Status_Auto__c",
  /** column name */
  Campaign__c = "Campaign__c",
  /** column name */
  Contact__c = "Contact__c",
  /** column name */
  CreatedById = "CreatedById",
  /** column name */
  CreatedDate = "CreatedDate",
  /** column name */
  Department = "Department",
  /** column name */
  Description = "Description",
  /** column name */
  Email = "Email",
  /** column name */
  EmailBouncedDate = "EmailBouncedDate",
  /** column name */
  EmailBouncedReason = "EmailBouncedReason",
  /** column name */
  Fax = "Fax",
  /** column name */
  FirstName = "FirstName",
  /** column name */
  HasOptedOutOfEmail = "HasOptedOutOfEmail",
  /** column name */
  HubSpot_Company_Id__c = "HubSpot_Company_Id__c",
  /** column name */
  HubSpot_Contact_Id__c = "HubSpot_Contact_Id__c",
  /** column name */
  HubSpot_Owner_Id__c = "HubSpot_Owner_Id__c",
  /** column name */
  HubSpot_Owner_Name__c = "HubSpot_Owner_Name__c",
  /** column name */
  Id = "Id",
  /** column name */
  Inactive__c = "Inactive__c",
  /** column name */
  IsDeleted = "IsDeleted",
  /** column name */
  IsEmailBounced = "IsEmailBounced",
  /** column name */
  Jigsaw = "Jigsaw",
  /** column name */
  JigsawContactId = "JigsawContactId",
  /** column name */
  LastActivityDate = "LastActivityDate",
  /** column name */
  LastCURequestDate = "LastCURequestDate",
  /** column name */
  LastCUUpdateDate = "LastCUUpdateDate",
  /** column name */
  LastModifiedById = "LastModifiedById",
  /** column name */
  LastModifiedDate = "LastModifiedDate",
  /** column name */
  LastName = "LastName",
  /** column name */
  LastReferencedDate = "LastReferencedDate",
  /** column name */
  LastViewedDate = "LastViewedDate",
  /** column name */
  LeadSource = "LeadSource",
  /** column name */
  Lifecycle_Stage__c = "Lifecycle_Stage__c",
  /** column name */
  Linkedin_URL__c = "Linkedin_URL__c",
  /** column name */
  MailingAddress = "MailingAddress",
  /** column name */
  MailingCity = "MailingCity",
  /** column name */
  MailingCountry = "MailingCountry",
  /** column name */
  MailingGeocodeAccuracy = "MailingGeocodeAccuracy",
  /** column name */
  MailingLatitude = "MailingLatitude",
  /** column name */
  MailingLongitude = "MailingLongitude",
  /** column name */
  MailingPostalCode = "MailingPostalCode",
  /** column name */
  MailingState = "MailingState",
  /** column name */
  MailingStreet = "MailingStreet",
  /** column name */
  MasterRecordId = "MasterRecordId",
  /** column name */
  Micro_Theme__c = "Micro_Theme__c",
  /** column name */
  MiddleName = "MiddleName",
  /** column name */
  MobilePhone = "MobilePhone",
  /** column name */
  Name = "Name",
  /** column name */
  Outreach_Actively_Being_Sequenced__c = "Outreach_Actively_Being_Sequenced__c",
  /** column name */
  Outreach_Current_Sequence_ID__c = "Outreach_Current_Sequence_ID__c",
  /** column name */
  Outreach_Current_Sequence_Name__c = "Outreach_Current_Sequence_Name__c",
  /** column name */
  Outreach_Current_Sequence_Status__c = "Outreach_Current_Sequence_Status__c",
  /** column name */
  Outreach_Current_Sequence_Step_Number__c = "Outreach_Current_Sequence_Step_Number__c",
  /** column name */
  Outreach_Current_Sequence_Step_Type__c = "Outreach_Current_Sequence_Step_Type__c",
  /** column name */
  Outreach_Current_Sequence_Task_Due_Date__c = "Outreach_Current_Sequence_Task_Due_Date__c",
  /** column name */
  Outreach_Current_Sequence_User_ID__c = "Outreach_Current_Sequence_User_ID__c",
  /** column name */
  Outreach_Date_Added_to_Sequence__c = "Outreach_Date_Added_to_Sequence__c",
  /** column name */
  Outreach_Finished_Sequences__c = "Outreach_Finished_Sequences__c",
  /** column name */
  Outreach_Number_of_Active_Sequences__c = "Outreach_Number_of_Active_Sequences__c",
  /** column name */
  Outreach_Number_of_Active_Tasks__c = "Outreach_Number_of_Active_Tasks__c",
  /** column name */
  OwnerId = "OwnerId",
  /** column name */
  Phone = "Phone",
  /** column name */
  PhotoUrl = "PhotoUrl",
  /** column name */
  ReportsToId = "ReportsToId",
  /** column name */
  Role__c = "Role__c",
  /** column name */
  Salutation = "Salutation",
  /** column name */
  Status__c = "Status__c",
  /** column name */
  Suffix = "Suffix",
  /** column name */
  SystemModstamp = "SystemModstamp",
  /** column name */
  Title = "Title",
}

export type Contact_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Contact_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Contact_set_input>;
  where: Contact_bool_exp;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_comparison_exp = {
  _eq?: InputMaybe<Scalars["Int"]>;
  _gt?: InputMaybe<Scalars["Int"]>;
  _gte?: InputMaybe<Scalars["Int"]>;
  _in?: InputMaybe<Array<Scalars["Int"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["Int"]>;
  _lte?: InputMaybe<Scalars["Int"]>;
  _neq?: InputMaybe<Scalars["Int"]>;
  _nin?: InputMaybe<Array<Scalars["Int"]>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_comparison_exp_remote_rel_crm_to_revtron_accountto_revtron_companies =
  {
    _gt?: InputMaybe<Scalars["Int"]>;
    _gte?: InputMaybe<Scalars["Int"]>;
    _in?: InputMaybe<Array<Scalars["Int"]>>;
    _is_null?: InputMaybe<Scalars["Boolean"]>;
    _lt?: InputMaybe<Scalars["Int"]>;
    _lte?: InputMaybe<Scalars["Int"]>;
    _neq?: InputMaybe<Scalars["Int"]>;
    _nin?: InputMaybe<Array<Scalars["Int"]>>;
  };

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_comparison_exp_remote_rel_ml_icp_last_predictionto_revtron = {
  _gt?: InputMaybe<Scalars["Int"]>;
  _gte?: InputMaybe<Scalars["Int"]>;
  _in?: InputMaybe<Array<Scalars["Int"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["Int"]>;
  _lte?: InputMaybe<Scalars["Int"]>;
  _neq?: InputMaybe<Scalars["Int"]>;
  _nin?: InputMaybe<Array<Scalars["Int"]>>;
};

export type Opportunity_aggregate_bool_exp = {
  avg?: InputMaybe<Opportunity_aggregate_bool_exp_avg>;
  bool_and?: InputMaybe<Opportunity_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<Opportunity_aggregate_bool_exp_bool_or>;
  corr?: InputMaybe<Opportunity_aggregate_bool_exp_corr>;
  count?: InputMaybe<Opportunity_aggregate_bool_exp_count>;
  covar_samp?: InputMaybe<Opportunity_aggregate_bool_exp_covar_samp>;
  max?: InputMaybe<Opportunity_aggregate_bool_exp_max>;
  min?: InputMaybe<Opportunity_aggregate_bool_exp_min>;
  stddev_samp?: InputMaybe<Opportunity_aggregate_bool_exp_stddev_samp>;
  sum?: InputMaybe<Opportunity_aggregate_bool_exp_sum>;
  var_samp?: InputMaybe<Opportunity_aggregate_bool_exp_var_samp>;
};

export type Opportunity_aggregate_bool_exp_avg = {
  arguments: Opportunity_select_column_Opportunity_aggregate_bool_exp_avg_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<Opportunity_bool_exp>;
  predicate: float8_comparison_exp;
};

export type Opportunity_aggregate_bool_exp_bool_and = {
  arguments: Opportunity_select_column_Opportunity_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<Opportunity_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type Opportunity_aggregate_bool_exp_bool_or = {
  arguments: Opportunity_select_column_Opportunity_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<Opportunity_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type Opportunity_aggregate_bool_exp_corr = {
  arguments: Opportunity_aggregate_bool_exp_corr_arguments;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<Opportunity_bool_exp>;
  predicate: float8_comparison_exp;
};

export type Opportunity_aggregate_bool_exp_corr_arguments = {
  X: Opportunity_select_column_Opportunity_aggregate_bool_exp_corr_arguments_columns;
  Y: Opportunity_select_column_Opportunity_aggregate_bool_exp_corr_arguments_columns;
};

export type Opportunity_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<Opportunity_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<Opportunity_bool_exp>;
  predicate: Int_comparison_exp;
};

export type Opportunity_aggregate_bool_exp_covar_samp = {
  arguments: Opportunity_aggregate_bool_exp_covar_samp_arguments;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<Opportunity_bool_exp>;
  predicate: float8_comparison_exp;
};

export type Opportunity_aggregate_bool_exp_covar_samp_arguments = {
  X: Opportunity_select_column_Opportunity_aggregate_bool_exp_covar_samp_arguments_columns;
  Y: Opportunity_select_column_Opportunity_aggregate_bool_exp_covar_samp_arguments_columns;
};

export type Opportunity_aggregate_bool_exp_max = {
  arguments: Opportunity_select_column_Opportunity_aggregate_bool_exp_max_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<Opportunity_bool_exp>;
  predicate: float8_comparison_exp;
};

export type Opportunity_aggregate_bool_exp_min = {
  arguments: Opportunity_select_column_Opportunity_aggregate_bool_exp_min_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<Opportunity_bool_exp>;
  predicate: float8_comparison_exp;
};

export type Opportunity_aggregate_bool_exp_stddev_samp = {
  arguments: Opportunity_select_column_Opportunity_aggregate_bool_exp_stddev_samp_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<Opportunity_bool_exp>;
  predicate: float8_comparison_exp;
};

export type Opportunity_aggregate_bool_exp_sum = {
  arguments: Opportunity_select_column_Opportunity_aggregate_bool_exp_sum_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<Opportunity_bool_exp>;
  predicate: float8_comparison_exp;
};

export type Opportunity_aggregate_bool_exp_var_samp = {
  arguments: Opportunity_select_column_Opportunity_aggregate_bool_exp_var_samp_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<Opportunity_bool_exp>;
  predicate: float8_comparison_exp;
};

/** order by aggregate values of table "Opportunity" */
export type Opportunity_aggregate_order_by = {
  avg?: InputMaybe<Opportunity_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<Opportunity_max_order_by>;
  min?: InputMaybe<Opportunity_min_order_by>;
  stddev?: InputMaybe<Opportunity_stddev_order_by>;
  stddev_pop?: InputMaybe<Opportunity_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<Opportunity_stddev_samp_order_by>;
  sum?: InputMaybe<Opportunity_sum_order_by>;
  var_pop?: InputMaybe<Opportunity_var_pop_order_by>;
  var_samp?: InputMaybe<Opportunity_var_samp_order_by>;
  variance?: InputMaybe<Opportunity_variance_order_by>;
};

/** input type for inserting array relation for remote table "Opportunity" */
export type Opportunity_arr_rel_insert_input = {
  data: Array<Opportunity_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Opportunity_on_conflict>;
};

/** order by avg() on columns of table "Opportunity" */
export type Opportunity_avg_order_by = {
  ARR__c?: InputMaybe<order_by>;
  AWARDview__c?: InputMaybe<order_by>;
  Amount?: InputMaybe<order_by>;
  CONTENTview__c?: InputMaybe<order_by>;
  Close_Date_Delta__c?: InputMaybe<order_by>;
  FiscalQuarter?: InputMaybe<order_by>;
  FiscalYear?: InputMaybe<order_by>;
  Implementation_Fee__c?: InputMaybe<order_by>;
  MODELview__c?: InputMaybe<order_by>;
  MRR__c?: InputMaybe<order_by>;
  Online_Statements__c?: InputMaybe<order_by>;
  Probability?: InputMaybe<order_by>;
  PushCount?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "Opportunity". All fields are combined with a logical 'AND'. */
export type Opportunity_bool_exp = {
  ARR__c?: InputMaybe<float8_comparison_exp>;
  AWARDview__c?: InputMaybe<float8_comparison_exp>;
  AccountId?: InputMaybe<String_comparison_exp>;
  All_Members_Commissionable__c?: InputMaybe<Boolean_comparison_exp>;
  Amount?: InputMaybe<float8_comparison_exp>;
  Budget_Confirmed__c?: InputMaybe<Boolean_comparison_exp>;
  COMPview__c?: InputMaybe<Boolean_comparison_exp>;
  CONTENTview__c?: InputMaybe<float8_comparison_exp>;
  CampaignId?: InputMaybe<String_comparison_exp>;
  CloseDate?: InputMaybe<date_comparison_exp>;
  Close_Date_Delta__c?: InputMaybe<float8_comparison_exp>;
  Competitors__c?: InputMaybe<String_comparison_exp>;
  ContactId?: InputMaybe<String_comparison_exp>;
  ContractId?: InputMaybe<String_comparison_exp>;
  CreatedById?: InputMaybe<String_comparison_exp>;
  CreatedDate?: InputMaybe<timestamp_comparison_exp>;
  Description?: InputMaybe<String_comparison_exp>;
  Discovery_Completed__c?: InputMaybe<Boolean_comparison_exp>;
  Expected_Go_Live__c?: InputMaybe<date_comparison_exp>;
  Fiscal?: InputMaybe<String_comparison_exp>;
  FiscalQuarter?: InputMaybe<Int_comparison_exp>;
  FiscalYear?: InputMaybe<Int_comparison_exp>;
  ForecastCategory?: InputMaybe<String_comparison_exp>;
  ForecastCategoryName?: InputMaybe<String_comparison_exp>;
  HasOpenActivity?: InputMaybe<Boolean_comparison_exp>;
  HasOpportunityLineItem?: InputMaybe<Boolean_comparison_exp>;
  HasOverdueTask?: InputMaybe<Boolean_comparison_exp>;
  HubSpot_Company_Id__c?: InputMaybe<String_comparison_exp>;
  HubSpot_Created_By_User_Id__c?: InputMaybe<String_comparison_exp>;
  HubSpot_Deal_Id__c?: InputMaybe<String_comparison_exp>;
  HubSpot_Owner_Id__c?: InputMaybe<String_comparison_exp>;
  INCENTview__c?: InputMaybe<Boolean_comparison_exp>;
  Id?: InputMaybe<String_comparison_exp>;
  Implementation_Fee__c?: InputMaybe<float8_comparison_exp>;
  IsClosed?: InputMaybe<Boolean_comparison_exp>;
  IsDeleted?: InputMaybe<Boolean_comparison_exp>;
  IsWon?: InputMaybe<Boolean_comparison_exp>;
  LastActivityDate?: InputMaybe<date_comparison_exp>;
  LastAmountChangedHistoryId?: InputMaybe<String_comparison_exp>;
  LastCloseDateChangedHistoryId?: InputMaybe<String_comparison_exp>;
  LastModifiedById?: InputMaybe<String_comparison_exp>;
  LastModifiedDate?: InputMaybe<timestamp_comparison_exp>;
  LastReferencedDate?: InputMaybe<timestamp_comparison_exp>;
  LastStageChangeDate?: InputMaybe<timestamp_comparison_exp>;
  LastViewedDate?: InputMaybe<timestamp_comparison_exp>;
  LeadSource?: InputMaybe<String_comparison_exp>;
  Loss_Reason__c?: InputMaybe<String_comparison_exp>;
  MODELview__c?: InputMaybe<float8_comparison_exp>;
  MRR__c?: InputMaybe<float8_comparison_exp>;
  Name?: InputMaybe<String_comparison_exp>;
  NextStep?: InputMaybe<String_comparison_exp>;
  Online_Statements__c?: InputMaybe<float8_comparison_exp>;
  Outreach_Attributed_Finished_Sequences__c?: InputMaybe<String_comparison_exp>;
  Outreach_Last_Touch_Contact__c?: InputMaybe<String_comparison_exp>;
  Outreach_Last_Touch_Sequence__c?: InputMaybe<String_comparison_exp>;
  Outreach_Sequence_Attributed__c?: InputMaybe<String_comparison_exp>;
  OwnerId?: InputMaybe<String_comparison_exp>;
  PAYview__c?: InputMaybe<Boolean_comparison_exp>;
  PERFORMview__c?: InputMaybe<Boolean_comparison_exp>;
  Previous_Close_Date__c?: InputMaybe<date_comparison_exp>;
  Pricebook2Id?: InputMaybe<String_comparison_exp>;
  Probability?: InputMaybe<float8_comparison_exp>;
  PushCount?: InputMaybe<Int_comparison_exp>;
  REWARDview__c?: InputMaybe<Boolean_comparison_exp>;
  ROI_Analysis_Completed__c?: InputMaybe<Boolean_comparison_exp>;
  Re_engagement_Date__c?: InputMaybe<date_comparison_exp>;
  Second_Competitor__c?: InputMaybe<String_comparison_exp>;
  StageName?: InputMaybe<String_comparison_exp>;
  SyncedQuoteId?: InputMaybe<String_comparison_exp>;
  SystemModstamp?: InputMaybe<timestamp_comparison_exp>;
  Type?: InputMaybe<String_comparison_exp>;
  _and?: InputMaybe<Array<Opportunity_bool_exp>>;
  _not?: InputMaybe<Opportunity_bool_exp>;
  _or?: InputMaybe<Array<Opportunity_bool_exp>>;
};

/** unique or primary key constraints on table "Opportunity" */
export enum Opportunity_constraint {
  /** unique or primary key constraint on columns "Id" */
  Opportunity_pkey = "Opportunity_pkey",
}

/** input type for incrementing numeric columns in table "Opportunity" */
export type Opportunity_inc_input = {
  ARR__c?: InputMaybe<Scalars["float8"]>;
  AWARDview__c?: InputMaybe<Scalars["float8"]>;
  Amount?: InputMaybe<Scalars["float8"]>;
  CONTENTview__c?: InputMaybe<Scalars["float8"]>;
  Close_Date_Delta__c?: InputMaybe<Scalars["float8"]>;
  FiscalQuarter?: InputMaybe<Scalars["Int"]>;
  FiscalYear?: InputMaybe<Scalars["Int"]>;
  Implementation_Fee__c?: InputMaybe<Scalars["float8"]>;
  MODELview__c?: InputMaybe<Scalars["float8"]>;
  MRR__c?: InputMaybe<Scalars["float8"]>;
  Online_Statements__c?: InputMaybe<Scalars["float8"]>;
  Probability?: InputMaybe<Scalars["float8"]>;
  PushCount?: InputMaybe<Scalars["Int"]>;
};

/** input type for inserting data into table "Opportunity" */
export type Opportunity_insert_input = {
  ARR__c?: InputMaybe<Scalars["float8"]>;
  AWARDview__c?: InputMaybe<Scalars["float8"]>;
  AccountId?: InputMaybe<Scalars["String"]>;
  All_Members_Commissionable__c?: InputMaybe<Scalars["Boolean"]>;
  Amount?: InputMaybe<Scalars["float8"]>;
  Budget_Confirmed__c?: InputMaybe<Scalars["Boolean"]>;
  COMPview__c?: InputMaybe<Scalars["Boolean"]>;
  CONTENTview__c?: InputMaybe<Scalars["float8"]>;
  CampaignId?: InputMaybe<Scalars["String"]>;
  CloseDate?: InputMaybe<Scalars["date"]>;
  Close_Date_Delta__c?: InputMaybe<Scalars["float8"]>;
  Competitors__c?: InputMaybe<Scalars["String"]>;
  ContactId?: InputMaybe<Scalars["String"]>;
  ContractId?: InputMaybe<Scalars["String"]>;
  CreatedById?: InputMaybe<Scalars["String"]>;
  CreatedDate?: InputMaybe<Scalars["timestamp"]>;
  Description?: InputMaybe<Scalars["String"]>;
  Discovery_Completed__c?: InputMaybe<Scalars["Boolean"]>;
  Expected_Go_Live__c?: InputMaybe<Scalars["date"]>;
  Fiscal?: InputMaybe<Scalars["String"]>;
  FiscalQuarter?: InputMaybe<Scalars["Int"]>;
  FiscalYear?: InputMaybe<Scalars["Int"]>;
  ForecastCategory?: InputMaybe<Scalars["String"]>;
  ForecastCategoryName?: InputMaybe<Scalars["String"]>;
  HasOpenActivity?: InputMaybe<Scalars["Boolean"]>;
  HasOpportunityLineItem?: InputMaybe<Scalars["Boolean"]>;
  HasOverdueTask?: InputMaybe<Scalars["Boolean"]>;
  HubSpot_Company_Id__c?: InputMaybe<Scalars["String"]>;
  HubSpot_Created_By_User_Id__c?: InputMaybe<Scalars["String"]>;
  HubSpot_Deal_Id__c?: InputMaybe<Scalars["String"]>;
  HubSpot_Owner_Id__c?: InputMaybe<Scalars["String"]>;
  INCENTview__c?: InputMaybe<Scalars["Boolean"]>;
  Id?: InputMaybe<Scalars["String"]>;
  Implementation_Fee__c?: InputMaybe<Scalars["float8"]>;
  IsClosed?: InputMaybe<Scalars["Boolean"]>;
  IsDeleted?: InputMaybe<Scalars["Boolean"]>;
  IsWon?: InputMaybe<Scalars["Boolean"]>;
  LastActivityDate?: InputMaybe<Scalars["date"]>;
  LastAmountChangedHistoryId?: InputMaybe<Scalars["String"]>;
  LastCloseDateChangedHistoryId?: InputMaybe<Scalars["String"]>;
  LastModifiedById?: InputMaybe<Scalars["String"]>;
  LastModifiedDate?: InputMaybe<Scalars["timestamp"]>;
  LastReferencedDate?: InputMaybe<Scalars["timestamp"]>;
  LastStageChangeDate?: InputMaybe<Scalars["timestamp"]>;
  LastViewedDate?: InputMaybe<Scalars["timestamp"]>;
  LeadSource?: InputMaybe<Scalars["String"]>;
  Loss_Reason__c?: InputMaybe<Scalars["String"]>;
  MODELview__c?: InputMaybe<Scalars["float8"]>;
  MRR__c?: InputMaybe<Scalars["float8"]>;
  Name?: InputMaybe<Scalars["String"]>;
  NextStep?: InputMaybe<Scalars["String"]>;
  Online_Statements__c?: InputMaybe<Scalars["float8"]>;
  Outreach_Attributed_Finished_Sequences__c?: InputMaybe<Scalars["String"]>;
  Outreach_Last_Touch_Contact__c?: InputMaybe<Scalars["String"]>;
  Outreach_Last_Touch_Sequence__c?: InputMaybe<Scalars["String"]>;
  Outreach_Sequence_Attributed__c?: InputMaybe<Scalars["String"]>;
  OwnerId?: InputMaybe<Scalars["String"]>;
  PAYview__c?: InputMaybe<Scalars["Boolean"]>;
  PERFORMview__c?: InputMaybe<Scalars["Boolean"]>;
  Previous_Close_Date__c?: InputMaybe<Scalars["date"]>;
  Pricebook2Id?: InputMaybe<Scalars["String"]>;
  Probability?: InputMaybe<Scalars["float8"]>;
  PushCount?: InputMaybe<Scalars["Int"]>;
  REWARDview__c?: InputMaybe<Scalars["Boolean"]>;
  ROI_Analysis_Completed__c?: InputMaybe<Scalars["Boolean"]>;
  Re_engagement_Date__c?: InputMaybe<Scalars["date"]>;
  Second_Competitor__c?: InputMaybe<Scalars["String"]>;
  StageName?: InputMaybe<Scalars["String"]>;
  SyncedQuoteId?: InputMaybe<Scalars["String"]>;
  SystemModstamp?: InputMaybe<Scalars["timestamp"]>;
  Type?: InputMaybe<Scalars["String"]>;
};

/** order by max() on columns of table "Opportunity" */
export type Opportunity_max_order_by = {
  ARR__c?: InputMaybe<order_by>;
  AWARDview__c?: InputMaybe<order_by>;
  AccountId?: InputMaybe<order_by>;
  Amount?: InputMaybe<order_by>;
  CONTENTview__c?: InputMaybe<order_by>;
  CampaignId?: InputMaybe<order_by>;
  CloseDate?: InputMaybe<order_by>;
  Close_Date_Delta__c?: InputMaybe<order_by>;
  Competitors__c?: InputMaybe<order_by>;
  ContactId?: InputMaybe<order_by>;
  ContractId?: InputMaybe<order_by>;
  CreatedById?: InputMaybe<order_by>;
  CreatedDate?: InputMaybe<order_by>;
  Description?: InputMaybe<order_by>;
  Expected_Go_Live__c?: InputMaybe<order_by>;
  Fiscal?: InputMaybe<order_by>;
  FiscalQuarter?: InputMaybe<order_by>;
  FiscalYear?: InputMaybe<order_by>;
  ForecastCategory?: InputMaybe<order_by>;
  ForecastCategoryName?: InputMaybe<order_by>;
  HubSpot_Company_Id__c?: InputMaybe<order_by>;
  HubSpot_Created_By_User_Id__c?: InputMaybe<order_by>;
  HubSpot_Deal_Id__c?: InputMaybe<order_by>;
  HubSpot_Owner_Id__c?: InputMaybe<order_by>;
  Id?: InputMaybe<order_by>;
  Implementation_Fee__c?: InputMaybe<order_by>;
  LastActivityDate?: InputMaybe<order_by>;
  LastAmountChangedHistoryId?: InputMaybe<order_by>;
  LastCloseDateChangedHistoryId?: InputMaybe<order_by>;
  LastModifiedById?: InputMaybe<order_by>;
  LastModifiedDate?: InputMaybe<order_by>;
  LastReferencedDate?: InputMaybe<order_by>;
  LastStageChangeDate?: InputMaybe<order_by>;
  LastViewedDate?: InputMaybe<order_by>;
  LeadSource?: InputMaybe<order_by>;
  Loss_Reason__c?: InputMaybe<order_by>;
  MODELview__c?: InputMaybe<order_by>;
  MRR__c?: InputMaybe<order_by>;
  Name?: InputMaybe<order_by>;
  NextStep?: InputMaybe<order_by>;
  Online_Statements__c?: InputMaybe<order_by>;
  Outreach_Attributed_Finished_Sequences__c?: InputMaybe<order_by>;
  Outreach_Last_Touch_Contact__c?: InputMaybe<order_by>;
  Outreach_Last_Touch_Sequence__c?: InputMaybe<order_by>;
  Outreach_Sequence_Attributed__c?: InputMaybe<order_by>;
  OwnerId?: InputMaybe<order_by>;
  Previous_Close_Date__c?: InputMaybe<order_by>;
  Pricebook2Id?: InputMaybe<order_by>;
  Probability?: InputMaybe<order_by>;
  PushCount?: InputMaybe<order_by>;
  Re_engagement_Date__c?: InputMaybe<order_by>;
  Second_Competitor__c?: InputMaybe<order_by>;
  StageName?: InputMaybe<order_by>;
  SyncedQuoteId?: InputMaybe<order_by>;
  SystemModstamp?: InputMaybe<order_by>;
  Type?: InputMaybe<order_by>;
};

/** order by min() on columns of table "Opportunity" */
export type Opportunity_min_order_by = {
  ARR__c?: InputMaybe<order_by>;
  AWARDview__c?: InputMaybe<order_by>;
  AccountId?: InputMaybe<order_by>;
  Amount?: InputMaybe<order_by>;
  CONTENTview__c?: InputMaybe<order_by>;
  CampaignId?: InputMaybe<order_by>;
  CloseDate?: InputMaybe<order_by>;
  Close_Date_Delta__c?: InputMaybe<order_by>;
  Competitors__c?: InputMaybe<order_by>;
  ContactId?: InputMaybe<order_by>;
  ContractId?: InputMaybe<order_by>;
  CreatedById?: InputMaybe<order_by>;
  CreatedDate?: InputMaybe<order_by>;
  Description?: InputMaybe<order_by>;
  Expected_Go_Live__c?: InputMaybe<order_by>;
  Fiscal?: InputMaybe<order_by>;
  FiscalQuarter?: InputMaybe<order_by>;
  FiscalYear?: InputMaybe<order_by>;
  ForecastCategory?: InputMaybe<order_by>;
  ForecastCategoryName?: InputMaybe<order_by>;
  HubSpot_Company_Id__c?: InputMaybe<order_by>;
  HubSpot_Created_By_User_Id__c?: InputMaybe<order_by>;
  HubSpot_Deal_Id__c?: InputMaybe<order_by>;
  HubSpot_Owner_Id__c?: InputMaybe<order_by>;
  Id?: InputMaybe<order_by>;
  Implementation_Fee__c?: InputMaybe<order_by>;
  LastActivityDate?: InputMaybe<order_by>;
  LastAmountChangedHistoryId?: InputMaybe<order_by>;
  LastCloseDateChangedHistoryId?: InputMaybe<order_by>;
  LastModifiedById?: InputMaybe<order_by>;
  LastModifiedDate?: InputMaybe<order_by>;
  LastReferencedDate?: InputMaybe<order_by>;
  LastStageChangeDate?: InputMaybe<order_by>;
  LastViewedDate?: InputMaybe<order_by>;
  LeadSource?: InputMaybe<order_by>;
  Loss_Reason__c?: InputMaybe<order_by>;
  MODELview__c?: InputMaybe<order_by>;
  MRR__c?: InputMaybe<order_by>;
  Name?: InputMaybe<order_by>;
  NextStep?: InputMaybe<order_by>;
  Online_Statements__c?: InputMaybe<order_by>;
  Outreach_Attributed_Finished_Sequences__c?: InputMaybe<order_by>;
  Outreach_Last_Touch_Contact__c?: InputMaybe<order_by>;
  Outreach_Last_Touch_Sequence__c?: InputMaybe<order_by>;
  Outreach_Sequence_Attributed__c?: InputMaybe<order_by>;
  OwnerId?: InputMaybe<order_by>;
  Previous_Close_Date__c?: InputMaybe<order_by>;
  Pricebook2Id?: InputMaybe<order_by>;
  Probability?: InputMaybe<order_by>;
  PushCount?: InputMaybe<order_by>;
  Re_engagement_Date__c?: InputMaybe<order_by>;
  Second_Competitor__c?: InputMaybe<order_by>;
  StageName?: InputMaybe<order_by>;
  SyncedQuoteId?: InputMaybe<order_by>;
  SystemModstamp?: InputMaybe<order_by>;
  Type?: InputMaybe<order_by>;
};

/** on_conflict condition type for table "Opportunity" */
export type Opportunity_on_conflict = {
  constraint: Opportunity_constraint;
  update_columns?: Array<Opportunity_update_column>;
  where?: InputMaybe<Opportunity_bool_exp>;
};

/** Ordering options when selecting data from "Opportunity". */
export type Opportunity_order_by = {
  ARR__c?: InputMaybe<order_by>;
  AWARDview__c?: InputMaybe<order_by>;
  AccountId?: InputMaybe<order_by>;
  All_Members_Commissionable__c?: InputMaybe<order_by>;
  Amount?: InputMaybe<order_by>;
  Budget_Confirmed__c?: InputMaybe<order_by>;
  COMPview__c?: InputMaybe<order_by>;
  CONTENTview__c?: InputMaybe<order_by>;
  CampaignId?: InputMaybe<order_by>;
  CloseDate?: InputMaybe<order_by>;
  Close_Date_Delta__c?: InputMaybe<order_by>;
  Competitors__c?: InputMaybe<order_by>;
  ContactId?: InputMaybe<order_by>;
  ContractId?: InputMaybe<order_by>;
  CreatedById?: InputMaybe<order_by>;
  CreatedDate?: InputMaybe<order_by>;
  Description?: InputMaybe<order_by>;
  Discovery_Completed__c?: InputMaybe<order_by>;
  Expected_Go_Live__c?: InputMaybe<order_by>;
  Fiscal?: InputMaybe<order_by>;
  FiscalQuarter?: InputMaybe<order_by>;
  FiscalYear?: InputMaybe<order_by>;
  ForecastCategory?: InputMaybe<order_by>;
  ForecastCategoryName?: InputMaybe<order_by>;
  HasOpenActivity?: InputMaybe<order_by>;
  HasOpportunityLineItem?: InputMaybe<order_by>;
  HasOverdueTask?: InputMaybe<order_by>;
  HubSpot_Company_Id__c?: InputMaybe<order_by>;
  HubSpot_Created_By_User_Id__c?: InputMaybe<order_by>;
  HubSpot_Deal_Id__c?: InputMaybe<order_by>;
  HubSpot_Owner_Id__c?: InputMaybe<order_by>;
  INCENTview__c?: InputMaybe<order_by>;
  Id?: InputMaybe<order_by>;
  Implementation_Fee__c?: InputMaybe<order_by>;
  IsClosed?: InputMaybe<order_by>;
  IsDeleted?: InputMaybe<order_by>;
  IsWon?: InputMaybe<order_by>;
  LastActivityDate?: InputMaybe<order_by>;
  LastAmountChangedHistoryId?: InputMaybe<order_by>;
  LastCloseDateChangedHistoryId?: InputMaybe<order_by>;
  LastModifiedById?: InputMaybe<order_by>;
  LastModifiedDate?: InputMaybe<order_by>;
  LastReferencedDate?: InputMaybe<order_by>;
  LastStageChangeDate?: InputMaybe<order_by>;
  LastViewedDate?: InputMaybe<order_by>;
  LeadSource?: InputMaybe<order_by>;
  Loss_Reason__c?: InputMaybe<order_by>;
  MODELview__c?: InputMaybe<order_by>;
  MRR__c?: InputMaybe<order_by>;
  Name?: InputMaybe<order_by>;
  NextStep?: InputMaybe<order_by>;
  Online_Statements__c?: InputMaybe<order_by>;
  Outreach_Attributed_Finished_Sequences__c?: InputMaybe<order_by>;
  Outreach_Last_Touch_Contact__c?: InputMaybe<order_by>;
  Outreach_Last_Touch_Sequence__c?: InputMaybe<order_by>;
  Outreach_Sequence_Attributed__c?: InputMaybe<order_by>;
  OwnerId?: InputMaybe<order_by>;
  PAYview__c?: InputMaybe<order_by>;
  PERFORMview__c?: InputMaybe<order_by>;
  Previous_Close_Date__c?: InputMaybe<order_by>;
  Pricebook2Id?: InputMaybe<order_by>;
  Probability?: InputMaybe<order_by>;
  PushCount?: InputMaybe<order_by>;
  REWARDview__c?: InputMaybe<order_by>;
  ROI_Analysis_Completed__c?: InputMaybe<order_by>;
  Re_engagement_Date__c?: InputMaybe<order_by>;
  Second_Competitor__c?: InputMaybe<order_by>;
  StageName?: InputMaybe<order_by>;
  SyncedQuoteId?: InputMaybe<order_by>;
  SystemModstamp?: InputMaybe<order_by>;
  Type?: InputMaybe<order_by>;
};

/** primary key columns input for table: Opportunity */
export type Opportunity_pk_columns_input = {
  Id: Scalars["String"];
};

/** select columns of table "Opportunity" */
export enum Opportunity_select_column {
  /** column name */
  ARR__c = "ARR__c",
  /** column name */
  AWARDview__c = "AWARDview__c",
  /** column name */
  AccountId = "AccountId",
  /** column name */
  All_Members_Commissionable__c = "All_Members_Commissionable__c",
  /** column name */
  Amount = "Amount",
  /** column name */
  Budget_Confirmed__c = "Budget_Confirmed__c",
  /** column name */
  COMPview__c = "COMPview__c",
  /** column name */
  CONTENTview__c = "CONTENTview__c",
  /** column name */
  CampaignId = "CampaignId",
  /** column name */
  CloseDate = "CloseDate",
  /** column name */
  Close_Date_Delta__c = "Close_Date_Delta__c",
  /** column name */
  Competitors__c = "Competitors__c",
  /** column name */
  ContactId = "ContactId",
  /** column name */
  ContractId = "ContractId",
  /** column name */
  CreatedById = "CreatedById",
  /** column name */
  CreatedDate = "CreatedDate",
  /** column name */
  Description = "Description",
  /** column name */
  Discovery_Completed__c = "Discovery_Completed__c",
  /** column name */
  Expected_Go_Live__c = "Expected_Go_Live__c",
  /** column name */
  Fiscal = "Fiscal",
  /** column name */
  FiscalQuarter = "FiscalQuarter",
  /** column name */
  FiscalYear = "FiscalYear",
  /** column name */
  ForecastCategory = "ForecastCategory",
  /** column name */
  ForecastCategoryName = "ForecastCategoryName",
  /** column name */
  HasOpenActivity = "HasOpenActivity",
  /** column name */
  HasOpportunityLineItem = "HasOpportunityLineItem",
  /** column name */
  HasOverdueTask = "HasOverdueTask",
  /** column name */
  HubSpot_Company_Id__c = "HubSpot_Company_Id__c",
  /** column name */
  HubSpot_Created_By_User_Id__c = "HubSpot_Created_By_User_Id__c",
  /** column name */
  HubSpot_Deal_Id__c = "HubSpot_Deal_Id__c",
  /** column name */
  HubSpot_Owner_Id__c = "HubSpot_Owner_Id__c",
  /** column name */
  INCENTview__c = "INCENTview__c",
  /** column name */
  Id = "Id",
  /** column name */
  Implementation_Fee__c = "Implementation_Fee__c",
  /** column name */
  IsClosed = "IsClosed",
  /** column name */
  IsDeleted = "IsDeleted",
  /** column name */
  IsWon = "IsWon",
  /** column name */
  LastActivityDate = "LastActivityDate",
  /** column name */
  LastAmountChangedHistoryId = "LastAmountChangedHistoryId",
  /** column name */
  LastCloseDateChangedHistoryId = "LastCloseDateChangedHistoryId",
  /** column name */
  LastModifiedById = "LastModifiedById",
  /** column name */
  LastModifiedDate = "LastModifiedDate",
  /** column name */
  LastReferencedDate = "LastReferencedDate",
  /** column name */
  LastStageChangeDate = "LastStageChangeDate",
  /** column name */
  LastViewedDate = "LastViewedDate",
  /** column name */
  LeadSource = "LeadSource",
  /** column name */
  Loss_Reason__c = "Loss_Reason__c",
  /** column name */
  MODELview__c = "MODELview__c",
  /** column name */
  MRR__c = "MRR__c",
  /** column name */
  Name = "Name",
  /** column name */
  NextStep = "NextStep",
  /** column name */
  Online_Statements__c = "Online_Statements__c",
  /** column name */
  Outreach_Attributed_Finished_Sequences__c = "Outreach_Attributed_Finished_Sequences__c",
  /** column name */
  Outreach_Last_Touch_Contact__c = "Outreach_Last_Touch_Contact__c",
  /** column name */
  Outreach_Last_Touch_Sequence__c = "Outreach_Last_Touch_Sequence__c",
  /** column name */
  Outreach_Sequence_Attributed__c = "Outreach_Sequence_Attributed__c",
  /** column name */
  OwnerId = "OwnerId",
  /** column name */
  PAYview__c = "PAYview__c",
  /** column name */
  PERFORMview__c = "PERFORMview__c",
  /** column name */
  Previous_Close_Date__c = "Previous_Close_Date__c",
  /** column name */
  Pricebook2Id = "Pricebook2Id",
  /** column name */
  Probability = "Probability",
  /** column name */
  PushCount = "PushCount",
  /** column name */
  REWARDview__c = "REWARDview__c",
  /** column name */
  ROI_Analysis_Completed__c = "ROI_Analysis_Completed__c",
  /** column name */
  Re_engagement_Date__c = "Re_engagement_Date__c",
  /** column name */
  Second_Competitor__c = "Second_Competitor__c",
  /** column name */
  StageName = "StageName",
  /** column name */
  SyncedQuoteId = "SyncedQuoteId",
  /** column name */
  SystemModstamp = "SystemModstamp",
  /** column name */
  Type = "Type",
}

/** select "Opportunity_aggregate_bool_exp_avg_arguments_columns" columns of table "Opportunity" */
export enum Opportunity_select_column_Opportunity_aggregate_bool_exp_avg_arguments_columns {
  /** column name */
  ARR__c = "ARR__c",
  /** column name */
  AWARDview__c = "AWARDview__c",
  /** column name */
  Amount = "Amount",
  /** column name */
  CONTENTview__c = "CONTENTview__c",
  /** column name */
  Close_Date_Delta__c = "Close_Date_Delta__c",
  /** column name */
  Implementation_Fee__c = "Implementation_Fee__c",
  /** column name */
  MODELview__c = "MODELview__c",
  /** column name */
  MRR__c = "MRR__c",
  /** column name */
  Online_Statements__c = "Online_Statements__c",
  /** column name */
  Probability = "Probability",
}

/** select "Opportunity_aggregate_bool_exp_bool_and_arguments_columns" columns of table "Opportunity" */
export enum Opportunity_select_column_Opportunity_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  All_Members_Commissionable__c = "All_Members_Commissionable__c",
  /** column name */
  Budget_Confirmed__c = "Budget_Confirmed__c",
  /** column name */
  COMPview__c = "COMPview__c",
  /** column name */
  Discovery_Completed__c = "Discovery_Completed__c",
  /** column name */
  HasOpenActivity = "HasOpenActivity",
  /** column name */
  HasOpportunityLineItem = "HasOpportunityLineItem",
  /** column name */
  HasOverdueTask = "HasOverdueTask",
  /** column name */
  INCENTview__c = "INCENTview__c",
  /** column name */
  IsClosed = "IsClosed",
  /** column name */
  IsDeleted = "IsDeleted",
  /** column name */
  IsWon = "IsWon",
  /** column name */
  PAYview__c = "PAYview__c",
  /** column name */
  PERFORMview__c = "PERFORMview__c",
  /** column name */
  REWARDview__c = "REWARDview__c",
  /** column name */
  ROI_Analysis_Completed__c = "ROI_Analysis_Completed__c",
}

/** select "Opportunity_aggregate_bool_exp_bool_or_arguments_columns" columns of table "Opportunity" */
export enum Opportunity_select_column_Opportunity_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  All_Members_Commissionable__c = "All_Members_Commissionable__c",
  /** column name */
  Budget_Confirmed__c = "Budget_Confirmed__c",
  /** column name */
  COMPview__c = "COMPview__c",
  /** column name */
  Discovery_Completed__c = "Discovery_Completed__c",
  /** column name */
  HasOpenActivity = "HasOpenActivity",
  /** column name */
  HasOpportunityLineItem = "HasOpportunityLineItem",
  /** column name */
  HasOverdueTask = "HasOverdueTask",
  /** column name */
  INCENTview__c = "INCENTview__c",
  /** column name */
  IsClosed = "IsClosed",
  /** column name */
  IsDeleted = "IsDeleted",
  /** column name */
  IsWon = "IsWon",
  /** column name */
  PAYview__c = "PAYview__c",
  /** column name */
  PERFORMview__c = "PERFORMview__c",
  /** column name */
  REWARDview__c = "REWARDview__c",
  /** column name */
  ROI_Analysis_Completed__c = "ROI_Analysis_Completed__c",
}

/** select "Opportunity_aggregate_bool_exp_corr_arguments_columns" columns of table "Opportunity" */
export enum Opportunity_select_column_Opportunity_aggregate_bool_exp_corr_arguments_columns {
  /** column name */
  ARR__c = "ARR__c",
  /** column name */
  AWARDview__c = "AWARDview__c",
  /** column name */
  Amount = "Amount",
  /** column name */
  CONTENTview__c = "CONTENTview__c",
  /** column name */
  Close_Date_Delta__c = "Close_Date_Delta__c",
  /** column name */
  Implementation_Fee__c = "Implementation_Fee__c",
  /** column name */
  MODELview__c = "MODELview__c",
  /** column name */
  MRR__c = "MRR__c",
  /** column name */
  Online_Statements__c = "Online_Statements__c",
  /** column name */
  Probability = "Probability",
}

/** select "Opportunity_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "Opportunity" */
export enum Opportunity_select_column_Opportunity_aggregate_bool_exp_covar_samp_arguments_columns {
  /** column name */
  ARR__c = "ARR__c",
  /** column name */
  AWARDview__c = "AWARDview__c",
  /** column name */
  Amount = "Amount",
  /** column name */
  CONTENTview__c = "CONTENTview__c",
  /** column name */
  Close_Date_Delta__c = "Close_Date_Delta__c",
  /** column name */
  Implementation_Fee__c = "Implementation_Fee__c",
  /** column name */
  MODELview__c = "MODELview__c",
  /** column name */
  MRR__c = "MRR__c",
  /** column name */
  Online_Statements__c = "Online_Statements__c",
  /** column name */
  Probability = "Probability",
}

/** select "Opportunity_aggregate_bool_exp_max_arguments_columns" columns of table "Opportunity" */
export enum Opportunity_select_column_Opportunity_aggregate_bool_exp_max_arguments_columns {
  /** column name */
  ARR__c = "ARR__c",
  /** column name */
  AWARDview__c = "AWARDview__c",
  /** column name */
  Amount = "Amount",
  /** column name */
  CONTENTview__c = "CONTENTview__c",
  /** column name */
  Close_Date_Delta__c = "Close_Date_Delta__c",
  /** column name */
  Implementation_Fee__c = "Implementation_Fee__c",
  /** column name */
  MODELview__c = "MODELview__c",
  /** column name */
  MRR__c = "MRR__c",
  /** column name */
  Online_Statements__c = "Online_Statements__c",
  /** column name */
  Probability = "Probability",
}

/** select "Opportunity_aggregate_bool_exp_min_arguments_columns" columns of table "Opportunity" */
export enum Opportunity_select_column_Opportunity_aggregate_bool_exp_min_arguments_columns {
  /** column name */
  ARR__c = "ARR__c",
  /** column name */
  AWARDview__c = "AWARDview__c",
  /** column name */
  Amount = "Amount",
  /** column name */
  CONTENTview__c = "CONTENTview__c",
  /** column name */
  Close_Date_Delta__c = "Close_Date_Delta__c",
  /** column name */
  Implementation_Fee__c = "Implementation_Fee__c",
  /** column name */
  MODELview__c = "MODELview__c",
  /** column name */
  MRR__c = "MRR__c",
  /** column name */
  Online_Statements__c = "Online_Statements__c",
  /** column name */
  Probability = "Probability",
}

/** select "Opportunity_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "Opportunity" */
export enum Opportunity_select_column_Opportunity_aggregate_bool_exp_stddev_samp_arguments_columns {
  /** column name */
  ARR__c = "ARR__c",
  /** column name */
  AWARDview__c = "AWARDview__c",
  /** column name */
  Amount = "Amount",
  /** column name */
  CONTENTview__c = "CONTENTview__c",
  /** column name */
  Close_Date_Delta__c = "Close_Date_Delta__c",
  /** column name */
  Implementation_Fee__c = "Implementation_Fee__c",
  /** column name */
  MODELview__c = "MODELview__c",
  /** column name */
  MRR__c = "MRR__c",
  /** column name */
  Online_Statements__c = "Online_Statements__c",
  /** column name */
  Probability = "Probability",
}

/** select "Opportunity_aggregate_bool_exp_sum_arguments_columns" columns of table "Opportunity" */
export enum Opportunity_select_column_Opportunity_aggregate_bool_exp_sum_arguments_columns {
  /** column name */
  ARR__c = "ARR__c",
  /** column name */
  AWARDview__c = "AWARDview__c",
  /** column name */
  Amount = "Amount",
  /** column name */
  CONTENTview__c = "CONTENTview__c",
  /** column name */
  Close_Date_Delta__c = "Close_Date_Delta__c",
  /** column name */
  Implementation_Fee__c = "Implementation_Fee__c",
  /** column name */
  MODELview__c = "MODELview__c",
  /** column name */
  MRR__c = "MRR__c",
  /** column name */
  Online_Statements__c = "Online_Statements__c",
  /** column name */
  Probability = "Probability",
}

/** select "Opportunity_aggregate_bool_exp_var_samp_arguments_columns" columns of table "Opportunity" */
export enum Opportunity_select_column_Opportunity_aggregate_bool_exp_var_samp_arguments_columns {
  /** column name */
  ARR__c = "ARR__c",
  /** column name */
  AWARDview__c = "AWARDview__c",
  /** column name */
  Amount = "Amount",
  /** column name */
  CONTENTview__c = "CONTENTview__c",
  /** column name */
  Close_Date_Delta__c = "Close_Date_Delta__c",
  /** column name */
  Implementation_Fee__c = "Implementation_Fee__c",
  /** column name */
  MODELview__c = "MODELview__c",
  /** column name */
  MRR__c = "MRR__c",
  /** column name */
  Online_Statements__c = "Online_Statements__c",
  /** column name */
  Probability = "Probability",
}

/** input type for updating data in table "Opportunity" */
export type Opportunity_set_input = {
  ARR__c?: InputMaybe<Scalars["float8"]>;
  AWARDview__c?: InputMaybe<Scalars["float8"]>;
  AccountId?: InputMaybe<Scalars["String"]>;
  All_Members_Commissionable__c?: InputMaybe<Scalars["Boolean"]>;
  Amount?: InputMaybe<Scalars["float8"]>;
  Budget_Confirmed__c?: InputMaybe<Scalars["Boolean"]>;
  COMPview__c?: InputMaybe<Scalars["Boolean"]>;
  CONTENTview__c?: InputMaybe<Scalars["float8"]>;
  CampaignId?: InputMaybe<Scalars["String"]>;
  CloseDate?: InputMaybe<Scalars["date"]>;
  Close_Date_Delta__c?: InputMaybe<Scalars["float8"]>;
  Competitors__c?: InputMaybe<Scalars["String"]>;
  ContactId?: InputMaybe<Scalars["String"]>;
  ContractId?: InputMaybe<Scalars["String"]>;
  CreatedById?: InputMaybe<Scalars["String"]>;
  CreatedDate?: InputMaybe<Scalars["timestamp"]>;
  Description?: InputMaybe<Scalars["String"]>;
  Discovery_Completed__c?: InputMaybe<Scalars["Boolean"]>;
  Expected_Go_Live__c?: InputMaybe<Scalars["date"]>;
  Fiscal?: InputMaybe<Scalars["String"]>;
  FiscalQuarter?: InputMaybe<Scalars["Int"]>;
  FiscalYear?: InputMaybe<Scalars["Int"]>;
  ForecastCategory?: InputMaybe<Scalars["String"]>;
  ForecastCategoryName?: InputMaybe<Scalars["String"]>;
  HasOpenActivity?: InputMaybe<Scalars["Boolean"]>;
  HasOpportunityLineItem?: InputMaybe<Scalars["Boolean"]>;
  HasOverdueTask?: InputMaybe<Scalars["Boolean"]>;
  HubSpot_Company_Id__c?: InputMaybe<Scalars["String"]>;
  HubSpot_Created_By_User_Id__c?: InputMaybe<Scalars["String"]>;
  HubSpot_Deal_Id__c?: InputMaybe<Scalars["String"]>;
  HubSpot_Owner_Id__c?: InputMaybe<Scalars["String"]>;
  INCENTview__c?: InputMaybe<Scalars["Boolean"]>;
  Id?: InputMaybe<Scalars["String"]>;
  Implementation_Fee__c?: InputMaybe<Scalars["float8"]>;
  IsClosed?: InputMaybe<Scalars["Boolean"]>;
  IsDeleted?: InputMaybe<Scalars["Boolean"]>;
  IsWon?: InputMaybe<Scalars["Boolean"]>;
  LastActivityDate?: InputMaybe<Scalars["date"]>;
  LastAmountChangedHistoryId?: InputMaybe<Scalars["String"]>;
  LastCloseDateChangedHistoryId?: InputMaybe<Scalars["String"]>;
  LastModifiedById?: InputMaybe<Scalars["String"]>;
  LastModifiedDate?: InputMaybe<Scalars["timestamp"]>;
  LastReferencedDate?: InputMaybe<Scalars["timestamp"]>;
  LastStageChangeDate?: InputMaybe<Scalars["timestamp"]>;
  LastViewedDate?: InputMaybe<Scalars["timestamp"]>;
  LeadSource?: InputMaybe<Scalars["String"]>;
  Loss_Reason__c?: InputMaybe<Scalars["String"]>;
  MODELview__c?: InputMaybe<Scalars["float8"]>;
  MRR__c?: InputMaybe<Scalars["float8"]>;
  Name?: InputMaybe<Scalars["String"]>;
  NextStep?: InputMaybe<Scalars["String"]>;
  Online_Statements__c?: InputMaybe<Scalars["float8"]>;
  Outreach_Attributed_Finished_Sequences__c?: InputMaybe<Scalars["String"]>;
  Outreach_Last_Touch_Contact__c?: InputMaybe<Scalars["String"]>;
  Outreach_Last_Touch_Sequence__c?: InputMaybe<Scalars["String"]>;
  Outreach_Sequence_Attributed__c?: InputMaybe<Scalars["String"]>;
  OwnerId?: InputMaybe<Scalars["String"]>;
  PAYview__c?: InputMaybe<Scalars["Boolean"]>;
  PERFORMview__c?: InputMaybe<Scalars["Boolean"]>;
  Previous_Close_Date__c?: InputMaybe<Scalars["date"]>;
  Pricebook2Id?: InputMaybe<Scalars["String"]>;
  Probability?: InputMaybe<Scalars["float8"]>;
  PushCount?: InputMaybe<Scalars["Int"]>;
  REWARDview__c?: InputMaybe<Scalars["Boolean"]>;
  ROI_Analysis_Completed__c?: InputMaybe<Scalars["Boolean"]>;
  Re_engagement_Date__c?: InputMaybe<Scalars["date"]>;
  Second_Competitor__c?: InputMaybe<Scalars["String"]>;
  StageName?: InputMaybe<Scalars["String"]>;
  SyncedQuoteId?: InputMaybe<Scalars["String"]>;
  SystemModstamp?: InputMaybe<Scalars["timestamp"]>;
  Type?: InputMaybe<Scalars["String"]>;
};

/** order by stddev() on columns of table "Opportunity" */
export type Opportunity_stddev_order_by = {
  ARR__c?: InputMaybe<order_by>;
  AWARDview__c?: InputMaybe<order_by>;
  Amount?: InputMaybe<order_by>;
  CONTENTview__c?: InputMaybe<order_by>;
  Close_Date_Delta__c?: InputMaybe<order_by>;
  FiscalQuarter?: InputMaybe<order_by>;
  FiscalYear?: InputMaybe<order_by>;
  Implementation_Fee__c?: InputMaybe<order_by>;
  MODELview__c?: InputMaybe<order_by>;
  MRR__c?: InputMaybe<order_by>;
  Online_Statements__c?: InputMaybe<order_by>;
  Probability?: InputMaybe<order_by>;
  PushCount?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "Opportunity" */
export type Opportunity_stddev_pop_order_by = {
  ARR__c?: InputMaybe<order_by>;
  AWARDview__c?: InputMaybe<order_by>;
  Amount?: InputMaybe<order_by>;
  CONTENTview__c?: InputMaybe<order_by>;
  Close_Date_Delta__c?: InputMaybe<order_by>;
  FiscalQuarter?: InputMaybe<order_by>;
  FiscalYear?: InputMaybe<order_by>;
  Implementation_Fee__c?: InputMaybe<order_by>;
  MODELview__c?: InputMaybe<order_by>;
  MRR__c?: InputMaybe<order_by>;
  Online_Statements__c?: InputMaybe<order_by>;
  Probability?: InputMaybe<order_by>;
  PushCount?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "Opportunity" */
export type Opportunity_stddev_samp_order_by = {
  ARR__c?: InputMaybe<order_by>;
  AWARDview__c?: InputMaybe<order_by>;
  Amount?: InputMaybe<order_by>;
  CONTENTview__c?: InputMaybe<order_by>;
  Close_Date_Delta__c?: InputMaybe<order_by>;
  FiscalQuarter?: InputMaybe<order_by>;
  FiscalYear?: InputMaybe<order_by>;
  Implementation_Fee__c?: InputMaybe<order_by>;
  MODELview__c?: InputMaybe<order_by>;
  MRR__c?: InputMaybe<order_by>;
  Online_Statements__c?: InputMaybe<order_by>;
  Probability?: InputMaybe<order_by>;
  PushCount?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "Opportunity" */
export type Opportunity_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: Opportunity_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Opportunity_stream_cursor_value_input = {
  ARR__c?: InputMaybe<Scalars["float8"]>;
  AWARDview__c?: InputMaybe<Scalars["float8"]>;
  AccountId?: InputMaybe<Scalars["String"]>;
  All_Members_Commissionable__c?: InputMaybe<Scalars["Boolean"]>;
  Amount?: InputMaybe<Scalars["float8"]>;
  Budget_Confirmed__c?: InputMaybe<Scalars["Boolean"]>;
  COMPview__c?: InputMaybe<Scalars["Boolean"]>;
  CONTENTview__c?: InputMaybe<Scalars["float8"]>;
  CampaignId?: InputMaybe<Scalars["String"]>;
  CloseDate?: InputMaybe<Scalars["date"]>;
  Close_Date_Delta__c?: InputMaybe<Scalars["float8"]>;
  Competitors__c?: InputMaybe<Scalars["String"]>;
  ContactId?: InputMaybe<Scalars["String"]>;
  ContractId?: InputMaybe<Scalars["String"]>;
  CreatedById?: InputMaybe<Scalars["String"]>;
  CreatedDate?: InputMaybe<Scalars["timestamp"]>;
  Description?: InputMaybe<Scalars["String"]>;
  Discovery_Completed__c?: InputMaybe<Scalars["Boolean"]>;
  Expected_Go_Live__c?: InputMaybe<Scalars["date"]>;
  Fiscal?: InputMaybe<Scalars["String"]>;
  FiscalQuarter?: InputMaybe<Scalars["Int"]>;
  FiscalYear?: InputMaybe<Scalars["Int"]>;
  ForecastCategory?: InputMaybe<Scalars["String"]>;
  ForecastCategoryName?: InputMaybe<Scalars["String"]>;
  HasOpenActivity?: InputMaybe<Scalars["Boolean"]>;
  HasOpportunityLineItem?: InputMaybe<Scalars["Boolean"]>;
  HasOverdueTask?: InputMaybe<Scalars["Boolean"]>;
  HubSpot_Company_Id__c?: InputMaybe<Scalars["String"]>;
  HubSpot_Created_By_User_Id__c?: InputMaybe<Scalars["String"]>;
  HubSpot_Deal_Id__c?: InputMaybe<Scalars["String"]>;
  HubSpot_Owner_Id__c?: InputMaybe<Scalars["String"]>;
  INCENTview__c?: InputMaybe<Scalars["Boolean"]>;
  Id?: InputMaybe<Scalars["String"]>;
  Implementation_Fee__c?: InputMaybe<Scalars["float8"]>;
  IsClosed?: InputMaybe<Scalars["Boolean"]>;
  IsDeleted?: InputMaybe<Scalars["Boolean"]>;
  IsWon?: InputMaybe<Scalars["Boolean"]>;
  LastActivityDate?: InputMaybe<Scalars["date"]>;
  LastAmountChangedHistoryId?: InputMaybe<Scalars["String"]>;
  LastCloseDateChangedHistoryId?: InputMaybe<Scalars["String"]>;
  LastModifiedById?: InputMaybe<Scalars["String"]>;
  LastModifiedDate?: InputMaybe<Scalars["timestamp"]>;
  LastReferencedDate?: InputMaybe<Scalars["timestamp"]>;
  LastStageChangeDate?: InputMaybe<Scalars["timestamp"]>;
  LastViewedDate?: InputMaybe<Scalars["timestamp"]>;
  LeadSource?: InputMaybe<Scalars["String"]>;
  Loss_Reason__c?: InputMaybe<Scalars["String"]>;
  MODELview__c?: InputMaybe<Scalars["float8"]>;
  MRR__c?: InputMaybe<Scalars["float8"]>;
  Name?: InputMaybe<Scalars["String"]>;
  NextStep?: InputMaybe<Scalars["String"]>;
  Online_Statements__c?: InputMaybe<Scalars["float8"]>;
  Outreach_Attributed_Finished_Sequences__c?: InputMaybe<Scalars["String"]>;
  Outreach_Last_Touch_Contact__c?: InputMaybe<Scalars["String"]>;
  Outreach_Last_Touch_Sequence__c?: InputMaybe<Scalars["String"]>;
  Outreach_Sequence_Attributed__c?: InputMaybe<Scalars["String"]>;
  OwnerId?: InputMaybe<Scalars["String"]>;
  PAYview__c?: InputMaybe<Scalars["Boolean"]>;
  PERFORMview__c?: InputMaybe<Scalars["Boolean"]>;
  Previous_Close_Date__c?: InputMaybe<Scalars["date"]>;
  Pricebook2Id?: InputMaybe<Scalars["String"]>;
  Probability?: InputMaybe<Scalars["float8"]>;
  PushCount?: InputMaybe<Scalars["Int"]>;
  REWARDview__c?: InputMaybe<Scalars["Boolean"]>;
  ROI_Analysis_Completed__c?: InputMaybe<Scalars["Boolean"]>;
  Re_engagement_Date__c?: InputMaybe<Scalars["date"]>;
  Second_Competitor__c?: InputMaybe<Scalars["String"]>;
  StageName?: InputMaybe<Scalars["String"]>;
  SyncedQuoteId?: InputMaybe<Scalars["String"]>;
  SystemModstamp?: InputMaybe<Scalars["timestamp"]>;
  Type?: InputMaybe<Scalars["String"]>;
};

/** order by sum() on columns of table "Opportunity" */
export type Opportunity_sum_order_by = {
  ARR__c?: InputMaybe<order_by>;
  AWARDview__c?: InputMaybe<order_by>;
  Amount?: InputMaybe<order_by>;
  CONTENTview__c?: InputMaybe<order_by>;
  Close_Date_Delta__c?: InputMaybe<order_by>;
  FiscalQuarter?: InputMaybe<order_by>;
  FiscalYear?: InputMaybe<order_by>;
  Implementation_Fee__c?: InputMaybe<order_by>;
  MODELview__c?: InputMaybe<order_by>;
  MRR__c?: InputMaybe<order_by>;
  Online_Statements__c?: InputMaybe<order_by>;
  Probability?: InputMaybe<order_by>;
  PushCount?: InputMaybe<order_by>;
};

/** update columns of table "Opportunity" */
export enum Opportunity_update_column {
  /** column name */
  ARR__c = "ARR__c",
  /** column name */
  AWARDview__c = "AWARDview__c",
  /** column name */
  AccountId = "AccountId",
  /** column name */
  All_Members_Commissionable__c = "All_Members_Commissionable__c",
  /** column name */
  Amount = "Amount",
  /** column name */
  Budget_Confirmed__c = "Budget_Confirmed__c",
  /** column name */
  COMPview__c = "COMPview__c",
  /** column name */
  CONTENTview__c = "CONTENTview__c",
  /** column name */
  CampaignId = "CampaignId",
  /** column name */
  CloseDate = "CloseDate",
  /** column name */
  Close_Date_Delta__c = "Close_Date_Delta__c",
  /** column name */
  Competitors__c = "Competitors__c",
  /** column name */
  ContactId = "ContactId",
  /** column name */
  ContractId = "ContractId",
  /** column name */
  CreatedById = "CreatedById",
  /** column name */
  CreatedDate = "CreatedDate",
  /** column name */
  Description = "Description",
  /** column name */
  Discovery_Completed__c = "Discovery_Completed__c",
  /** column name */
  Expected_Go_Live__c = "Expected_Go_Live__c",
  /** column name */
  Fiscal = "Fiscal",
  /** column name */
  FiscalQuarter = "FiscalQuarter",
  /** column name */
  FiscalYear = "FiscalYear",
  /** column name */
  ForecastCategory = "ForecastCategory",
  /** column name */
  ForecastCategoryName = "ForecastCategoryName",
  /** column name */
  HasOpenActivity = "HasOpenActivity",
  /** column name */
  HasOpportunityLineItem = "HasOpportunityLineItem",
  /** column name */
  HasOverdueTask = "HasOverdueTask",
  /** column name */
  HubSpot_Company_Id__c = "HubSpot_Company_Id__c",
  /** column name */
  HubSpot_Created_By_User_Id__c = "HubSpot_Created_By_User_Id__c",
  /** column name */
  HubSpot_Deal_Id__c = "HubSpot_Deal_Id__c",
  /** column name */
  HubSpot_Owner_Id__c = "HubSpot_Owner_Id__c",
  /** column name */
  INCENTview__c = "INCENTview__c",
  /** column name */
  Id = "Id",
  /** column name */
  Implementation_Fee__c = "Implementation_Fee__c",
  /** column name */
  IsClosed = "IsClosed",
  /** column name */
  IsDeleted = "IsDeleted",
  /** column name */
  IsWon = "IsWon",
  /** column name */
  LastActivityDate = "LastActivityDate",
  /** column name */
  LastAmountChangedHistoryId = "LastAmountChangedHistoryId",
  /** column name */
  LastCloseDateChangedHistoryId = "LastCloseDateChangedHistoryId",
  /** column name */
  LastModifiedById = "LastModifiedById",
  /** column name */
  LastModifiedDate = "LastModifiedDate",
  /** column name */
  LastReferencedDate = "LastReferencedDate",
  /** column name */
  LastStageChangeDate = "LastStageChangeDate",
  /** column name */
  LastViewedDate = "LastViewedDate",
  /** column name */
  LeadSource = "LeadSource",
  /** column name */
  Loss_Reason__c = "Loss_Reason__c",
  /** column name */
  MODELview__c = "MODELview__c",
  /** column name */
  MRR__c = "MRR__c",
  /** column name */
  Name = "Name",
  /** column name */
  NextStep = "NextStep",
  /** column name */
  Online_Statements__c = "Online_Statements__c",
  /** column name */
  Outreach_Attributed_Finished_Sequences__c = "Outreach_Attributed_Finished_Sequences__c",
  /** column name */
  Outreach_Last_Touch_Contact__c = "Outreach_Last_Touch_Contact__c",
  /** column name */
  Outreach_Last_Touch_Sequence__c = "Outreach_Last_Touch_Sequence__c",
  /** column name */
  Outreach_Sequence_Attributed__c = "Outreach_Sequence_Attributed__c",
  /** column name */
  OwnerId = "OwnerId",
  /** column name */
  PAYview__c = "PAYview__c",
  /** column name */
  PERFORMview__c = "PERFORMview__c",
  /** column name */
  Previous_Close_Date__c = "Previous_Close_Date__c",
  /** column name */
  Pricebook2Id = "Pricebook2Id",
  /** column name */
  Probability = "Probability",
  /** column name */
  PushCount = "PushCount",
  /** column name */
  REWARDview__c = "REWARDview__c",
  /** column name */
  ROI_Analysis_Completed__c = "ROI_Analysis_Completed__c",
  /** column name */
  Re_engagement_Date__c = "Re_engagement_Date__c",
  /** column name */
  Second_Competitor__c = "Second_Competitor__c",
  /** column name */
  StageName = "StageName",
  /** column name */
  SyncedQuoteId = "SyncedQuoteId",
  /** column name */
  SystemModstamp = "SystemModstamp",
  /** column name */
  Type = "Type",
}

export type Opportunity_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Opportunity_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Opportunity_set_input>;
  where: Opportunity_bool_exp;
};

/** order by var_pop() on columns of table "Opportunity" */
export type Opportunity_var_pop_order_by = {
  ARR__c?: InputMaybe<order_by>;
  AWARDview__c?: InputMaybe<order_by>;
  Amount?: InputMaybe<order_by>;
  CONTENTview__c?: InputMaybe<order_by>;
  Close_Date_Delta__c?: InputMaybe<order_by>;
  FiscalQuarter?: InputMaybe<order_by>;
  FiscalYear?: InputMaybe<order_by>;
  Implementation_Fee__c?: InputMaybe<order_by>;
  MODELview__c?: InputMaybe<order_by>;
  MRR__c?: InputMaybe<order_by>;
  Online_Statements__c?: InputMaybe<order_by>;
  Probability?: InputMaybe<order_by>;
  PushCount?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "Opportunity" */
export type Opportunity_var_samp_order_by = {
  ARR__c?: InputMaybe<order_by>;
  AWARDview__c?: InputMaybe<order_by>;
  Amount?: InputMaybe<order_by>;
  CONTENTview__c?: InputMaybe<order_by>;
  Close_Date_Delta__c?: InputMaybe<order_by>;
  FiscalQuarter?: InputMaybe<order_by>;
  FiscalYear?: InputMaybe<order_by>;
  Implementation_Fee__c?: InputMaybe<order_by>;
  MODELview__c?: InputMaybe<order_by>;
  MRR__c?: InputMaybe<order_by>;
  Online_Statements__c?: InputMaybe<order_by>;
  Probability?: InputMaybe<order_by>;
  PushCount?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "Opportunity" */
export type Opportunity_variance_order_by = {
  ARR__c?: InputMaybe<order_by>;
  AWARDview__c?: InputMaybe<order_by>;
  Amount?: InputMaybe<order_by>;
  CONTENTview__c?: InputMaybe<order_by>;
  Close_Date_Delta__c?: InputMaybe<order_by>;
  FiscalQuarter?: InputMaybe<order_by>;
  FiscalYear?: InputMaybe<order_by>;
  Implementation_Fee__c?: InputMaybe<order_by>;
  MODELview__c?: InputMaybe<order_by>;
  MRR__c?: InputMaybe<order_by>;
  Online_Statements__c?: InputMaybe<order_by>;
  Probability?: InputMaybe<order_by>;
  PushCount?: InputMaybe<order_by>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_comparison_exp = {
  _eq?: InputMaybe<Scalars["String"]>;
  _gt?: InputMaybe<Scalars["String"]>;
  _gte?: InputMaybe<Scalars["String"]>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars["String"]>;
  _in?: InputMaybe<Array<Scalars["String"]>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars["String"]>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars["String"]>;
  _lt?: InputMaybe<Scalars["String"]>;
  _lte?: InputMaybe<Scalars["String"]>;
  _neq?: InputMaybe<Scalars["String"]>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars["String"]>;
  _nin?: InputMaybe<Array<Scalars["String"]>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars["String"]>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars["String"]>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars["String"]>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars["String"]>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars["String"]>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type _Boolean_comparison_exp = {
  _eq?: InputMaybe<Scalars["Boolean"]>;
  _gt?: InputMaybe<Scalars["Boolean"]>;
  _gte?: InputMaybe<Scalars["Boolean"]>;
  _in?: InputMaybe<Array<Scalars["Boolean"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["Boolean"]>;
  _lte?: InputMaybe<Scalars["Boolean"]>;
  _neq?: InputMaybe<Scalars["Boolean"]>;
  _nin?: InputMaybe<Array<Scalars["Boolean"]>>;
};

/** Boolean expression to filter rows from the table "COMPANY". All fields are combined with a logical 'AND'. */
export type _COMPANY_bool_exp = {
  CITY?: InputMaybe<_String_comparison_exp>;
  COMPANYTYPE?: InputMaybe<_String_comparison_exp>;
  COUNTRY?: InputMaybe<_String_comparison_exp>;
  COUNTRYCODE?: InputMaybe<_String_comparison_exp>;
  CRUNCHBASE?: InputMaybe<_String_comparison_exp>;
  DATE_OF_RAISE?: InputMaybe<_String_comparison_exp>;
  DESCRIPTION?: InputMaybe<_String_comparison_exp>;
  DOMAIN?: InputMaybe<_String_comparison_exp>;
  FACEBOOK?: InputMaybe<_String_comparison_exp>;
  FOUNDINGYEAR?: InputMaybe<_float8_comparison_exp>;
  ID?: InputMaybe<_bigint_comparison_exp>;
  INFORMALNAME?: InputMaybe<_String_comparison_exp>;
  LINKEDIN?: InputMaybe<_String_comparison_exp>;
  LOADDATE?: InputMaybe<_String_comparison_exp>;
  MODIFIEDDATE?: InputMaybe<_String_comparison_exp>;
  MOST_RECENT_EMPLOYEE_COUNT?: InputMaybe<_float8_comparison_exp>;
  NAME?: InputMaybe<_String_comparison_exp>;
  NOLONGERINBUSINESS?: InputMaybe<_Boolean_comparison_exp>;
  NOLONGERINBUSINESSDATE?: InputMaybe<_String_comparison_exp>;
  NOLONGERINBUSINESSREASON?: InputMaybe<_float8_comparison_exp>;
  PARENTCOMPANY?: InputMaybe<_String_comparison_exp>;
  PARENTID?: InputMaybe<_float8_comparison_exp>;
  PHONENUMBER?: InputMaybe<_String_comparison_exp>;
  POSTALCODE?: InputMaybe<_String_comparison_exp>;
  RAISE_AMOUNT?: InputMaybe<_float8_comparison_exp>;
  RAISE_ROUND?: InputMaybe<_float8_comparison_exp>;
  RAISE_TRANSACTION_TYPE?: InputMaybe<_float8_comparison_exp>;
  RAISE_VALUATION?: InputMaybe<_float8_comparison_exp>;
  SOURCECITED?: InputMaybe<_String_comparison_exp>;
  SPECIALTIES?: InputMaybe<_String_comparison_exp>;
  STATE?: InputMaybe<_String_comparison_exp>;
  STATECODE?: InputMaybe<_String_comparison_exp>;
  SUB_INDUSTRY_CATEGORY_NAME?: InputMaybe<_String_comparison_exp>;
  TOTALAMOUNTINVESTED?: InputMaybe<_float8_comparison_exp>;
  TWITTER?: InputMaybe<_String_comparison_exp>;
  WEBSITE?: InputMaybe<_String_comparison_exp>;
  _and?: InputMaybe<Array<_COMPANY_bool_exp>>;
  _not?: InputMaybe<_COMPANY_bool_exp>;
  _or?: InputMaybe<Array<_COMPANY_bool_exp>>;
  index?: InputMaybe<_bigint_comparison_exp>;
};

/** input type for incrementing numeric columns in table "COMPANY" */
export type _COMPANY_inc_input = {
  FOUNDINGYEAR?: InputMaybe<Scalars["_float8"]>;
  ID?: InputMaybe<Scalars["_bigint"]>;
  MOST_RECENT_EMPLOYEE_COUNT?: InputMaybe<Scalars["_float8"]>;
  NOLONGERINBUSINESSREASON?: InputMaybe<Scalars["_float8"]>;
  PARENTID?: InputMaybe<Scalars["_float8"]>;
  RAISE_AMOUNT?: InputMaybe<Scalars["_float8"]>;
  RAISE_ROUND?: InputMaybe<Scalars["_float8"]>;
  RAISE_TRANSACTION_TYPE?: InputMaybe<Scalars["_float8"]>;
  RAISE_VALUATION?: InputMaybe<Scalars["_float8"]>;
  TOTALAMOUNTINVESTED?: InputMaybe<Scalars["_float8"]>;
  index?: InputMaybe<Scalars["_bigint"]>;
};

/** input type for inserting data into table "COMPANY" */
export type _COMPANY_insert_input = {
  CITY?: InputMaybe<Scalars["String"]>;
  COMPANYTYPE?: InputMaybe<Scalars["String"]>;
  COUNTRY?: InputMaybe<Scalars["String"]>;
  COUNTRYCODE?: InputMaybe<Scalars["String"]>;
  CRUNCHBASE?: InputMaybe<Scalars["String"]>;
  DATE_OF_RAISE?: InputMaybe<Scalars["String"]>;
  DESCRIPTION?: InputMaybe<Scalars["String"]>;
  DOMAIN?: InputMaybe<Scalars["String"]>;
  FACEBOOK?: InputMaybe<Scalars["String"]>;
  FOUNDINGYEAR?: InputMaybe<Scalars["_float8"]>;
  ID?: InputMaybe<Scalars["_bigint"]>;
  INFORMALNAME?: InputMaybe<Scalars["String"]>;
  LINKEDIN?: InputMaybe<Scalars["String"]>;
  LOADDATE?: InputMaybe<Scalars["String"]>;
  MODIFIEDDATE?: InputMaybe<Scalars["String"]>;
  MOST_RECENT_EMPLOYEE_COUNT?: InputMaybe<Scalars["_float8"]>;
  NAME?: InputMaybe<Scalars["String"]>;
  NOLONGERINBUSINESS?: InputMaybe<Scalars["Boolean"]>;
  NOLONGERINBUSINESSDATE?: InputMaybe<Scalars["String"]>;
  NOLONGERINBUSINESSREASON?: InputMaybe<Scalars["_float8"]>;
  PARENTCOMPANY?: InputMaybe<Scalars["String"]>;
  PARENTID?: InputMaybe<Scalars["_float8"]>;
  PHONENUMBER?: InputMaybe<Scalars["String"]>;
  POSTALCODE?: InputMaybe<Scalars["String"]>;
  RAISE_AMOUNT?: InputMaybe<Scalars["_float8"]>;
  RAISE_ROUND?: InputMaybe<Scalars["_float8"]>;
  RAISE_TRANSACTION_TYPE?: InputMaybe<Scalars["_float8"]>;
  RAISE_VALUATION?: InputMaybe<Scalars["_float8"]>;
  SOURCECITED?: InputMaybe<Scalars["String"]>;
  SPECIALTIES?: InputMaybe<Scalars["String"]>;
  STATE?: InputMaybe<Scalars["String"]>;
  STATECODE?: InputMaybe<Scalars["String"]>;
  SUB_INDUSTRY_CATEGORY_NAME?: InputMaybe<Scalars["String"]>;
  TOTALAMOUNTINVESTED?: InputMaybe<Scalars["_float8"]>;
  TWITTER?: InputMaybe<Scalars["String"]>;
  WEBSITE?: InputMaybe<Scalars["String"]>;
  index?: InputMaybe<Scalars["_bigint"]>;
};

/** Ordering options when selecting data from "COMPANY". */
export type _COMPANY_order_by = {
  CITY?: InputMaybe<_order_by>;
  COMPANYTYPE?: InputMaybe<_order_by>;
  COUNTRY?: InputMaybe<_order_by>;
  COUNTRYCODE?: InputMaybe<_order_by>;
  CRUNCHBASE?: InputMaybe<_order_by>;
  DATE_OF_RAISE?: InputMaybe<_order_by>;
  DESCRIPTION?: InputMaybe<_order_by>;
  DOMAIN?: InputMaybe<_order_by>;
  FACEBOOK?: InputMaybe<_order_by>;
  FOUNDINGYEAR?: InputMaybe<_order_by>;
  ID?: InputMaybe<_order_by>;
  INFORMALNAME?: InputMaybe<_order_by>;
  LINKEDIN?: InputMaybe<_order_by>;
  LOADDATE?: InputMaybe<_order_by>;
  MODIFIEDDATE?: InputMaybe<_order_by>;
  MOST_RECENT_EMPLOYEE_COUNT?: InputMaybe<_order_by>;
  NAME?: InputMaybe<_order_by>;
  NOLONGERINBUSINESS?: InputMaybe<_order_by>;
  NOLONGERINBUSINESSDATE?: InputMaybe<_order_by>;
  NOLONGERINBUSINESSREASON?: InputMaybe<_order_by>;
  PARENTCOMPANY?: InputMaybe<_order_by>;
  PARENTID?: InputMaybe<_order_by>;
  PHONENUMBER?: InputMaybe<_order_by>;
  POSTALCODE?: InputMaybe<_order_by>;
  RAISE_AMOUNT?: InputMaybe<_order_by>;
  RAISE_ROUND?: InputMaybe<_order_by>;
  RAISE_TRANSACTION_TYPE?: InputMaybe<_order_by>;
  RAISE_VALUATION?: InputMaybe<_order_by>;
  SOURCECITED?: InputMaybe<_order_by>;
  SPECIALTIES?: InputMaybe<_order_by>;
  STATE?: InputMaybe<_order_by>;
  STATECODE?: InputMaybe<_order_by>;
  SUB_INDUSTRY_CATEGORY_NAME?: InputMaybe<_order_by>;
  TOTALAMOUNTINVESTED?: InputMaybe<_order_by>;
  TWITTER?: InputMaybe<_order_by>;
  WEBSITE?: InputMaybe<_order_by>;
  index?: InputMaybe<_order_by>;
};

/** select columns of table "COMPANY" */
export enum _COMPANY_select_column {
  /** column name */
  CITY = "CITY",
  /** column name */
  COMPANYTYPE = "COMPANYTYPE",
  /** column name */
  COUNTRY = "COUNTRY",
  /** column name */
  COUNTRYCODE = "COUNTRYCODE",
  /** column name */
  CRUNCHBASE = "CRUNCHBASE",
  /** column name */
  DATE_OF_RAISE = "DATE_OF_RAISE",
  /** column name */
  DESCRIPTION = "DESCRIPTION",
  /** column name */
  DOMAIN = "DOMAIN",
  /** column name */
  FACEBOOK = "FACEBOOK",
  /** column name */
  FOUNDINGYEAR = "FOUNDINGYEAR",
  /** column name */
  ID = "ID",
  /** column name */
  INFORMALNAME = "INFORMALNAME",
  /** column name */
  LINKEDIN = "LINKEDIN",
  /** column name */
  LOADDATE = "LOADDATE",
  /** column name */
  MODIFIEDDATE = "MODIFIEDDATE",
  /** column name */
  MOST_RECENT_EMPLOYEE_COUNT = "MOST_RECENT_EMPLOYEE_COUNT",
  /** column name */
  NAME = "NAME",
  /** column name */
  NOLONGERINBUSINESS = "NOLONGERINBUSINESS",
  /** column name */
  NOLONGERINBUSINESSDATE = "NOLONGERINBUSINESSDATE",
  /** column name */
  NOLONGERINBUSINESSREASON = "NOLONGERINBUSINESSREASON",
  /** column name */
  PARENTCOMPANY = "PARENTCOMPANY",
  /** column name */
  PARENTID = "PARENTID",
  /** column name */
  PHONENUMBER = "PHONENUMBER",
  /** column name */
  POSTALCODE = "POSTALCODE",
  /** column name */
  RAISE_AMOUNT = "RAISE_AMOUNT",
  /** column name */
  RAISE_ROUND = "RAISE_ROUND",
  /** column name */
  RAISE_TRANSACTION_TYPE = "RAISE_TRANSACTION_TYPE",
  /** column name */
  RAISE_VALUATION = "RAISE_VALUATION",
  /** column name */
  SOURCECITED = "SOURCECITED",
  /** column name */
  SPECIALTIES = "SPECIALTIES",
  /** column name */
  STATE = "STATE",
  /** column name */
  STATECODE = "STATECODE",
  /** column name */
  SUB_INDUSTRY_CATEGORY_NAME = "SUB_INDUSTRY_CATEGORY_NAME",
  /** column name */
  TOTALAMOUNTINVESTED = "TOTALAMOUNTINVESTED",
  /** column name */
  TWITTER = "TWITTER",
  /** column name */
  WEBSITE = "WEBSITE",
  /** column name */
  index = "index",
}

/** input type for updating data in table "COMPANY" */
export type _COMPANY_set_input = {
  CITY?: InputMaybe<Scalars["String"]>;
  COMPANYTYPE?: InputMaybe<Scalars["String"]>;
  COUNTRY?: InputMaybe<Scalars["String"]>;
  COUNTRYCODE?: InputMaybe<Scalars["String"]>;
  CRUNCHBASE?: InputMaybe<Scalars["String"]>;
  DATE_OF_RAISE?: InputMaybe<Scalars["String"]>;
  DESCRIPTION?: InputMaybe<Scalars["String"]>;
  DOMAIN?: InputMaybe<Scalars["String"]>;
  FACEBOOK?: InputMaybe<Scalars["String"]>;
  FOUNDINGYEAR?: InputMaybe<Scalars["_float8"]>;
  ID?: InputMaybe<Scalars["_bigint"]>;
  INFORMALNAME?: InputMaybe<Scalars["String"]>;
  LINKEDIN?: InputMaybe<Scalars["String"]>;
  LOADDATE?: InputMaybe<Scalars["String"]>;
  MODIFIEDDATE?: InputMaybe<Scalars["String"]>;
  MOST_RECENT_EMPLOYEE_COUNT?: InputMaybe<Scalars["_float8"]>;
  NAME?: InputMaybe<Scalars["String"]>;
  NOLONGERINBUSINESS?: InputMaybe<Scalars["Boolean"]>;
  NOLONGERINBUSINESSDATE?: InputMaybe<Scalars["String"]>;
  NOLONGERINBUSINESSREASON?: InputMaybe<Scalars["_float8"]>;
  PARENTCOMPANY?: InputMaybe<Scalars["String"]>;
  PARENTID?: InputMaybe<Scalars["_float8"]>;
  PHONENUMBER?: InputMaybe<Scalars["String"]>;
  POSTALCODE?: InputMaybe<Scalars["String"]>;
  RAISE_AMOUNT?: InputMaybe<Scalars["_float8"]>;
  RAISE_ROUND?: InputMaybe<Scalars["_float8"]>;
  RAISE_TRANSACTION_TYPE?: InputMaybe<Scalars["_float8"]>;
  RAISE_VALUATION?: InputMaybe<Scalars["_float8"]>;
  SOURCECITED?: InputMaybe<Scalars["String"]>;
  SPECIALTIES?: InputMaybe<Scalars["String"]>;
  STATE?: InputMaybe<Scalars["String"]>;
  STATECODE?: InputMaybe<Scalars["String"]>;
  SUB_INDUSTRY_CATEGORY_NAME?: InputMaybe<Scalars["String"]>;
  TOTALAMOUNTINVESTED?: InputMaybe<Scalars["_float8"]>;
  TWITTER?: InputMaybe<Scalars["String"]>;
  WEBSITE?: InputMaybe<Scalars["String"]>;
  index?: InputMaybe<Scalars["_bigint"]>;
};

/** Streaming cursor of the table "COMPANY" */
export type _COMPANY_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: _COMPANY_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<_cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _COMPANY_stream_cursor_value_input = {
  CITY?: InputMaybe<Scalars["String"]>;
  COMPANYTYPE?: InputMaybe<Scalars["String"]>;
  COUNTRY?: InputMaybe<Scalars["String"]>;
  COUNTRYCODE?: InputMaybe<Scalars["String"]>;
  CRUNCHBASE?: InputMaybe<Scalars["String"]>;
  DATE_OF_RAISE?: InputMaybe<Scalars["String"]>;
  DESCRIPTION?: InputMaybe<Scalars["String"]>;
  DOMAIN?: InputMaybe<Scalars["String"]>;
  FACEBOOK?: InputMaybe<Scalars["String"]>;
  FOUNDINGYEAR?: InputMaybe<Scalars["_float8"]>;
  ID?: InputMaybe<Scalars["_bigint"]>;
  INFORMALNAME?: InputMaybe<Scalars["String"]>;
  LINKEDIN?: InputMaybe<Scalars["String"]>;
  LOADDATE?: InputMaybe<Scalars["String"]>;
  MODIFIEDDATE?: InputMaybe<Scalars["String"]>;
  MOST_RECENT_EMPLOYEE_COUNT?: InputMaybe<Scalars["_float8"]>;
  NAME?: InputMaybe<Scalars["String"]>;
  NOLONGERINBUSINESS?: InputMaybe<Scalars["Boolean"]>;
  NOLONGERINBUSINESSDATE?: InputMaybe<Scalars["String"]>;
  NOLONGERINBUSINESSREASON?: InputMaybe<Scalars["_float8"]>;
  PARENTCOMPANY?: InputMaybe<Scalars["String"]>;
  PARENTID?: InputMaybe<Scalars["_float8"]>;
  PHONENUMBER?: InputMaybe<Scalars["String"]>;
  POSTALCODE?: InputMaybe<Scalars["String"]>;
  RAISE_AMOUNT?: InputMaybe<Scalars["_float8"]>;
  RAISE_ROUND?: InputMaybe<Scalars["_float8"]>;
  RAISE_TRANSACTION_TYPE?: InputMaybe<Scalars["_float8"]>;
  RAISE_VALUATION?: InputMaybe<Scalars["_float8"]>;
  SOURCECITED?: InputMaybe<Scalars["String"]>;
  SPECIALTIES?: InputMaybe<Scalars["String"]>;
  STATE?: InputMaybe<Scalars["String"]>;
  STATECODE?: InputMaybe<Scalars["String"]>;
  SUB_INDUSTRY_CATEGORY_NAME?: InputMaybe<Scalars["String"]>;
  TOTALAMOUNTINVESTED?: InputMaybe<Scalars["_float8"]>;
  TWITTER?: InputMaybe<Scalars["String"]>;
  WEBSITE?: InputMaybe<Scalars["String"]>;
  index?: InputMaybe<Scalars["_bigint"]>;
};

export type _COMPANY_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<_COMPANY_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_COMPANY_set_input>;
  where: _COMPANY_bool_exp;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type _Int_comparison_exp = {
  _eq?: InputMaybe<Scalars["Int"]>;
  _gt?: InputMaybe<Scalars["Int"]>;
  _gte?: InputMaybe<Scalars["Int"]>;
  _in?: InputMaybe<Array<Scalars["Int"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["Int"]>;
  _lte?: InputMaybe<Scalars["Int"]>;
  _neq?: InputMaybe<Scalars["Int"]>;
  _nin?: InputMaybe<Array<Scalars["Int"]>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type _String_comparison_exp = {
  _eq?: InputMaybe<Scalars["String"]>;
  _gt?: InputMaybe<Scalars["String"]>;
  _gte?: InputMaybe<Scalars["String"]>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars["String"]>;
  _in?: InputMaybe<Array<Scalars["String"]>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars["String"]>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars["String"]>;
  _lt?: InputMaybe<Scalars["String"]>;
  _lte?: InputMaybe<Scalars["String"]>;
  _neq?: InputMaybe<Scalars["String"]>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars["String"]>;
  _nin?: InputMaybe<Array<Scalars["String"]>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars["String"]>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars["String"]>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars["String"]>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars["String"]>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars["String"]>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars["String"]>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type _authProviderRequests_append_input = {
  options?: InputMaybe<Scalars["_jsonb"]>;
};

/** Boolean expression to filter rows from the table "auth.provider_requests". All fields are combined with a logical 'AND'. */
export type _authProviderRequests_bool_exp = {
  _and?: InputMaybe<Array<_authProviderRequests_bool_exp>>;
  _not?: InputMaybe<_authProviderRequests_bool_exp>;
  _or?: InputMaybe<Array<_authProviderRequests_bool_exp>>;
  id?: InputMaybe<_uuid_comparison_exp>;
  options?: InputMaybe<_jsonb_comparison_exp>;
};

/** unique or primary key constraints on table "auth.provider_requests" */
export enum _authProviderRequests_constraint {
  /** unique or primary key constraint on columns "id" */
  provider_requests_pkey = "provider_requests_pkey",
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type _authProviderRequests_delete_at_path_input = {
  options?: InputMaybe<Array<Scalars["String"]>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type _authProviderRequests_delete_elem_input = {
  options?: InputMaybe<Scalars["Int"]>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type _authProviderRequests_delete_key_input = {
  options?: InputMaybe<Scalars["String"]>;
};

/** input type for inserting data into table "auth.provider_requests" */
export type _authProviderRequests_insert_input = {
  id?: InputMaybe<Scalars["_uuid"]>;
  options?: InputMaybe<Scalars["_jsonb"]>;
};

/** on_conflict condition type for table "auth.provider_requests" */
export type _authProviderRequests_on_conflict = {
  constraint: _authProviderRequests_constraint;
  update_columns?: Array<_authProviderRequests_update_column>;
  where?: InputMaybe<_authProviderRequests_bool_exp>;
};

/** Ordering options when selecting data from "auth.provider_requests". */
export type _authProviderRequests_order_by = {
  id?: InputMaybe<_order_by>;
  options?: InputMaybe<_order_by>;
};

/** primary key columns input for table: auth.provider_requests */
export type _authProviderRequests_pk_columns_input = {
  id: Scalars["_uuid"];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type _authProviderRequests_prepend_input = {
  options?: InputMaybe<Scalars["_jsonb"]>;
};

/** select columns of table "auth.provider_requests" */
export enum _authProviderRequests_select_column {
  /** column name */
  id = "id",
  /** column name */
  options = "options",
}

/** input type for updating data in table "auth.provider_requests" */
export type _authProviderRequests_set_input = {
  id?: InputMaybe<Scalars["_uuid"]>;
  options?: InputMaybe<Scalars["_jsonb"]>;
};

/** Streaming cursor of the table "authProviderRequests" */
export type _authProviderRequests_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: _authProviderRequests_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<_cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _authProviderRequests_stream_cursor_value_input = {
  id?: InputMaybe<Scalars["_uuid"]>;
  options?: InputMaybe<Scalars["_jsonb"]>;
};

/** update columns of table "auth.provider_requests" */
export enum _authProviderRequests_update_column {
  /** column name */
  id = "id",
  /** column name */
  options = "options",
}

export type _authProviderRequests_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<_authProviderRequests_append_input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<_authProviderRequests_delete_at_path_input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<_authProviderRequests_delete_elem_input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<_authProviderRequests_delete_key_input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<_authProviderRequests_prepend_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_authProviderRequests_set_input>;
  where: _authProviderRequests_bool_exp;
};

/** Boolean expression to filter rows from the table "auth.providers". All fields are combined with a logical 'AND'. */
export type _authProviders_bool_exp = {
  _and?: InputMaybe<Array<_authProviders_bool_exp>>;
  _not?: InputMaybe<_authProviders_bool_exp>;
  _or?: InputMaybe<Array<_authProviders_bool_exp>>;
  id?: InputMaybe<_String_comparison_exp>;
  userProviders?: InputMaybe<_authUserProviders_bool_exp>;
  userProviders_aggregate?: InputMaybe<_authUserProviders_aggregate_bool_exp>;
};

/** unique or primary key constraints on table "auth.providers" */
export enum _authProviders_constraint {
  /** unique or primary key constraint on columns "id" */
  providers_pkey = "providers_pkey",
}

/** input type for inserting data into table "auth.providers" */
export type _authProviders_insert_input = {
  id?: InputMaybe<Scalars["String"]>;
  userProviders?: InputMaybe<_authUserProviders_arr_rel_insert_input>;
};

/** input type for inserting object relation for remote table "auth.providers" */
export type _authProviders_obj_rel_insert_input = {
  data: _authProviders_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<_authProviders_on_conflict>;
};

/** on_conflict condition type for table "auth.providers" */
export type _authProviders_on_conflict = {
  constraint: _authProviders_constraint;
  update_columns?: Array<_authProviders_update_column>;
  where?: InputMaybe<_authProviders_bool_exp>;
};

/** Ordering options when selecting data from "auth.providers". */
export type _authProviders_order_by = {
  id?: InputMaybe<_order_by>;
  userProviders_aggregate?: InputMaybe<_authUserProviders_aggregate_order_by>;
};

/** primary key columns input for table: auth.providers */
export type _authProviders_pk_columns_input = {
  id: Scalars["String"];
};

/** select columns of table "auth.providers" */
export enum _authProviders_select_column {
  /** column name */
  id = "id",
}

/** input type for updating data in table "auth.providers" */
export type _authProviders_set_input = {
  id?: InputMaybe<Scalars["String"]>;
};

/** Streaming cursor of the table "authProviders" */
export type _authProviders_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: _authProviders_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<_cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _authProviders_stream_cursor_value_input = {
  id?: InputMaybe<Scalars["String"]>;
};

/** update columns of table "auth.providers" */
export enum _authProviders_update_column {
  /** column name */
  id = "id",
}

export type _authProviders_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_authProviders_set_input>;
  where: _authProviders_bool_exp;
};

export type _authRefreshTokens_aggregate_bool_exp = {
  count?: InputMaybe<_authRefreshTokens_aggregate_bool_exp_count>;
};

export type _authRefreshTokens_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<_authRefreshTokens_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<_authRefreshTokens_bool_exp>;
  predicate: _Int_comparison_exp;
};

/** order by aggregate values of table "auth.refresh_tokens" */
export type _authRefreshTokens_aggregate_order_by = {
  count?: InputMaybe<_order_by>;
  max?: InputMaybe<_authRefreshTokens_max_order_by>;
  min?: InputMaybe<_authRefreshTokens_min_order_by>;
};

/** input type for inserting array relation for remote table "auth.refresh_tokens" */
export type _authRefreshTokens_arr_rel_insert_input = {
  data: Array<_authRefreshTokens_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<_authRefreshTokens_on_conflict>;
};

/** Boolean expression to filter rows from the table "auth.refresh_tokens". All fields are combined with a logical 'AND'. */
export type _authRefreshTokens_bool_exp = {
  _and?: InputMaybe<Array<_authRefreshTokens_bool_exp>>;
  _not?: InputMaybe<_authRefreshTokens_bool_exp>;
  _or?: InputMaybe<Array<_authRefreshTokens_bool_exp>>;
  createdAt?: InputMaybe<_timestamptz_comparison_exp>;
  expiresAt?: InputMaybe<_timestamptz_comparison_exp>;
  refreshToken?: InputMaybe<_uuid_comparison_exp>;
  refreshTokenHash?: InputMaybe<_String_comparison_exp>;
  user?: InputMaybe<_users_bool_exp>;
  userId?: InputMaybe<_uuid_comparison_exp>;
};

/** unique or primary key constraints on table "auth.refresh_tokens" */
export enum _authRefreshTokens_constraint {
  /** unique or primary key constraint on columns "refresh_token" */
  refresh_tokens_pkey = "refresh_tokens_pkey",
}

/** input type for inserting data into table "auth.refresh_tokens" */
export type _authRefreshTokens_insert_input = {
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  expiresAt?: InputMaybe<Scalars["_timestamptz"]>;
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken?: InputMaybe<Scalars["_uuid"]>;
  user?: InputMaybe<_users_obj_rel_insert_input>;
  userId?: InputMaybe<Scalars["_uuid"]>;
};

/** order by max() on columns of table "auth.refresh_tokens" */
export type _authRefreshTokens_max_order_by = {
  createdAt?: InputMaybe<_order_by>;
  expiresAt?: InputMaybe<_order_by>;
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken?: InputMaybe<_order_by>;
  refreshTokenHash?: InputMaybe<_order_by>;
  userId?: InputMaybe<_order_by>;
};

/** order by min() on columns of table "auth.refresh_tokens" */
export type _authRefreshTokens_min_order_by = {
  createdAt?: InputMaybe<_order_by>;
  expiresAt?: InputMaybe<_order_by>;
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken?: InputMaybe<_order_by>;
  refreshTokenHash?: InputMaybe<_order_by>;
  userId?: InputMaybe<_order_by>;
};

/** on_conflict condition type for table "auth.refresh_tokens" */
export type _authRefreshTokens_on_conflict = {
  constraint: _authRefreshTokens_constraint;
  update_columns?: Array<_authRefreshTokens_update_column>;
  where?: InputMaybe<_authRefreshTokens_bool_exp>;
};

/** Ordering options when selecting data from "auth.refresh_tokens". */
export type _authRefreshTokens_order_by = {
  createdAt?: InputMaybe<_order_by>;
  expiresAt?: InputMaybe<_order_by>;
  refreshToken?: InputMaybe<_order_by>;
  refreshTokenHash?: InputMaybe<_order_by>;
  user?: InputMaybe<_users_order_by>;
  userId?: InputMaybe<_order_by>;
};

/** primary key columns input for table: auth.refresh_tokens */
export type _authRefreshTokens_pk_columns_input = {
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken: Scalars["_uuid"];
};

/** select columns of table "auth.refresh_tokens" */
export enum _authRefreshTokens_select_column {
  /** column name */
  createdAt = "createdAt",
  /** column name */
  expiresAt = "expiresAt",
  /** column name */
  refreshToken = "refreshToken",
  /** column name */
  refreshTokenHash = "refreshTokenHash",
  /** column name */
  userId = "userId",
}

/** input type for updating data in table "auth.refresh_tokens" */
export type _authRefreshTokens_set_input = {
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  expiresAt?: InputMaybe<Scalars["_timestamptz"]>;
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken?: InputMaybe<Scalars["_uuid"]>;
  userId?: InputMaybe<Scalars["_uuid"]>;
};

/** Streaming cursor of the table "authRefreshTokens" */
export type _authRefreshTokens_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: _authRefreshTokens_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<_cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _authRefreshTokens_stream_cursor_value_input = {
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  expiresAt?: InputMaybe<Scalars["_timestamptz"]>;
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken?: InputMaybe<Scalars["_uuid"]>;
  refreshTokenHash?: InputMaybe<Scalars["String"]>;
  userId?: InputMaybe<Scalars["_uuid"]>;
};

/** update columns of table "auth.refresh_tokens" */
export enum _authRefreshTokens_update_column {
  /** column name */
  createdAt = "createdAt",
  /** column name */
  expiresAt = "expiresAt",
  /** column name */
  refreshToken = "refreshToken",
  /** column name */
  userId = "userId",
}

export type _authRefreshTokens_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_authRefreshTokens_set_input>;
  where: _authRefreshTokens_bool_exp;
};

/** Boolean expression to filter rows from the table "auth.roles". All fields are combined with a logical 'AND'. */
export type _authRoles_bool_exp = {
  _and?: InputMaybe<Array<_authRoles_bool_exp>>;
  _not?: InputMaybe<_authRoles_bool_exp>;
  _or?: InputMaybe<Array<_authRoles_bool_exp>>;
  role?: InputMaybe<_String_comparison_exp>;
  userRoles?: InputMaybe<_authUserRoles_bool_exp>;
  userRoles_aggregate?: InputMaybe<_authUserRoles_aggregate_bool_exp>;
  usersByDefaultRole?: InputMaybe<_users_bool_exp>;
  usersByDefaultRole_aggregate?: InputMaybe<_users_aggregate_bool_exp>;
};

/** unique or primary key constraints on table "auth.roles" */
export enum _authRoles_constraint {
  /** unique or primary key constraint on columns "role" */
  roles_pkey = "roles_pkey",
}

/** input type for inserting data into table "auth.roles" */
export type _authRoles_insert_input = {
  role?: InputMaybe<Scalars["String"]>;
  userRoles?: InputMaybe<_authUserRoles_arr_rel_insert_input>;
  usersByDefaultRole?: InputMaybe<_users_arr_rel_insert_input>;
};

/** input type for inserting object relation for remote table "auth.roles" */
export type _authRoles_obj_rel_insert_input = {
  data: _authRoles_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<_authRoles_on_conflict>;
};

/** on_conflict condition type for table "auth.roles" */
export type _authRoles_on_conflict = {
  constraint: _authRoles_constraint;
  update_columns?: Array<_authRoles_update_column>;
  where?: InputMaybe<_authRoles_bool_exp>;
};

/** Ordering options when selecting data from "auth.roles". */
export type _authRoles_order_by = {
  role?: InputMaybe<_order_by>;
  userRoles_aggregate?: InputMaybe<_authUserRoles_aggregate_order_by>;
  usersByDefaultRole_aggregate?: InputMaybe<_users_aggregate_order_by>;
};

/** primary key columns input for table: auth.roles */
export type _authRoles_pk_columns_input = {
  role: Scalars["String"];
};

/** select columns of table "auth.roles" */
export enum _authRoles_select_column {
  /** column name */
  role = "role",
}

/** input type for updating data in table "auth.roles" */
export type _authRoles_set_input = {
  role?: InputMaybe<Scalars["String"]>;
};

/** Streaming cursor of the table "authRoles" */
export type _authRoles_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: _authRoles_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<_cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _authRoles_stream_cursor_value_input = {
  role?: InputMaybe<Scalars["String"]>;
};

/** update columns of table "auth.roles" */
export enum _authRoles_update_column {
  /** column name */
  role = "role",
}

export type _authRoles_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_authRoles_set_input>;
  where: _authRoles_bool_exp;
};

export type _authUserProviders_aggregate_bool_exp = {
  count?: InputMaybe<_authUserProviders_aggregate_bool_exp_count>;
};

export type _authUserProviders_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<_authUserProviders_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<_authUserProviders_bool_exp>;
  predicate: _Int_comparison_exp;
};

/** order by aggregate values of table "auth.user_providers" */
export type _authUserProviders_aggregate_order_by = {
  count?: InputMaybe<_order_by>;
  max?: InputMaybe<_authUserProviders_max_order_by>;
  min?: InputMaybe<_authUserProviders_min_order_by>;
};

/** input type for inserting array relation for remote table "auth.user_providers" */
export type _authUserProviders_arr_rel_insert_input = {
  data: Array<_authUserProviders_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<_authUserProviders_on_conflict>;
};

/** Boolean expression to filter rows from the table "auth.user_providers". All fields are combined with a logical 'AND'. */
export type _authUserProviders_bool_exp = {
  _and?: InputMaybe<Array<_authUserProviders_bool_exp>>;
  _not?: InputMaybe<_authUserProviders_bool_exp>;
  _or?: InputMaybe<Array<_authUserProviders_bool_exp>>;
  accessToken?: InputMaybe<_String_comparison_exp>;
  createdAt?: InputMaybe<_timestamptz_comparison_exp>;
  id?: InputMaybe<_uuid_comparison_exp>;
  provider?: InputMaybe<_authProviders_bool_exp>;
  providerId?: InputMaybe<_String_comparison_exp>;
  providerUserId?: InputMaybe<_String_comparison_exp>;
  refreshToken?: InputMaybe<_String_comparison_exp>;
  updatedAt?: InputMaybe<_timestamptz_comparison_exp>;
  user?: InputMaybe<_users_bool_exp>;
  userId?: InputMaybe<_uuid_comparison_exp>;
};

/** unique or primary key constraints on table "auth.user_providers" */
export enum _authUserProviders_constraint {
  /** unique or primary key constraint on columns "id" */
  user_providers_pkey = "user_providers_pkey",
  /** unique or primary key constraint on columns "provider_id", "provider_user_id" */
  user_providers_provider_id_provider_user_id_key = "user_providers_provider_id_provider_user_id_key",
  /** unique or primary key constraint on columns "provider_id", "user_id" */
  user_providers_user_id_provider_id_key = "user_providers_user_id_provider_id_key",
}

/** input type for inserting data into table "auth.user_providers" */
export type _authUserProviders_insert_input = {
  accessToken?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  id?: InputMaybe<Scalars["_uuid"]>;
  provider?: InputMaybe<_authProviders_obj_rel_insert_input>;
  providerId?: InputMaybe<Scalars["String"]>;
  providerUserId?: InputMaybe<Scalars["String"]>;
  refreshToken?: InputMaybe<Scalars["String"]>;
  updatedAt?: InputMaybe<Scalars["_timestamptz"]>;
  user?: InputMaybe<_users_obj_rel_insert_input>;
  userId?: InputMaybe<Scalars["_uuid"]>;
};

/** order by max() on columns of table "auth.user_providers" */
export type _authUserProviders_max_order_by = {
  accessToken?: InputMaybe<_order_by>;
  createdAt?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  providerId?: InputMaybe<_order_by>;
  providerUserId?: InputMaybe<_order_by>;
  refreshToken?: InputMaybe<_order_by>;
  updatedAt?: InputMaybe<_order_by>;
  userId?: InputMaybe<_order_by>;
};

/** order by min() on columns of table "auth.user_providers" */
export type _authUserProviders_min_order_by = {
  accessToken?: InputMaybe<_order_by>;
  createdAt?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  providerId?: InputMaybe<_order_by>;
  providerUserId?: InputMaybe<_order_by>;
  refreshToken?: InputMaybe<_order_by>;
  updatedAt?: InputMaybe<_order_by>;
  userId?: InputMaybe<_order_by>;
};

/** on_conflict condition type for table "auth.user_providers" */
export type _authUserProviders_on_conflict = {
  constraint: _authUserProviders_constraint;
  update_columns?: Array<_authUserProviders_update_column>;
  where?: InputMaybe<_authUserProviders_bool_exp>;
};

/** Ordering options when selecting data from "auth.user_providers". */
export type _authUserProviders_order_by = {
  accessToken?: InputMaybe<_order_by>;
  createdAt?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  provider?: InputMaybe<_authProviders_order_by>;
  providerId?: InputMaybe<_order_by>;
  providerUserId?: InputMaybe<_order_by>;
  refreshToken?: InputMaybe<_order_by>;
  updatedAt?: InputMaybe<_order_by>;
  user?: InputMaybe<_users_order_by>;
  userId?: InputMaybe<_order_by>;
};

/** primary key columns input for table: auth.user_providers */
export type _authUserProviders_pk_columns_input = {
  id: Scalars["_uuid"];
};

/** select columns of table "auth.user_providers" */
export enum _authUserProviders_select_column {
  /** column name */
  accessToken = "accessToken",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  id = "id",
  /** column name */
  providerId = "providerId",
  /** column name */
  providerUserId = "providerUserId",
  /** column name */
  refreshToken = "refreshToken",
  /** column name */
  updatedAt = "updatedAt",
  /** column name */
  userId = "userId",
}

/** input type for updating data in table "auth.user_providers" */
export type _authUserProviders_set_input = {
  accessToken?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  id?: InputMaybe<Scalars["_uuid"]>;
  providerId?: InputMaybe<Scalars["String"]>;
  providerUserId?: InputMaybe<Scalars["String"]>;
  refreshToken?: InputMaybe<Scalars["String"]>;
  updatedAt?: InputMaybe<Scalars["_timestamptz"]>;
  userId?: InputMaybe<Scalars["_uuid"]>;
};

/** Streaming cursor of the table "authUserProviders" */
export type _authUserProviders_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: _authUserProviders_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<_cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _authUserProviders_stream_cursor_value_input = {
  accessToken?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  id?: InputMaybe<Scalars["_uuid"]>;
  providerId?: InputMaybe<Scalars["String"]>;
  providerUserId?: InputMaybe<Scalars["String"]>;
  refreshToken?: InputMaybe<Scalars["String"]>;
  updatedAt?: InputMaybe<Scalars["_timestamptz"]>;
  userId?: InputMaybe<Scalars["_uuid"]>;
};

/** update columns of table "auth.user_providers" */
export enum _authUserProviders_update_column {
  /** column name */
  accessToken = "accessToken",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  id = "id",
  /** column name */
  providerId = "providerId",
  /** column name */
  providerUserId = "providerUserId",
  /** column name */
  refreshToken = "refreshToken",
  /** column name */
  updatedAt = "updatedAt",
  /** column name */
  userId = "userId",
}

export type _authUserProviders_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_authUserProviders_set_input>;
  where: _authUserProviders_bool_exp;
};

export type _authUserRoles_aggregate_bool_exp = {
  count?: InputMaybe<_authUserRoles_aggregate_bool_exp_count>;
};

export type _authUserRoles_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<_authUserRoles_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<_authUserRoles_bool_exp>;
  predicate: _Int_comparison_exp;
};

/** order by aggregate values of table "auth.user_roles" */
export type _authUserRoles_aggregate_order_by = {
  count?: InputMaybe<_order_by>;
  max?: InputMaybe<_authUserRoles_max_order_by>;
  min?: InputMaybe<_authUserRoles_min_order_by>;
};

/** input type for inserting array relation for remote table "auth.user_roles" */
export type _authUserRoles_arr_rel_insert_input = {
  data: Array<_authUserRoles_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<_authUserRoles_on_conflict>;
};

/** Boolean expression to filter rows from the table "auth.user_roles". All fields are combined with a logical 'AND'. */
export type _authUserRoles_bool_exp = {
  _and?: InputMaybe<Array<_authUserRoles_bool_exp>>;
  _not?: InputMaybe<_authUserRoles_bool_exp>;
  _or?: InputMaybe<Array<_authUserRoles_bool_exp>>;
  createdAt?: InputMaybe<_timestamptz_comparison_exp>;
  id?: InputMaybe<_uuid_comparison_exp>;
  role?: InputMaybe<_String_comparison_exp>;
  roleByRole?: InputMaybe<_authRoles_bool_exp>;
  user?: InputMaybe<_users_bool_exp>;
  userId?: InputMaybe<_uuid_comparison_exp>;
};

/** unique or primary key constraints on table "auth.user_roles" */
export enum _authUserRoles_constraint {
  /** unique or primary key constraint on columns "id" */
  user_roles_pkey = "user_roles_pkey",
  /** unique or primary key constraint on columns "user_id", "role" */
  user_roles_user_id_role_key = "user_roles_user_id_role_key",
}

/** input type for inserting data into table "auth.user_roles" */
export type _authUserRoles_insert_input = {
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  id?: InputMaybe<Scalars["_uuid"]>;
  role?: InputMaybe<Scalars["String"]>;
  roleByRole?: InputMaybe<_authRoles_obj_rel_insert_input>;
  user?: InputMaybe<_users_obj_rel_insert_input>;
  userId?: InputMaybe<Scalars["_uuid"]>;
};

/** order by max() on columns of table "auth.user_roles" */
export type _authUserRoles_max_order_by = {
  createdAt?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  role?: InputMaybe<_order_by>;
  userId?: InputMaybe<_order_by>;
};

/** order by min() on columns of table "auth.user_roles" */
export type _authUserRoles_min_order_by = {
  createdAt?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  role?: InputMaybe<_order_by>;
  userId?: InputMaybe<_order_by>;
};

/** on_conflict condition type for table "auth.user_roles" */
export type _authUserRoles_on_conflict = {
  constraint: _authUserRoles_constraint;
  update_columns?: Array<_authUserRoles_update_column>;
  where?: InputMaybe<_authUserRoles_bool_exp>;
};

/** Ordering options when selecting data from "auth.user_roles". */
export type _authUserRoles_order_by = {
  createdAt?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  role?: InputMaybe<_order_by>;
  roleByRole?: InputMaybe<_authRoles_order_by>;
  user?: InputMaybe<_users_order_by>;
  userId?: InputMaybe<_order_by>;
};

/** primary key columns input for table: auth.user_roles */
export type _authUserRoles_pk_columns_input = {
  id: Scalars["_uuid"];
};

/** select columns of table "auth.user_roles" */
export enum _authUserRoles_select_column {
  /** column name */
  createdAt = "createdAt",
  /** column name */
  id = "id",
  /** column name */
  role = "role",
  /** column name */
  userId = "userId",
}

/** input type for updating data in table "auth.user_roles" */
export type _authUserRoles_set_input = {
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  id?: InputMaybe<Scalars["_uuid"]>;
  role?: InputMaybe<Scalars["String"]>;
  userId?: InputMaybe<Scalars["_uuid"]>;
};

/** Streaming cursor of the table "authUserRoles" */
export type _authUserRoles_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: _authUserRoles_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<_cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _authUserRoles_stream_cursor_value_input = {
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  id?: InputMaybe<Scalars["_uuid"]>;
  role?: InputMaybe<Scalars["String"]>;
  userId?: InputMaybe<Scalars["_uuid"]>;
};

/** update columns of table "auth.user_roles" */
export enum _authUserRoles_update_column {
  /** column name */
  createdAt = "createdAt",
  /** column name */
  id = "id",
  /** column name */
  role = "role",
  /** column name */
  userId = "userId",
}

export type _authUserRoles_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_authUserRoles_set_input>;
  where: _authUserRoles_bool_exp;
};

export type _authUserSecurityKeys_aggregate_bool_exp = {
  count?: InputMaybe<_authUserSecurityKeys_aggregate_bool_exp_count>;
};

export type _authUserSecurityKeys_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<_authUserSecurityKeys_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<_authUserSecurityKeys_bool_exp>;
  predicate: _Int_comparison_exp;
};

/** order by aggregate values of table "auth.user_security_keys" */
export type _authUserSecurityKeys_aggregate_order_by = {
  avg?: InputMaybe<_authUserSecurityKeys_avg_order_by>;
  count?: InputMaybe<_order_by>;
  max?: InputMaybe<_authUserSecurityKeys_max_order_by>;
  min?: InputMaybe<_authUserSecurityKeys_min_order_by>;
  stddev?: InputMaybe<_authUserSecurityKeys_stddev_order_by>;
  stddev_pop?: InputMaybe<_authUserSecurityKeys_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<_authUserSecurityKeys_stddev_samp_order_by>;
  sum?: InputMaybe<_authUserSecurityKeys_sum_order_by>;
  var_pop?: InputMaybe<_authUserSecurityKeys_var_pop_order_by>;
  var_samp?: InputMaybe<_authUserSecurityKeys_var_samp_order_by>;
  variance?: InputMaybe<_authUserSecurityKeys_variance_order_by>;
};

/** input type for inserting array relation for remote table "auth.user_security_keys" */
export type _authUserSecurityKeys_arr_rel_insert_input = {
  data: Array<_authUserSecurityKeys_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<_authUserSecurityKeys_on_conflict>;
};

/** order by avg() on columns of table "auth.user_security_keys" */
export type _authUserSecurityKeys_avg_order_by = {
  counter?: InputMaybe<_order_by>;
};

/** Boolean expression to filter rows from the table "auth.user_security_keys". All fields are combined with a logical 'AND'. */
export type _authUserSecurityKeys_bool_exp = {
  _and?: InputMaybe<Array<_authUserSecurityKeys_bool_exp>>;
  _not?: InputMaybe<_authUserSecurityKeys_bool_exp>;
  _or?: InputMaybe<Array<_authUserSecurityKeys_bool_exp>>;
  counter?: InputMaybe<_bigint_comparison_exp>;
  credentialId?: InputMaybe<_String_comparison_exp>;
  credentialPublicKey?: InputMaybe<_bytea_comparison_exp>;
  id?: InputMaybe<_uuid_comparison_exp>;
  nickname?: InputMaybe<_String_comparison_exp>;
  transports?: InputMaybe<_String_comparison_exp>;
  user?: InputMaybe<_users_bool_exp>;
  userId?: InputMaybe<_uuid_comparison_exp>;
};

/** unique or primary key constraints on table "auth.user_security_keys" */
export enum _authUserSecurityKeys_constraint {
  /** unique or primary key constraint on columns "credential_id" */
  user_security_key_credential_id_key = "user_security_key_credential_id_key",
  /** unique or primary key constraint on columns "id" */
  user_security_keys_pkey = "user_security_keys_pkey",
}

/** input type for incrementing numeric columns in table "auth.user_security_keys" */
export type _authUserSecurityKeys_inc_input = {
  counter?: InputMaybe<Scalars["_bigint"]>;
};

/** input type for inserting data into table "auth.user_security_keys" */
export type _authUserSecurityKeys_insert_input = {
  counter?: InputMaybe<Scalars["_bigint"]>;
  credentialId?: InputMaybe<Scalars["String"]>;
  credentialPublicKey?: InputMaybe<Scalars["_bytea"]>;
  id?: InputMaybe<Scalars["_uuid"]>;
  nickname?: InputMaybe<Scalars["String"]>;
  transports?: InputMaybe<Scalars["String"]>;
  user?: InputMaybe<_users_obj_rel_insert_input>;
  userId?: InputMaybe<Scalars["_uuid"]>;
};

/** order by max() on columns of table "auth.user_security_keys" */
export type _authUserSecurityKeys_max_order_by = {
  counter?: InputMaybe<_order_by>;
  credentialId?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  nickname?: InputMaybe<_order_by>;
  transports?: InputMaybe<_order_by>;
  userId?: InputMaybe<_order_by>;
};

/** order by min() on columns of table "auth.user_security_keys" */
export type _authUserSecurityKeys_min_order_by = {
  counter?: InputMaybe<_order_by>;
  credentialId?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  nickname?: InputMaybe<_order_by>;
  transports?: InputMaybe<_order_by>;
  userId?: InputMaybe<_order_by>;
};

/** on_conflict condition type for table "auth.user_security_keys" */
export type _authUserSecurityKeys_on_conflict = {
  constraint: _authUserSecurityKeys_constraint;
  update_columns?: Array<_authUserSecurityKeys_update_column>;
  where?: InputMaybe<_authUserSecurityKeys_bool_exp>;
};

/** Ordering options when selecting data from "auth.user_security_keys". */
export type _authUserSecurityKeys_order_by = {
  counter?: InputMaybe<_order_by>;
  credentialId?: InputMaybe<_order_by>;
  credentialPublicKey?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  nickname?: InputMaybe<_order_by>;
  transports?: InputMaybe<_order_by>;
  user?: InputMaybe<_users_order_by>;
  userId?: InputMaybe<_order_by>;
};

/** primary key columns input for table: auth.user_security_keys */
export type _authUserSecurityKeys_pk_columns_input = {
  id: Scalars["_uuid"];
};

/** select columns of table "auth.user_security_keys" */
export enum _authUserSecurityKeys_select_column {
  /** column name */
  counter = "counter",
  /** column name */
  credentialId = "credentialId",
  /** column name */
  credentialPublicKey = "credentialPublicKey",
  /** column name */
  id = "id",
  /** column name */
  nickname = "nickname",
  /** column name */
  transports = "transports",
  /** column name */
  userId = "userId",
}

/** input type for updating data in table "auth.user_security_keys" */
export type _authUserSecurityKeys_set_input = {
  counter?: InputMaybe<Scalars["_bigint"]>;
  credentialId?: InputMaybe<Scalars["String"]>;
  credentialPublicKey?: InputMaybe<Scalars["_bytea"]>;
  id?: InputMaybe<Scalars["_uuid"]>;
  nickname?: InputMaybe<Scalars["String"]>;
  transports?: InputMaybe<Scalars["String"]>;
  userId?: InputMaybe<Scalars["_uuid"]>;
};

/** order by stddev() on columns of table "auth.user_security_keys" */
export type _authUserSecurityKeys_stddev_order_by = {
  counter?: InputMaybe<_order_by>;
};

/** order by stddev_pop() on columns of table "auth.user_security_keys" */
export type _authUserSecurityKeys_stddev_pop_order_by = {
  counter?: InputMaybe<_order_by>;
};

/** order by stddev_samp() on columns of table "auth.user_security_keys" */
export type _authUserSecurityKeys_stddev_samp_order_by = {
  counter?: InputMaybe<_order_by>;
};

/** Streaming cursor of the table "authUserSecurityKeys" */
export type _authUserSecurityKeys_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: _authUserSecurityKeys_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<_cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _authUserSecurityKeys_stream_cursor_value_input = {
  counter?: InputMaybe<Scalars["_bigint"]>;
  credentialId?: InputMaybe<Scalars["String"]>;
  credentialPublicKey?: InputMaybe<Scalars["_bytea"]>;
  id?: InputMaybe<Scalars["_uuid"]>;
  nickname?: InputMaybe<Scalars["String"]>;
  transports?: InputMaybe<Scalars["String"]>;
  userId?: InputMaybe<Scalars["_uuid"]>;
};

/** order by sum() on columns of table "auth.user_security_keys" */
export type _authUserSecurityKeys_sum_order_by = {
  counter?: InputMaybe<_order_by>;
};

/** update columns of table "auth.user_security_keys" */
export enum _authUserSecurityKeys_update_column {
  /** column name */
  counter = "counter",
  /** column name */
  credentialId = "credentialId",
  /** column name */
  credentialPublicKey = "credentialPublicKey",
  /** column name */
  id = "id",
  /** column name */
  nickname = "nickname",
  /** column name */
  transports = "transports",
  /** column name */
  userId = "userId",
}

export type _authUserSecurityKeys_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<_authUserSecurityKeys_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_authUserSecurityKeys_set_input>;
  where: _authUserSecurityKeys_bool_exp;
};

/** order by var_pop() on columns of table "auth.user_security_keys" */
export type _authUserSecurityKeys_var_pop_order_by = {
  counter?: InputMaybe<_order_by>;
};

/** order by var_samp() on columns of table "auth.user_security_keys" */
export type _authUserSecurityKeys_var_samp_order_by = {
  counter?: InputMaybe<_order_by>;
};

/** order by variance() on columns of table "auth.user_security_keys" */
export type _authUserSecurityKeys_variance_order_by = {
  counter?: InputMaybe<_order_by>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type _bigint_comparison_exp = {
  _eq?: InputMaybe<Scalars["_bigint"]>;
  _gt?: InputMaybe<Scalars["_bigint"]>;
  _gte?: InputMaybe<Scalars["_bigint"]>;
  _in?: InputMaybe<Array<Scalars["_bigint"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["_bigint"]>;
  _lte?: InputMaybe<Scalars["_bigint"]>;
  _neq?: InputMaybe<Scalars["_bigint"]>;
  _nin?: InputMaybe<Array<Scalars["_bigint"]>>;
};

/** Boolean expression to filter rows from the table "storage.buckets". All fields are combined with a logical 'AND'. */
export type _buckets_bool_exp = {
  _and?: InputMaybe<Array<_buckets_bool_exp>>;
  _not?: InputMaybe<_buckets_bool_exp>;
  _or?: InputMaybe<Array<_buckets_bool_exp>>;
  cacheControl?: InputMaybe<_String_comparison_exp>;
  createdAt?: InputMaybe<_timestamptz_comparison_exp>;
  downloadExpiration?: InputMaybe<_Int_comparison_exp>;
  files?: InputMaybe<_files_bool_exp>;
  files_aggregate?: InputMaybe<_files_aggregate_bool_exp>;
  id?: InputMaybe<_String_comparison_exp>;
  maxUploadFileSize?: InputMaybe<_Int_comparison_exp>;
  minUploadFileSize?: InputMaybe<_Int_comparison_exp>;
  presignedUrlsEnabled?: InputMaybe<_Boolean_comparison_exp>;
  updatedAt?: InputMaybe<_timestamptz_comparison_exp>;
};

/** unique or primary key constraints on table "storage.buckets" */
export enum _buckets_constraint {
  /** unique or primary key constraint on columns "id" */
  buckets_pkey = "buckets_pkey",
}

/** input type for incrementing numeric columns in table "storage.buckets" */
export type _buckets_inc_input = {
  downloadExpiration?: InputMaybe<Scalars["Int"]>;
  maxUploadFileSize?: InputMaybe<Scalars["Int"]>;
  minUploadFileSize?: InputMaybe<Scalars["Int"]>;
};

/** input type for inserting data into table "storage.buckets" */
export type _buckets_insert_input = {
  cacheControl?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  downloadExpiration?: InputMaybe<Scalars["Int"]>;
  files?: InputMaybe<_files_arr_rel_insert_input>;
  id?: InputMaybe<Scalars["String"]>;
  maxUploadFileSize?: InputMaybe<Scalars["Int"]>;
  minUploadFileSize?: InputMaybe<Scalars["Int"]>;
  presignedUrlsEnabled?: InputMaybe<Scalars["Boolean"]>;
  updatedAt?: InputMaybe<Scalars["_timestamptz"]>;
};

/** input type for inserting object relation for remote table "storage.buckets" */
export type _buckets_obj_rel_insert_input = {
  data: _buckets_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<_buckets_on_conflict>;
};

/** on_conflict condition type for table "storage.buckets" */
export type _buckets_on_conflict = {
  constraint: _buckets_constraint;
  update_columns?: Array<_buckets_update_column>;
  where?: InputMaybe<_buckets_bool_exp>;
};

/** Ordering options when selecting data from "storage.buckets". */
export type _buckets_order_by = {
  cacheControl?: InputMaybe<_order_by>;
  createdAt?: InputMaybe<_order_by>;
  downloadExpiration?: InputMaybe<_order_by>;
  files_aggregate?: InputMaybe<_files_aggregate_order_by>;
  id?: InputMaybe<_order_by>;
  maxUploadFileSize?: InputMaybe<_order_by>;
  minUploadFileSize?: InputMaybe<_order_by>;
  presignedUrlsEnabled?: InputMaybe<_order_by>;
  updatedAt?: InputMaybe<_order_by>;
};

/** primary key columns input for table: storage.buckets */
export type _buckets_pk_columns_input = {
  id: Scalars["String"];
};

/** select columns of table "storage.buckets" */
export enum _buckets_select_column {
  /** column name */
  cacheControl = "cacheControl",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  downloadExpiration = "downloadExpiration",
  /** column name */
  id = "id",
  /** column name */
  maxUploadFileSize = "maxUploadFileSize",
  /** column name */
  minUploadFileSize = "minUploadFileSize",
  /** column name */
  presignedUrlsEnabled = "presignedUrlsEnabled",
  /** column name */
  updatedAt = "updatedAt",
}

/** input type for updating data in table "storage.buckets" */
export type _buckets_set_input = {
  cacheControl?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  downloadExpiration?: InputMaybe<Scalars["Int"]>;
  id?: InputMaybe<Scalars["String"]>;
  maxUploadFileSize?: InputMaybe<Scalars["Int"]>;
  minUploadFileSize?: InputMaybe<Scalars["Int"]>;
  presignedUrlsEnabled?: InputMaybe<Scalars["Boolean"]>;
  updatedAt?: InputMaybe<Scalars["_timestamptz"]>;
};

/** Streaming cursor of the table "buckets" */
export type _buckets_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: _buckets_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<_cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _buckets_stream_cursor_value_input = {
  cacheControl?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  downloadExpiration?: InputMaybe<Scalars["Int"]>;
  id?: InputMaybe<Scalars["String"]>;
  maxUploadFileSize?: InputMaybe<Scalars["Int"]>;
  minUploadFileSize?: InputMaybe<Scalars["Int"]>;
  presignedUrlsEnabled?: InputMaybe<Scalars["Boolean"]>;
  updatedAt?: InputMaybe<Scalars["_timestamptz"]>;
};

/** update columns of table "storage.buckets" */
export enum _buckets_update_column {
  /** column name */
  cacheControl = "cacheControl",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  downloadExpiration = "downloadExpiration",
  /** column name */
  id = "id",
  /** column name */
  maxUploadFileSize = "maxUploadFileSize",
  /** column name */
  minUploadFileSize = "minUploadFileSize",
  /** column name */
  presignedUrlsEnabled = "presignedUrlsEnabled",
  /** column name */
  updatedAt = "updatedAt",
}

export type _buckets_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<_buckets_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_buckets_set_input>;
  where: _buckets_bool_exp;
};

/** Boolean expression to compare columns of type "bytea". All fields are combined with logical 'AND'. */
export type _bytea_comparison_exp = {
  _eq?: InputMaybe<Scalars["_bytea"]>;
  _gt?: InputMaybe<Scalars["_bytea"]>;
  _gte?: InputMaybe<Scalars["_bytea"]>;
  _in?: InputMaybe<Array<Scalars["_bytea"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["_bytea"]>;
  _lte?: InputMaybe<Scalars["_bytea"]>;
  _neq?: InputMaybe<Scalars["_bytea"]>;
  _nin?: InputMaybe<Array<Scalars["_bytea"]>>;
};

/** Boolean expression to compare columns of type "citext". All fields are combined with logical 'AND'. */
export type _citext_comparison_exp = {
  _eq?: InputMaybe<Scalars["_citext"]>;
  _gt?: InputMaybe<Scalars["_citext"]>;
  _gte?: InputMaybe<Scalars["_citext"]>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars["_citext"]>;
  _in?: InputMaybe<Array<Scalars["_citext"]>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars["_citext"]>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars["_citext"]>;
  _lt?: InputMaybe<Scalars["_citext"]>;
  _lte?: InputMaybe<Scalars["_citext"]>;
  _neq?: InputMaybe<Scalars["_citext"]>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars["_citext"]>;
  _nin?: InputMaybe<Array<Scalars["_citext"]>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars["_citext"]>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars["_citext"]>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars["_citext"]>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars["_citext"]>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars["_citext"]>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars["_citext"]>;
};

/** ordering argument of a cursor */
export enum _cursor_ordering {
  /** ascending ordering of the cursor */
  ASC = "ASC",
  /** descending ordering of the cursor */
  DESC = "DESC",
}

export type _files_aggregate_bool_exp = {
  bool_and?: InputMaybe<_files_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<_files_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<_files_aggregate_bool_exp_count>;
};

export type _files_aggregate_bool_exp_bool_and = {
  arguments: _files_select_column_files_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<_files_bool_exp>;
  predicate: _Boolean_comparison_exp;
};

export type _files_aggregate_bool_exp_bool_or = {
  arguments: _files_select_column_files_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<_files_bool_exp>;
  predicate: _Boolean_comparison_exp;
};

export type _files_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<_files_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<_files_bool_exp>;
  predicate: _Int_comparison_exp;
};

/** order by aggregate values of table "storage.files" */
export type _files_aggregate_order_by = {
  avg?: InputMaybe<_files_avg_order_by>;
  count?: InputMaybe<_order_by>;
  max?: InputMaybe<_files_max_order_by>;
  min?: InputMaybe<_files_min_order_by>;
  stddev?: InputMaybe<_files_stddev_order_by>;
  stddev_pop?: InputMaybe<_files_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<_files_stddev_samp_order_by>;
  sum?: InputMaybe<_files_sum_order_by>;
  var_pop?: InputMaybe<_files_var_pop_order_by>;
  var_samp?: InputMaybe<_files_var_samp_order_by>;
  variance?: InputMaybe<_files_variance_order_by>;
};

/** input type for inserting array relation for remote table "storage.files" */
export type _files_arr_rel_insert_input = {
  data: Array<_files_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<_files_on_conflict>;
};

/** order by avg() on columns of table "storage.files" */
export type _files_avg_order_by = {
  size?: InputMaybe<_order_by>;
};

/** Boolean expression to filter rows from the table "storage.files". All fields are combined with a logical 'AND'. */
export type _files_bool_exp = {
  _and?: InputMaybe<Array<_files_bool_exp>>;
  _not?: InputMaybe<_files_bool_exp>;
  _or?: InputMaybe<Array<_files_bool_exp>>;
  bucket?: InputMaybe<_buckets_bool_exp>;
  bucketId?: InputMaybe<_String_comparison_exp>;
  createdAt?: InputMaybe<_timestamptz_comparison_exp>;
  etag?: InputMaybe<_String_comparison_exp>;
  id?: InputMaybe<_uuid_comparison_exp>;
  isUploaded?: InputMaybe<_Boolean_comparison_exp>;
  mimeType?: InputMaybe<_String_comparison_exp>;
  name?: InputMaybe<_String_comparison_exp>;
  size?: InputMaybe<_Int_comparison_exp>;
  updatedAt?: InputMaybe<_timestamptz_comparison_exp>;
  uploadedByUserId?: InputMaybe<_uuid_comparison_exp>;
};

/** unique or primary key constraints on table "storage.files" */
export enum _files_constraint {
  /** unique or primary key constraint on columns "id" */
  files_pkey = "files_pkey",
}

/** input type for incrementing numeric columns in table "storage.files" */
export type _files_inc_input = {
  size?: InputMaybe<Scalars["Int"]>;
};

/** input type for inserting data into table "storage.files" */
export type _files_insert_input = {
  bucket?: InputMaybe<_buckets_obj_rel_insert_input>;
  bucketId?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  etag?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["_uuid"]>;
  isUploaded?: InputMaybe<Scalars["Boolean"]>;
  mimeType?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  size?: InputMaybe<Scalars["Int"]>;
  updatedAt?: InputMaybe<Scalars["_timestamptz"]>;
  uploadedByUserId?: InputMaybe<Scalars["_uuid"]>;
};

/** order by max() on columns of table "storage.files" */
export type _files_max_order_by = {
  bucketId?: InputMaybe<_order_by>;
  createdAt?: InputMaybe<_order_by>;
  etag?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  mimeType?: InputMaybe<_order_by>;
  name?: InputMaybe<_order_by>;
  size?: InputMaybe<_order_by>;
  updatedAt?: InputMaybe<_order_by>;
  uploadedByUserId?: InputMaybe<_order_by>;
};

/** order by min() on columns of table "storage.files" */
export type _files_min_order_by = {
  bucketId?: InputMaybe<_order_by>;
  createdAt?: InputMaybe<_order_by>;
  etag?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  mimeType?: InputMaybe<_order_by>;
  name?: InputMaybe<_order_by>;
  size?: InputMaybe<_order_by>;
  updatedAt?: InputMaybe<_order_by>;
  uploadedByUserId?: InputMaybe<_order_by>;
};

/** on_conflict condition type for table "storage.files" */
export type _files_on_conflict = {
  constraint: _files_constraint;
  update_columns?: Array<_files_update_column>;
  where?: InputMaybe<_files_bool_exp>;
};

/** Ordering options when selecting data from "storage.files". */
export type _files_order_by = {
  bucket?: InputMaybe<_buckets_order_by>;
  bucketId?: InputMaybe<_order_by>;
  createdAt?: InputMaybe<_order_by>;
  etag?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  isUploaded?: InputMaybe<_order_by>;
  mimeType?: InputMaybe<_order_by>;
  name?: InputMaybe<_order_by>;
  size?: InputMaybe<_order_by>;
  updatedAt?: InputMaybe<_order_by>;
  uploadedByUserId?: InputMaybe<_order_by>;
};

/** primary key columns input for table: storage.files */
export type _files_pk_columns_input = {
  id: Scalars["_uuid"];
};

/** select columns of table "storage.files" */
export enum _files_select_column {
  /** column name */
  bucketId = "bucketId",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  etag = "etag",
  /** column name */
  id = "id",
  /** column name */
  isUploaded = "isUploaded",
  /** column name */
  mimeType = "mimeType",
  /** column name */
  name = "name",
  /** column name */
  size = "size",
  /** column name */
  updatedAt = "updatedAt",
  /** column name */
  uploadedByUserId = "uploadedByUserId",
}

/** select "files_aggregate_bool_exp_bool_and_arguments_columns" columns of table "storage.files" */
export enum _files_select_column_files_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  isUploaded = "isUploaded",
}

/** select "files_aggregate_bool_exp_bool_or_arguments_columns" columns of table "storage.files" */
export enum _files_select_column_files_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  isUploaded = "isUploaded",
}

/** input type for updating data in table "storage.files" */
export type _files_set_input = {
  bucketId?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  etag?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["_uuid"]>;
  isUploaded?: InputMaybe<Scalars["Boolean"]>;
  mimeType?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  size?: InputMaybe<Scalars["Int"]>;
  updatedAt?: InputMaybe<Scalars["_timestamptz"]>;
  uploadedByUserId?: InputMaybe<Scalars["_uuid"]>;
};

/** order by stddev() on columns of table "storage.files" */
export type _files_stddev_order_by = {
  size?: InputMaybe<_order_by>;
};

/** order by stddev_pop() on columns of table "storage.files" */
export type _files_stddev_pop_order_by = {
  size?: InputMaybe<_order_by>;
};

/** order by stddev_samp() on columns of table "storage.files" */
export type _files_stddev_samp_order_by = {
  size?: InputMaybe<_order_by>;
};

/** Streaming cursor of the table "files" */
export type _files_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: _files_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<_cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _files_stream_cursor_value_input = {
  bucketId?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  etag?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["_uuid"]>;
  isUploaded?: InputMaybe<Scalars["Boolean"]>;
  mimeType?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  size?: InputMaybe<Scalars["Int"]>;
  updatedAt?: InputMaybe<Scalars["_timestamptz"]>;
  uploadedByUserId?: InputMaybe<Scalars["_uuid"]>;
};

/** order by sum() on columns of table "storage.files" */
export type _files_sum_order_by = {
  size?: InputMaybe<_order_by>;
};

/** update columns of table "storage.files" */
export enum _files_update_column {
  /** column name */
  bucketId = "bucketId",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  etag = "etag",
  /** column name */
  id = "id",
  /** column name */
  isUploaded = "isUploaded",
  /** column name */
  mimeType = "mimeType",
  /** column name */
  name = "name",
  /** column name */
  size = "size",
  /** column name */
  updatedAt = "updatedAt",
  /** column name */
  uploadedByUserId = "uploadedByUserId",
}

export type _files_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<_files_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_files_set_input>;
  where: _files_bool_exp;
};

/** order by var_pop() on columns of table "storage.files" */
export type _files_var_pop_order_by = {
  size?: InputMaybe<_order_by>;
};

/** order by var_samp() on columns of table "storage.files" */
export type _files_var_samp_order_by = {
  size?: InputMaybe<_order_by>;
};

/** order by variance() on columns of table "storage.files" */
export type _files_variance_order_by = {
  size?: InputMaybe<_order_by>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type _float8_comparison_exp = {
  _eq?: InputMaybe<Scalars["_float8"]>;
  _gt?: InputMaybe<Scalars["_float8"]>;
  _gte?: InputMaybe<Scalars["_float8"]>;
  _in?: InputMaybe<Array<Scalars["_float8"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["_float8"]>;
  _lte?: InputMaybe<Scalars["_float8"]>;
  _neq?: InputMaybe<Scalars["_float8"]>;
  _nin?: InputMaybe<Array<Scalars["_float8"]>>;
};

export type _jsonb_cast_exp = {
  String?: InputMaybe<_String_comparison_exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type _jsonb_comparison_exp = {
  _cast?: InputMaybe<_jsonb_cast_exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars["_jsonb"]>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars["_jsonb"]>;
  _eq?: InputMaybe<Scalars["_jsonb"]>;
  _gt?: InputMaybe<Scalars["_jsonb"]>;
  _gte?: InputMaybe<Scalars["_jsonb"]>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars["String"]>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars["String"]>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars["String"]>>;
  _in?: InputMaybe<Array<Scalars["_jsonb"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["_jsonb"]>;
  _lte?: InputMaybe<Scalars["_jsonb"]>;
  _neq?: InputMaybe<Scalars["_jsonb"]>;
  _nin?: InputMaybe<Array<Scalars["_jsonb"]>>;
};

/** column ordering options */
export enum _order_by {
  /** in ascending order, nulls last */
  asc = "asc",
  /** in ascending order, nulls first */
  asc_nulls_first = "asc_nulls_first",
  /** in ascending order, nulls last */
  asc_nulls_last = "asc_nulls_last",
  /** in descending order, nulls first */
  desc = "desc",
  /** in descending order, nulls first */
  desc_nulls_first = "desc_nulls_first",
  /** in descending order, nulls last */
  desc_nulls_last = "desc_nulls_last",
}

/** Boolean expression to filter rows from the table "revtron_companies". All fields are combined with a logical 'AND'. */
export type _revtron_companies_bool_exp = {
  _and?: InputMaybe<Array<_revtron_companies_bool_exp>>;
  _not?: InputMaybe<_revtron_companies_bool_exp>;
  _or?: InputMaybe<Array<_revtron_companies_bool_exp>>;
  address?: InputMaybe<_String_comparison_exp>;
  city?: InputMaybe<_String_comparison_exp>;
  country?: InputMaybe<_String_comparison_exp>;
  created_at?: InputMaybe<_timestamp_comparison_exp>;
  employee_counts?: InputMaybe<_bigint_comparison_exp>;
  founded_year?: InputMaybe<_Int_comparison_exp>;
  id?: InputMaybe<_Int_comparison_exp>;
  industry?: InputMaybe<_String_comparison_exp>;
  linkedin?: InputMaybe<_String_comparison_exp>;
  naics?: InputMaybe<_Int_comparison_exp>;
  name?: InputMaybe<_String_comparison_exp>;
  natural_name?: InputMaybe<_String_comparison_exp>;
  phone?: InputMaybe<_String_comparison_exp>;
  revenue?: InputMaybe<_bigint_comparison_exp>;
  state?: InputMaybe<_String_comparison_exp>;
  sub_industry?: InputMaybe<_String_comparison_exp>;
  tags?: InputMaybe<_String_comparison_exp>;
  ticker?: InputMaybe<_String_comparison_exp>;
  type?: InputMaybe<_String_comparison_exp>;
  updated_at?: InputMaybe<_timestamp_comparison_exp>;
  website?: InputMaybe<_String_comparison_exp>;
  zip_code?: InputMaybe<_String_comparison_exp>;
};

/** unique or primary key constraints on table "revtron_companies" */
export enum _revtron_companies_constraint {
  /** unique or primary key constraint on columns "id" */
  revtron_account_pkey = "revtron_account_pkey",
  /** unique or primary key constraint on columns "website" */
  revtron_account_website_key = "revtron_account_website_key",
}

/** input type for incrementing numeric columns in table "revtron_companies" */
export type _revtron_companies_inc_input = {
  employee_counts?: InputMaybe<Scalars["_bigint"]>;
  founded_year?: InputMaybe<Scalars["Int"]>;
  id?: InputMaybe<Scalars["Int"]>;
  naics?: InputMaybe<Scalars["Int"]>;
  revenue?: InputMaybe<Scalars["_bigint"]>;
};

/** input type for inserting data into table "revtron_companies" */
export type _revtron_companies_insert_input = {
  address?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  created_at?: InputMaybe<Scalars["_timestamp"]>;
  employee_counts?: InputMaybe<Scalars["_bigint"]>;
  founded_year?: InputMaybe<Scalars["Int"]>;
  id?: InputMaybe<Scalars["Int"]>;
  industry?: InputMaybe<Scalars["String"]>;
  linkedin?: InputMaybe<Scalars["String"]>;
  naics?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
  natural_name?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  revenue?: InputMaybe<Scalars["_bigint"]>;
  state?: InputMaybe<Scalars["String"]>;
  sub_industry?: InputMaybe<Scalars["String"]>;
  tags?: InputMaybe<Scalars["String"]>;
  ticker?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Scalars["String"]>;
  updated_at?: InputMaybe<Scalars["_timestamp"]>;
  website?: InputMaybe<Scalars["String"]>;
  zip_code?: InputMaybe<Scalars["String"]>;
};

/** on_conflict condition type for table "revtron_companies" */
export type _revtron_companies_on_conflict = {
  constraint: _revtron_companies_constraint;
  update_columns?: Array<_revtron_companies_update_column>;
  where?: InputMaybe<_revtron_companies_bool_exp>;
};

/** Ordering options when selecting data from "revtron_companies". */
export type _revtron_companies_order_by = {
  address?: InputMaybe<_order_by>;
  city?: InputMaybe<_order_by>;
  country?: InputMaybe<_order_by>;
  created_at?: InputMaybe<_order_by>;
  employee_counts?: InputMaybe<_order_by>;
  founded_year?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  industry?: InputMaybe<_order_by>;
  linkedin?: InputMaybe<_order_by>;
  naics?: InputMaybe<_order_by>;
  name?: InputMaybe<_order_by>;
  natural_name?: InputMaybe<_order_by>;
  phone?: InputMaybe<_order_by>;
  revenue?: InputMaybe<_order_by>;
  state?: InputMaybe<_order_by>;
  sub_industry?: InputMaybe<_order_by>;
  tags?: InputMaybe<_order_by>;
  ticker?: InputMaybe<_order_by>;
  type?: InputMaybe<_order_by>;
  updated_at?: InputMaybe<_order_by>;
  website?: InputMaybe<_order_by>;
  zip_code?: InputMaybe<_order_by>;
};

/** primary key columns input for table: revtron_companies */
export type _revtron_companies_pk_columns_input = {
  id: Scalars["Int"];
};

/** select columns of table "revtron_companies" */
export enum _revtron_companies_select_column {
  /** column name */
  address = "address",
  /** column name */
  city = "city",
  /** column name */
  country = "country",
  /** column name */
  created_at = "created_at",
  /** column name */
  employee_counts = "employee_counts",
  /** column name */
  founded_year = "founded_year",
  /** column name */
  id = "id",
  /** column name */
  industry = "industry",
  /** column name */
  linkedin = "linkedin",
  /** column name */
  naics = "naics",
  /** column name */
  name = "name",
  /** column name */
  natural_name = "natural_name",
  /** column name */
  phone = "phone",
  /** column name */
  revenue = "revenue",
  /** column name */
  state = "state",
  /** column name */
  sub_industry = "sub_industry",
  /** column name */
  tags = "tags",
  /** column name */
  ticker = "ticker",
  /** column name */
  type = "type",
  /** column name */
  updated_at = "updated_at",
  /** column name */
  website = "website",
  /** column name */
  zip_code = "zip_code",
}

/** input type for updating data in table "revtron_companies" */
export type _revtron_companies_set_input = {
  address?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  created_at?: InputMaybe<Scalars["_timestamp"]>;
  employee_counts?: InputMaybe<Scalars["_bigint"]>;
  founded_year?: InputMaybe<Scalars["Int"]>;
  id?: InputMaybe<Scalars["Int"]>;
  industry?: InputMaybe<Scalars["String"]>;
  linkedin?: InputMaybe<Scalars["String"]>;
  naics?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
  natural_name?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  revenue?: InputMaybe<Scalars["_bigint"]>;
  state?: InputMaybe<Scalars["String"]>;
  sub_industry?: InputMaybe<Scalars["String"]>;
  tags?: InputMaybe<Scalars["String"]>;
  ticker?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Scalars["String"]>;
  updated_at?: InputMaybe<Scalars["_timestamp"]>;
  website?: InputMaybe<Scalars["String"]>;
  zip_code?: InputMaybe<Scalars["String"]>;
};

/** Streaming cursor of the table "revtron_companies" */
export type _revtron_companies_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: _revtron_companies_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<_cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _revtron_companies_stream_cursor_value_input = {
  address?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  created_at?: InputMaybe<Scalars["_timestamp"]>;
  employee_counts?: InputMaybe<Scalars["_bigint"]>;
  founded_year?: InputMaybe<Scalars["Int"]>;
  id?: InputMaybe<Scalars["Int"]>;
  industry?: InputMaybe<Scalars["String"]>;
  linkedin?: InputMaybe<Scalars["String"]>;
  naics?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
  natural_name?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  revenue?: InputMaybe<Scalars["_bigint"]>;
  state?: InputMaybe<Scalars["String"]>;
  sub_industry?: InputMaybe<Scalars["String"]>;
  tags?: InputMaybe<Scalars["String"]>;
  ticker?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Scalars["String"]>;
  updated_at?: InputMaybe<Scalars["_timestamp"]>;
  website?: InputMaybe<Scalars["String"]>;
  zip_code?: InputMaybe<Scalars["String"]>;
};

/** update columns of table "revtron_companies" */
export enum _revtron_companies_update_column {
  /** column name */
  address = "address",
  /** column name */
  city = "city",
  /** column name */
  country = "country",
  /** column name */
  created_at = "created_at",
  /** column name */
  employee_counts = "employee_counts",
  /** column name */
  founded_year = "founded_year",
  /** column name */
  id = "id",
  /** column name */
  industry = "industry",
  /** column name */
  linkedin = "linkedin",
  /** column name */
  naics = "naics",
  /** column name */
  name = "name",
  /** column name */
  natural_name = "natural_name",
  /** column name */
  phone = "phone",
  /** column name */
  revenue = "revenue",
  /** column name */
  state = "state",
  /** column name */
  sub_industry = "sub_industry",
  /** column name */
  tags = "tags",
  /** column name */
  ticker = "ticker",
  /** column name */
  type = "type",
  /** column name */
  updated_at = "updated_at",
  /** column name */
  website = "website",
  /** column name */
  zip_code = "zip_code",
}

export type _revtron_companies_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<_revtron_companies_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_revtron_companies_set_input>;
  where: _revtron_companies_bool_exp;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type _timestamp_comparison_exp = {
  _eq?: InputMaybe<Scalars["_timestamp"]>;
  _gt?: InputMaybe<Scalars["_timestamp"]>;
  _gte?: InputMaybe<Scalars["_timestamp"]>;
  _in?: InputMaybe<Array<Scalars["_timestamp"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["_timestamp"]>;
  _lte?: InputMaybe<Scalars["_timestamp"]>;
  _neq?: InputMaybe<Scalars["_timestamp"]>;
  _nin?: InputMaybe<Array<Scalars["_timestamp"]>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type _timestamptz_comparison_exp = {
  _eq?: InputMaybe<Scalars["_timestamptz"]>;
  _gt?: InputMaybe<Scalars["_timestamptz"]>;
  _gte?: InputMaybe<Scalars["_timestamptz"]>;
  _in?: InputMaybe<Array<Scalars["_timestamptz"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["_timestamptz"]>;
  _lte?: InputMaybe<Scalars["_timestamptz"]>;
  _neq?: InputMaybe<Scalars["_timestamptz"]>;
  _nin?: InputMaybe<Array<Scalars["_timestamptz"]>>;
};

export type _users_aggregate_bool_exp = {
  bool_and?: InputMaybe<_users_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<_users_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<_users_aggregate_bool_exp_count>;
};

export type _users_aggregate_bool_exp_bool_and = {
  arguments: _users_select_column_users_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<_users_bool_exp>;
  predicate: _Boolean_comparison_exp;
};

export type _users_aggregate_bool_exp_bool_or = {
  arguments: _users_select_column_users_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<_users_bool_exp>;
  predicate: _Boolean_comparison_exp;
};

export type _users_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<_users_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<_users_bool_exp>;
  predicate: _Int_comparison_exp;
};

/** order by aggregate values of table "auth.users" */
export type _users_aggregate_order_by = {
  count?: InputMaybe<_order_by>;
  max?: InputMaybe<_users_max_order_by>;
  min?: InputMaybe<_users_min_order_by>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type _users_append_input = {
  metadata?: InputMaybe<Scalars["_jsonb"]>;
};

/** input type for inserting array relation for remote table "auth.users" */
export type _users_arr_rel_insert_input = {
  data: Array<_users_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<_users_on_conflict>;
};

/** Boolean expression to filter rows from the table "auth.users". All fields are combined with a logical 'AND'. */
export type _users_bool_exp = {
  _and?: InputMaybe<Array<_users_bool_exp>>;
  _not?: InputMaybe<_users_bool_exp>;
  _or?: InputMaybe<Array<_users_bool_exp>>;
  activeMfaType?: InputMaybe<_String_comparison_exp>;
  avatarUrl?: InputMaybe<_String_comparison_exp>;
  createdAt?: InputMaybe<_timestamptz_comparison_exp>;
  currentChallenge?: InputMaybe<_String_comparison_exp>;
  defaultRole?: InputMaybe<_String_comparison_exp>;
  defaultRoleByRole?: InputMaybe<_authRoles_bool_exp>;
  disabled?: InputMaybe<_Boolean_comparison_exp>;
  displayName?: InputMaybe<_String_comparison_exp>;
  email?: InputMaybe<_citext_comparison_exp>;
  emailVerified?: InputMaybe<_Boolean_comparison_exp>;
  id?: InputMaybe<_uuid_comparison_exp>;
  isAnonymous?: InputMaybe<_Boolean_comparison_exp>;
  lastSeen?: InputMaybe<_timestamptz_comparison_exp>;
  locale?: InputMaybe<_String_comparison_exp>;
  metadata?: InputMaybe<_jsonb_comparison_exp>;
  newEmail?: InputMaybe<_citext_comparison_exp>;
  otpHash?: InputMaybe<_String_comparison_exp>;
  otpHashExpiresAt?: InputMaybe<_timestamptz_comparison_exp>;
  otpMethodLastUsed?: InputMaybe<_String_comparison_exp>;
  passwordHash?: InputMaybe<_String_comparison_exp>;
  phoneNumber?: InputMaybe<_String_comparison_exp>;
  phoneNumberVerified?: InputMaybe<_Boolean_comparison_exp>;
  refreshTokens?: InputMaybe<_authRefreshTokens_bool_exp>;
  refreshTokens_aggregate?: InputMaybe<_authRefreshTokens_aggregate_bool_exp>;
  roles?: InputMaybe<_authUserRoles_bool_exp>;
  roles_aggregate?: InputMaybe<_authUserRoles_aggregate_bool_exp>;
  securityKeys?: InputMaybe<_authUserSecurityKeys_bool_exp>;
  securityKeys_aggregate?: InputMaybe<_authUserSecurityKeys_aggregate_bool_exp>;
  ticket?: InputMaybe<_String_comparison_exp>;
  ticketExpiresAt?: InputMaybe<_timestamptz_comparison_exp>;
  totpSecret?: InputMaybe<_String_comparison_exp>;
  updatedAt?: InputMaybe<_timestamptz_comparison_exp>;
  userProviders?: InputMaybe<_authUserProviders_bool_exp>;
  userProviders_aggregate?: InputMaybe<_authUserProviders_aggregate_bool_exp>;
};

/** unique or primary key constraints on table "auth.users" */
export enum _users_constraint {
  /** unique or primary key constraint on columns "email" */
  users_email_key = "users_email_key",
  /** unique or primary key constraint on columns "phone_number" */
  users_phone_number_key = "users_phone_number_key",
  /** unique or primary key constraint on columns "id" */
  users_pkey = "users_pkey",
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type _users_delete_at_path_input = {
  metadata?: InputMaybe<Array<Scalars["String"]>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type _users_delete_elem_input = {
  metadata?: InputMaybe<Scalars["Int"]>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type _users_delete_key_input = {
  metadata?: InputMaybe<Scalars["String"]>;
};

/** input type for inserting data into table "auth.users" */
export type _users_insert_input = {
  activeMfaType?: InputMaybe<Scalars["String"]>;
  avatarUrl?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  currentChallenge?: InputMaybe<Scalars["String"]>;
  defaultRole?: InputMaybe<Scalars["String"]>;
  defaultRoleByRole?: InputMaybe<_authRoles_obj_rel_insert_input>;
  disabled?: InputMaybe<Scalars["Boolean"]>;
  displayName?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["_citext"]>;
  emailVerified?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["_uuid"]>;
  isAnonymous?: InputMaybe<Scalars["Boolean"]>;
  lastSeen?: InputMaybe<Scalars["_timestamptz"]>;
  locale?: InputMaybe<Scalars["String"]>;
  metadata?: InputMaybe<Scalars["_jsonb"]>;
  newEmail?: InputMaybe<Scalars["_citext"]>;
  otpHash?: InputMaybe<Scalars["String"]>;
  otpHashExpiresAt?: InputMaybe<Scalars["_timestamptz"]>;
  otpMethodLastUsed?: InputMaybe<Scalars["String"]>;
  passwordHash?: InputMaybe<Scalars["String"]>;
  phoneNumber?: InputMaybe<Scalars["String"]>;
  phoneNumberVerified?: InputMaybe<Scalars["Boolean"]>;
  refreshTokens?: InputMaybe<_authRefreshTokens_arr_rel_insert_input>;
  roles?: InputMaybe<_authUserRoles_arr_rel_insert_input>;
  securityKeys?: InputMaybe<_authUserSecurityKeys_arr_rel_insert_input>;
  ticket?: InputMaybe<Scalars["String"]>;
  ticketExpiresAt?: InputMaybe<Scalars["_timestamptz"]>;
  totpSecret?: InputMaybe<Scalars["String"]>;
  updatedAt?: InputMaybe<Scalars["_timestamptz"]>;
  userProviders?: InputMaybe<_authUserProviders_arr_rel_insert_input>;
};

/** order by max() on columns of table "auth.users" */
export type _users_max_order_by = {
  activeMfaType?: InputMaybe<_order_by>;
  avatarUrl?: InputMaybe<_order_by>;
  createdAt?: InputMaybe<_order_by>;
  currentChallenge?: InputMaybe<_order_by>;
  defaultRole?: InputMaybe<_order_by>;
  displayName?: InputMaybe<_order_by>;
  email?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  lastSeen?: InputMaybe<_order_by>;
  locale?: InputMaybe<_order_by>;
  newEmail?: InputMaybe<_order_by>;
  otpHash?: InputMaybe<_order_by>;
  otpHashExpiresAt?: InputMaybe<_order_by>;
  otpMethodLastUsed?: InputMaybe<_order_by>;
  passwordHash?: InputMaybe<_order_by>;
  phoneNumber?: InputMaybe<_order_by>;
  ticket?: InputMaybe<_order_by>;
  ticketExpiresAt?: InputMaybe<_order_by>;
  totpSecret?: InputMaybe<_order_by>;
  updatedAt?: InputMaybe<_order_by>;
};

/** order by min() on columns of table "auth.users" */
export type _users_min_order_by = {
  activeMfaType?: InputMaybe<_order_by>;
  avatarUrl?: InputMaybe<_order_by>;
  createdAt?: InputMaybe<_order_by>;
  currentChallenge?: InputMaybe<_order_by>;
  defaultRole?: InputMaybe<_order_by>;
  displayName?: InputMaybe<_order_by>;
  email?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  lastSeen?: InputMaybe<_order_by>;
  locale?: InputMaybe<_order_by>;
  newEmail?: InputMaybe<_order_by>;
  otpHash?: InputMaybe<_order_by>;
  otpHashExpiresAt?: InputMaybe<_order_by>;
  otpMethodLastUsed?: InputMaybe<_order_by>;
  passwordHash?: InputMaybe<_order_by>;
  phoneNumber?: InputMaybe<_order_by>;
  ticket?: InputMaybe<_order_by>;
  ticketExpiresAt?: InputMaybe<_order_by>;
  totpSecret?: InputMaybe<_order_by>;
  updatedAt?: InputMaybe<_order_by>;
};

/** input type for inserting object relation for remote table "auth.users" */
export type _users_obj_rel_insert_input = {
  data: _users_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<_users_on_conflict>;
};

/** on_conflict condition type for table "auth.users" */
export type _users_on_conflict = {
  constraint: _users_constraint;
  update_columns?: Array<_users_update_column>;
  where?: InputMaybe<_users_bool_exp>;
};

/** Ordering options when selecting data from "auth.users". */
export type _users_order_by = {
  activeMfaType?: InputMaybe<_order_by>;
  avatarUrl?: InputMaybe<_order_by>;
  createdAt?: InputMaybe<_order_by>;
  currentChallenge?: InputMaybe<_order_by>;
  defaultRole?: InputMaybe<_order_by>;
  defaultRoleByRole?: InputMaybe<_authRoles_order_by>;
  disabled?: InputMaybe<_order_by>;
  displayName?: InputMaybe<_order_by>;
  email?: InputMaybe<_order_by>;
  emailVerified?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  isAnonymous?: InputMaybe<_order_by>;
  lastSeen?: InputMaybe<_order_by>;
  locale?: InputMaybe<_order_by>;
  metadata?: InputMaybe<_order_by>;
  newEmail?: InputMaybe<_order_by>;
  otpHash?: InputMaybe<_order_by>;
  otpHashExpiresAt?: InputMaybe<_order_by>;
  otpMethodLastUsed?: InputMaybe<_order_by>;
  passwordHash?: InputMaybe<_order_by>;
  phoneNumber?: InputMaybe<_order_by>;
  phoneNumberVerified?: InputMaybe<_order_by>;
  refreshTokens_aggregate?: InputMaybe<_authRefreshTokens_aggregate_order_by>;
  roles_aggregate?: InputMaybe<_authUserRoles_aggregate_order_by>;
  securityKeys_aggregate?: InputMaybe<_authUserSecurityKeys_aggregate_order_by>;
  ticket?: InputMaybe<_order_by>;
  ticketExpiresAt?: InputMaybe<_order_by>;
  totpSecret?: InputMaybe<_order_by>;
  updatedAt?: InputMaybe<_order_by>;
  userProviders_aggregate?: InputMaybe<_authUserProviders_aggregate_order_by>;
};

/** primary key columns input for table: auth.users */
export type _users_pk_columns_input = {
  id: Scalars["_uuid"];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type _users_prepend_input = {
  metadata?: InputMaybe<Scalars["_jsonb"]>;
};

/** select columns of table "auth.users" */
export enum _users_select_column {
  /** column name */
  activeMfaType = "activeMfaType",
  /** column name */
  avatarUrl = "avatarUrl",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  currentChallenge = "currentChallenge",
  /** column name */
  defaultRole = "defaultRole",
  /** column name */
  disabled = "disabled",
  /** column name */
  displayName = "displayName",
  /** column name */
  email = "email",
  /** column name */
  emailVerified = "emailVerified",
  /** column name */
  id = "id",
  /** column name */
  isAnonymous = "isAnonymous",
  /** column name */
  lastSeen = "lastSeen",
  /** column name */
  locale = "locale",
  /** column name */
  metadata = "metadata",
  /** column name */
  newEmail = "newEmail",
  /** column name */
  otpHash = "otpHash",
  /** column name */
  otpHashExpiresAt = "otpHashExpiresAt",
  /** column name */
  otpMethodLastUsed = "otpMethodLastUsed",
  /** column name */
  passwordHash = "passwordHash",
  /** column name */
  phoneNumber = "phoneNumber",
  /** column name */
  phoneNumberVerified = "phoneNumberVerified",
  /** column name */
  ticket = "ticket",
  /** column name */
  ticketExpiresAt = "ticketExpiresAt",
  /** column name */
  totpSecret = "totpSecret",
  /** column name */
  updatedAt = "updatedAt",
}

/** select "users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "auth.users" */
export enum _users_select_column_users_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  disabled = "disabled",
  /** column name */
  emailVerified = "emailVerified",
  /** column name */
  isAnonymous = "isAnonymous",
  /** column name */
  phoneNumberVerified = "phoneNumberVerified",
}

/** select "users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "auth.users" */
export enum _users_select_column_users_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  disabled = "disabled",
  /** column name */
  emailVerified = "emailVerified",
  /** column name */
  isAnonymous = "isAnonymous",
  /** column name */
  phoneNumberVerified = "phoneNumberVerified",
}

/** input type for updating data in table "auth.users" */
export type _users_set_input = {
  activeMfaType?: InputMaybe<Scalars["String"]>;
  avatarUrl?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  currentChallenge?: InputMaybe<Scalars["String"]>;
  defaultRole?: InputMaybe<Scalars["String"]>;
  disabled?: InputMaybe<Scalars["Boolean"]>;
  displayName?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["_citext"]>;
  emailVerified?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["_uuid"]>;
  isAnonymous?: InputMaybe<Scalars["Boolean"]>;
  lastSeen?: InputMaybe<Scalars["_timestamptz"]>;
  locale?: InputMaybe<Scalars["String"]>;
  metadata?: InputMaybe<Scalars["_jsonb"]>;
  newEmail?: InputMaybe<Scalars["_citext"]>;
  otpHash?: InputMaybe<Scalars["String"]>;
  otpHashExpiresAt?: InputMaybe<Scalars["_timestamptz"]>;
  otpMethodLastUsed?: InputMaybe<Scalars["String"]>;
  passwordHash?: InputMaybe<Scalars["String"]>;
  phoneNumber?: InputMaybe<Scalars["String"]>;
  phoneNumberVerified?: InputMaybe<Scalars["Boolean"]>;
  ticket?: InputMaybe<Scalars["String"]>;
  ticketExpiresAt?: InputMaybe<Scalars["_timestamptz"]>;
  totpSecret?: InputMaybe<Scalars["String"]>;
  updatedAt?: InputMaybe<Scalars["_timestamptz"]>;
};

/** Streaming cursor of the table "users" */
export type _users_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: _users_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<_cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _users_stream_cursor_value_input = {
  activeMfaType?: InputMaybe<Scalars["String"]>;
  avatarUrl?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  currentChallenge?: InputMaybe<Scalars["String"]>;
  defaultRole?: InputMaybe<Scalars["String"]>;
  disabled?: InputMaybe<Scalars["Boolean"]>;
  displayName?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["_citext"]>;
  emailVerified?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["_uuid"]>;
  isAnonymous?: InputMaybe<Scalars["Boolean"]>;
  lastSeen?: InputMaybe<Scalars["_timestamptz"]>;
  locale?: InputMaybe<Scalars["String"]>;
  metadata?: InputMaybe<Scalars["_jsonb"]>;
  newEmail?: InputMaybe<Scalars["_citext"]>;
  otpHash?: InputMaybe<Scalars["String"]>;
  otpHashExpiresAt?: InputMaybe<Scalars["_timestamptz"]>;
  otpMethodLastUsed?: InputMaybe<Scalars["String"]>;
  passwordHash?: InputMaybe<Scalars["String"]>;
  phoneNumber?: InputMaybe<Scalars["String"]>;
  phoneNumberVerified?: InputMaybe<Scalars["Boolean"]>;
  ticket?: InputMaybe<Scalars["String"]>;
  ticketExpiresAt?: InputMaybe<Scalars["_timestamptz"]>;
  totpSecret?: InputMaybe<Scalars["String"]>;
  updatedAt?: InputMaybe<Scalars["_timestamptz"]>;
};

/** update columns of table "auth.users" */
export enum _users_update_column {
  /** column name */
  activeMfaType = "activeMfaType",
  /** column name */
  avatarUrl = "avatarUrl",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  currentChallenge = "currentChallenge",
  /** column name */
  defaultRole = "defaultRole",
  /** column name */
  disabled = "disabled",
  /** column name */
  displayName = "displayName",
  /** column name */
  email = "email",
  /** column name */
  emailVerified = "emailVerified",
  /** column name */
  id = "id",
  /** column name */
  isAnonymous = "isAnonymous",
  /** column name */
  lastSeen = "lastSeen",
  /** column name */
  locale = "locale",
  /** column name */
  metadata = "metadata",
  /** column name */
  newEmail = "newEmail",
  /** column name */
  otpHash = "otpHash",
  /** column name */
  otpHashExpiresAt = "otpHashExpiresAt",
  /** column name */
  otpMethodLastUsed = "otpMethodLastUsed",
  /** column name */
  passwordHash = "passwordHash",
  /** column name */
  phoneNumber = "phoneNumber",
  /** column name */
  phoneNumberVerified = "phoneNumberVerified",
  /** column name */
  ticket = "ticket",
  /** column name */
  ticketExpiresAt = "ticketExpiresAt",
  /** column name */
  totpSecret = "totpSecret",
  /** column name */
  updatedAt = "updatedAt",
}

export type _users_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<_users_append_input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<_users_delete_at_path_input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<_users_delete_elem_input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<_users_delete_key_input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<_users_prepend_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_users_set_input>;
  where: _users_bool_exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type _uuid_comparison_exp = {
  _eq?: InputMaybe<Scalars["_uuid"]>;
  _gt?: InputMaybe<Scalars["_uuid"]>;
  _gte?: InputMaybe<Scalars["_uuid"]>;
  _in?: InputMaybe<Array<Scalars["_uuid"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["_uuid"]>;
  _lte?: InputMaybe<Scalars["_uuid"]>;
  _neq?: InputMaybe<Scalars["_uuid"]>;
  _nin?: InputMaybe<Array<Scalars["_uuid"]>>;
};

/** Boolean expression to filter rows from the table "waitlist". All fields are combined with a logical 'AND'. */
export type _waitlist_bool_exp = {
  _and?: InputMaybe<Array<_waitlist_bool_exp>>;
  _not?: InputMaybe<_waitlist_bool_exp>;
  _or?: InputMaybe<Array<_waitlist_bool_exp>>;
  created_at?: InputMaybe<_timestamptz_comparison_exp>;
  email?: InputMaybe<_citext_comparison_exp>;
  id?: InputMaybe<_bigint_comparison_exp>;
};

/** unique or primary key constraints on table "waitlist" */
export enum _waitlist_constraint {
  /** unique or primary key constraint on columns "id" */
  waitlist_pkey = "waitlist_pkey",
}

/** input type for incrementing numeric columns in table "waitlist" */
export type _waitlist_inc_input = {
  id?: InputMaybe<Scalars["_bigint"]>;
};

/** input type for inserting data into table "waitlist" */
export type _waitlist_insert_input = {
  created_at?: InputMaybe<Scalars["_timestamptz"]>;
  email?: InputMaybe<Scalars["_citext"]>;
  id?: InputMaybe<Scalars["_bigint"]>;
};

/** on_conflict condition type for table "waitlist" */
export type _waitlist_on_conflict = {
  constraint: _waitlist_constraint;
  update_columns?: Array<_waitlist_update_column>;
  where?: InputMaybe<_waitlist_bool_exp>;
};

/** Ordering options when selecting data from "waitlist". */
export type _waitlist_order_by = {
  created_at?: InputMaybe<_order_by>;
  email?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
};

/** primary key columns input for table: waitlist */
export type _waitlist_pk_columns_input = {
  id: Scalars["_bigint"];
};

/** select columns of table "waitlist" */
export enum _waitlist_select_column {
  /** column name */
  created_at = "created_at",
  /** column name */
  email = "email",
  /** column name */
  id = "id",
}

/** input type for updating data in table "waitlist" */
export type _waitlist_set_input = {
  created_at?: InputMaybe<Scalars["_timestamptz"]>;
  email?: InputMaybe<Scalars["_citext"]>;
  id?: InputMaybe<Scalars["_bigint"]>;
};

/** Streaming cursor of the table "waitlist" */
export type _waitlist_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: _waitlist_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<_cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _waitlist_stream_cursor_value_input = {
  created_at?: InputMaybe<Scalars["_timestamptz"]>;
  email?: InputMaybe<Scalars["_citext"]>;
  id?: InputMaybe<Scalars["_bigint"]>;
};

/** update columns of table "waitlist" */
export enum _waitlist_update_column {
  /** column name */
  created_at = "created_at",
  /** column name */
  email = "email",
  /** column name */
  id = "id",
}

export type _waitlist_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<_waitlist_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_waitlist_set_input>;
  where: _waitlist_bool_exp;
};

/** Boolean expression to filter rows from the table "account__c". All fields are combined with a logical 'AND'. */
export type account__c_bool_exp = {
  _and?: InputMaybe<Array<account__c_bool_exp>>;
  _not?: InputMaybe<account__c_bool_exp>;
  _or?: InputMaybe<Array<account__c_bool_exp>>;
  account_id__c?: InputMaybe<String_comparison_exp>;
  account_manager__c?: InputMaybe<String_comparison_exp>;
  account_notes__c?: InputMaybe<String_comparison_exp>;
  account_status_auto__c?: InputMaybe<String_comparison_exp>;
  annual_support_hours__c?: InputMaybe<String_comparison_exp>;
  api_access__c?: InputMaybe<Boolean_comparison_exp>;
  api_nps__c?: InputMaybe<numeric_comparison_exp>;
  ats__c?: InputMaybe<Boolean_comparison_exp>;
  ats_arr__c?: InputMaybe<numeric_comparison_exp>;
  auto_renewal_2__c?: InputMaybe<Boolean_comparison_exp>;
  auto_renewal__c?: InputMaybe<Boolean_comparison_exp>;
  average_nps__c?: InputMaybe<numeric_comparison_exp>;
  awardview__c?: InputMaybe<Boolean_comparison_exp>;
  awardview_arr__c?: InputMaybe<numeric_comparison_exp>;
  awardview_engagement_manager__c?: InputMaybe<String_comparison_exp>;
  awardview_ps_team__c?: InputMaybe<String_comparison_exp>;
  awardview_renewal_date__c?: InputMaybe<timestamp_comparison_exp>;
  awardview_start_date__c?: InputMaybe<timestamp_comparison_exp>;
  awardview_support_hours__c?: InputMaybe<numeric_comparison_exp>;
  base_licenses__c?: InputMaybe<numeric_comparison_exp>;
  billing_amount_2__c?: InputMaybe<String_comparison_exp>;
  billing_amount__c?: InputMaybe<String_comparison_exp>;
  billing_currency__c?: InputMaybe<String_comparison_exp>;
  billing_etc__c?: InputMaybe<String_comparison_exp>;
  billing_notes__c?: InputMaybe<String_comparison_exp>;
  billing_terms_2__c?: InputMaybe<String_comparison_exp>;
  billing_terms__c?: InputMaybe<String_comparison_exp>;
  churn_date__c?: InputMaybe<timestamp_comparison_exp>;
  client_number__c?: InputMaybe<String_comparison_exp>;
  client_self_service__c?: InputMaybe<numeric_comparison_exp>;
  client_start_date__c?: InputMaybe<timestamp_comparison_exp>;
  close_date__c?: InputMaybe<timestamp_comparison_exp>;
  compensation_system_in_place__c?: InputMaybe<String_comparison_exp>;
  compview__c?: InputMaybe<Boolean_comparison_exp>;
  compview_arr__c?: InputMaybe<numeric_comparison_exp>;
  compview_engagement_manager__c?: InputMaybe<String_comparison_exp>;
  compview_ps_team__c?: InputMaybe<String_comparison_exp>;
  compview_renewal_date__c?: InputMaybe<timestamp_comparison_exp>;
  compview_start_date__c?: InputMaybe<timestamp_comparison_exp>;
  compview_support_hours__c?: InputMaybe<numeric_comparison_exp>;
  configurability__c?: InputMaybe<numeric_comparison_exp>;
  contentview__c?: InputMaybe<Boolean_comparison_exp>;
  contentview_arr__c?: InputMaybe<numeric_comparison_exp>;
  contentview_engagement_manager__c?: InputMaybe<String_comparison_exp>;
  contentview_ps_team__c?: InputMaybe<String_comparison_exp>;
  contentview_renewal_date__c?: InputMaybe<timestamp_comparison_exp>;
  contentview_start_date__c?: InputMaybe<timestamp_comparison_exp>;
  contentview_support_hours__c?: InputMaybe<numeric_comparison_exp>;
  contract_etc__c?: InputMaybe<Boolean_comparison_exp>;
  contract_start_date__c?: InputMaybe<timestamp_comparison_exp>;
  contract_total_value__c?: InputMaybe<String_comparison_exp>;
  contract_uat_delivery_estimate__c?: InputMaybe<timestamp_comparison_exp>;
  current_active__c?: InputMaybe<numeric_comparison_exp>;
  current_end_date__c?: InputMaybe<timestamp_comparison_exp>;
  customer_lifecycle_stage__c?: InputMaybe<String_comparison_exp>;
  data_center_location__c?: InputMaybe<String_comparison_exp>;
  data_feeds__c?: InputMaybe<numeric_comparison_exp>;
  date_las__c?: InputMaybe<timestamp_comparison_exp>;
  delivery_assurance__c?: InputMaybe<numeric_comparison_exp>;
  domain__c?: InputMaybe<String_comparison_exp>;
  founded_year__c?: InputMaybe<String_comparison_exp>;
  g2_buyer_intent_details__c?: InputMaybe<String_comparison_exp>;
  g2_intent__c?: InputMaybe<Boolean_comparison_exp>;
  g2_survey_1__c?: InputMaybe<timestamp_comparison_exp>;
  g2_survey_2__c?: InputMaybe<timestamp_comparison_exp>;
  health_score__c?: InputMaybe<String_comparison_exp>;
  hr_tech__c?: InputMaybe<String_comparison_exp>;
  hris__c?: InputMaybe<String_comparison_exp>;
  hris_version__c?: InputMaybe<String_comparison_exp>;
  hubspot_company_id__c?: InputMaybe<String_comparison_exp>;
  hubspot_owner_id__c?: InputMaybe<String_comparison_exp>;
  hubspot_owner_name__c?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<String_comparison_exp>;
  incent__c?: InputMaybe<Boolean_comparison_exp>;
  incentview_arr__c?: InputMaybe<numeric_comparison_exp>;
  incentview_engagement_manager__c?: InputMaybe<String_comparison_exp>;
  incentview_ps_team__c?: InputMaybe<String_comparison_exp>;
  incentview_renewal_date__c?: InputMaybe<timestamp_comparison_exp>;
  incentview_start_date__c?: InputMaybe<timestamp_comparison_exp>;
  incentview_support_hours__c?: InputMaybe<numeric_comparison_exp>;
  international_global__c?: InputMaybe<Boolean_comparison_exp>;
  is_public__c?: InputMaybe<Boolean_comparison_exp>;
  language_paks__c?: InputMaybe<Boolean_comparison_exp>;
  language_paks_arr__c?: InputMaybe<numeric_comparison_exp>;
  last_after_action_review__c?: InputMaybe<timestamp_comparison_exp>;
  lifecycle_stage__c?: InputMaybe<String_comparison_exp>;
  linkedin_company_page__c?: InputMaybe<String_comparison_exp>;
  modelview__c?: InputMaybe<Boolean_comparison_exp>;
  modelview_arr__c?: InputMaybe<numeric_comparison_exp>;
  modelview_engagement_manager__c?: InputMaybe<String_comparison_exp>;
  modelview_ps_team__c?: InputMaybe<String_comparison_exp>;
  modelview_renewal_date__c?: InputMaybe<timestamp_comparison_exp>;
  modelview_start_date__c?: InputMaybe<timestamp_comparison_exp>;
  modelview_support_hours__c?: InputMaybe<numeric_comparison_exp>;
  naics__c?: InputMaybe<numeric_comparison_exp>;
  naics_industry_detail__c?: InputMaybe<String_comparison_exp>;
  naics_industry_title__c?: InputMaybe<String_comparison_exp>;
  number_of_users__c?: InputMaybe<String_comparison_exp>;
  ols__c?: InputMaybe<Boolean_comparison_exp>;
  ols_arr__c?: InputMaybe<numeric_comparison_exp>;
  online_statements_arr__c?: InputMaybe<numeric_comparison_exp>;
  onlinestatements__c?: InputMaybe<Boolean_comparison_exp>;
  overall_satisfaction__c?: InputMaybe<numeric_comparison_exp>;
  partnercontact__c?: InputMaybe<String_comparison_exp>;
  payview__c?: InputMaybe<Boolean_comparison_exp>;
  payview_arr__c?: InputMaybe<numeric_comparison_exp>;
  payview_engagement_manager__c?: InputMaybe<String_comparison_exp>;
  payview_ps_team__c?: InputMaybe<String_comparison_exp>;
  payview_renewal_date__c?: InputMaybe<timestamp_comparison_exp>;
  payview_start_date__c?: InputMaybe<timestamp_comparison_exp>;
  payview_support_hours__c?: InputMaybe<numeric_comparison_exp>;
  performance__c?: InputMaybe<numeric_comparison_exp>;
  performview__c?: InputMaybe<Boolean_comparison_exp>;
  performview_arr__c?: InputMaybe<numeric_comparison_exp>;
  performview_engagement_manager__c?: InputMaybe<String_comparison_exp>;
  performview_ps_team__c?: InputMaybe<String_comparison_exp>;
  performview_renewal_date__c?: InputMaybe<timestamp_comparison_exp>;
  performview_start_date__c?: InputMaybe<timestamp_comparison_exp>;
  performview_support_hours__c?: InputMaybe<numeric_comparison_exp>;
  platform_version__c?: InputMaybe<String_comparison_exp>;
  predict_proba__c?: InputMaybe<numeric_comparison_exp>;
  price_value_satisfaction__c?: InputMaybe<numeric_comparison_exp>;
  professional_services_package_program__c?: InputMaybe<Boolean_comparison_exp>;
  professional_services_rate_per_hr__c?: InputMaybe<numeric_comparison_exp>;
  recruitview__c?: InputMaybe<Boolean_comparison_exp>;
  recruitview_arr__c?: InputMaybe<numeric_comparison_exp>;
  recruitview_engagement_manager__c?: InputMaybe<String_comparison_exp>;
  recruitview_ps_team__c?: InputMaybe<String_comparison_exp>;
  recruitview_renewal_date__c?: InputMaybe<timestamp_comparison_exp>;
  recruitview_start_date__c?: InputMaybe<timestamp_comparison_exp>;
  recruitview_support_hours__c?: InputMaybe<numeric_comparison_exp>;
  reference_n__c?: InputMaybe<String_comparison_exp>;
  referenceable__c?: InputMaybe<Boolean_comparison_exp>;
  renewal_date_2__c?: InputMaybe<timestamp_comparison_exp>;
  renewal_date__c?: InputMaybe<timestamp_comparison_exp>;
  renewal_risk__c?: InputMaybe<String_comparison_exp>;
  reporting__c?: InputMaybe<numeric_comparison_exp>;
  retention_confidence__c?: InputMaybe<numeric_comparison_exp>;
  retention_risk_reasons__c?: InputMaybe<String_comparison_exp>;
  revtron_icp_score_formatted__c?: InputMaybe<numeric_comparison_exp>;
  rewardview__c?: InputMaybe<Boolean_comparison_exp>;
  rewardview_arr__c?: InputMaybe<numeric_comparison_exp>;
  rewardview_engagement_manager__c?: InputMaybe<String_comparison_exp>;
  rewardview_ps_team__c?: InputMaybe<String_comparison_exp>;
  rewardview_renewal_date__c?: InputMaybe<timestamp_comparison_exp>;
  rewardview_start_date__c?: InputMaybe<timestamp_comparison_exp>;
  rewardview_support_hours__c?: InputMaybe<numeric_comparison_exp>;
  security__c?: InputMaybe<numeric_comparison_exp>;
  segment__c?: InputMaybe<String_comparison_exp>;
  self_admin_certified__c?: InputMaybe<Boolean_comparison_exp>;
  sort_id?: InputMaybe<Int_comparison_exp>;
  sso_provider__c?: InputMaybe<String_comparison_exp>;
  support_hours_reset_date__c?: InputMaybe<timestamp_comparison_exp>;
  team_collaboration__c?: InputMaybe<numeric_comparison_exp>;
  territory__c?: InputMaybe<String_comparison_exp>;
  total_arr__c?: InputMaybe<numeric_comparison_exp>;
  total_money_raised__c?: InputMaybe<String_comparison_exp>;
  total_support_hours__c?: InputMaybe<numeric_comparison_exp>;
  ui_ux__c?: InputMaybe<numeric_comparison_exp>;
  user_conference_attended__c?: InputMaybe<String_comparison_exp>;
};

/** input type for incrementing numeric columns in table "account__c" */
export type account__c_inc_input = {
  api_nps__c?: InputMaybe<Scalars["numeric"]>;
  ats_arr__c?: InputMaybe<Scalars["numeric"]>;
  average_nps__c?: InputMaybe<Scalars["numeric"]>;
  awardview_arr__c?: InputMaybe<Scalars["numeric"]>;
  awardview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  base_licenses__c?: InputMaybe<Scalars["numeric"]>;
  client_self_service__c?: InputMaybe<Scalars["numeric"]>;
  compview_arr__c?: InputMaybe<Scalars["numeric"]>;
  compview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  configurability__c?: InputMaybe<Scalars["numeric"]>;
  contentview_arr__c?: InputMaybe<Scalars["numeric"]>;
  contentview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  current_active__c?: InputMaybe<Scalars["numeric"]>;
  data_feeds__c?: InputMaybe<Scalars["numeric"]>;
  delivery_assurance__c?: InputMaybe<Scalars["numeric"]>;
  incentview_arr__c?: InputMaybe<Scalars["numeric"]>;
  incentview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  language_paks_arr__c?: InputMaybe<Scalars["numeric"]>;
  modelview_arr__c?: InputMaybe<Scalars["numeric"]>;
  modelview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  naics__c?: InputMaybe<Scalars["numeric"]>;
  ols_arr__c?: InputMaybe<Scalars["numeric"]>;
  online_statements_arr__c?: InputMaybe<Scalars["numeric"]>;
  overall_satisfaction__c?: InputMaybe<Scalars["numeric"]>;
  payview_arr__c?: InputMaybe<Scalars["numeric"]>;
  payview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  performance__c?: InputMaybe<Scalars["numeric"]>;
  performview_arr__c?: InputMaybe<Scalars["numeric"]>;
  performview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  predict_proba__c?: InputMaybe<Scalars["numeric"]>;
  price_value_satisfaction__c?: InputMaybe<Scalars["numeric"]>;
  professional_services_rate_per_hr__c?: InputMaybe<Scalars["numeric"]>;
  recruitview_arr__c?: InputMaybe<Scalars["numeric"]>;
  recruitview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  reporting__c?: InputMaybe<Scalars["numeric"]>;
  retention_confidence__c?: InputMaybe<Scalars["numeric"]>;
  revtron_icp_score_formatted__c?: InputMaybe<Scalars["numeric"]>;
  rewardview_arr__c?: InputMaybe<Scalars["numeric"]>;
  rewardview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  security__c?: InputMaybe<Scalars["numeric"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  team_collaboration__c?: InputMaybe<Scalars["numeric"]>;
  total_arr__c?: InputMaybe<Scalars["numeric"]>;
  total_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  ui_ux__c?: InputMaybe<Scalars["numeric"]>;
};

/** input type for inserting data into table "account__c" */
export type account__c_insert_input = {
  account_id__c?: InputMaybe<Scalars["String"]>;
  account_manager__c?: InputMaybe<Scalars["String"]>;
  account_notes__c?: InputMaybe<Scalars["String"]>;
  account_status_auto__c?: InputMaybe<Scalars["String"]>;
  annual_support_hours__c?: InputMaybe<Scalars["String"]>;
  api_access__c?: InputMaybe<Scalars["Boolean"]>;
  api_nps__c?: InputMaybe<Scalars["numeric"]>;
  ats__c?: InputMaybe<Scalars["Boolean"]>;
  ats_arr__c?: InputMaybe<Scalars["numeric"]>;
  auto_renewal_2__c?: InputMaybe<Scalars["Boolean"]>;
  auto_renewal__c?: InputMaybe<Scalars["Boolean"]>;
  average_nps__c?: InputMaybe<Scalars["numeric"]>;
  awardview__c?: InputMaybe<Scalars["Boolean"]>;
  awardview_arr__c?: InputMaybe<Scalars["numeric"]>;
  awardview_engagement_manager__c?: InputMaybe<Scalars["String"]>;
  awardview_ps_team__c?: InputMaybe<Scalars["String"]>;
  awardview_renewal_date__c?: InputMaybe<Scalars["timestamp"]>;
  awardview_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  awardview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  base_licenses__c?: InputMaybe<Scalars["numeric"]>;
  billing_amount_2__c?: InputMaybe<Scalars["String"]>;
  billing_amount__c?: InputMaybe<Scalars["String"]>;
  billing_currency__c?: InputMaybe<Scalars["String"]>;
  billing_etc__c?: InputMaybe<Scalars["String"]>;
  billing_notes__c?: InputMaybe<Scalars["String"]>;
  billing_terms_2__c?: InputMaybe<Scalars["String"]>;
  billing_terms__c?: InputMaybe<Scalars["String"]>;
  churn_date__c?: InputMaybe<Scalars["timestamp"]>;
  client_number__c?: InputMaybe<Scalars["String"]>;
  client_self_service__c?: InputMaybe<Scalars["numeric"]>;
  client_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  close_date__c?: InputMaybe<Scalars["timestamp"]>;
  compensation_system_in_place__c?: InputMaybe<Scalars["String"]>;
  compview__c?: InputMaybe<Scalars["Boolean"]>;
  compview_arr__c?: InputMaybe<Scalars["numeric"]>;
  compview_engagement_manager__c?: InputMaybe<Scalars["String"]>;
  compview_ps_team__c?: InputMaybe<Scalars["String"]>;
  compview_renewal_date__c?: InputMaybe<Scalars["timestamp"]>;
  compview_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  compview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  configurability__c?: InputMaybe<Scalars["numeric"]>;
  contentview__c?: InputMaybe<Scalars["Boolean"]>;
  contentview_arr__c?: InputMaybe<Scalars["numeric"]>;
  contentview_engagement_manager__c?: InputMaybe<Scalars["String"]>;
  contentview_ps_team__c?: InputMaybe<Scalars["String"]>;
  contentview_renewal_date__c?: InputMaybe<Scalars["timestamp"]>;
  contentview_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  contentview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  contract_etc__c?: InputMaybe<Scalars["Boolean"]>;
  contract_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  contract_total_value__c?: InputMaybe<Scalars["String"]>;
  contract_uat_delivery_estimate__c?: InputMaybe<Scalars["timestamp"]>;
  current_active__c?: InputMaybe<Scalars["numeric"]>;
  current_end_date__c?: InputMaybe<Scalars["timestamp"]>;
  customer_lifecycle_stage__c?: InputMaybe<Scalars["String"]>;
  data_center_location__c?: InputMaybe<Scalars["String"]>;
  data_feeds__c?: InputMaybe<Scalars["numeric"]>;
  date_las__c?: InputMaybe<Scalars["timestamp"]>;
  delivery_assurance__c?: InputMaybe<Scalars["numeric"]>;
  domain__c?: InputMaybe<Scalars["String"]>;
  founded_year__c?: InputMaybe<Scalars["String"]>;
  g2_buyer_intent_details__c?: InputMaybe<Scalars["String"]>;
  g2_intent__c?: InputMaybe<Scalars["Boolean"]>;
  g2_survey_1__c?: InputMaybe<Scalars["timestamp"]>;
  g2_survey_2__c?: InputMaybe<Scalars["timestamp"]>;
  health_score__c?: InputMaybe<Scalars["String"]>;
  hr_tech__c?: InputMaybe<Scalars["String"]>;
  hris__c?: InputMaybe<Scalars["String"]>;
  hris_version__c?: InputMaybe<Scalars["String"]>;
  hubspot_company_id__c?: InputMaybe<Scalars["String"]>;
  hubspot_owner_id__c?: InputMaybe<Scalars["String"]>;
  hubspot_owner_name__c?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  incent__c?: InputMaybe<Scalars["Boolean"]>;
  incentview_arr__c?: InputMaybe<Scalars["numeric"]>;
  incentview_engagement_manager__c?: InputMaybe<Scalars["String"]>;
  incentview_ps_team__c?: InputMaybe<Scalars["String"]>;
  incentview_renewal_date__c?: InputMaybe<Scalars["timestamp"]>;
  incentview_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  incentview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  international_global__c?: InputMaybe<Scalars["Boolean"]>;
  is_public__c?: InputMaybe<Scalars["Boolean"]>;
  language_paks__c?: InputMaybe<Scalars["Boolean"]>;
  language_paks_arr__c?: InputMaybe<Scalars["numeric"]>;
  last_after_action_review__c?: InputMaybe<Scalars["timestamp"]>;
  lifecycle_stage__c?: InputMaybe<Scalars["String"]>;
  linkedin_company_page__c?: InputMaybe<Scalars["String"]>;
  modelview__c?: InputMaybe<Scalars["Boolean"]>;
  modelview_arr__c?: InputMaybe<Scalars["numeric"]>;
  modelview_engagement_manager__c?: InputMaybe<Scalars["String"]>;
  modelview_ps_team__c?: InputMaybe<Scalars["String"]>;
  modelview_renewal_date__c?: InputMaybe<Scalars["timestamp"]>;
  modelview_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  modelview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  naics__c?: InputMaybe<Scalars["numeric"]>;
  naics_industry_detail__c?: InputMaybe<Scalars["String"]>;
  naics_industry_title__c?: InputMaybe<Scalars["String"]>;
  number_of_users__c?: InputMaybe<Scalars["String"]>;
  ols__c?: InputMaybe<Scalars["Boolean"]>;
  ols_arr__c?: InputMaybe<Scalars["numeric"]>;
  online_statements_arr__c?: InputMaybe<Scalars["numeric"]>;
  onlinestatements__c?: InputMaybe<Scalars["Boolean"]>;
  overall_satisfaction__c?: InputMaybe<Scalars["numeric"]>;
  partnercontact__c?: InputMaybe<Scalars["String"]>;
  payview__c?: InputMaybe<Scalars["Boolean"]>;
  payview_arr__c?: InputMaybe<Scalars["numeric"]>;
  payview_engagement_manager__c?: InputMaybe<Scalars["String"]>;
  payview_ps_team__c?: InputMaybe<Scalars["String"]>;
  payview_renewal_date__c?: InputMaybe<Scalars["timestamp"]>;
  payview_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  payview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  performance__c?: InputMaybe<Scalars["numeric"]>;
  performview__c?: InputMaybe<Scalars["Boolean"]>;
  performview_arr__c?: InputMaybe<Scalars["numeric"]>;
  performview_engagement_manager__c?: InputMaybe<Scalars["String"]>;
  performview_ps_team__c?: InputMaybe<Scalars["String"]>;
  performview_renewal_date__c?: InputMaybe<Scalars["timestamp"]>;
  performview_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  performview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  platform_version__c?: InputMaybe<Scalars["String"]>;
  predict_proba__c?: InputMaybe<Scalars["numeric"]>;
  price_value_satisfaction__c?: InputMaybe<Scalars["numeric"]>;
  professional_services_package_program__c?: InputMaybe<Scalars["Boolean"]>;
  professional_services_rate_per_hr__c?: InputMaybe<Scalars["numeric"]>;
  recruitview__c?: InputMaybe<Scalars["Boolean"]>;
  recruitview_arr__c?: InputMaybe<Scalars["numeric"]>;
  recruitview_engagement_manager__c?: InputMaybe<Scalars["String"]>;
  recruitview_ps_team__c?: InputMaybe<Scalars["String"]>;
  recruitview_renewal_date__c?: InputMaybe<Scalars["timestamp"]>;
  recruitview_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  recruitview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  reference_n__c?: InputMaybe<Scalars["String"]>;
  referenceable__c?: InputMaybe<Scalars["Boolean"]>;
  renewal_date_2__c?: InputMaybe<Scalars["timestamp"]>;
  renewal_date__c?: InputMaybe<Scalars["timestamp"]>;
  renewal_risk__c?: InputMaybe<Scalars["String"]>;
  reporting__c?: InputMaybe<Scalars["numeric"]>;
  retention_confidence__c?: InputMaybe<Scalars["numeric"]>;
  retention_risk_reasons__c?: InputMaybe<Scalars["String"]>;
  revtron_icp_score_formatted__c?: InputMaybe<Scalars["numeric"]>;
  rewardview__c?: InputMaybe<Scalars["Boolean"]>;
  rewardview_arr__c?: InputMaybe<Scalars["numeric"]>;
  rewardview_engagement_manager__c?: InputMaybe<Scalars["String"]>;
  rewardview_ps_team__c?: InputMaybe<Scalars["String"]>;
  rewardview_renewal_date__c?: InputMaybe<Scalars["timestamp"]>;
  rewardview_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  rewardview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  security__c?: InputMaybe<Scalars["numeric"]>;
  segment__c?: InputMaybe<Scalars["String"]>;
  self_admin_certified__c?: InputMaybe<Scalars["Boolean"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  sso_provider__c?: InputMaybe<Scalars["String"]>;
  support_hours_reset_date__c?: InputMaybe<Scalars["timestamp"]>;
  team_collaboration__c?: InputMaybe<Scalars["numeric"]>;
  territory__c?: InputMaybe<Scalars["String"]>;
  total_arr__c?: InputMaybe<Scalars["numeric"]>;
  total_money_raised__c?: InputMaybe<Scalars["String"]>;
  total_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  ui_ux__c?: InputMaybe<Scalars["numeric"]>;
  user_conference_attended__c?: InputMaybe<Scalars["String"]>;
};

/** input type for inserting object relation for remote table "account__c" */
export type account__c_obj_rel_insert_input = {
  data: account__c_insert_input;
};

/** Ordering options when selecting data from "account__c". */
export type account__c_order_by = {
  account_id__c?: InputMaybe<order_by>;
  account_manager__c?: InputMaybe<order_by>;
  account_notes__c?: InputMaybe<order_by>;
  account_status_auto__c?: InputMaybe<order_by>;
  annual_support_hours__c?: InputMaybe<order_by>;
  api_access__c?: InputMaybe<order_by>;
  api_nps__c?: InputMaybe<order_by>;
  ats__c?: InputMaybe<order_by>;
  ats_arr__c?: InputMaybe<order_by>;
  auto_renewal_2__c?: InputMaybe<order_by>;
  auto_renewal__c?: InputMaybe<order_by>;
  average_nps__c?: InputMaybe<order_by>;
  awardview__c?: InputMaybe<order_by>;
  awardview_arr__c?: InputMaybe<order_by>;
  awardview_engagement_manager__c?: InputMaybe<order_by>;
  awardview_ps_team__c?: InputMaybe<order_by>;
  awardview_renewal_date__c?: InputMaybe<order_by>;
  awardview_start_date__c?: InputMaybe<order_by>;
  awardview_support_hours__c?: InputMaybe<order_by>;
  base_licenses__c?: InputMaybe<order_by>;
  billing_amount_2__c?: InputMaybe<order_by>;
  billing_amount__c?: InputMaybe<order_by>;
  billing_currency__c?: InputMaybe<order_by>;
  billing_etc__c?: InputMaybe<order_by>;
  billing_notes__c?: InputMaybe<order_by>;
  billing_terms_2__c?: InputMaybe<order_by>;
  billing_terms__c?: InputMaybe<order_by>;
  churn_date__c?: InputMaybe<order_by>;
  client_number__c?: InputMaybe<order_by>;
  client_self_service__c?: InputMaybe<order_by>;
  client_start_date__c?: InputMaybe<order_by>;
  close_date__c?: InputMaybe<order_by>;
  compensation_system_in_place__c?: InputMaybe<order_by>;
  compview__c?: InputMaybe<order_by>;
  compview_arr__c?: InputMaybe<order_by>;
  compview_engagement_manager__c?: InputMaybe<order_by>;
  compview_ps_team__c?: InputMaybe<order_by>;
  compview_renewal_date__c?: InputMaybe<order_by>;
  compview_start_date__c?: InputMaybe<order_by>;
  compview_support_hours__c?: InputMaybe<order_by>;
  configurability__c?: InputMaybe<order_by>;
  contentview__c?: InputMaybe<order_by>;
  contentview_arr__c?: InputMaybe<order_by>;
  contentview_engagement_manager__c?: InputMaybe<order_by>;
  contentview_ps_team__c?: InputMaybe<order_by>;
  contentview_renewal_date__c?: InputMaybe<order_by>;
  contentview_start_date__c?: InputMaybe<order_by>;
  contentview_support_hours__c?: InputMaybe<order_by>;
  contract_etc__c?: InputMaybe<order_by>;
  contract_start_date__c?: InputMaybe<order_by>;
  contract_total_value__c?: InputMaybe<order_by>;
  contract_uat_delivery_estimate__c?: InputMaybe<order_by>;
  current_active__c?: InputMaybe<order_by>;
  current_end_date__c?: InputMaybe<order_by>;
  customer_lifecycle_stage__c?: InputMaybe<order_by>;
  data_center_location__c?: InputMaybe<order_by>;
  data_feeds__c?: InputMaybe<order_by>;
  date_las__c?: InputMaybe<order_by>;
  delivery_assurance__c?: InputMaybe<order_by>;
  domain__c?: InputMaybe<order_by>;
  founded_year__c?: InputMaybe<order_by>;
  g2_buyer_intent_details__c?: InputMaybe<order_by>;
  g2_intent__c?: InputMaybe<order_by>;
  g2_survey_1__c?: InputMaybe<order_by>;
  g2_survey_2__c?: InputMaybe<order_by>;
  health_score__c?: InputMaybe<order_by>;
  hr_tech__c?: InputMaybe<order_by>;
  hris__c?: InputMaybe<order_by>;
  hris_version__c?: InputMaybe<order_by>;
  hubspot_company_id__c?: InputMaybe<order_by>;
  hubspot_owner_id__c?: InputMaybe<order_by>;
  hubspot_owner_name__c?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  incent__c?: InputMaybe<order_by>;
  incentview_arr__c?: InputMaybe<order_by>;
  incentview_engagement_manager__c?: InputMaybe<order_by>;
  incentview_ps_team__c?: InputMaybe<order_by>;
  incentview_renewal_date__c?: InputMaybe<order_by>;
  incentview_start_date__c?: InputMaybe<order_by>;
  incentview_support_hours__c?: InputMaybe<order_by>;
  international_global__c?: InputMaybe<order_by>;
  is_public__c?: InputMaybe<order_by>;
  language_paks__c?: InputMaybe<order_by>;
  language_paks_arr__c?: InputMaybe<order_by>;
  last_after_action_review__c?: InputMaybe<order_by>;
  lifecycle_stage__c?: InputMaybe<order_by>;
  linkedin_company_page__c?: InputMaybe<order_by>;
  modelview__c?: InputMaybe<order_by>;
  modelview_arr__c?: InputMaybe<order_by>;
  modelview_engagement_manager__c?: InputMaybe<order_by>;
  modelview_ps_team__c?: InputMaybe<order_by>;
  modelview_renewal_date__c?: InputMaybe<order_by>;
  modelview_start_date__c?: InputMaybe<order_by>;
  modelview_support_hours__c?: InputMaybe<order_by>;
  naics__c?: InputMaybe<order_by>;
  naics_industry_detail__c?: InputMaybe<order_by>;
  naics_industry_title__c?: InputMaybe<order_by>;
  number_of_users__c?: InputMaybe<order_by>;
  ols__c?: InputMaybe<order_by>;
  ols_arr__c?: InputMaybe<order_by>;
  online_statements_arr__c?: InputMaybe<order_by>;
  onlinestatements__c?: InputMaybe<order_by>;
  overall_satisfaction__c?: InputMaybe<order_by>;
  partnercontact__c?: InputMaybe<order_by>;
  payview__c?: InputMaybe<order_by>;
  payview_arr__c?: InputMaybe<order_by>;
  payview_engagement_manager__c?: InputMaybe<order_by>;
  payview_ps_team__c?: InputMaybe<order_by>;
  payview_renewal_date__c?: InputMaybe<order_by>;
  payview_start_date__c?: InputMaybe<order_by>;
  payview_support_hours__c?: InputMaybe<order_by>;
  performance__c?: InputMaybe<order_by>;
  performview__c?: InputMaybe<order_by>;
  performview_arr__c?: InputMaybe<order_by>;
  performview_engagement_manager__c?: InputMaybe<order_by>;
  performview_ps_team__c?: InputMaybe<order_by>;
  performview_renewal_date__c?: InputMaybe<order_by>;
  performview_start_date__c?: InputMaybe<order_by>;
  performview_support_hours__c?: InputMaybe<order_by>;
  platform_version__c?: InputMaybe<order_by>;
  predict_proba__c?: InputMaybe<order_by>;
  price_value_satisfaction__c?: InputMaybe<order_by>;
  professional_services_package_program__c?: InputMaybe<order_by>;
  professional_services_rate_per_hr__c?: InputMaybe<order_by>;
  recruitview__c?: InputMaybe<order_by>;
  recruitview_arr__c?: InputMaybe<order_by>;
  recruitview_engagement_manager__c?: InputMaybe<order_by>;
  recruitview_ps_team__c?: InputMaybe<order_by>;
  recruitview_renewal_date__c?: InputMaybe<order_by>;
  recruitview_start_date__c?: InputMaybe<order_by>;
  recruitview_support_hours__c?: InputMaybe<order_by>;
  reference_n__c?: InputMaybe<order_by>;
  referenceable__c?: InputMaybe<order_by>;
  renewal_date_2__c?: InputMaybe<order_by>;
  renewal_date__c?: InputMaybe<order_by>;
  renewal_risk__c?: InputMaybe<order_by>;
  reporting__c?: InputMaybe<order_by>;
  retention_confidence__c?: InputMaybe<order_by>;
  retention_risk_reasons__c?: InputMaybe<order_by>;
  revtron_icp_score_formatted__c?: InputMaybe<order_by>;
  rewardview__c?: InputMaybe<order_by>;
  rewardview_arr__c?: InputMaybe<order_by>;
  rewardview_engagement_manager__c?: InputMaybe<order_by>;
  rewardview_ps_team__c?: InputMaybe<order_by>;
  rewardview_renewal_date__c?: InputMaybe<order_by>;
  rewardview_start_date__c?: InputMaybe<order_by>;
  rewardview_support_hours__c?: InputMaybe<order_by>;
  security__c?: InputMaybe<order_by>;
  segment__c?: InputMaybe<order_by>;
  self_admin_certified__c?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  sso_provider__c?: InputMaybe<order_by>;
  support_hours_reset_date__c?: InputMaybe<order_by>;
  team_collaboration__c?: InputMaybe<order_by>;
  territory__c?: InputMaybe<order_by>;
  total_arr__c?: InputMaybe<order_by>;
  total_money_raised__c?: InputMaybe<order_by>;
  total_support_hours__c?: InputMaybe<order_by>;
  ui_ux__c?: InputMaybe<order_by>;
  user_conference_attended__c?: InputMaybe<order_by>;
};

/** select columns of table "account__c" */
export enum account__c_select_column {
  /** column name */
  account_id__c = "account_id__c",
  /** column name */
  account_manager__c = "account_manager__c",
  /** column name */
  account_notes__c = "account_notes__c",
  /** column name */
  account_status_auto__c = "account_status_auto__c",
  /** column name */
  annual_support_hours__c = "annual_support_hours__c",
  /** column name */
  api_access__c = "api_access__c",
  /** column name */
  api_nps__c = "api_nps__c",
  /** column name */
  ats__c = "ats__c",
  /** column name */
  ats_arr__c = "ats_arr__c",
  /** column name */
  auto_renewal_2__c = "auto_renewal_2__c",
  /** column name */
  auto_renewal__c = "auto_renewal__c",
  /** column name */
  average_nps__c = "average_nps__c",
  /** column name */
  awardview__c = "awardview__c",
  /** column name */
  awardview_arr__c = "awardview_arr__c",
  /** column name */
  awardview_engagement_manager__c = "awardview_engagement_manager__c",
  /** column name */
  awardview_ps_team__c = "awardview_ps_team__c",
  /** column name */
  awardview_renewal_date__c = "awardview_renewal_date__c",
  /** column name */
  awardview_start_date__c = "awardview_start_date__c",
  /** column name */
  awardview_support_hours__c = "awardview_support_hours__c",
  /** column name */
  base_licenses__c = "base_licenses__c",
  /** column name */
  billing_amount_2__c = "billing_amount_2__c",
  /** column name */
  billing_amount__c = "billing_amount__c",
  /** column name */
  billing_currency__c = "billing_currency__c",
  /** column name */
  billing_etc__c = "billing_etc__c",
  /** column name */
  billing_notes__c = "billing_notes__c",
  /** column name */
  billing_terms_2__c = "billing_terms_2__c",
  /** column name */
  billing_terms__c = "billing_terms__c",
  /** column name */
  churn_date__c = "churn_date__c",
  /** column name */
  client_number__c = "client_number__c",
  /** column name */
  client_self_service__c = "client_self_service__c",
  /** column name */
  client_start_date__c = "client_start_date__c",
  /** column name */
  close_date__c = "close_date__c",
  /** column name */
  compensation_system_in_place__c = "compensation_system_in_place__c",
  /** column name */
  compview__c = "compview__c",
  /** column name */
  compview_arr__c = "compview_arr__c",
  /** column name */
  compview_engagement_manager__c = "compview_engagement_manager__c",
  /** column name */
  compview_ps_team__c = "compview_ps_team__c",
  /** column name */
  compview_renewal_date__c = "compview_renewal_date__c",
  /** column name */
  compview_start_date__c = "compview_start_date__c",
  /** column name */
  compview_support_hours__c = "compview_support_hours__c",
  /** column name */
  configurability__c = "configurability__c",
  /** column name */
  contentview__c = "contentview__c",
  /** column name */
  contentview_arr__c = "contentview_arr__c",
  /** column name */
  contentview_engagement_manager__c = "contentview_engagement_manager__c",
  /** column name */
  contentview_ps_team__c = "contentview_ps_team__c",
  /** column name */
  contentview_renewal_date__c = "contentview_renewal_date__c",
  /** column name */
  contentview_start_date__c = "contentview_start_date__c",
  /** column name */
  contentview_support_hours__c = "contentview_support_hours__c",
  /** column name */
  contract_etc__c = "contract_etc__c",
  /** column name */
  contract_start_date__c = "contract_start_date__c",
  /** column name */
  contract_total_value__c = "contract_total_value__c",
  /** column name */
  contract_uat_delivery_estimate__c = "contract_uat_delivery_estimate__c",
  /** column name */
  current_active__c = "current_active__c",
  /** column name */
  current_end_date__c = "current_end_date__c",
  /** column name */
  customer_lifecycle_stage__c = "customer_lifecycle_stage__c",
  /** column name */
  data_center_location__c = "data_center_location__c",
  /** column name */
  data_feeds__c = "data_feeds__c",
  /** column name */
  date_las__c = "date_las__c",
  /** column name */
  delivery_assurance__c = "delivery_assurance__c",
  /** column name */
  domain__c = "domain__c",
  /** column name */
  founded_year__c = "founded_year__c",
  /** column name */
  g2_buyer_intent_details__c = "g2_buyer_intent_details__c",
  /** column name */
  g2_intent__c = "g2_intent__c",
  /** column name */
  g2_survey_1__c = "g2_survey_1__c",
  /** column name */
  g2_survey_2__c = "g2_survey_2__c",
  /** column name */
  health_score__c = "health_score__c",
  /** column name */
  hr_tech__c = "hr_tech__c",
  /** column name */
  hris__c = "hris__c",
  /** column name */
  hris_version__c = "hris_version__c",
  /** column name */
  hubspot_company_id__c = "hubspot_company_id__c",
  /** column name */
  hubspot_owner_id__c = "hubspot_owner_id__c",
  /** column name */
  hubspot_owner_name__c = "hubspot_owner_name__c",
  /** column name */
  id = "id",
  /** column name */
  incent__c = "incent__c",
  /** column name */
  incentview_arr__c = "incentview_arr__c",
  /** column name */
  incentview_engagement_manager__c = "incentview_engagement_manager__c",
  /** column name */
  incentview_ps_team__c = "incentview_ps_team__c",
  /** column name */
  incentview_renewal_date__c = "incentview_renewal_date__c",
  /** column name */
  incentview_start_date__c = "incentview_start_date__c",
  /** column name */
  incentview_support_hours__c = "incentview_support_hours__c",
  /** column name */
  international_global__c = "international_global__c",
  /** column name */
  is_public__c = "is_public__c",
  /** column name */
  language_paks__c = "language_paks__c",
  /** column name */
  language_paks_arr__c = "language_paks_arr__c",
  /** column name */
  last_after_action_review__c = "last_after_action_review__c",
  /** column name */
  lifecycle_stage__c = "lifecycle_stage__c",
  /** column name */
  linkedin_company_page__c = "linkedin_company_page__c",
  /** column name */
  modelview__c = "modelview__c",
  /** column name */
  modelview_arr__c = "modelview_arr__c",
  /** column name */
  modelview_engagement_manager__c = "modelview_engagement_manager__c",
  /** column name */
  modelview_ps_team__c = "modelview_ps_team__c",
  /** column name */
  modelview_renewal_date__c = "modelview_renewal_date__c",
  /** column name */
  modelview_start_date__c = "modelview_start_date__c",
  /** column name */
  modelview_support_hours__c = "modelview_support_hours__c",
  /** column name */
  naics__c = "naics__c",
  /** column name */
  naics_industry_detail__c = "naics_industry_detail__c",
  /** column name */
  naics_industry_title__c = "naics_industry_title__c",
  /** column name */
  number_of_users__c = "number_of_users__c",
  /** column name */
  ols__c = "ols__c",
  /** column name */
  ols_arr__c = "ols_arr__c",
  /** column name */
  online_statements_arr__c = "online_statements_arr__c",
  /** column name */
  onlinestatements__c = "onlinestatements__c",
  /** column name */
  overall_satisfaction__c = "overall_satisfaction__c",
  /** column name */
  partnercontact__c = "partnercontact__c",
  /** column name */
  payview__c = "payview__c",
  /** column name */
  payview_arr__c = "payview_arr__c",
  /** column name */
  payview_engagement_manager__c = "payview_engagement_manager__c",
  /** column name */
  payview_ps_team__c = "payview_ps_team__c",
  /** column name */
  payview_renewal_date__c = "payview_renewal_date__c",
  /** column name */
  payview_start_date__c = "payview_start_date__c",
  /** column name */
  payview_support_hours__c = "payview_support_hours__c",
  /** column name */
  performance__c = "performance__c",
  /** column name */
  performview__c = "performview__c",
  /** column name */
  performview_arr__c = "performview_arr__c",
  /** column name */
  performview_engagement_manager__c = "performview_engagement_manager__c",
  /** column name */
  performview_ps_team__c = "performview_ps_team__c",
  /** column name */
  performview_renewal_date__c = "performview_renewal_date__c",
  /** column name */
  performview_start_date__c = "performview_start_date__c",
  /** column name */
  performview_support_hours__c = "performview_support_hours__c",
  /** column name */
  platform_version__c = "platform_version__c",
  /** column name */
  predict_proba__c = "predict_proba__c",
  /** column name */
  price_value_satisfaction__c = "price_value_satisfaction__c",
  /** column name */
  professional_services_package_program__c = "professional_services_package_program__c",
  /** column name */
  professional_services_rate_per_hr__c = "professional_services_rate_per_hr__c",
  /** column name */
  recruitview__c = "recruitview__c",
  /** column name */
  recruitview_arr__c = "recruitview_arr__c",
  /** column name */
  recruitview_engagement_manager__c = "recruitview_engagement_manager__c",
  /** column name */
  recruitview_ps_team__c = "recruitview_ps_team__c",
  /** column name */
  recruitview_renewal_date__c = "recruitview_renewal_date__c",
  /** column name */
  recruitview_start_date__c = "recruitview_start_date__c",
  /** column name */
  recruitview_support_hours__c = "recruitview_support_hours__c",
  /** column name */
  reference_n__c = "reference_n__c",
  /** column name */
  referenceable__c = "referenceable__c",
  /** column name */
  renewal_date_2__c = "renewal_date_2__c",
  /** column name */
  renewal_date__c = "renewal_date__c",
  /** column name */
  renewal_risk__c = "renewal_risk__c",
  /** column name */
  reporting__c = "reporting__c",
  /** column name */
  retention_confidence__c = "retention_confidence__c",
  /** column name */
  retention_risk_reasons__c = "retention_risk_reasons__c",
  /** column name */
  revtron_icp_score_formatted__c = "revtron_icp_score_formatted__c",
  /** column name */
  rewardview__c = "rewardview__c",
  /** column name */
  rewardview_arr__c = "rewardview_arr__c",
  /** column name */
  rewardview_engagement_manager__c = "rewardview_engagement_manager__c",
  /** column name */
  rewardview_ps_team__c = "rewardview_ps_team__c",
  /** column name */
  rewardview_renewal_date__c = "rewardview_renewal_date__c",
  /** column name */
  rewardview_start_date__c = "rewardview_start_date__c",
  /** column name */
  rewardview_support_hours__c = "rewardview_support_hours__c",
  /** column name */
  security__c = "security__c",
  /** column name */
  segment__c = "segment__c",
  /** column name */
  self_admin_certified__c = "self_admin_certified__c",
  /** column name */
  sort_id = "sort_id",
  /** column name */
  sso_provider__c = "sso_provider__c",
  /** column name */
  support_hours_reset_date__c = "support_hours_reset_date__c",
  /** column name */
  team_collaboration__c = "team_collaboration__c",
  /** column name */
  territory__c = "territory__c",
  /** column name */
  total_arr__c = "total_arr__c",
  /** column name */
  total_money_raised__c = "total_money_raised__c",
  /** column name */
  total_support_hours__c = "total_support_hours__c",
  /** column name */
  ui_ux__c = "ui_ux__c",
  /** column name */
  user_conference_attended__c = "user_conference_attended__c",
}

/** input type for updating data in table "account__c" */
export type account__c_set_input = {
  account_id__c?: InputMaybe<Scalars["String"]>;
  account_manager__c?: InputMaybe<Scalars["String"]>;
  account_notes__c?: InputMaybe<Scalars["String"]>;
  account_status_auto__c?: InputMaybe<Scalars["String"]>;
  annual_support_hours__c?: InputMaybe<Scalars["String"]>;
  api_access__c?: InputMaybe<Scalars["Boolean"]>;
  api_nps__c?: InputMaybe<Scalars["numeric"]>;
  ats__c?: InputMaybe<Scalars["Boolean"]>;
  ats_arr__c?: InputMaybe<Scalars["numeric"]>;
  auto_renewal_2__c?: InputMaybe<Scalars["Boolean"]>;
  auto_renewal__c?: InputMaybe<Scalars["Boolean"]>;
  average_nps__c?: InputMaybe<Scalars["numeric"]>;
  awardview__c?: InputMaybe<Scalars["Boolean"]>;
  awardview_arr__c?: InputMaybe<Scalars["numeric"]>;
  awardview_engagement_manager__c?: InputMaybe<Scalars["String"]>;
  awardview_ps_team__c?: InputMaybe<Scalars["String"]>;
  awardview_renewal_date__c?: InputMaybe<Scalars["timestamp"]>;
  awardview_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  awardview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  base_licenses__c?: InputMaybe<Scalars["numeric"]>;
  billing_amount_2__c?: InputMaybe<Scalars["String"]>;
  billing_amount__c?: InputMaybe<Scalars["String"]>;
  billing_currency__c?: InputMaybe<Scalars["String"]>;
  billing_etc__c?: InputMaybe<Scalars["String"]>;
  billing_notes__c?: InputMaybe<Scalars["String"]>;
  billing_terms_2__c?: InputMaybe<Scalars["String"]>;
  billing_terms__c?: InputMaybe<Scalars["String"]>;
  churn_date__c?: InputMaybe<Scalars["timestamp"]>;
  client_number__c?: InputMaybe<Scalars["String"]>;
  client_self_service__c?: InputMaybe<Scalars["numeric"]>;
  client_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  close_date__c?: InputMaybe<Scalars["timestamp"]>;
  compensation_system_in_place__c?: InputMaybe<Scalars["String"]>;
  compview__c?: InputMaybe<Scalars["Boolean"]>;
  compview_arr__c?: InputMaybe<Scalars["numeric"]>;
  compview_engagement_manager__c?: InputMaybe<Scalars["String"]>;
  compview_ps_team__c?: InputMaybe<Scalars["String"]>;
  compview_renewal_date__c?: InputMaybe<Scalars["timestamp"]>;
  compview_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  compview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  configurability__c?: InputMaybe<Scalars["numeric"]>;
  contentview__c?: InputMaybe<Scalars["Boolean"]>;
  contentview_arr__c?: InputMaybe<Scalars["numeric"]>;
  contentview_engagement_manager__c?: InputMaybe<Scalars["String"]>;
  contentview_ps_team__c?: InputMaybe<Scalars["String"]>;
  contentview_renewal_date__c?: InputMaybe<Scalars["timestamp"]>;
  contentview_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  contentview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  contract_etc__c?: InputMaybe<Scalars["Boolean"]>;
  contract_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  contract_total_value__c?: InputMaybe<Scalars["String"]>;
  contract_uat_delivery_estimate__c?: InputMaybe<Scalars["timestamp"]>;
  current_active__c?: InputMaybe<Scalars["numeric"]>;
  current_end_date__c?: InputMaybe<Scalars["timestamp"]>;
  customer_lifecycle_stage__c?: InputMaybe<Scalars["String"]>;
  data_center_location__c?: InputMaybe<Scalars["String"]>;
  data_feeds__c?: InputMaybe<Scalars["numeric"]>;
  date_las__c?: InputMaybe<Scalars["timestamp"]>;
  delivery_assurance__c?: InputMaybe<Scalars["numeric"]>;
  domain__c?: InputMaybe<Scalars["String"]>;
  founded_year__c?: InputMaybe<Scalars["String"]>;
  g2_buyer_intent_details__c?: InputMaybe<Scalars["String"]>;
  g2_intent__c?: InputMaybe<Scalars["Boolean"]>;
  g2_survey_1__c?: InputMaybe<Scalars["timestamp"]>;
  g2_survey_2__c?: InputMaybe<Scalars["timestamp"]>;
  health_score__c?: InputMaybe<Scalars["String"]>;
  hr_tech__c?: InputMaybe<Scalars["String"]>;
  hris__c?: InputMaybe<Scalars["String"]>;
  hris_version__c?: InputMaybe<Scalars["String"]>;
  hubspot_company_id__c?: InputMaybe<Scalars["String"]>;
  hubspot_owner_id__c?: InputMaybe<Scalars["String"]>;
  hubspot_owner_name__c?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  incent__c?: InputMaybe<Scalars["Boolean"]>;
  incentview_arr__c?: InputMaybe<Scalars["numeric"]>;
  incentview_engagement_manager__c?: InputMaybe<Scalars["String"]>;
  incentview_ps_team__c?: InputMaybe<Scalars["String"]>;
  incentview_renewal_date__c?: InputMaybe<Scalars["timestamp"]>;
  incentview_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  incentview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  international_global__c?: InputMaybe<Scalars["Boolean"]>;
  is_public__c?: InputMaybe<Scalars["Boolean"]>;
  language_paks__c?: InputMaybe<Scalars["Boolean"]>;
  language_paks_arr__c?: InputMaybe<Scalars["numeric"]>;
  last_after_action_review__c?: InputMaybe<Scalars["timestamp"]>;
  lifecycle_stage__c?: InputMaybe<Scalars["String"]>;
  linkedin_company_page__c?: InputMaybe<Scalars["String"]>;
  modelview__c?: InputMaybe<Scalars["Boolean"]>;
  modelview_arr__c?: InputMaybe<Scalars["numeric"]>;
  modelview_engagement_manager__c?: InputMaybe<Scalars["String"]>;
  modelview_ps_team__c?: InputMaybe<Scalars["String"]>;
  modelview_renewal_date__c?: InputMaybe<Scalars["timestamp"]>;
  modelview_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  modelview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  naics__c?: InputMaybe<Scalars["numeric"]>;
  naics_industry_detail__c?: InputMaybe<Scalars["String"]>;
  naics_industry_title__c?: InputMaybe<Scalars["String"]>;
  number_of_users__c?: InputMaybe<Scalars["String"]>;
  ols__c?: InputMaybe<Scalars["Boolean"]>;
  ols_arr__c?: InputMaybe<Scalars["numeric"]>;
  online_statements_arr__c?: InputMaybe<Scalars["numeric"]>;
  onlinestatements__c?: InputMaybe<Scalars["Boolean"]>;
  overall_satisfaction__c?: InputMaybe<Scalars["numeric"]>;
  partnercontact__c?: InputMaybe<Scalars["String"]>;
  payview__c?: InputMaybe<Scalars["Boolean"]>;
  payview_arr__c?: InputMaybe<Scalars["numeric"]>;
  payview_engagement_manager__c?: InputMaybe<Scalars["String"]>;
  payview_ps_team__c?: InputMaybe<Scalars["String"]>;
  payview_renewal_date__c?: InputMaybe<Scalars["timestamp"]>;
  payview_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  payview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  performance__c?: InputMaybe<Scalars["numeric"]>;
  performview__c?: InputMaybe<Scalars["Boolean"]>;
  performview_arr__c?: InputMaybe<Scalars["numeric"]>;
  performview_engagement_manager__c?: InputMaybe<Scalars["String"]>;
  performview_ps_team__c?: InputMaybe<Scalars["String"]>;
  performview_renewal_date__c?: InputMaybe<Scalars["timestamp"]>;
  performview_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  performview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  platform_version__c?: InputMaybe<Scalars["String"]>;
  predict_proba__c?: InputMaybe<Scalars["numeric"]>;
  price_value_satisfaction__c?: InputMaybe<Scalars["numeric"]>;
  professional_services_package_program__c?: InputMaybe<Scalars["Boolean"]>;
  professional_services_rate_per_hr__c?: InputMaybe<Scalars["numeric"]>;
  recruitview__c?: InputMaybe<Scalars["Boolean"]>;
  recruitview_arr__c?: InputMaybe<Scalars["numeric"]>;
  recruitview_engagement_manager__c?: InputMaybe<Scalars["String"]>;
  recruitview_ps_team__c?: InputMaybe<Scalars["String"]>;
  recruitview_renewal_date__c?: InputMaybe<Scalars["timestamp"]>;
  recruitview_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  recruitview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  reference_n__c?: InputMaybe<Scalars["String"]>;
  referenceable__c?: InputMaybe<Scalars["Boolean"]>;
  renewal_date_2__c?: InputMaybe<Scalars["timestamp"]>;
  renewal_date__c?: InputMaybe<Scalars["timestamp"]>;
  renewal_risk__c?: InputMaybe<Scalars["String"]>;
  reporting__c?: InputMaybe<Scalars["numeric"]>;
  retention_confidence__c?: InputMaybe<Scalars["numeric"]>;
  retention_risk_reasons__c?: InputMaybe<Scalars["String"]>;
  revtron_icp_score_formatted__c?: InputMaybe<Scalars["numeric"]>;
  rewardview__c?: InputMaybe<Scalars["Boolean"]>;
  rewardview_arr__c?: InputMaybe<Scalars["numeric"]>;
  rewardview_engagement_manager__c?: InputMaybe<Scalars["String"]>;
  rewardview_ps_team__c?: InputMaybe<Scalars["String"]>;
  rewardview_renewal_date__c?: InputMaybe<Scalars["timestamp"]>;
  rewardview_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  rewardview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  security__c?: InputMaybe<Scalars["numeric"]>;
  segment__c?: InputMaybe<Scalars["String"]>;
  self_admin_certified__c?: InputMaybe<Scalars["Boolean"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  sso_provider__c?: InputMaybe<Scalars["String"]>;
  support_hours_reset_date__c?: InputMaybe<Scalars["timestamp"]>;
  team_collaboration__c?: InputMaybe<Scalars["numeric"]>;
  territory__c?: InputMaybe<Scalars["String"]>;
  total_arr__c?: InputMaybe<Scalars["numeric"]>;
  total_money_raised__c?: InputMaybe<Scalars["String"]>;
  total_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  ui_ux__c?: InputMaybe<Scalars["numeric"]>;
  user_conference_attended__c?: InputMaybe<Scalars["String"]>;
};

/** Streaming cursor of the table "account__c" */
export type account__c_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: account__c_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type account__c_stream_cursor_value_input = {
  account_id__c?: InputMaybe<Scalars["String"]>;
  account_manager__c?: InputMaybe<Scalars["String"]>;
  account_notes__c?: InputMaybe<Scalars["String"]>;
  account_status_auto__c?: InputMaybe<Scalars["String"]>;
  annual_support_hours__c?: InputMaybe<Scalars["String"]>;
  api_access__c?: InputMaybe<Scalars["Boolean"]>;
  api_nps__c?: InputMaybe<Scalars["numeric"]>;
  ats__c?: InputMaybe<Scalars["Boolean"]>;
  ats_arr__c?: InputMaybe<Scalars["numeric"]>;
  auto_renewal_2__c?: InputMaybe<Scalars["Boolean"]>;
  auto_renewal__c?: InputMaybe<Scalars["Boolean"]>;
  average_nps__c?: InputMaybe<Scalars["numeric"]>;
  awardview__c?: InputMaybe<Scalars["Boolean"]>;
  awardview_arr__c?: InputMaybe<Scalars["numeric"]>;
  awardview_engagement_manager__c?: InputMaybe<Scalars["String"]>;
  awardview_ps_team__c?: InputMaybe<Scalars["String"]>;
  awardview_renewal_date__c?: InputMaybe<Scalars["timestamp"]>;
  awardview_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  awardview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  base_licenses__c?: InputMaybe<Scalars["numeric"]>;
  billing_amount_2__c?: InputMaybe<Scalars["String"]>;
  billing_amount__c?: InputMaybe<Scalars["String"]>;
  billing_currency__c?: InputMaybe<Scalars["String"]>;
  billing_etc__c?: InputMaybe<Scalars["String"]>;
  billing_notes__c?: InputMaybe<Scalars["String"]>;
  billing_terms_2__c?: InputMaybe<Scalars["String"]>;
  billing_terms__c?: InputMaybe<Scalars["String"]>;
  churn_date__c?: InputMaybe<Scalars["timestamp"]>;
  client_number__c?: InputMaybe<Scalars["String"]>;
  client_self_service__c?: InputMaybe<Scalars["numeric"]>;
  client_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  close_date__c?: InputMaybe<Scalars["timestamp"]>;
  compensation_system_in_place__c?: InputMaybe<Scalars["String"]>;
  compview__c?: InputMaybe<Scalars["Boolean"]>;
  compview_arr__c?: InputMaybe<Scalars["numeric"]>;
  compview_engagement_manager__c?: InputMaybe<Scalars["String"]>;
  compview_ps_team__c?: InputMaybe<Scalars["String"]>;
  compview_renewal_date__c?: InputMaybe<Scalars["timestamp"]>;
  compview_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  compview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  configurability__c?: InputMaybe<Scalars["numeric"]>;
  contentview__c?: InputMaybe<Scalars["Boolean"]>;
  contentview_arr__c?: InputMaybe<Scalars["numeric"]>;
  contentview_engagement_manager__c?: InputMaybe<Scalars["String"]>;
  contentview_ps_team__c?: InputMaybe<Scalars["String"]>;
  contentview_renewal_date__c?: InputMaybe<Scalars["timestamp"]>;
  contentview_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  contentview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  contract_etc__c?: InputMaybe<Scalars["Boolean"]>;
  contract_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  contract_total_value__c?: InputMaybe<Scalars["String"]>;
  contract_uat_delivery_estimate__c?: InputMaybe<Scalars["timestamp"]>;
  current_active__c?: InputMaybe<Scalars["numeric"]>;
  current_end_date__c?: InputMaybe<Scalars["timestamp"]>;
  customer_lifecycle_stage__c?: InputMaybe<Scalars["String"]>;
  data_center_location__c?: InputMaybe<Scalars["String"]>;
  data_feeds__c?: InputMaybe<Scalars["numeric"]>;
  date_las__c?: InputMaybe<Scalars["timestamp"]>;
  delivery_assurance__c?: InputMaybe<Scalars["numeric"]>;
  domain__c?: InputMaybe<Scalars["String"]>;
  founded_year__c?: InputMaybe<Scalars["String"]>;
  g2_buyer_intent_details__c?: InputMaybe<Scalars["String"]>;
  g2_intent__c?: InputMaybe<Scalars["Boolean"]>;
  g2_survey_1__c?: InputMaybe<Scalars["timestamp"]>;
  g2_survey_2__c?: InputMaybe<Scalars["timestamp"]>;
  health_score__c?: InputMaybe<Scalars["String"]>;
  hr_tech__c?: InputMaybe<Scalars["String"]>;
  hris__c?: InputMaybe<Scalars["String"]>;
  hris_version__c?: InputMaybe<Scalars["String"]>;
  hubspot_company_id__c?: InputMaybe<Scalars["String"]>;
  hubspot_owner_id__c?: InputMaybe<Scalars["String"]>;
  hubspot_owner_name__c?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  incent__c?: InputMaybe<Scalars["Boolean"]>;
  incentview_arr__c?: InputMaybe<Scalars["numeric"]>;
  incentview_engagement_manager__c?: InputMaybe<Scalars["String"]>;
  incentview_ps_team__c?: InputMaybe<Scalars["String"]>;
  incentview_renewal_date__c?: InputMaybe<Scalars["timestamp"]>;
  incentview_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  incentview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  international_global__c?: InputMaybe<Scalars["Boolean"]>;
  is_public__c?: InputMaybe<Scalars["Boolean"]>;
  language_paks__c?: InputMaybe<Scalars["Boolean"]>;
  language_paks_arr__c?: InputMaybe<Scalars["numeric"]>;
  last_after_action_review__c?: InputMaybe<Scalars["timestamp"]>;
  lifecycle_stage__c?: InputMaybe<Scalars["String"]>;
  linkedin_company_page__c?: InputMaybe<Scalars["String"]>;
  modelview__c?: InputMaybe<Scalars["Boolean"]>;
  modelview_arr__c?: InputMaybe<Scalars["numeric"]>;
  modelview_engagement_manager__c?: InputMaybe<Scalars["String"]>;
  modelview_ps_team__c?: InputMaybe<Scalars["String"]>;
  modelview_renewal_date__c?: InputMaybe<Scalars["timestamp"]>;
  modelview_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  modelview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  naics__c?: InputMaybe<Scalars["numeric"]>;
  naics_industry_detail__c?: InputMaybe<Scalars["String"]>;
  naics_industry_title__c?: InputMaybe<Scalars["String"]>;
  number_of_users__c?: InputMaybe<Scalars["String"]>;
  ols__c?: InputMaybe<Scalars["Boolean"]>;
  ols_arr__c?: InputMaybe<Scalars["numeric"]>;
  online_statements_arr__c?: InputMaybe<Scalars["numeric"]>;
  onlinestatements__c?: InputMaybe<Scalars["Boolean"]>;
  overall_satisfaction__c?: InputMaybe<Scalars["numeric"]>;
  partnercontact__c?: InputMaybe<Scalars["String"]>;
  payview__c?: InputMaybe<Scalars["Boolean"]>;
  payview_arr__c?: InputMaybe<Scalars["numeric"]>;
  payview_engagement_manager__c?: InputMaybe<Scalars["String"]>;
  payview_ps_team__c?: InputMaybe<Scalars["String"]>;
  payview_renewal_date__c?: InputMaybe<Scalars["timestamp"]>;
  payview_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  payview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  performance__c?: InputMaybe<Scalars["numeric"]>;
  performview__c?: InputMaybe<Scalars["Boolean"]>;
  performview_arr__c?: InputMaybe<Scalars["numeric"]>;
  performview_engagement_manager__c?: InputMaybe<Scalars["String"]>;
  performview_ps_team__c?: InputMaybe<Scalars["String"]>;
  performview_renewal_date__c?: InputMaybe<Scalars["timestamp"]>;
  performview_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  performview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  platform_version__c?: InputMaybe<Scalars["String"]>;
  predict_proba__c?: InputMaybe<Scalars["numeric"]>;
  price_value_satisfaction__c?: InputMaybe<Scalars["numeric"]>;
  professional_services_package_program__c?: InputMaybe<Scalars["Boolean"]>;
  professional_services_rate_per_hr__c?: InputMaybe<Scalars["numeric"]>;
  recruitview__c?: InputMaybe<Scalars["Boolean"]>;
  recruitview_arr__c?: InputMaybe<Scalars["numeric"]>;
  recruitview_engagement_manager__c?: InputMaybe<Scalars["String"]>;
  recruitview_ps_team__c?: InputMaybe<Scalars["String"]>;
  recruitview_renewal_date__c?: InputMaybe<Scalars["timestamp"]>;
  recruitview_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  recruitview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  reference_n__c?: InputMaybe<Scalars["String"]>;
  referenceable__c?: InputMaybe<Scalars["Boolean"]>;
  renewal_date_2__c?: InputMaybe<Scalars["timestamp"]>;
  renewal_date__c?: InputMaybe<Scalars["timestamp"]>;
  renewal_risk__c?: InputMaybe<Scalars["String"]>;
  reporting__c?: InputMaybe<Scalars["numeric"]>;
  retention_confidence__c?: InputMaybe<Scalars["numeric"]>;
  retention_risk_reasons__c?: InputMaybe<Scalars["String"]>;
  revtron_icp_score_formatted__c?: InputMaybe<Scalars["numeric"]>;
  rewardview__c?: InputMaybe<Scalars["Boolean"]>;
  rewardview_arr__c?: InputMaybe<Scalars["numeric"]>;
  rewardview_engagement_manager__c?: InputMaybe<Scalars["String"]>;
  rewardview_ps_team__c?: InputMaybe<Scalars["String"]>;
  rewardview_renewal_date__c?: InputMaybe<Scalars["timestamp"]>;
  rewardview_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  rewardview_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  security__c?: InputMaybe<Scalars["numeric"]>;
  segment__c?: InputMaybe<Scalars["String"]>;
  self_admin_certified__c?: InputMaybe<Scalars["Boolean"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  sso_provider__c?: InputMaybe<Scalars["String"]>;
  support_hours_reset_date__c?: InputMaybe<Scalars["timestamp"]>;
  team_collaboration__c?: InputMaybe<Scalars["numeric"]>;
  territory__c?: InputMaybe<Scalars["String"]>;
  total_arr__c?: InputMaybe<Scalars["numeric"]>;
  total_money_raised__c?: InputMaybe<Scalars["String"]>;
  total_support_hours__c?: InputMaybe<Scalars["numeric"]>;
  ui_ux__c?: InputMaybe<Scalars["numeric"]>;
  user_conference_attended__c?: InputMaybe<Scalars["String"]>;
};

export type account__c_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<account__c_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<account__c_set_input>;
  where: account__c_bool_exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type account_append_input = {
  billingaddress?: InputMaybe<Scalars["jsonb"]>;
  shippingaddress?: InputMaybe<Scalars["jsonb"]>;
};

/** Boolean expression to filter rows from the table "account". All fields are combined with a logical 'AND'. */
export type account_bool_exp = {
  _and?: InputMaybe<Array<account_bool_exp>>;
  _not?: InputMaybe<account_bool_exp>;
  _or?: InputMaybe<Array<account_bool_exp>>;
  account_module_static?: InputMaybe<account_module_static_bool_exp>;
  account_to_custom_account?: InputMaybe<account__c_bool_exp>;
  accountsource?: InputMaybe<String_comparison_exp>;
  annualrevenue?: InputMaybe<numeric_comparison_exp>;
  billingaddress?: InputMaybe<jsonb_comparison_exp>;
  billingcity?: InputMaybe<String_comparison_exp>;
  billingcountry?: InputMaybe<String_comparison_exp>;
  billinggeocodeaccuracy?: InputMaybe<String_comparison_exp>;
  billinglatitude?: InputMaybe<numeric_comparison_exp>;
  billinglongitude?: InputMaybe<numeric_comparison_exp>;
  billingpostalcode?: InputMaybe<String_comparison_exp>;
  billingstate?: InputMaybe<String_comparison_exp>;
  billingstreet?: InputMaybe<String_comparison_exp>;
  createdbyid?: InputMaybe<String_comparison_exp>;
  createddate?: InputMaybe<timestamp_comparison_exp>;
  description?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<String_comparison_exp>;
  industry?: InputMaybe<String_comparison_exp>;
  isdeleted?: InputMaybe<Boolean_comparison_exp>;
  jigsaw?: InputMaybe<String_comparison_exp>;
  jigsawcompanyid?: InputMaybe<String_comparison_exp>;
  lastactivitydate?: InputMaybe<timestamp_comparison_exp>;
  lastmodifiedbyid?: InputMaybe<String_comparison_exp>;
  lastmodifieddate?: InputMaybe<timestamp_comparison_exp>;
  lastreferenceddate?: InputMaybe<timestamp_comparison_exp>;
  lastvieweddate?: InputMaybe<timestamp_comparison_exp>;
  masterrecordid?: InputMaybe<String_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  numberofemployees?: InputMaybe<Int_comparison_exp>;
  ownerid?: InputMaybe<String_comparison_exp>;
  parentid?: InputMaybe<String_comparison_exp>;
  phone?: InputMaybe<String_comparison_exp>;
  photourl?: InputMaybe<String_comparison_exp>;
  shippingaddress?: InputMaybe<jsonb_comparison_exp>;
  shippingcity?: InputMaybe<String_comparison_exp>;
  shippingcountry?: InputMaybe<String_comparison_exp>;
  shippinggeocodeaccuracy?: InputMaybe<String_comparison_exp>;
  shippinglatitude?: InputMaybe<numeric_comparison_exp>;
  shippinglongitude?: InputMaybe<numeric_comparison_exp>;
  shippingpostalcode?: InputMaybe<String_comparison_exp>;
  shippingstate?: InputMaybe<String_comparison_exp>;
  shippingstreet?: InputMaybe<String_comparison_exp>;
  sicdesc?: InputMaybe<String_comparison_exp>;
  sort_id?: InputMaybe<Int_comparison_exp>;
  systemmodstamp?: InputMaybe<timestamp_comparison_exp>;
  tickersymbol?: InputMaybe<String_comparison_exp>;
  to_revtron?: InputMaybe<crm_revtron_indexes_bool_exp>;
  type?: InputMaybe<String_comparison_exp>;
  website?: InputMaybe<String_comparison_exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type account_delete_at_path_input = {
  billingaddress?: InputMaybe<Array<Scalars["String"]>>;
  shippingaddress?: InputMaybe<Array<Scalars["String"]>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type account_delete_elem_input = {
  billingaddress?: InputMaybe<Scalars["Int"]>;
  shippingaddress?: InputMaybe<Scalars["Int"]>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type account_delete_key_input = {
  billingaddress?: InputMaybe<Scalars["String"]>;
  shippingaddress?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "account_effort_engagement_static_gql". All fields are combined with a logical 'AND'. */
export type account_effort_engagement_static_gql_bool_exp = {
  _and?: InputMaybe<Array<account_effort_engagement_static_gql_bool_exp>>;
  _not?: InputMaybe<account_effort_engagement_static_gql_bool_exp>;
  _or?: InputMaybe<Array<account_effort_engagement_static_gql_bool_exp>>;
  accountid?: InputMaybe<String_comparison_exp>;
  effort?: InputMaybe<numeric_comparison_exp>;
  engagement?: InputMaybe<numeric_comparison_exp>;
};

/** input type for incrementing numeric columns in table "account_effort_engagement_static_gql" */
export type account_effort_engagement_static_gql_inc_input = {
  effort?: InputMaybe<Scalars["numeric"]>;
  engagement?: InputMaybe<Scalars["numeric"]>;
};

/** input type for inserting data into table "account_effort_engagement_static_gql" */
export type account_effort_engagement_static_gql_insert_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  effort?: InputMaybe<Scalars["numeric"]>;
  engagement?: InputMaybe<Scalars["numeric"]>;
};

/** Ordering options when selecting data from "account_effort_engagement_static_gql". */
export type account_effort_engagement_static_gql_order_by = {
  accountid?: InputMaybe<order_by>;
  effort?: InputMaybe<order_by>;
  engagement?: InputMaybe<order_by>;
};

/** select columns of table "account_effort_engagement_static_gql" */
export enum account_effort_engagement_static_gql_select_column {
  /** column name */
  accountid = "accountid",
  /** column name */
  effort = "effort",
  /** column name */
  engagement = "engagement",
}

/** input type for updating data in table "account_effort_engagement_static_gql" */
export type account_effort_engagement_static_gql_set_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  effort?: InputMaybe<Scalars["numeric"]>;
  engagement?: InputMaybe<Scalars["numeric"]>;
};

/** Streaming cursor of the table "account_effort_engagement_static_gql" */
export type account_effort_engagement_static_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: account_effort_engagement_static_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type account_effort_engagement_static_gql_stream_cursor_value_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  effort?: InputMaybe<Scalars["numeric"]>;
  engagement?: InputMaybe<Scalars["numeric"]>;
};

export type account_effort_engagement_static_gql_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<account_effort_engagement_static_gql_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<account_effort_engagement_static_gql_set_input>;
  where: account_effort_engagement_static_gql_bool_exp;
};

/** input type for incrementing numeric columns in table "account" */
export type account_inc_input = {
  annualrevenue?: InputMaybe<Scalars["numeric"]>;
  billinglatitude?: InputMaybe<Scalars["numeric"]>;
  billinglongitude?: InputMaybe<Scalars["numeric"]>;
  numberofemployees?: InputMaybe<Scalars["Int"]>;
  shippinglatitude?: InputMaybe<Scalars["numeric"]>;
  shippinglongitude?: InputMaybe<Scalars["numeric"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
};

/** input type for inserting data into table "account" */
export type account_insert_input = {
  account_module_static?: InputMaybe<account_module_static_obj_rel_insert_input>;
  account_to_custom_account?: InputMaybe<account__c_obj_rel_insert_input>;
  accountsource?: InputMaybe<Scalars["String"]>;
  annualrevenue?: InputMaybe<Scalars["numeric"]>;
  billingaddress?: InputMaybe<Scalars["jsonb"]>;
  billingcity?: InputMaybe<Scalars["String"]>;
  billingcountry?: InputMaybe<Scalars["String"]>;
  billinggeocodeaccuracy?: InputMaybe<Scalars["String"]>;
  billinglatitude?: InputMaybe<Scalars["numeric"]>;
  billinglongitude?: InputMaybe<Scalars["numeric"]>;
  billingpostalcode?: InputMaybe<Scalars["String"]>;
  billingstate?: InputMaybe<Scalars["String"]>;
  billingstreet?: InputMaybe<Scalars["String"]>;
  createdbyid?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  description?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  industry?: InputMaybe<Scalars["String"]>;
  isdeleted?: InputMaybe<Scalars["Boolean"]>;
  jigsaw?: InputMaybe<Scalars["String"]>;
  jigsawcompanyid?: InputMaybe<Scalars["String"]>;
  lastactivitydate?: InputMaybe<Scalars["timestamp"]>;
  lastmodifiedbyid?: InputMaybe<Scalars["String"]>;
  lastmodifieddate?: InputMaybe<Scalars["timestamp"]>;
  lastreferenceddate?: InputMaybe<Scalars["timestamp"]>;
  lastvieweddate?: InputMaybe<Scalars["timestamp"]>;
  masterrecordid?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  numberofemployees?: InputMaybe<Scalars["Int"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  parentid?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  photourl?: InputMaybe<Scalars["String"]>;
  shippingaddress?: InputMaybe<Scalars["jsonb"]>;
  shippingcity?: InputMaybe<Scalars["String"]>;
  shippingcountry?: InputMaybe<Scalars["String"]>;
  shippinggeocodeaccuracy?: InputMaybe<Scalars["String"]>;
  shippinglatitude?: InputMaybe<Scalars["numeric"]>;
  shippinglongitude?: InputMaybe<Scalars["numeric"]>;
  shippingpostalcode?: InputMaybe<Scalars["String"]>;
  shippingstate?: InputMaybe<Scalars["String"]>;
  shippingstreet?: InputMaybe<Scalars["String"]>;
  sicdesc?: InputMaybe<Scalars["String"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  systemmodstamp?: InputMaybe<Scalars["timestamp"]>;
  tickersymbol?: InputMaybe<Scalars["String"]>;
  to_revtron?: InputMaybe<crm_revtron_indexes_obj_rel_insert_input>;
  type?: InputMaybe<Scalars["String"]>;
  website?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "account_module_expansion_gql". All fields are combined with a logical 'AND'. */
export type account_module_expansion_gql_bool_exp = {
  _and?: InputMaybe<Array<account_module_expansion_gql_bool_exp>>;
  _not?: InputMaybe<account_module_expansion_gql_bool_exp>;
  _or?: InputMaybe<Array<account_module_expansion_gql_bool_exp>>;
  account_id?: InputMaybe<String_comparison_exp>;
  daily_engagement?: InputMaybe<daily_effort_engagement_by_account_bool_exp>;
  daily_engagement_aggregate?: InputMaybe<daily_effort_engagement_by_account_aggregate_bool_exp>;
  number_of_contacts?: InputMaybe<bigint_comparison_exp>;
  open_opp_count?: InputMaybe<bigint_comparison_exp>;
};

/** Ordering options when selecting data from "account_module_expansion_gql". */
export type account_module_expansion_gql_order_by = {
  account_id?: InputMaybe<order_by>;
  daily_engagement_aggregate?: InputMaybe<daily_effort_engagement_by_account_aggregate_order_by>;
  number_of_contacts?: InputMaybe<order_by>;
  open_opp_count?: InputMaybe<order_by>;
};

/** select columns of table "account_module_expansion_gql" */
export enum account_module_expansion_gql_select_column {
  /** column name */
  account_id = "account_id",
  /** column name */
  number_of_contacts = "number_of_contacts",
  /** column name */
  open_opp_count = "open_opp_count",
}

/** Streaming cursor of the table "account_module_expansion_gql" */
export type account_module_expansion_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: account_module_expansion_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type account_module_expansion_gql_stream_cursor_value_input = {
  account_id?: InputMaybe<Scalars["String"]>;
  number_of_contacts?: InputMaybe<Scalars["bigint"]>;
  open_opp_count?: InputMaybe<Scalars["bigint"]>;
};

/** Boolean expression to filter rows from the table "account_module_gql". All fields are combined with a logical 'AND'. */
export type account_module_gql_bool_exp = {
  _and?: InputMaybe<Array<account_module_gql_bool_exp>>;
  _not?: InputMaybe<account_module_gql_bool_exp>;
  _or?: InputMaybe<Array<account_module_gql_bool_exp>>;
  account_id?: InputMaybe<String_comparison_exp>;
  account_name?: InputMaybe<String_comparison_exp>;
  account_owner?: InputMaybe<String_comparison_exp>;
  account_status_auto__c?: InputMaybe<String_comparison_exp>;
  billingcity?: InputMaybe<String_comparison_exp>;
  billingcountry?: InputMaybe<String_comparison_exp>;
  billingstate?: InputMaybe<String_comparison_exp>;
  effort?: InputMaybe<numeric_comparison_exp>;
  engagement?: InputMaybe<numeric_comparison_exp>;
  predct_proba?: InputMaybe<float8_comparison_exp>;
};

/** Ordering options when selecting data from "account_module_gql". */
export type account_module_gql_order_by = {
  account_id?: InputMaybe<order_by>;
  account_name?: InputMaybe<order_by>;
  account_owner?: InputMaybe<order_by>;
  account_status_auto__c?: InputMaybe<order_by>;
  billingcity?: InputMaybe<order_by>;
  billingcountry?: InputMaybe<order_by>;
  billingstate?: InputMaybe<order_by>;
  effort?: InputMaybe<order_by>;
  engagement?: InputMaybe<order_by>;
  predct_proba?: InputMaybe<order_by>;
};

/** select columns of table "account_module_gql" */
export enum account_module_gql_select_column {
  /** column name */
  account_id = "account_id",
  /** column name */
  account_name = "account_name",
  /** column name */
  account_owner = "account_owner",
  /** column name */
  account_status_auto__c = "account_status_auto__c",
  /** column name */
  billingcity = "billingcity",
  /** column name */
  billingcountry = "billingcountry",
  /** column name */
  billingstate = "billingstate",
  /** column name */
  effort = "effort",
  /** column name */
  engagement = "engagement",
  /** column name */
  predct_proba = "predct_proba",
}

/** Streaming cursor of the table "account_module_gql" */
export type account_module_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: account_module_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type account_module_gql_stream_cursor_value_input = {
  account_id?: InputMaybe<Scalars["String"]>;
  account_name?: InputMaybe<Scalars["String"]>;
  account_owner?: InputMaybe<Scalars["String"]>;
  account_status_auto__c?: InputMaybe<Scalars["String"]>;
  billingcity?: InputMaybe<Scalars["String"]>;
  billingcountry?: InputMaybe<Scalars["String"]>;
  billingstate?: InputMaybe<Scalars["String"]>;
  effort?: InputMaybe<Scalars["numeric"]>;
  engagement?: InputMaybe<Scalars["numeric"]>;
  predct_proba?: InputMaybe<Scalars["float8"]>;
};

/** Boolean expression to filter rows from the table "account_module_static". All fields are combined with a logical 'AND'. */
export type account_module_static_bool_exp = {
  _and?: InputMaybe<Array<account_module_static_bool_exp>>;
  _not?: InputMaybe<account_module_static_bool_exp>;
  _or?: InputMaybe<Array<account_module_static_bool_exp>>;
  account_id?: InputMaybe<String_comparison_exp>;
  account_name?: InputMaybe<String_comparison_exp>;
  account_owner?: InputMaybe<String_comparison_exp>;
  account_status_auto__c?: InputMaybe<String_comparison_exp>;
  billingcity?: InputMaybe<String_comparison_exp>;
  billingcountry?: InputMaybe<String_comparison_exp>;
  billingstate?: InputMaybe<String_comparison_exp>;
  effort?: InputMaybe<numeric_comparison_exp>;
  engagement?: InputMaybe<numeric_comparison_exp>;
  predct_proba?: InputMaybe<numeric_comparison_exp>;
};

/** unique or primary key constraints on table "account_module_static" */
export enum account_module_static_constraint {
  /** unique or primary key constraint on columns "account_id" */
  account_module_static_pkey = "account_module_static_pkey",
}

/** input type for incrementing numeric columns in table "account_module_static" */
export type account_module_static_inc_input = {
  effort?: InputMaybe<Scalars["numeric"]>;
  engagement?: InputMaybe<Scalars["numeric"]>;
  predct_proba?: InputMaybe<Scalars["numeric"]>;
};

/** input type for inserting data into table "account_module_static" */
export type account_module_static_insert_input = {
  account_id?: InputMaybe<Scalars["String"]>;
  account_name?: InputMaybe<Scalars["String"]>;
  account_owner?: InputMaybe<Scalars["String"]>;
  account_status_auto__c?: InputMaybe<Scalars["String"]>;
  billingcity?: InputMaybe<Scalars["String"]>;
  billingcountry?: InputMaybe<Scalars["String"]>;
  billingstate?: InputMaybe<Scalars["String"]>;
  effort?: InputMaybe<Scalars["numeric"]>;
  engagement?: InputMaybe<Scalars["numeric"]>;
  predct_proba?: InputMaybe<Scalars["numeric"]>;
};

/** input type for inserting object relation for remote table "account_module_static" */
export type account_module_static_obj_rel_insert_input = {
  data: account_module_static_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<account_module_static_on_conflict>;
};

/** on_conflict condition type for table "account_module_static" */
export type account_module_static_on_conflict = {
  constraint: account_module_static_constraint;
  update_columns?: Array<account_module_static_update_column>;
  where?: InputMaybe<account_module_static_bool_exp>;
};

/** Ordering options when selecting data from "account_module_static". */
export type account_module_static_order_by = {
  account_id?: InputMaybe<order_by>;
  account_name?: InputMaybe<order_by>;
  account_owner?: InputMaybe<order_by>;
  account_status_auto__c?: InputMaybe<order_by>;
  billingcity?: InputMaybe<order_by>;
  billingcountry?: InputMaybe<order_by>;
  billingstate?: InputMaybe<order_by>;
  effort?: InputMaybe<order_by>;
  engagement?: InputMaybe<order_by>;
  predct_proba?: InputMaybe<order_by>;
};

/** primary key columns input for table: account_module_static */
export type account_module_static_pk_columns_input = {
  account_id: Scalars["String"];
};

/** select columns of table "account_module_static" */
export enum account_module_static_select_column {
  /** column name */
  account_id = "account_id",
  /** column name */
  account_name = "account_name",
  /** column name */
  account_owner = "account_owner",
  /** column name */
  account_status_auto__c = "account_status_auto__c",
  /** column name */
  billingcity = "billingcity",
  /** column name */
  billingcountry = "billingcountry",
  /** column name */
  billingstate = "billingstate",
  /** column name */
  effort = "effort",
  /** column name */
  engagement = "engagement",
  /** column name */
  predct_proba = "predct_proba",
}

/** input type for updating data in table "account_module_static" */
export type account_module_static_set_input = {
  account_id?: InputMaybe<Scalars["String"]>;
  account_name?: InputMaybe<Scalars["String"]>;
  account_owner?: InputMaybe<Scalars["String"]>;
  account_status_auto__c?: InputMaybe<Scalars["String"]>;
  billingcity?: InputMaybe<Scalars["String"]>;
  billingcountry?: InputMaybe<Scalars["String"]>;
  billingstate?: InputMaybe<Scalars["String"]>;
  effort?: InputMaybe<Scalars["numeric"]>;
  engagement?: InputMaybe<Scalars["numeric"]>;
  predct_proba?: InputMaybe<Scalars["numeric"]>;
};

/** Streaming cursor of the table "account_module_static" */
export type account_module_static_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: account_module_static_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type account_module_static_stream_cursor_value_input = {
  account_id?: InputMaybe<Scalars["String"]>;
  account_name?: InputMaybe<Scalars["String"]>;
  account_owner?: InputMaybe<Scalars["String"]>;
  account_status_auto__c?: InputMaybe<Scalars["String"]>;
  billingcity?: InputMaybe<Scalars["String"]>;
  billingcountry?: InputMaybe<Scalars["String"]>;
  billingstate?: InputMaybe<Scalars["String"]>;
  effort?: InputMaybe<Scalars["numeric"]>;
  engagement?: InputMaybe<Scalars["numeric"]>;
  predct_proba?: InputMaybe<Scalars["numeric"]>;
};

/** update columns of table "account_module_static" */
export enum account_module_static_update_column {
  /** column name */
  account_id = "account_id",
  /** column name */
  account_name = "account_name",
  /** column name */
  account_owner = "account_owner",
  /** column name */
  account_status_auto__c = "account_status_auto__c",
  /** column name */
  billingcity = "billingcity",
  /** column name */
  billingcountry = "billingcountry",
  /** column name */
  billingstate = "billingstate",
  /** column name */
  effort = "effort",
  /** column name */
  engagement = "engagement",
  /** column name */
  predct_proba = "predct_proba",
}

export type account_module_static_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<account_module_static_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<account_module_static_set_input>;
  where: account_module_static_bool_exp;
};

/** Ordering options when selecting data from "account". */
export type account_order_by = {
  account_module_static?: InputMaybe<account_module_static_order_by>;
  account_to_custom_account?: InputMaybe<account__c_order_by>;
  accountsource?: InputMaybe<order_by>;
  annualrevenue?: InputMaybe<order_by>;
  billingaddress?: InputMaybe<order_by>;
  billingcity?: InputMaybe<order_by>;
  billingcountry?: InputMaybe<order_by>;
  billinggeocodeaccuracy?: InputMaybe<order_by>;
  billinglatitude?: InputMaybe<order_by>;
  billinglongitude?: InputMaybe<order_by>;
  billingpostalcode?: InputMaybe<order_by>;
  billingstate?: InputMaybe<order_by>;
  billingstreet?: InputMaybe<order_by>;
  createdbyid?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  industry?: InputMaybe<order_by>;
  isdeleted?: InputMaybe<order_by>;
  jigsaw?: InputMaybe<order_by>;
  jigsawcompanyid?: InputMaybe<order_by>;
  lastactivitydate?: InputMaybe<order_by>;
  lastmodifiedbyid?: InputMaybe<order_by>;
  lastmodifieddate?: InputMaybe<order_by>;
  lastreferenceddate?: InputMaybe<order_by>;
  lastvieweddate?: InputMaybe<order_by>;
  masterrecordid?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  numberofemployees?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  parentid?: InputMaybe<order_by>;
  phone?: InputMaybe<order_by>;
  photourl?: InputMaybe<order_by>;
  shippingaddress?: InputMaybe<order_by>;
  shippingcity?: InputMaybe<order_by>;
  shippingcountry?: InputMaybe<order_by>;
  shippinggeocodeaccuracy?: InputMaybe<order_by>;
  shippinglatitude?: InputMaybe<order_by>;
  shippinglongitude?: InputMaybe<order_by>;
  shippingpostalcode?: InputMaybe<order_by>;
  shippingstate?: InputMaybe<order_by>;
  shippingstreet?: InputMaybe<order_by>;
  sicdesc?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  systemmodstamp?: InputMaybe<order_by>;
  tickersymbol?: InputMaybe<order_by>;
  to_revtron?: InputMaybe<crm_revtron_indexes_order_by>;
  type?: InputMaybe<order_by>;
  website?: InputMaybe<order_by>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type account_prepend_input = {
  billingaddress?: InputMaybe<Scalars["jsonb"]>;
  shippingaddress?: InputMaybe<Scalars["jsonb"]>;
};

/** select columns of table "account" */
export enum account_select_column {
  /** column name */
  accountsource = "accountsource",
  /** column name */
  annualrevenue = "annualrevenue",
  /** column name */
  billingaddress = "billingaddress",
  /** column name */
  billingcity = "billingcity",
  /** column name */
  billingcountry = "billingcountry",
  /** column name */
  billinggeocodeaccuracy = "billinggeocodeaccuracy",
  /** column name */
  billinglatitude = "billinglatitude",
  /** column name */
  billinglongitude = "billinglongitude",
  /** column name */
  billingpostalcode = "billingpostalcode",
  /** column name */
  billingstate = "billingstate",
  /** column name */
  billingstreet = "billingstreet",
  /** column name */
  createdbyid = "createdbyid",
  /** column name */
  createddate = "createddate",
  /** column name */
  description = "description",
  /** column name */
  id = "id",
  /** column name */
  industry = "industry",
  /** column name */
  isdeleted = "isdeleted",
  /** column name */
  jigsaw = "jigsaw",
  /** column name */
  jigsawcompanyid = "jigsawcompanyid",
  /** column name */
  lastactivitydate = "lastactivitydate",
  /** column name */
  lastmodifiedbyid = "lastmodifiedbyid",
  /** column name */
  lastmodifieddate = "lastmodifieddate",
  /** column name */
  lastreferenceddate = "lastreferenceddate",
  /** column name */
  lastvieweddate = "lastvieweddate",
  /** column name */
  masterrecordid = "masterrecordid",
  /** column name */
  name = "name",
  /** column name */
  numberofemployees = "numberofemployees",
  /** column name */
  ownerid = "ownerid",
  /** column name */
  parentid = "parentid",
  /** column name */
  phone = "phone",
  /** column name */
  photourl = "photourl",
  /** column name */
  shippingaddress = "shippingaddress",
  /** column name */
  shippingcity = "shippingcity",
  /** column name */
  shippingcountry = "shippingcountry",
  /** column name */
  shippinggeocodeaccuracy = "shippinggeocodeaccuracy",
  /** column name */
  shippinglatitude = "shippinglatitude",
  /** column name */
  shippinglongitude = "shippinglongitude",
  /** column name */
  shippingpostalcode = "shippingpostalcode",
  /** column name */
  shippingstate = "shippingstate",
  /** column name */
  shippingstreet = "shippingstreet",
  /** column name */
  sicdesc = "sicdesc",
  /** column name */
  sort_id = "sort_id",
  /** column name */
  systemmodstamp = "systemmodstamp",
  /** column name */
  tickersymbol = "tickersymbol",
  /** column name */
  type = "type",
  /** column name */
  website = "website",
}

/** input type for updating data in table "account" */
export type account_set_input = {
  accountsource?: InputMaybe<Scalars["String"]>;
  annualrevenue?: InputMaybe<Scalars["numeric"]>;
  billingaddress?: InputMaybe<Scalars["jsonb"]>;
  billingcity?: InputMaybe<Scalars["String"]>;
  billingcountry?: InputMaybe<Scalars["String"]>;
  billinggeocodeaccuracy?: InputMaybe<Scalars["String"]>;
  billinglatitude?: InputMaybe<Scalars["numeric"]>;
  billinglongitude?: InputMaybe<Scalars["numeric"]>;
  billingpostalcode?: InputMaybe<Scalars["String"]>;
  billingstate?: InputMaybe<Scalars["String"]>;
  billingstreet?: InputMaybe<Scalars["String"]>;
  createdbyid?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  description?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  industry?: InputMaybe<Scalars["String"]>;
  isdeleted?: InputMaybe<Scalars["Boolean"]>;
  jigsaw?: InputMaybe<Scalars["String"]>;
  jigsawcompanyid?: InputMaybe<Scalars["String"]>;
  lastactivitydate?: InputMaybe<Scalars["timestamp"]>;
  lastmodifiedbyid?: InputMaybe<Scalars["String"]>;
  lastmodifieddate?: InputMaybe<Scalars["timestamp"]>;
  lastreferenceddate?: InputMaybe<Scalars["timestamp"]>;
  lastvieweddate?: InputMaybe<Scalars["timestamp"]>;
  masterrecordid?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  numberofemployees?: InputMaybe<Scalars["Int"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  parentid?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  photourl?: InputMaybe<Scalars["String"]>;
  shippingaddress?: InputMaybe<Scalars["jsonb"]>;
  shippingcity?: InputMaybe<Scalars["String"]>;
  shippingcountry?: InputMaybe<Scalars["String"]>;
  shippinggeocodeaccuracy?: InputMaybe<Scalars["String"]>;
  shippinglatitude?: InputMaybe<Scalars["numeric"]>;
  shippinglongitude?: InputMaybe<Scalars["numeric"]>;
  shippingpostalcode?: InputMaybe<Scalars["String"]>;
  shippingstate?: InputMaybe<Scalars["String"]>;
  shippingstreet?: InputMaybe<Scalars["String"]>;
  sicdesc?: InputMaybe<Scalars["String"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  systemmodstamp?: InputMaybe<Scalars["timestamp"]>;
  tickersymbol?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Scalars["String"]>;
  website?: InputMaybe<Scalars["String"]>;
};

/** Streaming cursor of the table "account" */
export type account_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: account_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type account_stream_cursor_value_input = {
  accountsource?: InputMaybe<Scalars["String"]>;
  annualrevenue?: InputMaybe<Scalars["numeric"]>;
  billingaddress?: InputMaybe<Scalars["jsonb"]>;
  billingcity?: InputMaybe<Scalars["String"]>;
  billingcountry?: InputMaybe<Scalars["String"]>;
  billinggeocodeaccuracy?: InputMaybe<Scalars["String"]>;
  billinglatitude?: InputMaybe<Scalars["numeric"]>;
  billinglongitude?: InputMaybe<Scalars["numeric"]>;
  billingpostalcode?: InputMaybe<Scalars["String"]>;
  billingstate?: InputMaybe<Scalars["String"]>;
  billingstreet?: InputMaybe<Scalars["String"]>;
  createdbyid?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  description?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  industry?: InputMaybe<Scalars["String"]>;
  isdeleted?: InputMaybe<Scalars["Boolean"]>;
  jigsaw?: InputMaybe<Scalars["String"]>;
  jigsawcompanyid?: InputMaybe<Scalars["String"]>;
  lastactivitydate?: InputMaybe<Scalars["timestamp"]>;
  lastmodifiedbyid?: InputMaybe<Scalars["String"]>;
  lastmodifieddate?: InputMaybe<Scalars["timestamp"]>;
  lastreferenceddate?: InputMaybe<Scalars["timestamp"]>;
  lastvieweddate?: InputMaybe<Scalars["timestamp"]>;
  masterrecordid?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  numberofemployees?: InputMaybe<Scalars["Int"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  parentid?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  photourl?: InputMaybe<Scalars["String"]>;
  shippingaddress?: InputMaybe<Scalars["jsonb"]>;
  shippingcity?: InputMaybe<Scalars["String"]>;
  shippingcountry?: InputMaybe<Scalars["String"]>;
  shippinggeocodeaccuracy?: InputMaybe<Scalars["String"]>;
  shippinglatitude?: InputMaybe<Scalars["numeric"]>;
  shippinglongitude?: InputMaybe<Scalars["numeric"]>;
  shippingpostalcode?: InputMaybe<Scalars["String"]>;
  shippingstate?: InputMaybe<Scalars["String"]>;
  shippingstreet?: InputMaybe<Scalars["String"]>;
  sicdesc?: InputMaybe<Scalars["String"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  systemmodstamp?: InputMaybe<Scalars["timestamp"]>;
  tickersymbol?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Scalars["String"]>;
  website?: InputMaybe<Scalars["String"]>;
};

export type account_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<account_append_input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<account_delete_at_path_input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<account_delete_elem_input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<account_delete_key_input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<account_inc_input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<account_prepend_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<account_set_input>;
  where: account_bool_exp;
};

/** Boolean expression to filter rows from the table "actuals_vs_targets_activity". All fields are combined with a logical 'AND'. */
export type actuals_vs_targets_activity_bool_exp = {
  _and?: InputMaybe<Array<actuals_vs_targets_activity_bool_exp>>;
  _not?: InputMaybe<actuals_vs_targets_activity_bool_exp>;
  _or?: InputMaybe<Array<actuals_vs_targets_activity_bool_exp>>;
  calls?: InputMaybe<bigint_comparison_exp>;
  calls_out?: InputMaybe<bigint_comparison_exp>;
  email?: InputMaybe<String_comparison_exp>;
  emails?: InputMaybe<bigint_comparison_exp>;
  emails_sent?: InputMaybe<bigint_comparison_exp>;
  meetings_booked?: InputMaybe<Int_comparison_exp>;
  meetings_scheduled?: InputMaybe<float8_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  opportunities?: InputMaybe<float8_comparison_exp>;
  opportunity_create_count?: InputMaybe<bigint_comparison_exp>;
  ownerid?: InputMaybe<String_comparison_exp>;
  photo_url?: InputMaybe<String_comparison_exp>;
  social?: InputMaybe<bigint_comparison_exp>;
  social_target?: InputMaybe<bigint_comparison_exp>;
};

/** Ordering options when selecting data from "actuals_vs_targets_activity". */
export type actuals_vs_targets_activity_order_by = {
  calls?: InputMaybe<order_by>;
  calls_out?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  emails?: InputMaybe<order_by>;
  emails_sent?: InputMaybe<order_by>;
  meetings_booked?: InputMaybe<order_by>;
  meetings_scheduled?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  opportunities?: InputMaybe<order_by>;
  opportunity_create_count?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  photo_url?: InputMaybe<order_by>;
  social?: InputMaybe<order_by>;
  social_target?: InputMaybe<order_by>;
};

/** select columns of table "actuals_vs_targets_activity" */
export enum actuals_vs_targets_activity_select_column {
  /** column name */
  calls = "calls",
  /** column name */
  calls_out = "calls_out",
  /** column name */
  email = "email",
  /** column name */
  emails = "emails",
  /** column name */
  emails_sent = "emails_sent",
  /** column name */
  meetings_booked = "meetings_booked",
  /** column name */
  meetings_scheduled = "meetings_scheduled",
  /** column name */
  name = "name",
  /** column name */
  opportunities = "opportunities",
  /** column name */
  opportunity_create_count = "opportunity_create_count",
  /** column name */
  ownerid = "ownerid",
  /** column name */
  photo_url = "photo_url",
  /** column name */
  social = "social",
  /** column name */
  social_target = "social_target",
}

/** Streaming cursor of the table "actuals_vs_targets_activity" */
export type actuals_vs_targets_activity_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: actuals_vs_targets_activity_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type actuals_vs_targets_activity_stream_cursor_value_input = {
  calls?: InputMaybe<Scalars["bigint"]>;
  calls_out?: InputMaybe<Scalars["bigint"]>;
  email?: InputMaybe<Scalars["String"]>;
  emails?: InputMaybe<Scalars["bigint"]>;
  emails_sent?: InputMaybe<Scalars["bigint"]>;
  meetings_booked?: InputMaybe<Scalars["Int"]>;
  meetings_scheduled?: InputMaybe<Scalars["float8"]>;
  name?: InputMaybe<Scalars["String"]>;
  opportunities?: InputMaybe<Scalars["float8"]>;
  opportunity_create_count?: InputMaybe<Scalars["bigint"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  photo_url?: InputMaybe<Scalars["String"]>;
  social?: InputMaybe<Scalars["bigint"]>;
  social_target?: InputMaybe<Scalars["bigint"]>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type authProviderRequests_append_input = {
  options?: InputMaybe<Scalars["jsonb"]>;
};

/** Boolean expression to filter rows from the table "auth.provider_requests". All fields are combined with a logical 'AND'. */
export type authProviderRequests_bool_exp = {
  _and?: InputMaybe<Array<authProviderRequests_bool_exp>>;
  _not?: InputMaybe<authProviderRequests_bool_exp>;
  _or?: InputMaybe<Array<authProviderRequests_bool_exp>>;
  id?: InputMaybe<uuid_comparison_exp>;
  options?: InputMaybe<jsonb_comparison_exp>;
};

/** unique or primary key constraints on table "auth.provider_requests" */
export enum authProviderRequests_constraint {
  /** unique or primary key constraint on columns "id" */
  provider_requests_pkey = "provider_requests_pkey",
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type authProviderRequests_delete_at_path_input = {
  options?: InputMaybe<Array<Scalars["String"]>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type authProviderRequests_delete_elem_input = {
  options?: InputMaybe<Scalars["Int"]>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type authProviderRequests_delete_key_input = {
  options?: InputMaybe<Scalars["String"]>;
};

/** input type for inserting data into table "auth.provider_requests" */
export type authProviderRequests_insert_input = {
  id?: InputMaybe<Scalars["uuid"]>;
  options?: InputMaybe<Scalars["jsonb"]>;
};

/** on_conflict condition type for table "auth.provider_requests" */
export type authProviderRequests_on_conflict = {
  constraint: authProviderRequests_constraint;
  update_columns?: Array<authProviderRequests_update_column>;
  where?: InputMaybe<authProviderRequests_bool_exp>;
};

/** Ordering options when selecting data from "auth.provider_requests". */
export type authProviderRequests_order_by = {
  id?: InputMaybe<order_by>;
  options?: InputMaybe<order_by>;
};

/** primary key columns input for table: auth.provider_requests */
export type authProviderRequests_pk_columns_input = {
  id: Scalars["uuid"];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type authProviderRequests_prepend_input = {
  options?: InputMaybe<Scalars["jsonb"]>;
};

/** select columns of table "auth.provider_requests" */
export enum authProviderRequests_select_column {
  /** column name */
  id = "id",
  /** column name */
  options = "options",
}

/** input type for updating data in table "auth.provider_requests" */
export type authProviderRequests_set_input = {
  id?: InputMaybe<Scalars["uuid"]>;
  options?: InputMaybe<Scalars["jsonb"]>;
};

/** Streaming cursor of the table "authProviderRequests" */
export type authProviderRequests_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: authProviderRequests_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type authProviderRequests_stream_cursor_value_input = {
  id?: InputMaybe<Scalars["uuid"]>;
  options?: InputMaybe<Scalars["jsonb"]>;
};

/** update columns of table "auth.provider_requests" */
export enum authProviderRequests_update_column {
  /** column name */
  id = "id",
  /** column name */
  options = "options",
}

export type authProviderRequests_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<authProviderRequests_append_input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<authProviderRequests_delete_at_path_input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<authProviderRequests_delete_elem_input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<authProviderRequests_delete_key_input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<authProviderRequests_prepend_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<authProviderRequests_set_input>;
  where: authProviderRequests_bool_exp;
};

/** Boolean expression to filter rows from the table "auth.providers". All fields are combined with a logical 'AND'. */
export type authProviders_bool_exp = {
  _and?: InputMaybe<Array<authProviders_bool_exp>>;
  _not?: InputMaybe<authProviders_bool_exp>;
  _or?: InputMaybe<Array<authProviders_bool_exp>>;
  id?: InputMaybe<String_comparison_exp>;
  userProviders?: InputMaybe<authUserProviders_bool_exp>;
  userProviders_aggregate?: InputMaybe<authUserProviders_aggregate_bool_exp>;
};

/** unique or primary key constraints on table "auth.providers" */
export enum authProviders_constraint {
  /** unique or primary key constraint on columns "id" */
  providers_pkey = "providers_pkey",
}

/** input type for inserting data into table "auth.providers" */
export type authProviders_insert_input = {
  id?: InputMaybe<Scalars["String"]>;
  userProviders?: InputMaybe<authUserProviders_arr_rel_insert_input>;
};

/** input type for inserting object relation for remote table "auth.providers" */
export type authProviders_obj_rel_insert_input = {
  data: authProviders_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<authProviders_on_conflict>;
};

/** on_conflict condition type for table "auth.providers" */
export type authProviders_on_conflict = {
  constraint: authProviders_constraint;
  update_columns?: Array<authProviders_update_column>;
  where?: InputMaybe<authProviders_bool_exp>;
};

/** Ordering options when selecting data from "auth.providers". */
export type authProviders_order_by = {
  id?: InputMaybe<order_by>;
  userProviders_aggregate?: InputMaybe<authUserProviders_aggregate_order_by>;
};

/** primary key columns input for table: auth.providers */
export type authProviders_pk_columns_input = {
  id: Scalars["String"];
};

/** select columns of table "auth.providers" */
export enum authProviders_select_column {
  /** column name */
  id = "id",
}

/** input type for updating data in table "auth.providers" */
export type authProviders_set_input = {
  id?: InputMaybe<Scalars["String"]>;
};

/** Streaming cursor of the table "authProviders" */
export type authProviders_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: authProviders_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type authProviders_stream_cursor_value_input = {
  id?: InputMaybe<Scalars["String"]>;
};

/** update columns of table "auth.providers" */
export enum authProviders_update_column {
  /** column name */
  id = "id",
}

export type authProviders_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<authProviders_set_input>;
  where: authProviders_bool_exp;
};

export type authRefreshTokens_aggregate_bool_exp = {
  count?: InputMaybe<authRefreshTokens_aggregate_bool_exp_count>;
};

export type authRefreshTokens_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<authRefreshTokens_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<authRefreshTokens_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "auth.refresh_tokens" */
export type authRefreshTokens_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<authRefreshTokens_max_order_by>;
  min?: InputMaybe<authRefreshTokens_min_order_by>;
};

/** input type for inserting array relation for remote table "auth.refresh_tokens" */
export type authRefreshTokens_arr_rel_insert_input = {
  data: Array<authRefreshTokens_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<authRefreshTokens_on_conflict>;
};

/** Boolean expression to filter rows from the table "auth.refresh_tokens". All fields are combined with a logical 'AND'. */
export type authRefreshTokens_bool_exp = {
  _and?: InputMaybe<Array<authRefreshTokens_bool_exp>>;
  _not?: InputMaybe<authRefreshTokens_bool_exp>;
  _or?: InputMaybe<Array<authRefreshTokens_bool_exp>>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  expiresAt?: InputMaybe<timestamptz_comparison_exp>;
  refreshToken?: InputMaybe<uuid_comparison_exp>;
  refreshTokenHash?: InputMaybe<String_comparison_exp>;
  user?: InputMaybe<users_bool_exp>;
  userId?: InputMaybe<uuid_comparison_exp>;
};

/** unique or primary key constraints on table "auth.refresh_tokens" */
export enum authRefreshTokens_constraint {
  /** unique or primary key constraint on columns "refresh_token" */
  refresh_tokens_pkey = "refresh_tokens_pkey",
}

/** input type for inserting data into table "auth.refresh_tokens" */
export type authRefreshTokens_insert_input = {
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  expiresAt?: InputMaybe<Scalars["timestamptz"]>;
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken?: InputMaybe<Scalars["uuid"]>;
  user?: InputMaybe<users_obj_rel_insert_input>;
  userId?: InputMaybe<Scalars["uuid"]>;
};

/** order by max() on columns of table "auth.refresh_tokens" */
export type authRefreshTokens_max_order_by = {
  createdAt?: InputMaybe<order_by>;
  expiresAt?: InputMaybe<order_by>;
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken?: InputMaybe<order_by>;
  refreshTokenHash?: InputMaybe<order_by>;
  userId?: InputMaybe<order_by>;
};

/** order by min() on columns of table "auth.refresh_tokens" */
export type authRefreshTokens_min_order_by = {
  createdAt?: InputMaybe<order_by>;
  expiresAt?: InputMaybe<order_by>;
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken?: InputMaybe<order_by>;
  refreshTokenHash?: InputMaybe<order_by>;
  userId?: InputMaybe<order_by>;
};

/** on_conflict condition type for table "auth.refresh_tokens" */
export type authRefreshTokens_on_conflict = {
  constraint: authRefreshTokens_constraint;
  update_columns?: Array<authRefreshTokens_update_column>;
  where?: InputMaybe<authRefreshTokens_bool_exp>;
};

/** Ordering options when selecting data from "auth.refresh_tokens". */
export type authRefreshTokens_order_by = {
  createdAt?: InputMaybe<order_by>;
  expiresAt?: InputMaybe<order_by>;
  refreshToken?: InputMaybe<order_by>;
  refreshTokenHash?: InputMaybe<order_by>;
  user?: InputMaybe<users_order_by>;
  userId?: InputMaybe<order_by>;
};

/** primary key columns input for table: auth.refresh_tokens */
export type authRefreshTokens_pk_columns_input = {
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken: Scalars["uuid"];
};

/** select columns of table "auth.refresh_tokens" */
export enum authRefreshTokens_select_column {
  /** column name */
  createdAt = "createdAt",
  /** column name */
  expiresAt = "expiresAt",
  /** column name */
  refreshToken = "refreshToken",
  /** column name */
  refreshTokenHash = "refreshTokenHash",
  /** column name */
  userId = "userId",
}

/** input type for updating data in table "auth.refresh_tokens" */
export type authRefreshTokens_set_input = {
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  expiresAt?: InputMaybe<Scalars["timestamptz"]>;
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken?: InputMaybe<Scalars["uuid"]>;
  userId?: InputMaybe<Scalars["uuid"]>;
};

/** Streaming cursor of the table "authRefreshTokens" */
export type authRefreshTokens_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: authRefreshTokens_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type authRefreshTokens_stream_cursor_value_input = {
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  expiresAt?: InputMaybe<Scalars["timestamptz"]>;
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken?: InputMaybe<Scalars["uuid"]>;
  refreshTokenHash?: InputMaybe<Scalars["String"]>;
  userId?: InputMaybe<Scalars["uuid"]>;
};

/** update columns of table "auth.refresh_tokens" */
export enum authRefreshTokens_update_column {
  /** column name */
  createdAt = "createdAt",
  /** column name */
  expiresAt = "expiresAt",
  /** column name */
  refreshToken = "refreshToken",
  /** column name */
  userId = "userId",
}

export type authRefreshTokens_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<authRefreshTokens_set_input>;
  where: authRefreshTokens_bool_exp;
};

/** Boolean expression to filter rows from the table "auth.roles". All fields are combined with a logical 'AND'. */
export type authRoles_bool_exp = {
  _and?: InputMaybe<Array<authRoles_bool_exp>>;
  _not?: InputMaybe<authRoles_bool_exp>;
  _or?: InputMaybe<Array<authRoles_bool_exp>>;
  role?: InputMaybe<String_comparison_exp>;
  userRoles?: InputMaybe<authUserRoles_bool_exp>;
  userRoles_aggregate?: InputMaybe<authUserRoles_aggregate_bool_exp>;
  usersByDefaultRole?: InputMaybe<users_bool_exp>;
  usersByDefaultRole_aggregate?: InputMaybe<users_aggregate_bool_exp>;
};

/** unique or primary key constraints on table "auth.roles" */
export enum authRoles_constraint {
  /** unique or primary key constraint on columns "role" */
  roles_pkey = "roles_pkey",
}

/** input type for inserting data into table "auth.roles" */
export type authRoles_insert_input = {
  role?: InputMaybe<Scalars["String"]>;
  userRoles?: InputMaybe<authUserRoles_arr_rel_insert_input>;
  usersByDefaultRole?: InputMaybe<users_arr_rel_insert_input>;
};

/** input type for inserting object relation for remote table "auth.roles" */
export type authRoles_obj_rel_insert_input = {
  data: authRoles_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<authRoles_on_conflict>;
};

/** on_conflict condition type for table "auth.roles" */
export type authRoles_on_conflict = {
  constraint: authRoles_constraint;
  update_columns?: Array<authRoles_update_column>;
  where?: InputMaybe<authRoles_bool_exp>;
};

/** Ordering options when selecting data from "auth.roles". */
export type authRoles_order_by = {
  role?: InputMaybe<order_by>;
  userRoles_aggregate?: InputMaybe<authUserRoles_aggregate_order_by>;
  usersByDefaultRole_aggregate?: InputMaybe<users_aggregate_order_by>;
};

/** primary key columns input for table: auth.roles */
export type authRoles_pk_columns_input = {
  role: Scalars["String"];
};

/** select columns of table "auth.roles" */
export enum authRoles_select_column {
  /** column name */
  role = "role",
}

/** input type for updating data in table "auth.roles" */
export type authRoles_set_input = {
  role?: InputMaybe<Scalars["String"]>;
};

/** Streaming cursor of the table "authRoles" */
export type authRoles_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: authRoles_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type authRoles_stream_cursor_value_input = {
  role?: InputMaybe<Scalars["String"]>;
};

/** update columns of table "auth.roles" */
export enum authRoles_update_column {
  /** column name */
  role = "role",
}

export type authRoles_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<authRoles_set_input>;
  where: authRoles_bool_exp;
};

export type authUserProviders_aggregate_bool_exp = {
  count?: InputMaybe<authUserProviders_aggregate_bool_exp_count>;
};

export type authUserProviders_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<authUserProviders_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<authUserProviders_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "auth.user_providers" */
export type authUserProviders_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<authUserProviders_max_order_by>;
  min?: InputMaybe<authUserProviders_min_order_by>;
};

/** input type for inserting array relation for remote table "auth.user_providers" */
export type authUserProviders_arr_rel_insert_input = {
  data: Array<authUserProviders_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<authUserProviders_on_conflict>;
};

/** Boolean expression to filter rows from the table "auth.user_providers". All fields are combined with a logical 'AND'. */
export type authUserProviders_bool_exp = {
  _and?: InputMaybe<Array<authUserProviders_bool_exp>>;
  _not?: InputMaybe<authUserProviders_bool_exp>;
  _or?: InputMaybe<Array<authUserProviders_bool_exp>>;
  accessToken?: InputMaybe<String_comparison_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  provider?: InputMaybe<authProviders_bool_exp>;
  providerId?: InputMaybe<String_comparison_exp>;
  providerUserId?: InputMaybe<String_comparison_exp>;
  refreshToken?: InputMaybe<String_comparison_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<users_bool_exp>;
  userId?: InputMaybe<uuid_comparison_exp>;
};

/** unique or primary key constraints on table "auth.user_providers" */
export enum authUserProviders_constraint {
  /** unique or primary key constraint on columns "id" */
  user_providers_pkey = "user_providers_pkey",
  /** unique or primary key constraint on columns "provider_id", "provider_user_id" */
  user_providers_provider_id_provider_user_id_key = "user_providers_provider_id_provider_user_id_key",
  /** unique or primary key constraint on columns "provider_id", "user_id" */
  user_providers_user_id_provider_id_key = "user_providers_user_id_provider_id_key",
}

/** input type for inserting data into table "auth.user_providers" */
export type authUserProviders_insert_input = {
  accessToken?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  id?: InputMaybe<Scalars["uuid"]>;
  provider?: InputMaybe<authProviders_obj_rel_insert_input>;
  providerId?: InputMaybe<Scalars["String"]>;
  providerUserId?: InputMaybe<Scalars["String"]>;
  refreshToken?: InputMaybe<Scalars["String"]>;
  updatedAt?: InputMaybe<Scalars["timestamptz"]>;
  user?: InputMaybe<users_obj_rel_insert_input>;
  userId?: InputMaybe<Scalars["uuid"]>;
};

/** order by max() on columns of table "auth.user_providers" */
export type authUserProviders_max_order_by = {
  accessToken?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  providerId?: InputMaybe<order_by>;
  providerUserId?: InputMaybe<order_by>;
  refreshToken?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  userId?: InputMaybe<order_by>;
};

/** order by min() on columns of table "auth.user_providers" */
export type authUserProviders_min_order_by = {
  accessToken?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  providerId?: InputMaybe<order_by>;
  providerUserId?: InputMaybe<order_by>;
  refreshToken?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  userId?: InputMaybe<order_by>;
};

/** on_conflict condition type for table "auth.user_providers" */
export type authUserProviders_on_conflict = {
  constraint: authUserProviders_constraint;
  update_columns?: Array<authUserProviders_update_column>;
  where?: InputMaybe<authUserProviders_bool_exp>;
};

/** Ordering options when selecting data from "auth.user_providers". */
export type authUserProviders_order_by = {
  accessToken?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  provider?: InputMaybe<authProviders_order_by>;
  providerId?: InputMaybe<order_by>;
  providerUserId?: InputMaybe<order_by>;
  refreshToken?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  user?: InputMaybe<users_order_by>;
  userId?: InputMaybe<order_by>;
};

/** primary key columns input for table: auth.user_providers */
export type authUserProviders_pk_columns_input = {
  id: Scalars["uuid"];
};

/** select columns of table "auth.user_providers" */
export enum authUserProviders_select_column {
  /** column name */
  accessToken = "accessToken",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  id = "id",
  /** column name */
  providerId = "providerId",
  /** column name */
  providerUserId = "providerUserId",
  /** column name */
  refreshToken = "refreshToken",
  /** column name */
  updatedAt = "updatedAt",
  /** column name */
  userId = "userId",
}

/** input type for updating data in table "auth.user_providers" */
export type authUserProviders_set_input = {
  accessToken?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  id?: InputMaybe<Scalars["uuid"]>;
  providerId?: InputMaybe<Scalars["String"]>;
  providerUserId?: InputMaybe<Scalars["String"]>;
  refreshToken?: InputMaybe<Scalars["String"]>;
  updatedAt?: InputMaybe<Scalars["timestamptz"]>;
  userId?: InputMaybe<Scalars["uuid"]>;
};

/** Streaming cursor of the table "authUserProviders" */
export type authUserProviders_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: authUserProviders_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type authUserProviders_stream_cursor_value_input = {
  accessToken?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  id?: InputMaybe<Scalars["uuid"]>;
  providerId?: InputMaybe<Scalars["String"]>;
  providerUserId?: InputMaybe<Scalars["String"]>;
  refreshToken?: InputMaybe<Scalars["String"]>;
  updatedAt?: InputMaybe<Scalars["timestamptz"]>;
  userId?: InputMaybe<Scalars["uuid"]>;
};

/** update columns of table "auth.user_providers" */
export enum authUserProviders_update_column {
  /** column name */
  accessToken = "accessToken",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  id = "id",
  /** column name */
  providerId = "providerId",
  /** column name */
  providerUserId = "providerUserId",
  /** column name */
  refreshToken = "refreshToken",
  /** column name */
  updatedAt = "updatedAt",
  /** column name */
  userId = "userId",
}

export type authUserProviders_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<authUserProviders_set_input>;
  where: authUserProviders_bool_exp;
};

export type authUserRoles_aggregate_bool_exp = {
  count?: InputMaybe<authUserRoles_aggregate_bool_exp_count>;
};

export type authUserRoles_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<authUserRoles_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<authUserRoles_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "auth.user_roles" */
export type authUserRoles_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<authUserRoles_max_order_by>;
  min?: InputMaybe<authUserRoles_min_order_by>;
};

/** input type for inserting array relation for remote table "auth.user_roles" */
export type authUserRoles_arr_rel_insert_input = {
  data: Array<authUserRoles_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<authUserRoles_on_conflict>;
};

/** Boolean expression to filter rows from the table "auth.user_roles". All fields are combined with a logical 'AND'. */
export type authUserRoles_bool_exp = {
  _and?: InputMaybe<Array<authUserRoles_bool_exp>>;
  _not?: InputMaybe<authUserRoles_bool_exp>;
  _or?: InputMaybe<Array<authUserRoles_bool_exp>>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  role?: InputMaybe<String_comparison_exp>;
  roleByRole?: InputMaybe<authRoles_bool_exp>;
  user?: InputMaybe<users_bool_exp>;
  userId?: InputMaybe<uuid_comparison_exp>;
};

/** unique or primary key constraints on table "auth.user_roles" */
export enum authUserRoles_constraint {
  /** unique or primary key constraint on columns "id" */
  user_roles_pkey = "user_roles_pkey",
  /** unique or primary key constraint on columns "user_id", "role" */
  user_roles_user_id_role_key = "user_roles_user_id_role_key",
}

/** input type for inserting data into table "auth.user_roles" */
export type authUserRoles_insert_input = {
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  id?: InputMaybe<Scalars["uuid"]>;
  role?: InputMaybe<Scalars["String"]>;
  roleByRole?: InputMaybe<authRoles_obj_rel_insert_input>;
  user?: InputMaybe<users_obj_rel_insert_input>;
  userId?: InputMaybe<Scalars["uuid"]>;
};

/** order by max() on columns of table "auth.user_roles" */
export type authUserRoles_max_order_by = {
  createdAt?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  role?: InputMaybe<order_by>;
  userId?: InputMaybe<order_by>;
};

/** order by min() on columns of table "auth.user_roles" */
export type authUserRoles_min_order_by = {
  createdAt?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  role?: InputMaybe<order_by>;
  userId?: InputMaybe<order_by>;
};

/** on_conflict condition type for table "auth.user_roles" */
export type authUserRoles_on_conflict = {
  constraint: authUserRoles_constraint;
  update_columns?: Array<authUserRoles_update_column>;
  where?: InputMaybe<authUserRoles_bool_exp>;
};

/** Ordering options when selecting data from "auth.user_roles". */
export type authUserRoles_order_by = {
  createdAt?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  role?: InputMaybe<order_by>;
  roleByRole?: InputMaybe<authRoles_order_by>;
  user?: InputMaybe<users_order_by>;
  userId?: InputMaybe<order_by>;
};

/** primary key columns input for table: auth.user_roles */
export type authUserRoles_pk_columns_input = {
  id: Scalars["uuid"];
};

/** select columns of table "auth.user_roles" */
export enum authUserRoles_select_column {
  /** column name */
  createdAt = "createdAt",
  /** column name */
  id = "id",
  /** column name */
  role = "role",
  /** column name */
  userId = "userId",
}

/** input type for updating data in table "auth.user_roles" */
export type authUserRoles_set_input = {
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  id?: InputMaybe<Scalars["uuid"]>;
  role?: InputMaybe<Scalars["String"]>;
  userId?: InputMaybe<Scalars["uuid"]>;
};

/** Streaming cursor of the table "authUserRoles" */
export type authUserRoles_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: authUserRoles_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type authUserRoles_stream_cursor_value_input = {
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  id?: InputMaybe<Scalars["uuid"]>;
  role?: InputMaybe<Scalars["String"]>;
  userId?: InputMaybe<Scalars["uuid"]>;
};

/** update columns of table "auth.user_roles" */
export enum authUserRoles_update_column {
  /** column name */
  createdAt = "createdAt",
  /** column name */
  id = "id",
  /** column name */
  role = "role",
  /** column name */
  userId = "userId",
}

export type authUserRoles_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<authUserRoles_set_input>;
  where: authUserRoles_bool_exp;
};

export type authUserSecurityKeys_aggregate_bool_exp = {
  count?: InputMaybe<authUserSecurityKeys_aggregate_bool_exp_count>;
};

export type authUserSecurityKeys_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<authUserSecurityKeys_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<authUserSecurityKeys_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "auth.user_security_keys" */
export type authUserSecurityKeys_aggregate_order_by = {
  avg?: InputMaybe<authUserSecurityKeys_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<authUserSecurityKeys_max_order_by>;
  min?: InputMaybe<authUserSecurityKeys_min_order_by>;
  stddev?: InputMaybe<authUserSecurityKeys_stddev_order_by>;
  stddev_pop?: InputMaybe<authUserSecurityKeys_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<authUserSecurityKeys_stddev_samp_order_by>;
  sum?: InputMaybe<authUserSecurityKeys_sum_order_by>;
  var_pop?: InputMaybe<authUserSecurityKeys_var_pop_order_by>;
  var_samp?: InputMaybe<authUserSecurityKeys_var_samp_order_by>;
  variance?: InputMaybe<authUserSecurityKeys_variance_order_by>;
};

/** input type for inserting array relation for remote table "auth.user_security_keys" */
export type authUserSecurityKeys_arr_rel_insert_input = {
  data: Array<authUserSecurityKeys_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<authUserSecurityKeys_on_conflict>;
};

/** order by avg() on columns of table "auth.user_security_keys" */
export type authUserSecurityKeys_avg_order_by = {
  counter?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "auth.user_security_keys". All fields are combined with a logical 'AND'. */
export type authUserSecurityKeys_bool_exp = {
  _and?: InputMaybe<Array<authUserSecurityKeys_bool_exp>>;
  _not?: InputMaybe<authUserSecurityKeys_bool_exp>;
  _or?: InputMaybe<Array<authUserSecurityKeys_bool_exp>>;
  counter?: InputMaybe<bigint_comparison_exp>;
  credentialId?: InputMaybe<String_comparison_exp>;
  credentialPublicKey?: InputMaybe<bytea_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  nickname?: InputMaybe<String_comparison_exp>;
  transports?: InputMaybe<String_comparison_exp>;
  user?: InputMaybe<users_bool_exp>;
  userId?: InputMaybe<uuid_comparison_exp>;
};

/** unique or primary key constraints on table "auth.user_security_keys" */
export enum authUserSecurityKeys_constraint {
  /** unique or primary key constraint on columns "credential_id" */
  user_security_key_credential_id_key = "user_security_key_credential_id_key",
  /** unique or primary key constraint on columns "id" */
  user_security_keys_pkey = "user_security_keys_pkey",
}

/** input type for incrementing numeric columns in table "auth.user_security_keys" */
export type authUserSecurityKeys_inc_input = {
  counter?: InputMaybe<Scalars["bigint"]>;
};

/** input type for inserting data into table "auth.user_security_keys" */
export type authUserSecurityKeys_insert_input = {
  counter?: InputMaybe<Scalars["bigint"]>;
  credentialId?: InputMaybe<Scalars["String"]>;
  credentialPublicKey?: InputMaybe<Scalars["bytea"]>;
  id?: InputMaybe<Scalars["uuid"]>;
  nickname?: InputMaybe<Scalars["String"]>;
  transports?: InputMaybe<Scalars["String"]>;
  user?: InputMaybe<users_obj_rel_insert_input>;
  userId?: InputMaybe<Scalars["uuid"]>;
};

/** order by max() on columns of table "auth.user_security_keys" */
export type authUserSecurityKeys_max_order_by = {
  counter?: InputMaybe<order_by>;
  credentialId?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  nickname?: InputMaybe<order_by>;
  transports?: InputMaybe<order_by>;
  userId?: InputMaybe<order_by>;
};

/** order by min() on columns of table "auth.user_security_keys" */
export type authUserSecurityKeys_min_order_by = {
  counter?: InputMaybe<order_by>;
  credentialId?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  nickname?: InputMaybe<order_by>;
  transports?: InputMaybe<order_by>;
  userId?: InputMaybe<order_by>;
};

/** on_conflict condition type for table "auth.user_security_keys" */
export type authUserSecurityKeys_on_conflict = {
  constraint: authUserSecurityKeys_constraint;
  update_columns?: Array<authUserSecurityKeys_update_column>;
  where?: InputMaybe<authUserSecurityKeys_bool_exp>;
};

/** Ordering options when selecting data from "auth.user_security_keys". */
export type authUserSecurityKeys_order_by = {
  counter?: InputMaybe<order_by>;
  credentialId?: InputMaybe<order_by>;
  credentialPublicKey?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  nickname?: InputMaybe<order_by>;
  transports?: InputMaybe<order_by>;
  user?: InputMaybe<users_order_by>;
  userId?: InputMaybe<order_by>;
};

/** primary key columns input for table: auth.user_security_keys */
export type authUserSecurityKeys_pk_columns_input = {
  id: Scalars["uuid"];
};

/** select columns of table "auth.user_security_keys" */
export enum authUserSecurityKeys_select_column {
  /** column name */
  counter = "counter",
  /** column name */
  credentialId = "credentialId",
  /** column name */
  credentialPublicKey = "credentialPublicKey",
  /** column name */
  id = "id",
  /** column name */
  nickname = "nickname",
  /** column name */
  transports = "transports",
  /** column name */
  userId = "userId",
}

/** input type for updating data in table "auth.user_security_keys" */
export type authUserSecurityKeys_set_input = {
  counter?: InputMaybe<Scalars["bigint"]>;
  credentialId?: InputMaybe<Scalars["String"]>;
  credentialPublicKey?: InputMaybe<Scalars["bytea"]>;
  id?: InputMaybe<Scalars["uuid"]>;
  nickname?: InputMaybe<Scalars["String"]>;
  transports?: InputMaybe<Scalars["String"]>;
  userId?: InputMaybe<Scalars["uuid"]>;
};

/** order by stddev() on columns of table "auth.user_security_keys" */
export type authUserSecurityKeys_stddev_order_by = {
  counter?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "auth.user_security_keys" */
export type authUserSecurityKeys_stddev_pop_order_by = {
  counter?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "auth.user_security_keys" */
export type authUserSecurityKeys_stddev_samp_order_by = {
  counter?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "authUserSecurityKeys" */
export type authUserSecurityKeys_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: authUserSecurityKeys_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type authUserSecurityKeys_stream_cursor_value_input = {
  counter?: InputMaybe<Scalars["bigint"]>;
  credentialId?: InputMaybe<Scalars["String"]>;
  credentialPublicKey?: InputMaybe<Scalars["bytea"]>;
  id?: InputMaybe<Scalars["uuid"]>;
  nickname?: InputMaybe<Scalars["String"]>;
  transports?: InputMaybe<Scalars["String"]>;
  userId?: InputMaybe<Scalars["uuid"]>;
};

/** order by sum() on columns of table "auth.user_security_keys" */
export type authUserSecurityKeys_sum_order_by = {
  counter?: InputMaybe<order_by>;
};

/** update columns of table "auth.user_security_keys" */
export enum authUserSecurityKeys_update_column {
  /** column name */
  counter = "counter",
  /** column name */
  credentialId = "credentialId",
  /** column name */
  credentialPublicKey = "credentialPublicKey",
  /** column name */
  id = "id",
  /** column name */
  nickname = "nickname",
  /** column name */
  transports = "transports",
  /** column name */
  userId = "userId",
}

export type authUserSecurityKeys_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<authUserSecurityKeys_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<authUserSecurityKeys_set_input>;
  where: authUserSecurityKeys_bool_exp;
};

/** order by var_pop() on columns of table "auth.user_security_keys" */
export type authUserSecurityKeys_var_pop_order_by = {
  counter?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "auth.user_security_keys" */
export type authUserSecurityKeys_var_samp_order_by = {
  counter?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "auth.user_security_keys" */
export type authUserSecurityKeys_variance_order_by = {
  counter?: InputMaybe<order_by>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type bigint_comparison_exp = {
  _eq?: InputMaybe<Scalars["bigint"]>;
  _gt?: InputMaybe<Scalars["bigint"]>;
  _gte?: InputMaybe<Scalars["bigint"]>;
  _in?: InputMaybe<Array<Scalars["bigint"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["bigint"]>;
  _lte?: InputMaybe<Scalars["bigint"]>;
  _neq?: InputMaybe<Scalars["bigint"]>;
  _nin?: InputMaybe<Array<Scalars["bigint"]>>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type bigint_comparison_exp_remote_rel_crm_revtron_indexesto_revtron_company =
  {
    _gt?: InputMaybe<Scalars["_bigint"]>;
    _gte?: InputMaybe<Scalars["_bigint"]>;
    _in?: InputMaybe<Array<Scalars["_bigint"]>>;
    _is_null?: InputMaybe<Scalars["Boolean"]>;
    _lt?: InputMaybe<Scalars["_bigint"]>;
    _lte?: InputMaybe<Scalars["_bigint"]>;
    _neq?: InputMaybe<Scalars["_bigint"]>;
    _nin?: InputMaybe<Array<Scalars["_bigint"]>>;
  };

/** Boolean expression to filter rows from the table "bookings_by_owner_gql". All fields are combined with a logical 'AND'. */
export type bookings_by_owner_gql_bool_exp = {
  _and?: InputMaybe<Array<bookings_by_owner_gql_bool_exp>>;
  _not?: InputMaybe<bookings_by_owner_gql_bool_exp>;
  _or?: InputMaybe<Array<bookings_by_owner_gql_bool_exp>>;
  bookings?: InputMaybe<numeric_comparison_exp>;
  photo_url?: InputMaybe<String_comparison_exp>;
  team_member?: InputMaybe<String_comparison_exp>;
  userid?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "bookings_by_owner_gql". */
export type bookings_by_owner_gql_order_by = {
  bookings?: InputMaybe<order_by>;
  photo_url?: InputMaybe<order_by>;
  team_member?: InputMaybe<order_by>;
  userid?: InputMaybe<order_by>;
};

/** select columns of table "bookings_by_owner_gql" */
export enum bookings_by_owner_gql_select_column {
  /** column name */
  bookings = "bookings",
  /** column name */
  photo_url = "photo_url",
  /** column name */
  team_member = "team_member",
  /** column name */
  userid = "userid",
}

/** Streaming cursor of the table "bookings_by_owner_gql" */
export type bookings_by_owner_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: bookings_by_owner_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type bookings_by_owner_gql_stream_cursor_value_input = {
  bookings?: InputMaybe<Scalars["numeric"]>;
  photo_url?: InputMaybe<Scalars["String"]>;
  team_member?: InputMaybe<Scalars["String"]>;
  userid?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "storage.buckets". All fields are combined with a logical 'AND'. */
export type buckets_bool_exp = {
  _and?: InputMaybe<Array<buckets_bool_exp>>;
  _not?: InputMaybe<buckets_bool_exp>;
  _or?: InputMaybe<Array<buckets_bool_exp>>;
  cacheControl?: InputMaybe<String_comparison_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  downloadExpiration?: InputMaybe<Int_comparison_exp>;
  files?: InputMaybe<files_bool_exp>;
  files_aggregate?: InputMaybe<files_aggregate_bool_exp>;
  id?: InputMaybe<String_comparison_exp>;
  maxUploadFileSize?: InputMaybe<Int_comparison_exp>;
  minUploadFileSize?: InputMaybe<Int_comparison_exp>;
  presignedUrlsEnabled?: InputMaybe<Boolean_comparison_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
};

/** unique or primary key constraints on table "storage.buckets" */
export enum buckets_constraint {
  /** unique or primary key constraint on columns "id" */
  buckets_pkey = "buckets_pkey",
}

/** input type for incrementing numeric columns in table "storage.buckets" */
export type buckets_inc_input = {
  downloadExpiration?: InputMaybe<Scalars["Int"]>;
  maxUploadFileSize?: InputMaybe<Scalars["Int"]>;
  minUploadFileSize?: InputMaybe<Scalars["Int"]>;
};

/** input type for inserting data into table "storage.buckets" */
export type buckets_insert_input = {
  cacheControl?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  downloadExpiration?: InputMaybe<Scalars["Int"]>;
  files?: InputMaybe<files_arr_rel_insert_input>;
  id?: InputMaybe<Scalars["String"]>;
  maxUploadFileSize?: InputMaybe<Scalars["Int"]>;
  minUploadFileSize?: InputMaybe<Scalars["Int"]>;
  presignedUrlsEnabled?: InputMaybe<Scalars["Boolean"]>;
  updatedAt?: InputMaybe<Scalars["timestamptz"]>;
};

/** input type for inserting object relation for remote table "storage.buckets" */
export type buckets_obj_rel_insert_input = {
  data: buckets_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<buckets_on_conflict>;
};

/** on_conflict condition type for table "storage.buckets" */
export type buckets_on_conflict = {
  constraint: buckets_constraint;
  update_columns?: Array<buckets_update_column>;
  where?: InputMaybe<buckets_bool_exp>;
};

/** Ordering options when selecting data from "storage.buckets". */
export type buckets_order_by = {
  cacheControl?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  downloadExpiration?: InputMaybe<order_by>;
  files_aggregate?: InputMaybe<files_aggregate_order_by>;
  id?: InputMaybe<order_by>;
  maxUploadFileSize?: InputMaybe<order_by>;
  minUploadFileSize?: InputMaybe<order_by>;
  presignedUrlsEnabled?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** primary key columns input for table: storage.buckets */
export type buckets_pk_columns_input = {
  id: Scalars["String"];
};

/** select columns of table "storage.buckets" */
export enum buckets_select_column {
  /** column name */
  cacheControl = "cacheControl",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  downloadExpiration = "downloadExpiration",
  /** column name */
  id = "id",
  /** column name */
  maxUploadFileSize = "maxUploadFileSize",
  /** column name */
  minUploadFileSize = "minUploadFileSize",
  /** column name */
  presignedUrlsEnabled = "presignedUrlsEnabled",
  /** column name */
  updatedAt = "updatedAt",
}

/** input type for updating data in table "storage.buckets" */
export type buckets_set_input = {
  cacheControl?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  downloadExpiration?: InputMaybe<Scalars["Int"]>;
  id?: InputMaybe<Scalars["String"]>;
  maxUploadFileSize?: InputMaybe<Scalars["Int"]>;
  minUploadFileSize?: InputMaybe<Scalars["Int"]>;
  presignedUrlsEnabled?: InputMaybe<Scalars["Boolean"]>;
  updatedAt?: InputMaybe<Scalars["timestamptz"]>;
};

/** Streaming cursor of the table "buckets" */
export type buckets_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: buckets_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type buckets_stream_cursor_value_input = {
  cacheControl?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  downloadExpiration?: InputMaybe<Scalars["Int"]>;
  id?: InputMaybe<Scalars["String"]>;
  maxUploadFileSize?: InputMaybe<Scalars["Int"]>;
  minUploadFileSize?: InputMaybe<Scalars["Int"]>;
  presignedUrlsEnabled?: InputMaybe<Scalars["Boolean"]>;
  updatedAt?: InputMaybe<Scalars["timestamptz"]>;
};

/** update columns of table "storage.buckets" */
export enum buckets_update_column {
  /** column name */
  cacheControl = "cacheControl",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  downloadExpiration = "downloadExpiration",
  /** column name */
  id = "id",
  /** column name */
  maxUploadFileSize = "maxUploadFileSize",
  /** column name */
  minUploadFileSize = "minUploadFileSize",
  /** column name */
  presignedUrlsEnabled = "presignedUrlsEnabled",
  /** column name */
  updatedAt = "updatedAt",
}

export type buckets_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<buckets_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<buckets_set_input>;
  where: buckets_bool_exp;
};

/** Boolean expression to compare columns of type "bytea". All fields are combined with logical 'AND'. */
export type bytea_comparison_exp = {
  _eq?: InputMaybe<Scalars["bytea"]>;
  _gt?: InputMaybe<Scalars["bytea"]>;
  _gte?: InputMaybe<Scalars["bytea"]>;
  _in?: InputMaybe<Array<Scalars["bytea"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["bytea"]>;
  _lte?: InputMaybe<Scalars["bytea"]>;
  _neq?: InputMaybe<Scalars["bytea"]>;
  _nin?: InputMaybe<Array<Scalars["bytea"]>>;
};

/** Boolean expression to filter rows from the table "calendar_gql_clean". All fields are combined with a logical 'AND'. */
export type calendar_gql_clean_bool_exp = {
  _and?: InputMaybe<Array<calendar_gql_clean_bool_exp>>;
  _not?: InputMaybe<calendar_gql_clean_bool_exp>;
  _or?: InputMaybe<Array<calendar_gql_clean_bool_exp>>;
  account_name?: InputMaybe<String_comparison_exp>;
  amount?: InputMaybe<numeric_comparison_exp>;
  enddatetime?: InputMaybe<timestamp_comparison_exp>;
  meeting_key?: InputMaybe<bigint_comparison_exp>;
  meeting_owner?: InputMaybe<String_comparison_exp>;
  meeting_owner_id?: InputMaybe<String_comparison_exp>;
  opportunity_name?: InputMaybe<String_comparison_exp>;
  probability?: InputMaybe<numeric_comparison_exp>;
  stagename?: InputMaybe<String_comparison_exp>;
  startdatetime?: InputMaybe<timestamp_comparison_exp>;
  subject?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "calendar_gql_clean". */
export type calendar_gql_clean_order_by = {
  account_name?: InputMaybe<order_by>;
  amount?: InputMaybe<order_by>;
  enddatetime?: InputMaybe<order_by>;
  meeting_key?: InputMaybe<order_by>;
  meeting_owner?: InputMaybe<order_by>;
  meeting_owner_id?: InputMaybe<order_by>;
  opportunity_name?: InputMaybe<order_by>;
  probability?: InputMaybe<order_by>;
  stagename?: InputMaybe<order_by>;
  startdatetime?: InputMaybe<order_by>;
  subject?: InputMaybe<order_by>;
};

/** select columns of table "calendar_gql_clean" */
export enum calendar_gql_clean_select_column {
  /** column name */
  account_name = "account_name",
  /** column name */
  amount = "amount",
  /** column name */
  enddatetime = "enddatetime",
  /** column name */
  meeting_key = "meeting_key",
  /** column name */
  meeting_owner = "meeting_owner",
  /** column name */
  meeting_owner_id = "meeting_owner_id",
  /** column name */
  opportunity_name = "opportunity_name",
  /** column name */
  probability = "probability",
  /** column name */
  stagename = "stagename",
  /** column name */
  startdatetime = "startdatetime",
  /** column name */
  subject = "subject",
}

/** Streaming cursor of the table "calendar_gql_clean" */
export type calendar_gql_clean_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: calendar_gql_clean_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type calendar_gql_clean_stream_cursor_value_input = {
  account_name?: InputMaybe<Scalars["String"]>;
  amount?: InputMaybe<Scalars["numeric"]>;
  enddatetime?: InputMaybe<Scalars["timestamp"]>;
  meeting_key?: InputMaybe<Scalars["bigint"]>;
  meeting_owner?: InputMaybe<Scalars["String"]>;
  meeting_owner_id?: InputMaybe<Scalars["String"]>;
  opportunity_name?: InputMaybe<Scalars["String"]>;
  probability?: InputMaybe<Scalars["numeric"]>;
  stagename?: InputMaybe<Scalars["String"]>;
  startdatetime?: InputMaybe<Scalars["timestamp"]>;
  subject?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "calendar_meeting_owner_gql". All fields are combined with a logical 'AND'. */
export type calendar_meeting_owner_gql_bool_exp = {
  _and?: InputMaybe<Array<calendar_meeting_owner_gql_bool_exp>>;
  _not?: InputMaybe<calendar_meeting_owner_gql_bool_exp>;
  _or?: InputMaybe<Array<calendar_meeting_owner_gql_bool_exp>>;
  meeting_owner?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "calendar_meeting_owner_gql". */
export type calendar_meeting_owner_gql_order_by = {
  meeting_owner?: InputMaybe<order_by>;
};

/** select columns of table "calendar_meeting_owner_gql" */
export enum calendar_meeting_owner_gql_select_column {
  /** column name */
  meeting_owner = "meeting_owner",
}

/** Streaming cursor of the table "calendar_meeting_owner_gql" */
export type calendar_meeting_owner_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: calendar_meeting_owner_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type calendar_meeting_owner_gql_stream_cursor_value_input = {
  meeting_owner?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "calendar_stagename_gql". All fields are combined with a logical 'AND'. */
export type calendar_stagename_gql_bool_exp = {
  _and?: InputMaybe<Array<calendar_stagename_gql_bool_exp>>;
  _not?: InputMaybe<calendar_stagename_gql_bool_exp>;
  _or?: InputMaybe<Array<calendar_stagename_gql_bool_exp>>;
  stagename?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "calendar_stagename_gql". */
export type calendar_stagename_gql_order_by = {
  stagename?: InputMaybe<order_by>;
};

/** select columns of table "calendar_stagename_gql" */
export enum calendar_stagename_gql_select_column {
  /** column name */
  stagename = "stagename",
}

/** Streaming cursor of the table "calendar_stagename_gql" */
export type calendar_stagename_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: calendar_stagename_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type calendar_stagename_gql_stream_cursor_value_input = {
  stagename?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to compare columns of type "citext". All fields are combined with logical 'AND'. */
export type citext_comparison_exp = {
  _eq?: InputMaybe<Scalars["citext"]>;
  _gt?: InputMaybe<Scalars["citext"]>;
  _gte?: InputMaybe<Scalars["citext"]>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars["citext"]>;
  _in?: InputMaybe<Array<Scalars["citext"]>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars["citext"]>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars["citext"]>;
  _lt?: InputMaybe<Scalars["citext"]>;
  _lte?: InputMaybe<Scalars["citext"]>;
  _neq?: InputMaybe<Scalars["citext"]>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars["citext"]>;
  _nin?: InputMaybe<Array<Scalars["citext"]>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars["citext"]>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars["citext"]>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars["citext"]>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars["citext"]>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars["citext"]>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars["citext"]>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type contacts_append_input = {
  mailingaddress?: InputMaybe<Scalars["jsonb"]>;
};

/** Boolean expression to filter rows from the table "contacts". All fields are combined with a logical 'AND'. */
export type contacts_bool_exp = {
  _and?: InputMaybe<Array<contacts_bool_exp>>;
  _not?: InputMaybe<contacts_bool_exp>;
  _or?: InputMaybe<Array<contacts_bool_exp>>;
  accountid?: InputMaybe<String_comparison_exp>;
  createdbyid?: InputMaybe<String_comparison_exp>;
  createddate?: InputMaybe<timestamp_comparison_exp>;
  department?: InputMaybe<String_comparison_exp>;
  description?: InputMaybe<String_comparison_exp>;
  email?: InputMaybe<String_comparison_exp>;
  emailbounceddate?: InputMaybe<timestamp_comparison_exp>;
  emailbouncedreason?: InputMaybe<String_comparison_exp>;
  fax?: InputMaybe<String_comparison_exp>;
  firstname?: InputMaybe<String_comparison_exp>;
  hasoptedoutofemail?: InputMaybe<Boolean_comparison_exp>;
  id?: InputMaybe<String_comparison_exp>;
  isdeleted?: InputMaybe<Boolean_comparison_exp>;
  isemailbounced?: InputMaybe<Boolean_comparison_exp>;
  jigsaw?: InputMaybe<String_comparison_exp>;
  jigsawcontactid?: InputMaybe<String_comparison_exp>;
  lastactivitydate?: InputMaybe<timestamp_comparison_exp>;
  lastcurequestdate?: InputMaybe<timestamp_comparison_exp>;
  lastcuupdatedate?: InputMaybe<timestamp_comparison_exp>;
  lastmodifiedbyid?: InputMaybe<String_comparison_exp>;
  lastmodifieddate?: InputMaybe<timestamp_comparison_exp>;
  lastname?: InputMaybe<String_comparison_exp>;
  lastreferenceddate?: InputMaybe<timestamp_comparison_exp>;
  lastvieweddate?: InputMaybe<timestamp_comparison_exp>;
  leadsource?: InputMaybe<String_comparison_exp>;
  mailingaddress?: InputMaybe<jsonb_comparison_exp>;
  mailingcity?: InputMaybe<String_comparison_exp>;
  mailingcountry?: InputMaybe<String_comparison_exp>;
  mailinggeocodeaccuracy?: InputMaybe<String_comparison_exp>;
  mailinglatitude?: InputMaybe<numeric_comparison_exp>;
  mailinglongitude?: InputMaybe<numeric_comparison_exp>;
  mailingpostalcode?: InputMaybe<String_comparison_exp>;
  mailingstate?: InputMaybe<String_comparison_exp>;
  mailingstreet?: InputMaybe<String_comparison_exp>;
  masterrecordid?: InputMaybe<String_comparison_exp>;
  middlename?: InputMaybe<String_comparison_exp>;
  mobilephone?: InputMaybe<String_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  ownerid?: InputMaybe<String_comparison_exp>;
  phone?: InputMaybe<String_comparison_exp>;
  photourl?: InputMaybe<String_comparison_exp>;
  reportstoid?: InputMaybe<String_comparison_exp>;
  salutation?: InputMaybe<String_comparison_exp>;
  sort_id?: InputMaybe<Int_comparison_exp>;
  suffix?: InputMaybe<String_comparison_exp>;
  systemmodstamp?: InputMaybe<timestamp_comparison_exp>;
  title?: InputMaybe<String_comparison_exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type contacts_delete_at_path_input = {
  mailingaddress?: InputMaybe<Array<Scalars["String"]>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type contacts_delete_elem_input = {
  mailingaddress?: InputMaybe<Scalars["Int"]>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type contacts_delete_key_input = {
  mailingaddress?: InputMaybe<Scalars["String"]>;
};

/** input type for incrementing numeric columns in table "contacts" */
export type contacts_inc_input = {
  mailinglatitude?: InputMaybe<Scalars["numeric"]>;
  mailinglongitude?: InputMaybe<Scalars["numeric"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
};

/** input type for inserting data into table "contacts" */
export type contacts_insert_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  createdbyid?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  department?: InputMaybe<Scalars["String"]>;
  description?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["String"]>;
  emailbounceddate?: InputMaybe<Scalars["timestamp"]>;
  emailbouncedreason?: InputMaybe<Scalars["String"]>;
  fax?: InputMaybe<Scalars["String"]>;
  firstname?: InputMaybe<Scalars["String"]>;
  hasoptedoutofemail?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["String"]>;
  isdeleted?: InputMaybe<Scalars["Boolean"]>;
  isemailbounced?: InputMaybe<Scalars["Boolean"]>;
  jigsaw?: InputMaybe<Scalars["String"]>;
  jigsawcontactid?: InputMaybe<Scalars["String"]>;
  lastactivitydate?: InputMaybe<Scalars["timestamp"]>;
  lastcurequestdate?: InputMaybe<Scalars["timestamp"]>;
  lastcuupdatedate?: InputMaybe<Scalars["timestamp"]>;
  lastmodifiedbyid?: InputMaybe<Scalars["String"]>;
  lastmodifieddate?: InputMaybe<Scalars["timestamp"]>;
  lastname?: InputMaybe<Scalars["String"]>;
  lastreferenceddate?: InputMaybe<Scalars["timestamp"]>;
  lastvieweddate?: InputMaybe<Scalars["timestamp"]>;
  leadsource?: InputMaybe<Scalars["String"]>;
  mailingaddress?: InputMaybe<Scalars["jsonb"]>;
  mailingcity?: InputMaybe<Scalars["String"]>;
  mailingcountry?: InputMaybe<Scalars["String"]>;
  mailinggeocodeaccuracy?: InputMaybe<Scalars["String"]>;
  mailinglatitude?: InputMaybe<Scalars["numeric"]>;
  mailinglongitude?: InputMaybe<Scalars["numeric"]>;
  mailingpostalcode?: InputMaybe<Scalars["String"]>;
  mailingstate?: InputMaybe<Scalars["String"]>;
  mailingstreet?: InputMaybe<Scalars["String"]>;
  masterrecordid?: InputMaybe<Scalars["String"]>;
  middlename?: InputMaybe<Scalars["String"]>;
  mobilephone?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  photourl?: InputMaybe<Scalars["String"]>;
  reportstoid?: InputMaybe<Scalars["String"]>;
  salutation?: InputMaybe<Scalars["String"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  suffix?: InputMaybe<Scalars["String"]>;
  systemmodstamp?: InputMaybe<Scalars["timestamp"]>;
  title?: InputMaybe<Scalars["String"]>;
};

/** Ordering options when selecting data from "contacts". */
export type contacts_order_by = {
  accountid?: InputMaybe<order_by>;
  createdbyid?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  department?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  emailbounceddate?: InputMaybe<order_by>;
  emailbouncedreason?: InputMaybe<order_by>;
  fax?: InputMaybe<order_by>;
  firstname?: InputMaybe<order_by>;
  hasoptedoutofemail?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  isdeleted?: InputMaybe<order_by>;
  isemailbounced?: InputMaybe<order_by>;
  jigsaw?: InputMaybe<order_by>;
  jigsawcontactid?: InputMaybe<order_by>;
  lastactivitydate?: InputMaybe<order_by>;
  lastcurequestdate?: InputMaybe<order_by>;
  lastcuupdatedate?: InputMaybe<order_by>;
  lastmodifiedbyid?: InputMaybe<order_by>;
  lastmodifieddate?: InputMaybe<order_by>;
  lastname?: InputMaybe<order_by>;
  lastreferenceddate?: InputMaybe<order_by>;
  lastvieweddate?: InputMaybe<order_by>;
  leadsource?: InputMaybe<order_by>;
  mailingaddress?: InputMaybe<order_by>;
  mailingcity?: InputMaybe<order_by>;
  mailingcountry?: InputMaybe<order_by>;
  mailinggeocodeaccuracy?: InputMaybe<order_by>;
  mailinglatitude?: InputMaybe<order_by>;
  mailinglongitude?: InputMaybe<order_by>;
  mailingpostalcode?: InputMaybe<order_by>;
  mailingstate?: InputMaybe<order_by>;
  mailingstreet?: InputMaybe<order_by>;
  masterrecordid?: InputMaybe<order_by>;
  middlename?: InputMaybe<order_by>;
  mobilephone?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  phone?: InputMaybe<order_by>;
  photourl?: InputMaybe<order_by>;
  reportstoid?: InputMaybe<order_by>;
  salutation?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  suffix?: InputMaybe<order_by>;
  systemmodstamp?: InputMaybe<order_by>;
  title?: InputMaybe<order_by>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type contacts_prepend_input = {
  mailingaddress?: InputMaybe<Scalars["jsonb"]>;
};

/** select columns of table "contacts" */
export enum contacts_select_column {
  /** column name */
  accountid = "accountid",
  /** column name */
  createdbyid = "createdbyid",
  /** column name */
  createddate = "createddate",
  /** column name */
  department = "department",
  /** column name */
  description = "description",
  /** column name */
  email = "email",
  /** column name */
  emailbounceddate = "emailbounceddate",
  /** column name */
  emailbouncedreason = "emailbouncedreason",
  /** column name */
  fax = "fax",
  /** column name */
  firstname = "firstname",
  /** column name */
  hasoptedoutofemail = "hasoptedoutofemail",
  /** column name */
  id = "id",
  /** column name */
  isdeleted = "isdeleted",
  /** column name */
  isemailbounced = "isemailbounced",
  /** column name */
  jigsaw = "jigsaw",
  /** column name */
  jigsawcontactid = "jigsawcontactid",
  /** column name */
  lastactivitydate = "lastactivitydate",
  /** column name */
  lastcurequestdate = "lastcurequestdate",
  /** column name */
  lastcuupdatedate = "lastcuupdatedate",
  /** column name */
  lastmodifiedbyid = "lastmodifiedbyid",
  /** column name */
  lastmodifieddate = "lastmodifieddate",
  /** column name */
  lastname = "lastname",
  /** column name */
  lastreferenceddate = "lastreferenceddate",
  /** column name */
  lastvieweddate = "lastvieweddate",
  /** column name */
  leadsource = "leadsource",
  /** column name */
  mailingaddress = "mailingaddress",
  /** column name */
  mailingcity = "mailingcity",
  /** column name */
  mailingcountry = "mailingcountry",
  /** column name */
  mailinggeocodeaccuracy = "mailinggeocodeaccuracy",
  /** column name */
  mailinglatitude = "mailinglatitude",
  /** column name */
  mailinglongitude = "mailinglongitude",
  /** column name */
  mailingpostalcode = "mailingpostalcode",
  /** column name */
  mailingstate = "mailingstate",
  /** column name */
  mailingstreet = "mailingstreet",
  /** column name */
  masterrecordid = "masterrecordid",
  /** column name */
  middlename = "middlename",
  /** column name */
  mobilephone = "mobilephone",
  /** column name */
  name = "name",
  /** column name */
  ownerid = "ownerid",
  /** column name */
  phone = "phone",
  /** column name */
  photourl = "photourl",
  /** column name */
  reportstoid = "reportstoid",
  /** column name */
  salutation = "salutation",
  /** column name */
  sort_id = "sort_id",
  /** column name */
  suffix = "suffix",
  /** column name */
  systemmodstamp = "systemmodstamp",
  /** column name */
  title = "title",
}

/** input type for updating data in table "contacts" */
export type contacts_set_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  createdbyid?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  department?: InputMaybe<Scalars["String"]>;
  description?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["String"]>;
  emailbounceddate?: InputMaybe<Scalars["timestamp"]>;
  emailbouncedreason?: InputMaybe<Scalars["String"]>;
  fax?: InputMaybe<Scalars["String"]>;
  firstname?: InputMaybe<Scalars["String"]>;
  hasoptedoutofemail?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["String"]>;
  isdeleted?: InputMaybe<Scalars["Boolean"]>;
  isemailbounced?: InputMaybe<Scalars["Boolean"]>;
  jigsaw?: InputMaybe<Scalars["String"]>;
  jigsawcontactid?: InputMaybe<Scalars["String"]>;
  lastactivitydate?: InputMaybe<Scalars["timestamp"]>;
  lastcurequestdate?: InputMaybe<Scalars["timestamp"]>;
  lastcuupdatedate?: InputMaybe<Scalars["timestamp"]>;
  lastmodifiedbyid?: InputMaybe<Scalars["String"]>;
  lastmodifieddate?: InputMaybe<Scalars["timestamp"]>;
  lastname?: InputMaybe<Scalars["String"]>;
  lastreferenceddate?: InputMaybe<Scalars["timestamp"]>;
  lastvieweddate?: InputMaybe<Scalars["timestamp"]>;
  leadsource?: InputMaybe<Scalars["String"]>;
  mailingaddress?: InputMaybe<Scalars["jsonb"]>;
  mailingcity?: InputMaybe<Scalars["String"]>;
  mailingcountry?: InputMaybe<Scalars["String"]>;
  mailinggeocodeaccuracy?: InputMaybe<Scalars["String"]>;
  mailinglatitude?: InputMaybe<Scalars["numeric"]>;
  mailinglongitude?: InputMaybe<Scalars["numeric"]>;
  mailingpostalcode?: InputMaybe<Scalars["String"]>;
  mailingstate?: InputMaybe<Scalars["String"]>;
  mailingstreet?: InputMaybe<Scalars["String"]>;
  masterrecordid?: InputMaybe<Scalars["String"]>;
  middlename?: InputMaybe<Scalars["String"]>;
  mobilephone?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  photourl?: InputMaybe<Scalars["String"]>;
  reportstoid?: InputMaybe<Scalars["String"]>;
  salutation?: InputMaybe<Scalars["String"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  suffix?: InputMaybe<Scalars["String"]>;
  systemmodstamp?: InputMaybe<Scalars["timestamp"]>;
  title?: InputMaybe<Scalars["String"]>;
};

/** Streaming cursor of the table "contacts" */
export type contacts_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: contacts_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type contacts_stream_cursor_value_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  createdbyid?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  department?: InputMaybe<Scalars["String"]>;
  description?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["String"]>;
  emailbounceddate?: InputMaybe<Scalars["timestamp"]>;
  emailbouncedreason?: InputMaybe<Scalars["String"]>;
  fax?: InputMaybe<Scalars["String"]>;
  firstname?: InputMaybe<Scalars["String"]>;
  hasoptedoutofemail?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["String"]>;
  isdeleted?: InputMaybe<Scalars["Boolean"]>;
  isemailbounced?: InputMaybe<Scalars["Boolean"]>;
  jigsaw?: InputMaybe<Scalars["String"]>;
  jigsawcontactid?: InputMaybe<Scalars["String"]>;
  lastactivitydate?: InputMaybe<Scalars["timestamp"]>;
  lastcurequestdate?: InputMaybe<Scalars["timestamp"]>;
  lastcuupdatedate?: InputMaybe<Scalars["timestamp"]>;
  lastmodifiedbyid?: InputMaybe<Scalars["String"]>;
  lastmodifieddate?: InputMaybe<Scalars["timestamp"]>;
  lastname?: InputMaybe<Scalars["String"]>;
  lastreferenceddate?: InputMaybe<Scalars["timestamp"]>;
  lastvieweddate?: InputMaybe<Scalars["timestamp"]>;
  leadsource?: InputMaybe<Scalars["String"]>;
  mailingaddress?: InputMaybe<Scalars["jsonb"]>;
  mailingcity?: InputMaybe<Scalars["String"]>;
  mailingcountry?: InputMaybe<Scalars["String"]>;
  mailinggeocodeaccuracy?: InputMaybe<Scalars["String"]>;
  mailinglatitude?: InputMaybe<Scalars["numeric"]>;
  mailinglongitude?: InputMaybe<Scalars["numeric"]>;
  mailingpostalcode?: InputMaybe<Scalars["String"]>;
  mailingstate?: InputMaybe<Scalars["String"]>;
  mailingstreet?: InputMaybe<Scalars["String"]>;
  masterrecordid?: InputMaybe<Scalars["String"]>;
  middlename?: InputMaybe<Scalars["String"]>;
  mobilephone?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  photourl?: InputMaybe<Scalars["String"]>;
  reportstoid?: InputMaybe<Scalars["String"]>;
  salutation?: InputMaybe<Scalars["String"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  suffix?: InputMaybe<Scalars["String"]>;
  systemmodstamp?: InputMaybe<Scalars["timestamp"]>;
  title?: InputMaybe<Scalars["String"]>;
};

export type contacts_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<contacts_append_input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<contacts_delete_at_path_input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<contacts_delete_elem_input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<contacts_delete_key_input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<contacts_inc_input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<contacts_prepend_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<contacts_set_input>;
  where: contacts_bool_exp;
};

/** Boolean expression to filter rows from the table "crm_account_mappings". All fields are combined with a logical 'AND'. */
export type crm_account_mappings_bool_exp = {
  _and?: InputMaybe<Array<crm_account_mappings_bool_exp>>;
  _not?: InputMaybe<crm_account_mappings_bool_exp>;
  _or?: InputMaybe<Array<crm_account_mappings_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  crm_field?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<bigint_comparison_exp>;
  is_active?: InputMaybe<Boolean_comparison_exp>;
  method?: InputMaybe<String_comparison_exp>;
  revtron_field?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** unique or primary key constraints on table "crm_account_mappings" */
export enum crm_account_mappings_constraint {
  /** unique or primary key constraint on columns "crm_field" */
  crm_account_mappings_crm_field_key = "crm_account_mappings_crm_field_key",
  /** unique or primary key constraint on columns "id" */
  crm_account_mappings_pkey = "crm_account_mappings_pkey",
}

/** input type for incrementing numeric columns in table "crm_account_mappings" */
export type crm_account_mappings_inc_input = {
  id?: InputMaybe<Scalars["bigint"]>;
};

/** input type for inserting data into table "crm_account_mappings" */
export type crm_account_mappings_insert_input = {
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  crm_field?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  is_active?: InputMaybe<Scalars["Boolean"]>;
  method?: InputMaybe<Scalars["String"]>;
  revtron_field?: InputMaybe<Scalars["String"]>;
  updated_at?: InputMaybe<Scalars["timestamptz"]>;
};

/** on_conflict condition type for table "crm_account_mappings" */
export type crm_account_mappings_on_conflict = {
  constraint: crm_account_mappings_constraint;
  update_columns?: Array<crm_account_mappings_update_column>;
  where?: InputMaybe<crm_account_mappings_bool_exp>;
};

/** Ordering options when selecting data from "crm_account_mappings". */
export type crm_account_mappings_order_by = {
  created_at?: InputMaybe<order_by>;
  crm_field?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  is_active?: InputMaybe<order_by>;
  method?: InputMaybe<order_by>;
  revtron_field?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** primary key columns input for table: crm_account_mappings */
export type crm_account_mappings_pk_columns_input = {
  id: Scalars["bigint"];
};

/** select columns of table "crm_account_mappings" */
export enum crm_account_mappings_select_column {
  /** column name */
  created_at = "created_at",
  /** column name */
  crm_field = "crm_field",
  /** column name */
  id = "id",
  /** column name */
  is_active = "is_active",
  /** column name */
  method = "method",
  /** column name */
  revtron_field = "revtron_field",
  /** column name */
  updated_at = "updated_at",
}

/** input type for updating data in table "crm_account_mappings" */
export type crm_account_mappings_set_input = {
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  crm_field?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  is_active?: InputMaybe<Scalars["Boolean"]>;
  method?: InputMaybe<Scalars["String"]>;
  revtron_field?: InputMaybe<Scalars["String"]>;
  updated_at?: InputMaybe<Scalars["timestamptz"]>;
};

/** Streaming cursor of the table "crm_account_mappings" */
export type crm_account_mappings_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: crm_account_mappings_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type crm_account_mappings_stream_cursor_value_input = {
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  crm_field?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  is_active?: InputMaybe<Scalars["Boolean"]>;
  method?: InputMaybe<Scalars["String"]>;
  revtron_field?: InputMaybe<Scalars["String"]>;
  updated_at?: InputMaybe<Scalars["timestamptz"]>;
};

/** update columns of table "crm_account_mappings" */
export enum crm_account_mappings_update_column {
  /** column name */
  created_at = "created_at",
  /** column name */
  crm_field = "crm_field",
  /** column name */
  id = "id",
  /** column name */
  is_active = "is_active",
  /** column name */
  method = "method",
  /** column name */
  revtron_field = "revtron_field",
  /** column name */
  updated_at = "updated_at",
}

export type crm_account_mappings_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<crm_account_mappings_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<crm_account_mappings_set_input>;
  where: crm_account_mappings_bool_exp;
};

/** Boolean expression to filter rows from the table "crm_contact_mappings". All fields are combined with a logical 'AND'. */
export type crm_contact_mappings_bool_exp = {
  _and?: InputMaybe<Array<crm_contact_mappings_bool_exp>>;
  _not?: InputMaybe<crm_contact_mappings_bool_exp>;
  _or?: InputMaybe<Array<crm_contact_mappings_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  crm_field?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<bigint_comparison_exp>;
  is_active?: InputMaybe<Boolean_comparison_exp>;
  method?: InputMaybe<String_comparison_exp>;
  revtron_field?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** unique or primary key constraints on table "crm_contact_mappings" */
export enum crm_contact_mappings_constraint {
  /** unique or primary key constraint on columns "crm_field" */
  crm_contact_mappings_crm_field_key = "crm_contact_mappings_crm_field_key",
  /** unique or primary key constraint on columns "id" */
  crm_contact_mappings_pkey = "crm_contact_mappings_pkey",
}

/** input type for incrementing numeric columns in table "crm_contact_mappings" */
export type crm_contact_mappings_inc_input = {
  id?: InputMaybe<Scalars["bigint"]>;
};

/** input type for inserting data into table "crm_contact_mappings" */
export type crm_contact_mappings_insert_input = {
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  crm_field?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  is_active?: InputMaybe<Scalars["Boolean"]>;
  method?: InputMaybe<Scalars["String"]>;
  revtron_field?: InputMaybe<Scalars["String"]>;
  updated_at?: InputMaybe<Scalars["timestamptz"]>;
};

/** on_conflict condition type for table "crm_contact_mappings" */
export type crm_contact_mappings_on_conflict = {
  constraint: crm_contact_mappings_constraint;
  update_columns?: Array<crm_contact_mappings_update_column>;
  where?: InputMaybe<crm_contact_mappings_bool_exp>;
};

/** Ordering options when selecting data from "crm_contact_mappings". */
export type crm_contact_mappings_order_by = {
  created_at?: InputMaybe<order_by>;
  crm_field?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  is_active?: InputMaybe<order_by>;
  method?: InputMaybe<order_by>;
  revtron_field?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** primary key columns input for table: crm_contact_mappings */
export type crm_contact_mappings_pk_columns_input = {
  id: Scalars["bigint"];
};

/** select columns of table "crm_contact_mappings" */
export enum crm_contact_mappings_select_column {
  /** column name */
  created_at = "created_at",
  /** column name */
  crm_field = "crm_field",
  /** column name */
  id = "id",
  /** column name */
  is_active = "is_active",
  /** column name */
  method = "method",
  /** column name */
  revtron_field = "revtron_field",
  /** column name */
  updated_at = "updated_at",
}

/** input type for updating data in table "crm_contact_mappings" */
export type crm_contact_mappings_set_input = {
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  crm_field?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  is_active?: InputMaybe<Scalars["Boolean"]>;
  method?: InputMaybe<Scalars["String"]>;
  revtron_field?: InputMaybe<Scalars["String"]>;
  updated_at?: InputMaybe<Scalars["timestamptz"]>;
};

/** Streaming cursor of the table "crm_contact_mappings" */
export type crm_contact_mappings_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: crm_contact_mappings_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type crm_contact_mappings_stream_cursor_value_input = {
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  crm_field?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  is_active?: InputMaybe<Scalars["Boolean"]>;
  method?: InputMaybe<Scalars["String"]>;
  revtron_field?: InputMaybe<Scalars["String"]>;
  updated_at?: InputMaybe<Scalars["timestamptz"]>;
};

/** update columns of table "crm_contact_mappings" */
export enum crm_contact_mappings_update_column {
  /** column name */
  created_at = "created_at",
  /** column name */
  crm_field = "crm_field",
  /** column name */
  id = "id",
  /** column name */
  is_active = "is_active",
  /** column name */
  method = "method",
  /** column name */
  revtron_field = "revtron_field",
  /** column name */
  updated_at = "updated_at",
}

export type crm_contact_mappings_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<crm_contact_mappings_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<crm_contact_mappings_set_input>;
  where: crm_contact_mappings_bool_exp;
};

/** Boolean expression to filter rows from the table "crm_revtron_indexes". All fields are combined with a logical 'AND'. */
export type crm_revtron_indexes_bool_exp = {
  _and?: InputMaybe<Array<crm_revtron_indexes_bool_exp>>;
  _not?: InputMaybe<crm_revtron_indexes_bool_exp>;
  _or?: InputMaybe<Array<crm_revtron_indexes_bool_exp>>;
  crm_id?: InputMaybe<String_comparison_exp>;
  revtron_id?: InputMaybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "crm_revtron_indexes" */
export enum crm_revtron_indexes_constraint {
  /** unique or primary key constraint on columns "revtron_id", "crm_id" */
  crm_revtron_indexes_pkey = "crm_revtron_indexes_pkey",
}

/** input type for inserting data into table "crm_revtron_indexes" */
export type crm_revtron_indexes_insert_input = {
  crm_id?: InputMaybe<Scalars["String"]>;
  revtron_id?: InputMaybe<Scalars["String"]>;
};

/** input type for inserting object relation for remote table "crm_revtron_indexes" */
export type crm_revtron_indexes_obj_rel_insert_input = {
  data: crm_revtron_indexes_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<crm_revtron_indexes_on_conflict>;
};

/** on_conflict condition type for table "crm_revtron_indexes" */
export type crm_revtron_indexes_on_conflict = {
  constraint: crm_revtron_indexes_constraint;
  update_columns?: Array<crm_revtron_indexes_update_column>;
  where?: InputMaybe<crm_revtron_indexes_bool_exp>;
};

/** Ordering options when selecting data from "crm_revtron_indexes". */
export type crm_revtron_indexes_order_by = {
  crm_id?: InputMaybe<order_by>;
  revtron_id?: InputMaybe<order_by>;
};

/** primary key columns input for table: crm_revtron_indexes */
export type crm_revtron_indexes_pk_columns_input = {
  crm_id: Scalars["String"];
  revtron_id: Scalars["String"];
};

/** select columns of table "crm_revtron_indexes" */
export enum crm_revtron_indexes_select_column {
  /** column name */
  crm_id = "crm_id",
  /** column name */
  revtron_id = "revtron_id",
}

/** input type for updating data in table "crm_revtron_indexes" */
export type crm_revtron_indexes_set_input = {
  crm_id?: InputMaybe<Scalars["String"]>;
  revtron_id?: InputMaybe<Scalars["String"]>;
};

/** Streaming cursor of the table "crm_revtron_indexes" */
export type crm_revtron_indexes_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: crm_revtron_indexes_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type crm_revtron_indexes_stream_cursor_value_input = {
  crm_id?: InputMaybe<Scalars["String"]>;
  revtron_id?: InputMaybe<Scalars["String"]>;
};

/** update columns of table "crm_revtron_indexes" */
export enum crm_revtron_indexes_update_column {
  /** column name */
  crm_id = "crm_id",
  /** column name */
  revtron_id = "revtron_id",
}

export type crm_revtron_indexes_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<crm_revtron_indexes_set_input>;
  where: crm_revtron_indexes_bool_exp;
};

export type crm_to_revtron_account_aggregate_bool_exp = {
  count?: InputMaybe<crm_to_revtron_account_aggregate_bool_exp_count>;
};

export type crm_to_revtron_account_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<crm_to_revtron_account_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<crm_to_revtron_account_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "crm_to_revtron_account" */
export type crm_to_revtron_account_aggregate_order_by = {
  avg?: InputMaybe<crm_to_revtron_account_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<crm_to_revtron_account_max_order_by>;
  min?: InputMaybe<crm_to_revtron_account_min_order_by>;
  stddev?: InputMaybe<crm_to_revtron_account_stddev_order_by>;
  stddev_pop?: InputMaybe<crm_to_revtron_account_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<crm_to_revtron_account_stddev_samp_order_by>;
  sum?: InputMaybe<crm_to_revtron_account_sum_order_by>;
  var_pop?: InputMaybe<crm_to_revtron_account_var_pop_order_by>;
  var_samp?: InputMaybe<crm_to_revtron_account_var_samp_order_by>;
  variance?: InputMaybe<crm_to_revtron_account_variance_order_by>;
};

/** input type for inserting array relation for remote table "crm_to_revtron_account" */
export type crm_to_revtron_account_arr_rel_insert_input = {
  data: Array<crm_to_revtron_account_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<crm_to_revtron_account_on_conflict>;
};

/** order by avg() on columns of table "crm_to_revtron_account" */
export type crm_to_revtron_account_avg_order_by = {
  match_count?: InputMaybe<order_by>;
  revtron_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "crm_to_revtron_account". All fields are combined with a logical 'AND'. */
export type crm_to_revtron_account_bool_exp = {
  _and?: InputMaybe<Array<crm_to_revtron_account_bool_exp>>;
  _not?: InputMaybe<crm_to_revtron_account_bool_exp>;
  _or?: InputMaybe<Array<crm_to_revtron_account_bool_exp>>;
  crm_id?: InputMaybe<String_comparison_exp>;
  match_count?: InputMaybe<Int_comparison_exp>;
  match_type?: InputMaybe<String_comparison_exp>;
  revtron_id?: InputMaybe<Int_comparison_exp>;
  to_crm_index?: InputMaybe<crm_to_revtron_account_bool_exp>;
  to_crm_index_aggregate?: InputMaybe<crm_to_revtron_account_aggregate_bool_exp>;
};

/** unique or primary key constraints on table "crm_to_revtron_account" */
export enum crm_to_revtron_account_constraint {
  /** unique or primary key constraint on columns "revtron_id", "crm_id" */
  crm_to_revtron_account_pkey = "crm_to_revtron_account_pkey",
}

/** input type for incrementing numeric columns in table "crm_to_revtron_account" */
export type crm_to_revtron_account_inc_input = {
  match_count?: InputMaybe<Scalars["Int"]>;
  revtron_id?: InputMaybe<Scalars["Int"]>;
};

/** input type for inserting data into table "crm_to_revtron_account" */
export type crm_to_revtron_account_insert_input = {
  crm_id?: InputMaybe<Scalars["String"]>;
  match_count?: InputMaybe<Scalars["Int"]>;
  match_type?: InputMaybe<Scalars["String"]>;
  revtron_id?: InputMaybe<Scalars["Int"]>;
  to_crm_index?: InputMaybe<crm_to_revtron_account_arr_rel_insert_input>;
};

/** order by max() on columns of table "crm_to_revtron_account" */
export type crm_to_revtron_account_max_order_by = {
  crm_id?: InputMaybe<order_by>;
  match_count?: InputMaybe<order_by>;
  match_type?: InputMaybe<order_by>;
  revtron_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "crm_to_revtron_account" */
export type crm_to_revtron_account_min_order_by = {
  crm_id?: InputMaybe<order_by>;
  match_count?: InputMaybe<order_by>;
  match_type?: InputMaybe<order_by>;
  revtron_id?: InputMaybe<order_by>;
};

/** input type for inserting object relation for remote table "crm_to_revtron_account" */
export type crm_to_revtron_account_obj_rel_insert_input = {
  data: crm_to_revtron_account_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<crm_to_revtron_account_on_conflict>;
};

/** on_conflict condition type for table "crm_to_revtron_account" */
export type crm_to_revtron_account_on_conflict = {
  constraint: crm_to_revtron_account_constraint;
  update_columns?: Array<crm_to_revtron_account_update_column>;
  where?: InputMaybe<crm_to_revtron_account_bool_exp>;
};

/** Ordering options when selecting data from "crm_to_revtron_account". */
export type crm_to_revtron_account_order_by = {
  crm_id?: InputMaybe<order_by>;
  match_count?: InputMaybe<order_by>;
  match_type?: InputMaybe<order_by>;
  revtron_id?: InputMaybe<order_by>;
  to_crm_index_aggregate?: InputMaybe<crm_to_revtron_account_aggregate_order_by>;
};

/** primary key columns input for table: crm_to_revtron_account */
export type crm_to_revtron_account_pk_columns_input = {
  crm_id: Scalars["String"];
  revtron_id: Scalars["Int"];
};

/** select columns of table "crm_to_revtron_account" */
export enum crm_to_revtron_account_select_column {
  /** column name */
  crm_id = "crm_id",
  /** column name */
  match_count = "match_count",
  /** column name */
  match_type = "match_type",
  /** column name */
  revtron_id = "revtron_id",
}

/** input type for updating data in table "crm_to_revtron_account" */
export type crm_to_revtron_account_set_input = {
  crm_id?: InputMaybe<Scalars["String"]>;
  match_count?: InputMaybe<Scalars["Int"]>;
  match_type?: InputMaybe<Scalars["String"]>;
  revtron_id?: InputMaybe<Scalars["Int"]>;
};

/** order by stddev() on columns of table "crm_to_revtron_account" */
export type crm_to_revtron_account_stddev_order_by = {
  match_count?: InputMaybe<order_by>;
  revtron_id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "crm_to_revtron_account" */
export type crm_to_revtron_account_stddev_pop_order_by = {
  match_count?: InputMaybe<order_by>;
  revtron_id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "crm_to_revtron_account" */
export type crm_to_revtron_account_stddev_samp_order_by = {
  match_count?: InputMaybe<order_by>;
  revtron_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "crm_to_revtron_account" */
export type crm_to_revtron_account_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: crm_to_revtron_account_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type crm_to_revtron_account_stream_cursor_value_input = {
  crm_id?: InputMaybe<Scalars["String"]>;
  match_count?: InputMaybe<Scalars["Int"]>;
  match_type?: InputMaybe<Scalars["String"]>;
  revtron_id?: InputMaybe<Scalars["Int"]>;
};

/** order by sum() on columns of table "crm_to_revtron_account" */
export type crm_to_revtron_account_sum_order_by = {
  match_count?: InputMaybe<order_by>;
  revtron_id?: InputMaybe<order_by>;
};

/** update columns of table "crm_to_revtron_account" */
export enum crm_to_revtron_account_update_column {
  /** column name */
  crm_id = "crm_id",
  /** column name */
  match_count = "match_count",
  /** column name */
  match_type = "match_type",
  /** column name */
  revtron_id = "revtron_id",
}

export type crm_to_revtron_account_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<crm_to_revtron_account_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<crm_to_revtron_account_set_input>;
  where: crm_to_revtron_account_bool_exp;
};

/** order by var_pop() on columns of table "crm_to_revtron_account" */
export type crm_to_revtron_account_var_pop_order_by = {
  match_count?: InputMaybe<order_by>;
  revtron_id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "crm_to_revtron_account" */
export type crm_to_revtron_account_var_samp_order_by = {
  match_count?: InputMaybe<order_by>;
  revtron_id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "crm_to_revtron_account" */
export type crm_to_revtron_account_variance_order_by = {
  match_count?: InputMaybe<order_by>;
  revtron_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "crm_users". All fields are combined with a logical 'AND'. */
export type crm_users_bool_exp = {
  _and?: InputMaybe<Array<crm_users_bool_exp>>;
  _not?: InputMaybe<crm_users_bool_exp>;
  _or?: InputMaybe<Array<crm_users_bool_exp>>;
  created_date?: InputMaybe<timestamp_comparison_exp>;
  email?: InputMaybe<String_comparison_exp>;
  firstname?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<String_comparison_exp>;
  isactive?: InputMaybe<Boolean_comparison_exp>;
  lastname?: InputMaybe<String_comparison_exp>;
  meeting_creation?: InputMaybe<event_bool_exp>;
  meeting_creation_aggregate?: InputMaybe<event_aggregate_bool_exp>;
  name?: InputMaybe<String_comparison_exp>;
  opp_creation?: InputMaybe<opportunity_bool_exp>;
  opp_creation_aggregate?: InputMaybe<opportunity_aggregate_bool_exp>;
  revtron_users?: InputMaybe<users_bool_exp>;
  title?: InputMaybe<String_comparison_exp>;
  to_effort_engagement?: InputMaybe<task_effort_engagement_mapping_bool_exp>;
  to_effort_engagement_aggregate?: InputMaybe<task_effort_engagement_mapping_aggregate_bool_exp>;
  to_opp?: InputMaybe<opportunity_bool_exp>;
  to_opp_aggregate?: InputMaybe<opportunity_aggregate_bool_exp>;
  to_opportunity?: InputMaybe<Opportunity_bool_exp>;
  to_opportunity_aggregate?: InputMaybe<Opportunity_aggregate_bool_exp>;
  to_win_rates?: InputMaybe<win_rates_individual_gql_bool_exp>;
  to_win_rates_aggregate?: InputMaybe<win_rates_individual_gql_aggregate_bool_exp>;
  updated_date?: InputMaybe<timestamp_comparison_exp>;
};

/** input type for inserting data into table "crm_users" */
export type crm_users_insert_input = {
  created_date?: InputMaybe<Scalars["timestamp"]>;
  email?: InputMaybe<Scalars["String"]>;
  firstname?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  isactive?: InputMaybe<Scalars["Boolean"]>;
  lastname?: InputMaybe<Scalars["String"]>;
  meeting_creation?: InputMaybe<event_arr_rel_insert_input>;
  name?: InputMaybe<Scalars["String"]>;
  opp_creation?: InputMaybe<opportunity_arr_rel_insert_input>;
  revtron_users?: InputMaybe<users_obj_rel_insert_input>;
  title?: InputMaybe<Scalars["String"]>;
  to_effort_engagement?: InputMaybe<task_effort_engagement_mapping_arr_rel_insert_input>;
  to_opp?: InputMaybe<opportunity_arr_rel_insert_input>;
  to_opportunity?: InputMaybe<Opportunity_arr_rel_insert_input>;
  to_win_rates?: InputMaybe<win_rates_individual_gql_arr_rel_insert_input>;
  updated_date?: InputMaybe<Scalars["timestamp"]>;
};

/** input type for inserting object relation for remote table "crm_users" */
export type crm_users_obj_rel_insert_input = {
  data: crm_users_insert_input;
};

/** Ordering options when selecting data from "crm_users". */
export type crm_users_order_by = {
  created_date?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  firstname?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  isactive?: InputMaybe<order_by>;
  lastname?: InputMaybe<order_by>;
  meeting_creation_aggregate?: InputMaybe<event_aggregate_order_by>;
  name?: InputMaybe<order_by>;
  opp_creation_aggregate?: InputMaybe<opportunity_aggregate_order_by>;
  revtron_users?: InputMaybe<users_order_by>;
  title?: InputMaybe<order_by>;
  to_effort_engagement_aggregate?: InputMaybe<task_effort_engagement_mapping_aggregate_order_by>;
  to_opp_aggregate?: InputMaybe<opportunity_aggregate_order_by>;
  to_opportunity_aggregate?: InputMaybe<Opportunity_aggregate_order_by>;
  to_win_rates_aggregate?: InputMaybe<win_rates_individual_gql_aggregate_order_by>;
  updated_date?: InputMaybe<order_by>;
};

/** select columns of table "crm_users" */
export enum crm_users_select_column {
  /** column name */
  created_date = "created_date",
  /** column name */
  email = "email",
  /** column name */
  firstname = "firstname",
  /** column name */
  id = "id",
  /** column name */
  isactive = "isactive",
  /** column name */
  lastname = "lastname",
  /** column name */
  name = "name",
  /** column name */
  title = "title",
  /** column name */
  updated_date = "updated_date",
}

/** input type for updating data in table "crm_users" */
export type crm_users_set_input = {
  created_date?: InputMaybe<Scalars["timestamp"]>;
  email?: InputMaybe<Scalars["String"]>;
  firstname?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  isactive?: InputMaybe<Scalars["Boolean"]>;
  lastname?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
  updated_date?: InputMaybe<Scalars["timestamp"]>;
};

/** Streaming cursor of the table "crm_users" */
export type crm_users_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: crm_users_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type crm_users_stream_cursor_value_input = {
  created_date?: InputMaybe<Scalars["timestamp"]>;
  email?: InputMaybe<Scalars["String"]>;
  firstname?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  isactive?: InputMaybe<Scalars["Boolean"]>;
  lastname?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
  updated_date?: InputMaybe<Scalars["timestamp"]>;
};

export type crm_users_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<crm_users_set_input>;
  where: crm_users_bool_exp;
};

/** ordering argument of a cursor */
export enum cursor_ordering {
  /** ascending ordering of the cursor */
  ASC = "ASC",
  /** descending ordering of the cursor */
  DESC = "DESC",
}

export type daily_effort_engagement_by_account_aggregate_bool_exp = {
  count?: InputMaybe<daily_effort_engagement_by_account_aggregate_bool_exp_count>;
};

export type daily_effort_engagement_by_account_aggregate_bool_exp_count = {
  arguments?: InputMaybe<
    Array<daily_effort_engagement_by_account_select_column>
  >;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<daily_effort_engagement_by_account_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "daily_effort_engagement_by_account" */
export type daily_effort_engagement_by_account_aggregate_order_by = {
  avg?: InputMaybe<daily_effort_engagement_by_account_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<daily_effort_engagement_by_account_max_order_by>;
  min?: InputMaybe<daily_effort_engagement_by_account_min_order_by>;
  stddev?: InputMaybe<daily_effort_engagement_by_account_stddev_order_by>;
  stddev_pop?: InputMaybe<daily_effort_engagement_by_account_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<daily_effort_engagement_by_account_stddev_samp_order_by>;
  sum?: InputMaybe<daily_effort_engagement_by_account_sum_order_by>;
  var_pop?: InputMaybe<daily_effort_engagement_by_account_var_pop_order_by>;
  var_samp?: InputMaybe<daily_effort_engagement_by_account_var_samp_order_by>;
  variance?: InputMaybe<daily_effort_engagement_by_account_variance_order_by>;
};

/** order by avg() on columns of table "daily_effort_engagement_by_account" */
export type daily_effort_engagement_by_account_avg_order_by = {
  effort?: InputMaybe<order_by>;
  engagement?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "daily_effort_engagement_by_account". All fields are combined with a logical 'AND'. */
export type daily_effort_engagement_by_account_bool_exp = {
  _and?: InputMaybe<Array<daily_effort_engagement_by_account_bool_exp>>;
  _not?: InputMaybe<daily_effort_engagement_by_account_bool_exp>;
  _or?: InputMaybe<Array<daily_effort_engagement_by_account_bool_exp>>;
  accountid?: InputMaybe<String_comparison_exp>;
  activity_date?: InputMaybe<timestamp_comparison_exp>;
  effort?: InputMaybe<numeric_comparison_exp>;
  engagement?: InputMaybe<numeric_comparison_exp>;
};

/** order by max() on columns of table "daily_effort_engagement_by_account" */
export type daily_effort_engagement_by_account_max_order_by = {
  accountid?: InputMaybe<order_by>;
  activity_date?: InputMaybe<order_by>;
  effort?: InputMaybe<order_by>;
  engagement?: InputMaybe<order_by>;
};

/** order by min() on columns of table "daily_effort_engagement_by_account" */
export type daily_effort_engagement_by_account_min_order_by = {
  accountid?: InputMaybe<order_by>;
  activity_date?: InputMaybe<order_by>;
  effort?: InputMaybe<order_by>;
  engagement?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "daily_effort_engagement_by_account". */
export type daily_effort_engagement_by_account_order_by = {
  accountid?: InputMaybe<order_by>;
  activity_date?: InputMaybe<order_by>;
  effort?: InputMaybe<order_by>;
  engagement?: InputMaybe<order_by>;
};

/** select columns of table "daily_effort_engagement_by_account" */
export enum daily_effort_engagement_by_account_select_column {
  /** column name */
  accountid = "accountid",
  /** column name */
  activity_date = "activity_date",
  /** column name */
  effort = "effort",
  /** column name */
  engagement = "engagement",
}

/** order by stddev() on columns of table "daily_effort_engagement_by_account" */
export type daily_effort_engagement_by_account_stddev_order_by = {
  effort?: InputMaybe<order_by>;
  engagement?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "daily_effort_engagement_by_account" */
export type daily_effort_engagement_by_account_stddev_pop_order_by = {
  effort?: InputMaybe<order_by>;
  engagement?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "daily_effort_engagement_by_account" */
export type daily_effort_engagement_by_account_stddev_samp_order_by = {
  effort?: InputMaybe<order_by>;
  engagement?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "daily_effort_engagement_by_account" */
export type daily_effort_engagement_by_account_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: daily_effort_engagement_by_account_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type daily_effort_engagement_by_account_stream_cursor_value_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  activity_date?: InputMaybe<Scalars["timestamp"]>;
  effort?: InputMaybe<Scalars["numeric"]>;
  engagement?: InputMaybe<Scalars["numeric"]>;
};

/** order by sum() on columns of table "daily_effort_engagement_by_account" */
export type daily_effort_engagement_by_account_sum_order_by = {
  effort?: InputMaybe<order_by>;
  engagement?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "daily_effort_engagement_by_account" */
export type daily_effort_engagement_by_account_var_pop_order_by = {
  effort?: InputMaybe<order_by>;
  engagement?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "daily_effort_engagement_by_account" */
export type daily_effort_engagement_by_account_var_samp_order_by = {
  effort?: InputMaybe<order_by>;
  engagement?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "daily_effort_engagement_by_account" */
export type daily_effort_engagement_by_account_variance_order_by = {
  effort?: InputMaybe<order_by>;
  engagement?: InputMaybe<order_by>;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type date_comparison_exp = {
  _eq?: InputMaybe<Scalars["date"]>;
  _gt?: InputMaybe<Scalars["date"]>;
  _gte?: InputMaybe<Scalars["date"]>;
  _in?: InputMaybe<Array<Scalars["date"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["date"]>;
  _lte?: InputMaybe<Scalars["date"]>;
  _neq?: InputMaybe<Scalars["date"]>;
  _nin?: InputMaybe<Array<Scalars["date"]>>;
};

export type event_aggregate_bool_exp = {
  bool_and?: InputMaybe<event_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<event_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<event_aggregate_bool_exp_count>;
};

export type event_aggregate_bool_exp_bool_and = {
  arguments: event_select_column_event_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<event_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type event_aggregate_bool_exp_bool_or = {
  arguments: event_select_column_event_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<event_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type event_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<event_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<event_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "event" */
export type event_aggregate_order_by = {
  avg?: InputMaybe<event_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<event_max_order_by>;
  min?: InputMaybe<event_min_order_by>;
  stddev?: InputMaybe<event_stddev_order_by>;
  stddev_pop?: InputMaybe<event_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<event_stddev_samp_order_by>;
  sum?: InputMaybe<event_sum_order_by>;
  var_pop?: InputMaybe<event_var_pop_order_by>;
  var_samp?: InputMaybe<event_var_samp_order_by>;
  variance?: InputMaybe<event_variance_order_by>;
};

/** input type for inserting array relation for remote table "event" */
export type event_arr_rel_insert_input = {
  data: Array<event_insert_input>;
};

/** order by avg() on columns of table "event" */
export type event_avg_order_by = {
  durationinminutes?: InputMaybe<order_by>;
  recurrencedayofmonth?: InputMaybe<order_by>;
  recurrencedayofweekmask?: InputMaybe<order_by>;
  recurrenceinterval?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  whatcount?: InputMaybe<order_by>;
  whocount?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "event". All fields are combined with a logical 'AND'. */
export type event_bool_exp = {
  _and?: InputMaybe<Array<event_bool_exp>>;
  _not?: InputMaybe<event_bool_exp>;
  _or?: InputMaybe<Array<event_bool_exp>>;
  accountid?: InputMaybe<String_comparison_exp>;
  activitydate?: InputMaybe<timestamp_comparison_exp>;
  activitydatetime?: InputMaybe<timestamp_comparison_exp>;
  createdbyid?: InputMaybe<String_comparison_exp>;
  createddate?: InputMaybe<timestamp_comparison_exp>;
  description?: InputMaybe<String_comparison_exp>;
  durationinminutes?: InputMaybe<Int_comparison_exp>;
  enddate?: InputMaybe<timestamp_comparison_exp>;
  enddatetime?: InputMaybe<timestamp_comparison_exp>;
  eventsubtype?: InputMaybe<String_comparison_exp>;
  groupeventtype?: InputMaybe<String_comparison_exp>;
  hubspot_owner_id__c?: InputMaybe<String_comparison_exp>;
  hubspot_owner_name__c?: InputMaybe<String_comparison_exp>;
  hubspot_task_id__c?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<String_comparison_exp>;
  isalldayevent?: InputMaybe<Boolean_comparison_exp>;
  isarchived?: InputMaybe<Boolean_comparison_exp>;
  ischild?: InputMaybe<Boolean_comparison_exp>;
  isdeleted?: InputMaybe<Boolean_comparison_exp>;
  isgroupevent?: InputMaybe<Boolean_comparison_exp>;
  isprivate?: InputMaybe<Boolean_comparison_exp>;
  isrecurrence?: InputMaybe<Boolean_comparison_exp>;
  isrecurrence2?: InputMaybe<Boolean_comparison_exp>;
  isrecurrence2exception?: InputMaybe<Boolean_comparison_exp>;
  isrecurrence2exclusion?: InputMaybe<Boolean_comparison_exp>;
  isreminderset?: InputMaybe<Boolean_comparison_exp>;
  kaia_recording_url__c?: InputMaybe<String_comparison_exp>;
  lastmodifiedbyid?: InputMaybe<String_comparison_exp>;
  lastmodifieddate?: InputMaybe<timestamp_comparison_exp>;
  location?: InputMaybe<String_comparison_exp>;
  meeting_cancelled__c?: InputMaybe<Boolean_comparison_exp>;
  outreach_attributed_sequence_name__c?: InputMaybe<String_comparison_exp>;
  ownerid?: InputMaybe<String_comparison_exp>;
  recurrence2patternstartdate?: InputMaybe<timestamp_comparison_exp>;
  recurrence2patterntext?: InputMaybe<String_comparison_exp>;
  recurrence2patterntimezone?: InputMaybe<String_comparison_exp>;
  recurrence2patternversion?: InputMaybe<String_comparison_exp>;
  recurrenceactivityid?: InputMaybe<String_comparison_exp>;
  recurrencedayofmonth?: InputMaybe<Int_comparison_exp>;
  recurrencedayofweekmask?: InputMaybe<Int_comparison_exp>;
  recurrenceenddateonly?: InputMaybe<timestamp_comparison_exp>;
  recurrenceinstance?: InputMaybe<String_comparison_exp>;
  recurrenceinterval?: InputMaybe<Int_comparison_exp>;
  recurrencemonthofyear?: InputMaybe<String_comparison_exp>;
  recurrencestartdatetime?: InputMaybe<timestamp_comparison_exp>;
  recurrencetimezonesidkey?: InputMaybe<String_comparison_exp>;
  recurrencetype?: InputMaybe<String_comparison_exp>;
  reminderdatetime?: InputMaybe<timestamp_comparison_exp>;
  showas?: InputMaybe<String_comparison_exp>;
  sort_id?: InputMaybe<Int_comparison_exp>;
  startdatetime?: InputMaybe<timestamp_comparison_exp>;
  subject?: InputMaybe<String_comparison_exp>;
  systemmodstamp?: InputMaybe<timestamp_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
  whatcount?: InputMaybe<Int_comparison_exp>;
  whatid?: InputMaybe<String_comparison_exp>;
  whocount?: InputMaybe<Int_comparison_exp>;
  whoid?: InputMaybe<String_comparison_exp>;
};

/** input type for incrementing numeric columns in table "event" */
export type event_inc_input = {
  durationinminutes?: InputMaybe<Scalars["Int"]>;
  recurrencedayofmonth?: InputMaybe<Scalars["Int"]>;
  recurrencedayofweekmask?: InputMaybe<Scalars["Int"]>;
  recurrenceinterval?: InputMaybe<Scalars["Int"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  whatcount?: InputMaybe<Scalars["Int"]>;
  whocount?: InputMaybe<Scalars["Int"]>;
};

/** input type for inserting data into table "event" */
export type event_insert_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  activitydate?: InputMaybe<Scalars["timestamp"]>;
  activitydatetime?: InputMaybe<Scalars["timestamp"]>;
  createdbyid?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  description?: InputMaybe<Scalars["String"]>;
  durationinminutes?: InputMaybe<Scalars["Int"]>;
  enddate?: InputMaybe<Scalars["timestamp"]>;
  enddatetime?: InputMaybe<Scalars["timestamp"]>;
  eventsubtype?: InputMaybe<Scalars["String"]>;
  groupeventtype?: InputMaybe<Scalars["String"]>;
  hubspot_owner_id__c?: InputMaybe<Scalars["String"]>;
  hubspot_owner_name__c?: InputMaybe<Scalars["String"]>;
  hubspot_task_id__c?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  isalldayevent?: InputMaybe<Scalars["Boolean"]>;
  isarchived?: InputMaybe<Scalars["Boolean"]>;
  ischild?: InputMaybe<Scalars["Boolean"]>;
  isdeleted?: InputMaybe<Scalars["Boolean"]>;
  isgroupevent?: InputMaybe<Scalars["Boolean"]>;
  isprivate?: InputMaybe<Scalars["Boolean"]>;
  isrecurrence?: InputMaybe<Scalars["Boolean"]>;
  isrecurrence2?: InputMaybe<Scalars["Boolean"]>;
  isrecurrence2exception?: InputMaybe<Scalars["Boolean"]>;
  isrecurrence2exclusion?: InputMaybe<Scalars["Boolean"]>;
  isreminderset?: InputMaybe<Scalars["Boolean"]>;
  kaia_recording_url__c?: InputMaybe<Scalars["String"]>;
  lastmodifiedbyid?: InputMaybe<Scalars["String"]>;
  lastmodifieddate?: InputMaybe<Scalars["timestamp"]>;
  location?: InputMaybe<Scalars["String"]>;
  meeting_cancelled__c?: InputMaybe<Scalars["Boolean"]>;
  outreach_attributed_sequence_name__c?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  recurrence2patternstartdate?: InputMaybe<Scalars["timestamp"]>;
  recurrence2patterntext?: InputMaybe<Scalars["String"]>;
  recurrence2patterntimezone?: InputMaybe<Scalars["String"]>;
  recurrence2patternversion?: InputMaybe<Scalars["String"]>;
  recurrenceactivityid?: InputMaybe<Scalars["String"]>;
  recurrencedayofmonth?: InputMaybe<Scalars["Int"]>;
  recurrencedayofweekmask?: InputMaybe<Scalars["Int"]>;
  recurrenceenddateonly?: InputMaybe<Scalars["timestamp"]>;
  recurrenceinstance?: InputMaybe<Scalars["String"]>;
  recurrenceinterval?: InputMaybe<Scalars["Int"]>;
  recurrencemonthofyear?: InputMaybe<Scalars["String"]>;
  recurrencestartdatetime?: InputMaybe<Scalars["timestamp"]>;
  recurrencetimezonesidkey?: InputMaybe<Scalars["String"]>;
  recurrencetype?: InputMaybe<Scalars["String"]>;
  reminderdatetime?: InputMaybe<Scalars["timestamp"]>;
  showas?: InputMaybe<Scalars["String"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  startdatetime?: InputMaybe<Scalars["timestamp"]>;
  subject?: InputMaybe<Scalars["String"]>;
  systemmodstamp?: InputMaybe<Scalars["timestamp"]>;
  type?: InputMaybe<Scalars["String"]>;
  whatcount?: InputMaybe<Scalars["Int"]>;
  whatid?: InputMaybe<Scalars["String"]>;
  whocount?: InputMaybe<Scalars["Int"]>;
  whoid?: InputMaybe<Scalars["String"]>;
};

/** order by max() on columns of table "event" */
export type event_max_order_by = {
  accountid?: InputMaybe<order_by>;
  activitydate?: InputMaybe<order_by>;
  activitydatetime?: InputMaybe<order_by>;
  createdbyid?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  durationinminutes?: InputMaybe<order_by>;
  enddate?: InputMaybe<order_by>;
  enddatetime?: InputMaybe<order_by>;
  eventsubtype?: InputMaybe<order_by>;
  groupeventtype?: InputMaybe<order_by>;
  hubspot_owner_id__c?: InputMaybe<order_by>;
  hubspot_owner_name__c?: InputMaybe<order_by>;
  hubspot_task_id__c?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  kaia_recording_url__c?: InputMaybe<order_by>;
  lastmodifiedbyid?: InputMaybe<order_by>;
  lastmodifieddate?: InputMaybe<order_by>;
  location?: InputMaybe<order_by>;
  outreach_attributed_sequence_name__c?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  recurrence2patternstartdate?: InputMaybe<order_by>;
  recurrence2patterntext?: InputMaybe<order_by>;
  recurrence2patterntimezone?: InputMaybe<order_by>;
  recurrence2patternversion?: InputMaybe<order_by>;
  recurrenceactivityid?: InputMaybe<order_by>;
  recurrencedayofmonth?: InputMaybe<order_by>;
  recurrencedayofweekmask?: InputMaybe<order_by>;
  recurrenceenddateonly?: InputMaybe<order_by>;
  recurrenceinstance?: InputMaybe<order_by>;
  recurrenceinterval?: InputMaybe<order_by>;
  recurrencemonthofyear?: InputMaybe<order_by>;
  recurrencestartdatetime?: InputMaybe<order_by>;
  recurrencetimezonesidkey?: InputMaybe<order_by>;
  recurrencetype?: InputMaybe<order_by>;
  reminderdatetime?: InputMaybe<order_by>;
  showas?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  startdatetime?: InputMaybe<order_by>;
  subject?: InputMaybe<order_by>;
  systemmodstamp?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
  whatcount?: InputMaybe<order_by>;
  whatid?: InputMaybe<order_by>;
  whocount?: InputMaybe<order_by>;
  whoid?: InputMaybe<order_by>;
};

/** order by min() on columns of table "event" */
export type event_min_order_by = {
  accountid?: InputMaybe<order_by>;
  activitydate?: InputMaybe<order_by>;
  activitydatetime?: InputMaybe<order_by>;
  createdbyid?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  durationinminutes?: InputMaybe<order_by>;
  enddate?: InputMaybe<order_by>;
  enddatetime?: InputMaybe<order_by>;
  eventsubtype?: InputMaybe<order_by>;
  groupeventtype?: InputMaybe<order_by>;
  hubspot_owner_id__c?: InputMaybe<order_by>;
  hubspot_owner_name__c?: InputMaybe<order_by>;
  hubspot_task_id__c?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  kaia_recording_url__c?: InputMaybe<order_by>;
  lastmodifiedbyid?: InputMaybe<order_by>;
  lastmodifieddate?: InputMaybe<order_by>;
  location?: InputMaybe<order_by>;
  outreach_attributed_sequence_name__c?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  recurrence2patternstartdate?: InputMaybe<order_by>;
  recurrence2patterntext?: InputMaybe<order_by>;
  recurrence2patterntimezone?: InputMaybe<order_by>;
  recurrence2patternversion?: InputMaybe<order_by>;
  recurrenceactivityid?: InputMaybe<order_by>;
  recurrencedayofmonth?: InputMaybe<order_by>;
  recurrencedayofweekmask?: InputMaybe<order_by>;
  recurrenceenddateonly?: InputMaybe<order_by>;
  recurrenceinstance?: InputMaybe<order_by>;
  recurrenceinterval?: InputMaybe<order_by>;
  recurrencemonthofyear?: InputMaybe<order_by>;
  recurrencestartdatetime?: InputMaybe<order_by>;
  recurrencetimezonesidkey?: InputMaybe<order_by>;
  recurrencetype?: InputMaybe<order_by>;
  reminderdatetime?: InputMaybe<order_by>;
  showas?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  startdatetime?: InputMaybe<order_by>;
  subject?: InputMaybe<order_by>;
  systemmodstamp?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
  whatcount?: InputMaybe<order_by>;
  whatid?: InputMaybe<order_by>;
  whocount?: InputMaybe<order_by>;
  whoid?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "event". */
export type event_order_by = {
  accountid?: InputMaybe<order_by>;
  activitydate?: InputMaybe<order_by>;
  activitydatetime?: InputMaybe<order_by>;
  createdbyid?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  durationinminutes?: InputMaybe<order_by>;
  enddate?: InputMaybe<order_by>;
  enddatetime?: InputMaybe<order_by>;
  eventsubtype?: InputMaybe<order_by>;
  groupeventtype?: InputMaybe<order_by>;
  hubspot_owner_id__c?: InputMaybe<order_by>;
  hubspot_owner_name__c?: InputMaybe<order_by>;
  hubspot_task_id__c?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  isalldayevent?: InputMaybe<order_by>;
  isarchived?: InputMaybe<order_by>;
  ischild?: InputMaybe<order_by>;
  isdeleted?: InputMaybe<order_by>;
  isgroupevent?: InputMaybe<order_by>;
  isprivate?: InputMaybe<order_by>;
  isrecurrence?: InputMaybe<order_by>;
  isrecurrence2?: InputMaybe<order_by>;
  isrecurrence2exception?: InputMaybe<order_by>;
  isrecurrence2exclusion?: InputMaybe<order_by>;
  isreminderset?: InputMaybe<order_by>;
  kaia_recording_url__c?: InputMaybe<order_by>;
  lastmodifiedbyid?: InputMaybe<order_by>;
  lastmodifieddate?: InputMaybe<order_by>;
  location?: InputMaybe<order_by>;
  meeting_cancelled__c?: InputMaybe<order_by>;
  outreach_attributed_sequence_name__c?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  recurrence2patternstartdate?: InputMaybe<order_by>;
  recurrence2patterntext?: InputMaybe<order_by>;
  recurrence2patterntimezone?: InputMaybe<order_by>;
  recurrence2patternversion?: InputMaybe<order_by>;
  recurrenceactivityid?: InputMaybe<order_by>;
  recurrencedayofmonth?: InputMaybe<order_by>;
  recurrencedayofweekmask?: InputMaybe<order_by>;
  recurrenceenddateonly?: InputMaybe<order_by>;
  recurrenceinstance?: InputMaybe<order_by>;
  recurrenceinterval?: InputMaybe<order_by>;
  recurrencemonthofyear?: InputMaybe<order_by>;
  recurrencestartdatetime?: InputMaybe<order_by>;
  recurrencetimezonesidkey?: InputMaybe<order_by>;
  recurrencetype?: InputMaybe<order_by>;
  reminderdatetime?: InputMaybe<order_by>;
  showas?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  startdatetime?: InputMaybe<order_by>;
  subject?: InputMaybe<order_by>;
  systemmodstamp?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
  whatcount?: InputMaybe<order_by>;
  whatid?: InputMaybe<order_by>;
  whocount?: InputMaybe<order_by>;
  whoid?: InputMaybe<order_by>;
};

/** select columns of table "event" */
export enum event_select_column {
  /** column name */
  accountid = "accountid",
  /** column name */
  activitydate = "activitydate",
  /** column name */
  activitydatetime = "activitydatetime",
  /** column name */
  createdbyid = "createdbyid",
  /** column name */
  createddate = "createddate",
  /** column name */
  description = "description",
  /** column name */
  durationinminutes = "durationinminutes",
  /** column name */
  enddate = "enddate",
  /** column name */
  enddatetime = "enddatetime",
  /** column name */
  eventsubtype = "eventsubtype",
  /** column name */
  groupeventtype = "groupeventtype",
  /** column name */
  hubspot_owner_id__c = "hubspot_owner_id__c",
  /** column name */
  hubspot_owner_name__c = "hubspot_owner_name__c",
  /** column name */
  hubspot_task_id__c = "hubspot_task_id__c",
  /** column name */
  id = "id",
  /** column name */
  isalldayevent = "isalldayevent",
  /** column name */
  isarchived = "isarchived",
  /** column name */
  ischild = "ischild",
  /** column name */
  isdeleted = "isdeleted",
  /** column name */
  isgroupevent = "isgroupevent",
  /** column name */
  isprivate = "isprivate",
  /** column name */
  isrecurrence = "isrecurrence",
  /** column name */
  isrecurrence2 = "isrecurrence2",
  /** column name */
  isrecurrence2exception = "isrecurrence2exception",
  /** column name */
  isrecurrence2exclusion = "isrecurrence2exclusion",
  /** column name */
  isreminderset = "isreminderset",
  /** column name */
  kaia_recording_url__c = "kaia_recording_url__c",
  /** column name */
  lastmodifiedbyid = "lastmodifiedbyid",
  /** column name */
  lastmodifieddate = "lastmodifieddate",
  /** column name */
  location = "location",
  /** column name */
  meeting_cancelled__c = "meeting_cancelled__c",
  /** column name */
  outreach_attributed_sequence_name__c = "outreach_attributed_sequence_name__c",
  /** column name */
  ownerid = "ownerid",
  /** column name */
  recurrence2patternstartdate = "recurrence2patternstartdate",
  /** column name */
  recurrence2patterntext = "recurrence2patterntext",
  /** column name */
  recurrence2patterntimezone = "recurrence2patterntimezone",
  /** column name */
  recurrence2patternversion = "recurrence2patternversion",
  /** column name */
  recurrenceactivityid = "recurrenceactivityid",
  /** column name */
  recurrencedayofmonth = "recurrencedayofmonth",
  /** column name */
  recurrencedayofweekmask = "recurrencedayofweekmask",
  /** column name */
  recurrenceenddateonly = "recurrenceenddateonly",
  /** column name */
  recurrenceinstance = "recurrenceinstance",
  /** column name */
  recurrenceinterval = "recurrenceinterval",
  /** column name */
  recurrencemonthofyear = "recurrencemonthofyear",
  /** column name */
  recurrencestartdatetime = "recurrencestartdatetime",
  /** column name */
  recurrencetimezonesidkey = "recurrencetimezonesidkey",
  /** column name */
  recurrencetype = "recurrencetype",
  /** column name */
  reminderdatetime = "reminderdatetime",
  /** column name */
  showas = "showas",
  /** column name */
  sort_id = "sort_id",
  /** column name */
  startdatetime = "startdatetime",
  /** column name */
  subject = "subject",
  /** column name */
  systemmodstamp = "systemmodstamp",
  /** column name */
  type = "type",
  /** column name */
  whatcount = "whatcount",
  /** column name */
  whatid = "whatid",
  /** column name */
  whocount = "whocount",
  /** column name */
  whoid = "whoid",
}

/** select "event_aggregate_bool_exp_bool_and_arguments_columns" columns of table "event" */
export enum event_select_column_event_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  isalldayevent = "isalldayevent",
  /** column name */
  isarchived = "isarchived",
  /** column name */
  ischild = "ischild",
  /** column name */
  isdeleted = "isdeleted",
  /** column name */
  isgroupevent = "isgroupevent",
  /** column name */
  isprivate = "isprivate",
  /** column name */
  isrecurrence = "isrecurrence",
  /** column name */
  isrecurrence2 = "isrecurrence2",
  /** column name */
  isrecurrence2exception = "isrecurrence2exception",
  /** column name */
  isrecurrence2exclusion = "isrecurrence2exclusion",
  /** column name */
  isreminderset = "isreminderset",
  /** column name */
  meeting_cancelled__c = "meeting_cancelled__c",
}

/** select "event_aggregate_bool_exp_bool_or_arguments_columns" columns of table "event" */
export enum event_select_column_event_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  isalldayevent = "isalldayevent",
  /** column name */
  isarchived = "isarchived",
  /** column name */
  ischild = "ischild",
  /** column name */
  isdeleted = "isdeleted",
  /** column name */
  isgroupevent = "isgroupevent",
  /** column name */
  isprivate = "isprivate",
  /** column name */
  isrecurrence = "isrecurrence",
  /** column name */
  isrecurrence2 = "isrecurrence2",
  /** column name */
  isrecurrence2exception = "isrecurrence2exception",
  /** column name */
  isrecurrence2exclusion = "isrecurrence2exclusion",
  /** column name */
  isreminderset = "isreminderset",
  /** column name */
  meeting_cancelled__c = "meeting_cancelled__c",
}

/** input type for updating data in table "event" */
export type event_set_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  activitydate?: InputMaybe<Scalars["timestamp"]>;
  activitydatetime?: InputMaybe<Scalars["timestamp"]>;
  createdbyid?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  description?: InputMaybe<Scalars["String"]>;
  durationinminutes?: InputMaybe<Scalars["Int"]>;
  enddate?: InputMaybe<Scalars["timestamp"]>;
  enddatetime?: InputMaybe<Scalars["timestamp"]>;
  eventsubtype?: InputMaybe<Scalars["String"]>;
  groupeventtype?: InputMaybe<Scalars["String"]>;
  hubspot_owner_id__c?: InputMaybe<Scalars["String"]>;
  hubspot_owner_name__c?: InputMaybe<Scalars["String"]>;
  hubspot_task_id__c?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  isalldayevent?: InputMaybe<Scalars["Boolean"]>;
  isarchived?: InputMaybe<Scalars["Boolean"]>;
  ischild?: InputMaybe<Scalars["Boolean"]>;
  isdeleted?: InputMaybe<Scalars["Boolean"]>;
  isgroupevent?: InputMaybe<Scalars["Boolean"]>;
  isprivate?: InputMaybe<Scalars["Boolean"]>;
  isrecurrence?: InputMaybe<Scalars["Boolean"]>;
  isrecurrence2?: InputMaybe<Scalars["Boolean"]>;
  isrecurrence2exception?: InputMaybe<Scalars["Boolean"]>;
  isrecurrence2exclusion?: InputMaybe<Scalars["Boolean"]>;
  isreminderset?: InputMaybe<Scalars["Boolean"]>;
  kaia_recording_url__c?: InputMaybe<Scalars["String"]>;
  lastmodifiedbyid?: InputMaybe<Scalars["String"]>;
  lastmodifieddate?: InputMaybe<Scalars["timestamp"]>;
  location?: InputMaybe<Scalars["String"]>;
  meeting_cancelled__c?: InputMaybe<Scalars["Boolean"]>;
  outreach_attributed_sequence_name__c?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  recurrence2patternstartdate?: InputMaybe<Scalars["timestamp"]>;
  recurrence2patterntext?: InputMaybe<Scalars["String"]>;
  recurrence2patterntimezone?: InputMaybe<Scalars["String"]>;
  recurrence2patternversion?: InputMaybe<Scalars["String"]>;
  recurrenceactivityid?: InputMaybe<Scalars["String"]>;
  recurrencedayofmonth?: InputMaybe<Scalars["Int"]>;
  recurrencedayofweekmask?: InputMaybe<Scalars["Int"]>;
  recurrenceenddateonly?: InputMaybe<Scalars["timestamp"]>;
  recurrenceinstance?: InputMaybe<Scalars["String"]>;
  recurrenceinterval?: InputMaybe<Scalars["Int"]>;
  recurrencemonthofyear?: InputMaybe<Scalars["String"]>;
  recurrencestartdatetime?: InputMaybe<Scalars["timestamp"]>;
  recurrencetimezonesidkey?: InputMaybe<Scalars["String"]>;
  recurrencetype?: InputMaybe<Scalars["String"]>;
  reminderdatetime?: InputMaybe<Scalars["timestamp"]>;
  showas?: InputMaybe<Scalars["String"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  startdatetime?: InputMaybe<Scalars["timestamp"]>;
  subject?: InputMaybe<Scalars["String"]>;
  systemmodstamp?: InputMaybe<Scalars["timestamp"]>;
  type?: InputMaybe<Scalars["String"]>;
  whatcount?: InputMaybe<Scalars["Int"]>;
  whatid?: InputMaybe<Scalars["String"]>;
  whocount?: InputMaybe<Scalars["Int"]>;
  whoid?: InputMaybe<Scalars["String"]>;
};

/** order by stddev() on columns of table "event" */
export type event_stddev_order_by = {
  durationinminutes?: InputMaybe<order_by>;
  recurrencedayofmonth?: InputMaybe<order_by>;
  recurrencedayofweekmask?: InputMaybe<order_by>;
  recurrenceinterval?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  whatcount?: InputMaybe<order_by>;
  whocount?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "event" */
export type event_stddev_pop_order_by = {
  durationinminutes?: InputMaybe<order_by>;
  recurrencedayofmonth?: InputMaybe<order_by>;
  recurrencedayofweekmask?: InputMaybe<order_by>;
  recurrenceinterval?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  whatcount?: InputMaybe<order_by>;
  whocount?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "event" */
export type event_stddev_samp_order_by = {
  durationinminutes?: InputMaybe<order_by>;
  recurrencedayofmonth?: InputMaybe<order_by>;
  recurrencedayofweekmask?: InputMaybe<order_by>;
  recurrenceinterval?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  whatcount?: InputMaybe<order_by>;
  whocount?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "event" */
export type event_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: event_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type event_stream_cursor_value_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  activitydate?: InputMaybe<Scalars["timestamp"]>;
  activitydatetime?: InputMaybe<Scalars["timestamp"]>;
  createdbyid?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  description?: InputMaybe<Scalars["String"]>;
  durationinminutes?: InputMaybe<Scalars["Int"]>;
  enddate?: InputMaybe<Scalars["timestamp"]>;
  enddatetime?: InputMaybe<Scalars["timestamp"]>;
  eventsubtype?: InputMaybe<Scalars["String"]>;
  groupeventtype?: InputMaybe<Scalars["String"]>;
  hubspot_owner_id__c?: InputMaybe<Scalars["String"]>;
  hubspot_owner_name__c?: InputMaybe<Scalars["String"]>;
  hubspot_task_id__c?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  isalldayevent?: InputMaybe<Scalars["Boolean"]>;
  isarchived?: InputMaybe<Scalars["Boolean"]>;
  ischild?: InputMaybe<Scalars["Boolean"]>;
  isdeleted?: InputMaybe<Scalars["Boolean"]>;
  isgroupevent?: InputMaybe<Scalars["Boolean"]>;
  isprivate?: InputMaybe<Scalars["Boolean"]>;
  isrecurrence?: InputMaybe<Scalars["Boolean"]>;
  isrecurrence2?: InputMaybe<Scalars["Boolean"]>;
  isrecurrence2exception?: InputMaybe<Scalars["Boolean"]>;
  isrecurrence2exclusion?: InputMaybe<Scalars["Boolean"]>;
  isreminderset?: InputMaybe<Scalars["Boolean"]>;
  kaia_recording_url__c?: InputMaybe<Scalars["String"]>;
  lastmodifiedbyid?: InputMaybe<Scalars["String"]>;
  lastmodifieddate?: InputMaybe<Scalars["timestamp"]>;
  location?: InputMaybe<Scalars["String"]>;
  meeting_cancelled__c?: InputMaybe<Scalars["Boolean"]>;
  outreach_attributed_sequence_name__c?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  recurrence2patternstartdate?: InputMaybe<Scalars["timestamp"]>;
  recurrence2patterntext?: InputMaybe<Scalars["String"]>;
  recurrence2patterntimezone?: InputMaybe<Scalars["String"]>;
  recurrence2patternversion?: InputMaybe<Scalars["String"]>;
  recurrenceactivityid?: InputMaybe<Scalars["String"]>;
  recurrencedayofmonth?: InputMaybe<Scalars["Int"]>;
  recurrencedayofweekmask?: InputMaybe<Scalars["Int"]>;
  recurrenceenddateonly?: InputMaybe<Scalars["timestamp"]>;
  recurrenceinstance?: InputMaybe<Scalars["String"]>;
  recurrenceinterval?: InputMaybe<Scalars["Int"]>;
  recurrencemonthofyear?: InputMaybe<Scalars["String"]>;
  recurrencestartdatetime?: InputMaybe<Scalars["timestamp"]>;
  recurrencetimezonesidkey?: InputMaybe<Scalars["String"]>;
  recurrencetype?: InputMaybe<Scalars["String"]>;
  reminderdatetime?: InputMaybe<Scalars["timestamp"]>;
  showas?: InputMaybe<Scalars["String"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  startdatetime?: InputMaybe<Scalars["timestamp"]>;
  subject?: InputMaybe<Scalars["String"]>;
  systemmodstamp?: InputMaybe<Scalars["timestamp"]>;
  type?: InputMaybe<Scalars["String"]>;
  whatcount?: InputMaybe<Scalars["Int"]>;
  whatid?: InputMaybe<Scalars["String"]>;
  whocount?: InputMaybe<Scalars["Int"]>;
  whoid?: InputMaybe<Scalars["String"]>;
};

/** order by sum() on columns of table "event" */
export type event_sum_order_by = {
  durationinminutes?: InputMaybe<order_by>;
  recurrencedayofmonth?: InputMaybe<order_by>;
  recurrencedayofweekmask?: InputMaybe<order_by>;
  recurrenceinterval?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  whatcount?: InputMaybe<order_by>;
  whocount?: InputMaybe<order_by>;
};

export type event_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<event_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<event_set_input>;
  where: event_bool_exp;
};

/** order by var_pop() on columns of table "event" */
export type event_var_pop_order_by = {
  durationinminutes?: InputMaybe<order_by>;
  recurrencedayofmonth?: InputMaybe<order_by>;
  recurrencedayofweekmask?: InputMaybe<order_by>;
  recurrenceinterval?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  whatcount?: InputMaybe<order_by>;
  whocount?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "event" */
export type event_var_samp_order_by = {
  durationinminutes?: InputMaybe<order_by>;
  recurrencedayofmonth?: InputMaybe<order_by>;
  recurrencedayofweekmask?: InputMaybe<order_by>;
  recurrenceinterval?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  whatcount?: InputMaybe<order_by>;
  whocount?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "event" */
export type event_variance_order_by = {
  durationinminutes?: InputMaybe<order_by>;
  recurrencedayofmonth?: InputMaybe<order_by>;
  recurrencedayofweekmask?: InputMaybe<order_by>;
  recurrenceinterval?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  whatcount?: InputMaybe<order_by>;
  whocount?: InputMaybe<order_by>;
};

export type files_aggregate_bool_exp = {
  bool_and?: InputMaybe<files_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<files_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<files_aggregate_bool_exp_count>;
};

export type files_aggregate_bool_exp_bool_and = {
  arguments: files_select_column_files_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<files_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type files_aggregate_bool_exp_bool_or = {
  arguments: files_select_column_files_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<files_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type files_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<files_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<files_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "storage.files" */
export type files_aggregate_order_by = {
  avg?: InputMaybe<files_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<files_max_order_by>;
  min?: InputMaybe<files_min_order_by>;
  stddev?: InputMaybe<files_stddev_order_by>;
  stddev_pop?: InputMaybe<files_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<files_stddev_samp_order_by>;
  sum?: InputMaybe<files_sum_order_by>;
  var_pop?: InputMaybe<files_var_pop_order_by>;
  var_samp?: InputMaybe<files_var_samp_order_by>;
  variance?: InputMaybe<files_variance_order_by>;
};

/** input type for inserting array relation for remote table "storage.files" */
export type files_arr_rel_insert_input = {
  data: Array<files_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<files_on_conflict>;
};

/** order by avg() on columns of table "storage.files" */
export type files_avg_order_by = {
  size?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "storage.files". All fields are combined with a logical 'AND'. */
export type files_bool_exp = {
  _and?: InputMaybe<Array<files_bool_exp>>;
  _not?: InputMaybe<files_bool_exp>;
  _or?: InputMaybe<Array<files_bool_exp>>;
  bucket?: InputMaybe<buckets_bool_exp>;
  bucketId?: InputMaybe<String_comparison_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  etag?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  isUploaded?: InputMaybe<Boolean_comparison_exp>;
  mimeType?: InputMaybe<String_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  size?: InputMaybe<Int_comparison_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
  uploadedByUserId?: InputMaybe<uuid_comparison_exp>;
};

/** unique or primary key constraints on table "storage.files" */
export enum files_constraint {
  /** unique or primary key constraint on columns "id" */
  files_pkey = "files_pkey",
}

/** input type for incrementing numeric columns in table "storage.files" */
export type files_inc_input = {
  size?: InputMaybe<Scalars["Int"]>;
};

/** input type for inserting data into table "storage.files" */
export type files_insert_input = {
  bucket?: InputMaybe<buckets_obj_rel_insert_input>;
  bucketId?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  etag?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["uuid"]>;
  isUploaded?: InputMaybe<Scalars["Boolean"]>;
  mimeType?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  size?: InputMaybe<Scalars["Int"]>;
  updatedAt?: InputMaybe<Scalars["timestamptz"]>;
  uploadedByUserId?: InputMaybe<Scalars["uuid"]>;
};

/** order by max() on columns of table "storage.files" */
export type files_max_order_by = {
  bucketId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  etag?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  mimeType?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  size?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  uploadedByUserId?: InputMaybe<order_by>;
};

/** order by min() on columns of table "storage.files" */
export type files_min_order_by = {
  bucketId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  etag?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  mimeType?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  size?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  uploadedByUserId?: InputMaybe<order_by>;
};

/** on_conflict condition type for table "storage.files" */
export type files_on_conflict = {
  constraint: files_constraint;
  update_columns?: Array<files_update_column>;
  where?: InputMaybe<files_bool_exp>;
};

/** Ordering options when selecting data from "storage.files". */
export type files_order_by = {
  bucket?: InputMaybe<buckets_order_by>;
  bucketId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  etag?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  isUploaded?: InputMaybe<order_by>;
  mimeType?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  size?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  uploadedByUserId?: InputMaybe<order_by>;
};

/** primary key columns input for table: storage.files */
export type files_pk_columns_input = {
  id: Scalars["uuid"];
};

/** select columns of table "storage.files" */
export enum files_select_column {
  /** column name */
  bucketId = "bucketId",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  etag = "etag",
  /** column name */
  id = "id",
  /** column name */
  isUploaded = "isUploaded",
  /** column name */
  mimeType = "mimeType",
  /** column name */
  name = "name",
  /** column name */
  size = "size",
  /** column name */
  updatedAt = "updatedAt",
  /** column name */
  uploadedByUserId = "uploadedByUserId",
}

/** select "files_aggregate_bool_exp_bool_and_arguments_columns" columns of table "storage.files" */
export enum files_select_column_files_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  isUploaded = "isUploaded",
}

/** select "files_aggregate_bool_exp_bool_or_arguments_columns" columns of table "storage.files" */
export enum files_select_column_files_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  isUploaded = "isUploaded",
}

/** input type for updating data in table "storage.files" */
export type files_set_input = {
  bucketId?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  etag?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["uuid"]>;
  isUploaded?: InputMaybe<Scalars["Boolean"]>;
  mimeType?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  size?: InputMaybe<Scalars["Int"]>;
  updatedAt?: InputMaybe<Scalars["timestamptz"]>;
  uploadedByUserId?: InputMaybe<Scalars["uuid"]>;
};

/** order by stddev() on columns of table "storage.files" */
export type files_stddev_order_by = {
  size?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "storage.files" */
export type files_stddev_pop_order_by = {
  size?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "storage.files" */
export type files_stddev_samp_order_by = {
  size?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "files" */
export type files_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: files_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type files_stream_cursor_value_input = {
  bucketId?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  etag?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["uuid"]>;
  isUploaded?: InputMaybe<Scalars["Boolean"]>;
  mimeType?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  size?: InputMaybe<Scalars["Int"]>;
  updatedAt?: InputMaybe<Scalars["timestamptz"]>;
  uploadedByUserId?: InputMaybe<Scalars["uuid"]>;
};

/** order by sum() on columns of table "storage.files" */
export type files_sum_order_by = {
  size?: InputMaybe<order_by>;
};

/** update columns of table "storage.files" */
export enum files_update_column {
  /** column name */
  bucketId = "bucketId",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  etag = "etag",
  /** column name */
  id = "id",
  /** column name */
  isUploaded = "isUploaded",
  /** column name */
  mimeType = "mimeType",
  /** column name */
  name = "name",
  /** column name */
  size = "size",
  /** column name */
  updatedAt = "updatedAt",
  /** column name */
  uploadedByUserId = "uploadedByUserId",
}

export type files_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<files_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<files_set_input>;
  where: files_bool_exp;
};

/** order by var_pop() on columns of table "storage.files" */
export type files_var_pop_order_by = {
  size?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "storage.files" */
export type files_var_samp_order_by = {
  size?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "storage.files" */
export type files_variance_order_by = {
  size?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "first_meetings_leads_accounts_gql". All fields are combined with a logical 'AND'. */
export type first_meetings_leads_accounts_gql_bool_exp = {
  _and?: InputMaybe<Array<first_meetings_leads_accounts_gql_bool_exp>>;
  _not?: InputMaybe<first_meetings_leads_accounts_gql_bool_exp>;
  _or?: InputMaybe<Array<first_meetings_leads_accounts_gql_bool_exp>>;
  account_name?: InputMaybe<String_comparison_exp>;
  activitydate?: InputMaybe<timestamp_comparison_exp>;
  contact?: InputMaybe<String_comparison_exp>;
  createddate?: InputMaybe<timestamp_comparison_exp>;
  eventid?: InputMaybe<String_comparison_exp>;
  meeting_owner?: InputMaybe<String_comparison_exp>;
  subject?: InputMaybe<String_comparison_exp>;
  title?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "first_meetings_leads_accounts_gql". */
export type first_meetings_leads_accounts_gql_order_by = {
  account_name?: InputMaybe<order_by>;
  activitydate?: InputMaybe<order_by>;
  contact?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  eventid?: InputMaybe<order_by>;
  meeting_owner?: InputMaybe<order_by>;
  subject?: InputMaybe<order_by>;
  title?: InputMaybe<order_by>;
};

/** select columns of table "first_meetings_leads_accounts_gql" */
export enum first_meetings_leads_accounts_gql_select_column {
  /** column name */
  account_name = "account_name",
  /** column name */
  activitydate = "activitydate",
  /** column name */
  contact = "contact",
  /** column name */
  createddate = "createddate",
  /** column name */
  eventid = "eventid",
  /** column name */
  meeting_owner = "meeting_owner",
  /** column name */
  subject = "subject",
  /** column name */
  title = "title",
}

/** Streaming cursor of the table "first_meetings_leads_accounts_gql" */
export type first_meetings_leads_accounts_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: first_meetings_leads_accounts_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type first_meetings_leads_accounts_gql_stream_cursor_value_input = {
  account_name?: InputMaybe<Scalars["String"]>;
  activitydate?: InputMaybe<Scalars["timestamp"]>;
  contact?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  eventid?: InputMaybe<Scalars["String"]>;
  meeting_owner?: InputMaybe<Scalars["String"]>;
  subject?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type float8_comparison_exp = {
  _eq?: InputMaybe<Scalars["float8"]>;
  _gt?: InputMaybe<Scalars["float8"]>;
  _gte?: InputMaybe<Scalars["float8"]>;
  _in?: InputMaybe<Array<Scalars["float8"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["float8"]>;
  _lte?: InputMaybe<Scalars["float8"]>;
  _neq?: InputMaybe<Scalars["float8"]>;
  _nin?: InputMaybe<Array<Scalars["float8"]>>;
};

/** Boolean expression to filter rows from the table "icp_industry_gql". All fields are combined with a logical 'AND'. */
export type icp_industry_gql_bool_exp = {
  _and?: InputMaybe<Array<icp_industry_gql_bool_exp>>;
  _not?: InputMaybe<icp_industry_gql_bool_exp>;
  _or?: InputMaybe<Array<icp_industry_gql_bool_exp>>;
  count?: InputMaybe<bigint_comparison_exp>;
  naics_industry_detail__c?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "icp_industry_gql". */
export type icp_industry_gql_order_by = {
  count?: InputMaybe<order_by>;
  naics_industry_detail__c?: InputMaybe<order_by>;
};

/** select columns of table "icp_industry_gql" */
export enum icp_industry_gql_select_column {
  /** column name */
  count = "count",
  /** column name */
  naics_industry_detail__c = "naics_industry_detail__c",
}

/** Streaming cursor of the table "icp_industry_gql" */
export type icp_industry_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: icp_industry_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type icp_industry_gql_stream_cursor_value_input = {
  count?: InputMaybe<Scalars["bigint"]>;
  naics_industry_detail__c?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "invites". All fields are combined with a logical 'AND'. */
export type invites_bool_exp = {
  _and?: InputMaybe<Array<invites_bool_exp>>;
  _not?: InputMaybe<invites_bool_exp>;
  _or?: InputMaybe<Array<invites_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<bigint_comparison_exp>;
  invitee_email?: InputMaybe<citext_comparison_exp>;
  inviter_id?: InputMaybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "invites" */
export enum invites_constraint {
  /** unique or primary key constraint on columns "id" */
  invites_pkey = "invites_pkey",
}

/** input type for incrementing numeric columns in table "invites" */
export type invites_inc_input = {
  id?: InputMaybe<Scalars["bigint"]>;
};

/** input type for inserting data into table "invites" */
export type invites_insert_input = {
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  invitee_email?: InputMaybe<Scalars["citext"]>;
  inviter_id?: InputMaybe<Scalars["String"]>;
};

/** on_conflict condition type for table "invites" */
export type invites_on_conflict = {
  constraint: invites_constraint;
  update_columns?: Array<invites_update_column>;
  where?: InputMaybe<invites_bool_exp>;
};

/** Ordering options when selecting data from "invites". */
export type invites_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  invitee_email?: InputMaybe<order_by>;
  inviter_id?: InputMaybe<order_by>;
};

/** primary key columns input for table: invites */
export type invites_pk_columns_input = {
  id: Scalars["bigint"];
};

/** select columns of table "invites" */
export enum invites_select_column {
  /** column name */
  created_at = "created_at",
  /** column name */
  id = "id",
  /** column name */
  invitee_email = "invitee_email",
  /** column name */
  inviter_id = "inviter_id",
}

/** input type for updating data in table "invites" */
export type invites_set_input = {
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  invitee_email?: InputMaybe<Scalars["citext"]>;
  inviter_id?: InputMaybe<Scalars["String"]>;
};

/** Streaming cursor of the table "invites" */
export type invites_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: invites_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type invites_stream_cursor_value_input = {
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  invitee_email?: InputMaybe<Scalars["citext"]>;
  inviter_id?: InputMaybe<Scalars["String"]>;
};

/** update columns of table "invites" */
export enum invites_update_column {
  /** column name */
  created_at = "created_at",
  /** column name */
  id = "id",
  /** column name */
  invitee_email = "invitee_email",
  /** column name */
  inviter_id = "inviter_id",
}

export type invites_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<invites_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<invites_set_input>;
  where: invites_bool_exp;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type json_comparison_exp = {
  _eq?: InputMaybe<Scalars["json"]>;
  _gt?: InputMaybe<Scalars["json"]>;
  _gte?: InputMaybe<Scalars["json"]>;
  _in?: InputMaybe<Array<Scalars["json"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["json"]>;
  _lte?: InputMaybe<Scalars["json"]>;
  _neq?: InputMaybe<Scalars["json"]>;
  _nin?: InputMaybe<Array<Scalars["json"]>>;
};

export type jsonb_cast_exp = {
  String?: InputMaybe<String_comparison_exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type jsonb_comparison_exp = {
  _cast?: InputMaybe<jsonb_cast_exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars["jsonb"]>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars["jsonb"]>;
  _eq?: InputMaybe<Scalars["jsonb"]>;
  _gt?: InputMaybe<Scalars["jsonb"]>;
  _gte?: InputMaybe<Scalars["jsonb"]>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars["String"]>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars["String"]>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars["String"]>>;
  _in?: InputMaybe<Array<Scalars["jsonb"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["jsonb"]>;
  _lte?: InputMaybe<Scalars["jsonb"]>;
  _neq?: InputMaybe<Scalars["jsonb"]>;
  _nin?: InputMaybe<Array<Scalars["jsonb"]>>;
};

/** Boolean expression to filter rows from the table "leaderboard_summary_gql". All fields are combined with a logical 'AND'. */
export type leaderboard_summary_gql_bool_exp = {
  _and?: InputMaybe<Array<leaderboard_summary_gql_bool_exp>>;
  _not?: InputMaybe<leaderboard_summary_gql_bool_exp>;
  _or?: InputMaybe<Array<leaderboard_summary_gql_bool_exp>>;
  closedate?: InputMaybe<timestamp_comparison_exp>;
  createddate?: InputMaybe<timestamp_comparison_exp>;
  id?: InputMaybe<String_comparison_exp>;
  licenses__c?: InputMaybe<numeric_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "leaderboard_summary_gql". */
export type leaderboard_summary_gql_order_by = {
  closedate?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  licenses__c?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
};

/** select columns of table "leaderboard_summary_gql" */
export enum leaderboard_summary_gql_select_column {
  /** column name */
  closedate = "closedate",
  /** column name */
  createddate = "createddate",
  /** column name */
  id = "id",
  /** column name */
  licenses__c = "licenses__c",
  /** column name */
  name = "name",
}

/** Streaming cursor of the table "leaderboard_summary_gql" */
export type leaderboard_summary_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: leaderboard_summary_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type leaderboard_summary_gql_stream_cursor_value_input = {
  closedate?: InputMaybe<Scalars["timestamp"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  id?: InputMaybe<Scalars["String"]>;
  licenses__c?: InputMaybe<Scalars["numeric"]>;
  name?: InputMaybe<Scalars["String"]>;
};

export type ml_icp_account_aggregate_bool_exp = {
  avg?: InputMaybe<ml_icp_account_aggregate_bool_exp_avg>;
  corr?: InputMaybe<ml_icp_account_aggregate_bool_exp_corr>;
  count?: InputMaybe<ml_icp_account_aggregate_bool_exp_count>;
  covar_samp?: InputMaybe<ml_icp_account_aggregate_bool_exp_covar_samp>;
  max?: InputMaybe<ml_icp_account_aggregate_bool_exp_max>;
  min?: InputMaybe<ml_icp_account_aggregate_bool_exp_min>;
  stddev_samp?: InputMaybe<ml_icp_account_aggregate_bool_exp_stddev_samp>;
  sum?: InputMaybe<ml_icp_account_aggregate_bool_exp_sum>;
  var_samp?: InputMaybe<ml_icp_account_aggregate_bool_exp_var_samp>;
};

export type ml_icp_account_aggregate_bool_exp_avg = {
  arguments: ml_icp_account_select_column_ml_icp_account_aggregate_bool_exp_avg_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<ml_icp_account_bool_exp>;
  predicate: float8_comparison_exp;
};

export type ml_icp_account_aggregate_bool_exp_corr = {
  arguments: ml_icp_account_aggregate_bool_exp_corr_arguments;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<ml_icp_account_bool_exp>;
  predicate: float8_comparison_exp;
};

export type ml_icp_account_aggregate_bool_exp_corr_arguments = {
  X: ml_icp_account_select_column_ml_icp_account_aggregate_bool_exp_corr_arguments_columns;
  Y: ml_icp_account_select_column_ml_icp_account_aggregate_bool_exp_corr_arguments_columns;
};

export type ml_icp_account_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<ml_icp_account_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<ml_icp_account_bool_exp>;
  predicate: Int_comparison_exp;
};

export type ml_icp_account_aggregate_bool_exp_covar_samp = {
  arguments: ml_icp_account_aggregate_bool_exp_covar_samp_arguments;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<ml_icp_account_bool_exp>;
  predicate: float8_comparison_exp;
};

export type ml_icp_account_aggregate_bool_exp_covar_samp_arguments = {
  X: ml_icp_account_select_column_ml_icp_account_aggregate_bool_exp_covar_samp_arguments_columns;
  Y: ml_icp_account_select_column_ml_icp_account_aggregate_bool_exp_covar_samp_arguments_columns;
};

export type ml_icp_account_aggregate_bool_exp_max = {
  arguments: ml_icp_account_select_column_ml_icp_account_aggregate_bool_exp_max_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<ml_icp_account_bool_exp>;
  predicate: float8_comparison_exp;
};

export type ml_icp_account_aggregate_bool_exp_min = {
  arguments: ml_icp_account_select_column_ml_icp_account_aggregate_bool_exp_min_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<ml_icp_account_bool_exp>;
  predicate: float8_comparison_exp;
};

export type ml_icp_account_aggregate_bool_exp_stddev_samp = {
  arguments: ml_icp_account_select_column_ml_icp_account_aggregate_bool_exp_stddev_samp_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<ml_icp_account_bool_exp>;
  predicate: float8_comparison_exp;
};

export type ml_icp_account_aggregate_bool_exp_sum = {
  arguments: ml_icp_account_select_column_ml_icp_account_aggregate_bool_exp_sum_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<ml_icp_account_bool_exp>;
  predicate: float8_comparison_exp;
};

export type ml_icp_account_aggregate_bool_exp_var_samp = {
  arguments: ml_icp_account_select_column_ml_icp_account_aggregate_bool_exp_var_samp_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<ml_icp_account_bool_exp>;
  predicate: float8_comparison_exp;
};

/** order by aggregate values of table "ml_icp_account" */
export type ml_icp_account_aggregate_order_by = {
  avg?: InputMaybe<ml_icp_account_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<ml_icp_account_max_order_by>;
  min?: InputMaybe<ml_icp_account_min_order_by>;
  stddev?: InputMaybe<ml_icp_account_stddev_order_by>;
  stddev_pop?: InputMaybe<ml_icp_account_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<ml_icp_account_stddev_samp_order_by>;
  sum?: InputMaybe<ml_icp_account_sum_order_by>;
  var_pop?: InputMaybe<ml_icp_account_var_pop_order_by>;
  var_samp?: InputMaybe<ml_icp_account_var_samp_order_by>;
  variance?: InputMaybe<ml_icp_account_variance_order_by>;
};

/** input type for inserting array relation for remote table "ml_icp_account" */
export type ml_icp_account_arr_rel_insert_input = {
  data: Array<ml_icp_account_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ml_icp_account_on_conflict>;
};

/** order by avg() on columns of table "ml_icp_account" */
export type ml_icp_account_avg_order_by = {
  predict_proba?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "ml_icp_account". All fields are combined with a logical 'AND'. */
export type ml_icp_account_bool_exp = {
  _and?: InputMaybe<Array<ml_icp_account_bool_exp>>;
  _not?: InputMaybe<ml_icp_account_bool_exp>;
  _or?: InputMaybe<Array<ml_icp_account_bool_exp>>;
  accountid?: InputMaybe<String_comparison_exp>;
  date?: InputMaybe<date_comparison_exp>;
  model_version?: InputMaybe<String_comparison_exp>;
  predict_proba?: InputMaybe<float8_comparison_exp>;
  updated_at?: InputMaybe<timestamp_comparison_exp>;
};

/** unique or primary key constraints on table "ml_icp_account" */
export enum ml_icp_account_constraint {
  /** unique or primary key constraint on columns "date", "accountid" */
  ml_icp_account_pkey = "ml_icp_account_pkey",
}

/** input type for incrementing numeric columns in table "ml_icp_account" */
export type ml_icp_account_inc_input = {
  predict_proba?: InputMaybe<Scalars["float8"]>;
};

/** input type for inserting data into table "ml_icp_account" */
export type ml_icp_account_insert_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  date?: InputMaybe<Scalars["date"]>;
  model_version?: InputMaybe<Scalars["String"]>;
  predict_proba?: InputMaybe<Scalars["float8"]>;
  updated_at?: InputMaybe<Scalars["timestamp"]>;
};

/** order by max() on columns of table "ml_icp_account" */
export type ml_icp_account_max_order_by = {
  accountid?: InputMaybe<order_by>;
  date?: InputMaybe<order_by>;
  model_version?: InputMaybe<order_by>;
  predict_proba?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** order by min() on columns of table "ml_icp_account" */
export type ml_icp_account_min_order_by = {
  accountid?: InputMaybe<order_by>;
  date?: InputMaybe<order_by>;
  model_version?: InputMaybe<order_by>;
  predict_proba?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** on_conflict condition type for table "ml_icp_account" */
export type ml_icp_account_on_conflict = {
  constraint: ml_icp_account_constraint;
  update_columns?: Array<ml_icp_account_update_column>;
  where?: InputMaybe<ml_icp_account_bool_exp>;
};

/** Ordering options when selecting data from "ml_icp_account". */
export type ml_icp_account_order_by = {
  accountid?: InputMaybe<order_by>;
  date?: InputMaybe<order_by>;
  model_version?: InputMaybe<order_by>;
  predict_proba?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** primary key columns input for table: ml_icp_account */
export type ml_icp_account_pk_columns_input = {
  accountid: Scalars["String"];
  date: Scalars["date"];
};

/** select columns of table "ml_icp_account" */
export enum ml_icp_account_select_column {
  /** column name */
  accountid = "accountid",
  /** column name */
  date = "date",
  /** column name */
  model_version = "model_version",
  /** column name */
  predict_proba = "predict_proba",
  /** column name */
  updated_at = "updated_at",
}

/** select "ml_icp_account_aggregate_bool_exp_avg_arguments_columns" columns of table "ml_icp_account" */
export enum ml_icp_account_select_column_ml_icp_account_aggregate_bool_exp_avg_arguments_columns {
  /** column name */
  predict_proba = "predict_proba",
}

/** select "ml_icp_account_aggregate_bool_exp_corr_arguments_columns" columns of table "ml_icp_account" */
export enum ml_icp_account_select_column_ml_icp_account_aggregate_bool_exp_corr_arguments_columns {
  /** column name */
  predict_proba = "predict_proba",
}

/** select "ml_icp_account_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "ml_icp_account" */
export enum ml_icp_account_select_column_ml_icp_account_aggregate_bool_exp_covar_samp_arguments_columns {
  /** column name */
  predict_proba = "predict_proba",
}

/** select "ml_icp_account_aggregate_bool_exp_max_arguments_columns" columns of table "ml_icp_account" */
export enum ml_icp_account_select_column_ml_icp_account_aggregate_bool_exp_max_arguments_columns {
  /** column name */
  predict_proba = "predict_proba",
}

/** select "ml_icp_account_aggregate_bool_exp_min_arguments_columns" columns of table "ml_icp_account" */
export enum ml_icp_account_select_column_ml_icp_account_aggregate_bool_exp_min_arguments_columns {
  /** column name */
  predict_proba = "predict_proba",
}

/** select "ml_icp_account_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "ml_icp_account" */
export enum ml_icp_account_select_column_ml_icp_account_aggregate_bool_exp_stddev_samp_arguments_columns {
  /** column name */
  predict_proba = "predict_proba",
}

/** select "ml_icp_account_aggregate_bool_exp_sum_arguments_columns" columns of table "ml_icp_account" */
export enum ml_icp_account_select_column_ml_icp_account_aggregate_bool_exp_sum_arguments_columns {
  /** column name */
  predict_proba = "predict_proba",
}

/** select "ml_icp_account_aggregate_bool_exp_var_samp_arguments_columns" columns of table "ml_icp_account" */
export enum ml_icp_account_select_column_ml_icp_account_aggregate_bool_exp_var_samp_arguments_columns {
  /** column name */
  predict_proba = "predict_proba",
}

/** input type for updating data in table "ml_icp_account" */
export type ml_icp_account_set_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  date?: InputMaybe<Scalars["date"]>;
  model_version?: InputMaybe<Scalars["String"]>;
  predict_proba?: InputMaybe<Scalars["float8"]>;
  updated_at?: InputMaybe<Scalars["timestamp"]>;
};

/** order by stddev() on columns of table "ml_icp_account" */
export type ml_icp_account_stddev_order_by = {
  predict_proba?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "ml_icp_account" */
export type ml_icp_account_stddev_pop_order_by = {
  predict_proba?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "ml_icp_account" */
export type ml_icp_account_stddev_samp_order_by = {
  predict_proba?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "ml_icp_account" */
export type ml_icp_account_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: ml_icp_account_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ml_icp_account_stream_cursor_value_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  date?: InputMaybe<Scalars["date"]>;
  model_version?: InputMaybe<Scalars["String"]>;
  predict_proba?: InputMaybe<Scalars["float8"]>;
  updated_at?: InputMaybe<Scalars["timestamp"]>;
};

/** order by sum() on columns of table "ml_icp_account" */
export type ml_icp_account_sum_order_by = {
  predict_proba?: InputMaybe<order_by>;
};

/** update columns of table "ml_icp_account" */
export enum ml_icp_account_update_column {
  /** column name */
  accountid = "accountid",
  /** column name */
  date = "date",
  /** column name */
  model_version = "model_version",
  /** column name */
  predict_proba = "predict_proba",
  /** column name */
  updated_at = "updated_at",
}

export type ml_icp_account_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ml_icp_account_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ml_icp_account_set_input>;
  where: ml_icp_account_bool_exp;
};

/** order by var_pop() on columns of table "ml_icp_account" */
export type ml_icp_account_var_pop_order_by = {
  predict_proba?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "ml_icp_account" */
export type ml_icp_account_var_samp_order_by = {
  predict_proba?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "ml_icp_account" */
export type ml_icp_account_variance_order_by = {
  predict_proba?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "ml_icp_last_prediction". All fields are combined with a logical 'AND'. */
export type ml_icp_last_prediction_bool_exp = {
  _and?: InputMaybe<Array<ml_icp_last_prediction_bool_exp>>;
  _not?: InputMaybe<ml_icp_last_prediction_bool_exp>;
  _or?: InputMaybe<Array<ml_icp_last_prediction_bool_exp>>;
  crm_id?: InputMaybe<String_comparison_exp>;
  date?: InputMaybe<date_comparison_exp>;
  predict_proba?: InputMaybe<float8_comparison_exp>;
  revtron_id?: InputMaybe<Int_comparison_exp>;
  to_revtron_companies?: InputMaybe<revtron_companies_bool_exp>;
};

/** Ordering options when selecting data from "ml_icp_last_prediction". */
export type ml_icp_last_prediction_order_by = {
  crm_id?: InputMaybe<order_by>;
  date?: InputMaybe<order_by>;
  predict_proba?: InputMaybe<order_by>;
  revtron_id?: InputMaybe<order_by>;
  to_revtron_companies?: InputMaybe<revtron_companies_order_by>;
};

/** select columns of table "ml_icp_last_prediction" */
export enum ml_icp_last_prediction_select_column {
  /** column name */
  crm_id = "crm_id",
  /** column name */
  date = "date",
  /** column name */
  predict_proba = "predict_proba",
  /** column name */
  revtron_id = "revtron_id",
}

/** Streaming cursor of the table "ml_icp_last_prediction" */
export type ml_icp_last_prediction_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: ml_icp_last_prediction_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ml_icp_last_prediction_stream_cursor_value_input = {
  crm_id?: InputMaybe<Scalars["String"]>;
  date?: InputMaybe<Scalars["date"]>;
  predict_proba?: InputMaybe<Scalars["float8"]>;
  revtron_id?: InputMaybe<Scalars["Int"]>;
};

export type ml_icp_predictions_aggregate_bool_exp = {
  avg?: InputMaybe<ml_icp_predictions_aggregate_bool_exp_avg>;
  corr?: InputMaybe<ml_icp_predictions_aggregate_bool_exp_corr>;
  count?: InputMaybe<ml_icp_predictions_aggregate_bool_exp_count>;
  covar_samp?: InputMaybe<ml_icp_predictions_aggregate_bool_exp_covar_samp>;
  max?: InputMaybe<ml_icp_predictions_aggregate_bool_exp_max>;
  min?: InputMaybe<ml_icp_predictions_aggregate_bool_exp_min>;
  stddev_samp?: InputMaybe<ml_icp_predictions_aggregate_bool_exp_stddev_samp>;
  sum?: InputMaybe<ml_icp_predictions_aggregate_bool_exp_sum>;
  var_samp?: InputMaybe<ml_icp_predictions_aggregate_bool_exp_var_samp>;
};

export type ml_icp_predictions_aggregate_bool_exp_avg = {
  arguments: ml_icp_predictions_select_column_ml_icp_predictions_aggregate_bool_exp_avg_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<ml_icp_predictions_bool_exp>;
  predicate: float8_comparison_exp;
};

export type ml_icp_predictions_aggregate_bool_exp_corr = {
  arguments: ml_icp_predictions_aggregate_bool_exp_corr_arguments;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<ml_icp_predictions_bool_exp>;
  predicate: float8_comparison_exp;
};

export type ml_icp_predictions_aggregate_bool_exp_corr_arguments = {
  X: ml_icp_predictions_select_column_ml_icp_predictions_aggregate_bool_exp_corr_arguments_columns;
  Y: ml_icp_predictions_select_column_ml_icp_predictions_aggregate_bool_exp_corr_arguments_columns;
};

export type ml_icp_predictions_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<ml_icp_predictions_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<ml_icp_predictions_bool_exp>;
  predicate: Int_comparison_exp;
};

export type ml_icp_predictions_aggregate_bool_exp_covar_samp = {
  arguments: ml_icp_predictions_aggregate_bool_exp_covar_samp_arguments;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<ml_icp_predictions_bool_exp>;
  predicate: float8_comparison_exp;
};

export type ml_icp_predictions_aggregate_bool_exp_covar_samp_arguments = {
  X: ml_icp_predictions_select_column_ml_icp_predictions_aggregate_bool_exp_covar_samp_arguments_columns;
  Y: ml_icp_predictions_select_column_ml_icp_predictions_aggregate_bool_exp_covar_samp_arguments_columns;
};

export type ml_icp_predictions_aggregate_bool_exp_max = {
  arguments: ml_icp_predictions_select_column_ml_icp_predictions_aggregate_bool_exp_max_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<ml_icp_predictions_bool_exp>;
  predicate: float8_comparison_exp;
};

export type ml_icp_predictions_aggregate_bool_exp_min = {
  arguments: ml_icp_predictions_select_column_ml_icp_predictions_aggregate_bool_exp_min_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<ml_icp_predictions_bool_exp>;
  predicate: float8_comparison_exp;
};

export type ml_icp_predictions_aggregate_bool_exp_stddev_samp = {
  arguments: ml_icp_predictions_select_column_ml_icp_predictions_aggregate_bool_exp_stddev_samp_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<ml_icp_predictions_bool_exp>;
  predicate: float8_comparison_exp;
};

export type ml_icp_predictions_aggregate_bool_exp_sum = {
  arguments: ml_icp_predictions_select_column_ml_icp_predictions_aggregate_bool_exp_sum_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<ml_icp_predictions_bool_exp>;
  predicate: float8_comparison_exp;
};

export type ml_icp_predictions_aggregate_bool_exp_var_samp = {
  arguments: ml_icp_predictions_select_column_ml_icp_predictions_aggregate_bool_exp_var_samp_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<ml_icp_predictions_bool_exp>;
  predicate: float8_comparison_exp;
};

/** order by aggregate values of table "ml_icp_predictions" */
export type ml_icp_predictions_aggregate_order_by = {
  avg?: InputMaybe<ml_icp_predictions_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<ml_icp_predictions_max_order_by>;
  min?: InputMaybe<ml_icp_predictions_min_order_by>;
  stddev?: InputMaybe<ml_icp_predictions_stddev_order_by>;
  stddev_pop?: InputMaybe<ml_icp_predictions_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<ml_icp_predictions_stddev_samp_order_by>;
  sum?: InputMaybe<ml_icp_predictions_sum_order_by>;
  var_pop?: InputMaybe<ml_icp_predictions_var_pop_order_by>;
  var_samp?: InputMaybe<ml_icp_predictions_var_samp_order_by>;
  variance?: InputMaybe<ml_icp_predictions_variance_order_by>;
};

/** input type for inserting array relation for remote table "ml_icp_predictions" */
export type ml_icp_predictions_arr_rel_insert_input = {
  data: Array<ml_icp_predictions_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ml_icp_predictions_on_conflict>;
};

/** order by avg() on columns of table "ml_icp_predictions" */
export type ml_icp_predictions_avg_order_by = {
  predict_proba?: InputMaybe<order_by>;
  revtron_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "ml_icp_predictions". All fields are combined with a logical 'AND'. */
export type ml_icp_predictions_bool_exp = {
  _and?: InputMaybe<Array<ml_icp_predictions_bool_exp>>;
  _not?: InputMaybe<ml_icp_predictions_bool_exp>;
  _or?: InputMaybe<Array<ml_icp_predictions_bool_exp>>;
  date?: InputMaybe<date_comparison_exp>;
  model_version?: InputMaybe<String_comparison_exp>;
  predict_proba?: InputMaybe<float8_comparison_exp>;
  revtron_id?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamp_comparison_exp>;
};

/** unique or primary key constraints on table "ml_icp_predictions" */
export enum ml_icp_predictions_constraint {
  /** unique or primary key constraint on columns "revtron_id", "date" */
  ml_icp_predictions_pkey = "ml_icp_predictions_pkey",
}

/** input type for incrementing numeric columns in table "ml_icp_predictions" */
export type ml_icp_predictions_inc_input = {
  predict_proba?: InputMaybe<Scalars["float8"]>;
  revtron_id?: InputMaybe<Scalars["Int"]>;
};

/** input type for inserting data into table "ml_icp_predictions" */
export type ml_icp_predictions_insert_input = {
  date?: InputMaybe<Scalars["date"]>;
  model_version?: InputMaybe<Scalars["String"]>;
  predict_proba?: InputMaybe<Scalars["float8"]>;
  revtron_id?: InputMaybe<Scalars["Int"]>;
  updated_at?: InputMaybe<Scalars["timestamp"]>;
};

/** order by max() on columns of table "ml_icp_predictions" */
export type ml_icp_predictions_max_order_by = {
  date?: InputMaybe<order_by>;
  model_version?: InputMaybe<order_by>;
  predict_proba?: InputMaybe<order_by>;
  revtron_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** order by min() on columns of table "ml_icp_predictions" */
export type ml_icp_predictions_min_order_by = {
  date?: InputMaybe<order_by>;
  model_version?: InputMaybe<order_by>;
  predict_proba?: InputMaybe<order_by>;
  revtron_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** on_conflict condition type for table "ml_icp_predictions" */
export type ml_icp_predictions_on_conflict = {
  constraint: ml_icp_predictions_constraint;
  update_columns?: Array<ml_icp_predictions_update_column>;
  where?: InputMaybe<ml_icp_predictions_bool_exp>;
};

/** Ordering options when selecting data from "ml_icp_predictions". */
export type ml_icp_predictions_order_by = {
  date?: InputMaybe<order_by>;
  model_version?: InputMaybe<order_by>;
  predict_proba?: InputMaybe<order_by>;
  revtron_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** primary key columns input for table: ml_icp_predictions */
export type ml_icp_predictions_pk_columns_input = {
  date: Scalars["date"];
  revtron_id: Scalars["Int"];
};

/** select columns of table "ml_icp_predictions" */
export enum ml_icp_predictions_select_column {
  /** column name */
  date = "date",
  /** column name */
  model_version = "model_version",
  /** column name */
  predict_proba = "predict_proba",
  /** column name */
  revtron_id = "revtron_id",
  /** column name */
  updated_at = "updated_at",
}

/** select "ml_icp_predictions_aggregate_bool_exp_avg_arguments_columns" columns of table "ml_icp_predictions" */
export enum ml_icp_predictions_select_column_ml_icp_predictions_aggregate_bool_exp_avg_arguments_columns {
  /** column name */
  predict_proba = "predict_proba",
}

/** select "ml_icp_predictions_aggregate_bool_exp_corr_arguments_columns" columns of table "ml_icp_predictions" */
export enum ml_icp_predictions_select_column_ml_icp_predictions_aggregate_bool_exp_corr_arguments_columns {
  /** column name */
  predict_proba = "predict_proba",
}

/** select "ml_icp_predictions_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "ml_icp_predictions" */
export enum ml_icp_predictions_select_column_ml_icp_predictions_aggregate_bool_exp_covar_samp_arguments_columns {
  /** column name */
  predict_proba = "predict_proba",
}

/** select "ml_icp_predictions_aggregate_bool_exp_max_arguments_columns" columns of table "ml_icp_predictions" */
export enum ml_icp_predictions_select_column_ml_icp_predictions_aggregate_bool_exp_max_arguments_columns {
  /** column name */
  predict_proba = "predict_proba",
}

/** select "ml_icp_predictions_aggregate_bool_exp_min_arguments_columns" columns of table "ml_icp_predictions" */
export enum ml_icp_predictions_select_column_ml_icp_predictions_aggregate_bool_exp_min_arguments_columns {
  /** column name */
  predict_proba = "predict_proba",
}

/** select "ml_icp_predictions_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "ml_icp_predictions" */
export enum ml_icp_predictions_select_column_ml_icp_predictions_aggregate_bool_exp_stddev_samp_arguments_columns {
  /** column name */
  predict_proba = "predict_proba",
}

/** select "ml_icp_predictions_aggregate_bool_exp_sum_arguments_columns" columns of table "ml_icp_predictions" */
export enum ml_icp_predictions_select_column_ml_icp_predictions_aggregate_bool_exp_sum_arguments_columns {
  /** column name */
  predict_proba = "predict_proba",
}

/** select "ml_icp_predictions_aggregate_bool_exp_var_samp_arguments_columns" columns of table "ml_icp_predictions" */
export enum ml_icp_predictions_select_column_ml_icp_predictions_aggregate_bool_exp_var_samp_arguments_columns {
  /** column name */
  predict_proba = "predict_proba",
}

/** input type for updating data in table "ml_icp_predictions" */
export type ml_icp_predictions_set_input = {
  date?: InputMaybe<Scalars["date"]>;
  model_version?: InputMaybe<Scalars["String"]>;
  predict_proba?: InputMaybe<Scalars["float8"]>;
  revtron_id?: InputMaybe<Scalars["Int"]>;
  updated_at?: InputMaybe<Scalars["timestamp"]>;
};

/** order by stddev() on columns of table "ml_icp_predictions" */
export type ml_icp_predictions_stddev_order_by = {
  predict_proba?: InputMaybe<order_by>;
  revtron_id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "ml_icp_predictions" */
export type ml_icp_predictions_stddev_pop_order_by = {
  predict_proba?: InputMaybe<order_by>;
  revtron_id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "ml_icp_predictions" */
export type ml_icp_predictions_stddev_samp_order_by = {
  predict_proba?: InputMaybe<order_by>;
  revtron_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "ml_icp_predictions" */
export type ml_icp_predictions_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: ml_icp_predictions_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ml_icp_predictions_stream_cursor_value_input = {
  date?: InputMaybe<Scalars["date"]>;
  model_version?: InputMaybe<Scalars["String"]>;
  predict_proba?: InputMaybe<Scalars["float8"]>;
  revtron_id?: InputMaybe<Scalars["Int"]>;
  updated_at?: InputMaybe<Scalars["timestamp"]>;
};

/** order by sum() on columns of table "ml_icp_predictions" */
export type ml_icp_predictions_sum_order_by = {
  predict_proba?: InputMaybe<order_by>;
  revtron_id?: InputMaybe<order_by>;
};

/** update columns of table "ml_icp_predictions" */
export enum ml_icp_predictions_update_column {
  /** column name */
  date = "date",
  /** column name */
  model_version = "model_version",
  /** column name */
  predict_proba = "predict_proba",
  /** column name */
  revtron_id = "revtron_id",
  /** column name */
  updated_at = "updated_at",
}

export type ml_icp_predictions_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ml_icp_predictions_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ml_icp_predictions_set_input>;
  where: ml_icp_predictions_bool_exp;
};

/** order by var_pop() on columns of table "ml_icp_predictions" */
export type ml_icp_predictions_var_pop_order_by = {
  predict_proba?: InputMaybe<order_by>;
  revtron_id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "ml_icp_predictions" */
export type ml_icp_predictions_var_samp_order_by = {
  predict_proba?: InputMaybe<order_by>;
  revtron_id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "ml_icp_predictions" */
export type ml_icp_predictions_variance_order_by = {
  predict_proba?: InputMaybe<order_by>;
  revtron_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "ml_icp_prospector". All fields are combined with a logical 'AND'. */
export type ml_icp_prospector_bool_exp = {
  _and?: InputMaybe<Array<ml_icp_prospector_bool_exp>>;
  _not?: InputMaybe<ml_icp_prospector_bool_exp>;
  _or?: InputMaybe<Array<ml_icp_prospector_bool_exp>>;
  crm_id?: InputMaybe<String_comparison_exp>;
  date?: InputMaybe<date_comparison_exp>;
  predict_proba?: InputMaybe<float8_comparison_exp>;
  revtron_id?: InputMaybe<Int_comparison_exp>;
  to_Account?: InputMaybe<Account_bool_exp>;
  to_revtron?: InputMaybe<revtron_companies_bool_exp>;
  to_revtron_aggregate?: InputMaybe<revtron_companies_aggregate_bool_exp>;
};

/** Ordering options when selecting data from "ml_icp_prospector". */
export type ml_icp_prospector_order_by = {
  crm_id?: InputMaybe<order_by>;
  date?: InputMaybe<order_by>;
  predict_proba?: InputMaybe<order_by>;
  revtron_id?: InputMaybe<order_by>;
  to_Account?: InputMaybe<Account_order_by>;
  to_revtron_aggregate?: InputMaybe<revtron_companies_aggregate_order_by>;
};

/** select columns of table "ml_icp_prospector" */
export enum ml_icp_prospector_select_column {
  /** column name */
  crm_id = "crm_id",
  /** column name */
  date = "date",
  /** column name */
  predict_proba = "predict_proba",
  /** column name */
  revtron_id = "revtron_id",
}

/** Streaming cursor of the table "ml_icp_prospector" */
export type ml_icp_prospector_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: ml_icp_prospector_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ml_icp_prospector_stream_cursor_value_input = {
  crm_id?: InputMaybe<Scalars["String"]>;
  date?: InputMaybe<Scalars["date"]>;
  predict_proba?: InputMaybe<Scalars["float8"]>;
  revtron_id?: InputMaybe<Scalars["Int"]>;
};

/** Boolean expression to filter rows from the table "ml_weighted_pipeline_gql". All fields are combined with a logical 'AND'. */
export type ml_weighted_pipeline_gql_bool_exp = {
  _and?: InputMaybe<Array<ml_weighted_pipeline_gql_bool_exp>>;
  _not?: InputMaybe<ml_weighted_pipeline_gql_bool_exp>;
  _or?: InputMaybe<Array<ml_weighted_pipeline_gql_bool_exp>>;
  account_id?: InputMaybe<String_comparison_exp>;
  account_name?: InputMaybe<String_comparison_exp>;
  amount?: InputMaybe<numeric_comparison_exp>;
  closedate?: InputMaybe<timestamp_comparison_exp>;
  createddate?: InputMaybe<timestamp_comparison_exp>;
  email?: InputMaybe<String_comparison_exp>;
  forecast_category?: InputMaybe<String_comparison_exp>;
  isclosed?: InputMaybe<Boolean_comparison_exp>;
  iswon?: InputMaybe<Boolean_comparison_exp>;
  leadsource?: InputMaybe<String_comparison_exp>;
  ml_probability?: InputMaybe<float8_comparison_exp>;
  ml_scored_date?: InputMaybe<date_comparison_exp>;
  ml_updated_at?: InputMaybe<timestamp_comparison_exp>;
  ml_weighted_arr?: InputMaybe<float8_comparison_exp>;
  ml_weighted_services?: InputMaybe<float8_comparison_exp>;
  opportunity_age?: InputMaybe<Int_comparison_exp>;
  opportunity_id?: InputMaybe<String_comparison_exp>;
  opportunity_name?: InputMaybe<String_comparison_exp>;
  opportunity_owner?: InputMaybe<String_comparison_exp>;
  probability?: InputMaybe<numeric_comparison_exp>;
  services_amount?: InputMaybe<numeric_comparison_exp>;
  sf_weighted_arr?: InputMaybe<numeric_comparison_exp>;
  sf_weighted_services?: InputMaybe<numeric_comparison_exp>;
  stage?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "ml_weighted_pipeline_gql". */
export type ml_weighted_pipeline_gql_order_by = {
  account_id?: InputMaybe<order_by>;
  account_name?: InputMaybe<order_by>;
  amount?: InputMaybe<order_by>;
  closedate?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  forecast_category?: InputMaybe<order_by>;
  isclosed?: InputMaybe<order_by>;
  iswon?: InputMaybe<order_by>;
  leadsource?: InputMaybe<order_by>;
  ml_probability?: InputMaybe<order_by>;
  ml_scored_date?: InputMaybe<order_by>;
  ml_updated_at?: InputMaybe<order_by>;
  ml_weighted_arr?: InputMaybe<order_by>;
  ml_weighted_services?: InputMaybe<order_by>;
  opportunity_age?: InputMaybe<order_by>;
  opportunity_id?: InputMaybe<order_by>;
  opportunity_name?: InputMaybe<order_by>;
  opportunity_owner?: InputMaybe<order_by>;
  probability?: InputMaybe<order_by>;
  services_amount?: InputMaybe<order_by>;
  sf_weighted_arr?: InputMaybe<order_by>;
  sf_weighted_services?: InputMaybe<order_by>;
  stage?: InputMaybe<order_by>;
};

/** select columns of table "ml_weighted_pipeline_gql" */
export enum ml_weighted_pipeline_gql_select_column {
  /** column name */
  account_id = "account_id",
  /** column name */
  account_name = "account_name",
  /** column name */
  amount = "amount",
  /** column name */
  closedate = "closedate",
  /** column name */
  createddate = "createddate",
  /** column name */
  email = "email",
  /** column name */
  forecast_category = "forecast_category",
  /** column name */
  isclosed = "isclosed",
  /** column name */
  iswon = "iswon",
  /** column name */
  leadsource = "leadsource",
  /** column name */
  ml_probability = "ml_probability",
  /** column name */
  ml_scored_date = "ml_scored_date",
  /** column name */
  ml_updated_at = "ml_updated_at",
  /** column name */
  ml_weighted_arr = "ml_weighted_arr",
  /** column name */
  ml_weighted_services = "ml_weighted_services",
  /** column name */
  opportunity_age = "opportunity_age",
  /** column name */
  opportunity_id = "opportunity_id",
  /** column name */
  opportunity_name = "opportunity_name",
  /** column name */
  opportunity_owner = "opportunity_owner",
  /** column name */
  probability = "probability",
  /** column name */
  services_amount = "services_amount",
  /** column name */
  sf_weighted_arr = "sf_weighted_arr",
  /** column name */
  sf_weighted_services = "sf_weighted_services",
  /** column name */
  stage = "stage",
}

/** Streaming cursor of the table "ml_weighted_pipeline_gql" */
export type ml_weighted_pipeline_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: ml_weighted_pipeline_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ml_weighted_pipeline_gql_stream_cursor_value_input = {
  account_id?: InputMaybe<Scalars["String"]>;
  account_name?: InputMaybe<Scalars["String"]>;
  amount?: InputMaybe<Scalars["numeric"]>;
  closedate?: InputMaybe<Scalars["timestamp"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  email?: InputMaybe<Scalars["String"]>;
  forecast_category?: InputMaybe<Scalars["String"]>;
  isclosed?: InputMaybe<Scalars["Boolean"]>;
  iswon?: InputMaybe<Scalars["Boolean"]>;
  leadsource?: InputMaybe<Scalars["String"]>;
  ml_probability?: InputMaybe<Scalars["float8"]>;
  ml_scored_date?: InputMaybe<Scalars["date"]>;
  ml_updated_at?: InputMaybe<Scalars["timestamp"]>;
  ml_weighted_arr?: InputMaybe<Scalars["float8"]>;
  ml_weighted_services?: InputMaybe<Scalars["float8"]>;
  opportunity_age?: InputMaybe<Scalars["Int"]>;
  opportunity_id?: InputMaybe<Scalars["String"]>;
  opportunity_name?: InputMaybe<Scalars["String"]>;
  opportunity_owner?: InputMaybe<Scalars["String"]>;
  probability?: InputMaybe<Scalars["numeric"]>;
  services_amount?: InputMaybe<Scalars["numeric"]>;
  sf_weighted_arr?: InputMaybe<Scalars["numeric"]>;
  sf_weighted_services?: InputMaybe<Scalars["numeric"]>;
  stage?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "monthly_bookings_gql". All fields are combined with a logical 'AND'. */
export type monthly_bookings_gql_bool_exp = {
  _and?: InputMaybe<Array<monthly_bookings_gql_bool_exp>>;
  _not?: InputMaybe<monthly_bookings_gql_bool_exp>;
  _or?: InputMaybe<Array<monthly_bookings_gql_bool_exp>>;
  date_trunc?: InputMaybe<timestamp_comparison_exp>;
  sum?: InputMaybe<numeric_comparison_exp>;
};

/** Ordering options when selecting data from "monthly_bookings_gql". */
export type monthly_bookings_gql_order_by = {
  date_trunc?: InputMaybe<order_by>;
  sum?: InputMaybe<order_by>;
};

/** select columns of table "monthly_bookings_gql" */
export enum monthly_bookings_gql_select_column {
  /** column name */
  date_trunc = "date_trunc",
  /** column name */
  sum = "sum",
}

/** Streaming cursor of the table "monthly_bookings_gql" */
export type monthly_bookings_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: monthly_bookings_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type monthly_bookings_gql_stream_cursor_value_input = {
  date_trunc?: InputMaybe<Scalars["timestamp"]>;
  sum?: InputMaybe<Scalars["numeric"]>;
};

/** Boolean expression to filter rows from the table "monthly_effort_breakdown_overview_gql". All fields are combined with a logical 'AND'. */
export type monthly_effort_breakdown_overview_gql_bool_exp = {
  _and?: InputMaybe<Array<monthly_effort_breakdown_overview_gql_bool_exp>>;
  _not?: InputMaybe<monthly_effort_breakdown_overview_gql_bool_exp>;
  _or?: InputMaybe<Array<monthly_effort_breakdown_overview_gql_bool_exp>>;
  count?: InputMaybe<bigint_comparison_exp>;
  date_trunc?: InputMaybe<timestamp_comparison_exp>;
  meeting_key?: InputMaybe<bigint_comparison_exp>;
  task_categorization?: InputMaybe<Int_comparison_exp>;
  type_category?: InputMaybe<String_comparison_exp>;
  type_detail?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "monthly_effort_breakdown_overview_gql". */
export type monthly_effort_breakdown_overview_gql_order_by = {
  count?: InputMaybe<order_by>;
  date_trunc?: InputMaybe<order_by>;
  meeting_key?: InputMaybe<order_by>;
  task_categorization?: InputMaybe<order_by>;
  type_category?: InputMaybe<order_by>;
  type_detail?: InputMaybe<order_by>;
};

/** select columns of table "monthly_effort_breakdown_overview_gql" */
export enum monthly_effort_breakdown_overview_gql_select_column {
  /** column name */
  count = "count",
  /** column name */
  date_trunc = "date_trunc",
  /** column name */
  meeting_key = "meeting_key",
  /** column name */
  task_categorization = "task_categorization",
  /** column name */
  type_category = "type_category",
  /** column name */
  type_detail = "type_detail",
}

/** Streaming cursor of the table "monthly_effort_breakdown_overview_gql" */
export type monthly_effort_breakdown_overview_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: monthly_effort_breakdown_overview_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type monthly_effort_breakdown_overview_gql_stream_cursor_value_input = {
  count?: InputMaybe<Scalars["bigint"]>;
  date_trunc?: InputMaybe<Scalars["timestamp"]>;
  meeting_key?: InputMaybe<Scalars["bigint"]>;
  task_categorization?: InputMaybe<Scalars["Int"]>;
  type_category?: InputMaybe<Scalars["String"]>;
  type_detail?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "monthly_engagement_breakdown_overview_gql". All fields are combined with a logical 'AND'. */
export type monthly_engagement_breakdown_overview_gql_bool_exp = {
  _and?: InputMaybe<Array<monthly_engagement_breakdown_overview_gql_bool_exp>>;
  _not?: InputMaybe<monthly_engagement_breakdown_overview_gql_bool_exp>;
  _or?: InputMaybe<Array<monthly_engagement_breakdown_overview_gql_bool_exp>>;
  count?: InputMaybe<bigint_comparison_exp>;
  date_trunc?: InputMaybe<timestamp_comparison_exp>;
  meeting_key?: InputMaybe<bigint_comparison_exp>;
  task_categorization?: InputMaybe<Int_comparison_exp>;
  type_category?: InputMaybe<String_comparison_exp>;
  type_detail?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "monthly_engagement_breakdown_overview_gql". */
export type monthly_engagement_breakdown_overview_gql_order_by = {
  count?: InputMaybe<order_by>;
  date_trunc?: InputMaybe<order_by>;
  meeting_key?: InputMaybe<order_by>;
  task_categorization?: InputMaybe<order_by>;
  type_category?: InputMaybe<order_by>;
  type_detail?: InputMaybe<order_by>;
};

/** select columns of table "monthly_engagement_breakdown_overview_gql" */
export enum monthly_engagement_breakdown_overview_gql_select_column {
  /** column name */
  count = "count",
  /** column name */
  date_trunc = "date_trunc",
  /** column name */
  meeting_key = "meeting_key",
  /** column name */
  task_categorization = "task_categorization",
  /** column name */
  type_category = "type_category",
  /** column name */
  type_detail = "type_detail",
}

/** Streaming cursor of the table "monthly_engagement_breakdown_overview_gql" */
export type monthly_engagement_breakdown_overview_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: monthly_engagement_breakdown_overview_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type monthly_engagement_breakdown_overview_gql_stream_cursor_value_input =
  {
    count?: InputMaybe<Scalars["bigint"]>;
    date_trunc?: InputMaybe<Scalars["timestamp"]>;
    meeting_key?: InputMaybe<Scalars["bigint"]>;
    task_categorization?: InputMaybe<Scalars["Int"]>;
    type_category?: InputMaybe<Scalars["String"]>;
    type_detail?: InputMaybe<Scalars["String"]>;
  };

/** Boolean expression to filter rows from the table "monthly_pipeline_gql_new". All fields are combined with a logical 'AND'. */
export type monthly_pipeline_gql_new_bool_exp = {
  _and?: InputMaybe<Array<monthly_pipeline_gql_new_bool_exp>>;
  _not?: InputMaybe<monthly_pipeline_gql_new_bool_exp>;
  _or?: InputMaybe<Array<monthly_pipeline_gql_new_bool_exp>>;
  amount?: InputMaybe<numeric_comparison_exp>;
  date_trunc?: InputMaybe<timestamp_comparison_exp>;
  lead_source?: InputMaybe<String_comparison_exp>;
  opportunity_id?: InputMaybe<String_comparison_exp>;
  opportunity_name?: InputMaybe<String_comparison_exp>;
  owner_name?: InputMaybe<String_comparison_exp>;
  stagename?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "monthly_pipeline_gql_new". */
export type monthly_pipeline_gql_new_order_by = {
  amount?: InputMaybe<order_by>;
  date_trunc?: InputMaybe<order_by>;
  lead_source?: InputMaybe<order_by>;
  opportunity_id?: InputMaybe<order_by>;
  opportunity_name?: InputMaybe<order_by>;
  owner_name?: InputMaybe<order_by>;
  stagename?: InputMaybe<order_by>;
};

/** select columns of table "monthly_pipeline_gql_new" */
export enum monthly_pipeline_gql_new_select_column {
  /** column name */
  amount = "amount",
  /** column name */
  date_trunc = "date_trunc",
  /** column name */
  lead_source = "lead_source",
  /** column name */
  opportunity_id = "opportunity_id",
  /** column name */
  opportunity_name = "opportunity_name",
  /** column name */
  owner_name = "owner_name",
  /** column name */
  stagename = "stagename",
}

/** Streaming cursor of the table "monthly_pipeline_gql_new" */
export type monthly_pipeline_gql_new_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: monthly_pipeline_gql_new_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type monthly_pipeline_gql_new_stream_cursor_value_input = {
  amount?: InputMaybe<Scalars["numeric"]>;
  date_trunc?: InputMaybe<Scalars["timestamp"]>;
  lead_source?: InputMaybe<Scalars["String"]>;
  opportunity_id?: InputMaybe<Scalars["String"]>;
  opportunity_name?: InputMaybe<Scalars["String"]>;
  owner_name?: InputMaybe<Scalars["String"]>;
  stagename?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type numeric_comparison_exp = {
  _eq?: InputMaybe<Scalars["numeric"]>;
  _gt?: InputMaybe<Scalars["numeric"]>;
  _gte?: InputMaybe<Scalars["numeric"]>;
  _in?: InputMaybe<Array<Scalars["numeric"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["numeric"]>;
  _lte?: InputMaybe<Scalars["numeric"]>;
  _neq?: InputMaybe<Scalars["numeric"]>;
  _nin?: InputMaybe<Array<Scalars["numeric"]>>;
};

/** Boolean expression to filter rows from the table "opp_detail_gql". All fields are combined with a logical 'AND'. */
export type opp_detail_gql_bool_exp = {
  _and?: InputMaybe<Array<opp_detail_gql_bool_exp>>;
  _not?: InputMaybe<opp_detail_gql_bool_exp>;
  _or?: InputMaybe<Array<opp_detail_gql_bool_exp>>;
  account_id?: InputMaybe<String_comparison_exp>;
  account_name?: InputMaybe<String_comparison_exp>;
  amount?: InputMaybe<numeric_comparison_exp>;
  closedate?: InputMaybe<timestamp_comparison_exp>;
  created_by?: InputMaybe<String_comparison_exp>;
  createddate?: InputMaybe<timestamp_comparison_exp>;
  email?: InputMaybe<String_comparison_exp>;
  forecast_category?: InputMaybe<String_comparison_exp>;
  leadsource?: InputMaybe<String_comparison_exp>;
  opportunity_id?: InputMaybe<String_comparison_exp>;
  opportunity_name?: InputMaybe<String_comparison_exp>;
  opportunity_owner?: InputMaybe<String_comparison_exp>;
  ownerid?: InputMaybe<String_comparison_exp>;
  stage?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "opp_detail_gql". */
export type opp_detail_gql_order_by = {
  account_id?: InputMaybe<order_by>;
  account_name?: InputMaybe<order_by>;
  amount?: InputMaybe<order_by>;
  closedate?: InputMaybe<order_by>;
  created_by?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  forecast_category?: InputMaybe<order_by>;
  leadsource?: InputMaybe<order_by>;
  opportunity_id?: InputMaybe<order_by>;
  opportunity_name?: InputMaybe<order_by>;
  opportunity_owner?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  stage?: InputMaybe<order_by>;
};

/** select columns of table "opp_detail_gql" */
export enum opp_detail_gql_select_column {
  /** column name */
  account_id = "account_id",
  /** column name */
  account_name = "account_name",
  /** column name */
  amount = "amount",
  /** column name */
  closedate = "closedate",
  /** column name */
  created_by = "created_by",
  /** column name */
  createddate = "createddate",
  /** column name */
  email = "email",
  /** column name */
  forecast_category = "forecast_category",
  /** column name */
  leadsource = "leadsource",
  /** column name */
  opportunity_id = "opportunity_id",
  /** column name */
  opportunity_name = "opportunity_name",
  /** column name */
  opportunity_owner = "opportunity_owner",
  /** column name */
  ownerid = "ownerid",
  /** column name */
  stage = "stage",
}

/** Streaming cursor of the table "opp_detail_gql" */
export type opp_detail_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: opp_detail_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type opp_detail_gql_stream_cursor_value_input = {
  account_id?: InputMaybe<Scalars["String"]>;
  account_name?: InputMaybe<Scalars["String"]>;
  amount?: InputMaybe<Scalars["numeric"]>;
  closedate?: InputMaybe<Scalars["timestamp"]>;
  created_by?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  email?: InputMaybe<Scalars["String"]>;
  forecast_category?: InputMaybe<Scalars["String"]>;
  leadsource?: InputMaybe<Scalars["String"]>;
  opportunity_id?: InputMaybe<Scalars["String"]>;
  opportunity_name?: InputMaybe<Scalars["String"]>;
  opportunity_owner?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  stage?: InputMaybe<Scalars["String"]>;
};

export type opportunity_aggregate_bool_exp = {
  bool_and?: InputMaybe<opportunity_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<opportunity_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<opportunity_aggregate_bool_exp_count>;
};

export type opportunity_aggregate_bool_exp_bool_and = {
  arguments: opportunity_select_column_opportunity_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<opportunity_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type opportunity_aggregate_bool_exp_bool_or = {
  arguments: opportunity_select_column_opportunity_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<opportunity_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type opportunity_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<opportunity_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<opportunity_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "opportunity" */
export type opportunity_aggregate_order_by = {
  avg?: InputMaybe<opportunity_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<opportunity_max_order_by>;
  min?: InputMaybe<opportunity_min_order_by>;
  stddev?: InputMaybe<opportunity_stddev_order_by>;
  stddev_pop?: InputMaybe<opportunity_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<opportunity_stddev_samp_order_by>;
  sum?: InputMaybe<opportunity_sum_order_by>;
  var_pop?: InputMaybe<opportunity_var_pop_order_by>;
  var_samp?: InputMaybe<opportunity_var_samp_order_by>;
  variance?: InputMaybe<opportunity_variance_order_by>;
};

/** input type for inserting array relation for remote table "opportunity" */
export type opportunity_arr_rel_insert_input = {
  data: Array<opportunity_insert_input>;
};

/** order by avg() on columns of table "opportunity" */
export type opportunity_avg_order_by = {
  amount?: InputMaybe<order_by>;
  fiscalquarter?: InputMaybe<order_by>;
  fiscalyear?: InputMaybe<order_by>;
  probability?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "opportunity". All fields are combined with a logical 'AND'. */
export type opportunity_bool_exp = {
  _and?: InputMaybe<Array<opportunity_bool_exp>>;
  _not?: InputMaybe<opportunity_bool_exp>;
  _or?: InputMaybe<Array<opportunity_bool_exp>>;
  accountid?: InputMaybe<String_comparison_exp>;
  amount?: InputMaybe<numeric_comparison_exp>;
  campaignid?: InputMaybe<String_comparison_exp>;
  closedate?: InputMaybe<timestamp_comparison_exp>;
  contactid?: InputMaybe<String_comparison_exp>;
  contractid?: InputMaybe<String_comparison_exp>;
  createdbyid?: InputMaybe<String_comparison_exp>;
  createddate?: InputMaybe<timestamp_comparison_exp>;
  description?: InputMaybe<String_comparison_exp>;
  fiscal?: InputMaybe<String_comparison_exp>;
  fiscalquarter?: InputMaybe<Int_comparison_exp>;
  fiscalyear?: InputMaybe<Int_comparison_exp>;
  forecastcategory?: InputMaybe<String_comparison_exp>;
  forecastcategoryname?: InputMaybe<String_comparison_exp>;
  hasopenactivity?: InputMaybe<Boolean_comparison_exp>;
  hasopportunitylineitem?: InputMaybe<Boolean_comparison_exp>;
  hasoverduetask?: InputMaybe<Boolean_comparison_exp>;
  id?: InputMaybe<String_comparison_exp>;
  isclosed?: InputMaybe<Boolean_comparison_exp>;
  isdeleted?: InputMaybe<Boolean_comparison_exp>;
  iswon?: InputMaybe<Boolean_comparison_exp>;
  lastactivitydate?: InputMaybe<timestamp_comparison_exp>;
  lastamountchangedhistoryid?: InputMaybe<String_comparison_exp>;
  lastclosedatechangedhistoryid?: InputMaybe<String_comparison_exp>;
  lastmodifiedbyid?: InputMaybe<String_comparison_exp>;
  lastmodifieddate?: InputMaybe<timestamp_comparison_exp>;
  lastreferenceddate?: InputMaybe<timestamp_comparison_exp>;
  laststagechangedate?: InputMaybe<timestamp_comparison_exp>;
  lastvieweddate?: InputMaybe<timestamp_comparison_exp>;
  leadsource?: InputMaybe<String_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  nextstep?: InputMaybe<String_comparison_exp>;
  ownerid?: InputMaybe<String_comparison_exp>;
  pricebook2id?: InputMaybe<String_comparison_exp>;
  probability?: InputMaybe<numeric_comparison_exp>;
  sort_id?: InputMaybe<Int_comparison_exp>;
  stagename?: InputMaybe<String_comparison_exp>;
  syncedquoteid?: InputMaybe<String_comparison_exp>;
  systemmodstamp?: InputMaybe<timestamp_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
};

/** input type for incrementing numeric columns in table "opportunity" */
export type opportunity_inc_input = {
  amount?: InputMaybe<Scalars["numeric"]>;
  fiscalquarter?: InputMaybe<Scalars["Int"]>;
  fiscalyear?: InputMaybe<Scalars["Int"]>;
  probability?: InputMaybe<Scalars["numeric"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
};

/** input type for inserting data into table "opportunity" */
export type opportunity_insert_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  amount?: InputMaybe<Scalars["numeric"]>;
  campaignid?: InputMaybe<Scalars["String"]>;
  closedate?: InputMaybe<Scalars["timestamp"]>;
  contactid?: InputMaybe<Scalars["String"]>;
  contractid?: InputMaybe<Scalars["String"]>;
  createdbyid?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  description?: InputMaybe<Scalars["String"]>;
  fiscal?: InputMaybe<Scalars["String"]>;
  fiscalquarter?: InputMaybe<Scalars["Int"]>;
  fiscalyear?: InputMaybe<Scalars["Int"]>;
  forecastcategory?: InputMaybe<Scalars["String"]>;
  forecastcategoryname?: InputMaybe<Scalars["String"]>;
  hasopenactivity?: InputMaybe<Scalars["Boolean"]>;
  hasopportunitylineitem?: InputMaybe<Scalars["Boolean"]>;
  hasoverduetask?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["String"]>;
  isclosed?: InputMaybe<Scalars["Boolean"]>;
  isdeleted?: InputMaybe<Scalars["Boolean"]>;
  iswon?: InputMaybe<Scalars["Boolean"]>;
  lastactivitydate?: InputMaybe<Scalars["timestamp"]>;
  lastamountchangedhistoryid?: InputMaybe<Scalars["String"]>;
  lastclosedatechangedhistoryid?: InputMaybe<Scalars["String"]>;
  lastmodifiedbyid?: InputMaybe<Scalars["String"]>;
  lastmodifieddate?: InputMaybe<Scalars["timestamp"]>;
  lastreferenceddate?: InputMaybe<Scalars["timestamp"]>;
  laststagechangedate?: InputMaybe<Scalars["timestamp"]>;
  lastvieweddate?: InputMaybe<Scalars["timestamp"]>;
  leadsource?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  nextstep?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  pricebook2id?: InputMaybe<Scalars["String"]>;
  probability?: InputMaybe<Scalars["numeric"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  stagename?: InputMaybe<Scalars["String"]>;
  syncedquoteid?: InputMaybe<Scalars["String"]>;
  systemmodstamp?: InputMaybe<Scalars["timestamp"]>;
  type?: InputMaybe<Scalars["String"]>;
};

/** order by max() on columns of table "opportunity" */
export type opportunity_max_order_by = {
  accountid?: InputMaybe<order_by>;
  amount?: InputMaybe<order_by>;
  campaignid?: InputMaybe<order_by>;
  closedate?: InputMaybe<order_by>;
  contactid?: InputMaybe<order_by>;
  contractid?: InputMaybe<order_by>;
  createdbyid?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  fiscal?: InputMaybe<order_by>;
  fiscalquarter?: InputMaybe<order_by>;
  fiscalyear?: InputMaybe<order_by>;
  forecastcategory?: InputMaybe<order_by>;
  forecastcategoryname?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  lastactivitydate?: InputMaybe<order_by>;
  lastamountchangedhistoryid?: InputMaybe<order_by>;
  lastclosedatechangedhistoryid?: InputMaybe<order_by>;
  lastmodifiedbyid?: InputMaybe<order_by>;
  lastmodifieddate?: InputMaybe<order_by>;
  lastreferenceddate?: InputMaybe<order_by>;
  laststagechangedate?: InputMaybe<order_by>;
  lastvieweddate?: InputMaybe<order_by>;
  leadsource?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  nextstep?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  pricebook2id?: InputMaybe<order_by>;
  probability?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  stagename?: InputMaybe<order_by>;
  syncedquoteid?: InputMaybe<order_by>;
  systemmodstamp?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
};

/** order by min() on columns of table "opportunity" */
export type opportunity_min_order_by = {
  accountid?: InputMaybe<order_by>;
  amount?: InputMaybe<order_by>;
  campaignid?: InputMaybe<order_by>;
  closedate?: InputMaybe<order_by>;
  contactid?: InputMaybe<order_by>;
  contractid?: InputMaybe<order_by>;
  createdbyid?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  fiscal?: InputMaybe<order_by>;
  fiscalquarter?: InputMaybe<order_by>;
  fiscalyear?: InputMaybe<order_by>;
  forecastcategory?: InputMaybe<order_by>;
  forecastcategoryname?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  lastactivitydate?: InputMaybe<order_by>;
  lastamountchangedhistoryid?: InputMaybe<order_by>;
  lastclosedatechangedhistoryid?: InputMaybe<order_by>;
  lastmodifiedbyid?: InputMaybe<order_by>;
  lastmodifieddate?: InputMaybe<order_by>;
  lastreferenceddate?: InputMaybe<order_by>;
  laststagechangedate?: InputMaybe<order_by>;
  lastvieweddate?: InputMaybe<order_by>;
  leadsource?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  nextstep?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  pricebook2id?: InputMaybe<order_by>;
  probability?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  stagename?: InputMaybe<order_by>;
  syncedquoteid?: InputMaybe<order_by>;
  systemmodstamp?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "opportunity". */
export type opportunity_order_by = {
  accountid?: InputMaybe<order_by>;
  amount?: InputMaybe<order_by>;
  campaignid?: InputMaybe<order_by>;
  closedate?: InputMaybe<order_by>;
  contactid?: InputMaybe<order_by>;
  contractid?: InputMaybe<order_by>;
  createdbyid?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  fiscal?: InputMaybe<order_by>;
  fiscalquarter?: InputMaybe<order_by>;
  fiscalyear?: InputMaybe<order_by>;
  forecastcategory?: InputMaybe<order_by>;
  forecastcategoryname?: InputMaybe<order_by>;
  hasopenactivity?: InputMaybe<order_by>;
  hasopportunitylineitem?: InputMaybe<order_by>;
  hasoverduetask?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  isclosed?: InputMaybe<order_by>;
  isdeleted?: InputMaybe<order_by>;
  iswon?: InputMaybe<order_by>;
  lastactivitydate?: InputMaybe<order_by>;
  lastamountchangedhistoryid?: InputMaybe<order_by>;
  lastclosedatechangedhistoryid?: InputMaybe<order_by>;
  lastmodifiedbyid?: InputMaybe<order_by>;
  lastmodifieddate?: InputMaybe<order_by>;
  lastreferenceddate?: InputMaybe<order_by>;
  laststagechangedate?: InputMaybe<order_by>;
  lastvieweddate?: InputMaybe<order_by>;
  leadsource?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  nextstep?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  pricebook2id?: InputMaybe<order_by>;
  probability?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  stagename?: InputMaybe<order_by>;
  syncedquoteid?: InputMaybe<order_by>;
  systemmodstamp?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
};

/** select columns of table "opportunity" */
export enum opportunity_select_column {
  /** column name */
  accountid = "accountid",
  /** column name */
  amount = "amount",
  /** column name */
  campaignid = "campaignid",
  /** column name */
  closedate = "closedate",
  /** column name */
  contactid = "contactid",
  /** column name */
  contractid = "contractid",
  /** column name */
  createdbyid = "createdbyid",
  /** column name */
  createddate = "createddate",
  /** column name */
  description = "description",
  /** column name */
  fiscal = "fiscal",
  /** column name */
  fiscalquarter = "fiscalquarter",
  /** column name */
  fiscalyear = "fiscalyear",
  /** column name */
  forecastcategory = "forecastcategory",
  /** column name */
  forecastcategoryname = "forecastcategoryname",
  /** column name */
  hasopenactivity = "hasopenactivity",
  /** column name */
  hasopportunitylineitem = "hasopportunitylineitem",
  /** column name */
  hasoverduetask = "hasoverduetask",
  /** column name */
  id = "id",
  /** column name */
  isclosed = "isclosed",
  /** column name */
  isdeleted = "isdeleted",
  /** column name */
  iswon = "iswon",
  /** column name */
  lastactivitydate = "lastactivitydate",
  /** column name */
  lastamountchangedhistoryid = "lastamountchangedhistoryid",
  /** column name */
  lastclosedatechangedhistoryid = "lastclosedatechangedhistoryid",
  /** column name */
  lastmodifiedbyid = "lastmodifiedbyid",
  /** column name */
  lastmodifieddate = "lastmodifieddate",
  /** column name */
  lastreferenceddate = "lastreferenceddate",
  /** column name */
  laststagechangedate = "laststagechangedate",
  /** column name */
  lastvieweddate = "lastvieweddate",
  /** column name */
  leadsource = "leadsource",
  /** column name */
  name = "name",
  /** column name */
  nextstep = "nextstep",
  /** column name */
  ownerid = "ownerid",
  /** column name */
  pricebook2id = "pricebook2id",
  /** column name */
  probability = "probability",
  /** column name */
  sort_id = "sort_id",
  /** column name */
  stagename = "stagename",
  /** column name */
  syncedquoteid = "syncedquoteid",
  /** column name */
  systemmodstamp = "systemmodstamp",
  /** column name */
  type = "type",
}

/** select "opportunity_aggregate_bool_exp_bool_and_arguments_columns" columns of table "opportunity" */
export enum opportunity_select_column_opportunity_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  hasopenactivity = "hasopenactivity",
  /** column name */
  hasopportunitylineitem = "hasopportunitylineitem",
  /** column name */
  hasoverduetask = "hasoverduetask",
  /** column name */
  isclosed = "isclosed",
  /** column name */
  isdeleted = "isdeleted",
  /** column name */
  iswon = "iswon",
}

/** select "opportunity_aggregate_bool_exp_bool_or_arguments_columns" columns of table "opportunity" */
export enum opportunity_select_column_opportunity_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  hasopenactivity = "hasopenactivity",
  /** column name */
  hasopportunitylineitem = "hasopportunitylineitem",
  /** column name */
  hasoverduetask = "hasoverduetask",
  /** column name */
  isclosed = "isclosed",
  /** column name */
  isdeleted = "isdeleted",
  /** column name */
  iswon = "iswon",
}

/** input type for updating data in table "opportunity" */
export type opportunity_set_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  amount?: InputMaybe<Scalars["numeric"]>;
  campaignid?: InputMaybe<Scalars["String"]>;
  closedate?: InputMaybe<Scalars["timestamp"]>;
  contactid?: InputMaybe<Scalars["String"]>;
  contractid?: InputMaybe<Scalars["String"]>;
  createdbyid?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  description?: InputMaybe<Scalars["String"]>;
  fiscal?: InputMaybe<Scalars["String"]>;
  fiscalquarter?: InputMaybe<Scalars["Int"]>;
  fiscalyear?: InputMaybe<Scalars["Int"]>;
  forecastcategory?: InputMaybe<Scalars["String"]>;
  forecastcategoryname?: InputMaybe<Scalars["String"]>;
  hasopenactivity?: InputMaybe<Scalars["Boolean"]>;
  hasopportunitylineitem?: InputMaybe<Scalars["Boolean"]>;
  hasoverduetask?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["String"]>;
  isclosed?: InputMaybe<Scalars["Boolean"]>;
  isdeleted?: InputMaybe<Scalars["Boolean"]>;
  iswon?: InputMaybe<Scalars["Boolean"]>;
  lastactivitydate?: InputMaybe<Scalars["timestamp"]>;
  lastamountchangedhistoryid?: InputMaybe<Scalars["String"]>;
  lastclosedatechangedhistoryid?: InputMaybe<Scalars["String"]>;
  lastmodifiedbyid?: InputMaybe<Scalars["String"]>;
  lastmodifieddate?: InputMaybe<Scalars["timestamp"]>;
  lastreferenceddate?: InputMaybe<Scalars["timestamp"]>;
  laststagechangedate?: InputMaybe<Scalars["timestamp"]>;
  lastvieweddate?: InputMaybe<Scalars["timestamp"]>;
  leadsource?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  nextstep?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  pricebook2id?: InputMaybe<Scalars["String"]>;
  probability?: InputMaybe<Scalars["numeric"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  stagename?: InputMaybe<Scalars["String"]>;
  syncedquoteid?: InputMaybe<Scalars["String"]>;
  systemmodstamp?: InputMaybe<Scalars["timestamp"]>;
  type?: InputMaybe<Scalars["String"]>;
};

/** order by stddev() on columns of table "opportunity" */
export type opportunity_stddev_order_by = {
  amount?: InputMaybe<order_by>;
  fiscalquarter?: InputMaybe<order_by>;
  fiscalyear?: InputMaybe<order_by>;
  probability?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "opportunity" */
export type opportunity_stddev_pop_order_by = {
  amount?: InputMaybe<order_by>;
  fiscalquarter?: InputMaybe<order_by>;
  fiscalyear?: InputMaybe<order_by>;
  probability?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "opportunity" */
export type opportunity_stddev_samp_order_by = {
  amount?: InputMaybe<order_by>;
  fiscalquarter?: InputMaybe<order_by>;
  fiscalyear?: InputMaybe<order_by>;
  probability?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "opportunity" */
export type opportunity_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: opportunity_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type opportunity_stream_cursor_value_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  amount?: InputMaybe<Scalars["numeric"]>;
  campaignid?: InputMaybe<Scalars["String"]>;
  closedate?: InputMaybe<Scalars["timestamp"]>;
  contactid?: InputMaybe<Scalars["String"]>;
  contractid?: InputMaybe<Scalars["String"]>;
  createdbyid?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  description?: InputMaybe<Scalars["String"]>;
  fiscal?: InputMaybe<Scalars["String"]>;
  fiscalquarter?: InputMaybe<Scalars["Int"]>;
  fiscalyear?: InputMaybe<Scalars["Int"]>;
  forecastcategory?: InputMaybe<Scalars["String"]>;
  forecastcategoryname?: InputMaybe<Scalars["String"]>;
  hasopenactivity?: InputMaybe<Scalars["Boolean"]>;
  hasopportunitylineitem?: InputMaybe<Scalars["Boolean"]>;
  hasoverduetask?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["String"]>;
  isclosed?: InputMaybe<Scalars["Boolean"]>;
  isdeleted?: InputMaybe<Scalars["Boolean"]>;
  iswon?: InputMaybe<Scalars["Boolean"]>;
  lastactivitydate?: InputMaybe<Scalars["timestamp"]>;
  lastamountchangedhistoryid?: InputMaybe<Scalars["String"]>;
  lastclosedatechangedhistoryid?: InputMaybe<Scalars["String"]>;
  lastmodifiedbyid?: InputMaybe<Scalars["String"]>;
  lastmodifieddate?: InputMaybe<Scalars["timestamp"]>;
  lastreferenceddate?: InputMaybe<Scalars["timestamp"]>;
  laststagechangedate?: InputMaybe<Scalars["timestamp"]>;
  lastvieweddate?: InputMaybe<Scalars["timestamp"]>;
  leadsource?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  nextstep?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  pricebook2id?: InputMaybe<Scalars["String"]>;
  probability?: InputMaybe<Scalars["numeric"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  stagename?: InputMaybe<Scalars["String"]>;
  syncedquoteid?: InputMaybe<Scalars["String"]>;
  systemmodstamp?: InputMaybe<Scalars["timestamp"]>;
  type?: InputMaybe<Scalars["String"]>;
};

/** order by sum() on columns of table "opportunity" */
export type opportunity_sum_order_by = {
  amount?: InputMaybe<order_by>;
  fiscalquarter?: InputMaybe<order_by>;
  fiscalyear?: InputMaybe<order_by>;
  probability?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
};

export type opportunity_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<opportunity_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<opportunity_set_input>;
  where: opportunity_bool_exp;
};

/** order by var_pop() on columns of table "opportunity" */
export type opportunity_var_pop_order_by = {
  amount?: InputMaybe<order_by>;
  fiscalquarter?: InputMaybe<order_by>;
  fiscalyear?: InputMaybe<order_by>;
  probability?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "opportunity" */
export type opportunity_var_samp_order_by = {
  amount?: InputMaybe<order_by>;
  fiscalquarter?: InputMaybe<order_by>;
  fiscalyear?: InputMaybe<order_by>;
  probability?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "opportunity" */
export type opportunity_variance_order_by = {
  amount?: InputMaybe<order_by>;
  fiscalquarter?: InputMaybe<order_by>;
  fiscalyear?: InputMaybe<order_by>;
  probability?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
};

/** column ordering options */
export enum order_by {
  /** in ascending order, nulls last */
  asc = "asc",
  /** in ascending order, nulls first */
  asc_nulls_first = "asc_nulls_first",
  /** in ascending order, nulls last */
  asc_nulls_last = "asc_nulls_last",
  /** in descending order, nulls first */
  desc = "desc",
  /** in descending order, nulls first */
  desc_nulls_first = "desc_nulls_first",
  /** in descending order, nulls last */
  desc_nulls_last = "desc_nulls_last",
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type pdl_people_data_append_input = {
  countries?: InputMaybe<Scalars["jsonb"]>;
  education?: InputMaybe<Scalars["jsonb"]>;
  emails?: InputMaybe<Scalars["jsonb"]>;
  experience?: InputMaybe<Scalars["jsonb"]>;
  interests?: InputMaybe<Scalars["jsonb"]>;
  job_title_levels?: InputMaybe<Scalars["jsonb"]>;
  location_names?: InputMaybe<Scalars["jsonb"]>;
  personal_emails?: InputMaybe<Scalars["jsonb"]>;
  phone_numbers?: InputMaybe<Scalars["jsonb"]>;
  profiles?: InputMaybe<Scalars["jsonb"]>;
  regions?: InputMaybe<Scalars["jsonb"]>;
  skills?: InputMaybe<Scalars["jsonb"]>;
  street_addresses?: InputMaybe<Scalars["jsonb"]>;
  version_status?: InputMaybe<Scalars["jsonb"]>;
};

/** Boolean expression to filter rows from the table "pdl_people_data". All fields are combined with a logical 'AND'. */
export type pdl_people_data_bool_exp = {
  _and?: InputMaybe<Array<pdl_people_data_bool_exp>>;
  _not?: InputMaybe<pdl_people_data_bool_exp>;
  _or?: InputMaybe<Array<pdl_people_data_bool_exp>>;
  birth_date?: InputMaybe<String_comparison_exp>;
  birth_year?: InputMaybe<Int_comparison_exp>;
  countries?: InputMaybe<jsonb_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  crm_account_id?: InputMaybe<String_comparison_exp>;
  education?: InputMaybe<jsonb_comparison_exp>;
  emails?: InputMaybe<jsonb_comparison_exp>;
  experience?: InputMaybe<jsonb_comparison_exp>;
  facebook_id?: InputMaybe<numeric_comparison_exp>;
  facebook_url?: InputMaybe<String_comparison_exp>;
  facebook_username?: InputMaybe<String_comparison_exp>;
  first_name?: InputMaybe<String_comparison_exp>;
  full_name?: InputMaybe<String_comparison_exp>;
  gender?: InputMaybe<String_comparison_exp>;
  github_url?: InputMaybe<String_comparison_exp>;
  github_username?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<String_comparison_exp>;
  industry?: InputMaybe<String_comparison_exp>;
  interests?: InputMaybe<jsonb_comparison_exp>;
  job_company_facebook_url?: InputMaybe<String_comparison_exp>;
  job_company_founded?: InputMaybe<Int_comparison_exp>;
  job_company_id?: InputMaybe<String_comparison_exp>;
  job_company_industry?: InputMaybe<String_comparison_exp>;
  job_company_linkedin_id?: InputMaybe<Int_comparison_exp>;
  job_company_linkedin_url?: InputMaybe<String_comparison_exp>;
  job_company_location_address_line_2?: InputMaybe<String_comparison_exp>;
  job_company_location_continent?: InputMaybe<String_comparison_exp>;
  job_company_location_country?: InputMaybe<String_comparison_exp>;
  job_company_location_geo?: InputMaybe<String_comparison_exp>;
  job_company_location_locality?: InputMaybe<String_comparison_exp>;
  job_company_location_metro?: InputMaybe<String_comparison_exp>;
  job_company_location_name?: InputMaybe<String_comparison_exp>;
  job_company_location_postal_code?: InputMaybe<String_comparison_exp>;
  job_company_location_region?: InputMaybe<String_comparison_exp>;
  job_company_location_street_address?: InputMaybe<String_comparison_exp>;
  job_company_name?: InputMaybe<String_comparison_exp>;
  job_company_size?: InputMaybe<String_comparison_exp>;
  job_company_twitter_url?: InputMaybe<String_comparison_exp>;
  job_company_website?: InputMaybe<String_comparison_exp>;
  job_last_updated?: InputMaybe<String_comparison_exp>;
  job_start_date?: InputMaybe<String_comparison_exp>;
  job_title?: InputMaybe<String_comparison_exp>;
  job_title_levels?: InputMaybe<jsonb_comparison_exp>;
  job_title_role?: InputMaybe<String_comparison_exp>;
  job_title_sub_role?: InputMaybe<String_comparison_exp>;
  last_initial?: InputMaybe<String_comparison_exp>;
  last_name?: InputMaybe<String_comparison_exp>;
  linkedin_id?: InputMaybe<Int_comparison_exp>;
  linkedin_url?: InputMaybe<String_comparison_exp>;
  linkedin_username?: InputMaybe<String_comparison_exp>;
  location_address_line_2?: InputMaybe<String_comparison_exp>;
  location_continent?: InputMaybe<String_comparison_exp>;
  location_country?: InputMaybe<String_comparison_exp>;
  location_geo?: InputMaybe<String_comparison_exp>;
  location_last_updated?: InputMaybe<String_comparison_exp>;
  location_locality?: InputMaybe<String_comparison_exp>;
  location_metro?: InputMaybe<String_comparison_exp>;
  location_name?: InputMaybe<String_comparison_exp>;
  location_names?: InputMaybe<jsonb_comparison_exp>;
  location_postal_code?: InputMaybe<String_comparison_exp>;
  location_region?: InputMaybe<String_comparison_exp>;
  location_street_address?: InputMaybe<String_comparison_exp>;
  middle_initial?: InputMaybe<String_comparison_exp>;
  middle_name?: InputMaybe<String_comparison_exp>;
  mobile_phone?: InputMaybe<String_comparison_exp>;
  personal_emails?: InputMaybe<jsonb_comparison_exp>;
  phone_numbers?: InputMaybe<jsonb_comparison_exp>;
  profiles?: InputMaybe<jsonb_comparison_exp>;
  recommended_personal_email?: InputMaybe<String_comparison_exp>;
  regions?: InputMaybe<jsonb_comparison_exp>;
  revtron_user_id?: InputMaybe<uuid_comparison_exp>;
  skills?: InputMaybe<jsonb_comparison_exp>;
  street_addresses?: InputMaybe<jsonb_comparison_exp>;
  twitter_url?: InputMaybe<String_comparison_exp>;
  twitter_username?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  version_status?: InputMaybe<jsonb_comparison_exp>;
  work_email?: InputMaybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "pdl_people_data" */
export enum pdl_people_data_constraint {
  /** unique or primary key constraint on columns "id" */
  pdl_people_data_pkey = "pdl_people_data_pkey",
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type pdl_people_data_delete_at_path_input = {
  countries?: InputMaybe<Array<Scalars["String"]>>;
  education?: InputMaybe<Array<Scalars["String"]>>;
  emails?: InputMaybe<Array<Scalars["String"]>>;
  experience?: InputMaybe<Array<Scalars["String"]>>;
  interests?: InputMaybe<Array<Scalars["String"]>>;
  job_title_levels?: InputMaybe<Array<Scalars["String"]>>;
  location_names?: InputMaybe<Array<Scalars["String"]>>;
  personal_emails?: InputMaybe<Array<Scalars["String"]>>;
  phone_numbers?: InputMaybe<Array<Scalars["String"]>>;
  profiles?: InputMaybe<Array<Scalars["String"]>>;
  regions?: InputMaybe<Array<Scalars["String"]>>;
  skills?: InputMaybe<Array<Scalars["String"]>>;
  street_addresses?: InputMaybe<Array<Scalars["String"]>>;
  version_status?: InputMaybe<Array<Scalars["String"]>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type pdl_people_data_delete_elem_input = {
  countries?: InputMaybe<Scalars["Int"]>;
  education?: InputMaybe<Scalars["Int"]>;
  emails?: InputMaybe<Scalars["Int"]>;
  experience?: InputMaybe<Scalars["Int"]>;
  interests?: InputMaybe<Scalars["Int"]>;
  job_title_levels?: InputMaybe<Scalars["Int"]>;
  location_names?: InputMaybe<Scalars["Int"]>;
  personal_emails?: InputMaybe<Scalars["Int"]>;
  phone_numbers?: InputMaybe<Scalars["Int"]>;
  profiles?: InputMaybe<Scalars["Int"]>;
  regions?: InputMaybe<Scalars["Int"]>;
  skills?: InputMaybe<Scalars["Int"]>;
  street_addresses?: InputMaybe<Scalars["Int"]>;
  version_status?: InputMaybe<Scalars["Int"]>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type pdl_people_data_delete_key_input = {
  countries?: InputMaybe<Scalars["String"]>;
  education?: InputMaybe<Scalars["String"]>;
  emails?: InputMaybe<Scalars["String"]>;
  experience?: InputMaybe<Scalars["String"]>;
  interests?: InputMaybe<Scalars["String"]>;
  job_title_levels?: InputMaybe<Scalars["String"]>;
  location_names?: InputMaybe<Scalars["String"]>;
  personal_emails?: InputMaybe<Scalars["String"]>;
  phone_numbers?: InputMaybe<Scalars["String"]>;
  profiles?: InputMaybe<Scalars["String"]>;
  regions?: InputMaybe<Scalars["String"]>;
  skills?: InputMaybe<Scalars["String"]>;
  street_addresses?: InputMaybe<Scalars["String"]>;
  version_status?: InputMaybe<Scalars["String"]>;
};

/** input type for incrementing numeric columns in table "pdl_people_data" */
export type pdl_people_data_inc_input = {
  birth_year?: InputMaybe<Scalars["Int"]>;
  facebook_id?: InputMaybe<Scalars["numeric"]>;
  job_company_founded?: InputMaybe<Scalars["Int"]>;
  job_company_linkedin_id?: InputMaybe<Scalars["Int"]>;
  linkedin_id?: InputMaybe<Scalars["Int"]>;
};

/** input type for inserting data into table "pdl_people_data" */
export type pdl_people_data_insert_input = {
  birth_date?: InputMaybe<Scalars["String"]>;
  birth_year?: InputMaybe<Scalars["Int"]>;
  countries?: InputMaybe<Scalars["jsonb"]>;
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  crm_account_id?: InputMaybe<Scalars["String"]>;
  education?: InputMaybe<Scalars["jsonb"]>;
  emails?: InputMaybe<Scalars["jsonb"]>;
  experience?: InputMaybe<Scalars["jsonb"]>;
  facebook_id?: InputMaybe<Scalars["numeric"]>;
  facebook_url?: InputMaybe<Scalars["String"]>;
  facebook_username?: InputMaybe<Scalars["String"]>;
  first_name?: InputMaybe<Scalars["String"]>;
  full_name?: InputMaybe<Scalars["String"]>;
  gender?: InputMaybe<Scalars["String"]>;
  github_url?: InputMaybe<Scalars["String"]>;
  github_username?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  industry?: InputMaybe<Scalars["String"]>;
  interests?: InputMaybe<Scalars["jsonb"]>;
  job_company_facebook_url?: InputMaybe<Scalars["String"]>;
  job_company_founded?: InputMaybe<Scalars["Int"]>;
  job_company_id?: InputMaybe<Scalars["String"]>;
  job_company_industry?: InputMaybe<Scalars["String"]>;
  job_company_linkedin_id?: InputMaybe<Scalars["Int"]>;
  job_company_linkedin_url?: InputMaybe<Scalars["String"]>;
  job_company_location_address_line_2?: InputMaybe<Scalars["String"]>;
  job_company_location_continent?: InputMaybe<Scalars["String"]>;
  job_company_location_country?: InputMaybe<Scalars["String"]>;
  job_company_location_geo?: InputMaybe<Scalars["String"]>;
  job_company_location_locality?: InputMaybe<Scalars["String"]>;
  job_company_location_metro?: InputMaybe<Scalars["String"]>;
  job_company_location_name?: InputMaybe<Scalars["String"]>;
  job_company_location_postal_code?: InputMaybe<Scalars["String"]>;
  job_company_location_region?: InputMaybe<Scalars["String"]>;
  job_company_location_street_address?: InputMaybe<Scalars["String"]>;
  job_company_name?: InputMaybe<Scalars["String"]>;
  job_company_size?: InputMaybe<Scalars["String"]>;
  job_company_twitter_url?: InputMaybe<Scalars["String"]>;
  job_company_website?: InputMaybe<Scalars["String"]>;
  job_last_updated?: InputMaybe<Scalars["String"]>;
  job_start_date?: InputMaybe<Scalars["String"]>;
  job_title?: InputMaybe<Scalars["String"]>;
  job_title_levels?: InputMaybe<Scalars["jsonb"]>;
  job_title_role?: InputMaybe<Scalars["String"]>;
  job_title_sub_role?: InputMaybe<Scalars["String"]>;
  last_initial?: InputMaybe<Scalars["String"]>;
  last_name?: InputMaybe<Scalars["String"]>;
  linkedin_id?: InputMaybe<Scalars["Int"]>;
  linkedin_url?: InputMaybe<Scalars["String"]>;
  linkedin_username?: InputMaybe<Scalars["String"]>;
  location_address_line_2?: InputMaybe<Scalars["String"]>;
  location_continent?: InputMaybe<Scalars["String"]>;
  location_country?: InputMaybe<Scalars["String"]>;
  location_geo?: InputMaybe<Scalars["String"]>;
  location_last_updated?: InputMaybe<Scalars["String"]>;
  location_locality?: InputMaybe<Scalars["String"]>;
  location_metro?: InputMaybe<Scalars["String"]>;
  location_name?: InputMaybe<Scalars["String"]>;
  location_names?: InputMaybe<Scalars["jsonb"]>;
  location_postal_code?: InputMaybe<Scalars["String"]>;
  location_region?: InputMaybe<Scalars["String"]>;
  location_street_address?: InputMaybe<Scalars["String"]>;
  middle_initial?: InputMaybe<Scalars["String"]>;
  middle_name?: InputMaybe<Scalars["String"]>;
  mobile_phone?: InputMaybe<Scalars["String"]>;
  personal_emails?: InputMaybe<Scalars["jsonb"]>;
  phone_numbers?: InputMaybe<Scalars["jsonb"]>;
  profiles?: InputMaybe<Scalars["jsonb"]>;
  recommended_personal_email?: InputMaybe<Scalars["String"]>;
  regions?: InputMaybe<Scalars["jsonb"]>;
  revtron_user_id?: InputMaybe<Scalars["uuid"]>;
  skills?: InputMaybe<Scalars["jsonb"]>;
  street_addresses?: InputMaybe<Scalars["jsonb"]>;
  twitter_url?: InputMaybe<Scalars["String"]>;
  twitter_username?: InputMaybe<Scalars["String"]>;
  updated_at?: InputMaybe<Scalars["timestamptz"]>;
  version_status?: InputMaybe<Scalars["jsonb"]>;
  work_email?: InputMaybe<Scalars["String"]>;
};

/** on_conflict condition type for table "pdl_people_data" */
export type pdl_people_data_on_conflict = {
  constraint: pdl_people_data_constraint;
  update_columns?: Array<pdl_people_data_update_column>;
  where?: InputMaybe<pdl_people_data_bool_exp>;
};

/** Ordering options when selecting data from "pdl_people_data". */
export type pdl_people_data_order_by = {
  birth_date?: InputMaybe<order_by>;
  birth_year?: InputMaybe<order_by>;
  countries?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  crm_account_id?: InputMaybe<order_by>;
  education?: InputMaybe<order_by>;
  emails?: InputMaybe<order_by>;
  experience?: InputMaybe<order_by>;
  facebook_id?: InputMaybe<order_by>;
  facebook_url?: InputMaybe<order_by>;
  facebook_username?: InputMaybe<order_by>;
  first_name?: InputMaybe<order_by>;
  full_name?: InputMaybe<order_by>;
  gender?: InputMaybe<order_by>;
  github_url?: InputMaybe<order_by>;
  github_username?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  industry?: InputMaybe<order_by>;
  interests?: InputMaybe<order_by>;
  job_company_facebook_url?: InputMaybe<order_by>;
  job_company_founded?: InputMaybe<order_by>;
  job_company_id?: InputMaybe<order_by>;
  job_company_industry?: InputMaybe<order_by>;
  job_company_linkedin_id?: InputMaybe<order_by>;
  job_company_linkedin_url?: InputMaybe<order_by>;
  job_company_location_address_line_2?: InputMaybe<order_by>;
  job_company_location_continent?: InputMaybe<order_by>;
  job_company_location_country?: InputMaybe<order_by>;
  job_company_location_geo?: InputMaybe<order_by>;
  job_company_location_locality?: InputMaybe<order_by>;
  job_company_location_metro?: InputMaybe<order_by>;
  job_company_location_name?: InputMaybe<order_by>;
  job_company_location_postal_code?: InputMaybe<order_by>;
  job_company_location_region?: InputMaybe<order_by>;
  job_company_location_street_address?: InputMaybe<order_by>;
  job_company_name?: InputMaybe<order_by>;
  job_company_size?: InputMaybe<order_by>;
  job_company_twitter_url?: InputMaybe<order_by>;
  job_company_website?: InputMaybe<order_by>;
  job_last_updated?: InputMaybe<order_by>;
  job_start_date?: InputMaybe<order_by>;
  job_title?: InputMaybe<order_by>;
  job_title_levels?: InputMaybe<order_by>;
  job_title_role?: InputMaybe<order_by>;
  job_title_sub_role?: InputMaybe<order_by>;
  last_initial?: InputMaybe<order_by>;
  last_name?: InputMaybe<order_by>;
  linkedin_id?: InputMaybe<order_by>;
  linkedin_url?: InputMaybe<order_by>;
  linkedin_username?: InputMaybe<order_by>;
  location_address_line_2?: InputMaybe<order_by>;
  location_continent?: InputMaybe<order_by>;
  location_country?: InputMaybe<order_by>;
  location_geo?: InputMaybe<order_by>;
  location_last_updated?: InputMaybe<order_by>;
  location_locality?: InputMaybe<order_by>;
  location_metro?: InputMaybe<order_by>;
  location_name?: InputMaybe<order_by>;
  location_names?: InputMaybe<order_by>;
  location_postal_code?: InputMaybe<order_by>;
  location_region?: InputMaybe<order_by>;
  location_street_address?: InputMaybe<order_by>;
  middle_initial?: InputMaybe<order_by>;
  middle_name?: InputMaybe<order_by>;
  mobile_phone?: InputMaybe<order_by>;
  personal_emails?: InputMaybe<order_by>;
  phone_numbers?: InputMaybe<order_by>;
  profiles?: InputMaybe<order_by>;
  recommended_personal_email?: InputMaybe<order_by>;
  regions?: InputMaybe<order_by>;
  revtron_user_id?: InputMaybe<order_by>;
  skills?: InputMaybe<order_by>;
  street_addresses?: InputMaybe<order_by>;
  twitter_url?: InputMaybe<order_by>;
  twitter_username?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  version_status?: InputMaybe<order_by>;
  work_email?: InputMaybe<order_by>;
};

/** primary key columns input for table: pdl_people_data */
export type pdl_people_data_pk_columns_input = {
  id: Scalars["String"];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type pdl_people_data_prepend_input = {
  countries?: InputMaybe<Scalars["jsonb"]>;
  education?: InputMaybe<Scalars["jsonb"]>;
  emails?: InputMaybe<Scalars["jsonb"]>;
  experience?: InputMaybe<Scalars["jsonb"]>;
  interests?: InputMaybe<Scalars["jsonb"]>;
  job_title_levels?: InputMaybe<Scalars["jsonb"]>;
  location_names?: InputMaybe<Scalars["jsonb"]>;
  personal_emails?: InputMaybe<Scalars["jsonb"]>;
  phone_numbers?: InputMaybe<Scalars["jsonb"]>;
  profiles?: InputMaybe<Scalars["jsonb"]>;
  regions?: InputMaybe<Scalars["jsonb"]>;
  skills?: InputMaybe<Scalars["jsonb"]>;
  street_addresses?: InputMaybe<Scalars["jsonb"]>;
  version_status?: InputMaybe<Scalars["jsonb"]>;
};

/** select columns of table "pdl_people_data" */
export enum pdl_people_data_select_column {
  /** column name */
  birth_date = "birth_date",
  /** column name */
  birth_year = "birth_year",
  /** column name */
  countries = "countries",
  /** column name */
  created_at = "created_at",
  /** column name */
  crm_account_id = "crm_account_id",
  /** column name */
  education = "education",
  /** column name */
  emails = "emails",
  /** column name */
  experience = "experience",
  /** column name */
  facebook_id = "facebook_id",
  /** column name */
  facebook_url = "facebook_url",
  /** column name */
  facebook_username = "facebook_username",
  /** column name */
  first_name = "first_name",
  /** column name */
  full_name = "full_name",
  /** column name */
  gender = "gender",
  /** column name */
  github_url = "github_url",
  /** column name */
  github_username = "github_username",
  /** column name */
  id = "id",
  /** column name */
  industry = "industry",
  /** column name */
  interests = "interests",
  /** column name */
  job_company_facebook_url = "job_company_facebook_url",
  /** column name */
  job_company_founded = "job_company_founded",
  /** column name */
  job_company_id = "job_company_id",
  /** column name */
  job_company_industry = "job_company_industry",
  /** column name */
  job_company_linkedin_id = "job_company_linkedin_id",
  /** column name */
  job_company_linkedin_url = "job_company_linkedin_url",
  /** column name */
  job_company_location_address_line_2 = "job_company_location_address_line_2",
  /** column name */
  job_company_location_continent = "job_company_location_continent",
  /** column name */
  job_company_location_country = "job_company_location_country",
  /** column name */
  job_company_location_geo = "job_company_location_geo",
  /** column name */
  job_company_location_locality = "job_company_location_locality",
  /** column name */
  job_company_location_metro = "job_company_location_metro",
  /** column name */
  job_company_location_name = "job_company_location_name",
  /** column name */
  job_company_location_postal_code = "job_company_location_postal_code",
  /** column name */
  job_company_location_region = "job_company_location_region",
  /** column name */
  job_company_location_street_address = "job_company_location_street_address",
  /** column name */
  job_company_name = "job_company_name",
  /** column name */
  job_company_size = "job_company_size",
  /** column name */
  job_company_twitter_url = "job_company_twitter_url",
  /** column name */
  job_company_website = "job_company_website",
  /** column name */
  job_last_updated = "job_last_updated",
  /** column name */
  job_start_date = "job_start_date",
  /** column name */
  job_title = "job_title",
  /** column name */
  job_title_levels = "job_title_levels",
  /** column name */
  job_title_role = "job_title_role",
  /** column name */
  job_title_sub_role = "job_title_sub_role",
  /** column name */
  last_initial = "last_initial",
  /** column name */
  last_name = "last_name",
  /** column name */
  linkedin_id = "linkedin_id",
  /** column name */
  linkedin_url = "linkedin_url",
  /** column name */
  linkedin_username = "linkedin_username",
  /** column name */
  location_address_line_2 = "location_address_line_2",
  /** column name */
  location_continent = "location_continent",
  /** column name */
  location_country = "location_country",
  /** column name */
  location_geo = "location_geo",
  /** column name */
  location_last_updated = "location_last_updated",
  /** column name */
  location_locality = "location_locality",
  /** column name */
  location_metro = "location_metro",
  /** column name */
  location_name = "location_name",
  /** column name */
  location_names = "location_names",
  /** column name */
  location_postal_code = "location_postal_code",
  /** column name */
  location_region = "location_region",
  /** column name */
  location_street_address = "location_street_address",
  /** column name */
  middle_initial = "middle_initial",
  /** column name */
  middle_name = "middle_name",
  /** column name */
  mobile_phone = "mobile_phone",
  /** column name */
  personal_emails = "personal_emails",
  /** column name */
  phone_numbers = "phone_numbers",
  /** column name */
  profiles = "profiles",
  /** column name */
  recommended_personal_email = "recommended_personal_email",
  /** column name */
  regions = "regions",
  /** column name */
  revtron_user_id = "revtron_user_id",
  /** column name */
  skills = "skills",
  /** column name */
  street_addresses = "street_addresses",
  /** column name */
  twitter_url = "twitter_url",
  /** column name */
  twitter_username = "twitter_username",
  /** column name */
  updated_at = "updated_at",
  /** column name */
  version_status = "version_status",
  /** column name */
  work_email = "work_email",
}

/** input type for updating data in table "pdl_people_data" */
export type pdl_people_data_set_input = {
  birth_date?: InputMaybe<Scalars["String"]>;
  birth_year?: InputMaybe<Scalars["Int"]>;
  countries?: InputMaybe<Scalars["jsonb"]>;
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  crm_account_id?: InputMaybe<Scalars["String"]>;
  education?: InputMaybe<Scalars["jsonb"]>;
  emails?: InputMaybe<Scalars["jsonb"]>;
  experience?: InputMaybe<Scalars["jsonb"]>;
  facebook_id?: InputMaybe<Scalars["numeric"]>;
  facebook_url?: InputMaybe<Scalars["String"]>;
  facebook_username?: InputMaybe<Scalars["String"]>;
  first_name?: InputMaybe<Scalars["String"]>;
  full_name?: InputMaybe<Scalars["String"]>;
  gender?: InputMaybe<Scalars["String"]>;
  github_url?: InputMaybe<Scalars["String"]>;
  github_username?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  industry?: InputMaybe<Scalars["String"]>;
  interests?: InputMaybe<Scalars["jsonb"]>;
  job_company_facebook_url?: InputMaybe<Scalars["String"]>;
  job_company_founded?: InputMaybe<Scalars["Int"]>;
  job_company_id?: InputMaybe<Scalars["String"]>;
  job_company_industry?: InputMaybe<Scalars["String"]>;
  job_company_linkedin_id?: InputMaybe<Scalars["Int"]>;
  job_company_linkedin_url?: InputMaybe<Scalars["String"]>;
  job_company_location_address_line_2?: InputMaybe<Scalars["String"]>;
  job_company_location_continent?: InputMaybe<Scalars["String"]>;
  job_company_location_country?: InputMaybe<Scalars["String"]>;
  job_company_location_geo?: InputMaybe<Scalars["String"]>;
  job_company_location_locality?: InputMaybe<Scalars["String"]>;
  job_company_location_metro?: InputMaybe<Scalars["String"]>;
  job_company_location_name?: InputMaybe<Scalars["String"]>;
  job_company_location_postal_code?: InputMaybe<Scalars["String"]>;
  job_company_location_region?: InputMaybe<Scalars["String"]>;
  job_company_location_street_address?: InputMaybe<Scalars["String"]>;
  job_company_name?: InputMaybe<Scalars["String"]>;
  job_company_size?: InputMaybe<Scalars["String"]>;
  job_company_twitter_url?: InputMaybe<Scalars["String"]>;
  job_company_website?: InputMaybe<Scalars["String"]>;
  job_last_updated?: InputMaybe<Scalars["String"]>;
  job_start_date?: InputMaybe<Scalars["String"]>;
  job_title?: InputMaybe<Scalars["String"]>;
  job_title_levels?: InputMaybe<Scalars["jsonb"]>;
  job_title_role?: InputMaybe<Scalars["String"]>;
  job_title_sub_role?: InputMaybe<Scalars["String"]>;
  last_initial?: InputMaybe<Scalars["String"]>;
  last_name?: InputMaybe<Scalars["String"]>;
  linkedin_id?: InputMaybe<Scalars["Int"]>;
  linkedin_url?: InputMaybe<Scalars["String"]>;
  linkedin_username?: InputMaybe<Scalars["String"]>;
  location_address_line_2?: InputMaybe<Scalars["String"]>;
  location_continent?: InputMaybe<Scalars["String"]>;
  location_country?: InputMaybe<Scalars["String"]>;
  location_geo?: InputMaybe<Scalars["String"]>;
  location_last_updated?: InputMaybe<Scalars["String"]>;
  location_locality?: InputMaybe<Scalars["String"]>;
  location_metro?: InputMaybe<Scalars["String"]>;
  location_name?: InputMaybe<Scalars["String"]>;
  location_names?: InputMaybe<Scalars["jsonb"]>;
  location_postal_code?: InputMaybe<Scalars["String"]>;
  location_region?: InputMaybe<Scalars["String"]>;
  location_street_address?: InputMaybe<Scalars["String"]>;
  middle_initial?: InputMaybe<Scalars["String"]>;
  middle_name?: InputMaybe<Scalars["String"]>;
  mobile_phone?: InputMaybe<Scalars["String"]>;
  personal_emails?: InputMaybe<Scalars["jsonb"]>;
  phone_numbers?: InputMaybe<Scalars["jsonb"]>;
  profiles?: InputMaybe<Scalars["jsonb"]>;
  recommended_personal_email?: InputMaybe<Scalars["String"]>;
  regions?: InputMaybe<Scalars["jsonb"]>;
  revtron_user_id?: InputMaybe<Scalars["uuid"]>;
  skills?: InputMaybe<Scalars["jsonb"]>;
  street_addresses?: InputMaybe<Scalars["jsonb"]>;
  twitter_url?: InputMaybe<Scalars["String"]>;
  twitter_username?: InputMaybe<Scalars["String"]>;
  updated_at?: InputMaybe<Scalars["timestamptz"]>;
  version_status?: InputMaybe<Scalars["jsonb"]>;
  work_email?: InputMaybe<Scalars["String"]>;
};

/** Streaming cursor of the table "pdl_people_data" */
export type pdl_people_data_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: pdl_people_data_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type pdl_people_data_stream_cursor_value_input = {
  birth_date?: InputMaybe<Scalars["String"]>;
  birth_year?: InputMaybe<Scalars["Int"]>;
  countries?: InputMaybe<Scalars["jsonb"]>;
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  crm_account_id?: InputMaybe<Scalars["String"]>;
  education?: InputMaybe<Scalars["jsonb"]>;
  emails?: InputMaybe<Scalars["jsonb"]>;
  experience?: InputMaybe<Scalars["jsonb"]>;
  facebook_id?: InputMaybe<Scalars["numeric"]>;
  facebook_url?: InputMaybe<Scalars["String"]>;
  facebook_username?: InputMaybe<Scalars["String"]>;
  first_name?: InputMaybe<Scalars["String"]>;
  full_name?: InputMaybe<Scalars["String"]>;
  gender?: InputMaybe<Scalars["String"]>;
  github_url?: InputMaybe<Scalars["String"]>;
  github_username?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  industry?: InputMaybe<Scalars["String"]>;
  interests?: InputMaybe<Scalars["jsonb"]>;
  job_company_facebook_url?: InputMaybe<Scalars["String"]>;
  job_company_founded?: InputMaybe<Scalars["Int"]>;
  job_company_id?: InputMaybe<Scalars["String"]>;
  job_company_industry?: InputMaybe<Scalars["String"]>;
  job_company_linkedin_id?: InputMaybe<Scalars["Int"]>;
  job_company_linkedin_url?: InputMaybe<Scalars["String"]>;
  job_company_location_address_line_2?: InputMaybe<Scalars["String"]>;
  job_company_location_continent?: InputMaybe<Scalars["String"]>;
  job_company_location_country?: InputMaybe<Scalars["String"]>;
  job_company_location_geo?: InputMaybe<Scalars["String"]>;
  job_company_location_locality?: InputMaybe<Scalars["String"]>;
  job_company_location_metro?: InputMaybe<Scalars["String"]>;
  job_company_location_name?: InputMaybe<Scalars["String"]>;
  job_company_location_postal_code?: InputMaybe<Scalars["String"]>;
  job_company_location_region?: InputMaybe<Scalars["String"]>;
  job_company_location_street_address?: InputMaybe<Scalars["String"]>;
  job_company_name?: InputMaybe<Scalars["String"]>;
  job_company_size?: InputMaybe<Scalars["String"]>;
  job_company_twitter_url?: InputMaybe<Scalars["String"]>;
  job_company_website?: InputMaybe<Scalars["String"]>;
  job_last_updated?: InputMaybe<Scalars["String"]>;
  job_start_date?: InputMaybe<Scalars["String"]>;
  job_title?: InputMaybe<Scalars["String"]>;
  job_title_levels?: InputMaybe<Scalars["jsonb"]>;
  job_title_role?: InputMaybe<Scalars["String"]>;
  job_title_sub_role?: InputMaybe<Scalars["String"]>;
  last_initial?: InputMaybe<Scalars["String"]>;
  last_name?: InputMaybe<Scalars["String"]>;
  linkedin_id?: InputMaybe<Scalars["Int"]>;
  linkedin_url?: InputMaybe<Scalars["String"]>;
  linkedin_username?: InputMaybe<Scalars["String"]>;
  location_address_line_2?: InputMaybe<Scalars["String"]>;
  location_continent?: InputMaybe<Scalars["String"]>;
  location_country?: InputMaybe<Scalars["String"]>;
  location_geo?: InputMaybe<Scalars["String"]>;
  location_last_updated?: InputMaybe<Scalars["String"]>;
  location_locality?: InputMaybe<Scalars["String"]>;
  location_metro?: InputMaybe<Scalars["String"]>;
  location_name?: InputMaybe<Scalars["String"]>;
  location_names?: InputMaybe<Scalars["jsonb"]>;
  location_postal_code?: InputMaybe<Scalars["String"]>;
  location_region?: InputMaybe<Scalars["String"]>;
  location_street_address?: InputMaybe<Scalars["String"]>;
  middle_initial?: InputMaybe<Scalars["String"]>;
  middle_name?: InputMaybe<Scalars["String"]>;
  mobile_phone?: InputMaybe<Scalars["String"]>;
  personal_emails?: InputMaybe<Scalars["jsonb"]>;
  phone_numbers?: InputMaybe<Scalars["jsonb"]>;
  profiles?: InputMaybe<Scalars["jsonb"]>;
  recommended_personal_email?: InputMaybe<Scalars["String"]>;
  regions?: InputMaybe<Scalars["jsonb"]>;
  revtron_user_id?: InputMaybe<Scalars["uuid"]>;
  skills?: InputMaybe<Scalars["jsonb"]>;
  street_addresses?: InputMaybe<Scalars["jsonb"]>;
  twitter_url?: InputMaybe<Scalars["String"]>;
  twitter_username?: InputMaybe<Scalars["String"]>;
  updated_at?: InputMaybe<Scalars["timestamptz"]>;
  version_status?: InputMaybe<Scalars["jsonb"]>;
  work_email?: InputMaybe<Scalars["String"]>;
};

/** update columns of table "pdl_people_data" */
export enum pdl_people_data_update_column {
  /** column name */
  birth_date = "birth_date",
  /** column name */
  birth_year = "birth_year",
  /** column name */
  countries = "countries",
  /** column name */
  created_at = "created_at",
  /** column name */
  crm_account_id = "crm_account_id",
  /** column name */
  education = "education",
  /** column name */
  emails = "emails",
  /** column name */
  experience = "experience",
  /** column name */
  facebook_id = "facebook_id",
  /** column name */
  facebook_url = "facebook_url",
  /** column name */
  facebook_username = "facebook_username",
  /** column name */
  first_name = "first_name",
  /** column name */
  full_name = "full_name",
  /** column name */
  gender = "gender",
  /** column name */
  github_url = "github_url",
  /** column name */
  github_username = "github_username",
  /** column name */
  id = "id",
  /** column name */
  industry = "industry",
  /** column name */
  interests = "interests",
  /** column name */
  job_company_facebook_url = "job_company_facebook_url",
  /** column name */
  job_company_founded = "job_company_founded",
  /** column name */
  job_company_id = "job_company_id",
  /** column name */
  job_company_industry = "job_company_industry",
  /** column name */
  job_company_linkedin_id = "job_company_linkedin_id",
  /** column name */
  job_company_linkedin_url = "job_company_linkedin_url",
  /** column name */
  job_company_location_address_line_2 = "job_company_location_address_line_2",
  /** column name */
  job_company_location_continent = "job_company_location_continent",
  /** column name */
  job_company_location_country = "job_company_location_country",
  /** column name */
  job_company_location_geo = "job_company_location_geo",
  /** column name */
  job_company_location_locality = "job_company_location_locality",
  /** column name */
  job_company_location_metro = "job_company_location_metro",
  /** column name */
  job_company_location_name = "job_company_location_name",
  /** column name */
  job_company_location_postal_code = "job_company_location_postal_code",
  /** column name */
  job_company_location_region = "job_company_location_region",
  /** column name */
  job_company_location_street_address = "job_company_location_street_address",
  /** column name */
  job_company_name = "job_company_name",
  /** column name */
  job_company_size = "job_company_size",
  /** column name */
  job_company_twitter_url = "job_company_twitter_url",
  /** column name */
  job_company_website = "job_company_website",
  /** column name */
  job_last_updated = "job_last_updated",
  /** column name */
  job_start_date = "job_start_date",
  /** column name */
  job_title = "job_title",
  /** column name */
  job_title_levels = "job_title_levels",
  /** column name */
  job_title_role = "job_title_role",
  /** column name */
  job_title_sub_role = "job_title_sub_role",
  /** column name */
  last_initial = "last_initial",
  /** column name */
  last_name = "last_name",
  /** column name */
  linkedin_id = "linkedin_id",
  /** column name */
  linkedin_url = "linkedin_url",
  /** column name */
  linkedin_username = "linkedin_username",
  /** column name */
  location_address_line_2 = "location_address_line_2",
  /** column name */
  location_continent = "location_continent",
  /** column name */
  location_country = "location_country",
  /** column name */
  location_geo = "location_geo",
  /** column name */
  location_last_updated = "location_last_updated",
  /** column name */
  location_locality = "location_locality",
  /** column name */
  location_metro = "location_metro",
  /** column name */
  location_name = "location_name",
  /** column name */
  location_names = "location_names",
  /** column name */
  location_postal_code = "location_postal_code",
  /** column name */
  location_region = "location_region",
  /** column name */
  location_street_address = "location_street_address",
  /** column name */
  middle_initial = "middle_initial",
  /** column name */
  middle_name = "middle_name",
  /** column name */
  mobile_phone = "mobile_phone",
  /** column name */
  personal_emails = "personal_emails",
  /** column name */
  phone_numbers = "phone_numbers",
  /** column name */
  profiles = "profiles",
  /** column name */
  recommended_personal_email = "recommended_personal_email",
  /** column name */
  regions = "regions",
  /** column name */
  revtron_user_id = "revtron_user_id",
  /** column name */
  skills = "skills",
  /** column name */
  street_addresses = "street_addresses",
  /** column name */
  twitter_url = "twitter_url",
  /** column name */
  twitter_username = "twitter_username",
  /** column name */
  updated_at = "updated_at",
  /** column name */
  version_status = "version_status",
  /** column name */
  work_email = "work_email",
}

export type pdl_people_data_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<pdl_people_data_append_input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<pdl_people_data_delete_at_path_input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<pdl_people_data_delete_elem_input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<pdl_people_data_delete_key_input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<pdl_people_data_inc_input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<pdl_people_data_prepend_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<pdl_people_data_set_input>;
  where: pdl_people_data_bool_exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type pdl_people_preview_append_input = {
  job_title_levels?: InputMaybe<Scalars["jsonb"]>;
  version_status?: InputMaybe<Scalars["jsonb"]>;
};

/** Boolean expression to filter rows from the table "pdl_people_preview". All fields are combined with a logical 'AND'. */
export type pdl_people_preview_bool_exp = {
  _and?: InputMaybe<Array<pdl_people_preview_bool_exp>>;
  _not?: InputMaybe<pdl_people_preview_bool_exp>;
  _or?: InputMaybe<Array<pdl_people_preview_bool_exp>>;
  birth_date?: InputMaybe<Boolean_comparison_exp>;
  birth_year?: InputMaybe<Boolean_comparison_exp>;
  countries?: InputMaybe<Boolean_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  crm_account_id?: InputMaybe<String_comparison_exp>;
  education?: InputMaybe<Boolean_comparison_exp>;
  emails?: InputMaybe<Boolean_comparison_exp>;
  experience?: InputMaybe<Boolean_comparison_exp>;
  facebook_id?: InputMaybe<Boolean_comparison_exp>;
  facebook_url?: InputMaybe<Boolean_comparison_exp>;
  facebook_username?: InputMaybe<Boolean_comparison_exp>;
  first_name?: InputMaybe<Boolean_comparison_exp>;
  full_name?: InputMaybe<String_comparison_exp>;
  gender?: InputMaybe<String_comparison_exp>;
  github_url?: InputMaybe<Boolean_comparison_exp>;
  github_username?: InputMaybe<Boolean_comparison_exp>;
  id?: InputMaybe<String_comparison_exp>;
  industry?: InputMaybe<String_comparison_exp>;
  interests?: InputMaybe<Boolean_comparison_exp>;
  job_company_facebook_url?: InputMaybe<Boolean_comparison_exp>;
  job_company_founded?: InputMaybe<Boolean_comparison_exp>;
  job_company_id?: InputMaybe<Boolean_comparison_exp>;
  job_company_industry?: InputMaybe<Boolean_comparison_exp>;
  job_company_linkedin_id?: InputMaybe<Boolean_comparison_exp>;
  job_company_linkedin_url?: InputMaybe<Boolean_comparison_exp>;
  job_company_location_address_line_2?: InputMaybe<Boolean_comparison_exp>;
  job_company_location_continent?: InputMaybe<Boolean_comparison_exp>;
  job_company_location_country?: InputMaybe<Boolean_comparison_exp>;
  job_company_location_geo?: InputMaybe<Boolean_comparison_exp>;
  job_company_location_locality?: InputMaybe<Boolean_comparison_exp>;
  job_company_location_metro?: InputMaybe<Boolean_comparison_exp>;
  job_company_location_name?: InputMaybe<Boolean_comparison_exp>;
  job_company_location_postal_code?: InputMaybe<Boolean_comparison_exp>;
  job_company_location_region?: InputMaybe<Boolean_comparison_exp>;
  job_company_location_street_address?: InputMaybe<Boolean_comparison_exp>;
  job_company_name?: InputMaybe<String_comparison_exp>;
  job_company_size?: InputMaybe<Boolean_comparison_exp>;
  job_company_twitter_url?: InputMaybe<Boolean_comparison_exp>;
  job_company_website?: InputMaybe<String_comparison_exp>;
  job_last_updated?: InputMaybe<Boolean_comparison_exp>;
  job_start_date?: InputMaybe<Boolean_comparison_exp>;
  job_title?: InputMaybe<String_comparison_exp>;
  job_title_levels?: InputMaybe<jsonb_comparison_exp>;
  job_title_role?: InputMaybe<String_comparison_exp>;
  job_title_sub_role?: InputMaybe<String_comparison_exp>;
  last_initial?: InputMaybe<Boolean_comparison_exp>;
  last_name?: InputMaybe<Boolean_comparison_exp>;
  linkedin_id?: InputMaybe<Boolean_comparison_exp>;
  linkedin_url?: InputMaybe<String_comparison_exp>;
  linkedin_username?: InputMaybe<Boolean_comparison_exp>;
  location_address_line_2?: InputMaybe<Boolean_comparison_exp>;
  location_continent?: InputMaybe<Boolean_comparison_exp>;
  location_country?: InputMaybe<Boolean_comparison_exp>;
  location_geo?: InputMaybe<Boolean_comparison_exp>;
  location_last_updated?: InputMaybe<Boolean_comparison_exp>;
  location_locality?: InputMaybe<Boolean_comparison_exp>;
  location_metro?: InputMaybe<Boolean_comparison_exp>;
  location_name?: InputMaybe<String_comparison_exp>;
  location_names?: InputMaybe<Boolean_comparison_exp>;
  location_postal_code?: InputMaybe<Boolean_comparison_exp>;
  location_region?: InputMaybe<Boolean_comparison_exp>;
  location_street_address?: InputMaybe<Boolean_comparison_exp>;
  middle_initial?: InputMaybe<Boolean_comparison_exp>;
  middle_name?: InputMaybe<Boolean_comparison_exp>;
  mobile_phone?: InputMaybe<Boolean_comparison_exp>;
  personal_emails?: InputMaybe<Boolean_comparison_exp>;
  phone_numbers?: InputMaybe<Boolean_comparison_exp>;
  profiles?: InputMaybe<Boolean_comparison_exp>;
  regions?: InputMaybe<Boolean_comparison_exp>;
  revtron_user_id?: InputMaybe<uuid_comparison_exp>;
  skills?: InputMaybe<Boolean_comparison_exp>;
  street_addresses?: InputMaybe<Boolean_comparison_exp>;
  twitter_url?: InputMaybe<Boolean_comparison_exp>;
  twitter_username?: InputMaybe<Boolean_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  version_status?: InputMaybe<jsonb_comparison_exp>;
  work_email?: InputMaybe<Boolean_comparison_exp>;
};

/** unique or primary key constraints on table "pdl_people_preview" */
export enum pdl_people_preview_constraint {
  /** unique or primary key constraint on columns "id" */
  pdl_people_preview_pkey = "pdl_people_preview_pkey",
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type pdl_people_preview_delete_at_path_input = {
  job_title_levels?: InputMaybe<Array<Scalars["String"]>>;
  version_status?: InputMaybe<Array<Scalars["String"]>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type pdl_people_preview_delete_elem_input = {
  job_title_levels?: InputMaybe<Scalars["Int"]>;
  version_status?: InputMaybe<Scalars["Int"]>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type pdl_people_preview_delete_key_input = {
  job_title_levels?: InputMaybe<Scalars["String"]>;
  version_status?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "pdl_people_preview_in_crm". All fields are combined with a logical 'AND'. */
export type pdl_people_preview_in_crm_bool_exp = {
  _and?: InputMaybe<Array<pdl_people_preview_in_crm_bool_exp>>;
  _not?: InputMaybe<pdl_people_preview_in_crm_bool_exp>;
  _or?: InputMaybe<Array<pdl_people_preview_in_crm_bool_exp>>;
  birth_date?: InputMaybe<Boolean_comparison_exp>;
  birth_year?: InputMaybe<Boolean_comparison_exp>;
  countries?: InputMaybe<Boolean_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  crm_account_id?: InputMaybe<String_comparison_exp>;
  education?: InputMaybe<Boolean_comparison_exp>;
  emails?: InputMaybe<Boolean_comparison_exp>;
  experience?: InputMaybe<Boolean_comparison_exp>;
  facebook_id?: InputMaybe<Boolean_comparison_exp>;
  facebook_url?: InputMaybe<Boolean_comparison_exp>;
  facebook_username?: InputMaybe<Boolean_comparison_exp>;
  first_name?: InputMaybe<Boolean_comparison_exp>;
  full_name?: InputMaybe<String_comparison_exp>;
  gender?: InputMaybe<String_comparison_exp>;
  github_url?: InputMaybe<Boolean_comparison_exp>;
  github_username?: InputMaybe<Boolean_comparison_exp>;
  id?: InputMaybe<String_comparison_exp>;
  industry?: InputMaybe<String_comparison_exp>;
  interests?: InputMaybe<Boolean_comparison_exp>;
  job_company_facebook_url?: InputMaybe<Boolean_comparison_exp>;
  job_company_founded?: InputMaybe<Boolean_comparison_exp>;
  job_company_id?: InputMaybe<Boolean_comparison_exp>;
  job_company_industry?: InputMaybe<Boolean_comparison_exp>;
  job_company_linkedin_id?: InputMaybe<Boolean_comparison_exp>;
  job_company_linkedin_url?: InputMaybe<Boolean_comparison_exp>;
  job_company_location_address_line_2?: InputMaybe<Boolean_comparison_exp>;
  job_company_location_continent?: InputMaybe<Boolean_comparison_exp>;
  job_company_location_country?: InputMaybe<Boolean_comparison_exp>;
  job_company_location_geo?: InputMaybe<Boolean_comparison_exp>;
  job_company_location_locality?: InputMaybe<Boolean_comparison_exp>;
  job_company_location_metro?: InputMaybe<Boolean_comparison_exp>;
  job_company_location_name?: InputMaybe<Boolean_comparison_exp>;
  job_company_location_postal_code?: InputMaybe<Boolean_comparison_exp>;
  job_company_location_region?: InputMaybe<Boolean_comparison_exp>;
  job_company_location_street_address?: InputMaybe<Boolean_comparison_exp>;
  job_company_name?: InputMaybe<String_comparison_exp>;
  job_company_size?: InputMaybe<Boolean_comparison_exp>;
  job_company_twitter_url?: InputMaybe<Boolean_comparison_exp>;
  job_company_website?: InputMaybe<String_comparison_exp>;
  job_last_updated?: InputMaybe<Boolean_comparison_exp>;
  job_start_date?: InputMaybe<Boolean_comparison_exp>;
  job_title?: InputMaybe<String_comparison_exp>;
  job_title_levels?: InputMaybe<jsonb_comparison_exp>;
  job_title_role?: InputMaybe<String_comparison_exp>;
  job_title_sub_role?: InputMaybe<String_comparison_exp>;
  last_initial?: InputMaybe<Boolean_comparison_exp>;
  last_name?: InputMaybe<Boolean_comparison_exp>;
  linkedin_id?: InputMaybe<Boolean_comparison_exp>;
  linkedin_url?: InputMaybe<String_comparison_exp>;
  linkedin_username?: InputMaybe<Boolean_comparison_exp>;
  location_address_line_2?: InputMaybe<Boolean_comparison_exp>;
  location_continent?: InputMaybe<Boolean_comparison_exp>;
  location_country?: InputMaybe<Boolean_comparison_exp>;
  location_geo?: InputMaybe<Boolean_comparison_exp>;
  location_last_updated?: InputMaybe<Boolean_comparison_exp>;
  location_locality?: InputMaybe<Boolean_comparison_exp>;
  location_metro?: InputMaybe<Boolean_comparison_exp>;
  location_name?: InputMaybe<String_comparison_exp>;
  location_names?: InputMaybe<Boolean_comparison_exp>;
  location_postal_code?: InputMaybe<Boolean_comparison_exp>;
  location_region?: InputMaybe<Boolean_comparison_exp>;
  location_street_address?: InputMaybe<Boolean_comparison_exp>;
  middle_initial?: InputMaybe<Boolean_comparison_exp>;
  middle_name?: InputMaybe<Boolean_comparison_exp>;
  mobile_phone?: InputMaybe<Boolean_comparison_exp>;
  personal_emails?: InputMaybe<Boolean_comparison_exp>;
  phone_numbers?: InputMaybe<Boolean_comparison_exp>;
  profiles?: InputMaybe<Boolean_comparison_exp>;
  regions?: InputMaybe<Boolean_comparison_exp>;
  revtron_user_id?: InputMaybe<uuid_comparison_exp>;
  skills?: InputMaybe<Boolean_comparison_exp>;
  street_addresses?: InputMaybe<Boolean_comparison_exp>;
  twitter_url?: InputMaybe<Boolean_comparison_exp>;
  twitter_username?: InputMaybe<Boolean_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  version_status?: InputMaybe<jsonb_comparison_exp>;
  work_email?: InputMaybe<Boolean_comparison_exp>;
};

/** Ordering options when selecting data from "pdl_people_preview_in_crm". */
export type pdl_people_preview_in_crm_order_by = {
  birth_date?: InputMaybe<order_by>;
  birth_year?: InputMaybe<order_by>;
  countries?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  crm_account_id?: InputMaybe<order_by>;
  education?: InputMaybe<order_by>;
  emails?: InputMaybe<order_by>;
  experience?: InputMaybe<order_by>;
  facebook_id?: InputMaybe<order_by>;
  facebook_url?: InputMaybe<order_by>;
  facebook_username?: InputMaybe<order_by>;
  first_name?: InputMaybe<order_by>;
  full_name?: InputMaybe<order_by>;
  gender?: InputMaybe<order_by>;
  github_url?: InputMaybe<order_by>;
  github_username?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  industry?: InputMaybe<order_by>;
  interests?: InputMaybe<order_by>;
  job_company_facebook_url?: InputMaybe<order_by>;
  job_company_founded?: InputMaybe<order_by>;
  job_company_id?: InputMaybe<order_by>;
  job_company_industry?: InputMaybe<order_by>;
  job_company_linkedin_id?: InputMaybe<order_by>;
  job_company_linkedin_url?: InputMaybe<order_by>;
  job_company_location_address_line_2?: InputMaybe<order_by>;
  job_company_location_continent?: InputMaybe<order_by>;
  job_company_location_country?: InputMaybe<order_by>;
  job_company_location_geo?: InputMaybe<order_by>;
  job_company_location_locality?: InputMaybe<order_by>;
  job_company_location_metro?: InputMaybe<order_by>;
  job_company_location_name?: InputMaybe<order_by>;
  job_company_location_postal_code?: InputMaybe<order_by>;
  job_company_location_region?: InputMaybe<order_by>;
  job_company_location_street_address?: InputMaybe<order_by>;
  job_company_name?: InputMaybe<order_by>;
  job_company_size?: InputMaybe<order_by>;
  job_company_twitter_url?: InputMaybe<order_by>;
  job_company_website?: InputMaybe<order_by>;
  job_last_updated?: InputMaybe<order_by>;
  job_start_date?: InputMaybe<order_by>;
  job_title?: InputMaybe<order_by>;
  job_title_levels?: InputMaybe<order_by>;
  job_title_role?: InputMaybe<order_by>;
  job_title_sub_role?: InputMaybe<order_by>;
  last_initial?: InputMaybe<order_by>;
  last_name?: InputMaybe<order_by>;
  linkedin_id?: InputMaybe<order_by>;
  linkedin_url?: InputMaybe<order_by>;
  linkedin_username?: InputMaybe<order_by>;
  location_address_line_2?: InputMaybe<order_by>;
  location_continent?: InputMaybe<order_by>;
  location_country?: InputMaybe<order_by>;
  location_geo?: InputMaybe<order_by>;
  location_last_updated?: InputMaybe<order_by>;
  location_locality?: InputMaybe<order_by>;
  location_metro?: InputMaybe<order_by>;
  location_name?: InputMaybe<order_by>;
  location_names?: InputMaybe<order_by>;
  location_postal_code?: InputMaybe<order_by>;
  location_region?: InputMaybe<order_by>;
  location_street_address?: InputMaybe<order_by>;
  middle_initial?: InputMaybe<order_by>;
  middle_name?: InputMaybe<order_by>;
  mobile_phone?: InputMaybe<order_by>;
  personal_emails?: InputMaybe<order_by>;
  phone_numbers?: InputMaybe<order_by>;
  profiles?: InputMaybe<order_by>;
  regions?: InputMaybe<order_by>;
  revtron_user_id?: InputMaybe<order_by>;
  skills?: InputMaybe<order_by>;
  street_addresses?: InputMaybe<order_by>;
  twitter_url?: InputMaybe<order_by>;
  twitter_username?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  version_status?: InputMaybe<order_by>;
  work_email?: InputMaybe<order_by>;
};

/** select columns of table "pdl_people_preview_in_crm" */
export enum pdl_people_preview_in_crm_select_column {
  /** column name */
  birth_date = "birth_date",
  /** column name */
  birth_year = "birth_year",
  /** column name */
  countries = "countries",
  /** column name */
  created_at = "created_at",
  /** column name */
  crm_account_id = "crm_account_id",
  /** column name */
  education = "education",
  /** column name */
  emails = "emails",
  /** column name */
  experience = "experience",
  /** column name */
  facebook_id = "facebook_id",
  /** column name */
  facebook_url = "facebook_url",
  /** column name */
  facebook_username = "facebook_username",
  /** column name */
  first_name = "first_name",
  /** column name */
  full_name = "full_name",
  /** column name */
  gender = "gender",
  /** column name */
  github_url = "github_url",
  /** column name */
  github_username = "github_username",
  /** column name */
  id = "id",
  /** column name */
  industry = "industry",
  /** column name */
  interests = "interests",
  /** column name */
  job_company_facebook_url = "job_company_facebook_url",
  /** column name */
  job_company_founded = "job_company_founded",
  /** column name */
  job_company_id = "job_company_id",
  /** column name */
  job_company_industry = "job_company_industry",
  /** column name */
  job_company_linkedin_id = "job_company_linkedin_id",
  /** column name */
  job_company_linkedin_url = "job_company_linkedin_url",
  /** column name */
  job_company_location_address_line_2 = "job_company_location_address_line_2",
  /** column name */
  job_company_location_continent = "job_company_location_continent",
  /** column name */
  job_company_location_country = "job_company_location_country",
  /** column name */
  job_company_location_geo = "job_company_location_geo",
  /** column name */
  job_company_location_locality = "job_company_location_locality",
  /** column name */
  job_company_location_metro = "job_company_location_metro",
  /** column name */
  job_company_location_name = "job_company_location_name",
  /** column name */
  job_company_location_postal_code = "job_company_location_postal_code",
  /** column name */
  job_company_location_region = "job_company_location_region",
  /** column name */
  job_company_location_street_address = "job_company_location_street_address",
  /** column name */
  job_company_name = "job_company_name",
  /** column name */
  job_company_size = "job_company_size",
  /** column name */
  job_company_twitter_url = "job_company_twitter_url",
  /** column name */
  job_company_website = "job_company_website",
  /** column name */
  job_last_updated = "job_last_updated",
  /** column name */
  job_start_date = "job_start_date",
  /** column name */
  job_title = "job_title",
  /** column name */
  job_title_levels = "job_title_levels",
  /** column name */
  job_title_role = "job_title_role",
  /** column name */
  job_title_sub_role = "job_title_sub_role",
  /** column name */
  last_initial = "last_initial",
  /** column name */
  last_name = "last_name",
  /** column name */
  linkedin_id = "linkedin_id",
  /** column name */
  linkedin_url = "linkedin_url",
  /** column name */
  linkedin_username = "linkedin_username",
  /** column name */
  location_address_line_2 = "location_address_line_2",
  /** column name */
  location_continent = "location_continent",
  /** column name */
  location_country = "location_country",
  /** column name */
  location_geo = "location_geo",
  /** column name */
  location_last_updated = "location_last_updated",
  /** column name */
  location_locality = "location_locality",
  /** column name */
  location_metro = "location_metro",
  /** column name */
  location_name = "location_name",
  /** column name */
  location_names = "location_names",
  /** column name */
  location_postal_code = "location_postal_code",
  /** column name */
  location_region = "location_region",
  /** column name */
  location_street_address = "location_street_address",
  /** column name */
  middle_initial = "middle_initial",
  /** column name */
  middle_name = "middle_name",
  /** column name */
  mobile_phone = "mobile_phone",
  /** column name */
  personal_emails = "personal_emails",
  /** column name */
  phone_numbers = "phone_numbers",
  /** column name */
  profiles = "profiles",
  /** column name */
  regions = "regions",
  /** column name */
  revtron_user_id = "revtron_user_id",
  /** column name */
  skills = "skills",
  /** column name */
  street_addresses = "street_addresses",
  /** column name */
  twitter_url = "twitter_url",
  /** column name */
  twitter_username = "twitter_username",
  /** column name */
  updated_at = "updated_at",
  /** column name */
  version_status = "version_status",
  /** column name */
  work_email = "work_email",
}

/** Streaming cursor of the table "pdl_people_preview_in_crm" */
export type pdl_people_preview_in_crm_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: pdl_people_preview_in_crm_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type pdl_people_preview_in_crm_stream_cursor_value_input = {
  birth_date?: InputMaybe<Scalars["Boolean"]>;
  birth_year?: InputMaybe<Scalars["Boolean"]>;
  countries?: InputMaybe<Scalars["Boolean"]>;
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  crm_account_id?: InputMaybe<Scalars["String"]>;
  education?: InputMaybe<Scalars["Boolean"]>;
  emails?: InputMaybe<Scalars["Boolean"]>;
  experience?: InputMaybe<Scalars["Boolean"]>;
  facebook_id?: InputMaybe<Scalars["Boolean"]>;
  facebook_url?: InputMaybe<Scalars["Boolean"]>;
  facebook_username?: InputMaybe<Scalars["Boolean"]>;
  first_name?: InputMaybe<Scalars["Boolean"]>;
  full_name?: InputMaybe<Scalars["String"]>;
  gender?: InputMaybe<Scalars["String"]>;
  github_url?: InputMaybe<Scalars["Boolean"]>;
  github_username?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["String"]>;
  industry?: InputMaybe<Scalars["String"]>;
  interests?: InputMaybe<Scalars["Boolean"]>;
  job_company_facebook_url?: InputMaybe<Scalars["Boolean"]>;
  job_company_founded?: InputMaybe<Scalars["Boolean"]>;
  job_company_id?: InputMaybe<Scalars["Boolean"]>;
  job_company_industry?: InputMaybe<Scalars["Boolean"]>;
  job_company_linkedin_id?: InputMaybe<Scalars["Boolean"]>;
  job_company_linkedin_url?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_address_line_2?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_continent?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_country?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_geo?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_locality?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_metro?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_name?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_postal_code?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_region?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_street_address?: InputMaybe<Scalars["Boolean"]>;
  job_company_name?: InputMaybe<Scalars["String"]>;
  job_company_size?: InputMaybe<Scalars["Boolean"]>;
  job_company_twitter_url?: InputMaybe<Scalars["Boolean"]>;
  job_company_website?: InputMaybe<Scalars["String"]>;
  job_last_updated?: InputMaybe<Scalars["Boolean"]>;
  job_start_date?: InputMaybe<Scalars["Boolean"]>;
  job_title?: InputMaybe<Scalars["String"]>;
  job_title_levels?: InputMaybe<Scalars["jsonb"]>;
  job_title_role?: InputMaybe<Scalars["String"]>;
  job_title_sub_role?: InputMaybe<Scalars["String"]>;
  last_initial?: InputMaybe<Scalars["Boolean"]>;
  last_name?: InputMaybe<Scalars["Boolean"]>;
  linkedin_id?: InputMaybe<Scalars["Boolean"]>;
  linkedin_url?: InputMaybe<Scalars["String"]>;
  linkedin_username?: InputMaybe<Scalars["Boolean"]>;
  location_address_line_2?: InputMaybe<Scalars["Boolean"]>;
  location_continent?: InputMaybe<Scalars["Boolean"]>;
  location_country?: InputMaybe<Scalars["Boolean"]>;
  location_geo?: InputMaybe<Scalars["Boolean"]>;
  location_last_updated?: InputMaybe<Scalars["Boolean"]>;
  location_locality?: InputMaybe<Scalars["Boolean"]>;
  location_metro?: InputMaybe<Scalars["Boolean"]>;
  location_name?: InputMaybe<Scalars["String"]>;
  location_names?: InputMaybe<Scalars["Boolean"]>;
  location_postal_code?: InputMaybe<Scalars["Boolean"]>;
  location_region?: InputMaybe<Scalars["Boolean"]>;
  location_street_address?: InputMaybe<Scalars["Boolean"]>;
  middle_initial?: InputMaybe<Scalars["Boolean"]>;
  middle_name?: InputMaybe<Scalars["Boolean"]>;
  mobile_phone?: InputMaybe<Scalars["Boolean"]>;
  personal_emails?: InputMaybe<Scalars["Boolean"]>;
  phone_numbers?: InputMaybe<Scalars["Boolean"]>;
  profiles?: InputMaybe<Scalars["Boolean"]>;
  regions?: InputMaybe<Scalars["Boolean"]>;
  revtron_user_id?: InputMaybe<Scalars["uuid"]>;
  skills?: InputMaybe<Scalars["Boolean"]>;
  street_addresses?: InputMaybe<Scalars["Boolean"]>;
  twitter_url?: InputMaybe<Scalars["Boolean"]>;
  twitter_username?: InputMaybe<Scalars["Boolean"]>;
  updated_at?: InputMaybe<Scalars["timestamptz"]>;
  version_status?: InputMaybe<Scalars["jsonb"]>;
  work_email?: InputMaybe<Scalars["Boolean"]>;
};

/** input type for inserting data into table "pdl_people_preview" */
export type pdl_people_preview_insert_input = {
  birth_date?: InputMaybe<Scalars["Boolean"]>;
  birth_year?: InputMaybe<Scalars["Boolean"]>;
  countries?: InputMaybe<Scalars["Boolean"]>;
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  crm_account_id?: InputMaybe<Scalars["String"]>;
  education?: InputMaybe<Scalars["Boolean"]>;
  emails?: InputMaybe<Scalars["Boolean"]>;
  experience?: InputMaybe<Scalars["Boolean"]>;
  facebook_id?: InputMaybe<Scalars["Boolean"]>;
  facebook_url?: InputMaybe<Scalars["Boolean"]>;
  facebook_username?: InputMaybe<Scalars["Boolean"]>;
  first_name?: InputMaybe<Scalars["Boolean"]>;
  full_name?: InputMaybe<Scalars["String"]>;
  gender?: InputMaybe<Scalars["String"]>;
  github_url?: InputMaybe<Scalars["Boolean"]>;
  github_username?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["String"]>;
  industry?: InputMaybe<Scalars["String"]>;
  interests?: InputMaybe<Scalars["Boolean"]>;
  job_company_facebook_url?: InputMaybe<Scalars["Boolean"]>;
  job_company_founded?: InputMaybe<Scalars["Boolean"]>;
  job_company_id?: InputMaybe<Scalars["Boolean"]>;
  job_company_industry?: InputMaybe<Scalars["Boolean"]>;
  job_company_linkedin_id?: InputMaybe<Scalars["Boolean"]>;
  job_company_linkedin_url?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_address_line_2?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_continent?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_country?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_geo?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_locality?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_metro?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_name?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_postal_code?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_region?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_street_address?: InputMaybe<Scalars["Boolean"]>;
  job_company_name?: InputMaybe<Scalars["String"]>;
  job_company_size?: InputMaybe<Scalars["Boolean"]>;
  job_company_twitter_url?: InputMaybe<Scalars["Boolean"]>;
  job_company_website?: InputMaybe<Scalars["String"]>;
  job_last_updated?: InputMaybe<Scalars["Boolean"]>;
  job_start_date?: InputMaybe<Scalars["Boolean"]>;
  job_title?: InputMaybe<Scalars["String"]>;
  job_title_levels?: InputMaybe<Scalars["jsonb"]>;
  job_title_role?: InputMaybe<Scalars["String"]>;
  job_title_sub_role?: InputMaybe<Scalars["String"]>;
  last_initial?: InputMaybe<Scalars["Boolean"]>;
  last_name?: InputMaybe<Scalars["Boolean"]>;
  linkedin_id?: InputMaybe<Scalars["Boolean"]>;
  linkedin_url?: InputMaybe<Scalars["String"]>;
  linkedin_username?: InputMaybe<Scalars["Boolean"]>;
  location_address_line_2?: InputMaybe<Scalars["Boolean"]>;
  location_continent?: InputMaybe<Scalars["Boolean"]>;
  location_country?: InputMaybe<Scalars["Boolean"]>;
  location_geo?: InputMaybe<Scalars["Boolean"]>;
  location_last_updated?: InputMaybe<Scalars["Boolean"]>;
  location_locality?: InputMaybe<Scalars["Boolean"]>;
  location_metro?: InputMaybe<Scalars["Boolean"]>;
  location_name?: InputMaybe<Scalars["String"]>;
  location_names?: InputMaybe<Scalars["Boolean"]>;
  location_postal_code?: InputMaybe<Scalars["Boolean"]>;
  location_region?: InputMaybe<Scalars["Boolean"]>;
  location_street_address?: InputMaybe<Scalars["Boolean"]>;
  middle_initial?: InputMaybe<Scalars["Boolean"]>;
  middle_name?: InputMaybe<Scalars["Boolean"]>;
  mobile_phone?: InputMaybe<Scalars["Boolean"]>;
  personal_emails?: InputMaybe<Scalars["Boolean"]>;
  phone_numbers?: InputMaybe<Scalars["Boolean"]>;
  profiles?: InputMaybe<Scalars["Boolean"]>;
  regions?: InputMaybe<Scalars["Boolean"]>;
  revtron_user_id?: InputMaybe<Scalars["uuid"]>;
  skills?: InputMaybe<Scalars["Boolean"]>;
  street_addresses?: InputMaybe<Scalars["Boolean"]>;
  twitter_url?: InputMaybe<Scalars["Boolean"]>;
  twitter_username?: InputMaybe<Scalars["Boolean"]>;
  updated_at?: InputMaybe<Scalars["timestamptz"]>;
  version_status?: InputMaybe<Scalars["jsonb"]>;
  work_email?: InputMaybe<Scalars["Boolean"]>;
};

/** on_conflict condition type for table "pdl_people_preview" */
export type pdl_people_preview_on_conflict = {
  constraint: pdl_people_preview_constraint;
  update_columns?: Array<pdl_people_preview_update_column>;
  where?: InputMaybe<pdl_people_preview_bool_exp>;
};

/** Ordering options when selecting data from "pdl_people_preview". */
export type pdl_people_preview_order_by = {
  birth_date?: InputMaybe<order_by>;
  birth_year?: InputMaybe<order_by>;
  countries?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  crm_account_id?: InputMaybe<order_by>;
  education?: InputMaybe<order_by>;
  emails?: InputMaybe<order_by>;
  experience?: InputMaybe<order_by>;
  facebook_id?: InputMaybe<order_by>;
  facebook_url?: InputMaybe<order_by>;
  facebook_username?: InputMaybe<order_by>;
  first_name?: InputMaybe<order_by>;
  full_name?: InputMaybe<order_by>;
  gender?: InputMaybe<order_by>;
  github_url?: InputMaybe<order_by>;
  github_username?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  industry?: InputMaybe<order_by>;
  interests?: InputMaybe<order_by>;
  job_company_facebook_url?: InputMaybe<order_by>;
  job_company_founded?: InputMaybe<order_by>;
  job_company_id?: InputMaybe<order_by>;
  job_company_industry?: InputMaybe<order_by>;
  job_company_linkedin_id?: InputMaybe<order_by>;
  job_company_linkedin_url?: InputMaybe<order_by>;
  job_company_location_address_line_2?: InputMaybe<order_by>;
  job_company_location_continent?: InputMaybe<order_by>;
  job_company_location_country?: InputMaybe<order_by>;
  job_company_location_geo?: InputMaybe<order_by>;
  job_company_location_locality?: InputMaybe<order_by>;
  job_company_location_metro?: InputMaybe<order_by>;
  job_company_location_name?: InputMaybe<order_by>;
  job_company_location_postal_code?: InputMaybe<order_by>;
  job_company_location_region?: InputMaybe<order_by>;
  job_company_location_street_address?: InputMaybe<order_by>;
  job_company_name?: InputMaybe<order_by>;
  job_company_size?: InputMaybe<order_by>;
  job_company_twitter_url?: InputMaybe<order_by>;
  job_company_website?: InputMaybe<order_by>;
  job_last_updated?: InputMaybe<order_by>;
  job_start_date?: InputMaybe<order_by>;
  job_title?: InputMaybe<order_by>;
  job_title_levels?: InputMaybe<order_by>;
  job_title_role?: InputMaybe<order_by>;
  job_title_sub_role?: InputMaybe<order_by>;
  last_initial?: InputMaybe<order_by>;
  last_name?: InputMaybe<order_by>;
  linkedin_id?: InputMaybe<order_by>;
  linkedin_url?: InputMaybe<order_by>;
  linkedin_username?: InputMaybe<order_by>;
  location_address_line_2?: InputMaybe<order_by>;
  location_continent?: InputMaybe<order_by>;
  location_country?: InputMaybe<order_by>;
  location_geo?: InputMaybe<order_by>;
  location_last_updated?: InputMaybe<order_by>;
  location_locality?: InputMaybe<order_by>;
  location_metro?: InputMaybe<order_by>;
  location_name?: InputMaybe<order_by>;
  location_names?: InputMaybe<order_by>;
  location_postal_code?: InputMaybe<order_by>;
  location_region?: InputMaybe<order_by>;
  location_street_address?: InputMaybe<order_by>;
  middle_initial?: InputMaybe<order_by>;
  middle_name?: InputMaybe<order_by>;
  mobile_phone?: InputMaybe<order_by>;
  personal_emails?: InputMaybe<order_by>;
  phone_numbers?: InputMaybe<order_by>;
  profiles?: InputMaybe<order_by>;
  regions?: InputMaybe<order_by>;
  revtron_user_id?: InputMaybe<order_by>;
  skills?: InputMaybe<order_by>;
  street_addresses?: InputMaybe<order_by>;
  twitter_url?: InputMaybe<order_by>;
  twitter_username?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  version_status?: InputMaybe<order_by>;
  work_email?: InputMaybe<order_by>;
};

/** primary key columns input for table: pdl_people_preview */
export type pdl_people_preview_pk_columns_input = {
  id: Scalars["String"];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type pdl_people_preview_prepend_input = {
  job_title_levels?: InputMaybe<Scalars["jsonb"]>;
  version_status?: InputMaybe<Scalars["jsonb"]>;
};

/** select columns of table "pdl_people_preview" */
export enum pdl_people_preview_select_column {
  /** column name */
  birth_date = "birth_date",
  /** column name */
  birth_year = "birth_year",
  /** column name */
  countries = "countries",
  /** column name */
  created_at = "created_at",
  /** column name */
  crm_account_id = "crm_account_id",
  /** column name */
  education = "education",
  /** column name */
  emails = "emails",
  /** column name */
  experience = "experience",
  /** column name */
  facebook_id = "facebook_id",
  /** column name */
  facebook_url = "facebook_url",
  /** column name */
  facebook_username = "facebook_username",
  /** column name */
  first_name = "first_name",
  /** column name */
  full_name = "full_name",
  /** column name */
  gender = "gender",
  /** column name */
  github_url = "github_url",
  /** column name */
  github_username = "github_username",
  /** column name */
  id = "id",
  /** column name */
  industry = "industry",
  /** column name */
  interests = "interests",
  /** column name */
  job_company_facebook_url = "job_company_facebook_url",
  /** column name */
  job_company_founded = "job_company_founded",
  /** column name */
  job_company_id = "job_company_id",
  /** column name */
  job_company_industry = "job_company_industry",
  /** column name */
  job_company_linkedin_id = "job_company_linkedin_id",
  /** column name */
  job_company_linkedin_url = "job_company_linkedin_url",
  /** column name */
  job_company_location_address_line_2 = "job_company_location_address_line_2",
  /** column name */
  job_company_location_continent = "job_company_location_continent",
  /** column name */
  job_company_location_country = "job_company_location_country",
  /** column name */
  job_company_location_geo = "job_company_location_geo",
  /** column name */
  job_company_location_locality = "job_company_location_locality",
  /** column name */
  job_company_location_metro = "job_company_location_metro",
  /** column name */
  job_company_location_name = "job_company_location_name",
  /** column name */
  job_company_location_postal_code = "job_company_location_postal_code",
  /** column name */
  job_company_location_region = "job_company_location_region",
  /** column name */
  job_company_location_street_address = "job_company_location_street_address",
  /** column name */
  job_company_name = "job_company_name",
  /** column name */
  job_company_size = "job_company_size",
  /** column name */
  job_company_twitter_url = "job_company_twitter_url",
  /** column name */
  job_company_website = "job_company_website",
  /** column name */
  job_last_updated = "job_last_updated",
  /** column name */
  job_start_date = "job_start_date",
  /** column name */
  job_title = "job_title",
  /** column name */
  job_title_levels = "job_title_levels",
  /** column name */
  job_title_role = "job_title_role",
  /** column name */
  job_title_sub_role = "job_title_sub_role",
  /** column name */
  last_initial = "last_initial",
  /** column name */
  last_name = "last_name",
  /** column name */
  linkedin_id = "linkedin_id",
  /** column name */
  linkedin_url = "linkedin_url",
  /** column name */
  linkedin_username = "linkedin_username",
  /** column name */
  location_address_line_2 = "location_address_line_2",
  /** column name */
  location_continent = "location_continent",
  /** column name */
  location_country = "location_country",
  /** column name */
  location_geo = "location_geo",
  /** column name */
  location_last_updated = "location_last_updated",
  /** column name */
  location_locality = "location_locality",
  /** column name */
  location_metro = "location_metro",
  /** column name */
  location_name = "location_name",
  /** column name */
  location_names = "location_names",
  /** column name */
  location_postal_code = "location_postal_code",
  /** column name */
  location_region = "location_region",
  /** column name */
  location_street_address = "location_street_address",
  /** column name */
  middle_initial = "middle_initial",
  /** column name */
  middle_name = "middle_name",
  /** column name */
  mobile_phone = "mobile_phone",
  /** column name */
  personal_emails = "personal_emails",
  /** column name */
  phone_numbers = "phone_numbers",
  /** column name */
  profiles = "profiles",
  /** column name */
  regions = "regions",
  /** column name */
  revtron_user_id = "revtron_user_id",
  /** column name */
  skills = "skills",
  /** column name */
  street_addresses = "street_addresses",
  /** column name */
  twitter_url = "twitter_url",
  /** column name */
  twitter_username = "twitter_username",
  /** column name */
  updated_at = "updated_at",
  /** column name */
  version_status = "version_status",
  /** column name */
  work_email = "work_email",
}

/** input type for updating data in table "pdl_people_preview" */
export type pdl_people_preview_set_input = {
  birth_date?: InputMaybe<Scalars["Boolean"]>;
  birth_year?: InputMaybe<Scalars["Boolean"]>;
  countries?: InputMaybe<Scalars["Boolean"]>;
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  crm_account_id?: InputMaybe<Scalars["String"]>;
  education?: InputMaybe<Scalars["Boolean"]>;
  emails?: InputMaybe<Scalars["Boolean"]>;
  experience?: InputMaybe<Scalars["Boolean"]>;
  facebook_id?: InputMaybe<Scalars["Boolean"]>;
  facebook_url?: InputMaybe<Scalars["Boolean"]>;
  facebook_username?: InputMaybe<Scalars["Boolean"]>;
  first_name?: InputMaybe<Scalars["Boolean"]>;
  full_name?: InputMaybe<Scalars["String"]>;
  gender?: InputMaybe<Scalars["String"]>;
  github_url?: InputMaybe<Scalars["Boolean"]>;
  github_username?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["String"]>;
  industry?: InputMaybe<Scalars["String"]>;
  interests?: InputMaybe<Scalars["Boolean"]>;
  job_company_facebook_url?: InputMaybe<Scalars["Boolean"]>;
  job_company_founded?: InputMaybe<Scalars["Boolean"]>;
  job_company_id?: InputMaybe<Scalars["Boolean"]>;
  job_company_industry?: InputMaybe<Scalars["Boolean"]>;
  job_company_linkedin_id?: InputMaybe<Scalars["Boolean"]>;
  job_company_linkedin_url?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_address_line_2?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_continent?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_country?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_geo?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_locality?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_metro?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_name?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_postal_code?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_region?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_street_address?: InputMaybe<Scalars["Boolean"]>;
  job_company_name?: InputMaybe<Scalars["String"]>;
  job_company_size?: InputMaybe<Scalars["Boolean"]>;
  job_company_twitter_url?: InputMaybe<Scalars["Boolean"]>;
  job_company_website?: InputMaybe<Scalars["String"]>;
  job_last_updated?: InputMaybe<Scalars["Boolean"]>;
  job_start_date?: InputMaybe<Scalars["Boolean"]>;
  job_title?: InputMaybe<Scalars["String"]>;
  job_title_levels?: InputMaybe<Scalars["jsonb"]>;
  job_title_role?: InputMaybe<Scalars["String"]>;
  job_title_sub_role?: InputMaybe<Scalars["String"]>;
  last_initial?: InputMaybe<Scalars["Boolean"]>;
  last_name?: InputMaybe<Scalars["Boolean"]>;
  linkedin_id?: InputMaybe<Scalars["Boolean"]>;
  linkedin_url?: InputMaybe<Scalars["String"]>;
  linkedin_username?: InputMaybe<Scalars["Boolean"]>;
  location_address_line_2?: InputMaybe<Scalars["Boolean"]>;
  location_continent?: InputMaybe<Scalars["Boolean"]>;
  location_country?: InputMaybe<Scalars["Boolean"]>;
  location_geo?: InputMaybe<Scalars["Boolean"]>;
  location_last_updated?: InputMaybe<Scalars["Boolean"]>;
  location_locality?: InputMaybe<Scalars["Boolean"]>;
  location_metro?: InputMaybe<Scalars["Boolean"]>;
  location_name?: InputMaybe<Scalars["String"]>;
  location_names?: InputMaybe<Scalars["Boolean"]>;
  location_postal_code?: InputMaybe<Scalars["Boolean"]>;
  location_region?: InputMaybe<Scalars["Boolean"]>;
  location_street_address?: InputMaybe<Scalars["Boolean"]>;
  middle_initial?: InputMaybe<Scalars["Boolean"]>;
  middle_name?: InputMaybe<Scalars["Boolean"]>;
  mobile_phone?: InputMaybe<Scalars["Boolean"]>;
  personal_emails?: InputMaybe<Scalars["Boolean"]>;
  phone_numbers?: InputMaybe<Scalars["Boolean"]>;
  profiles?: InputMaybe<Scalars["Boolean"]>;
  regions?: InputMaybe<Scalars["Boolean"]>;
  revtron_user_id?: InputMaybe<Scalars["uuid"]>;
  skills?: InputMaybe<Scalars["Boolean"]>;
  street_addresses?: InputMaybe<Scalars["Boolean"]>;
  twitter_url?: InputMaybe<Scalars["Boolean"]>;
  twitter_username?: InputMaybe<Scalars["Boolean"]>;
  updated_at?: InputMaybe<Scalars["timestamptz"]>;
  version_status?: InputMaybe<Scalars["jsonb"]>;
  work_email?: InputMaybe<Scalars["Boolean"]>;
};

/** Streaming cursor of the table "pdl_people_preview" */
export type pdl_people_preview_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: pdl_people_preview_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type pdl_people_preview_stream_cursor_value_input = {
  birth_date?: InputMaybe<Scalars["Boolean"]>;
  birth_year?: InputMaybe<Scalars["Boolean"]>;
  countries?: InputMaybe<Scalars["Boolean"]>;
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  crm_account_id?: InputMaybe<Scalars["String"]>;
  education?: InputMaybe<Scalars["Boolean"]>;
  emails?: InputMaybe<Scalars["Boolean"]>;
  experience?: InputMaybe<Scalars["Boolean"]>;
  facebook_id?: InputMaybe<Scalars["Boolean"]>;
  facebook_url?: InputMaybe<Scalars["Boolean"]>;
  facebook_username?: InputMaybe<Scalars["Boolean"]>;
  first_name?: InputMaybe<Scalars["Boolean"]>;
  full_name?: InputMaybe<Scalars["String"]>;
  gender?: InputMaybe<Scalars["String"]>;
  github_url?: InputMaybe<Scalars["Boolean"]>;
  github_username?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["String"]>;
  industry?: InputMaybe<Scalars["String"]>;
  interests?: InputMaybe<Scalars["Boolean"]>;
  job_company_facebook_url?: InputMaybe<Scalars["Boolean"]>;
  job_company_founded?: InputMaybe<Scalars["Boolean"]>;
  job_company_id?: InputMaybe<Scalars["Boolean"]>;
  job_company_industry?: InputMaybe<Scalars["Boolean"]>;
  job_company_linkedin_id?: InputMaybe<Scalars["Boolean"]>;
  job_company_linkedin_url?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_address_line_2?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_continent?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_country?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_geo?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_locality?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_metro?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_name?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_postal_code?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_region?: InputMaybe<Scalars["Boolean"]>;
  job_company_location_street_address?: InputMaybe<Scalars["Boolean"]>;
  job_company_name?: InputMaybe<Scalars["String"]>;
  job_company_size?: InputMaybe<Scalars["Boolean"]>;
  job_company_twitter_url?: InputMaybe<Scalars["Boolean"]>;
  job_company_website?: InputMaybe<Scalars["String"]>;
  job_last_updated?: InputMaybe<Scalars["Boolean"]>;
  job_start_date?: InputMaybe<Scalars["Boolean"]>;
  job_title?: InputMaybe<Scalars["String"]>;
  job_title_levels?: InputMaybe<Scalars["jsonb"]>;
  job_title_role?: InputMaybe<Scalars["String"]>;
  job_title_sub_role?: InputMaybe<Scalars["String"]>;
  last_initial?: InputMaybe<Scalars["Boolean"]>;
  last_name?: InputMaybe<Scalars["Boolean"]>;
  linkedin_id?: InputMaybe<Scalars["Boolean"]>;
  linkedin_url?: InputMaybe<Scalars["String"]>;
  linkedin_username?: InputMaybe<Scalars["Boolean"]>;
  location_address_line_2?: InputMaybe<Scalars["Boolean"]>;
  location_continent?: InputMaybe<Scalars["Boolean"]>;
  location_country?: InputMaybe<Scalars["Boolean"]>;
  location_geo?: InputMaybe<Scalars["Boolean"]>;
  location_last_updated?: InputMaybe<Scalars["Boolean"]>;
  location_locality?: InputMaybe<Scalars["Boolean"]>;
  location_metro?: InputMaybe<Scalars["Boolean"]>;
  location_name?: InputMaybe<Scalars["String"]>;
  location_names?: InputMaybe<Scalars["Boolean"]>;
  location_postal_code?: InputMaybe<Scalars["Boolean"]>;
  location_region?: InputMaybe<Scalars["Boolean"]>;
  location_street_address?: InputMaybe<Scalars["Boolean"]>;
  middle_initial?: InputMaybe<Scalars["Boolean"]>;
  middle_name?: InputMaybe<Scalars["Boolean"]>;
  mobile_phone?: InputMaybe<Scalars["Boolean"]>;
  personal_emails?: InputMaybe<Scalars["Boolean"]>;
  phone_numbers?: InputMaybe<Scalars["Boolean"]>;
  profiles?: InputMaybe<Scalars["Boolean"]>;
  regions?: InputMaybe<Scalars["Boolean"]>;
  revtron_user_id?: InputMaybe<Scalars["uuid"]>;
  skills?: InputMaybe<Scalars["Boolean"]>;
  street_addresses?: InputMaybe<Scalars["Boolean"]>;
  twitter_url?: InputMaybe<Scalars["Boolean"]>;
  twitter_username?: InputMaybe<Scalars["Boolean"]>;
  updated_at?: InputMaybe<Scalars["timestamptz"]>;
  version_status?: InputMaybe<Scalars["jsonb"]>;
  work_email?: InputMaybe<Scalars["Boolean"]>;
};

/** update columns of table "pdl_people_preview" */
export enum pdl_people_preview_update_column {
  /** column name */
  birth_date = "birth_date",
  /** column name */
  birth_year = "birth_year",
  /** column name */
  countries = "countries",
  /** column name */
  created_at = "created_at",
  /** column name */
  crm_account_id = "crm_account_id",
  /** column name */
  education = "education",
  /** column name */
  emails = "emails",
  /** column name */
  experience = "experience",
  /** column name */
  facebook_id = "facebook_id",
  /** column name */
  facebook_url = "facebook_url",
  /** column name */
  facebook_username = "facebook_username",
  /** column name */
  first_name = "first_name",
  /** column name */
  full_name = "full_name",
  /** column name */
  gender = "gender",
  /** column name */
  github_url = "github_url",
  /** column name */
  github_username = "github_username",
  /** column name */
  id = "id",
  /** column name */
  industry = "industry",
  /** column name */
  interests = "interests",
  /** column name */
  job_company_facebook_url = "job_company_facebook_url",
  /** column name */
  job_company_founded = "job_company_founded",
  /** column name */
  job_company_id = "job_company_id",
  /** column name */
  job_company_industry = "job_company_industry",
  /** column name */
  job_company_linkedin_id = "job_company_linkedin_id",
  /** column name */
  job_company_linkedin_url = "job_company_linkedin_url",
  /** column name */
  job_company_location_address_line_2 = "job_company_location_address_line_2",
  /** column name */
  job_company_location_continent = "job_company_location_continent",
  /** column name */
  job_company_location_country = "job_company_location_country",
  /** column name */
  job_company_location_geo = "job_company_location_geo",
  /** column name */
  job_company_location_locality = "job_company_location_locality",
  /** column name */
  job_company_location_metro = "job_company_location_metro",
  /** column name */
  job_company_location_name = "job_company_location_name",
  /** column name */
  job_company_location_postal_code = "job_company_location_postal_code",
  /** column name */
  job_company_location_region = "job_company_location_region",
  /** column name */
  job_company_location_street_address = "job_company_location_street_address",
  /** column name */
  job_company_name = "job_company_name",
  /** column name */
  job_company_size = "job_company_size",
  /** column name */
  job_company_twitter_url = "job_company_twitter_url",
  /** column name */
  job_company_website = "job_company_website",
  /** column name */
  job_last_updated = "job_last_updated",
  /** column name */
  job_start_date = "job_start_date",
  /** column name */
  job_title = "job_title",
  /** column name */
  job_title_levels = "job_title_levels",
  /** column name */
  job_title_role = "job_title_role",
  /** column name */
  job_title_sub_role = "job_title_sub_role",
  /** column name */
  last_initial = "last_initial",
  /** column name */
  last_name = "last_name",
  /** column name */
  linkedin_id = "linkedin_id",
  /** column name */
  linkedin_url = "linkedin_url",
  /** column name */
  linkedin_username = "linkedin_username",
  /** column name */
  location_address_line_2 = "location_address_line_2",
  /** column name */
  location_continent = "location_continent",
  /** column name */
  location_country = "location_country",
  /** column name */
  location_geo = "location_geo",
  /** column name */
  location_last_updated = "location_last_updated",
  /** column name */
  location_locality = "location_locality",
  /** column name */
  location_metro = "location_metro",
  /** column name */
  location_name = "location_name",
  /** column name */
  location_names = "location_names",
  /** column name */
  location_postal_code = "location_postal_code",
  /** column name */
  location_region = "location_region",
  /** column name */
  location_street_address = "location_street_address",
  /** column name */
  middle_initial = "middle_initial",
  /** column name */
  middle_name = "middle_name",
  /** column name */
  mobile_phone = "mobile_phone",
  /** column name */
  personal_emails = "personal_emails",
  /** column name */
  phone_numbers = "phone_numbers",
  /** column name */
  profiles = "profiles",
  /** column name */
  regions = "regions",
  /** column name */
  revtron_user_id = "revtron_user_id",
  /** column name */
  skills = "skills",
  /** column name */
  street_addresses = "street_addresses",
  /** column name */
  twitter_url = "twitter_url",
  /** column name */
  twitter_username = "twitter_username",
  /** column name */
  updated_at = "updated_at",
  /** column name */
  version_status = "version_status",
  /** column name */
  work_email = "work_email",
}

export type pdl_people_preview_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<pdl_people_preview_append_input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<pdl_people_preview_delete_at_path_input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<pdl_people_preview_delete_elem_input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<pdl_people_preview_delete_key_input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<pdl_people_preview_prepend_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<pdl_people_preview_set_input>;
  where: pdl_people_preview_bool_exp;
};

/** Boolean expression to filter rows from the table "pipeline_activity_drill_down_gql". All fields are combined with a logical 'AND'. */
export type pipeline_activity_drill_down_gql_bool_exp = {
  _and?: InputMaybe<Array<pipeline_activity_drill_down_gql_bool_exp>>;
  _not?: InputMaybe<pipeline_activity_drill_down_gql_bool_exp>;
  _or?: InputMaybe<Array<pipeline_activity_drill_down_gql_bool_exp>>;
  account_id?: InputMaybe<String_comparison_exp>;
  account_name?: InputMaybe<String_comparison_exp>;
  contact_id?: InputMaybe<String_comparison_exp>;
  contact_name?: InputMaybe<String_comparison_exp>;
  contact_title?: InputMaybe<String_comparison_exp>;
  createddate?: InputMaybe<timestamp_comparison_exp>;
  description?: InputMaybe<String_comparison_exp>;
  subject?: InputMaybe<String_comparison_exp>;
  task_id?: InputMaybe<String_comparison_exp>;
  tasksubtype?: InputMaybe<String_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
  user_name?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "pipeline_activity_drill_down_gql". */
export type pipeline_activity_drill_down_gql_order_by = {
  account_id?: InputMaybe<order_by>;
  account_name?: InputMaybe<order_by>;
  contact_id?: InputMaybe<order_by>;
  contact_name?: InputMaybe<order_by>;
  contact_title?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  subject?: InputMaybe<order_by>;
  task_id?: InputMaybe<order_by>;
  tasksubtype?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
  user_name?: InputMaybe<order_by>;
};

/** select columns of table "pipeline_activity_drill_down_gql" */
export enum pipeline_activity_drill_down_gql_select_column {
  /** column name */
  account_id = "account_id",
  /** column name */
  account_name = "account_name",
  /** column name */
  contact_id = "contact_id",
  /** column name */
  contact_name = "contact_name",
  /** column name */
  contact_title = "contact_title",
  /** column name */
  createddate = "createddate",
  /** column name */
  description = "description",
  /** column name */
  subject = "subject",
  /** column name */
  task_id = "task_id",
  /** column name */
  tasksubtype = "tasksubtype",
  /** column name */
  type = "type",
  /** column name */
  user_name = "user_name",
}

/** Streaming cursor of the table "pipeline_activity_drill_down_gql" */
export type pipeline_activity_drill_down_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: pipeline_activity_drill_down_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type pipeline_activity_drill_down_gql_stream_cursor_value_input = {
  account_id?: InputMaybe<Scalars["String"]>;
  account_name?: InputMaybe<Scalars["String"]>;
  contact_id?: InputMaybe<Scalars["String"]>;
  contact_name?: InputMaybe<Scalars["String"]>;
  contact_title?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  description?: InputMaybe<Scalars["String"]>;
  subject?: InputMaybe<Scalars["String"]>;
  task_id?: InputMaybe<Scalars["String"]>;
  tasksubtype?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Scalars["String"]>;
  user_name?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "pipeline_opp_detail_gql". All fields are combined with a logical 'AND'. */
export type pipeline_opp_detail_gql_bool_exp = {
  _and?: InputMaybe<Array<pipeline_opp_detail_gql_bool_exp>>;
  _not?: InputMaybe<pipeline_opp_detail_gql_bool_exp>;
  _or?: InputMaybe<Array<pipeline_opp_detail_gql_bool_exp>>;
  account_id?: InputMaybe<String_comparison_exp>;
  account_name?: InputMaybe<String_comparison_exp>;
  amount?: InputMaybe<float8_comparison_exp>;
  closedate?: InputMaybe<timestamp_comparison_exp>;
  createddate?: InputMaybe<timestamp_comparison_exp>;
  email?: InputMaybe<String_comparison_exp>;
  forecast_category?: InputMaybe<String_comparison_exp>;
  isclosed?: InputMaybe<Boolean_comparison_exp>;
  iswon?: InputMaybe<Boolean_comparison_exp>;
  leadsource?: InputMaybe<String_comparison_exp>;
  opportunity_id?: InputMaybe<String_comparison_exp>;
  opportunity_link?: InputMaybe<String_comparison_exp>;
  opportunity_name?: InputMaybe<String_comparison_exp>;
  opportunity_owner?: InputMaybe<String_comparison_exp>;
  ownerid?: InputMaybe<String_comparison_exp>;
  probability?: InputMaybe<numeric_comparison_exp>;
  services_amount?: InputMaybe<numeric_comparison_exp>;
  stage?: InputMaybe<String_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "pipeline_opp_detail_gql". */
export type pipeline_opp_detail_gql_order_by = {
  account_id?: InputMaybe<order_by>;
  account_name?: InputMaybe<order_by>;
  amount?: InputMaybe<order_by>;
  closedate?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  forecast_category?: InputMaybe<order_by>;
  isclosed?: InputMaybe<order_by>;
  iswon?: InputMaybe<order_by>;
  leadsource?: InputMaybe<order_by>;
  opportunity_id?: InputMaybe<order_by>;
  opportunity_link?: InputMaybe<order_by>;
  opportunity_name?: InputMaybe<order_by>;
  opportunity_owner?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  probability?: InputMaybe<order_by>;
  services_amount?: InputMaybe<order_by>;
  stage?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
};

/** select columns of table "pipeline_opp_detail_gql" */
export enum pipeline_opp_detail_gql_select_column {
  /** column name */
  account_id = "account_id",
  /** column name */
  account_name = "account_name",
  /** column name */
  amount = "amount",
  /** column name */
  closedate = "closedate",
  /** column name */
  createddate = "createddate",
  /** column name */
  email = "email",
  /** column name */
  forecast_category = "forecast_category",
  /** column name */
  isclosed = "isclosed",
  /** column name */
  iswon = "iswon",
  /** column name */
  leadsource = "leadsource",
  /** column name */
  opportunity_id = "opportunity_id",
  /** column name */
  opportunity_link = "opportunity_link",
  /** column name */
  opportunity_name = "opportunity_name",
  /** column name */
  opportunity_owner = "opportunity_owner",
  /** column name */
  ownerid = "ownerid",
  /** column name */
  probability = "probability",
  /** column name */
  services_amount = "services_amount",
  /** column name */
  stage = "stage",
  /** column name */
  type = "type",
}

/** Streaming cursor of the table "pipeline_opp_detail_gql" */
export type pipeline_opp_detail_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: pipeline_opp_detail_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type pipeline_opp_detail_gql_stream_cursor_value_input = {
  account_id?: InputMaybe<Scalars["String"]>;
  account_name?: InputMaybe<Scalars["String"]>;
  amount?: InputMaybe<Scalars["float8"]>;
  closedate?: InputMaybe<Scalars["timestamp"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  email?: InputMaybe<Scalars["String"]>;
  forecast_category?: InputMaybe<Scalars["String"]>;
  isclosed?: InputMaybe<Scalars["Boolean"]>;
  iswon?: InputMaybe<Scalars["Boolean"]>;
  leadsource?: InputMaybe<Scalars["String"]>;
  opportunity_id?: InputMaybe<Scalars["String"]>;
  opportunity_link?: InputMaybe<Scalars["String"]>;
  opportunity_name?: InputMaybe<Scalars["String"]>;
  opportunity_owner?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  probability?: InputMaybe<Scalars["numeric"]>;
  services_amount?: InputMaybe<Scalars["numeric"]>;
  stage?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "pipeline_opp_detail_ml_gql". All fields are combined with a logical 'AND'. */
export type pipeline_opp_detail_ml_gql_bool_exp = {
  _and?: InputMaybe<Array<pipeline_opp_detail_ml_gql_bool_exp>>;
  _not?: InputMaybe<pipeline_opp_detail_ml_gql_bool_exp>;
  _or?: InputMaybe<Array<pipeline_opp_detail_ml_gql_bool_exp>>;
  account_id?: InputMaybe<String_comparison_exp>;
  account_key?: InputMaybe<bigint_comparison_exp>;
  account_name?: InputMaybe<String_comparison_exp>;
  amount?: InputMaybe<float8_comparison_exp>;
  closedate?: InputMaybe<timestamp_comparison_exp>;
  coalesce?: InputMaybe<float8_comparison_exp>;
  createddate?: InputMaybe<timestamp_comparison_exp>;
  custom_filter_1?: InputMaybe<String_comparison_exp>;
  email?: InputMaybe<String_comparison_exp>;
  forecast_category?: InputMaybe<String_comparison_exp>;
  isclosed?: InputMaybe<Boolean_comparison_exp>;
  iswon?: InputMaybe<Boolean_comparison_exp>;
  leadsource?: InputMaybe<String_comparison_exp>;
  ml_last_scored_at?: InputMaybe<timestamp_comparison_exp>;
  ml_probability?: InputMaybe<float8_comparison_exp>;
  ml_weighted_arr?: InputMaybe<float8_comparison_exp>;
  ml_weighted_services?: InputMaybe<float8_comparison_exp>;
  opportunity_age?: InputMaybe<float8_comparison_exp>;
  opportunity_id?: InputMaybe<String_comparison_exp>;
  opportunity_link?: InputMaybe<String_comparison_exp>;
  opportunity_name?: InputMaybe<String_comparison_exp>;
  opportunity_owner?: InputMaybe<String_comparison_exp>;
  ownerid?: InputMaybe<String_comparison_exp>;
  probability?: InputMaybe<numeric_comparison_exp>;
  services_amount?: InputMaybe<numeric_comparison_exp>;
  stage?: InputMaybe<String_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "pipeline_opp_detail_ml_gql". */
export type pipeline_opp_detail_ml_gql_order_by = {
  account_id?: InputMaybe<order_by>;
  account_key?: InputMaybe<order_by>;
  account_name?: InputMaybe<order_by>;
  amount?: InputMaybe<order_by>;
  closedate?: InputMaybe<order_by>;
  coalesce?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  custom_filter_1?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  forecast_category?: InputMaybe<order_by>;
  isclosed?: InputMaybe<order_by>;
  iswon?: InputMaybe<order_by>;
  leadsource?: InputMaybe<order_by>;
  ml_last_scored_at?: InputMaybe<order_by>;
  ml_probability?: InputMaybe<order_by>;
  ml_weighted_arr?: InputMaybe<order_by>;
  ml_weighted_services?: InputMaybe<order_by>;
  opportunity_age?: InputMaybe<order_by>;
  opportunity_id?: InputMaybe<order_by>;
  opportunity_link?: InputMaybe<order_by>;
  opportunity_name?: InputMaybe<order_by>;
  opportunity_owner?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  probability?: InputMaybe<order_by>;
  services_amount?: InputMaybe<order_by>;
  stage?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
};

/** select columns of table "pipeline_opp_detail_ml_gql" */
export enum pipeline_opp_detail_ml_gql_select_column {
  /** column name */
  account_id = "account_id",
  /** column name */
  account_key = "account_key",
  /** column name */
  account_name = "account_name",
  /** column name */
  amount = "amount",
  /** column name */
  closedate = "closedate",
  /** column name */
  coalesce = "coalesce",
  /** column name */
  createddate = "createddate",
  /** column name */
  custom_filter_1 = "custom_filter_1",
  /** column name */
  email = "email",
  /** column name */
  forecast_category = "forecast_category",
  /** column name */
  isclosed = "isclosed",
  /** column name */
  iswon = "iswon",
  /** column name */
  leadsource = "leadsource",
  /** column name */
  ml_last_scored_at = "ml_last_scored_at",
  /** column name */
  ml_probability = "ml_probability",
  /** column name */
  ml_weighted_arr = "ml_weighted_arr",
  /** column name */
  ml_weighted_services = "ml_weighted_services",
  /** column name */
  opportunity_age = "opportunity_age",
  /** column name */
  opportunity_id = "opportunity_id",
  /** column name */
  opportunity_link = "opportunity_link",
  /** column name */
  opportunity_name = "opportunity_name",
  /** column name */
  opportunity_owner = "opportunity_owner",
  /** column name */
  ownerid = "ownerid",
  /** column name */
  probability = "probability",
  /** column name */
  services_amount = "services_amount",
  /** column name */
  stage = "stage",
  /** column name */
  type = "type",
}

/** Streaming cursor of the table "pipeline_opp_detail_ml_gql" */
export type pipeline_opp_detail_ml_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: pipeline_opp_detail_ml_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type pipeline_opp_detail_ml_gql_stream_cursor_value_input = {
  account_id?: InputMaybe<Scalars["String"]>;
  account_key?: InputMaybe<Scalars["bigint"]>;
  account_name?: InputMaybe<Scalars["String"]>;
  amount?: InputMaybe<Scalars["float8"]>;
  closedate?: InputMaybe<Scalars["timestamp"]>;
  coalesce?: InputMaybe<Scalars["float8"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  custom_filter_1?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["String"]>;
  forecast_category?: InputMaybe<Scalars["String"]>;
  isclosed?: InputMaybe<Scalars["Boolean"]>;
  iswon?: InputMaybe<Scalars["Boolean"]>;
  leadsource?: InputMaybe<Scalars["String"]>;
  ml_last_scored_at?: InputMaybe<Scalars["timestamp"]>;
  ml_probability?: InputMaybe<Scalars["float8"]>;
  ml_weighted_arr?: InputMaybe<Scalars["float8"]>;
  ml_weighted_services?: InputMaybe<Scalars["float8"]>;
  opportunity_age?: InputMaybe<Scalars["float8"]>;
  opportunity_id?: InputMaybe<Scalars["String"]>;
  opportunity_link?: InputMaybe<Scalars["String"]>;
  opportunity_name?: InputMaybe<Scalars["String"]>;
  opportunity_owner?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  probability?: InputMaybe<Scalars["numeric"]>;
  services_amount?: InputMaybe<Scalars["numeric"]>;
  stage?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Scalars["String"]>;
};

export type revtron_companies_aggregate_bool_exp = {
  count?: InputMaybe<revtron_companies_aggregate_bool_exp_count>;
};

export type revtron_companies_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<revtron_companies_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<revtron_companies_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "revtron_companies" */
export type revtron_companies_aggregate_order_by = {
  avg?: InputMaybe<revtron_companies_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<revtron_companies_max_order_by>;
  min?: InputMaybe<revtron_companies_min_order_by>;
  stddev?: InputMaybe<revtron_companies_stddev_order_by>;
  stddev_pop?: InputMaybe<revtron_companies_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<revtron_companies_stddev_samp_order_by>;
  sum?: InputMaybe<revtron_companies_sum_order_by>;
  var_pop?: InputMaybe<revtron_companies_var_pop_order_by>;
  var_samp?: InputMaybe<revtron_companies_var_samp_order_by>;
  variance?: InputMaybe<revtron_companies_variance_order_by>;
};

/** order by avg() on columns of table "revtron_companies" */
export type revtron_companies_avg_order_by = {
  employee_counts?: InputMaybe<order_by>;
  founded_year?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  naics?: InputMaybe<order_by>;
  revenue?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "revtron_companies". All fields are combined with a logical 'AND'. */
export type revtron_companies_bool_exp = {
  _and?: InputMaybe<Array<revtron_companies_bool_exp>>;
  _not?: InputMaybe<revtron_companies_bool_exp>;
  _or?: InputMaybe<Array<revtron_companies_bool_exp>>;
  address?: InputMaybe<String_comparison_exp>;
  city?: InputMaybe<String_comparison_exp>;
  country?: InputMaybe<String_comparison_exp>;
  created_at?: InputMaybe<timestamp_comparison_exp>;
  employee_counts?: InputMaybe<bigint_comparison_exp>;
  founded_year?: InputMaybe<Int_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  industry?: InputMaybe<String_comparison_exp>;
  linkedin?: InputMaybe<String_comparison_exp>;
  naics?: InputMaybe<Int_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  natural_name?: InputMaybe<String_comparison_exp>;
  phone?: InputMaybe<String_comparison_exp>;
  revenue?: InputMaybe<bigint_comparison_exp>;
  state?: InputMaybe<String_comparison_exp>;
  sub_industry?: InputMaybe<String_comparison_exp>;
  tags?: InputMaybe<String_comparison_exp>;
  ticker?: InputMaybe<String_comparison_exp>;
  to_crm_accounts?: InputMaybe<crm_to_revtron_account_bool_exp>;
  to_crm_accounts_aggregate?: InputMaybe<crm_to_revtron_account_aggregate_bool_exp>;
  to_icp_score?: InputMaybe<ml_icp_predictions_bool_exp>;
  to_icp_score_aggregate?: InputMaybe<ml_icp_predictions_aggregate_bool_exp>;
  to_send_to_crm_events?: InputMaybe<send_to_crm_events_bool_exp>;
  to_send_to_crm_events_aggregate?: InputMaybe<send_to_crm_events_aggregate_bool_exp>;
  type?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamp_comparison_exp>;
  website?: InputMaybe<String_comparison_exp>;
  zip_code?: InputMaybe<String_comparison_exp>;
};

/** Boolean expression to filter rows from the table "revtron_companies". All fields are combined with a logical 'AND'. */
export type revtron_companies_bool_exp_remote_rel_crm_to_revtron_accountto_revtron_companies =
  {
    _and?: InputMaybe<Array<_revtron_companies_bool_exp>>;
    _not?: InputMaybe<_revtron_companies_bool_exp>;
    _or?: InputMaybe<Array<_revtron_companies_bool_exp>>;
    address?: InputMaybe<_String_comparison_exp>;
    city?: InputMaybe<_String_comparison_exp>;
    country?: InputMaybe<_String_comparison_exp>;
    created_at?: InputMaybe<_timestamp_comparison_exp>;
    employee_counts?: InputMaybe<_bigint_comparison_exp>;
    founded_year?: InputMaybe<_Int_comparison_exp>;
    id?: InputMaybe<Int_comparison_exp_remote_rel_crm_to_revtron_accountto_revtron_companies>;
    industry?: InputMaybe<_String_comparison_exp>;
    linkedin?: InputMaybe<_String_comparison_exp>;
    naics?: InputMaybe<_Int_comparison_exp>;
    name?: InputMaybe<_String_comparison_exp>;
    natural_name?: InputMaybe<_String_comparison_exp>;
    phone?: InputMaybe<_String_comparison_exp>;
    revenue?: InputMaybe<_bigint_comparison_exp>;
    state?: InputMaybe<_String_comparison_exp>;
    sub_industry?: InputMaybe<_String_comparison_exp>;
    tags?: InputMaybe<_String_comparison_exp>;
    ticker?: InputMaybe<_String_comparison_exp>;
    type?: InputMaybe<_String_comparison_exp>;
    updated_at?: InputMaybe<_timestamp_comparison_exp>;
    website?: InputMaybe<_String_comparison_exp>;
    zip_code?: InputMaybe<_String_comparison_exp>;
  };

/** Boolean expression to filter rows from the table "revtron_companies". All fields are combined with a logical 'AND'. */
export type revtron_companies_bool_exp_remote_rel_ml_icp_last_predictionto_revtron =
  {
    _and?: InputMaybe<Array<_revtron_companies_bool_exp>>;
    _not?: InputMaybe<_revtron_companies_bool_exp>;
    _or?: InputMaybe<Array<_revtron_companies_bool_exp>>;
    address?: InputMaybe<_String_comparison_exp>;
    city?: InputMaybe<_String_comparison_exp>;
    country?: InputMaybe<_String_comparison_exp>;
    created_at?: InputMaybe<_timestamp_comparison_exp>;
    employee_counts?: InputMaybe<_bigint_comparison_exp>;
    founded_year?: InputMaybe<_Int_comparison_exp>;
    id?: InputMaybe<Int_comparison_exp_remote_rel_ml_icp_last_predictionto_revtron>;
    industry?: InputMaybe<_String_comparison_exp>;
    linkedin?: InputMaybe<_String_comparison_exp>;
    naics?: InputMaybe<_Int_comparison_exp>;
    name?: InputMaybe<_String_comparison_exp>;
    natural_name?: InputMaybe<_String_comparison_exp>;
    phone?: InputMaybe<_String_comparison_exp>;
    revenue?: InputMaybe<_bigint_comparison_exp>;
    state?: InputMaybe<_String_comparison_exp>;
    sub_industry?: InputMaybe<_String_comparison_exp>;
    tags?: InputMaybe<_String_comparison_exp>;
    ticker?: InputMaybe<_String_comparison_exp>;
    type?: InputMaybe<_String_comparison_exp>;
    updated_at?: InputMaybe<_timestamp_comparison_exp>;
    website?: InputMaybe<_String_comparison_exp>;
    zip_code?: InputMaybe<_String_comparison_exp>;
  };

/** unique or primary key constraints on table "revtron_companies" */
export enum revtron_companies_constraint {
  /** unique or primary key constraint on columns "id" */
  revtron_companies_pkey = "revtron_companies_pkey",
  /** unique or primary key constraint on columns "website" */
  revtron_companies_website_key = "revtron_companies_website_key",
}

/** input type for incrementing numeric columns in table "revtron_companies" */
export type revtron_companies_inc_input = {
  employee_counts?: InputMaybe<Scalars["bigint"]>;
  founded_year?: InputMaybe<Scalars["Int"]>;
  id?: InputMaybe<Scalars["Int"]>;
  naics?: InputMaybe<Scalars["Int"]>;
  revenue?: InputMaybe<Scalars["bigint"]>;
};

/** input type for inserting data into table "revtron_companies" */
export type revtron_companies_insert_input = {
  address?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  created_at?: InputMaybe<Scalars["timestamp"]>;
  employee_counts?: InputMaybe<Scalars["bigint"]>;
  founded_year?: InputMaybe<Scalars["Int"]>;
  id?: InputMaybe<Scalars["Int"]>;
  industry?: InputMaybe<Scalars["String"]>;
  linkedin?: InputMaybe<Scalars["String"]>;
  naics?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
  natural_name?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  revenue?: InputMaybe<Scalars["bigint"]>;
  state?: InputMaybe<Scalars["String"]>;
  sub_industry?: InputMaybe<Scalars["String"]>;
  tags?: InputMaybe<Scalars["String"]>;
  ticker?: InputMaybe<Scalars["String"]>;
  to_crm_accounts?: InputMaybe<crm_to_revtron_account_arr_rel_insert_input>;
  to_icp_score?: InputMaybe<ml_icp_predictions_arr_rel_insert_input>;
  to_send_to_crm_events?: InputMaybe<send_to_crm_events_arr_rel_insert_input>;
  type?: InputMaybe<Scalars["String"]>;
  updated_at?: InputMaybe<Scalars["timestamp"]>;
  website?: InputMaybe<Scalars["String"]>;
  zip_code?: InputMaybe<Scalars["String"]>;
};

/** order by max() on columns of table "revtron_companies" */
export type revtron_companies_max_order_by = {
  address?: InputMaybe<order_by>;
  city?: InputMaybe<order_by>;
  country?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  employee_counts?: InputMaybe<order_by>;
  founded_year?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  industry?: InputMaybe<order_by>;
  linkedin?: InputMaybe<order_by>;
  naics?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  natural_name?: InputMaybe<order_by>;
  phone?: InputMaybe<order_by>;
  revenue?: InputMaybe<order_by>;
  state?: InputMaybe<order_by>;
  sub_industry?: InputMaybe<order_by>;
  tags?: InputMaybe<order_by>;
  ticker?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  website?: InputMaybe<order_by>;
  zip_code?: InputMaybe<order_by>;
};

/** order by min() on columns of table "revtron_companies" */
export type revtron_companies_min_order_by = {
  address?: InputMaybe<order_by>;
  city?: InputMaybe<order_by>;
  country?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  employee_counts?: InputMaybe<order_by>;
  founded_year?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  industry?: InputMaybe<order_by>;
  linkedin?: InputMaybe<order_by>;
  naics?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  natural_name?: InputMaybe<order_by>;
  phone?: InputMaybe<order_by>;
  revenue?: InputMaybe<order_by>;
  state?: InputMaybe<order_by>;
  sub_industry?: InputMaybe<order_by>;
  tags?: InputMaybe<order_by>;
  ticker?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  website?: InputMaybe<order_by>;
  zip_code?: InputMaybe<order_by>;
};

/** on_conflict condition type for table "revtron_companies" */
export type revtron_companies_on_conflict = {
  constraint: revtron_companies_constraint;
  update_columns?: Array<revtron_companies_update_column>;
  where?: InputMaybe<revtron_companies_bool_exp>;
};

/** Ordering options when selecting data from "revtron_companies". */
export type revtron_companies_order_by = {
  address?: InputMaybe<order_by>;
  city?: InputMaybe<order_by>;
  country?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  employee_counts?: InputMaybe<order_by>;
  founded_year?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  industry?: InputMaybe<order_by>;
  linkedin?: InputMaybe<order_by>;
  naics?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  natural_name?: InputMaybe<order_by>;
  phone?: InputMaybe<order_by>;
  revenue?: InputMaybe<order_by>;
  state?: InputMaybe<order_by>;
  sub_industry?: InputMaybe<order_by>;
  tags?: InputMaybe<order_by>;
  ticker?: InputMaybe<order_by>;
  to_crm_accounts_aggregate?: InputMaybe<crm_to_revtron_account_aggregate_order_by>;
  to_icp_score_aggregate?: InputMaybe<ml_icp_predictions_aggregate_order_by>;
  to_send_to_crm_events_aggregate?: InputMaybe<send_to_crm_events_aggregate_order_by>;
  type?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  website?: InputMaybe<order_by>;
  zip_code?: InputMaybe<order_by>;
};

/** primary key columns input for table: revtron_companies */
export type revtron_companies_pk_columns_input = {
  id: Scalars["Int"];
};

/** select columns of table "revtron_companies" */
export enum revtron_companies_select_column {
  /** column name */
  address = "address",
  /** column name */
  city = "city",
  /** column name */
  country = "country",
  /** column name */
  created_at = "created_at",
  /** column name */
  employee_counts = "employee_counts",
  /** column name */
  founded_year = "founded_year",
  /** column name */
  id = "id",
  /** column name */
  industry = "industry",
  /** column name */
  linkedin = "linkedin",
  /** column name */
  naics = "naics",
  /** column name */
  name = "name",
  /** column name */
  natural_name = "natural_name",
  /** column name */
  phone = "phone",
  /** column name */
  revenue = "revenue",
  /** column name */
  state = "state",
  /** column name */
  sub_industry = "sub_industry",
  /** column name */
  tags = "tags",
  /** column name */
  ticker = "ticker",
  /** column name */
  type = "type",
  /** column name */
  updated_at = "updated_at",
  /** column name */
  website = "website",
  /** column name */
  zip_code = "zip_code",
}

/** input type for updating data in table "revtron_companies" */
export type revtron_companies_set_input = {
  address?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  created_at?: InputMaybe<Scalars["timestamp"]>;
  employee_counts?: InputMaybe<Scalars["bigint"]>;
  founded_year?: InputMaybe<Scalars["Int"]>;
  id?: InputMaybe<Scalars["Int"]>;
  industry?: InputMaybe<Scalars["String"]>;
  linkedin?: InputMaybe<Scalars["String"]>;
  naics?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
  natural_name?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  revenue?: InputMaybe<Scalars["bigint"]>;
  state?: InputMaybe<Scalars["String"]>;
  sub_industry?: InputMaybe<Scalars["String"]>;
  tags?: InputMaybe<Scalars["String"]>;
  ticker?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Scalars["String"]>;
  updated_at?: InputMaybe<Scalars["timestamp"]>;
  website?: InputMaybe<Scalars["String"]>;
  zip_code?: InputMaybe<Scalars["String"]>;
};

/** order by stddev() on columns of table "revtron_companies" */
export type revtron_companies_stddev_order_by = {
  employee_counts?: InputMaybe<order_by>;
  founded_year?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  naics?: InputMaybe<order_by>;
  revenue?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "revtron_companies" */
export type revtron_companies_stddev_pop_order_by = {
  employee_counts?: InputMaybe<order_by>;
  founded_year?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  naics?: InputMaybe<order_by>;
  revenue?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "revtron_companies" */
export type revtron_companies_stddev_samp_order_by = {
  employee_counts?: InputMaybe<order_by>;
  founded_year?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  naics?: InputMaybe<order_by>;
  revenue?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "revtron_companies" */
export type revtron_companies_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: revtron_companies_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type revtron_companies_stream_cursor_value_input = {
  address?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  created_at?: InputMaybe<Scalars["timestamp"]>;
  employee_counts?: InputMaybe<Scalars["bigint"]>;
  founded_year?: InputMaybe<Scalars["Int"]>;
  id?: InputMaybe<Scalars["Int"]>;
  industry?: InputMaybe<Scalars["String"]>;
  linkedin?: InputMaybe<Scalars["String"]>;
  naics?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
  natural_name?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  revenue?: InputMaybe<Scalars["bigint"]>;
  state?: InputMaybe<Scalars["String"]>;
  sub_industry?: InputMaybe<Scalars["String"]>;
  tags?: InputMaybe<Scalars["String"]>;
  ticker?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Scalars["String"]>;
  updated_at?: InputMaybe<Scalars["timestamp"]>;
  website?: InputMaybe<Scalars["String"]>;
  zip_code?: InputMaybe<Scalars["String"]>;
};

/** order by sum() on columns of table "revtron_companies" */
export type revtron_companies_sum_order_by = {
  employee_counts?: InputMaybe<order_by>;
  founded_year?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  naics?: InputMaybe<order_by>;
  revenue?: InputMaybe<order_by>;
};

/** update columns of table "revtron_companies" */
export enum revtron_companies_update_column {
  /** column name */
  address = "address",
  /** column name */
  city = "city",
  /** column name */
  country = "country",
  /** column name */
  created_at = "created_at",
  /** column name */
  employee_counts = "employee_counts",
  /** column name */
  founded_year = "founded_year",
  /** column name */
  id = "id",
  /** column name */
  industry = "industry",
  /** column name */
  linkedin = "linkedin",
  /** column name */
  naics = "naics",
  /** column name */
  name = "name",
  /** column name */
  natural_name = "natural_name",
  /** column name */
  phone = "phone",
  /** column name */
  revenue = "revenue",
  /** column name */
  state = "state",
  /** column name */
  sub_industry = "sub_industry",
  /** column name */
  tags = "tags",
  /** column name */
  ticker = "ticker",
  /** column name */
  type = "type",
  /** column name */
  updated_at = "updated_at",
  /** column name */
  website = "website",
  /** column name */
  zip_code = "zip_code",
}

export type revtron_companies_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<revtron_companies_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<revtron_companies_set_input>;
  where: revtron_companies_bool_exp;
};

/** order by var_pop() on columns of table "revtron_companies" */
export type revtron_companies_var_pop_order_by = {
  employee_counts?: InputMaybe<order_by>;
  founded_year?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  naics?: InputMaybe<order_by>;
  revenue?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "revtron_companies" */
export type revtron_companies_var_samp_order_by = {
  employee_counts?: InputMaybe<order_by>;
  founded_year?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  naics?: InputMaybe<order_by>;
  revenue?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "revtron_companies" */
export type revtron_companies_variance_order_by = {
  employee_counts?: InputMaybe<order_by>;
  founded_year?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  naics?: InputMaybe<order_by>;
  revenue?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "revtron_reporting_bookings_by_channel_gql". All fields are combined with a logical 'AND'. */
export type revtron_reporting_bookings_by_channel_gql_bool_exp = {
  _and?: InputMaybe<Array<revtron_reporting_bookings_by_channel_gql_bool_exp>>;
  _not?: InputMaybe<revtron_reporting_bookings_by_channel_gql_bool_exp>;
  _or?: InputMaybe<Array<revtron_reporting_bookings_by_channel_gql_bool_exp>>;
  avg_cycle_times_wins?: InputMaybe<float8_comparison_exp>;
  avg_deal_size_wins?: InputMaybe<numeric_comparison_exp>;
  lead_channel?: InputMaybe<String_comparison_exp>;
  losses?: InputMaybe<bigint_comparison_exp>;
  total_opps?: InputMaybe<bigint_comparison_exp>;
  total_won_revenue?: InputMaybe<numeric_comparison_exp>;
  wins?: InputMaybe<bigint_comparison_exp>;
};

/** Ordering options when selecting data from "revtron_reporting_bookings_by_channel_gql". */
export type revtron_reporting_bookings_by_channel_gql_order_by = {
  avg_cycle_times_wins?: InputMaybe<order_by>;
  avg_deal_size_wins?: InputMaybe<order_by>;
  lead_channel?: InputMaybe<order_by>;
  losses?: InputMaybe<order_by>;
  total_opps?: InputMaybe<order_by>;
  total_won_revenue?: InputMaybe<order_by>;
  wins?: InputMaybe<order_by>;
};

/** select columns of table "revtron_reporting_bookings_by_channel_gql" */
export enum revtron_reporting_bookings_by_channel_gql_select_column {
  /** column name */
  avg_cycle_times_wins = "avg_cycle_times_wins",
  /** column name */
  avg_deal_size_wins = "avg_deal_size_wins",
  /** column name */
  lead_channel = "lead_channel",
  /** column name */
  losses = "losses",
  /** column name */
  total_opps = "total_opps",
  /** column name */
  total_won_revenue = "total_won_revenue",
  /** column name */
  wins = "wins",
}

/** Streaming cursor of the table "revtron_reporting_bookings_by_channel_gql" */
export type revtron_reporting_bookings_by_channel_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: revtron_reporting_bookings_by_channel_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type revtron_reporting_bookings_by_channel_gql_stream_cursor_value_input =
  {
    avg_cycle_times_wins?: InputMaybe<Scalars["float8"]>;
    avg_deal_size_wins?: InputMaybe<Scalars["numeric"]>;
    lead_channel?: InputMaybe<Scalars["String"]>;
    losses?: InputMaybe<Scalars["bigint"]>;
    total_opps?: InputMaybe<Scalars["bigint"]>;
    total_won_revenue?: InputMaybe<Scalars["numeric"]>;
    wins?: InputMaybe<Scalars["bigint"]>;
  };

/** Boolean expression to filter rows from the table "revtron_reporting_bookings_by_detailed_channel_gql". All fields are combined with a logical 'AND'. */
export type revtron_reporting_bookings_by_detailed_channel_gql_bool_exp = {
  _and?: InputMaybe<
    Array<revtron_reporting_bookings_by_detailed_channel_gql_bool_exp>
  >;
  _not?: InputMaybe<revtron_reporting_bookings_by_detailed_channel_gql_bool_exp>;
  _or?: InputMaybe<
    Array<revtron_reporting_bookings_by_detailed_channel_gql_bool_exp>
  >;
  avg_cycle_times_wins?: InputMaybe<float8_comparison_exp>;
  avg_deal_size_wins?: InputMaybe<numeric_comparison_exp>;
  lead_channel?: InputMaybe<String_comparison_exp>;
  leadsource?: InputMaybe<String_comparison_exp>;
  losses?: InputMaybe<bigint_comparison_exp>;
  total_opps?: InputMaybe<bigint_comparison_exp>;
  total_won_revenue?: InputMaybe<numeric_comparison_exp>;
  wins?: InputMaybe<bigint_comparison_exp>;
};

/** Ordering options when selecting data from "revtron_reporting_bookings_by_detailed_channel_gql". */
export type revtron_reporting_bookings_by_detailed_channel_gql_order_by = {
  avg_cycle_times_wins?: InputMaybe<order_by>;
  avg_deal_size_wins?: InputMaybe<order_by>;
  lead_channel?: InputMaybe<order_by>;
  leadsource?: InputMaybe<order_by>;
  losses?: InputMaybe<order_by>;
  total_opps?: InputMaybe<order_by>;
  total_won_revenue?: InputMaybe<order_by>;
  wins?: InputMaybe<order_by>;
};

/** select columns of table "revtron_reporting_bookings_by_detailed_channel_gql" */
export enum revtron_reporting_bookings_by_detailed_channel_gql_select_column {
  /** column name */
  avg_cycle_times_wins = "avg_cycle_times_wins",
  /** column name */
  avg_deal_size_wins = "avg_deal_size_wins",
  /** column name */
  lead_channel = "lead_channel",
  /** column name */
  leadsource = "leadsource",
  /** column name */
  losses = "losses",
  /** column name */
  total_opps = "total_opps",
  /** column name */
  total_won_revenue = "total_won_revenue",
  /** column name */
  wins = "wins",
}

/** Streaming cursor of the table "revtron_reporting_bookings_by_detailed_channel_gql" */
export type revtron_reporting_bookings_by_detailed_channel_gql_stream_cursor_input =
  {
    /** Stream column input with initial value */
    initial_value: revtron_reporting_bookings_by_detailed_channel_gql_stream_cursor_value_input;
    /** cursor ordering */
    ordering?: InputMaybe<cursor_ordering>;
  };

/** Initial value of the column from where the streaming should start */
export type revtron_reporting_bookings_by_detailed_channel_gql_stream_cursor_value_input =
  {
    avg_cycle_times_wins?: InputMaybe<Scalars["float8"]>;
    avg_deal_size_wins?: InputMaybe<Scalars["numeric"]>;
    lead_channel?: InputMaybe<Scalars["String"]>;
    leadsource?: InputMaybe<Scalars["String"]>;
    losses?: InputMaybe<Scalars["bigint"]>;
    total_opps?: InputMaybe<Scalars["bigint"]>;
    total_won_revenue?: InputMaybe<Scalars["numeric"]>;
    wins?: InputMaybe<Scalars["bigint"]>;
  };

/** Boolean expression to filter rows from the table "revtron_reporting_bookings_yoy_gql". All fields are combined with a logical 'AND'. */
export type revtron_reporting_bookings_yoy_gql_bool_exp = {
  _and?: InputMaybe<Array<revtron_reporting_bookings_yoy_gql_bool_exp>>;
  _not?: InputMaybe<revtron_reporting_bookings_yoy_gql_bool_exp>;
  _or?: InputMaybe<Array<revtron_reporting_bookings_yoy_gql_bool_exp>>;
  current_period_revenue?: InputMaybe<numeric_comparison_exp>;
  percent_change?: InputMaybe<numeric_comparison_exp>;
  previous_period_revenue?: InputMaybe<numeric_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "revtron_reporting_bookings_yoy_gql". */
export type revtron_reporting_bookings_yoy_gql_order_by = {
  current_period_revenue?: InputMaybe<order_by>;
  percent_change?: InputMaybe<order_by>;
  previous_period_revenue?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
};

/** select columns of table "revtron_reporting_bookings_yoy_gql" */
export enum revtron_reporting_bookings_yoy_gql_select_column {
  /** column name */
  current_period_revenue = "current_period_revenue",
  /** column name */
  percent_change = "percent_change",
  /** column name */
  previous_period_revenue = "previous_period_revenue",
  /** column name */
  type = "type",
}

/** Streaming cursor of the table "revtron_reporting_bookings_yoy_gql" */
export type revtron_reporting_bookings_yoy_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: revtron_reporting_bookings_yoy_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type revtron_reporting_bookings_yoy_gql_stream_cursor_value_input = {
  current_period_revenue?: InputMaybe<Scalars["numeric"]>;
  percent_change?: InputMaybe<Scalars["numeric"]>;
  previous_period_revenue?: InputMaybe<Scalars["numeric"]>;
  type?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "revtron_reporting_individuals_gql". All fields are combined with a logical 'AND'. */
export type revtron_reporting_individuals_gql_bool_exp = {
  _and?: InputMaybe<Array<revtron_reporting_individuals_gql_bool_exp>>;
  _not?: InputMaybe<revtron_reporting_individuals_gql_bool_exp>;
  _or?: InputMaybe<Array<revtron_reporting_individuals_gql_bool_exp>>;
  accounts?: InputMaybe<bigint_comparison_exp>;
  contacts?: InputMaybe<bigint_comparison_exp>;
  contacts_per_account?: InputMaybe<numeric_comparison_exp>;
  date_trunc?: InputMaybe<timestamp_comparison_exp>;
  leads?: InputMaybe<bigint_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  outbound_opps?: InputMaybe<bigint_comparison_exp>;
  ownerid?: InputMaybe<String_comparison_exp>;
  pipeline_generated?: InputMaybe<numeric_comparison_exp>;
  total_new_biz_opps?: InputMaybe<bigint_comparison_exp>;
};

/** Ordering options when selecting data from "revtron_reporting_individuals_gql". */
export type revtron_reporting_individuals_gql_order_by = {
  accounts?: InputMaybe<order_by>;
  contacts?: InputMaybe<order_by>;
  contacts_per_account?: InputMaybe<order_by>;
  date_trunc?: InputMaybe<order_by>;
  leads?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  outbound_opps?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  pipeline_generated?: InputMaybe<order_by>;
  total_new_biz_opps?: InputMaybe<order_by>;
};

/** select columns of table "revtron_reporting_individuals_gql" */
export enum revtron_reporting_individuals_gql_select_column {
  /** column name */
  accounts = "accounts",
  /** column name */
  contacts = "contacts",
  /** column name */
  contacts_per_account = "contacts_per_account",
  /** column name */
  date_trunc = "date_trunc",
  /** column name */
  leads = "leads",
  /** column name */
  name = "name",
  /** column name */
  outbound_opps = "outbound_opps",
  /** column name */
  ownerid = "ownerid",
  /** column name */
  pipeline_generated = "pipeline_generated",
  /** column name */
  total_new_biz_opps = "total_new_biz_opps",
}

/** Streaming cursor of the table "revtron_reporting_individuals_gql" */
export type revtron_reporting_individuals_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: revtron_reporting_individuals_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type revtron_reporting_individuals_gql_stream_cursor_value_input = {
  accounts?: InputMaybe<Scalars["bigint"]>;
  contacts?: InputMaybe<Scalars["bigint"]>;
  contacts_per_account?: InputMaybe<Scalars["numeric"]>;
  date_trunc?: InputMaybe<Scalars["timestamp"]>;
  leads?: InputMaybe<Scalars["bigint"]>;
  name?: InputMaybe<Scalars["String"]>;
  outbound_opps?: InputMaybe<Scalars["bigint"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  pipeline_generated?: InputMaybe<Scalars["numeric"]>;
  total_new_biz_opps?: InputMaybe<Scalars["bigint"]>;
};

/** Boolean expression to filter rows from the table "revtron_reporting_sales_velocity_details_gql". All fields are combined with a logical 'AND'. */
export type revtron_reporting_sales_velocity_details_gql_bool_exp = {
  _and?: InputMaybe<
    Array<revtron_reporting_sales_velocity_details_gql_bool_exp>
  >;
  _not?: InputMaybe<revtron_reporting_sales_velocity_details_gql_bool_exp>;
  _or?: InputMaybe<
    Array<revtron_reporting_sales_velocity_details_gql_bool_exp>
  >;
  stat?: InputMaybe<float8_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "revtron_reporting_sales_velocity_details_gql". */
export type revtron_reporting_sales_velocity_details_gql_order_by = {
  stat?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
};

/** select columns of table "revtron_reporting_sales_velocity_details_gql" */
export enum revtron_reporting_sales_velocity_details_gql_select_column {
  /** column name */
  stat = "stat",
  /** column name */
  type = "type",
}

/** Streaming cursor of the table "revtron_reporting_sales_velocity_details_gql" */
export type revtron_reporting_sales_velocity_details_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: revtron_reporting_sales_velocity_details_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type revtron_reporting_sales_velocity_details_gql_stream_cursor_value_input =
  {
    stat?: InputMaybe<Scalars["float8"]>;
    type?: InputMaybe<Scalars["String"]>;
  };

/** Boolean expression to filter rows from the table "revtron_reporting_tof_numbers_yoy_gql". All fields are combined with a logical 'AND'. */
export type revtron_reporting_tof_numbers_yoy_gql_bool_exp = {
  _and?: InputMaybe<Array<revtron_reporting_tof_numbers_yoy_gql_bool_exp>>;
  _not?: InputMaybe<revtron_reporting_tof_numbers_yoy_gql_bool_exp>;
  _or?: InputMaybe<Array<revtron_reporting_tof_numbers_yoy_gql_bool_exp>>;
  change?: InputMaybe<bigint_comparison_exp>;
  current_period_opps?: InputMaybe<bigint_comparison_exp>;
  percent_change?: InputMaybe<float8_comparison_exp>;
  previous_period_count?: InputMaybe<bigint_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "revtron_reporting_tof_numbers_yoy_gql". */
export type revtron_reporting_tof_numbers_yoy_gql_order_by = {
  change?: InputMaybe<order_by>;
  current_period_opps?: InputMaybe<order_by>;
  percent_change?: InputMaybe<order_by>;
  previous_period_count?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
};

/** select columns of table "revtron_reporting_tof_numbers_yoy_gql" */
export enum revtron_reporting_tof_numbers_yoy_gql_select_column {
  /** column name */
  change = "change",
  /** column name */
  current_period_opps = "current_period_opps",
  /** column name */
  percent_change = "percent_change",
  /** column name */
  previous_period_count = "previous_period_count",
  /** column name */
  type = "type",
}

/** Streaming cursor of the table "revtron_reporting_tof_numbers_yoy_gql" */
export type revtron_reporting_tof_numbers_yoy_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: revtron_reporting_tof_numbers_yoy_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type revtron_reporting_tof_numbers_yoy_gql_stream_cursor_value_input = {
  change?: InputMaybe<Scalars["bigint"]>;
  current_period_opps?: InputMaybe<Scalars["bigint"]>;
  percent_change?: InputMaybe<Scalars["float8"]>;
  previous_period_count?: InputMaybe<Scalars["bigint"]>;
  type?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "revtron_reporting_tof_yoy_gql". All fields are combined with a logical 'AND'. */
export type revtron_reporting_tof_yoy_gql_bool_exp = {
  _and?: InputMaybe<Array<revtron_reporting_tof_yoy_gql_bool_exp>>;
  _not?: InputMaybe<revtron_reporting_tof_yoy_gql_bool_exp>;
  _or?: InputMaybe<Array<revtron_reporting_tof_yoy_gql_bool_exp>>;
  current_period_revenue?: InputMaybe<numeric_comparison_exp>;
  percent_change?: InputMaybe<numeric_comparison_exp>;
  previous_period_revenue?: InputMaybe<numeric_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "revtron_reporting_tof_yoy_gql". */
export type revtron_reporting_tof_yoy_gql_order_by = {
  current_period_revenue?: InputMaybe<order_by>;
  percent_change?: InputMaybe<order_by>;
  previous_period_revenue?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
};

/** select columns of table "revtron_reporting_tof_yoy_gql" */
export enum revtron_reporting_tof_yoy_gql_select_column {
  /** column name */
  current_period_revenue = "current_period_revenue",
  /** column name */
  percent_change = "percent_change",
  /** column name */
  previous_period_revenue = "previous_period_revenue",
  /** column name */
  type = "type",
}

/** Streaming cursor of the table "revtron_reporting_tof_yoy_gql" */
export type revtron_reporting_tof_yoy_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: revtron_reporting_tof_yoy_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type revtron_reporting_tof_yoy_gql_stream_cursor_value_input = {
  current_period_revenue?: InputMaybe<Scalars["numeric"]>;
  percent_change?: InputMaybe<Scalars["numeric"]>;
  previous_period_revenue?: InputMaybe<Scalars["numeric"]>;
  type?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "revtron_reporting_total_bookings_yoy_gql". All fields are combined with a logical 'AND'. */
export type revtron_reporting_total_bookings_yoy_gql_bool_exp = {
  _and?: InputMaybe<Array<revtron_reporting_total_bookings_yoy_gql_bool_exp>>;
  _not?: InputMaybe<revtron_reporting_total_bookings_yoy_gql_bool_exp>;
  _or?: InputMaybe<Array<revtron_reporting_total_bookings_yoy_gql_bool_exp>>;
  current_period_revenue?: InputMaybe<numeric_comparison_exp>;
  percent_change?: InputMaybe<numeric_comparison_exp>;
  previous_period_revenue?: InputMaybe<numeric_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "revtron_reporting_total_bookings_yoy_gql". */
export type revtron_reporting_total_bookings_yoy_gql_order_by = {
  current_period_revenue?: InputMaybe<order_by>;
  percent_change?: InputMaybe<order_by>;
  previous_period_revenue?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
};

/** select columns of table "revtron_reporting_total_bookings_yoy_gql" */
export enum revtron_reporting_total_bookings_yoy_gql_select_column {
  /** column name */
  current_period_revenue = "current_period_revenue",
  /** column name */
  percent_change = "percent_change",
  /** column name */
  previous_period_revenue = "previous_period_revenue",
  /** column name */
  type = "type",
}

/** Streaming cursor of the table "revtron_reporting_total_bookings_yoy_gql" */
export type revtron_reporting_total_bookings_yoy_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: revtron_reporting_total_bookings_yoy_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type revtron_reporting_total_bookings_yoy_gql_stream_cursor_value_input =
  {
    current_period_revenue?: InputMaybe<Scalars["numeric"]>;
    percent_change?: InputMaybe<Scalars["numeric"]>;
    previous_period_revenue?: InputMaybe<Scalars["numeric"]>;
    type?: InputMaybe<Scalars["String"]>;
  };

/** Boolean expression to filter rows from the table "revtron_reporting_total_tof_numbers_yoy_gql". All fields are combined with a logical 'AND'. */
export type revtron_reporting_total_tof_numbers_yoy_gql_bool_exp = {
  _and?: InputMaybe<
    Array<revtron_reporting_total_tof_numbers_yoy_gql_bool_exp>
  >;
  _not?: InputMaybe<revtron_reporting_total_tof_numbers_yoy_gql_bool_exp>;
  _or?: InputMaybe<Array<revtron_reporting_total_tof_numbers_yoy_gql_bool_exp>>;
  current_period_opps?: InputMaybe<numeric_comparison_exp>;
  percent_change?: InputMaybe<numeric_comparison_exp>;
  previous_period_count?: InputMaybe<numeric_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "revtron_reporting_total_tof_numbers_yoy_gql". */
export type revtron_reporting_total_tof_numbers_yoy_gql_order_by = {
  current_period_opps?: InputMaybe<order_by>;
  percent_change?: InputMaybe<order_by>;
  previous_period_count?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
};

/** select columns of table "revtron_reporting_total_tof_numbers_yoy_gql" */
export enum revtron_reporting_total_tof_numbers_yoy_gql_select_column {
  /** column name */
  current_period_opps = "current_period_opps",
  /** column name */
  percent_change = "percent_change",
  /** column name */
  previous_period_count = "previous_period_count",
  /** column name */
  type = "type",
}

/** Streaming cursor of the table "revtron_reporting_total_tof_numbers_yoy_gql" */
export type revtron_reporting_total_tof_numbers_yoy_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: revtron_reporting_total_tof_numbers_yoy_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type revtron_reporting_total_tof_numbers_yoy_gql_stream_cursor_value_input =
  {
    current_period_opps?: InputMaybe<Scalars["numeric"]>;
    percent_change?: InputMaybe<Scalars["numeric"]>;
    previous_period_count?: InputMaybe<Scalars["numeric"]>;
    type?: InputMaybe<Scalars["String"]>;
  };

/** Boolean expression to filter rows from the table "revtron_reporting_total_tof_yoy_gql". All fields are combined with a logical 'AND'. */
export type revtron_reporting_total_tof_yoy_gql_bool_exp = {
  _and?: InputMaybe<Array<revtron_reporting_total_tof_yoy_gql_bool_exp>>;
  _not?: InputMaybe<revtron_reporting_total_tof_yoy_gql_bool_exp>;
  _or?: InputMaybe<Array<revtron_reporting_total_tof_yoy_gql_bool_exp>>;
  current_period_revenue?: InputMaybe<numeric_comparison_exp>;
  percent_change?: InputMaybe<numeric_comparison_exp>;
  previous_period_revenue?: InputMaybe<numeric_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "revtron_reporting_total_tof_yoy_gql". */
export type revtron_reporting_total_tof_yoy_gql_order_by = {
  current_period_revenue?: InputMaybe<order_by>;
  percent_change?: InputMaybe<order_by>;
  previous_period_revenue?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
};

/** select columns of table "revtron_reporting_total_tof_yoy_gql" */
export enum revtron_reporting_total_tof_yoy_gql_select_column {
  /** column name */
  current_period_revenue = "current_period_revenue",
  /** column name */
  percent_change = "percent_change",
  /** column name */
  previous_period_revenue = "previous_period_revenue",
  /** column name */
  type = "type",
}

/** Streaming cursor of the table "revtron_reporting_total_tof_yoy_gql" */
export type revtron_reporting_total_tof_yoy_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: revtron_reporting_total_tof_yoy_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type revtron_reporting_total_tof_yoy_gql_stream_cursor_value_input = {
  current_period_revenue?: InputMaybe<Scalars["numeric"]>;
  percent_change?: InputMaybe<Scalars["numeric"]>;
  previous_period_revenue?: InputMaybe<Scalars["numeric"]>;
  type?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "revtron_reporting_totals_gql". All fields are combined with a logical 'AND'. */
export type revtron_reporting_totals_gql_bool_exp = {
  _and?: InputMaybe<Array<revtron_reporting_totals_gql_bool_exp>>;
  _not?: InputMaybe<revtron_reporting_totals_gql_bool_exp>;
  _or?: InputMaybe<Array<revtron_reporting_totals_gql_bool_exp>>;
  stat?: InputMaybe<numeric_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "revtron_reporting_totals_gql". */
export type revtron_reporting_totals_gql_order_by = {
  stat?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
};

/** select columns of table "revtron_reporting_totals_gql" */
export enum revtron_reporting_totals_gql_select_column {
  /** column name */
  stat = "stat",
  /** column name */
  type = "type",
}

/** Streaming cursor of the table "revtron_reporting_totals_gql" */
export type revtron_reporting_totals_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: revtron_reporting_totals_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type revtron_reporting_totals_gql_stream_cursor_value_input = {
  stat?: InputMaybe<Scalars["numeric"]>;
  type?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "revtron_reporting_weighted_gql". All fields are combined with a logical 'AND'. */
export type revtron_reporting_weighted_gql_bool_exp = {
  _and?: InputMaybe<Array<revtron_reporting_weighted_gql_bool_exp>>;
  _not?: InputMaybe<revtron_reporting_weighted_gql_bool_exp>;
  _or?: InputMaybe<Array<revtron_reporting_weighted_gql_bool_exp>>;
  sum?: InputMaybe<float8_comparison_exp>;
};

/** Ordering options when selecting data from "revtron_reporting_weighted_gql". */
export type revtron_reporting_weighted_gql_order_by = {
  sum?: InputMaybe<order_by>;
};

/** select columns of table "revtron_reporting_weighted_gql" */
export enum revtron_reporting_weighted_gql_select_column {
  /** column name */
  sum = "sum",
}

/** Streaming cursor of the table "revtron_reporting_weighted_gql" */
export type revtron_reporting_weighted_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: revtron_reporting_weighted_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type revtron_reporting_weighted_gql_stream_cursor_value_input = {
  sum?: InputMaybe<Scalars["float8"]>;
};

/** Boolean expression to filter rows from the table "running_revenue_gql". All fields are combined with a logical 'AND'. */
export type running_revenue_gql_bool_exp = {
  _and?: InputMaybe<Array<running_revenue_gql_bool_exp>>;
  _not?: InputMaybe<running_revenue_gql_bool_exp>;
  _or?: InputMaybe<Array<running_revenue_gql_bool_exp>>;
  day?: InputMaybe<timestamp_comparison_exp>;
  revenue?: InputMaybe<numeric_comparison_exp>;
};

/** Ordering options when selecting data from "running_revenue_gql". */
export type running_revenue_gql_order_by = {
  day?: InputMaybe<order_by>;
  revenue?: InputMaybe<order_by>;
};

/** select columns of table "running_revenue_gql" */
export enum running_revenue_gql_select_column {
  /** column name */
  day = "day",
  /** column name */
  revenue = "revenue",
}

/** Streaming cursor of the table "running_revenue_gql" */
export type running_revenue_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: running_revenue_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type running_revenue_gql_stream_cursor_value_input = {
  day?: InputMaybe<Scalars["timestamp"]>;
  revenue?: InputMaybe<Scalars["numeric"]>;
};

export type send_to_crm_events_aggregate_bool_exp = {
  count?: InputMaybe<send_to_crm_events_aggregate_bool_exp_count>;
};

export type send_to_crm_events_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<send_to_crm_events_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<send_to_crm_events_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "send_to_crm_events" */
export type send_to_crm_events_aggregate_order_by = {
  avg?: InputMaybe<send_to_crm_events_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<send_to_crm_events_max_order_by>;
  min?: InputMaybe<send_to_crm_events_min_order_by>;
  stddev?: InputMaybe<send_to_crm_events_stddev_order_by>;
  stddev_pop?: InputMaybe<send_to_crm_events_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<send_to_crm_events_stddev_samp_order_by>;
  sum?: InputMaybe<send_to_crm_events_sum_order_by>;
  var_pop?: InputMaybe<send_to_crm_events_var_pop_order_by>;
  var_samp?: InputMaybe<send_to_crm_events_var_samp_order_by>;
  variance?: InputMaybe<send_to_crm_events_variance_order_by>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type send_to_crm_events_append_input = {
  records?: InputMaybe<Scalars["jsonb"]>;
};

/** input type for inserting array relation for remote table "send_to_crm_events" */
export type send_to_crm_events_arr_rel_insert_input = {
  data: Array<send_to_crm_events_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<send_to_crm_events_on_conflict>;
};

/** order by avg() on columns of table "send_to_crm_events" */
export type send_to_crm_events_avg_order_by = {
  id?: InputMaybe<order_by>;
  revtron_company_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "send_to_crm_events". All fields are combined with a logical 'AND'. */
export type send_to_crm_events_bool_exp = {
  _and?: InputMaybe<Array<send_to_crm_events_bool_exp>>;
  _not?: InputMaybe<send_to_crm_events_bool_exp>;
  _or?: InputMaybe<Array<send_to_crm_events_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  crm_user_id?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<bigint_comparison_exp>;
  records?: InputMaybe<jsonb_comparison_exp>;
  revtron_company_id?: InputMaybe<Int_comparison_exp>;
  revtron_user_id?: InputMaybe<uuid_comparison_exp>;
  salesforce?: InputMaybe<String_comparison_exp>;
  sobject?: InputMaybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "send_to_crm_events" */
export enum send_to_crm_events_constraint {
  /** unique or primary key constraint on columns "id" */
  send_to_crm_events_pkey = "send_to_crm_events_pkey",
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type send_to_crm_events_delete_at_path_input = {
  records?: InputMaybe<Array<Scalars["String"]>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type send_to_crm_events_delete_elem_input = {
  records?: InputMaybe<Scalars["Int"]>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type send_to_crm_events_delete_key_input = {
  records?: InputMaybe<Scalars["String"]>;
};

/** input type for incrementing numeric columns in table "send_to_crm_events" */
export type send_to_crm_events_inc_input = {
  id?: InputMaybe<Scalars["bigint"]>;
  revtron_company_id?: InputMaybe<Scalars["Int"]>;
};

/** input type for inserting data into table "send_to_crm_events" */
export type send_to_crm_events_insert_input = {
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  crm_user_id?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  records?: InputMaybe<Scalars["jsonb"]>;
  revtron_company_id?: InputMaybe<Scalars["Int"]>;
  revtron_user_id?: InputMaybe<Scalars["uuid"]>;
  salesforce?: InputMaybe<Scalars["String"]>;
  sobject?: InputMaybe<Scalars["String"]>;
};

/** order by max() on columns of table "send_to_crm_events" */
export type send_to_crm_events_max_order_by = {
  created_at?: InputMaybe<order_by>;
  crm_user_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  revtron_company_id?: InputMaybe<order_by>;
  revtron_user_id?: InputMaybe<order_by>;
  salesforce?: InputMaybe<order_by>;
  sobject?: InputMaybe<order_by>;
};

/** order by min() on columns of table "send_to_crm_events" */
export type send_to_crm_events_min_order_by = {
  created_at?: InputMaybe<order_by>;
  crm_user_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  revtron_company_id?: InputMaybe<order_by>;
  revtron_user_id?: InputMaybe<order_by>;
  salesforce?: InputMaybe<order_by>;
  sobject?: InputMaybe<order_by>;
};

/** on_conflict condition type for table "send_to_crm_events" */
export type send_to_crm_events_on_conflict = {
  constraint: send_to_crm_events_constraint;
  update_columns?: Array<send_to_crm_events_update_column>;
  where?: InputMaybe<send_to_crm_events_bool_exp>;
};

/** Ordering options when selecting data from "send_to_crm_events". */
export type send_to_crm_events_order_by = {
  created_at?: InputMaybe<order_by>;
  crm_user_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  records?: InputMaybe<order_by>;
  revtron_company_id?: InputMaybe<order_by>;
  revtron_user_id?: InputMaybe<order_by>;
  salesforce?: InputMaybe<order_by>;
  sobject?: InputMaybe<order_by>;
};

/** primary key columns input for table: send_to_crm_events */
export type send_to_crm_events_pk_columns_input = {
  id: Scalars["bigint"];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type send_to_crm_events_prepend_input = {
  records?: InputMaybe<Scalars["jsonb"]>;
};

/** select columns of table "send_to_crm_events" */
export enum send_to_crm_events_select_column {
  /** column name */
  created_at = "created_at",
  /** column name */
  crm_user_id = "crm_user_id",
  /** column name */
  id = "id",
  /** column name */
  records = "records",
  /** column name */
  revtron_company_id = "revtron_company_id",
  /** column name */
  revtron_user_id = "revtron_user_id",
  /** column name */
  salesforce = "salesforce",
  /** column name */
  sobject = "sobject",
}

/** input type for updating data in table "send_to_crm_events" */
export type send_to_crm_events_set_input = {
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  crm_user_id?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  records?: InputMaybe<Scalars["jsonb"]>;
  revtron_company_id?: InputMaybe<Scalars["Int"]>;
  revtron_user_id?: InputMaybe<Scalars["uuid"]>;
  salesforce?: InputMaybe<Scalars["String"]>;
  sobject?: InputMaybe<Scalars["String"]>;
};

/** order by stddev() on columns of table "send_to_crm_events" */
export type send_to_crm_events_stddev_order_by = {
  id?: InputMaybe<order_by>;
  revtron_company_id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "send_to_crm_events" */
export type send_to_crm_events_stddev_pop_order_by = {
  id?: InputMaybe<order_by>;
  revtron_company_id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "send_to_crm_events" */
export type send_to_crm_events_stddev_samp_order_by = {
  id?: InputMaybe<order_by>;
  revtron_company_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "send_to_crm_events" */
export type send_to_crm_events_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: send_to_crm_events_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type send_to_crm_events_stream_cursor_value_input = {
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  crm_user_id?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  records?: InputMaybe<Scalars["jsonb"]>;
  revtron_company_id?: InputMaybe<Scalars["Int"]>;
  revtron_user_id?: InputMaybe<Scalars["uuid"]>;
  salesforce?: InputMaybe<Scalars["String"]>;
  sobject?: InputMaybe<Scalars["String"]>;
};

/** order by sum() on columns of table "send_to_crm_events" */
export type send_to_crm_events_sum_order_by = {
  id?: InputMaybe<order_by>;
  revtron_company_id?: InputMaybe<order_by>;
};

/** update columns of table "send_to_crm_events" */
export enum send_to_crm_events_update_column {
  /** column name */
  created_at = "created_at",
  /** column name */
  crm_user_id = "crm_user_id",
  /** column name */
  id = "id",
  /** column name */
  records = "records",
  /** column name */
  revtron_company_id = "revtron_company_id",
  /** column name */
  revtron_user_id = "revtron_user_id",
  /** column name */
  salesforce = "salesforce",
  /** column name */
  sobject = "sobject",
}

export type send_to_crm_events_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<send_to_crm_events_append_input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<send_to_crm_events_delete_at_path_input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<send_to_crm_events_delete_elem_input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<send_to_crm_events_delete_key_input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<send_to_crm_events_inc_input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<send_to_crm_events_prepend_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<send_to_crm_events_set_input>;
  where: send_to_crm_events_bool_exp;
};

/** order by var_pop() on columns of table "send_to_crm_events" */
export type send_to_crm_events_var_pop_order_by = {
  id?: InputMaybe<order_by>;
  revtron_company_id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "send_to_crm_events" */
export type send_to_crm_events_var_samp_order_by = {
  id?: InputMaybe<order_by>;
  revtron_company_id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "send_to_crm_events" */
export type send_to_crm_events_variance_order_by = {
  id?: InputMaybe<order_by>;
  revtron_company_id?: InputMaybe<order_by>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type sf_users_append_input = {
  address?: InputMaybe<Scalars["jsonb"]>;
};

/** Boolean expression to filter rows from the table "sf_users". All fields are combined with a logical 'AND'. */
export type sf_users_bool_exp = {
  _and?: InputMaybe<Array<sf_users_bool_exp>>;
  _not?: InputMaybe<sf_users_bool_exp>;
  _or?: InputMaybe<Array<sf_users_bool_exp>>;
  aboutme?: InputMaybe<String_comparison_exp>;
  accountid?: InputMaybe<String_comparison_exp>;
  address?: InputMaybe<jsonb_comparison_exp>;
  alias?: InputMaybe<String_comparison_exp>;
  badgetext?: InputMaybe<String_comparison_exp>;
  bannerphotourl?: InputMaybe<String_comparison_exp>;
  callcenterid?: InputMaybe<String_comparison_exp>;
  city?: InputMaybe<String_comparison_exp>;
  communitynickname?: InputMaybe<String_comparison_exp>;
  companyname?: InputMaybe<String_comparison_exp>;
  contactid?: InputMaybe<String_comparison_exp>;
  country?: InputMaybe<String_comparison_exp>;
  createdbyid?: InputMaybe<String_comparison_exp>;
  createddate?: InputMaybe<timestamp_comparison_exp>;
  defaultgroupnotificationfrequency?: InputMaybe<String_comparison_exp>;
  delegatedapproverid?: InputMaybe<String_comparison_exp>;
  department?: InputMaybe<String_comparison_exp>;
  digestfrequency?: InputMaybe<String_comparison_exp>;
  division?: InputMaybe<String_comparison_exp>;
  email?: InputMaybe<String_comparison_exp>;
  emailencodingkey?: InputMaybe<String_comparison_exp>;
  emailpreferencesautobcc?: InputMaybe<Boolean_comparison_exp>;
  emailpreferencesautobccstayintouch?: InputMaybe<Boolean_comparison_exp>;
  emailpreferencesstayintouchreminder?: InputMaybe<Boolean_comparison_exp>;
  employeenumber?: InputMaybe<String_comparison_exp>;
  extension?: InputMaybe<String_comparison_exp>;
  fax?: InputMaybe<String_comparison_exp>;
  federationidentifier?: InputMaybe<String_comparison_exp>;
  firstname?: InputMaybe<String_comparison_exp>;
  forecastenabled?: InputMaybe<Boolean_comparison_exp>;
  fullphotourl?: InputMaybe<String_comparison_exp>;
  geocodeaccuracy?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<String_comparison_exp>;
  isactive?: InputMaybe<Boolean_comparison_exp>;
  isextindicatorvisible?: InputMaybe<Boolean_comparison_exp>;
  isprofilephotoactive?: InputMaybe<Boolean_comparison_exp>;
  languagelocalekey?: InputMaybe<String_comparison_exp>;
  lastlogindate?: InputMaybe<timestamp_comparison_exp>;
  lastmodifiedbyid?: InputMaybe<String_comparison_exp>;
  lastmodifieddate?: InputMaybe<timestamp_comparison_exp>;
  lastname?: InputMaybe<String_comparison_exp>;
  lastpasswordchangedate?: InputMaybe<timestamp_comparison_exp>;
  lastreferenceddate?: InputMaybe<timestamp_comparison_exp>;
  lastvieweddate?: InputMaybe<timestamp_comparison_exp>;
  latitude?: InputMaybe<numeric_comparison_exp>;
  localesidkey?: InputMaybe<String_comparison_exp>;
  longitude?: InputMaybe<numeric_comparison_exp>;
  managerid?: InputMaybe<String_comparison_exp>;
  mediumbannerphotourl?: InputMaybe<String_comparison_exp>;
  mediumphotourl?: InputMaybe<String_comparison_exp>;
  middlename?: InputMaybe<String_comparison_exp>;
  mobilephone?: InputMaybe<String_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  numberoffailedlogins?: InputMaybe<Int_comparison_exp>;
  offlinepdatrialexpirationdate?: InputMaybe<timestamp_comparison_exp>;
  offlinetrialexpirationdate?: InputMaybe<timestamp_comparison_exp>;
  outofofficemessage?: InputMaybe<String_comparison_exp>;
  phone?: InputMaybe<String_comparison_exp>;
  postalcode?: InputMaybe<String_comparison_exp>;
  profileid?: InputMaybe<String_comparison_exp>;
  receivesadmininfoemails?: InputMaybe<Boolean_comparison_exp>;
  receivesinfoemails?: InputMaybe<Boolean_comparison_exp>;
  senderemail?: InputMaybe<String_comparison_exp>;
  sendername?: InputMaybe<String_comparison_exp>;
  signature?: InputMaybe<String_comparison_exp>;
  smallbannerphotourl?: InputMaybe<String_comparison_exp>;
  smallphotourl?: InputMaybe<String_comparison_exp>;
  sort_id?: InputMaybe<Int_comparison_exp>;
  state?: InputMaybe<String_comparison_exp>;
  stayintouchnote?: InputMaybe<String_comparison_exp>;
  stayintouchsignature?: InputMaybe<String_comparison_exp>;
  stayintouchsubject?: InputMaybe<String_comparison_exp>;
  street?: InputMaybe<String_comparison_exp>;
  suffix?: InputMaybe<String_comparison_exp>;
  systemmodstamp?: InputMaybe<timestamp_comparison_exp>;
  timezonesidkey?: InputMaybe<String_comparison_exp>;
  title?: InputMaybe<String_comparison_exp>;
  username?: InputMaybe<String_comparison_exp>;
  userpermissionsavantgouser?: InputMaybe<Boolean_comparison_exp>;
  userpermissionscallcenterautologin?: InputMaybe<Boolean_comparison_exp>;
  userpermissionsinteractionuser?: InputMaybe<Boolean_comparison_exp>;
  userpermissionsmarketinguser?: InputMaybe<Boolean_comparison_exp>;
  userpermissionsofflineuser?: InputMaybe<Boolean_comparison_exp>;
  userpermissionssfcontentuser?: InputMaybe<Boolean_comparison_exp>;
  userpermissionssupportuser?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesactivityreminderspopup?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesapexpagesdevelopermode?: InputMaybe<Boolean_comparison_exp>;
  userpreferencescachediagnostics?: InputMaybe<Boolean_comparison_exp>;
  userpreferencescreatelexappswtshown?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesdisableallfeedsemail?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesdisablebookmarkemail?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesdisablechangecommentemail?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesdisableendorsementemail?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesdisablefilesharenotificationsforapi?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesdisablefollowersemail?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesdisablelatercommentemail?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesdisablelikeemail?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesdisablementionspostemail?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesdisablemessageemail?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesdisableprofilepostemail?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesdisablesharepostemail?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesdiscommentafterlikeemail?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesdismentionscommentemail?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesdisprofpostcommentemail?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesenableautosubforfeeds?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceseventreminderscheckboxdefault?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesexcludemailappattachments?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesfavoritesshowtopfavorites?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesfavoriteswtshown?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesglobalnavbarwtshown?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesglobalnavgridmenuwtshown?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceshascelebrationbadge?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceshidebiggerphotocallout?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceshidebrowseproductredirectconfirmation?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceshidechatteronboardingsplash?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceshidecsndesktoptask?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceshidecsngetchattermobiletask?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceshideenduseronboardingassistantmodal?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceshideinvoicesredirectconfirmation?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceshidelightningmigrationmodal?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceshideonlinesalesappwelcomemat?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceshides1browserui?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceshidesecondchatteronboardingsplash?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceshidesfxwelcomemat?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceshidestatementsredirectconfirmation?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceslightningexperiencepreferred?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesnativeemailclient?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesnewlightningreportrunpageenabled?: InputMaybe<Boolean_comparison_exp>;
  userpreferencespathassistantcollapsed?: InputMaybe<Boolean_comparison_exp>;
  userpreferencespreviewcustomtheme?: InputMaybe<Boolean_comparison_exp>;
  userpreferencespreviewlightning?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesreceivenonotificationsasapprover?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesreceivenotificationsasdelegatedapprover?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesrecordhomereservedwtshown?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesrecordhomesectioncollapsewtshown?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesremindersoundoff?: InputMaybe<Boolean_comparison_exp>;
  userpreferencessendlistemailthroughexternalservice?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowcitytoexternalusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowcitytoguestusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowcountrytoexternalusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowcountrytoguestusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowemailtoexternalusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowemailtoguestusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowfaxtoexternalusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowfaxtoguestusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowmanagertoexternalusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowmanagertoguestusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowmobilephonetoexternalusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowmobilephonetoguestusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowpostalcodetoexternalusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowpostalcodetoguestusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowprofilepictoguestusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowstatetoexternalusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowstatetoguestusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowstreetaddresstoexternalusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowstreetaddresstoguestusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowtitletoexternalusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowtitletoguestusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowworkphonetoexternalusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowworkphonetoguestusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencessortfeedbycomment?: InputMaybe<Boolean_comparison_exp>;
  userpreferencessrhoverrideactivities?: InputMaybe<Boolean_comparison_exp>;
  userpreferencessuppresseventsfxreminders?: InputMaybe<Boolean_comparison_exp>;
  userpreferencessuppresstasksfxreminders?: InputMaybe<Boolean_comparison_exp>;
  userpreferencestaskreminderscheckboxdefault?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesuserdebugmodepref?: InputMaybe<Boolean_comparison_exp>;
  userroleid?: InputMaybe<String_comparison_exp>;
  usertype?: InputMaybe<String_comparison_exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type sf_users_delete_at_path_input = {
  address?: InputMaybe<Array<Scalars["String"]>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type sf_users_delete_elem_input = {
  address?: InputMaybe<Scalars["Int"]>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type sf_users_delete_key_input = {
  address?: InputMaybe<Scalars["String"]>;
};

/** input type for incrementing numeric columns in table "sf_users" */
export type sf_users_inc_input = {
  latitude?: InputMaybe<Scalars["numeric"]>;
  longitude?: InputMaybe<Scalars["numeric"]>;
  numberoffailedlogins?: InputMaybe<Scalars["Int"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
};

/** input type for inserting data into table "sf_users" */
export type sf_users_insert_input = {
  aboutme?: InputMaybe<Scalars["String"]>;
  accountid?: InputMaybe<Scalars["String"]>;
  address?: InputMaybe<Scalars["jsonb"]>;
  alias?: InputMaybe<Scalars["String"]>;
  badgetext?: InputMaybe<Scalars["String"]>;
  bannerphotourl?: InputMaybe<Scalars["String"]>;
  callcenterid?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  communitynickname?: InputMaybe<Scalars["String"]>;
  companyname?: InputMaybe<Scalars["String"]>;
  contactid?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  createdbyid?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  defaultgroupnotificationfrequency?: InputMaybe<Scalars["String"]>;
  delegatedapproverid?: InputMaybe<Scalars["String"]>;
  department?: InputMaybe<Scalars["String"]>;
  digestfrequency?: InputMaybe<Scalars["String"]>;
  division?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["String"]>;
  emailencodingkey?: InputMaybe<Scalars["String"]>;
  emailpreferencesautobcc?: InputMaybe<Scalars["Boolean"]>;
  emailpreferencesautobccstayintouch?: InputMaybe<Scalars["Boolean"]>;
  emailpreferencesstayintouchreminder?: InputMaybe<Scalars["Boolean"]>;
  employeenumber?: InputMaybe<Scalars["String"]>;
  extension?: InputMaybe<Scalars["String"]>;
  fax?: InputMaybe<Scalars["String"]>;
  federationidentifier?: InputMaybe<Scalars["String"]>;
  firstname?: InputMaybe<Scalars["String"]>;
  forecastenabled?: InputMaybe<Scalars["Boolean"]>;
  fullphotourl?: InputMaybe<Scalars["String"]>;
  geocodeaccuracy?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  isactive?: InputMaybe<Scalars["Boolean"]>;
  isextindicatorvisible?: InputMaybe<Scalars["Boolean"]>;
  isprofilephotoactive?: InputMaybe<Scalars["Boolean"]>;
  languagelocalekey?: InputMaybe<Scalars["String"]>;
  lastlogindate?: InputMaybe<Scalars["timestamp"]>;
  lastmodifiedbyid?: InputMaybe<Scalars["String"]>;
  lastmodifieddate?: InputMaybe<Scalars["timestamp"]>;
  lastname?: InputMaybe<Scalars["String"]>;
  lastpasswordchangedate?: InputMaybe<Scalars["timestamp"]>;
  lastreferenceddate?: InputMaybe<Scalars["timestamp"]>;
  lastvieweddate?: InputMaybe<Scalars["timestamp"]>;
  latitude?: InputMaybe<Scalars["numeric"]>;
  localesidkey?: InputMaybe<Scalars["String"]>;
  longitude?: InputMaybe<Scalars["numeric"]>;
  managerid?: InputMaybe<Scalars["String"]>;
  mediumbannerphotourl?: InputMaybe<Scalars["String"]>;
  mediumphotourl?: InputMaybe<Scalars["String"]>;
  middlename?: InputMaybe<Scalars["String"]>;
  mobilephone?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  numberoffailedlogins?: InputMaybe<Scalars["Int"]>;
  offlinepdatrialexpirationdate?: InputMaybe<Scalars["timestamp"]>;
  offlinetrialexpirationdate?: InputMaybe<Scalars["timestamp"]>;
  outofofficemessage?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  postalcode?: InputMaybe<Scalars["String"]>;
  profileid?: InputMaybe<Scalars["String"]>;
  receivesadmininfoemails?: InputMaybe<Scalars["Boolean"]>;
  receivesinfoemails?: InputMaybe<Scalars["Boolean"]>;
  senderemail?: InputMaybe<Scalars["String"]>;
  sendername?: InputMaybe<Scalars["String"]>;
  signature?: InputMaybe<Scalars["String"]>;
  smallbannerphotourl?: InputMaybe<Scalars["String"]>;
  smallphotourl?: InputMaybe<Scalars["String"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  state?: InputMaybe<Scalars["String"]>;
  stayintouchnote?: InputMaybe<Scalars["String"]>;
  stayintouchsignature?: InputMaybe<Scalars["String"]>;
  stayintouchsubject?: InputMaybe<Scalars["String"]>;
  street?: InputMaybe<Scalars["String"]>;
  suffix?: InputMaybe<Scalars["String"]>;
  systemmodstamp?: InputMaybe<Scalars["timestamp"]>;
  timezonesidkey?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
  username?: InputMaybe<Scalars["String"]>;
  userpermissionsavantgouser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionscallcenterautologin?: InputMaybe<Scalars["Boolean"]>;
  userpermissionsinteractionuser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionsmarketinguser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionsofflineuser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionssfcontentuser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionssupportuser?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesactivityreminderspopup?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesapexpagesdevelopermode?: InputMaybe<Scalars["Boolean"]>;
  userpreferencescachediagnostics?: InputMaybe<Scalars["Boolean"]>;
  userpreferencescreatelexappswtshown?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisableallfeedsemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablebookmarkemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablechangecommentemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisableendorsementemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablefilesharenotificationsforapi?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesdisablefollowersemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablelatercommentemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablelikeemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablementionspostemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablemessageemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisableprofilepostemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablesharepostemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdiscommentafterlikeemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdismentionscommentemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisprofpostcommentemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesenableautosubforfeeds?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceseventreminderscheckboxdefault?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesexcludemailappattachments?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesfavoritesshowtopfavorites?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesfavoriteswtshown?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesglobalnavbarwtshown?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesglobalnavgridmenuwtshown?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshascelebrationbadge?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidebiggerphotocallout?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidebrowseproductredirectconfirmation?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferenceshidechatteronboardingsplash?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidecsndesktoptask?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidecsngetchattermobiletask?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshideenduseronboardingassistantmodal?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferenceshideinvoicesredirectconfirmation?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferenceshidelightningmigrationmodal?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshideonlinesalesappwelcomemat?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshides1browserui?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidesecondchatteronboardingsplash?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferenceshidesfxwelcomemat?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidestatementsredirectconfirmation?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferenceslightningexperiencepreferred?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesnativeemailclient?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesnewlightningreportrunpageenabled?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencespathassistantcollapsed?: InputMaybe<Scalars["Boolean"]>;
  userpreferencespreviewcustomtheme?: InputMaybe<Scalars["Boolean"]>;
  userpreferencespreviewlightning?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesreceivenonotificationsasapprover?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesreceivenotificationsasdelegatedapprover?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesrecordhomereservedwtshown?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesrecordhomesectioncollapsewtshown?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesremindersoundoff?: InputMaybe<Scalars["Boolean"]>;
  userpreferencessendlistemailthroughexternalservice?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesshowcitytoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowcitytoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowcountrytoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowcountrytoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowemailtoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowemailtoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowfaxtoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowfaxtoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowmanagertoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowmanagertoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowmobilephonetoexternalusers?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesshowmobilephonetoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowpostalcodetoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowpostalcodetoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowprofilepictoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowstatetoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowstatetoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowstreetaddresstoexternalusers?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesshowstreetaddresstoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowtitletoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowtitletoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowworkphonetoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowworkphonetoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencessortfeedbycomment?: InputMaybe<Scalars["Boolean"]>;
  userpreferencessrhoverrideactivities?: InputMaybe<Scalars["Boolean"]>;
  userpreferencessuppresseventsfxreminders?: InputMaybe<Scalars["Boolean"]>;
  userpreferencessuppresstasksfxreminders?: InputMaybe<Scalars["Boolean"]>;
  userpreferencestaskreminderscheckboxdefault?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesuserdebugmodepref?: InputMaybe<Scalars["Boolean"]>;
  userroleid?: InputMaybe<Scalars["String"]>;
  usertype?: InputMaybe<Scalars["String"]>;
};

/** Ordering options when selecting data from "sf_users". */
export type sf_users_order_by = {
  aboutme?: InputMaybe<order_by>;
  accountid?: InputMaybe<order_by>;
  address?: InputMaybe<order_by>;
  alias?: InputMaybe<order_by>;
  badgetext?: InputMaybe<order_by>;
  bannerphotourl?: InputMaybe<order_by>;
  callcenterid?: InputMaybe<order_by>;
  city?: InputMaybe<order_by>;
  communitynickname?: InputMaybe<order_by>;
  companyname?: InputMaybe<order_by>;
  contactid?: InputMaybe<order_by>;
  country?: InputMaybe<order_by>;
  createdbyid?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  defaultgroupnotificationfrequency?: InputMaybe<order_by>;
  delegatedapproverid?: InputMaybe<order_by>;
  department?: InputMaybe<order_by>;
  digestfrequency?: InputMaybe<order_by>;
  division?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  emailencodingkey?: InputMaybe<order_by>;
  emailpreferencesautobcc?: InputMaybe<order_by>;
  emailpreferencesautobccstayintouch?: InputMaybe<order_by>;
  emailpreferencesstayintouchreminder?: InputMaybe<order_by>;
  employeenumber?: InputMaybe<order_by>;
  extension?: InputMaybe<order_by>;
  fax?: InputMaybe<order_by>;
  federationidentifier?: InputMaybe<order_by>;
  firstname?: InputMaybe<order_by>;
  forecastenabled?: InputMaybe<order_by>;
  fullphotourl?: InputMaybe<order_by>;
  geocodeaccuracy?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  isactive?: InputMaybe<order_by>;
  isextindicatorvisible?: InputMaybe<order_by>;
  isprofilephotoactive?: InputMaybe<order_by>;
  languagelocalekey?: InputMaybe<order_by>;
  lastlogindate?: InputMaybe<order_by>;
  lastmodifiedbyid?: InputMaybe<order_by>;
  lastmodifieddate?: InputMaybe<order_by>;
  lastname?: InputMaybe<order_by>;
  lastpasswordchangedate?: InputMaybe<order_by>;
  lastreferenceddate?: InputMaybe<order_by>;
  lastvieweddate?: InputMaybe<order_by>;
  latitude?: InputMaybe<order_by>;
  localesidkey?: InputMaybe<order_by>;
  longitude?: InputMaybe<order_by>;
  managerid?: InputMaybe<order_by>;
  mediumbannerphotourl?: InputMaybe<order_by>;
  mediumphotourl?: InputMaybe<order_by>;
  middlename?: InputMaybe<order_by>;
  mobilephone?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  numberoffailedlogins?: InputMaybe<order_by>;
  offlinepdatrialexpirationdate?: InputMaybe<order_by>;
  offlinetrialexpirationdate?: InputMaybe<order_by>;
  outofofficemessage?: InputMaybe<order_by>;
  phone?: InputMaybe<order_by>;
  postalcode?: InputMaybe<order_by>;
  profileid?: InputMaybe<order_by>;
  receivesadmininfoemails?: InputMaybe<order_by>;
  receivesinfoemails?: InputMaybe<order_by>;
  senderemail?: InputMaybe<order_by>;
  sendername?: InputMaybe<order_by>;
  signature?: InputMaybe<order_by>;
  smallbannerphotourl?: InputMaybe<order_by>;
  smallphotourl?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  state?: InputMaybe<order_by>;
  stayintouchnote?: InputMaybe<order_by>;
  stayintouchsignature?: InputMaybe<order_by>;
  stayintouchsubject?: InputMaybe<order_by>;
  street?: InputMaybe<order_by>;
  suffix?: InputMaybe<order_by>;
  systemmodstamp?: InputMaybe<order_by>;
  timezonesidkey?: InputMaybe<order_by>;
  title?: InputMaybe<order_by>;
  username?: InputMaybe<order_by>;
  userpermissionsavantgouser?: InputMaybe<order_by>;
  userpermissionscallcenterautologin?: InputMaybe<order_by>;
  userpermissionsinteractionuser?: InputMaybe<order_by>;
  userpermissionsmarketinguser?: InputMaybe<order_by>;
  userpermissionsofflineuser?: InputMaybe<order_by>;
  userpermissionssfcontentuser?: InputMaybe<order_by>;
  userpermissionssupportuser?: InputMaybe<order_by>;
  userpreferencesactivityreminderspopup?: InputMaybe<order_by>;
  userpreferencesapexpagesdevelopermode?: InputMaybe<order_by>;
  userpreferencescachediagnostics?: InputMaybe<order_by>;
  userpreferencescreatelexappswtshown?: InputMaybe<order_by>;
  userpreferencesdisableallfeedsemail?: InputMaybe<order_by>;
  userpreferencesdisablebookmarkemail?: InputMaybe<order_by>;
  userpreferencesdisablechangecommentemail?: InputMaybe<order_by>;
  userpreferencesdisableendorsementemail?: InputMaybe<order_by>;
  userpreferencesdisablefilesharenotificationsforapi?: InputMaybe<order_by>;
  userpreferencesdisablefollowersemail?: InputMaybe<order_by>;
  userpreferencesdisablelatercommentemail?: InputMaybe<order_by>;
  userpreferencesdisablelikeemail?: InputMaybe<order_by>;
  userpreferencesdisablementionspostemail?: InputMaybe<order_by>;
  userpreferencesdisablemessageemail?: InputMaybe<order_by>;
  userpreferencesdisableprofilepostemail?: InputMaybe<order_by>;
  userpreferencesdisablesharepostemail?: InputMaybe<order_by>;
  userpreferencesdiscommentafterlikeemail?: InputMaybe<order_by>;
  userpreferencesdismentionscommentemail?: InputMaybe<order_by>;
  userpreferencesdisprofpostcommentemail?: InputMaybe<order_by>;
  userpreferencesenableautosubforfeeds?: InputMaybe<order_by>;
  userpreferenceseventreminderscheckboxdefault?: InputMaybe<order_by>;
  userpreferencesexcludemailappattachments?: InputMaybe<order_by>;
  userpreferencesfavoritesshowtopfavorites?: InputMaybe<order_by>;
  userpreferencesfavoriteswtshown?: InputMaybe<order_by>;
  userpreferencesglobalnavbarwtshown?: InputMaybe<order_by>;
  userpreferencesglobalnavgridmenuwtshown?: InputMaybe<order_by>;
  userpreferenceshascelebrationbadge?: InputMaybe<order_by>;
  userpreferenceshidebiggerphotocallout?: InputMaybe<order_by>;
  userpreferenceshidebrowseproductredirectconfirmation?: InputMaybe<order_by>;
  userpreferenceshidechatteronboardingsplash?: InputMaybe<order_by>;
  userpreferenceshidecsndesktoptask?: InputMaybe<order_by>;
  userpreferenceshidecsngetchattermobiletask?: InputMaybe<order_by>;
  userpreferenceshideenduseronboardingassistantmodal?: InputMaybe<order_by>;
  userpreferenceshideinvoicesredirectconfirmation?: InputMaybe<order_by>;
  userpreferenceshidelightningmigrationmodal?: InputMaybe<order_by>;
  userpreferenceshideonlinesalesappwelcomemat?: InputMaybe<order_by>;
  userpreferenceshides1browserui?: InputMaybe<order_by>;
  userpreferenceshidesecondchatteronboardingsplash?: InputMaybe<order_by>;
  userpreferenceshidesfxwelcomemat?: InputMaybe<order_by>;
  userpreferenceshidestatementsredirectconfirmation?: InputMaybe<order_by>;
  userpreferenceslightningexperiencepreferred?: InputMaybe<order_by>;
  userpreferencesnativeemailclient?: InputMaybe<order_by>;
  userpreferencesnewlightningreportrunpageenabled?: InputMaybe<order_by>;
  userpreferencespathassistantcollapsed?: InputMaybe<order_by>;
  userpreferencespreviewcustomtheme?: InputMaybe<order_by>;
  userpreferencespreviewlightning?: InputMaybe<order_by>;
  userpreferencesreceivenonotificationsasapprover?: InputMaybe<order_by>;
  userpreferencesreceivenotificationsasdelegatedapprover?: InputMaybe<order_by>;
  userpreferencesrecordhomereservedwtshown?: InputMaybe<order_by>;
  userpreferencesrecordhomesectioncollapsewtshown?: InputMaybe<order_by>;
  userpreferencesremindersoundoff?: InputMaybe<order_by>;
  userpreferencessendlistemailthroughexternalservice?: InputMaybe<order_by>;
  userpreferencesshowcitytoexternalusers?: InputMaybe<order_by>;
  userpreferencesshowcitytoguestusers?: InputMaybe<order_by>;
  userpreferencesshowcountrytoexternalusers?: InputMaybe<order_by>;
  userpreferencesshowcountrytoguestusers?: InputMaybe<order_by>;
  userpreferencesshowemailtoexternalusers?: InputMaybe<order_by>;
  userpreferencesshowemailtoguestusers?: InputMaybe<order_by>;
  userpreferencesshowfaxtoexternalusers?: InputMaybe<order_by>;
  userpreferencesshowfaxtoguestusers?: InputMaybe<order_by>;
  userpreferencesshowmanagertoexternalusers?: InputMaybe<order_by>;
  userpreferencesshowmanagertoguestusers?: InputMaybe<order_by>;
  userpreferencesshowmobilephonetoexternalusers?: InputMaybe<order_by>;
  userpreferencesshowmobilephonetoguestusers?: InputMaybe<order_by>;
  userpreferencesshowpostalcodetoexternalusers?: InputMaybe<order_by>;
  userpreferencesshowpostalcodetoguestusers?: InputMaybe<order_by>;
  userpreferencesshowprofilepictoguestusers?: InputMaybe<order_by>;
  userpreferencesshowstatetoexternalusers?: InputMaybe<order_by>;
  userpreferencesshowstatetoguestusers?: InputMaybe<order_by>;
  userpreferencesshowstreetaddresstoexternalusers?: InputMaybe<order_by>;
  userpreferencesshowstreetaddresstoguestusers?: InputMaybe<order_by>;
  userpreferencesshowtitletoexternalusers?: InputMaybe<order_by>;
  userpreferencesshowtitletoguestusers?: InputMaybe<order_by>;
  userpreferencesshowworkphonetoexternalusers?: InputMaybe<order_by>;
  userpreferencesshowworkphonetoguestusers?: InputMaybe<order_by>;
  userpreferencessortfeedbycomment?: InputMaybe<order_by>;
  userpreferencessrhoverrideactivities?: InputMaybe<order_by>;
  userpreferencessuppresseventsfxreminders?: InputMaybe<order_by>;
  userpreferencessuppresstasksfxreminders?: InputMaybe<order_by>;
  userpreferencestaskreminderscheckboxdefault?: InputMaybe<order_by>;
  userpreferencesuserdebugmodepref?: InputMaybe<order_by>;
  userroleid?: InputMaybe<order_by>;
  usertype?: InputMaybe<order_by>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type sf_users_prepend_input = {
  address?: InputMaybe<Scalars["jsonb"]>;
};

/** select columns of table "sf_users" */
export enum sf_users_select_column {
  /** column name */
  aboutme = "aboutme",
  /** column name */
  accountid = "accountid",
  /** column name */
  address = "address",
  /** column name */
  alias = "alias",
  /** column name */
  badgetext = "badgetext",
  /** column name */
  bannerphotourl = "bannerphotourl",
  /** column name */
  callcenterid = "callcenterid",
  /** column name */
  city = "city",
  /** column name */
  communitynickname = "communitynickname",
  /** column name */
  companyname = "companyname",
  /** column name */
  contactid = "contactid",
  /** column name */
  country = "country",
  /** column name */
  createdbyid = "createdbyid",
  /** column name */
  createddate = "createddate",
  /** column name */
  defaultgroupnotificationfrequency = "defaultgroupnotificationfrequency",
  /** column name */
  delegatedapproverid = "delegatedapproverid",
  /** column name */
  department = "department",
  /** column name */
  digestfrequency = "digestfrequency",
  /** column name */
  division = "division",
  /** column name */
  email = "email",
  /** column name */
  emailencodingkey = "emailencodingkey",
  /** column name */
  emailpreferencesautobcc = "emailpreferencesautobcc",
  /** column name */
  emailpreferencesautobccstayintouch = "emailpreferencesautobccstayintouch",
  /** column name */
  emailpreferencesstayintouchreminder = "emailpreferencesstayintouchreminder",
  /** column name */
  employeenumber = "employeenumber",
  /** column name */
  extension = "extension",
  /** column name */
  fax = "fax",
  /** column name */
  federationidentifier = "federationidentifier",
  /** column name */
  firstname = "firstname",
  /** column name */
  forecastenabled = "forecastenabled",
  /** column name */
  fullphotourl = "fullphotourl",
  /** column name */
  geocodeaccuracy = "geocodeaccuracy",
  /** column name */
  id = "id",
  /** column name */
  isactive = "isactive",
  /** column name */
  isextindicatorvisible = "isextindicatorvisible",
  /** column name */
  isprofilephotoactive = "isprofilephotoactive",
  /** column name */
  languagelocalekey = "languagelocalekey",
  /** column name */
  lastlogindate = "lastlogindate",
  /** column name */
  lastmodifiedbyid = "lastmodifiedbyid",
  /** column name */
  lastmodifieddate = "lastmodifieddate",
  /** column name */
  lastname = "lastname",
  /** column name */
  lastpasswordchangedate = "lastpasswordchangedate",
  /** column name */
  lastreferenceddate = "lastreferenceddate",
  /** column name */
  lastvieweddate = "lastvieweddate",
  /** column name */
  latitude = "latitude",
  /** column name */
  localesidkey = "localesidkey",
  /** column name */
  longitude = "longitude",
  /** column name */
  managerid = "managerid",
  /** column name */
  mediumbannerphotourl = "mediumbannerphotourl",
  /** column name */
  mediumphotourl = "mediumphotourl",
  /** column name */
  middlename = "middlename",
  /** column name */
  mobilephone = "mobilephone",
  /** column name */
  name = "name",
  /** column name */
  numberoffailedlogins = "numberoffailedlogins",
  /** column name */
  offlinepdatrialexpirationdate = "offlinepdatrialexpirationdate",
  /** column name */
  offlinetrialexpirationdate = "offlinetrialexpirationdate",
  /** column name */
  outofofficemessage = "outofofficemessage",
  /** column name */
  phone = "phone",
  /** column name */
  postalcode = "postalcode",
  /** column name */
  profileid = "profileid",
  /** column name */
  receivesadmininfoemails = "receivesadmininfoemails",
  /** column name */
  receivesinfoemails = "receivesinfoemails",
  /** column name */
  senderemail = "senderemail",
  /** column name */
  sendername = "sendername",
  /** column name */
  signature = "signature",
  /** column name */
  smallbannerphotourl = "smallbannerphotourl",
  /** column name */
  smallphotourl = "smallphotourl",
  /** column name */
  sort_id = "sort_id",
  /** column name */
  state = "state",
  /** column name */
  stayintouchnote = "stayintouchnote",
  /** column name */
  stayintouchsignature = "stayintouchsignature",
  /** column name */
  stayintouchsubject = "stayintouchsubject",
  /** column name */
  street = "street",
  /** column name */
  suffix = "suffix",
  /** column name */
  systemmodstamp = "systemmodstamp",
  /** column name */
  timezonesidkey = "timezonesidkey",
  /** column name */
  title = "title",
  /** column name */
  username = "username",
  /** column name */
  userpermissionsavantgouser = "userpermissionsavantgouser",
  /** column name */
  userpermissionscallcenterautologin = "userpermissionscallcenterautologin",
  /** column name */
  userpermissionsinteractionuser = "userpermissionsinteractionuser",
  /** column name */
  userpermissionsmarketinguser = "userpermissionsmarketinguser",
  /** column name */
  userpermissionsofflineuser = "userpermissionsofflineuser",
  /** column name */
  userpermissionssfcontentuser = "userpermissionssfcontentuser",
  /** column name */
  userpermissionssupportuser = "userpermissionssupportuser",
  /** column name */
  userpreferencesactivityreminderspopup = "userpreferencesactivityreminderspopup",
  /** column name */
  userpreferencesapexpagesdevelopermode = "userpreferencesapexpagesdevelopermode",
  /** column name */
  userpreferencescachediagnostics = "userpreferencescachediagnostics",
  /** column name */
  userpreferencescreatelexappswtshown = "userpreferencescreatelexappswtshown",
  /** column name */
  userpreferencesdisableallfeedsemail = "userpreferencesdisableallfeedsemail",
  /** column name */
  userpreferencesdisablebookmarkemail = "userpreferencesdisablebookmarkemail",
  /** column name */
  userpreferencesdisablechangecommentemail = "userpreferencesdisablechangecommentemail",
  /** column name */
  userpreferencesdisableendorsementemail = "userpreferencesdisableendorsementemail",
  /** column name */
  userpreferencesdisablefilesharenotificationsforapi = "userpreferencesdisablefilesharenotificationsforapi",
  /** column name */
  userpreferencesdisablefollowersemail = "userpreferencesdisablefollowersemail",
  /** column name */
  userpreferencesdisablelatercommentemail = "userpreferencesdisablelatercommentemail",
  /** column name */
  userpreferencesdisablelikeemail = "userpreferencesdisablelikeemail",
  /** column name */
  userpreferencesdisablementionspostemail = "userpreferencesdisablementionspostemail",
  /** column name */
  userpreferencesdisablemessageemail = "userpreferencesdisablemessageemail",
  /** column name */
  userpreferencesdisableprofilepostemail = "userpreferencesdisableprofilepostemail",
  /** column name */
  userpreferencesdisablesharepostemail = "userpreferencesdisablesharepostemail",
  /** column name */
  userpreferencesdiscommentafterlikeemail = "userpreferencesdiscommentafterlikeemail",
  /** column name */
  userpreferencesdismentionscommentemail = "userpreferencesdismentionscommentemail",
  /** column name */
  userpreferencesdisprofpostcommentemail = "userpreferencesdisprofpostcommentemail",
  /** column name */
  userpreferencesenableautosubforfeeds = "userpreferencesenableautosubforfeeds",
  /** column name */
  userpreferenceseventreminderscheckboxdefault = "userpreferenceseventreminderscheckboxdefault",
  /** column name */
  userpreferencesexcludemailappattachments = "userpreferencesexcludemailappattachments",
  /** column name */
  userpreferencesfavoritesshowtopfavorites = "userpreferencesfavoritesshowtopfavorites",
  /** column name */
  userpreferencesfavoriteswtshown = "userpreferencesfavoriteswtshown",
  /** column name */
  userpreferencesglobalnavbarwtshown = "userpreferencesglobalnavbarwtshown",
  /** column name */
  userpreferencesglobalnavgridmenuwtshown = "userpreferencesglobalnavgridmenuwtshown",
  /** column name */
  userpreferenceshascelebrationbadge = "userpreferenceshascelebrationbadge",
  /** column name */
  userpreferenceshidebiggerphotocallout = "userpreferenceshidebiggerphotocallout",
  /** column name */
  userpreferenceshidebrowseproductredirectconfirmation = "userpreferenceshidebrowseproductredirectconfirmation",
  /** column name */
  userpreferenceshidechatteronboardingsplash = "userpreferenceshidechatteronboardingsplash",
  /** column name */
  userpreferenceshidecsndesktoptask = "userpreferenceshidecsndesktoptask",
  /** column name */
  userpreferenceshidecsngetchattermobiletask = "userpreferenceshidecsngetchattermobiletask",
  /** column name */
  userpreferenceshideenduseronboardingassistantmodal = "userpreferenceshideenduseronboardingassistantmodal",
  /** column name */
  userpreferenceshideinvoicesredirectconfirmation = "userpreferenceshideinvoicesredirectconfirmation",
  /** column name */
  userpreferenceshidelightningmigrationmodal = "userpreferenceshidelightningmigrationmodal",
  /** column name */
  userpreferenceshideonlinesalesappwelcomemat = "userpreferenceshideonlinesalesappwelcomemat",
  /** column name */
  userpreferenceshides1browserui = "userpreferenceshides1browserui",
  /** column name */
  userpreferenceshidesecondchatteronboardingsplash = "userpreferenceshidesecondchatteronboardingsplash",
  /** column name */
  userpreferenceshidesfxwelcomemat = "userpreferenceshidesfxwelcomemat",
  /** column name */
  userpreferenceshidestatementsredirectconfirmation = "userpreferenceshidestatementsredirectconfirmation",
  /** column name */
  userpreferenceslightningexperiencepreferred = "userpreferenceslightningexperiencepreferred",
  /** column name */
  userpreferencesnativeemailclient = "userpreferencesnativeemailclient",
  /** column name */
  userpreferencesnewlightningreportrunpageenabled = "userpreferencesnewlightningreportrunpageenabled",
  /** column name */
  userpreferencespathassistantcollapsed = "userpreferencespathassistantcollapsed",
  /** column name */
  userpreferencespreviewcustomtheme = "userpreferencespreviewcustomtheme",
  /** column name */
  userpreferencespreviewlightning = "userpreferencespreviewlightning",
  /** column name */
  userpreferencesreceivenonotificationsasapprover = "userpreferencesreceivenonotificationsasapprover",
  /** column name */
  userpreferencesreceivenotificationsasdelegatedapprover = "userpreferencesreceivenotificationsasdelegatedapprover",
  /** column name */
  userpreferencesrecordhomereservedwtshown = "userpreferencesrecordhomereservedwtshown",
  /** column name */
  userpreferencesrecordhomesectioncollapsewtshown = "userpreferencesrecordhomesectioncollapsewtshown",
  /** column name */
  userpreferencesremindersoundoff = "userpreferencesremindersoundoff",
  /** column name */
  userpreferencessendlistemailthroughexternalservice = "userpreferencessendlistemailthroughexternalservice",
  /** column name */
  userpreferencesshowcitytoexternalusers = "userpreferencesshowcitytoexternalusers",
  /** column name */
  userpreferencesshowcitytoguestusers = "userpreferencesshowcitytoguestusers",
  /** column name */
  userpreferencesshowcountrytoexternalusers = "userpreferencesshowcountrytoexternalusers",
  /** column name */
  userpreferencesshowcountrytoguestusers = "userpreferencesshowcountrytoguestusers",
  /** column name */
  userpreferencesshowemailtoexternalusers = "userpreferencesshowemailtoexternalusers",
  /** column name */
  userpreferencesshowemailtoguestusers = "userpreferencesshowemailtoguestusers",
  /** column name */
  userpreferencesshowfaxtoexternalusers = "userpreferencesshowfaxtoexternalusers",
  /** column name */
  userpreferencesshowfaxtoguestusers = "userpreferencesshowfaxtoguestusers",
  /** column name */
  userpreferencesshowmanagertoexternalusers = "userpreferencesshowmanagertoexternalusers",
  /** column name */
  userpreferencesshowmanagertoguestusers = "userpreferencesshowmanagertoguestusers",
  /** column name */
  userpreferencesshowmobilephonetoexternalusers = "userpreferencesshowmobilephonetoexternalusers",
  /** column name */
  userpreferencesshowmobilephonetoguestusers = "userpreferencesshowmobilephonetoguestusers",
  /** column name */
  userpreferencesshowpostalcodetoexternalusers = "userpreferencesshowpostalcodetoexternalusers",
  /** column name */
  userpreferencesshowpostalcodetoguestusers = "userpreferencesshowpostalcodetoguestusers",
  /** column name */
  userpreferencesshowprofilepictoguestusers = "userpreferencesshowprofilepictoguestusers",
  /** column name */
  userpreferencesshowstatetoexternalusers = "userpreferencesshowstatetoexternalusers",
  /** column name */
  userpreferencesshowstatetoguestusers = "userpreferencesshowstatetoguestusers",
  /** column name */
  userpreferencesshowstreetaddresstoexternalusers = "userpreferencesshowstreetaddresstoexternalusers",
  /** column name */
  userpreferencesshowstreetaddresstoguestusers = "userpreferencesshowstreetaddresstoguestusers",
  /** column name */
  userpreferencesshowtitletoexternalusers = "userpreferencesshowtitletoexternalusers",
  /** column name */
  userpreferencesshowtitletoguestusers = "userpreferencesshowtitletoguestusers",
  /** column name */
  userpreferencesshowworkphonetoexternalusers = "userpreferencesshowworkphonetoexternalusers",
  /** column name */
  userpreferencesshowworkphonetoguestusers = "userpreferencesshowworkphonetoguestusers",
  /** column name */
  userpreferencessortfeedbycomment = "userpreferencessortfeedbycomment",
  /** column name */
  userpreferencessrhoverrideactivities = "userpreferencessrhoverrideactivities",
  /** column name */
  userpreferencessuppresseventsfxreminders = "userpreferencessuppresseventsfxreminders",
  /** column name */
  userpreferencessuppresstasksfxreminders = "userpreferencessuppresstasksfxreminders",
  /** column name */
  userpreferencestaskreminderscheckboxdefault = "userpreferencestaskreminderscheckboxdefault",
  /** column name */
  userpreferencesuserdebugmodepref = "userpreferencesuserdebugmodepref",
  /** column name */
  userroleid = "userroleid",
  /** column name */
  usertype = "usertype",
}

/** input type for updating data in table "sf_users" */
export type sf_users_set_input = {
  aboutme?: InputMaybe<Scalars["String"]>;
  accountid?: InputMaybe<Scalars["String"]>;
  address?: InputMaybe<Scalars["jsonb"]>;
  alias?: InputMaybe<Scalars["String"]>;
  badgetext?: InputMaybe<Scalars["String"]>;
  bannerphotourl?: InputMaybe<Scalars["String"]>;
  callcenterid?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  communitynickname?: InputMaybe<Scalars["String"]>;
  companyname?: InputMaybe<Scalars["String"]>;
  contactid?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  createdbyid?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  defaultgroupnotificationfrequency?: InputMaybe<Scalars["String"]>;
  delegatedapproverid?: InputMaybe<Scalars["String"]>;
  department?: InputMaybe<Scalars["String"]>;
  digestfrequency?: InputMaybe<Scalars["String"]>;
  division?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["String"]>;
  emailencodingkey?: InputMaybe<Scalars["String"]>;
  emailpreferencesautobcc?: InputMaybe<Scalars["Boolean"]>;
  emailpreferencesautobccstayintouch?: InputMaybe<Scalars["Boolean"]>;
  emailpreferencesstayintouchreminder?: InputMaybe<Scalars["Boolean"]>;
  employeenumber?: InputMaybe<Scalars["String"]>;
  extension?: InputMaybe<Scalars["String"]>;
  fax?: InputMaybe<Scalars["String"]>;
  federationidentifier?: InputMaybe<Scalars["String"]>;
  firstname?: InputMaybe<Scalars["String"]>;
  forecastenabled?: InputMaybe<Scalars["Boolean"]>;
  fullphotourl?: InputMaybe<Scalars["String"]>;
  geocodeaccuracy?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  isactive?: InputMaybe<Scalars["Boolean"]>;
  isextindicatorvisible?: InputMaybe<Scalars["Boolean"]>;
  isprofilephotoactive?: InputMaybe<Scalars["Boolean"]>;
  languagelocalekey?: InputMaybe<Scalars["String"]>;
  lastlogindate?: InputMaybe<Scalars["timestamp"]>;
  lastmodifiedbyid?: InputMaybe<Scalars["String"]>;
  lastmodifieddate?: InputMaybe<Scalars["timestamp"]>;
  lastname?: InputMaybe<Scalars["String"]>;
  lastpasswordchangedate?: InputMaybe<Scalars["timestamp"]>;
  lastreferenceddate?: InputMaybe<Scalars["timestamp"]>;
  lastvieweddate?: InputMaybe<Scalars["timestamp"]>;
  latitude?: InputMaybe<Scalars["numeric"]>;
  localesidkey?: InputMaybe<Scalars["String"]>;
  longitude?: InputMaybe<Scalars["numeric"]>;
  managerid?: InputMaybe<Scalars["String"]>;
  mediumbannerphotourl?: InputMaybe<Scalars["String"]>;
  mediumphotourl?: InputMaybe<Scalars["String"]>;
  middlename?: InputMaybe<Scalars["String"]>;
  mobilephone?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  numberoffailedlogins?: InputMaybe<Scalars["Int"]>;
  offlinepdatrialexpirationdate?: InputMaybe<Scalars["timestamp"]>;
  offlinetrialexpirationdate?: InputMaybe<Scalars["timestamp"]>;
  outofofficemessage?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  postalcode?: InputMaybe<Scalars["String"]>;
  profileid?: InputMaybe<Scalars["String"]>;
  receivesadmininfoemails?: InputMaybe<Scalars["Boolean"]>;
  receivesinfoemails?: InputMaybe<Scalars["Boolean"]>;
  senderemail?: InputMaybe<Scalars["String"]>;
  sendername?: InputMaybe<Scalars["String"]>;
  signature?: InputMaybe<Scalars["String"]>;
  smallbannerphotourl?: InputMaybe<Scalars["String"]>;
  smallphotourl?: InputMaybe<Scalars["String"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  state?: InputMaybe<Scalars["String"]>;
  stayintouchnote?: InputMaybe<Scalars["String"]>;
  stayintouchsignature?: InputMaybe<Scalars["String"]>;
  stayintouchsubject?: InputMaybe<Scalars["String"]>;
  street?: InputMaybe<Scalars["String"]>;
  suffix?: InputMaybe<Scalars["String"]>;
  systemmodstamp?: InputMaybe<Scalars["timestamp"]>;
  timezonesidkey?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
  username?: InputMaybe<Scalars["String"]>;
  userpermissionsavantgouser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionscallcenterautologin?: InputMaybe<Scalars["Boolean"]>;
  userpermissionsinteractionuser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionsmarketinguser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionsofflineuser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionssfcontentuser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionssupportuser?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesactivityreminderspopup?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesapexpagesdevelopermode?: InputMaybe<Scalars["Boolean"]>;
  userpreferencescachediagnostics?: InputMaybe<Scalars["Boolean"]>;
  userpreferencescreatelexappswtshown?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisableallfeedsemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablebookmarkemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablechangecommentemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisableendorsementemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablefilesharenotificationsforapi?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesdisablefollowersemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablelatercommentemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablelikeemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablementionspostemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablemessageemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisableprofilepostemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablesharepostemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdiscommentafterlikeemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdismentionscommentemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisprofpostcommentemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesenableautosubforfeeds?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceseventreminderscheckboxdefault?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesexcludemailappattachments?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesfavoritesshowtopfavorites?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesfavoriteswtshown?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesglobalnavbarwtshown?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesglobalnavgridmenuwtshown?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshascelebrationbadge?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidebiggerphotocallout?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidebrowseproductredirectconfirmation?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferenceshidechatteronboardingsplash?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidecsndesktoptask?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidecsngetchattermobiletask?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshideenduseronboardingassistantmodal?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferenceshideinvoicesredirectconfirmation?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferenceshidelightningmigrationmodal?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshideonlinesalesappwelcomemat?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshides1browserui?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidesecondchatteronboardingsplash?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferenceshidesfxwelcomemat?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidestatementsredirectconfirmation?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferenceslightningexperiencepreferred?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesnativeemailclient?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesnewlightningreportrunpageenabled?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencespathassistantcollapsed?: InputMaybe<Scalars["Boolean"]>;
  userpreferencespreviewcustomtheme?: InputMaybe<Scalars["Boolean"]>;
  userpreferencespreviewlightning?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesreceivenonotificationsasapprover?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesreceivenotificationsasdelegatedapprover?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesrecordhomereservedwtshown?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesrecordhomesectioncollapsewtshown?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesremindersoundoff?: InputMaybe<Scalars["Boolean"]>;
  userpreferencessendlistemailthroughexternalservice?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesshowcitytoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowcitytoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowcountrytoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowcountrytoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowemailtoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowemailtoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowfaxtoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowfaxtoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowmanagertoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowmanagertoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowmobilephonetoexternalusers?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesshowmobilephonetoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowpostalcodetoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowpostalcodetoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowprofilepictoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowstatetoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowstatetoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowstreetaddresstoexternalusers?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesshowstreetaddresstoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowtitletoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowtitletoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowworkphonetoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowworkphonetoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencessortfeedbycomment?: InputMaybe<Scalars["Boolean"]>;
  userpreferencessrhoverrideactivities?: InputMaybe<Scalars["Boolean"]>;
  userpreferencessuppresseventsfxreminders?: InputMaybe<Scalars["Boolean"]>;
  userpreferencessuppresstasksfxreminders?: InputMaybe<Scalars["Boolean"]>;
  userpreferencestaskreminderscheckboxdefault?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesuserdebugmodepref?: InputMaybe<Scalars["Boolean"]>;
  userroleid?: InputMaybe<Scalars["String"]>;
  usertype?: InputMaybe<Scalars["String"]>;
};

/** Streaming cursor of the table "sf_users" */
export type sf_users_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: sf_users_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type sf_users_stream_cursor_value_input = {
  aboutme?: InputMaybe<Scalars["String"]>;
  accountid?: InputMaybe<Scalars["String"]>;
  address?: InputMaybe<Scalars["jsonb"]>;
  alias?: InputMaybe<Scalars["String"]>;
  badgetext?: InputMaybe<Scalars["String"]>;
  bannerphotourl?: InputMaybe<Scalars["String"]>;
  callcenterid?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  communitynickname?: InputMaybe<Scalars["String"]>;
  companyname?: InputMaybe<Scalars["String"]>;
  contactid?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  createdbyid?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  defaultgroupnotificationfrequency?: InputMaybe<Scalars["String"]>;
  delegatedapproverid?: InputMaybe<Scalars["String"]>;
  department?: InputMaybe<Scalars["String"]>;
  digestfrequency?: InputMaybe<Scalars["String"]>;
  division?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["String"]>;
  emailencodingkey?: InputMaybe<Scalars["String"]>;
  emailpreferencesautobcc?: InputMaybe<Scalars["Boolean"]>;
  emailpreferencesautobccstayintouch?: InputMaybe<Scalars["Boolean"]>;
  emailpreferencesstayintouchreminder?: InputMaybe<Scalars["Boolean"]>;
  employeenumber?: InputMaybe<Scalars["String"]>;
  extension?: InputMaybe<Scalars["String"]>;
  fax?: InputMaybe<Scalars["String"]>;
  federationidentifier?: InputMaybe<Scalars["String"]>;
  firstname?: InputMaybe<Scalars["String"]>;
  forecastenabled?: InputMaybe<Scalars["Boolean"]>;
  fullphotourl?: InputMaybe<Scalars["String"]>;
  geocodeaccuracy?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  isactive?: InputMaybe<Scalars["Boolean"]>;
  isextindicatorvisible?: InputMaybe<Scalars["Boolean"]>;
  isprofilephotoactive?: InputMaybe<Scalars["Boolean"]>;
  languagelocalekey?: InputMaybe<Scalars["String"]>;
  lastlogindate?: InputMaybe<Scalars["timestamp"]>;
  lastmodifiedbyid?: InputMaybe<Scalars["String"]>;
  lastmodifieddate?: InputMaybe<Scalars["timestamp"]>;
  lastname?: InputMaybe<Scalars["String"]>;
  lastpasswordchangedate?: InputMaybe<Scalars["timestamp"]>;
  lastreferenceddate?: InputMaybe<Scalars["timestamp"]>;
  lastvieweddate?: InputMaybe<Scalars["timestamp"]>;
  latitude?: InputMaybe<Scalars["numeric"]>;
  localesidkey?: InputMaybe<Scalars["String"]>;
  longitude?: InputMaybe<Scalars["numeric"]>;
  managerid?: InputMaybe<Scalars["String"]>;
  mediumbannerphotourl?: InputMaybe<Scalars["String"]>;
  mediumphotourl?: InputMaybe<Scalars["String"]>;
  middlename?: InputMaybe<Scalars["String"]>;
  mobilephone?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  numberoffailedlogins?: InputMaybe<Scalars["Int"]>;
  offlinepdatrialexpirationdate?: InputMaybe<Scalars["timestamp"]>;
  offlinetrialexpirationdate?: InputMaybe<Scalars["timestamp"]>;
  outofofficemessage?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  postalcode?: InputMaybe<Scalars["String"]>;
  profileid?: InputMaybe<Scalars["String"]>;
  receivesadmininfoemails?: InputMaybe<Scalars["Boolean"]>;
  receivesinfoemails?: InputMaybe<Scalars["Boolean"]>;
  senderemail?: InputMaybe<Scalars["String"]>;
  sendername?: InputMaybe<Scalars["String"]>;
  signature?: InputMaybe<Scalars["String"]>;
  smallbannerphotourl?: InputMaybe<Scalars["String"]>;
  smallphotourl?: InputMaybe<Scalars["String"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  state?: InputMaybe<Scalars["String"]>;
  stayintouchnote?: InputMaybe<Scalars["String"]>;
  stayintouchsignature?: InputMaybe<Scalars["String"]>;
  stayintouchsubject?: InputMaybe<Scalars["String"]>;
  street?: InputMaybe<Scalars["String"]>;
  suffix?: InputMaybe<Scalars["String"]>;
  systemmodstamp?: InputMaybe<Scalars["timestamp"]>;
  timezonesidkey?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
  username?: InputMaybe<Scalars["String"]>;
  userpermissionsavantgouser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionscallcenterautologin?: InputMaybe<Scalars["Boolean"]>;
  userpermissionsinteractionuser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionsmarketinguser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionsofflineuser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionssfcontentuser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionssupportuser?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesactivityreminderspopup?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesapexpagesdevelopermode?: InputMaybe<Scalars["Boolean"]>;
  userpreferencescachediagnostics?: InputMaybe<Scalars["Boolean"]>;
  userpreferencescreatelexappswtshown?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisableallfeedsemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablebookmarkemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablechangecommentemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisableendorsementemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablefilesharenotificationsforapi?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesdisablefollowersemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablelatercommentemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablelikeemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablementionspostemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablemessageemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisableprofilepostemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablesharepostemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdiscommentafterlikeemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdismentionscommentemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisprofpostcommentemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesenableautosubforfeeds?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceseventreminderscheckboxdefault?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesexcludemailappattachments?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesfavoritesshowtopfavorites?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesfavoriteswtshown?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesglobalnavbarwtshown?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesglobalnavgridmenuwtshown?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshascelebrationbadge?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidebiggerphotocallout?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidebrowseproductredirectconfirmation?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferenceshidechatteronboardingsplash?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidecsndesktoptask?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidecsngetchattermobiletask?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshideenduseronboardingassistantmodal?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferenceshideinvoicesredirectconfirmation?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferenceshidelightningmigrationmodal?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshideonlinesalesappwelcomemat?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshides1browserui?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidesecondchatteronboardingsplash?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferenceshidesfxwelcomemat?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidestatementsredirectconfirmation?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferenceslightningexperiencepreferred?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesnativeemailclient?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesnewlightningreportrunpageenabled?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencespathassistantcollapsed?: InputMaybe<Scalars["Boolean"]>;
  userpreferencespreviewcustomtheme?: InputMaybe<Scalars["Boolean"]>;
  userpreferencespreviewlightning?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesreceivenonotificationsasapprover?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesreceivenotificationsasdelegatedapprover?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesrecordhomereservedwtshown?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesrecordhomesectioncollapsewtshown?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesremindersoundoff?: InputMaybe<Scalars["Boolean"]>;
  userpreferencessendlistemailthroughexternalservice?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesshowcitytoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowcitytoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowcountrytoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowcountrytoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowemailtoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowemailtoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowfaxtoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowfaxtoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowmanagertoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowmanagertoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowmobilephonetoexternalusers?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesshowmobilephonetoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowpostalcodetoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowpostalcodetoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowprofilepictoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowstatetoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowstatetoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowstreetaddresstoexternalusers?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesshowstreetaddresstoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowtitletoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowtitletoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowworkphonetoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowworkphonetoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencessortfeedbycomment?: InputMaybe<Scalars["Boolean"]>;
  userpreferencessrhoverrideactivities?: InputMaybe<Scalars["Boolean"]>;
  userpreferencessuppresseventsfxreminders?: InputMaybe<Scalars["Boolean"]>;
  userpreferencessuppresstasksfxreminders?: InputMaybe<Scalars["Boolean"]>;
  userpreferencestaskreminderscheckboxdefault?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesuserdebugmodepref?: InputMaybe<Scalars["Boolean"]>;
  userroleid?: InputMaybe<Scalars["String"]>;
  usertype?: InputMaybe<Scalars["String"]>;
};

export type sf_users_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<sf_users_append_input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<sf_users_delete_at_path_input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<sf_users_delete_elem_input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<sf_users_delete_key_input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<sf_users_inc_input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<sf_users_prepend_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<sf_users_set_input>;
  where: sf_users_bool_exp;
};

export type task_effort_engagement_mapping_aggregate_bool_exp = {
  count?: InputMaybe<task_effort_engagement_mapping_aggregate_bool_exp_count>;
};

export type task_effort_engagement_mapping_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<task_effort_engagement_mapping_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<task_effort_engagement_mapping_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_aggregate_order_by = {
  avg?: InputMaybe<task_effort_engagement_mapping_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<task_effort_engagement_mapping_max_order_by>;
  min?: InputMaybe<task_effort_engagement_mapping_min_order_by>;
  stddev?: InputMaybe<task_effort_engagement_mapping_stddev_order_by>;
  stddev_pop?: InputMaybe<task_effort_engagement_mapping_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<task_effort_engagement_mapping_stddev_samp_order_by>;
  sum?: InputMaybe<task_effort_engagement_mapping_sum_order_by>;
  var_pop?: InputMaybe<task_effort_engagement_mapping_var_pop_order_by>;
  var_samp?: InputMaybe<task_effort_engagement_mapping_var_samp_order_by>;
  variance?: InputMaybe<task_effort_engagement_mapping_variance_order_by>;
};

/** input type for inserting array relation for remote table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_arr_rel_insert_input = {
  data: Array<task_effort_engagement_mapping_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<task_effort_engagement_mapping_on_conflict>;
};

/** order by avg() on columns of table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_avg_order_by = {
  task_categorization?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "task_effort_engagement_mapping". All fields are combined with a logical 'AND'. */
export type task_effort_engagement_mapping_bool_exp = {
  _and?: InputMaybe<Array<task_effort_engagement_mapping_bool_exp>>;
  _not?: InputMaybe<task_effort_engagement_mapping_bool_exp>;
  _or?: InputMaybe<Array<task_effort_engagement_mapping_bool_exp>>;
  accountid?: InputMaybe<String_comparison_exp>;
  activitydate?: InputMaybe<timestamp_comparison_exp>;
  createddate?: InputMaybe<timestamp_comparison_exp>;
  ownerid?: InputMaybe<String_comparison_exp>;
  subject?: InputMaybe<String_comparison_exp>;
  task_categorization?: InputMaybe<Int_comparison_exp>;
  task_id?: InputMaybe<String_comparison_exp>;
  whatid?: InputMaybe<String_comparison_exp>;
  whoid?: InputMaybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "task_effort_engagement_mapping" */
export enum task_effort_engagement_mapping_constraint {
  /** unique or primary key constraint on columns "task_id" */
  task_effort_engagement_mapping_pkey = "task_effort_engagement_mapping_pkey",
}

/** input type for incrementing numeric columns in table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_inc_input = {
  task_categorization?: InputMaybe<Scalars["Int"]>;
};

/** input type for inserting data into table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_insert_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  activitydate?: InputMaybe<Scalars["timestamp"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  subject?: InputMaybe<Scalars["String"]>;
  task_categorization?: InputMaybe<Scalars["Int"]>;
  task_id?: InputMaybe<Scalars["String"]>;
  whatid?: InputMaybe<Scalars["String"]>;
  whoid?: InputMaybe<Scalars["String"]>;
};

/** order by max() on columns of table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_max_order_by = {
  accountid?: InputMaybe<order_by>;
  activitydate?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  subject?: InputMaybe<order_by>;
  task_categorization?: InputMaybe<order_by>;
  task_id?: InputMaybe<order_by>;
  whatid?: InputMaybe<order_by>;
  whoid?: InputMaybe<order_by>;
};

/** order by min() on columns of table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_min_order_by = {
  accountid?: InputMaybe<order_by>;
  activitydate?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  subject?: InputMaybe<order_by>;
  task_categorization?: InputMaybe<order_by>;
  task_id?: InputMaybe<order_by>;
  whatid?: InputMaybe<order_by>;
  whoid?: InputMaybe<order_by>;
};

/** on_conflict condition type for table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_on_conflict = {
  constraint: task_effort_engagement_mapping_constraint;
  update_columns?: Array<task_effort_engagement_mapping_update_column>;
  where?: InputMaybe<task_effort_engagement_mapping_bool_exp>;
};

/** Ordering options when selecting data from "task_effort_engagement_mapping". */
export type task_effort_engagement_mapping_order_by = {
  accountid?: InputMaybe<order_by>;
  activitydate?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  subject?: InputMaybe<order_by>;
  task_categorization?: InputMaybe<order_by>;
  task_id?: InputMaybe<order_by>;
  whatid?: InputMaybe<order_by>;
  whoid?: InputMaybe<order_by>;
};

/** primary key columns input for table: task_effort_engagement_mapping */
export type task_effort_engagement_mapping_pk_columns_input = {
  task_id: Scalars["String"];
};

/** select columns of table "task_effort_engagement_mapping" */
export enum task_effort_engagement_mapping_select_column {
  /** column name */
  accountid = "accountid",
  /** column name */
  activitydate = "activitydate",
  /** column name */
  createddate = "createddate",
  /** column name */
  ownerid = "ownerid",
  /** column name */
  subject = "subject",
  /** column name */
  task_categorization = "task_categorization",
  /** column name */
  task_id = "task_id",
  /** column name */
  whatid = "whatid",
  /** column name */
  whoid = "whoid",
}

/** input type for updating data in table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_set_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  activitydate?: InputMaybe<Scalars["timestamp"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  subject?: InputMaybe<Scalars["String"]>;
  task_categorization?: InputMaybe<Scalars["Int"]>;
  task_id?: InputMaybe<Scalars["String"]>;
  whatid?: InputMaybe<Scalars["String"]>;
  whoid?: InputMaybe<Scalars["String"]>;
};

/** order by stddev() on columns of table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_stddev_order_by = {
  task_categorization?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_stddev_pop_order_by = {
  task_categorization?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_stddev_samp_order_by = {
  task_categorization?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: task_effort_engagement_mapping_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type task_effort_engagement_mapping_stream_cursor_value_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  activitydate?: InputMaybe<Scalars["timestamp"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  subject?: InputMaybe<Scalars["String"]>;
  task_categorization?: InputMaybe<Scalars["Int"]>;
  task_id?: InputMaybe<Scalars["String"]>;
  whatid?: InputMaybe<Scalars["String"]>;
  whoid?: InputMaybe<Scalars["String"]>;
};

/** order by sum() on columns of table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_sum_order_by = {
  task_categorization?: InputMaybe<order_by>;
};

/** update columns of table "task_effort_engagement_mapping" */
export enum task_effort_engagement_mapping_update_column {
  /** column name */
  accountid = "accountid",
  /** column name */
  activitydate = "activitydate",
  /** column name */
  createddate = "createddate",
  /** column name */
  ownerid = "ownerid",
  /** column name */
  subject = "subject",
  /** column name */
  task_categorization = "task_categorization",
  /** column name */
  task_id = "task_id",
  /** column name */
  whatid = "whatid",
  /** column name */
  whoid = "whoid",
}

export type task_effort_engagement_mapping_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<task_effort_engagement_mapping_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<task_effort_engagement_mapping_set_input>;
  where: task_effort_engagement_mapping_bool_exp;
};

/** order by var_pop() on columns of table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_var_pop_order_by = {
  task_categorization?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_var_samp_order_by = {
  task_categorization?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_variance_order_by = {
  task_categorization?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "team_activity_gql". All fields are combined with a logical 'AND'. */
export type team_activity_gql_bool_exp = {
  _and?: InputMaybe<Array<team_activity_gql_bool_exp>>;
  _not?: InputMaybe<team_activity_gql_bool_exp>;
  _or?: InputMaybe<Array<team_activity_gql_bool_exp>>;
  calls_actuals?: InputMaybe<numeric_comparison_exp>;
  calls_out?: InputMaybe<numeric_comparison_exp>;
  calls_target?: InputMaybe<numeric_comparison_exp>;
  email_actuals?: InputMaybe<numeric_comparison_exp>;
  email_targets?: InputMaybe<numeric_comparison_exp>;
  emails_sent?: InputMaybe<numeric_comparison_exp>;
  key?: InputMaybe<Int_comparison_exp>;
  meeting_actuals?: InputMaybe<bigint_comparison_exp>;
  meeting_targets?: InputMaybe<float8_comparison_exp>;
  meetings?: InputMaybe<float8_comparison_exp>;
  opportunities?: InputMaybe<float8_comparison_exp>;
  opportunity_actuals?: InputMaybe<bigint_comparison_exp>;
  opportunity_targets?: InputMaybe<float8_comparison_exp>;
  social?: InputMaybe<numeric_comparison_exp>;
  social_actuals?: InputMaybe<numeric_comparison_exp>;
  social_target?: InputMaybe<numeric_comparison_exp>;
};

/** Ordering options when selecting data from "team_activity_gql". */
export type team_activity_gql_order_by = {
  calls_actuals?: InputMaybe<order_by>;
  calls_out?: InputMaybe<order_by>;
  calls_target?: InputMaybe<order_by>;
  email_actuals?: InputMaybe<order_by>;
  email_targets?: InputMaybe<order_by>;
  emails_sent?: InputMaybe<order_by>;
  key?: InputMaybe<order_by>;
  meeting_actuals?: InputMaybe<order_by>;
  meeting_targets?: InputMaybe<order_by>;
  meetings?: InputMaybe<order_by>;
  opportunities?: InputMaybe<order_by>;
  opportunity_actuals?: InputMaybe<order_by>;
  opportunity_targets?: InputMaybe<order_by>;
  social?: InputMaybe<order_by>;
  social_actuals?: InputMaybe<order_by>;
  social_target?: InputMaybe<order_by>;
};

/** select columns of table "team_activity_gql" */
export enum team_activity_gql_select_column {
  /** column name */
  calls_actuals = "calls_actuals",
  /** column name */
  calls_out = "calls_out",
  /** column name */
  calls_target = "calls_target",
  /** column name */
  email_actuals = "email_actuals",
  /** column name */
  email_targets = "email_targets",
  /** column name */
  emails_sent = "emails_sent",
  /** column name */
  key = "key",
  /** column name */
  meeting_actuals = "meeting_actuals",
  /** column name */
  meeting_targets = "meeting_targets",
  /** column name */
  meetings = "meetings",
  /** column name */
  opportunities = "opportunities",
  /** column name */
  opportunity_actuals = "opportunity_actuals",
  /** column name */
  opportunity_targets = "opportunity_targets",
  /** column name */
  social = "social",
  /** column name */
  social_actuals = "social_actuals",
  /** column name */
  social_target = "social_target",
}

/** Streaming cursor of the table "team_activity_gql" */
export type team_activity_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: team_activity_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type team_activity_gql_stream_cursor_value_input = {
  calls_actuals?: InputMaybe<Scalars["numeric"]>;
  calls_out?: InputMaybe<Scalars["numeric"]>;
  calls_target?: InputMaybe<Scalars["numeric"]>;
  email_actuals?: InputMaybe<Scalars["numeric"]>;
  email_targets?: InputMaybe<Scalars["numeric"]>;
  emails_sent?: InputMaybe<Scalars["numeric"]>;
  key?: InputMaybe<Scalars["Int"]>;
  meeting_actuals?: InputMaybe<Scalars["bigint"]>;
  meeting_targets?: InputMaybe<Scalars["float8"]>;
  meetings?: InputMaybe<Scalars["float8"]>;
  opportunities?: InputMaybe<Scalars["float8"]>;
  opportunity_actuals?: InputMaybe<Scalars["bigint"]>;
  opportunity_targets?: InputMaybe<Scalars["float8"]>;
  social?: InputMaybe<Scalars["numeric"]>;
  social_actuals?: InputMaybe<Scalars["numeric"]>;
  social_target?: InputMaybe<Scalars["numeric"]>;
};

export type team_members_aggregate_bool_exp = {
  count?: InputMaybe<team_members_aggregate_bool_exp_count>;
};

export type team_members_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<team_members_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<team_members_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "team_members" */
export type team_members_aggregate_order_by = {
  avg?: InputMaybe<team_members_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<team_members_max_order_by>;
  min?: InputMaybe<team_members_min_order_by>;
  stddev?: InputMaybe<team_members_stddev_order_by>;
  stddev_pop?: InputMaybe<team_members_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<team_members_stddev_samp_order_by>;
  sum?: InputMaybe<team_members_sum_order_by>;
  var_pop?: InputMaybe<team_members_var_pop_order_by>;
  var_samp?: InputMaybe<team_members_var_samp_order_by>;
  variance?: InputMaybe<team_members_variance_order_by>;
};

/** input type for inserting array relation for remote table "team_members" */
export type team_members_arr_rel_insert_input = {
  data: Array<team_members_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<team_members_on_conflict>;
};

/** order by avg() on columns of table "team_members" */
export type team_members_avg_order_by = {
  id?: InputMaybe<order_by>;
  team_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "team_members". All fields are combined with a logical 'AND'. */
export type team_members_bool_exp = {
  _and?: InputMaybe<Array<team_members_bool_exp>>;
  _not?: InputMaybe<team_members_bool_exp>;
  _or?: InputMaybe<Array<team_members_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<bigint_comparison_exp>;
  team_id?: InputMaybe<bigint_comparison_exp>;
  to_teams?: InputMaybe<teams_bool_exp>;
  to_users?: InputMaybe<users_bool_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user_id?: InputMaybe<uuid_comparison_exp>;
};

/** unique or primary key constraints on table "team_members" */
export enum team_members_constraint {
  /** unique or primary key constraint on columns "id" */
  team_members_pkey = "team_members_pkey",
}

/** input type for incrementing numeric columns in table "team_members" */
export type team_members_inc_input = {
  id?: InputMaybe<Scalars["bigint"]>;
  team_id?: InputMaybe<Scalars["bigint"]>;
};

/** input type for inserting data into table "team_members" */
export type team_members_insert_input = {
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  team_id?: InputMaybe<Scalars["bigint"]>;
  to_teams?: InputMaybe<teams_obj_rel_insert_input>;
  to_users?: InputMaybe<users_obj_rel_insert_input>;
  updated_at?: InputMaybe<Scalars["timestamptz"]>;
  user_id?: InputMaybe<Scalars["uuid"]>;
};

/** order by max() on columns of table "team_members" */
export type team_members_max_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  team_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "team_members" */
export type team_members_min_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  team_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** input type for inserting object relation for remote table "team_members" */
export type team_members_obj_rel_insert_input = {
  data: team_members_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<team_members_on_conflict>;
};

/** on_conflict condition type for table "team_members" */
export type team_members_on_conflict = {
  constraint: team_members_constraint;
  update_columns?: Array<team_members_update_column>;
  where?: InputMaybe<team_members_bool_exp>;
};

/** Ordering options when selecting data from "team_members". */
export type team_members_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  team_id?: InputMaybe<order_by>;
  to_teams?: InputMaybe<teams_order_by>;
  to_users?: InputMaybe<users_order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** primary key columns input for table: team_members */
export type team_members_pk_columns_input = {
  id: Scalars["bigint"];
};

/** select columns of table "team_members" */
export enum team_members_select_column {
  /** column name */
  created_at = "created_at",
  /** column name */
  id = "id",
  /** column name */
  team_id = "team_id",
  /** column name */
  updated_at = "updated_at",
  /** column name */
  user_id = "user_id",
}

/** input type for updating data in table "team_members" */
export type team_members_set_input = {
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  team_id?: InputMaybe<Scalars["bigint"]>;
  updated_at?: InputMaybe<Scalars["timestamptz"]>;
  user_id?: InputMaybe<Scalars["uuid"]>;
};

/** order by stddev() on columns of table "team_members" */
export type team_members_stddev_order_by = {
  id?: InputMaybe<order_by>;
  team_id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "team_members" */
export type team_members_stddev_pop_order_by = {
  id?: InputMaybe<order_by>;
  team_id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "team_members" */
export type team_members_stddev_samp_order_by = {
  id?: InputMaybe<order_by>;
  team_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "team_members" */
export type team_members_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: team_members_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type team_members_stream_cursor_value_input = {
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  team_id?: InputMaybe<Scalars["bigint"]>;
  updated_at?: InputMaybe<Scalars["timestamptz"]>;
  user_id?: InputMaybe<Scalars["uuid"]>;
};

/** order by sum() on columns of table "team_members" */
export type team_members_sum_order_by = {
  id?: InputMaybe<order_by>;
  team_id?: InputMaybe<order_by>;
};

/** update columns of table "team_members" */
export enum team_members_update_column {
  /** column name */
  created_at = "created_at",
  /** column name */
  id = "id",
  /** column name */
  team_id = "team_id",
  /** column name */
  updated_at = "updated_at",
  /** column name */
  user_id = "user_id",
}

export type team_members_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<team_members_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<team_members_set_input>;
  where: team_members_bool_exp;
};

/** order by var_pop() on columns of table "team_members" */
export type team_members_var_pop_order_by = {
  id?: InputMaybe<order_by>;
  team_id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "team_members" */
export type team_members_var_samp_order_by = {
  id?: InputMaybe<order_by>;
  team_id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "team_members" */
export type team_members_variance_order_by = {
  id?: InputMaybe<order_by>;
  team_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "teams". All fields are combined with a logical 'AND'. */
export type teams_bool_exp = {
  _and?: InputMaybe<Array<teams_bool_exp>>;
  _not?: InputMaybe<teams_bool_exp>;
  _or?: InputMaybe<Array<teams_bool_exp>>;
  call_target?: InputMaybe<bigint_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  email_target?: InputMaybe<bigint_comparison_exp>;
  id?: InputMaybe<bigint_comparison_exp>;
  is_deleted?: InputMaybe<Boolean_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  opportunity_target?: InputMaybe<bigint_comparison_exp>;
  social_target?: InputMaybe<bigint_comparison_exp>;
  to_members?: InputMaybe<team_members_bool_exp>;
  to_members_aggregate?: InputMaybe<team_members_aggregate_bool_exp>;
  type?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** unique or primary key constraints on table "teams" */
export enum teams_constraint {
  /** unique or primary key constraint on columns "id" */
  teams_pkey = "teams_pkey",
}

/** input type for incrementing numeric columns in table "teams" */
export type teams_inc_input = {
  call_target?: InputMaybe<Scalars["bigint"]>;
  email_target?: InputMaybe<Scalars["bigint"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  opportunity_target?: InputMaybe<Scalars["bigint"]>;
  social_target?: InputMaybe<Scalars["bigint"]>;
};

/** input type for inserting data into table "teams" */
export type teams_insert_input = {
  call_target?: InputMaybe<Scalars["bigint"]>;
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  email_target?: InputMaybe<Scalars["bigint"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  is_deleted?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["String"]>;
  opportunity_target?: InputMaybe<Scalars["bigint"]>;
  social_target?: InputMaybe<Scalars["bigint"]>;
  to_members?: InputMaybe<team_members_arr_rel_insert_input>;
  type?: InputMaybe<Scalars["String"]>;
  updated_at?: InputMaybe<Scalars["timestamptz"]>;
};

/** input type for inserting object relation for remote table "teams" */
export type teams_obj_rel_insert_input = {
  data: teams_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<teams_on_conflict>;
};

/** on_conflict condition type for table "teams" */
export type teams_on_conflict = {
  constraint: teams_constraint;
  update_columns?: Array<teams_update_column>;
  where?: InputMaybe<teams_bool_exp>;
};

/** Ordering options when selecting data from "teams". */
export type teams_order_by = {
  call_target?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  email_target?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  is_deleted?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  opportunity_target?: InputMaybe<order_by>;
  social_target?: InputMaybe<order_by>;
  to_members_aggregate?: InputMaybe<team_members_aggregate_order_by>;
  type?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** primary key columns input for table: teams */
export type teams_pk_columns_input = {
  id: Scalars["bigint"];
};

/** select columns of table "teams" */
export enum teams_select_column {
  /** column name */
  call_target = "call_target",
  /** column name */
  created_at = "created_at",
  /** column name */
  email_target = "email_target",
  /** column name */
  id = "id",
  /** column name */
  is_deleted = "is_deleted",
  /** column name */
  name = "name",
  /** column name */
  opportunity_target = "opportunity_target",
  /** column name */
  social_target = "social_target",
  /** column name */
  type = "type",
  /** column name */
  updated_at = "updated_at",
}

/** input type for updating data in table "teams" */
export type teams_set_input = {
  call_target?: InputMaybe<Scalars["bigint"]>;
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  email_target?: InputMaybe<Scalars["bigint"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  is_deleted?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["String"]>;
  opportunity_target?: InputMaybe<Scalars["bigint"]>;
  social_target?: InputMaybe<Scalars["bigint"]>;
  type?: InputMaybe<Scalars["String"]>;
  updated_at?: InputMaybe<Scalars["timestamptz"]>;
};

/** Streaming cursor of the table "teams" */
export type teams_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: teams_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type teams_stream_cursor_value_input = {
  call_target?: InputMaybe<Scalars["bigint"]>;
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  email_target?: InputMaybe<Scalars["bigint"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  is_deleted?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["String"]>;
  opportunity_target?: InputMaybe<Scalars["bigint"]>;
  social_target?: InputMaybe<Scalars["bigint"]>;
  type?: InputMaybe<Scalars["String"]>;
  updated_at?: InputMaybe<Scalars["timestamptz"]>;
};

/** update columns of table "teams" */
export enum teams_update_column {
  /** column name */
  call_target = "call_target",
  /** column name */
  created_at = "created_at",
  /** column name */
  email_target = "email_target",
  /** column name */
  id = "id",
  /** column name */
  is_deleted = "is_deleted",
  /** column name */
  name = "name",
  /** column name */
  opportunity_target = "opportunity_target",
  /** column name */
  social_target = "social_target",
  /** column name */
  type = "type",
  /** column name */
  updated_at = "updated_at",
}

export type teams_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<teams_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<teams_set_input>;
  where: teams_bool_exp;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type timestamp_comparison_exp = {
  _eq?: InputMaybe<Scalars["timestamp"]>;
  _gt?: InputMaybe<Scalars["timestamp"]>;
  _gte?: InputMaybe<Scalars["timestamp"]>;
  _in?: InputMaybe<Array<Scalars["timestamp"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["timestamp"]>;
  _lte?: InputMaybe<Scalars["timestamp"]>;
  _neq?: InputMaybe<Scalars["timestamp"]>;
  _nin?: InputMaybe<Array<Scalars["timestamp"]>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type timestamptz_comparison_exp = {
  _eq?: InputMaybe<Scalars["timestamptz"]>;
  _gt?: InputMaybe<Scalars["timestamptz"]>;
  _gte?: InputMaybe<Scalars["timestamptz"]>;
  _in?: InputMaybe<Array<Scalars["timestamptz"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["timestamptz"]>;
  _lte?: InputMaybe<Scalars["timestamptz"]>;
  _neq?: InputMaybe<Scalars["timestamptz"]>;
  _nin?: InputMaybe<Array<Scalars["timestamptz"]>>;
};

/** Boolean expression to filter rows from the table "user_photo_mapping". All fields are combined with a logical 'AND'. */
export type user_photo_mapping_bool_exp = {
  _and?: InputMaybe<Array<user_photo_mapping_bool_exp>>;
  _not?: InputMaybe<user_photo_mapping_bool_exp>;
  _or?: InputMaybe<Array<user_photo_mapping_bool_exp>>;
  email?: InputMaybe<String_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  ownerid?: InputMaybe<String_comparison_exp>;
  photo_url?: InputMaybe<String_comparison_exp>;
  revtron_role?: InputMaybe<String_comparison_exp>;
};

/** input type for inserting data into table "user_photo_mapping" */
export type user_photo_mapping_insert_input = {
  email?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  photo_url?: InputMaybe<Scalars["String"]>;
  revtron_role?: InputMaybe<Scalars["String"]>;
};

/** Ordering options when selecting data from "user_photo_mapping". */
export type user_photo_mapping_order_by = {
  email?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  photo_url?: InputMaybe<order_by>;
  revtron_role?: InputMaybe<order_by>;
};

/** select columns of table "user_photo_mapping" */
export enum user_photo_mapping_select_column {
  /** column name */
  email = "email",
  /** column name */
  name = "name",
  /** column name */
  ownerid = "ownerid",
  /** column name */
  photo_url = "photo_url",
  /** column name */
  revtron_role = "revtron_role",
}

/** input type for updating data in table "user_photo_mapping" */
export type user_photo_mapping_set_input = {
  email?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  photo_url?: InputMaybe<Scalars["String"]>;
  revtron_role?: InputMaybe<Scalars["String"]>;
};

/** Streaming cursor of the table "user_photo_mapping" */
export type user_photo_mapping_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: user_photo_mapping_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type user_photo_mapping_stream_cursor_value_input = {
  email?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  photo_url?: InputMaybe<Scalars["String"]>;
  revtron_role?: InputMaybe<Scalars["String"]>;
};

export type user_photo_mapping_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<user_photo_mapping_set_input>;
  where: user_photo_mapping_bool_exp;
};

export type users_aggregate_bool_exp = {
  bool_and?: InputMaybe<users_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<users_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<users_aggregate_bool_exp_count>;
};

export type users_aggregate_bool_exp_bool_and = {
  arguments: users_select_column_users_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<users_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type users_aggregate_bool_exp_bool_or = {
  arguments: users_select_column_users_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<users_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type users_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<users_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<users_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "auth.users" */
export type users_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<users_max_order_by>;
  min?: InputMaybe<users_min_order_by>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type users_append_input = {
  metadata?: InputMaybe<Scalars["jsonb"]>;
};

/** input type for inserting array relation for remote table "auth.users" */
export type users_arr_rel_insert_input = {
  data: Array<users_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<users_on_conflict>;
};

/** Boolean expression to filter rows from the table "auth.users". All fields are combined with a logical 'AND'. */
export type users_bool_exp = {
  _and?: InputMaybe<Array<users_bool_exp>>;
  _not?: InputMaybe<users_bool_exp>;
  _or?: InputMaybe<Array<users_bool_exp>>;
  activeMfaType?: InputMaybe<String_comparison_exp>;
  avatarUrl?: InputMaybe<String_comparison_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  crm_users?: InputMaybe<crm_users_bool_exp>;
  currentChallenge?: InputMaybe<String_comparison_exp>;
  defaultRole?: InputMaybe<String_comparison_exp>;
  defaultRoleByRole?: InputMaybe<authRoles_bool_exp>;
  disabled?: InputMaybe<Boolean_comparison_exp>;
  displayName?: InputMaybe<String_comparison_exp>;
  email?: InputMaybe<citext_comparison_exp>;
  emailVerified?: InputMaybe<Boolean_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  isAnonymous?: InputMaybe<Boolean_comparison_exp>;
  lastSeen?: InputMaybe<timestamptz_comparison_exp>;
  locale?: InputMaybe<String_comparison_exp>;
  metadata?: InputMaybe<jsonb_comparison_exp>;
  newEmail?: InputMaybe<citext_comparison_exp>;
  otpHash?: InputMaybe<String_comparison_exp>;
  otpHashExpiresAt?: InputMaybe<timestamptz_comparison_exp>;
  otpMethodLastUsed?: InputMaybe<String_comparison_exp>;
  passwordHash?: InputMaybe<String_comparison_exp>;
  phoneNumber?: InputMaybe<String_comparison_exp>;
  phoneNumberVerified?: InputMaybe<Boolean_comparison_exp>;
  refreshTokens?: InputMaybe<authRefreshTokens_bool_exp>;
  refreshTokens_aggregate?: InputMaybe<authRefreshTokens_aggregate_bool_exp>;
  revtron_team?: InputMaybe<team_members_bool_exp>;
  roles?: InputMaybe<authUserRoles_bool_exp>;
  roles_aggregate?: InputMaybe<authUserRoles_aggregate_bool_exp>;
  securityKeys?: InputMaybe<authUserSecurityKeys_bool_exp>;
  securityKeys_aggregate?: InputMaybe<authUserSecurityKeys_aggregate_bool_exp>;
  ticket?: InputMaybe<String_comparison_exp>;
  ticketExpiresAt?: InputMaybe<timestamptz_comparison_exp>;
  totpSecret?: InputMaybe<String_comparison_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
  userProviders?: InputMaybe<authUserProviders_bool_exp>;
  userProviders_aggregate?: InputMaybe<authUserProviders_aggregate_bool_exp>;
};

/** unique or primary key constraints on table "auth.users" */
export enum users_constraint {
  /** unique or primary key constraint on columns "email" */
  users_email_key = "users_email_key",
  /** unique or primary key constraint on columns "phone_number" */
  users_phone_number_key = "users_phone_number_key",
  /** unique or primary key constraint on columns "id" */
  users_pkey = "users_pkey",
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type users_delete_at_path_input = {
  metadata?: InputMaybe<Array<Scalars["String"]>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type users_delete_elem_input = {
  metadata?: InputMaybe<Scalars["Int"]>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type users_delete_key_input = {
  metadata?: InputMaybe<Scalars["String"]>;
};

/** input type for inserting data into table "auth.users" */
export type users_insert_input = {
  activeMfaType?: InputMaybe<Scalars["String"]>;
  avatarUrl?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  crm_users?: InputMaybe<crm_users_obj_rel_insert_input>;
  currentChallenge?: InputMaybe<Scalars["String"]>;
  defaultRole?: InputMaybe<Scalars["String"]>;
  defaultRoleByRole?: InputMaybe<authRoles_obj_rel_insert_input>;
  disabled?: InputMaybe<Scalars["Boolean"]>;
  displayName?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["citext"]>;
  emailVerified?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["uuid"]>;
  isAnonymous?: InputMaybe<Scalars["Boolean"]>;
  lastSeen?: InputMaybe<Scalars["timestamptz"]>;
  locale?: InputMaybe<Scalars["String"]>;
  metadata?: InputMaybe<Scalars["jsonb"]>;
  newEmail?: InputMaybe<Scalars["citext"]>;
  otpHash?: InputMaybe<Scalars["String"]>;
  otpHashExpiresAt?: InputMaybe<Scalars["timestamptz"]>;
  otpMethodLastUsed?: InputMaybe<Scalars["String"]>;
  passwordHash?: InputMaybe<Scalars["String"]>;
  phoneNumber?: InputMaybe<Scalars["String"]>;
  phoneNumberVerified?: InputMaybe<Scalars["Boolean"]>;
  refreshTokens?: InputMaybe<authRefreshTokens_arr_rel_insert_input>;
  revtron_team?: InputMaybe<team_members_obj_rel_insert_input>;
  roles?: InputMaybe<authUserRoles_arr_rel_insert_input>;
  securityKeys?: InputMaybe<authUserSecurityKeys_arr_rel_insert_input>;
  ticket?: InputMaybe<Scalars["String"]>;
  ticketExpiresAt?: InputMaybe<Scalars["timestamptz"]>;
  totpSecret?: InputMaybe<Scalars["String"]>;
  updatedAt?: InputMaybe<Scalars["timestamptz"]>;
  userProviders?: InputMaybe<authUserProviders_arr_rel_insert_input>;
};

/** order by max() on columns of table "auth.users" */
export type users_max_order_by = {
  activeMfaType?: InputMaybe<order_by>;
  avatarUrl?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  currentChallenge?: InputMaybe<order_by>;
  defaultRole?: InputMaybe<order_by>;
  displayName?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  lastSeen?: InputMaybe<order_by>;
  locale?: InputMaybe<order_by>;
  newEmail?: InputMaybe<order_by>;
  otpHash?: InputMaybe<order_by>;
  otpHashExpiresAt?: InputMaybe<order_by>;
  otpMethodLastUsed?: InputMaybe<order_by>;
  passwordHash?: InputMaybe<order_by>;
  phoneNumber?: InputMaybe<order_by>;
  ticket?: InputMaybe<order_by>;
  ticketExpiresAt?: InputMaybe<order_by>;
  totpSecret?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** order by min() on columns of table "auth.users" */
export type users_min_order_by = {
  activeMfaType?: InputMaybe<order_by>;
  avatarUrl?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  currentChallenge?: InputMaybe<order_by>;
  defaultRole?: InputMaybe<order_by>;
  displayName?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  lastSeen?: InputMaybe<order_by>;
  locale?: InputMaybe<order_by>;
  newEmail?: InputMaybe<order_by>;
  otpHash?: InputMaybe<order_by>;
  otpHashExpiresAt?: InputMaybe<order_by>;
  otpMethodLastUsed?: InputMaybe<order_by>;
  passwordHash?: InputMaybe<order_by>;
  phoneNumber?: InputMaybe<order_by>;
  ticket?: InputMaybe<order_by>;
  ticketExpiresAt?: InputMaybe<order_by>;
  totpSecret?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** input type for inserting object relation for remote table "auth.users" */
export type users_obj_rel_insert_input = {
  data: users_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<users_on_conflict>;
};

/** on_conflict condition type for table "auth.users" */
export type users_on_conflict = {
  constraint: users_constraint;
  update_columns?: Array<users_update_column>;
  where?: InputMaybe<users_bool_exp>;
};

/** Ordering options when selecting data from "auth.users". */
export type users_order_by = {
  activeMfaType?: InputMaybe<order_by>;
  avatarUrl?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  crm_users?: InputMaybe<crm_users_order_by>;
  currentChallenge?: InputMaybe<order_by>;
  defaultRole?: InputMaybe<order_by>;
  defaultRoleByRole?: InputMaybe<authRoles_order_by>;
  disabled?: InputMaybe<order_by>;
  displayName?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  emailVerified?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  isAnonymous?: InputMaybe<order_by>;
  lastSeen?: InputMaybe<order_by>;
  locale?: InputMaybe<order_by>;
  metadata?: InputMaybe<order_by>;
  newEmail?: InputMaybe<order_by>;
  otpHash?: InputMaybe<order_by>;
  otpHashExpiresAt?: InputMaybe<order_by>;
  otpMethodLastUsed?: InputMaybe<order_by>;
  passwordHash?: InputMaybe<order_by>;
  phoneNumber?: InputMaybe<order_by>;
  phoneNumberVerified?: InputMaybe<order_by>;
  refreshTokens_aggregate?: InputMaybe<authRefreshTokens_aggregate_order_by>;
  revtron_team?: InputMaybe<team_members_order_by>;
  roles_aggregate?: InputMaybe<authUserRoles_aggregate_order_by>;
  securityKeys_aggregate?: InputMaybe<authUserSecurityKeys_aggregate_order_by>;
  ticket?: InputMaybe<order_by>;
  ticketExpiresAt?: InputMaybe<order_by>;
  totpSecret?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  userProviders_aggregate?: InputMaybe<authUserProviders_aggregate_order_by>;
};

/** primary key columns input for table: auth.users */
export type users_pk_columns_input = {
  id: Scalars["uuid"];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type users_prepend_input = {
  metadata?: InputMaybe<Scalars["jsonb"]>;
};

/** select columns of table "auth.users" */
export enum users_select_column {
  /** column name */
  activeMfaType = "activeMfaType",
  /** column name */
  avatarUrl = "avatarUrl",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  currentChallenge = "currentChallenge",
  /** column name */
  defaultRole = "defaultRole",
  /** column name */
  disabled = "disabled",
  /** column name */
  displayName = "displayName",
  /** column name */
  email = "email",
  /** column name */
  emailVerified = "emailVerified",
  /** column name */
  id = "id",
  /** column name */
  isAnonymous = "isAnonymous",
  /** column name */
  lastSeen = "lastSeen",
  /** column name */
  locale = "locale",
  /** column name */
  metadata = "metadata",
  /** column name */
  newEmail = "newEmail",
  /** column name */
  otpHash = "otpHash",
  /** column name */
  otpHashExpiresAt = "otpHashExpiresAt",
  /** column name */
  otpMethodLastUsed = "otpMethodLastUsed",
  /** column name */
  passwordHash = "passwordHash",
  /** column name */
  phoneNumber = "phoneNumber",
  /** column name */
  phoneNumberVerified = "phoneNumberVerified",
  /** column name */
  ticket = "ticket",
  /** column name */
  ticketExpiresAt = "ticketExpiresAt",
  /** column name */
  totpSecret = "totpSecret",
  /** column name */
  updatedAt = "updatedAt",
}

/** select "users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "auth.users" */
export enum users_select_column_users_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  disabled = "disabled",
  /** column name */
  emailVerified = "emailVerified",
  /** column name */
  isAnonymous = "isAnonymous",
  /** column name */
  phoneNumberVerified = "phoneNumberVerified",
}

/** select "users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "auth.users" */
export enum users_select_column_users_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  disabled = "disabled",
  /** column name */
  emailVerified = "emailVerified",
  /** column name */
  isAnonymous = "isAnonymous",
  /** column name */
  phoneNumberVerified = "phoneNumberVerified",
}

/** input type for updating data in table "auth.users" */
export type users_set_input = {
  activeMfaType?: InputMaybe<Scalars["String"]>;
  avatarUrl?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  currentChallenge?: InputMaybe<Scalars["String"]>;
  defaultRole?: InputMaybe<Scalars["String"]>;
  disabled?: InputMaybe<Scalars["Boolean"]>;
  displayName?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["citext"]>;
  emailVerified?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["uuid"]>;
  isAnonymous?: InputMaybe<Scalars["Boolean"]>;
  lastSeen?: InputMaybe<Scalars["timestamptz"]>;
  locale?: InputMaybe<Scalars["String"]>;
  metadata?: InputMaybe<Scalars["jsonb"]>;
  newEmail?: InputMaybe<Scalars["citext"]>;
  otpHash?: InputMaybe<Scalars["String"]>;
  otpHashExpiresAt?: InputMaybe<Scalars["timestamptz"]>;
  otpMethodLastUsed?: InputMaybe<Scalars["String"]>;
  passwordHash?: InputMaybe<Scalars["String"]>;
  phoneNumber?: InputMaybe<Scalars["String"]>;
  phoneNumberVerified?: InputMaybe<Scalars["Boolean"]>;
  ticket?: InputMaybe<Scalars["String"]>;
  ticketExpiresAt?: InputMaybe<Scalars["timestamptz"]>;
  totpSecret?: InputMaybe<Scalars["String"]>;
  updatedAt?: InputMaybe<Scalars["timestamptz"]>;
};

/** Streaming cursor of the table "users" */
export type users_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: users_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type users_stream_cursor_value_input = {
  activeMfaType?: InputMaybe<Scalars["String"]>;
  avatarUrl?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  currentChallenge?: InputMaybe<Scalars["String"]>;
  defaultRole?: InputMaybe<Scalars["String"]>;
  disabled?: InputMaybe<Scalars["Boolean"]>;
  displayName?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["citext"]>;
  emailVerified?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["uuid"]>;
  isAnonymous?: InputMaybe<Scalars["Boolean"]>;
  lastSeen?: InputMaybe<Scalars["timestamptz"]>;
  locale?: InputMaybe<Scalars["String"]>;
  metadata?: InputMaybe<Scalars["jsonb"]>;
  newEmail?: InputMaybe<Scalars["citext"]>;
  otpHash?: InputMaybe<Scalars["String"]>;
  otpHashExpiresAt?: InputMaybe<Scalars["timestamptz"]>;
  otpMethodLastUsed?: InputMaybe<Scalars["String"]>;
  passwordHash?: InputMaybe<Scalars["String"]>;
  phoneNumber?: InputMaybe<Scalars["String"]>;
  phoneNumberVerified?: InputMaybe<Scalars["Boolean"]>;
  ticket?: InputMaybe<Scalars["String"]>;
  ticketExpiresAt?: InputMaybe<Scalars["timestamptz"]>;
  totpSecret?: InputMaybe<Scalars["String"]>;
  updatedAt?: InputMaybe<Scalars["timestamptz"]>;
};

/** update columns of table "auth.users" */
export enum users_update_column {
  /** column name */
  activeMfaType = "activeMfaType",
  /** column name */
  avatarUrl = "avatarUrl",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  currentChallenge = "currentChallenge",
  /** column name */
  defaultRole = "defaultRole",
  /** column name */
  disabled = "disabled",
  /** column name */
  displayName = "displayName",
  /** column name */
  email = "email",
  /** column name */
  emailVerified = "emailVerified",
  /** column name */
  id = "id",
  /** column name */
  isAnonymous = "isAnonymous",
  /** column name */
  lastSeen = "lastSeen",
  /** column name */
  locale = "locale",
  /** column name */
  metadata = "metadata",
  /** column name */
  newEmail = "newEmail",
  /** column name */
  otpHash = "otpHash",
  /** column name */
  otpHashExpiresAt = "otpHashExpiresAt",
  /** column name */
  otpMethodLastUsed = "otpMethodLastUsed",
  /** column name */
  passwordHash = "passwordHash",
  /** column name */
  phoneNumber = "phoneNumber",
  /** column name */
  phoneNumberVerified = "phoneNumberVerified",
  /** column name */
  ticket = "ticket",
  /** column name */
  ticketExpiresAt = "ticketExpiresAt",
  /** column name */
  totpSecret = "totpSecret",
  /** column name */
  updatedAt = "updatedAt",
}

export type users_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<users_append_input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<users_delete_at_path_input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<users_delete_elem_input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<users_delete_key_input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<users_prepend_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<users_set_input>;
  where: users_bool_exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type uuid_comparison_exp = {
  _eq?: InputMaybe<Scalars["uuid"]>;
  _gt?: InputMaybe<Scalars["uuid"]>;
  _gte?: InputMaybe<Scalars["uuid"]>;
  _in?: InputMaybe<Array<Scalars["uuid"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["uuid"]>;
  _lte?: InputMaybe<Scalars["uuid"]>;
  _neq?: InputMaybe<Scalars["uuid"]>;
  _nin?: InputMaybe<Array<Scalars["uuid"]>>;
};

/** Boolean expression to filter rows from the table "weekly_activity_targets". All fields are combined with a logical 'AND'. */
export type weekly_activity_targets_bool_exp = {
  _and?: InputMaybe<Array<weekly_activity_targets_bool_exp>>;
  _not?: InputMaybe<weekly_activity_targets_bool_exp>;
  _or?: InputMaybe<Array<weekly_activity_targets_bool_exp>>;
  calls?: InputMaybe<bigint_comparison_exp>;
  conversational_touch_points?: InputMaybe<bigint_comparison_exp>;
  email_address?: InputMaybe<String_comparison_exp>;
  emails?: InputMaybe<bigint_comparison_exp>;
  id?: InputMaybe<String_comparison_exp>;
  meetings_held?: InputMaybe<float8_comparison_exp>;
  meetings_scheduled?: InputMaybe<float8_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  new_pipeline_arr?: InputMaybe<bigint_comparison_exp>;
  opportunities?: InputMaybe<float8_comparison_exp>;
  social?: InputMaybe<bigint_comparison_exp>;
  total_activities?: InputMaybe<bigint_comparison_exp>;
};

/** input type for incrementing numeric columns in table "weekly_activity_targets" */
export type weekly_activity_targets_inc_input = {
  calls?: InputMaybe<Scalars["bigint"]>;
  conversational_touch_points?: InputMaybe<Scalars["bigint"]>;
  emails?: InputMaybe<Scalars["bigint"]>;
  meetings_held?: InputMaybe<Scalars["float8"]>;
  meetings_scheduled?: InputMaybe<Scalars["float8"]>;
  new_pipeline_arr?: InputMaybe<Scalars["bigint"]>;
  opportunities?: InputMaybe<Scalars["float8"]>;
  social?: InputMaybe<Scalars["bigint"]>;
  total_activities?: InputMaybe<Scalars["bigint"]>;
};

/** input type for inserting data into table "weekly_activity_targets" */
export type weekly_activity_targets_insert_input = {
  calls?: InputMaybe<Scalars["bigint"]>;
  conversational_touch_points?: InputMaybe<Scalars["bigint"]>;
  email_address?: InputMaybe<Scalars["String"]>;
  emails?: InputMaybe<Scalars["bigint"]>;
  id?: InputMaybe<Scalars["String"]>;
  meetings_held?: InputMaybe<Scalars["float8"]>;
  meetings_scheduled?: InputMaybe<Scalars["float8"]>;
  name?: InputMaybe<Scalars["String"]>;
  new_pipeline_arr?: InputMaybe<Scalars["bigint"]>;
  opportunities?: InputMaybe<Scalars["float8"]>;
  social?: InputMaybe<Scalars["bigint"]>;
  total_activities?: InputMaybe<Scalars["bigint"]>;
};

/** Ordering options when selecting data from "weekly_activity_targets". */
export type weekly_activity_targets_order_by = {
  calls?: InputMaybe<order_by>;
  conversational_touch_points?: InputMaybe<order_by>;
  email_address?: InputMaybe<order_by>;
  emails?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  meetings_held?: InputMaybe<order_by>;
  meetings_scheduled?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  new_pipeline_arr?: InputMaybe<order_by>;
  opportunities?: InputMaybe<order_by>;
  social?: InputMaybe<order_by>;
  total_activities?: InputMaybe<order_by>;
};

/** select columns of table "weekly_activity_targets" */
export enum weekly_activity_targets_select_column {
  /** column name */
  calls = "calls",
  /** column name */
  conversational_touch_points = "conversational_touch_points",
  /** column name */
  email_address = "email_address",
  /** column name */
  emails = "emails",
  /** column name */
  id = "id",
  /** column name */
  meetings_held = "meetings_held",
  /** column name */
  meetings_scheduled = "meetings_scheduled",
  /** column name */
  name = "name",
  /** column name */
  new_pipeline_arr = "new_pipeline_arr",
  /** column name */
  opportunities = "opportunities",
  /** column name */
  social = "social",
  /** column name */
  total_activities = "total_activities",
}

/** input type for updating data in table "weekly_activity_targets" */
export type weekly_activity_targets_set_input = {
  calls?: InputMaybe<Scalars["bigint"]>;
  conversational_touch_points?: InputMaybe<Scalars["bigint"]>;
  email_address?: InputMaybe<Scalars["String"]>;
  emails?: InputMaybe<Scalars["bigint"]>;
  id?: InputMaybe<Scalars["String"]>;
  meetings_held?: InputMaybe<Scalars["float8"]>;
  meetings_scheduled?: InputMaybe<Scalars["float8"]>;
  name?: InputMaybe<Scalars["String"]>;
  new_pipeline_arr?: InputMaybe<Scalars["bigint"]>;
  opportunities?: InputMaybe<Scalars["float8"]>;
  social?: InputMaybe<Scalars["bigint"]>;
  total_activities?: InputMaybe<Scalars["bigint"]>;
};

/** Streaming cursor of the table "weekly_activity_targets" */
export type weekly_activity_targets_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: weekly_activity_targets_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type weekly_activity_targets_stream_cursor_value_input = {
  calls?: InputMaybe<Scalars["bigint"]>;
  conversational_touch_points?: InputMaybe<Scalars["bigint"]>;
  email_address?: InputMaybe<Scalars["String"]>;
  emails?: InputMaybe<Scalars["bigint"]>;
  id?: InputMaybe<Scalars["String"]>;
  meetings_held?: InputMaybe<Scalars["float8"]>;
  meetings_scheduled?: InputMaybe<Scalars["float8"]>;
  name?: InputMaybe<Scalars["String"]>;
  new_pipeline_arr?: InputMaybe<Scalars["bigint"]>;
  opportunities?: InputMaybe<Scalars["float8"]>;
  social?: InputMaybe<Scalars["bigint"]>;
  total_activities?: InputMaybe<Scalars["bigint"]>;
};

export type weekly_activity_targets_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<weekly_activity_targets_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<weekly_activity_targets_set_input>;
  where: weekly_activity_targets_bool_exp;
};

/** Boolean expression to filter rows from the table "weekly_activity_vs_targets_gql". All fields are combined with a logical 'AND'. */
export type weekly_activity_vs_targets_gql_bool_exp = {
  _and?: InputMaybe<Array<weekly_activity_vs_targets_gql_bool_exp>>;
  _not?: InputMaybe<weekly_activity_vs_targets_gql_bool_exp>;
  _or?: InputMaybe<Array<weekly_activity_vs_targets_gql_bool_exp>>;
  call_answered?: InputMaybe<bigint_comparison_exp>;
  call_targets?: InputMaybe<bigint_comparison_exp>;
  calls_out?: InputMaybe<bigint_comparison_exp>;
  conversation_targets?: InputMaybe<bigint_comparison_exp>;
  date_trunc?: InputMaybe<timestamptz_comparison_exp>;
  email?: InputMaybe<String_comparison_exp>;
  email_address?: InputMaybe<String_comparison_exp>;
  email_opens?: InputMaybe<bigint_comparison_exp>;
  email_responses?: InputMaybe<bigint_comparison_exp>;
  email_targets?: InputMaybe<bigint_comparison_exp>;
  emails_sent?: InputMaybe<bigint_comparison_exp>;
  engagement_ratio?: InputMaybe<numeric_comparison_exp>;
  id?: InputMaybe<String_comparison_exp>;
  inbound_calls?: InputMaybe<bigint_comparison_exp>;
  meetings_booked?: InputMaybe<Int_comparison_exp>;
  meetings_targets?: InputMaybe<float8_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  name_team_member?: InputMaybe<String_comparison_exp>;
  opportunity_create_count?: InputMaybe<bigint_comparison_exp>;
  opportunity_targets?: InputMaybe<float8_comparison_exp>;
  ownerid?: InputMaybe<String_comparison_exp>;
  photo_url?: InputMaybe<String_comparison_exp>;
  pipeline_targets?: InputMaybe<bigint_comparison_exp>;
  social?: InputMaybe<bigint_comparison_exp>;
  social_targets?: InputMaybe<bigint_comparison_exp>;
  total_activity_targets?: InputMaybe<bigint_comparison_exp>;
  weekly_effort?: InputMaybe<numeric_comparison_exp>;
  weekly_engagement?: InputMaybe<numeric_comparison_exp>;
};

/** Ordering options when selecting data from "weekly_activity_vs_targets_gql". */
export type weekly_activity_vs_targets_gql_order_by = {
  call_answered?: InputMaybe<order_by>;
  call_targets?: InputMaybe<order_by>;
  calls_out?: InputMaybe<order_by>;
  conversation_targets?: InputMaybe<order_by>;
  date_trunc?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  email_address?: InputMaybe<order_by>;
  email_opens?: InputMaybe<order_by>;
  email_responses?: InputMaybe<order_by>;
  email_targets?: InputMaybe<order_by>;
  emails_sent?: InputMaybe<order_by>;
  engagement_ratio?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  inbound_calls?: InputMaybe<order_by>;
  meetings_booked?: InputMaybe<order_by>;
  meetings_targets?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  name_team_member?: InputMaybe<order_by>;
  opportunity_create_count?: InputMaybe<order_by>;
  opportunity_targets?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  photo_url?: InputMaybe<order_by>;
  pipeline_targets?: InputMaybe<order_by>;
  social?: InputMaybe<order_by>;
  social_targets?: InputMaybe<order_by>;
  total_activity_targets?: InputMaybe<order_by>;
  weekly_effort?: InputMaybe<order_by>;
  weekly_engagement?: InputMaybe<order_by>;
};

/** select columns of table "weekly_activity_vs_targets_gql" */
export enum weekly_activity_vs_targets_gql_select_column {
  /** column name */
  call_answered = "call_answered",
  /** column name */
  call_targets = "call_targets",
  /** column name */
  calls_out = "calls_out",
  /** column name */
  conversation_targets = "conversation_targets",
  /** column name */
  date_trunc = "date_trunc",
  /** column name */
  email = "email",
  /** column name */
  email_address = "email_address",
  /** column name */
  email_opens = "email_opens",
  /** column name */
  email_responses = "email_responses",
  /** column name */
  email_targets = "email_targets",
  /** column name */
  emails_sent = "emails_sent",
  /** column name */
  engagement_ratio = "engagement_ratio",
  /** column name */
  id = "id",
  /** column name */
  inbound_calls = "inbound_calls",
  /** column name */
  meetings_booked = "meetings_booked",
  /** column name */
  meetings_targets = "meetings_targets",
  /** column name */
  name = "name",
  /** column name */
  name_team_member = "name_team_member",
  /** column name */
  opportunity_create_count = "opportunity_create_count",
  /** column name */
  opportunity_targets = "opportunity_targets",
  /** column name */
  ownerid = "ownerid",
  /** column name */
  photo_url = "photo_url",
  /** column name */
  pipeline_targets = "pipeline_targets",
  /** column name */
  social = "social",
  /** column name */
  social_targets = "social_targets",
  /** column name */
  total_activity_targets = "total_activity_targets",
  /** column name */
  weekly_effort = "weekly_effort",
  /** column name */
  weekly_engagement = "weekly_engagement",
}

/** Streaming cursor of the table "weekly_activity_vs_targets_gql" */
export type weekly_activity_vs_targets_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: weekly_activity_vs_targets_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type weekly_activity_vs_targets_gql_stream_cursor_value_input = {
  call_answered?: InputMaybe<Scalars["bigint"]>;
  call_targets?: InputMaybe<Scalars["bigint"]>;
  calls_out?: InputMaybe<Scalars["bigint"]>;
  conversation_targets?: InputMaybe<Scalars["bigint"]>;
  date_trunc?: InputMaybe<Scalars["timestamptz"]>;
  email?: InputMaybe<Scalars["String"]>;
  email_address?: InputMaybe<Scalars["String"]>;
  email_opens?: InputMaybe<Scalars["bigint"]>;
  email_responses?: InputMaybe<Scalars["bigint"]>;
  email_targets?: InputMaybe<Scalars["bigint"]>;
  emails_sent?: InputMaybe<Scalars["bigint"]>;
  engagement_ratio?: InputMaybe<Scalars["numeric"]>;
  id?: InputMaybe<Scalars["String"]>;
  inbound_calls?: InputMaybe<Scalars["bigint"]>;
  meetings_booked?: InputMaybe<Scalars["Int"]>;
  meetings_targets?: InputMaybe<Scalars["float8"]>;
  name?: InputMaybe<Scalars["String"]>;
  name_team_member?: InputMaybe<Scalars["String"]>;
  opportunity_create_count?: InputMaybe<Scalars["bigint"]>;
  opportunity_targets?: InputMaybe<Scalars["float8"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  photo_url?: InputMaybe<Scalars["String"]>;
  pipeline_targets?: InputMaybe<Scalars["bigint"]>;
  social?: InputMaybe<Scalars["bigint"]>;
  social_targets?: InputMaybe<Scalars["bigint"]>;
  total_activity_targets?: InputMaybe<Scalars["bigint"]>;
  weekly_effort?: InputMaybe<Scalars["numeric"]>;
  weekly_engagement?: InputMaybe<Scalars["numeric"]>;
};

/** Boolean expression to filter rows from the table "weekly_effort_breakdown_overview_gql". All fields are combined with a logical 'AND'. */
export type weekly_effort_breakdown_overview_gql_bool_exp = {
  _and?: InputMaybe<Array<weekly_effort_breakdown_overview_gql_bool_exp>>;
  _not?: InputMaybe<weekly_effort_breakdown_overview_gql_bool_exp>;
  _or?: InputMaybe<Array<weekly_effort_breakdown_overview_gql_bool_exp>>;
  count?: InputMaybe<bigint_comparison_exp>;
  date_trunc?: InputMaybe<timestamp_comparison_exp>;
  meeting_key?: InputMaybe<bigint_comparison_exp>;
  task_categorization?: InputMaybe<Int_comparison_exp>;
  type_category?: InputMaybe<String_comparison_exp>;
  type_detail?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "weekly_effort_breakdown_overview_gql". */
export type weekly_effort_breakdown_overview_gql_order_by = {
  count?: InputMaybe<order_by>;
  date_trunc?: InputMaybe<order_by>;
  meeting_key?: InputMaybe<order_by>;
  task_categorization?: InputMaybe<order_by>;
  type_category?: InputMaybe<order_by>;
  type_detail?: InputMaybe<order_by>;
};

/** select columns of table "weekly_effort_breakdown_overview_gql" */
export enum weekly_effort_breakdown_overview_gql_select_column {
  /** column name */
  count = "count",
  /** column name */
  date_trunc = "date_trunc",
  /** column name */
  meeting_key = "meeting_key",
  /** column name */
  task_categorization = "task_categorization",
  /** column name */
  type_category = "type_category",
  /** column name */
  type_detail = "type_detail",
}

/** Streaming cursor of the table "weekly_effort_breakdown_overview_gql" */
export type weekly_effort_breakdown_overview_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: weekly_effort_breakdown_overview_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type weekly_effort_breakdown_overview_gql_stream_cursor_value_input = {
  count?: InputMaybe<Scalars["bigint"]>;
  date_trunc?: InputMaybe<Scalars["timestamp"]>;
  meeting_key?: InputMaybe<Scalars["bigint"]>;
  task_categorization?: InputMaybe<Scalars["Int"]>;
  type_category?: InputMaybe<Scalars["String"]>;
  type_detail?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "weekly_engagement_breakdown_overview_gql". All fields are combined with a logical 'AND'. */
export type weekly_engagement_breakdown_overview_gql_bool_exp = {
  _and?: InputMaybe<Array<weekly_engagement_breakdown_overview_gql_bool_exp>>;
  _not?: InputMaybe<weekly_engagement_breakdown_overview_gql_bool_exp>;
  _or?: InputMaybe<Array<weekly_engagement_breakdown_overview_gql_bool_exp>>;
  count?: InputMaybe<bigint_comparison_exp>;
  date_trunc?: InputMaybe<timestamp_comparison_exp>;
  meeting_key?: InputMaybe<bigint_comparison_exp>;
  task_categorization?: InputMaybe<Int_comparison_exp>;
  type_category?: InputMaybe<String_comparison_exp>;
  type_detail?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "weekly_engagement_breakdown_overview_gql". */
export type weekly_engagement_breakdown_overview_gql_order_by = {
  count?: InputMaybe<order_by>;
  date_trunc?: InputMaybe<order_by>;
  meeting_key?: InputMaybe<order_by>;
  task_categorization?: InputMaybe<order_by>;
  type_category?: InputMaybe<order_by>;
  type_detail?: InputMaybe<order_by>;
};

/** select columns of table "weekly_engagement_breakdown_overview_gql" */
export enum weekly_engagement_breakdown_overview_gql_select_column {
  /** column name */
  count = "count",
  /** column name */
  date_trunc = "date_trunc",
  /** column name */
  meeting_key = "meeting_key",
  /** column name */
  task_categorization = "task_categorization",
  /** column name */
  type_category = "type_category",
  /** column name */
  type_detail = "type_detail",
}

/** Streaming cursor of the table "weekly_engagement_breakdown_overview_gql" */
export type weekly_engagement_breakdown_overview_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: weekly_engagement_breakdown_overview_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type weekly_engagement_breakdown_overview_gql_stream_cursor_value_input =
  {
    count?: InputMaybe<Scalars["bigint"]>;
    date_trunc?: InputMaybe<Scalars["timestamp"]>;
    meeting_key?: InputMaybe<Scalars["bigint"]>;
    task_categorization?: InputMaybe<Scalars["Int"]>;
    type_category?: InputMaybe<Scalars["String"]>;
    type_detail?: InputMaybe<Scalars["String"]>;
  };

/** Boolean expression to filter rows from the table "weekly_leaderboard_gql". All fields are combined with a logical 'AND'. */
export type weekly_leaderboard_gql_bool_exp = {
  _and?: InputMaybe<Array<weekly_leaderboard_gql_bool_exp>>;
  _not?: InputMaybe<weekly_leaderboard_gql_bool_exp>;
  _or?: InputMaybe<Array<weekly_leaderboard_gql_bool_exp>>;
  call_answered?: InputMaybe<bigint_comparison_exp>;
  calls_out?: InputMaybe<bigint_comparison_exp>;
  date_trunc?: InputMaybe<timestamptz_comparison_exp>;
  email?: InputMaybe<String_comparison_exp>;
  email_opens?: InputMaybe<bigint_comparison_exp>;
  email_responses?: InputMaybe<bigint_comparison_exp>;
  emails_sent?: InputMaybe<bigint_comparison_exp>;
  inbound_calls?: InputMaybe<bigint_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  opportunity_create_count?: InputMaybe<bigint_comparison_exp>;
  ownerid?: InputMaybe<String_comparison_exp>;
  photo_url?: InputMaybe<String_comparison_exp>;
  social?: InputMaybe<bigint_comparison_exp>;
  weekly_effort?: InputMaybe<numeric_comparison_exp>;
  weekly_engagement?: InputMaybe<numeric_comparison_exp>;
};

/** Ordering options when selecting data from "weekly_leaderboard_gql". */
export type weekly_leaderboard_gql_order_by = {
  call_answered?: InputMaybe<order_by>;
  calls_out?: InputMaybe<order_by>;
  date_trunc?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  email_opens?: InputMaybe<order_by>;
  email_responses?: InputMaybe<order_by>;
  emails_sent?: InputMaybe<order_by>;
  inbound_calls?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  opportunity_create_count?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  photo_url?: InputMaybe<order_by>;
  social?: InputMaybe<order_by>;
  weekly_effort?: InputMaybe<order_by>;
  weekly_engagement?: InputMaybe<order_by>;
};

/** select columns of table "weekly_leaderboard_gql" */
export enum weekly_leaderboard_gql_select_column {
  /** column name */
  call_answered = "call_answered",
  /** column name */
  calls_out = "calls_out",
  /** column name */
  date_trunc = "date_trunc",
  /** column name */
  email = "email",
  /** column name */
  email_opens = "email_opens",
  /** column name */
  email_responses = "email_responses",
  /** column name */
  emails_sent = "emails_sent",
  /** column name */
  inbound_calls = "inbound_calls",
  /** column name */
  name = "name",
  /** column name */
  opportunity_create_count = "opportunity_create_count",
  /** column name */
  ownerid = "ownerid",
  /** column name */
  photo_url = "photo_url",
  /** column name */
  social = "social",
  /** column name */
  weekly_effort = "weekly_effort",
  /** column name */
  weekly_engagement = "weekly_engagement",
}

/** Streaming cursor of the table "weekly_leaderboard_gql" */
export type weekly_leaderboard_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: weekly_leaderboard_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type weekly_leaderboard_gql_stream_cursor_value_input = {
  call_answered?: InputMaybe<Scalars["bigint"]>;
  calls_out?: InputMaybe<Scalars["bigint"]>;
  date_trunc?: InputMaybe<Scalars["timestamptz"]>;
  email?: InputMaybe<Scalars["String"]>;
  email_opens?: InputMaybe<Scalars["bigint"]>;
  email_responses?: InputMaybe<Scalars["bigint"]>;
  emails_sent?: InputMaybe<Scalars["bigint"]>;
  inbound_calls?: InputMaybe<Scalars["bigint"]>;
  name?: InputMaybe<Scalars["String"]>;
  opportunity_create_count?: InputMaybe<Scalars["bigint"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  photo_url?: InputMaybe<Scalars["String"]>;
  social?: InputMaybe<Scalars["bigint"]>;
  weekly_effort?: InputMaybe<Scalars["numeric"]>;
  weekly_engagement?: InputMaybe<Scalars["numeric"]>;
};

/** Boolean expression to filter rows from the table "weekly_pipeline_gql_new". All fields are combined with a logical 'AND'. */
export type weekly_pipeline_gql_new_bool_exp = {
  _and?: InputMaybe<Array<weekly_pipeline_gql_new_bool_exp>>;
  _not?: InputMaybe<weekly_pipeline_gql_new_bool_exp>;
  _or?: InputMaybe<Array<weekly_pipeline_gql_new_bool_exp>>;
  amount?: InputMaybe<numeric_comparison_exp>;
  date_trunc?: InputMaybe<timestamp_comparison_exp>;
  lead_source?: InputMaybe<String_comparison_exp>;
  opportunity_id?: InputMaybe<String_comparison_exp>;
  opportunity_name?: InputMaybe<String_comparison_exp>;
  owner_name?: InputMaybe<String_comparison_exp>;
  stagename?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "weekly_pipeline_gql_new". */
export type weekly_pipeline_gql_new_order_by = {
  amount?: InputMaybe<order_by>;
  date_trunc?: InputMaybe<order_by>;
  lead_source?: InputMaybe<order_by>;
  opportunity_id?: InputMaybe<order_by>;
  opportunity_name?: InputMaybe<order_by>;
  owner_name?: InputMaybe<order_by>;
  stagename?: InputMaybe<order_by>;
};

/** select columns of table "weekly_pipeline_gql_new" */
export enum weekly_pipeline_gql_new_select_column {
  /** column name */
  amount = "amount",
  /** column name */
  date_trunc = "date_trunc",
  /** column name */
  lead_source = "lead_source",
  /** column name */
  opportunity_id = "opportunity_id",
  /** column name */
  opportunity_name = "opportunity_name",
  /** column name */
  owner_name = "owner_name",
  /** column name */
  stagename = "stagename",
}

/** Streaming cursor of the table "weekly_pipeline_gql_new" */
export type weekly_pipeline_gql_new_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: weekly_pipeline_gql_new_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type weekly_pipeline_gql_new_stream_cursor_value_input = {
  amount?: InputMaybe<Scalars["numeric"]>;
  date_trunc?: InputMaybe<Scalars["timestamp"]>;
  lead_source?: InputMaybe<Scalars["String"]>;
  opportunity_id?: InputMaybe<Scalars["String"]>;
  opportunity_name?: InputMaybe<Scalars["String"]>;
  owner_name?: InputMaybe<Scalars["String"]>;
  stagename?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "weighted_pipeline_ml_gql". All fields are combined with a logical 'AND'. */
export type weighted_pipeline_ml_gql_bool_exp = {
  _and?: InputMaybe<Array<weighted_pipeline_ml_gql_bool_exp>>;
  _not?: InputMaybe<weighted_pipeline_ml_gql_bool_exp>;
  _or?: InputMaybe<Array<weighted_pipeline_ml_gql_bool_exp>>;
  account_id?: InputMaybe<String_comparison_exp>;
  closedate?: InputMaybe<timestamp_comparison_exp>;
  custom_filter_1?: InputMaybe<String_comparison_exp>;
  forecast_category?: InputMaybe<String_comparison_exp>;
  ml_weighted_arr?: InputMaybe<float8_comparison_exp>;
  ml_weighted_arr1?: InputMaybe<float8_comparison_exp>;
  ml_weighted_services?: InputMaybe<float8_comparison_exp>;
  ml_weighted_services1?: InputMaybe<float8_comparison_exp>;
  opportunity_name?: InputMaybe<String_comparison_exp>;
  opportunity_owner?: InputMaybe<String_comparison_exp>;
  stage?: InputMaybe<String_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
  weighted_arr?: InputMaybe<float8_comparison_exp>;
  weighted_services?: InputMaybe<float8_comparison_exp>;
};

/** Ordering options when selecting data from "weighted_pipeline_ml_gql". */
export type weighted_pipeline_ml_gql_order_by = {
  account_id?: InputMaybe<order_by>;
  closedate?: InputMaybe<order_by>;
  custom_filter_1?: InputMaybe<order_by>;
  forecast_category?: InputMaybe<order_by>;
  ml_weighted_arr?: InputMaybe<order_by>;
  ml_weighted_arr1?: InputMaybe<order_by>;
  ml_weighted_services?: InputMaybe<order_by>;
  ml_weighted_services1?: InputMaybe<order_by>;
  opportunity_name?: InputMaybe<order_by>;
  opportunity_owner?: InputMaybe<order_by>;
  stage?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
  weighted_arr?: InputMaybe<order_by>;
  weighted_services?: InputMaybe<order_by>;
};

/** select columns of table "weighted_pipeline_ml_gql" */
export enum weighted_pipeline_ml_gql_select_column {
  /** column name */
  account_id = "account_id",
  /** column name */
  closedate = "closedate",
  /** column name */
  custom_filter_1 = "custom_filter_1",
  /** column name */
  forecast_category = "forecast_category",
  /** column name */
  ml_weighted_arr = "ml_weighted_arr",
  /** column name */
  ml_weighted_arr1 = "ml_weighted_arr1",
  /** column name */
  ml_weighted_services = "ml_weighted_services",
  /** column name */
  ml_weighted_services1 = "ml_weighted_services1",
  /** column name */
  opportunity_name = "opportunity_name",
  /** column name */
  opportunity_owner = "opportunity_owner",
  /** column name */
  stage = "stage",
  /** column name */
  type = "type",
  /** column name */
  weighted_arr = "weighted_arr",
  /** column name */
  weighted_services = "weighted_services",
}

/** Streaming cursor of the table "weighted_pipeline_ml_gql" */
export type weighted_pipeline_ml_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: weighted_pipeline_ml_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type weighted_pipeline_ml_gql_stream_cursor_value_input = {
  account_id?: InputMaybe<Scalars["String"]>;
  closedate?: InputMaybe<Scalars["timestamp"]>;
  custom_filter_1?: InputMaybe<Scalars["String"]>;
  forecast_category?: InputMaybe<Scalars["String"]>;
  ml_weighted_arr?: InputMaybe<Scalars["float8"]>;
  ml_weighted_arr1?: InputMaybe<Scalars["float8"]>;
  ml_weighted_services?: InputMaybe<Scalars["float8"]>;
  ml_weighted_services1?: InputMaybe<Scalars["float8"]>;
  opportunity_name?: InputMaybe<Scalars["String"]>;
  opportunity_owner?: InputMaybe<Scalars["String"]>;
  stage?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Scalars["String"]>;
  weighted_arr?: InputMaybe<Scalars["float8"]>;
  weighted_services?: InputMaybe<Scalars["float8"]>;
};

/** Boolean expression to filter rows from the table "win_rate_totals". All fields are combined with a logical 'AND'. */
export type win_rate_totals_bool_exp = {
  _and?: InputMaybe<Array<win_rate_totals_bool_exp>>;
  _not?: InputMaybe<win_rate_totals_bool_exp>;
  _or?: InputMaybe<Array<win_rate_totals_bool_exp>>;
  type?: InputMaybe<String_comparison_exp>;
  win_rate?: InputMaybe<numeric_comparison_exp>;
};

/** Ordering options when selecting data from "win_rate_totals". */
export type win_rate_totals_order_by = {
  type?: InputMaybe<order_by>;
  win_rate?: InputMaybe<order_by>;
};

/** select columns of table "win_rate_totals" */
export enum win_rate_totals_select_column {
  /** column name */
  type = "type",
  /** column name */
  win_rate = "win_rate",
}

/** Streaming cursor of the table "win_rate_totals" */
export type win_rate_totals_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: win_rate_totals_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type win_rate_totals_stream_cursor_value_input = {
  type?: InputMaybe<Scalars["String"]>;
  win_rate?: InputMaybe<Scalars["numeric"]>;
};

export type win_rates_individual_gql_aggregate_bool_exp = {
  avg?: InputMaybe<win_rates_individual_gql_aggregate_bool_exp_avg>;
  corr?: InputMaybe<win_rates_individual_gql_aggregate_bool_exp_corr>;
  count?: InputMaybe<win_rates_individual_gql_aggregate_bool_exp_count>;
  covar_samp?: InputMaybe<win_rates_individual_gql_aggregate_bool_exp_covar_samp>;
  max?: InputMaybe<win_rates_individual_gql_aggregate_bool_exp_max>;
  min?: InputMaybe<win_rates_individual_gql_aggregate_bool_exp_min>;
  stddev_samp?: InputMaybe<win_rates_individual_gql_aggregate_bool_exp_stddev_samp>;
  sum?: InputMaybe<win_rates_individual_gql_aggregate_bool_exp_sum>;
  var_samp?: InputMaybe<win_rates_individual_gql_aggregate_bool_exp_var_samp>;
};

export type win_rates_individual_gql_aggregate_bool_exp_avg = {
  arguments: win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_avg_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<win_rates_individual_gql_bool_exp>;
  predicate: float8_comparison_exp;
};

export type win_rates_individual_gql_aggregate_bool_exp_corr = {
  arguments: win_rates_individual_gql_aggregate_bool_exp_corr_arguments;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<win_rates_individual_gql_bool_exp>;
  predicate: float8_comparison_exp;
};

export type win_rates_individual_gql_aggregate_bool_exp_corr_arguments = {
  X: win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_corr_arguments_columns;
  Y: win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_corr_arguments_columns;
};

export type win_rates_individual_gql_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<win_rates_individual_gql_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<win_rates_individual_gql_bool_exp>;
  predicate: Int_comparison_exp;
};

export type win_rates_individual_gql_aggregate_bool_exp_covar_samp = {
  arguments: win_rates_individual_gql_aggregate_bool_exp_covar_samp_arguments;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<win_rates_individual_gql_bool_exp>;
  predicate: float8_comparison_exp;
};

export type win_rates_individual_gql_aggregate_bool_exp_covar_samp_arguments = {
  X: win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_covar_samp_arguments_columns;
  Y: win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_covar_samp_arguments_columns;
};

export type win_rates_individual_gql_aggregate_bool_exp_max = {
  arguments: win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_max_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<win_rates_individual_gql_bool_exp>;
  predicate: float8_comparison_exp;
};

export type win_rates_individual_gql_aggregate_bool_exp_min = {
  arguments: win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_min_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<win_rates_individual_gql_bool_exp>;
  predicate: float8_comparison_exp;
};

export type win_rates_individual_gql_aggregate_bool_exp_stddev_samp = {
  arguments: win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_stddev_samp_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<win_rates_individual_gql_bool_exp>;
  predicate: float8_comparison_exp;
};

export type win_rates_individual_gql_aggregate_bool_exp_sum = {
  arguments: win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_sum_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<win_rates_individual_gql_bool_exp>;
  predicate: float8_comparison_exp;
};

export type win_rates_individual_gql_aggregate_bool_exp_var_samp = {
  arguments: win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_var_samp_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<win_rates_individual_gql_bool_exp>;
  predicate: float8_comparison_exp;
};

/** order by aggregate values of table "win_rates_individual_gql" */
export type win_rates_individual_gql_aggregate_order_by = {
  avg?: InputMaybe<win_rates_individual_gql_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<win_rates_individual_gql_max_order_by>;
  min?: InputMaybe<win_rates_individual_gql_min_order_by>;
  stddev?: InputMaybe<win_rates_individual_gql_stddev_order_by>;
  stddev_pop?: InputMaybe<win_rates_individual_gql_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<win_rates_individual_gql_stddev_samp_order_by>;
  sum?: InputMaybe<win_rates_individual_gql_sum_order_by>;
  var_pop?: InputMaybe<win_rates_individual_gql_var_pop_order_by>;
  var_samp?: InputMaybe<win_rates_individual_gql_var_samp_order_by>;
  variance?: InputMaybe<win_rates_individual_gql_variance_order_by>;
};

/** input type for inserting array relation for remote table "win_rates_individual_gql" */
export type win_rates_individual_gql_arr_rel_insert_input = {
  data: Array<win_rates_individual_gql_insert_input>;
};

/** order by avg() on columns of table "win_rates_individual_gql" */
export type win_rates_individual_gql_avg_order_by = {
  key?: InputMaybe<order_by>;
  losses?: InputMaybe<order_by>;
  total_opps?: InputMaybe<order_by>;
  win_rate?: InputMaybe<order_by>;
  wins?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "win_rates_individual_gql". All fields are combined with a logical 'AND'. */
export type win_rates_individual_gql_bool_exp = {
  _and?: InputMaybe<Array<win_rates_individual_gql_bool_exp>>;
  _not?: InputMaybe<win_rates_individual_gql_bool_exp>;
  _or?: InputMaybe<Array<win_rates_individual_gql_bool_exp>>;
  key?: InputMaybe<bigint_comparison_exp>;
  losses?: InputMaybe<bigint_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  ownerid?: InputMaybe<String_comparison_exp>;
  total_opps?: InputMaybe<bigint_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
  win_rate?: InputMaybe<float8_comparison_exp>;
  wins?: InputMaybe<bigint_comparison_exp>;
};

/** input type for inserting data into table "win_rates_individual_gql" */
export type win_rates_individual_gql_insert_input = {
  key?: InputMaybe<Scalars["bigint"]>;
  losses?: InputMaybe<Scalars["bigint"]>;
  name?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  total_opps?: InputMaybe<Scalars["bigint"]>;
  type?: InputMaybe<Scalars["String"]>;
  win_rate?: InputMaybe<Scalars["float8"]>;
  wins?: InputMaybe<Scalars["bigint"]>;
};

/** order by max() on columns of table "win_rates_individual_gql" */
export type win_rates_individual_gql_max_order_by = {
  key?: InputMaybe<order_by>;
  losses?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  total_opps?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
  win_rate?: InputMaybe<order_by>;
  wins?: InputMaybe<order_by>;
};

/** order by min() on columns of table "win_rates_individual_gql" */
export type win_rates_individual_gql_min_order_by = {
  key?: InputMaybe<order_by>;
  losses?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  total_opps?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
  win_rate?: InputMaybe<order_by>;
  wins?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "win_rates_individual_gql". */
export type win_rates_individual_gql_order_by = {
  key?: InputMaybe<order_by>;
  losses?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  total_opps?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
  win_rate?: InputMaybe<order_by>;
  wins?: InputMaybe<order_by>;
};

/** select columns of table "win_rates_individual_gql" */
export enum win_rates_individual_gql_select_column {
  /** column name */
  key = "key",
  /** column name */
  losses = "losses",
  /** column name */
  name = "name",
  /** column name */
  ownerid = "ownerid",
  /** column name */
  total_opps = "total_opps",
  /** column name */
  type = "type",
  /** column name */
  win_rate = "win_rate",
  /** column name */
  wins = "wins",
}

/** select "win_rates_individual_gql_aggregate_bool_exp_avg_arguments_columns" columns of table "win_rates_individual_gql" */
export enum win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_avg_arguments_columns {
  /** column name */
  win_rate = "win_rate",
}

/** select "win_rates_individual_gql_aggregate_bool_exp_corr_arguments_columns" columns of table "win_rates_individual_gql" */
export enum win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_corr_arguments_columns {
  /** column name */
  win_rate = "win_rate",
}

/** select "win_rates_individual_gql_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "win_rates_individual_gql" */
export enum win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_covar_samp_arguments_columns {
  /** column name */
  win_rate = "win_rate",
}

/** select "win_rates_individual_gql_aggregate_bool_exp_max_arguments_columns" columns of table "win_rates_individual_gql" */
export enum win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_max_arguments_columns {
  /** column name */
  win_rate = "win_rate",
}

/** select "win_rates_individual_gql_aggregate_bool_exp_min_arguments_columns" columns of table "win_rates_individual_gql" */
export enum win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_min_arguments_columns {
  /** column name */
  win_rate = "win_rate",
}

/** select "win_rates_individual_gql_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "win_rates_individual_gql" */
export enum win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_stddev_samp_arguments_columns {
  /** column name */
  win_rate = "win_rate",
}

/** select "win_rates_individual_gql_aggregate_bool_exp_sum_arguments_columns" columns of table "win_rates_individual_gql" */
export enum win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_sum_arguments_columns {
  /** column name */
  win_rate = "win_rate",
}

/** select "win_rates_individual_gql_aggregate_bool_exp_var_samp_arguments_columns" columns of table "win_rates_individual_gql" */
export enum win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_var_samp_arguments_columns {
  /** column name */
  win_rate = "win_rate",
}

/** order by stddev() on columns of table "win_rates_individual_gql" */
export type win_rates_individual_gql_stddev_order_by = {
  key?: InputMaybe<order_by>;
  losses?: InputMaybe<order_by>;
  total_opps?: InputMaybe<order_by>;
  win_rate?: InputMaybe<order_by>;
  wins?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "win_rates_individual_gql" */
export type win_rates_individual_gql_stddev_pop_order_by = {
  key?: InputMaybe<order_by>;
  losses?: InputMaybe<order_by>;
  total_opps?: InputMaybe<order_by>;
  win_rate?: InputMaybe<order_by>;
  wins?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "win_rates_individual_gql" */
export type win_rates_individual_gql_stddev_samp_order_by = {
  key?: InputMaybe<order_by>;
  losses?: InputMaybe<order_by>;
  total_opps?: InputMaybe<order_by>;
  win_rate?: InputMaybe<order_by>;
  wins?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "win_rates_individual_gql" */
export type win_rates_individual_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: win_rates_individual_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type win_rates_individual_gql_stream_cursor_value_input = {
  key?: InputMaybe<Scalars["bigint"]>;
  losses?: InputMaybe<Scalars["bigint"]>;
  name?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  total_opps?: InputMaybe<Scalars["bigint"]>;
  type?: InputMaybe<Scalars["String"]>;
  win_rate?: InputMaybe<Scalars["float8"]>;
  wins?: InputMaybe<Scalars["bigint"]>;
};

/** order by sum() on columns of table "win_rates_individual_gql" */
export type win_rates_individual_gql_sum_order_by = {
  key?: InputMaybe<order_by>;
  losses?: InputMaybe<order_by>;
  total_opps?: InputMaybe<order_by>;
  win_rate?: InputMaybe<order_by>;
  wins?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "win_rates_individual_gql" */
export type win_rates_individual_gql_var_pop_order_by = {
  key?: InputMaybe<order_by>;
  losses?: InputMaybe<order_by>;
  total_opps?: InputMaybe<order_by>;
  win_rate?: InputMaybe<order_by>;
  wins?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "win_rates_individual_gql" */
export type win_rates_individual_gql_var_samp_order_by = {
  key?: InputMaybe<order_by>;
  losses?: InputMaybe<order_by>;
  total_opps?: InputMaybe<order_by>;
  win_rate?: InputMaybe<order_by>;
  wins?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "win_rates_individual_gql" */
export type win_rates_individual_gql_variance_order_by = {
  key?: InputMaybe<order_by>;
  losses?: InputMaybe<order_by>;
  total_opps?: InputMaybe<order_by>;
  win_rate?: InputMaybe<order_by>;
  wins?: InputMaybe<order_by>;
};

/** An enum describing what kind of type a given `__Type` is. */
export enum __TypeKind {
  /** Indicates this type is a scalar. */
  SCALAR = "SCALAR",
  /** Indicates this type is an object. `fields` and `interfaces` are valid fields. */
  OBJECT = "OBJECT",
  /** Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields. */
  INTERFACE = "INTERFACE",
  /** Indicates this type is a union. `possibleTypes` is a valid field. */
  UNION = "UNION",
  /** Indicates this type is an enum. `enumValues` is a valid field. */
  ENUM = "ENUM",
  /** Indicates this type is an input object. `inputFields` is a valid field. */
  INPUT_OBJECT = "INPUT_OBJECT",
  /** Indicates this type is a list. `ofType` is a valid field. */
  LIST = "LIST",
  /** Indicates this type is a non-null. `ofType` is a valid field. */
  NON_NULL = "NON_NULL",
}

export type AccountListQueryVariables = Exact<{
  offset?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  where: account_module_static_bool_exp;
}>;

export type AccountListQuery = {
  account_module_static: Array<{
    account_id: string;
    account_name?: string | null;
    account_owner?: string | null;
    billingcity?: string | null;
    billingcountry?: string | null;
    billingstate?: string | null;
    effort?: any | null;
    engagement?: any | null;
    account_status_auto__c?: string | null;
    predct_proba?: any | null;
  }>;
  account_module_static_aggregate: { aggregate?: { count: number } | null };
};

export type AggregateAccountsCountQueryVariables = Exact<{
  where: account_module_static_bool_exp;
}>;

export type AggregateAccountsCountQuery = {
  account_module_static_aggregate: { aggregate?: { count: number } | null };
};

export type AggregateEngagedCountQueryVariables = Exact<{
  where: account_module_static_bool_exp;
}>;

export type AggregateEngagedCountQuery = {
  account_module_static_aggregate: { aggregate?: { count: number } | null };
};

export type AggregateColdCountQueryVariables = Exact<{
  where: account_module_static_bool_exp;
}>;

export type AggregateColdCountQuery = {
  account_module_static_aggregate: { aggregate?: { count: number } | null };
};

export type AccountOwnerListQueryVariables = Exact<{ [key: string]: never }>;

export type AccountOwnerListQuery = {
  account_module_static: Array<{ account_owner?: string | null }>;
};

export type AccountCustomStatusListQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AccountCustomStatusListQuery = {
  account_module_static: Array<{ account_status_auto__c?: string | null }>;
};

export type AccountExpandedRowQueryVariables = Exact<{
  account_id?: InputMaybe<Array<Scalars["String"]> | Scalars["String"]>;
}>;

export type AccountExpandedRowQuery = {
  account_module_expansion_gql: Array<{
    number_of_contacts?: any | null;
    open_opp_count?: any | null;
    daily_engagement: Array<{
      activity_date?: any | null;
      engagement?: any | null;
      effort?: any | null;
    }>;
    daily_engagement_aggregate: {
      aggregate?: { max?: { activity_date?: any | null } | null } | null;
    };
  }>;
};

export type WeeklyLeaderboardQueryVariables = Exact<{ [key: string]: never }>;

export type WeeklyLeaderboardQuery = {
  weekly_activity_vs_targets_gql: Array<{
    call_answered?: any | null;
    call_targets?: any | null;
    calls_out?: any | null;
    conversation_targets?: any | null;
    date_trunc?: any | null;
    email?: string | null;
    email_address?: string | null;
    email_opens?: any | null;
    email_responses?: any | null;
    email_targets?: any | null;
    emails_sent?: any | null;
    id?: string | null;
    inbound_calls?: any | null;
    meetings_booked?: number | null;
    meetings_targets?: any | null;
    name?: string | null;
    name_team_member?: string | null;
    opportunity_create_count?: any | null;
    opportunity_targets?: any | null;
    ownerid?: string | null;
    pipeline_targets?: any | null;
    social?: any | null;
    social_targets?: any | null;
    total_activity_targets?: any | null;
    weekly_effort?: any | null;
    weekly_engagement?: any | null;
    photo_url?: string | null;
    engagement_ratio?: any | null;
  }>;
};

export type OppDetailQueryVariables = Exact<{ [key: string]: never }>;

export type OppDetailQuery = {
  opp_detail_gql: Array<{
    account_id?: string | null;
    account_name?: string | null;
    amount?: any | null;
    closedate?: any | null;
    createddate?: any | null;
    email?: string | null;
    forecast_category?: string | null;
    leadsource?: string | null;
    opportunity_id?: string | null;
    opportunity_name?: string | null;
    opportunity_owner?: string | null;
    ownerid?: string | null;
    stage?: string | null;
    created_by?: string | null;
  }>;
};

export type TeamActivityQueryVariables = Exact<{ [key: string]: never }>;

export type TeamActivityQuery = {
  team_activity_gql: Array<{
    calls_out?: any | null;
    calls_actuals?: any | null;
    calls_target?: any | null;
    emails_sent?: any | null;
    email_actuals?: any | null;
    email_targets?: any | null;
    meetings?: any | null;
    opportunities?: any | null;
    opportunity_targets?: any | null;
    meeting_targets?: any | null;
    opportunity_actuals?: any | null;
    social?: any | null;
    social_actuals?: any | null;
    social_target?: any | null;
  }>;
};

export type IndividualProgressQueryVariables = Exact<{ [key: string]: never }>;

export type IndividualProgressQuery = {
  actuals_vs_targets_activity: Array<{
    ownerid?: string | null;
    name?: string | null;
    emails_sent?: any | null;
    emails?: any | null;
    calls_out?: any | null;
    calls?: any | null;
    social?: any | null;
    social_target?: any | null;
    opportunity_create_count?: any | null;
    opportunities?: any | null;
  }>;
};

export type WeeklyLeaderboardMeetingDetailQueryVariables = Exact<{
  [key: string]: never;
}>;

export type WeeklyLeaderboardMeetingDetailQuery = {
  first_meetings_leads_accounts_gql: Array<{
    account_name?: string | null;
    contact?: string | null;
    title?: string | null;
    subject?: string | null;
    createddate?: any | null;
    activitydate?: any | null;
    meeting_owner?: string | null;
    eventid?: string | null;
  }>;
};

export type ActivityByUserQueryVariables = Exact<{
  where: event_bool_exp;
  where2: opportunity_bool_exp;
  where3: task_effort_engagement_mapping_bool_exp;
}>;

export type ActivityByUserQuery = {
  teams: Array<{
    to_members: Array<{
      team_id: any;
      to_users?: {
        id: any;
        email?: any | null;
        avatarUrl: string;
        crm_users?: {
          id?: string | null;
          name?: string | null;
          revtron_users?: {
            revtron_team?: {
              to_teams?: { team_name: string; team_type: string } | null;
            } | null;
          } | null;
          meeting_creation: Array<{
            id?: string | null;
            ownerid?: string | null;
            subject?: string | null;
            description?: string | null;
            type?: string | null;
            eventsubtype?: string | null;
            createddate?: any | null;
            activitydatetime?: any | null;
            enddatetime?: any | null;
          }>;
          opp_creation: Array<{
            id?: string | null;
            ownerid?: string | null;
            createdbyid?: string | null;
            name?: string | null;
            stagename?: string | null;
            type?: string | null;
            leadsource?: string | null;
            createddate?: any | null;
            closedate?: any | null;
            amount?: any | null;
          }>;
          to_effort_engagement_aggregate: {
            accountsTouched?: { count: number } | null;
            contactsTouched?: { count: number } | null;
          };
        } | null;
      } | null;
    }>;
  }>;
};

export type CalendarCleanQueryVariables = Exact<{
  offset?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  where: calendar_gql_clean_bool_exp;
}>;

export type CalendarCleanQuery = {
  calendar_gql_clean: Array<{
    account_name?: string | null;
    amount?: any | null;
    enddatetime?: any | null;
    meeting_key?: any | null;
    meeting_owner?: string | null;
    meeting_owner_id?: string | null;
    opportunity_name?: string | null;
    probability?: any | null;
    stagename?: string | null;
    startdatetime?: any | null;
    subject?: string | null;
  }>;
  calendar_gql_clean_aggregate: { aggregate?: { count: number } | null };
};

export type CalendarStageNameQueryVariables = Exact<{ [key: string]: never }>;

export type CalendarStageNameQuery = {
  calendar_stagename_gql: Array<{ stagename?: string | null }>;
};

export type CalendarMeetingOwnerQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CalendarMeetingOwnerQuery = {
  calendar_meeting_owner_gql: Array<{ meeting_owner?: string | null }>;
};

export type IcpModuleLegacyQueryVariables = Exact<{
  where: account_bool_exp;
  orderBy: account_order_by;
  limit: Scalars["Int"];
}>;

export type IcpModuleLegacyQuery = {
  account: Array<{
    id?: string | null;
    name?: string | null;
    website?: string | null;
    billingcity?: string | null;
    billingstate?: string | null;
    billingcountry?: string | null;
    annualrevenue?: any | null;
    numberofemployees?: number | null;
    to_revtron?: {
      to_revtron_company: Array<{
        ID?: any | null;
        NAME?: string | null;
        INFORMALNAME?: string | null;
        WEBSITE?: string | null;
        DOMAIN?: string | null;
        LINKEDIN?: string | null;
        FOUNDINGYEAR?: any | null;
        SUB_INDUSTRY_CATEGORY_NAME?: string | null;
        MOST_RECENT_EMPLOYEE_COUNT?: any | null;
        CITY?: string | null;
        STATE?: string | null;
        COUNTRY?: string | null;
        COMPANYTYPE?: string | null;
        PARENTCOMPANY?: string | null;
        SPECIALTIES?: string | null;
      }>;
    } | null;
    account_module_static?: { predct_proba?: any | null } | null;
  }>;
};

export type _revtron_companiesFragmentFragment = {
  name?: string | null;
  website?: string | null;
  linkedin?: string | null;
  founded_year?: number | null;
  industry?: string | null;
  sub_industry?: string | null;
  employee_counts?: any | null;
  revenue?: any | null;
  city?: string | null;
  state?: string | null;
  zip_code?: string | null;
  country?: string | null;
  ticker?: string | null;
  phone?: string | null;
  type?: string | null;
  natural_name?: string | null;
  tags?: string | null;
  address?: string | null;
  naics?: number | null;
  revtron_id: number;
};

export type IcpModuleQueryVariables = Exact<{
  where: Account_bool_exp;
  orderBy: Account_order_by;
  limit: Scalars["Int"];
}>;

export type IcpModuleQuery = {
  Account: Array<{
    Id: string;
    Name?: string | null;
    Website?: string | null;
    AnnualRevenue?: any | null;
    NumberOfEmployees?: number | null;
    to_revtron?: {
      revtron_id: number;
      to_revtron_companies: Array<{
        name?: string | null;
        website?: string | null;
        linkedin?: string | null;
        founded_year?: number | null;
        industry?: string | null;
        sub_industry?: string | null;
        employee_counts?: any | null;
        revenue?: any | null;
        city?: string | null;
        state?: string | null;
        zip_code?: string | null;
        country?: string | null;
        ticker?: string | null;
        phone?: string | null;
        type?: string | null;
        natural_name?: string | null;
        tags?: string | null;
        address?: string | null;
        naics?: number | null;
        revtron_id: number;
      }>;
    } | null;
    account_module_static?: { predict_proba?: any | null } | null;
  }>;
};

export type AccountRecModuleQueryVariables = Exact<{
  where: ml_icp_last_prediction_bool_exp;
  orderBy: ml_icp_last_prediction_order_by;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
}>;

export type AccountRecModuleQuery = {
  accountsRec: Array<{
    crm_id?: string | null;
    predict_proba?: any | null;
    revtron_id?: number | null;
    to_revtron_companies?: {
      name?: string | null;
      natural_name?: string | null;
      website?: string | null;
      phone?: string | null;
      type?: string | null;
      ticker?: string | null;
      founded_year?: number | null;
      address?: string | null;
      city?: string | null;
      state?: string | null;
      zip_code?: string | null;
      country?: string | null;
      employee_counts?: any | null;
      revenue?: any | null;
      linkedin?: string | null;
      naics?: number | null;
      industry?: string | null;
      sub_industry?: string | null;
      tags?: string | null;
    } | null;
  }>;
  totalRecords: { aggregate?: { count: number } | null };
};

export type LoggedinUserQueryVariables = Exact<{
  userId: Scalars["uuid"];
}>;

export type LoggedinUserQuery = {
  user?: {
    revtron_user_id: any;
    crm_users?: { id?: string | null } | null;
  } | null;
};

export type SendDataToCrmEventsMutationVariables = Exact<{
  crmEventsData:
    | Array<send_to_crm_events_insert_input>
    | send_to_crm_events_insert_input;
}>;

export type SendDataToCrmEventsMutation = {
  insert_send_to_crm_events?: {
    returning: Array<{
      id: any;
      revtron_user_id: any;
      revtron_company_id?: number | null;
      crm_user_id?: string | null;
      records: any;
    }>;
  } | null;
};

export type MonthlyBookingsQueryVariables = Exact<{ [key: string]: never }>;

export type MonthlyBookingsQuery = {
  monthly_bookings_gql: Array<{ date_trunc?: any | null; sum?: any | null }>;
};

export type BookingsByOwnerQueryVariables = Exact<{ [key: string]: never }>;

export type BookingsByOwnerQuery = {
  bookings_by_owner_gql: Array<{
    bookings?: any | null;
    team_member?: string | null;
    userid?: string | null;
    photo_url?: string | null;
  }>;
};

export type RunningRevenueQueryVariables = Exact<{ [key: string]: never }>;

export type RunningRevenueQuery = {
  running_revenue_gql: Array<{ day?: any | null; revenue?: any | null }>;
};

export type LeaderboardSummaryQueryVariables = Exact<{ [key: string]: never }>;

export type LeaderboardSummaryQuery = {
  leaderboard_summary_gql_aggregate: {
    aggregate?: {
      count: number;
      sum?: { licenses__c?: any | null } | null;
      avg?: { licenses__c?: number | null } | null;
    } | null;
  };
};

export type SalesVeloBreakdownQueryVariables = Exact<{ [key: string]: never }>;

export type SalesVeloBreakdownQuery = {
  revtron_reporting_sales_velocity_details_gql: Array<{
    stat?: any | null;
    type?: string | null;
  }>;
};

export type SalesVelocityDataByOwnerQueryVariables = Exact<{
  oppWhere: Opportunity_bool_exp;
  pipelineWhere: Opportunity_bool_exp;
  netNewAvgWhere: Opportunity_bool_exp;
  winRateWhere: win_rate_totals_bool_exp;
  individualWinRateWhere: win_rates_individual_gql_bool_exp;
}>;

export type SalesVelocityDataByOwnerQuery = {
  crm_users: Array<{
    id?: string | null;
    name?: string | null;
    email?: string | null;
    to_opp: Array<{
      Id: string;
      Name?: string | null;
      Type?: string | null;
      StageName?: string | null;
      ForecastCategoryName?: string | null;
      CloseDate?: any | null;
      CreatedDate?: any | null;
      Amount?: any | null;
      LeadSource?: string | null;
      IsClosed?: boolean | null;
      IsWon?: boolean | null;
    }>;
    revtron_users?: {
      avatarUrl: string;
      revtron_team?: {
        to_teams?: { name: string; type: string } | null;
      } | null;
    } | null;
    avg: {
      aggregate?: {
        number_of_wins: number;
        avg?: { avg_deal_size?: number | null } | null;
      } | null;
      nodes: Array<{
        CreatedDate?: any | null;
        CloseDate?: any | null;
        Amount?: any | null;
      }>;
    };
    pipeline: { aggregate?: { ninety_day_pipeline: number } | null };
    to_win_rates: Array<{
      type?: string | null;
      wins?: any | null;
      losses?: any | null;
      total_opps?: any | null;
      win_rate?: any | null;
    }>;
  }>;
  ninety_days_pipeline: { aggregate?: { count: number } | null };
  net_new_avg: {
    aggregate?: { avg?: { Amount?: number | null } | null } | null;
    nodes: Array<{ CreatedDate?: any | null; CloseDate?: any | null }>;
  };
  win_rate: Array<{ type?: string | null; win_rate?: any | null }>;
};

export type MonthlyRevenueQueryVariables = Exact<{ [key: string]: never }>;

export type MonthlyRevenueQuery = {
  running_revenue_gql: Array<{ day?: any | null; revenue?: any | null }>;
};

export type WeeklyEffortNewQueryVariables = Exact<{ [key: string]: never }>;

export type WeeklyEffortNewQuery = {
  weekly_effort_breakdown_overview_gql: Array<{
    count?: any | null;
    date_trunc?: any | null;
    meeting_key?: any | null;
    task_categorization?: number | null;
    type_category?: string | null;
    type_detail?: string | null;
  }>;
};

export type MonthlyEffortNewQueryVariables = Exact<{ [key: string]: never }>;

export type MonthlyEffortNewQuery = {
  monthly_effort_breakdown_overview_gql: Array<{
    count?: any | null;
    date_trunc?: any | null;
    meeting_key?: any | null;
    task_categorization?: number | null;
    type_category?: string | null;
    type_detail?: string | null;
  }>;
};

export type WeeklyEngagementNewQueryVariables = Exact<{ [key: string]: never }>;

export type WeeklyEngagementNewQuery = {
  weekly_engagement_breakdown_overview_gql: Array<{
    count?: any | null;
    date_trunc?: any | null;
    meeting_key?: any | null;
    task_categorization?: number | null;
    type_category?: string | null;
    type_detail?: string | null;
  }>;
};

export type MonthlyEngagementNewQueryVariables = Exact<{
  [key: string]: never;
}>;

export type MonthlyEngagementNewQuery = {
  monthly_engagement_breakdown_overview_gql: Array<{
    count?: any | null;
    date_trunc?: any | null;
    meeting_key?: any | null;
    task_categorization?: number | null;
    type_category?: string | null;
    type_detail?: string | null;
  }>;
};

export type MonthlyPipelineQueryVariables = Exact<{ [key: string]: never }>;

export type MonthlyPipelineQuery = {
  monthly_pipeline_gql_new: Array<{
    amount?: any | null;
    date_trunc?: any | null;
    lead_source?: string | null;
    opportunity_id?: string | null;
    opportunity_name?: string | null;
    owner_name?: string | null;
    stagename?: string | null;
  }>;
};

export type WeeklyPipelineQueryVariables = Exact<{ [key: string]: never }>;

export type WeeklyPipelineQuery = {
  weekly_pipeline_gql_new: Array<{
    amount?: any | null;
    date_trunc?: any | null;
    lead_source?: string | null;
    opportunity_id?: string | null;
    opportunity_name?: string | null;
    owner_name?: string | null;
    stagename?: string | null;
  }>;
};

export type TofTotalNumbersYoyQueryVariables = Exact<{ [key: string]: never }>;

export type TofTotalNumbersYoyQuery = {
  revtron_reporting_total_tof_numbers_yoy_gql: Array<{
    current_period_opps?: any | null;
    percent_change?: any | null;
    previous_period_count?: any | null;
    type?: string | null;
  }>;
};

export type TofNumbersYoyQueryVariables = Exact<{ [key: string]: never }>;

export type TofNumbersYoyQuery = {
  revtron_reporting_tof_numbers_yoy_gql: Array<{
    current_period_opps?: any | null;
    percent_change?: any | null;
    previous_period_count?: any | null;
    type?: string | null;
  }>;
};

export type TotalBookingsYoyQueryVariables = Exact<{ [key: string]: never }>;

export type TotalBookingsYoyQuery = {
  revtron_reporting_total_bookings_yoy_gql: Array<{
    type?: string | null;
    previous_period_revenue?: any | null;
    percent_change?: any | null;
    current_period_revenue?: any | null;
  }>;
};

export type BookingsYoyQueryVariables = Exact<{ [key: string]: never }>;

export type BookingsYoyQuery = {
  revtron_reporting_bookings_yoy_gql: Array<{
    current_period_revenue?: any | null;
    percent_change?: any | null;
    previous_period_revenue?: any | null;
    type?: string | null;
  }>;
};

export type OppDetailEngagementAllQueryVariables = Exact<{
  [key: string]: never;
}>;

export type OppDetailEngagementAllQuery = {
  pipeline_opp_detail_ml_gql: Array<{
    account_id?: string | null;
    account_name?: string | null;
    amount?: any | null;
    closedate?: any | null;
    coalesce?: any | null;
    createddate?: any | null;
    email?: string | null;
    forecast_category?: string | null;
    leadsource?: string | null;
    opportunity_id?: string | null;
    opportunity_name?: string | null;
    opportunity_owner?: string | null;
    ownerid?: string | null;
    probability?: any | null;
    stage?: string | null;
    services_amount?: any | null;
    opportunity_age?: any | null;
    opportunity_link?: string | null;
    type?: string | null;
    custom_filter_1?: string | null;
  }>;
};

export type OppDetailEngagementFilterQueryVariables = Exact<{
  where: pipeline_opp_detail_ml_gql_bool_exp;
}>;

export type OppDetailEngagementFilterQuery = {
  pipeline_opp_detail_ml_gql: Array<{
    account_id?: string | null;
    account_name?: string | null;
    amount?: any | null;
    closedate?: any | null;
    coalesce?: any | null;
    createddate?: any | null;
    email?: string | null;
    forecast_category?: string | null;
    leadsource?: string | null;
    opportunity_id?: string | null;
    opportunity_name?: string | null;
    opportunity_owner?: string | null;
    ownerid?: string | null;
    probability?: any | null;
    stage?: string | null;
    services_amount?: any | null;
    opportunity_age?: any | null;
    opportunity_link?: string | null;
    type?: string | null;
  }>;
};

export type PipelineActivityDrillDownQueryVariables = Exact<{
  account_id?: InputMaybe<Array<Scalars["String"]> | Scalars["String"]>;
}>;

export type PipelineActivityDrillDownQuery = {
  pipeline_activity_drill_down_gql: Array<{
    account_id?: string | null;
    account_name?: string | null;
    contact_id?: string | null;
    contact_name?: string | null;
    contact_title?: string | null;
    createddate?: any | null;
    description?: string | null;
    subject?: string | null;
    task_id?: string | null;
    tasksubtype?: string | null;
    type?: string | null;
    user_name?: string | null;
  }>;
};

export type BookedAggregateQueryVariables = Exact<{
  where: pipeline_opp_detail_ml_gql_bool_exp;
}>;

export type BookedAggregateQuery = {
  pipeline_opp_detail_ml_gql_aggregate: {
    aggregate?: {
      count: number;
      sum?: { amount?: any | null; services_amount?: any | null } | null;
    } | null;
  };
};

export type PipeAggregateQueryVariables = Exact<{
  where: pipeline_opp_detail_ml_gql_bool_exp;
}>;

export type PipeAggregateQuery = {
  pipeline_opp_detail_ml_gql_aggregate: {
    aggregate?: {
      count: number;
      sum?: { amount?: any | null; services_amount?: any | null } | null;
    } | null;
  };
};

export type WeightedAggregateQueryVariables = Exact<{
  where: weighted_pipeline_ml_gql_bool_exp;
}>;

export type WeightedAggregateQuery = {
  weighted_pipeline_ml_gql_aggregate: {
    aggregate?: {
      sum?: { weighted_arr?: any | null; ml_weighted_arr?: any | null } | null;
    } | null;
  };
};

export type UpdateUserMutationVariables = Exact<{
  id: Scalars["uuid"];
  displayName: Scalars["String"];
  metadata?: InputMaybe<Scalars["jsonb"]>;
}>;

export type UpdateUserMutation = {
  updateUser?: { id: any; displayName: string; metadata?: any | null } | null;
};

export type UpdateUserAvatarMutationVariables = Exact<{
  id: Scalars["uuid"];
  avatarUrl?: InputMaybe<Scalars["String"]>;
}>;

export type UpdateUserAvatarMutation = {
  updateUser?: { id: any; avatarUrl: string } | null;
};

export type ProspectorModuleQueryVariables = Exact<{
  where: Account_bool_exp;
  orderBy: Account_order_by;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
}>;

export type ProspectorModuleQuery = {
  prospectors: Array<{
    Id: string;
    Name?: string | null;
    Website?: string | null;
    Phone?: string | null;
    Industry?: string | null;
    NumberOfEmployees?: number | null;
    AnnualRevenue?: any | null;
    Type?: string | null;
    Description?: string | null;
    TickerSymbol?: string | null;
    BillingStreet?: string | null;
    BillingCity?: string | null;
    BillingState?: string | null;
    BillingPostalCode?: string | null;
    BillingCountry?: string | null;
    account_module_static?: { predict_proba?: any | null } | null;
  }>;
  totalRecords: { aggregate?: { count: number } | null };
};

export type SavePeopleDataMutationVariables = Exact<{
  people: Array<pdl_people_data_insert_input> | pdl_people_data_insert_input;
}>;

export type SavePeopleDataMutation = {
  insert_pdl_people_data?: { returning: Array<{ id: string }> } | null;
};

export type SavePeoplePreviewDataMutationVariables = Exact<{
  people:
    | Array<pdl_people_preview_insert_input>
    | pdl_people_preview_insert_input;
}>;

export type SavePeoplePreviewDataMutation = {
  insert_pdl_people_preview?: { returning: Array<{ id: string }> } | null;
};

export type UserListQueryVariables = Exact<{ [key: string]: never }>;

export type UserListQuery = {
  users: Array<{
    avatarUrl: string;
    disabled: boolean;
    defaultRole: string;
    email?: any | null;
    displayName: string;
    id: any;
    crm_users?: {
      title?: string | null;
      name?: string | null;
      email?: string | null;
      isactive?: boolean | null;
    } | null;
  }>;
};

export type TeamListSubscriptionVariables = Exact<{ [key: string]: never }>;

export type TeamListSubscription = {
  teams: Array<{
    id: any;
    name: string;
    type: string;
    opportunity_target: any;
    email_target: any;
    call_target: any;
    social_target: any;
    to_members: Array<{
      user_id: any;
      id: any;
      to_users?: { displayName: string; avatarUrl: string } | null;
    }>;
  }>;
};

export type CreateTeamMutationVariables = Exact<{
  name?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Scalars["String"]>;
  opportunity_target?: InputMaybe<Scalars["bigint"]>;
  email_target?: InputMaybe<Scalars["bigint"]>;
  call_target?: InputMaybe<Scalars["bigint"]>;
  social_target?: InputMaybe<Scalars["bigint"]>;
}>;

export type CreateTeamMutation = {
  insert_teams?: { affected_rows: number } | null;
};

export type RemoveTeamMutationVariables = Exact<{
  id?: InputMaybe<Scalars["bigint"]>;
}>;

export type RemoveTeamMutation = {
  update_teams_by_pk?: { is_deleted: boolean } | null;
};

export type UpdateTeamMutationVariables = Exact<{
  id?: InputMaybe<Scalars["bigint"]>;
  name?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Scalars["String"]>;
  opportunity_target?: InputMaybe<Scalars["bigint"]>;
  email_target?: InputMaybe<Scalars["bigint"]>;
  call_target?: InputMaybe<Scalars["bigint"]>;
  social_target?: InputMaybe<Scalars["bigint"]>;
}>;

export type UpdateTeamMutation = {
  update_teams_by_pk?: { id: any; name: string } | null;
};

export type InsertTeamMemberMutationVariables = Exact<{
  team_id?: InputMaybe<Scalars["bigint"]>;
  user_id?: InputMaybe<Scalars["uuid"]>;
}>;

export type InsertTeamMemberMutation = {
  insert_team_members_one?: { team_id: any; user_id: any } | null;
};

export type RemoveTeamMemberMutationVariables = Exact<{
  id?: InputMaybe<Scalars["bigint"]>;
}>;

export type RemoveTeamMemberMutation = {
  delete_team_members_by_pk?: { id: any; user_id: any } | null;
};

export type AllCrmUsersSubscriptionVariables = Exact<{ [key: string]: never }>;

export type AllCrmUsersSubscription = {
  crm_users: Array<{
    firstname?: string | null;
    lastname?: string | null;
    name?: string | null;
    email?: string | null;
    title?: string | null;
    revtron_users?: { id: any; avatarUrl: string } | null;
  }>;
};

export type CreateInviteMutationVariables = Exact<{
  invitee_email?: InputMaybe<Scalars["citext"]>;
  inviter_id?: InputMaybe<Scalars["String"]>;
}>;

export type CreateInviteMutation = {
  insert_invites?: { returning: Array<{ invitee_email: any }> } | null;
};

export type RemoveUserMutationVariables = Exact<{
  id?: InputMaybe<Scalars["uuid"]>;
}>;

export type RemoveUserMutation = { updateUser?: { disabled: boolean } | null };

export type CrmAccountFieldsQueryVariables = Exact<{ [key: string]: never }>;

export type CrmAccountFieldsQuery = {
  account?: {
    fields?: Array<{
      name: string;
      type: { name?: string | null; kind: __TypeKind };
    }> | null;
  } | null;
  revtronCompanies?: {
    fields?: Array<{
      name: string;
      type: { name?: string | null; kind: __TypeKind };
    }> | null;
  } | null;
};

export type CrmContactFieldsQueryVariables = Exact<{ [key: string]: never }>;

export type CrmContactFieldsQuery = {
  contact?: {
    fields?: Array<{
      name: string;
      type: { name?: string | null; kind: __TypeKind };
    }> | null;
  } | null;
  pdlPeopleData?: {
    fields?: Array<{
      name: string;
      type: { name?: string | null; kind: __TypeKind };
    }> | null;
  } | null;
};

export type CrmAccountMappingsQueryVariables = Exact<{ [key: string]: never }>;

export type CrmAccountMappingsQuery = {
  crm_account_mappings: Array<{
    id: any;
    crm_field: string;
    revtron_field: string;
    is_active: boolean;
    method: string;
  }>;
};

export type CrmContactMappingsQueryVariables = Exact<{ [key: string]: never }>;

export type CrmContactMappingsQuery = {
  crm_contact_mappings: Array<{
    id: any;
    crm_field: string;
    revtron_field: string;
    is_active: boolean;
    method: string;
  }>;
};

export type UpdateAccountMappingsMutationVariables = Exact<{
  mappings:
    | Array<crm_account_mappings_insert_input>
    | crm_account_mappings_insert_input;
  removeIds?: InputMaybe<Array<Scalars["bigint"]> | Scalars["bigint"]>;
}>;

export type UpdateAccountMappingsMutation = {
  insert_crm_account_mappings?: {
    returning: Array<{
      id: any;
      crm_field: string;
      revtron_field: string;
      is_active: boolean;
      method: string;
    }>;
  } | null;
  delete_crm_account_mappings?: { affected_rows: number } | null;
};

export type UpdateContactMappingsMutationVariables = Exact<{
  mappings:
    | Array<crm_contact_mappings_insert_input>
    | crm_contact_mappings_insert_input;
  removeIds?: InputMaybe<Array<Scalars["bigint"]> | Scalars["bigint"]>;
}>;

export type UpdateContactMappingsMutation = {
  insert_crm_contact_mappings?: {
    returning: Array<{
      id: any;
      crm_field: string;
      revtron_field: string;
      is_active: boolean;
      method: string;
    }>;
  } | null;
  delete_crm_contact_mappings?: { affected_rows: number } | null;
};

export const _revtron_companiesFragmentFragmentDoc = gql`
  fragment _revtron_companiesFragment on _revtron_companies {
    revtron_id: id
    name
    website
    linkedin
    founded_year
    industry
    sub_industry
    employee_counts
    revenue
    city
    state
    zip_code
    country
    ticker
    phone
    type
    natural_name
    tags
    address
    naics
  }
`;
export const AccountListDocument = gql`
  query AccountList(
    $offset: Int
    $limit: Int
    $where: account_module_static_bool_exp!
  ) {
    account_module_static(
      offset: $offset
      limit: $limit
      where: $where
      order_by: { predct_proba: desc_nulls_last }
    ) {
      account_id
      account_name
      account_owner
      billingcity
      billingcountry
      billingstate
      effort
      engagement
      account_status_auto__c
      predct_proba
    }
    account_module_static_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

/**
 * __useAccountListQuery__
 *
 * To run a query within a React component, call `useAccountListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountListQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAccountListQuery(
  baseOptions: Apollo.QueryHookOptions<
    AccountListQuery,
    AccountListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AccountListQuery, AccountListQueryVariables>(
    AccountListDocument,
    options
  );
}
export function useAccountListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccountListQuery,
    AccountListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AccountListQuery, AccountListQueryVariables>(
    AccountListDocument,
    options
  );
}
export type AccountListQueryHookResult = ReturnType<typeof useAccountListQuery>;
export type AccountListLazyQueryHookResult = ReturnType<
  typeof useAccountListLazyQuery
>;
export type AccountListQueryResult = Apollo.QueryResult<
  AccountListQuery,
  AccountListQueryVariables
>;
export function refetchAccountListQuery(variables: AccountListQueryVariables) {
  return { query: AccountListDocument, variables: variables };
}
export const AggregateAccountsCountDocument = gql`
  query AggregateAccountsCount($where: account_module_static_bool_exp!) {
    account_module_static_aggregate(where: $where) {
      aggregate {
        count(columns: account_id)
      }
    }
  }
`;

/**
 * __useAggregateAccountsCountQuery__
 *
 * To run a query within a React component, call `useAggregateAccountsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAggregateAccountsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAggregateAccountsCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAggregateAccountsCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    AggregateAccountsCountQuery,
    AggregateAccountsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AggregateAccountsCountQuery,
    AggregateAccountsCountQueryVariables
  >(AggregateAccountsCountDocument, options);
}
export function useAggregateAccountsCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AggregateAccountsCountQuery,
    AggregateAccountsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AggregateAccountsCountQuery,
    AggregateAccountsCountQueryVariables
  >(AggregateAccountsCountDocument, options);
}
export type AggregateAccountsCountQueryHookResult = ReturnType<
  typeof useAggregateAccountsCountQuery
>;
export type AggregateAccountsCountLazyQueryHookResult = ReturnType<
  typeof useAggregateAccountsCountLazyQuery
>;
export type AggregateAccountsCountQueryResult = Apollo.QueryResult<
  AggregateAccountsCountQuery,
  AggregateAccountsCountQueryVariables
>;
export function refetchAggregateAccountsCountQuery(
  variables: AggregateAccountsCountQueryVariables
) {
  return { query: AggregateAccountsCountDocument, variables: variables };
}
export const AggregateEngagedCountDocument = gql`
  query AggregateEngagedCount($where: account_module_static_bool_exp!) {
    account_module_static_aggregate(where: $where) {
      aggregate {
        count(columns: account_id)
      }
    }
  }
`;

/**
 * __useAggregateEngagedCountQuery__
 *
 * To run a query within a React component, call `useAggregateEngagedCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAggregateEngagedCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAggregateEngagedCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAggregateEngagedCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    AggregateEngagedCountQuery,
    AggregateEngagedCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AggregateEngagedCountQuery,
    AggregateEngagedCountQueryVariables
  >(AggregateEngagedCountDocument, options);
}
export function useAggregateEngagedCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AggregateEngagedCountQuery,
    AggregateEngagedCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AggregateEngagedCountQuery,
    AggregateEngagedCountQueryVariables
  >(AggregateEngagedCountDocument, options);
}
export type AggregateEngagedCountQueryHookResult = ReturnType<
  typeof useAggregateEngagedCountQuery
>;
export type AggregateEngagedCountLazyQueryHookResult = ReturnType<
  typeof useAggregateEngagedCountLazyQuery
>;
export type AggregateEngagedCountQueryResult = Apollo.QueryResult<
  AggregateEngagedCountQuery,
  AggregateEngagedCountQueryVariables
>;
export function refetchAggregateEngagedCountQuery(
  variables: AggregateEngagedCountQueryVariables
) {
  return { query: AggregateEngagedCountDocument, variables: variables };
}
export const AggregateColdCountDocument = gql`
  query AggregateColdCount($where: account_module_static_bool_exp!) {
    account_module_static_aggregate(where: $where) {
      aggregate {
        count(columns: account_id)
      }
    }
  }
`;

/**
 * __useAggregateColdCountQuery__
 *
 * To run a query within a React component, call `useAggregateColdCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAggregateColdCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAggregateColdCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAggregateColdCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    AggregateColdCountQuery,
    AggregateColdCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AggregateColdCountQuery,
    AggregateColdCountQueryVariables
  >(AggregateColdCountDocument, options);
}
export function useAggregateColdCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AggregateColdCountQuery,
    AggregateColdCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AggregateColdCountQuery,
    AggregateColdCountQueryVariables
  >(AggregateColdCountDocument, options);
}
export type AggregateColdCountQueryHookResult = ReturnType<
  typeof useAggregateColdCountQuery
>;
export type AggregateColdCountLazyQueryHookResult = ReturnType<
  typeof useAggregateColdCountLazyQuery
>;
export type AggregateColdCountQueryResult = Apollo.QueryResult<
  AggregateColdCountQuery,
  AggregateColdCountQueryVariables
>;
export function refetchAggregateColdCountQuery(
  variables: AggregateColdCountQueryVariables
) {
  return { query: AggregateColdCountDocument, variables: variables };
}
export const AccountOwnerListDocument = gql`
  query AccountOwnerList {
    account_module_static(distinct_on: account_owner) {
      account_owner
    }
  }
`;

/**
 * __useAccountOwnerListQuery__
 *
 * To run a query within a React component, call `useAccountOwnerListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountOwnerListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountOwnerListQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountOwnerListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AccountOwnerListQuery,
    AccountOwnerListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AccountOwnerListQuery, AccountOwnerListQueryVariables>(
    AccountOwnerListDocument,
    options
  );
}
export function useAccountOwnerListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccountOwnerListQuery,
    AccountOwnerListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AccountOwnerListQuery,
    AccountOwnerListQueryVariables
  >(AccountOwnerListDocument, options);
}
export type AccountOwnerListQueryHookResult = ReturnType<
  typeof useAccountOwnerListQuery
>;
export type AccountOwnerListLazyQueryHookResult = ReturnType<
  typeof useAccountOwnerListLazyQuery
>;
export type AccountOwnerListQueryResult = Apollo.QueryResult<
  AccountOwnerListQuery,
  AccountOwnerListQueryVariables
>;
export function refetchAccountOwnerListQuery(
  variables?: AccountOwnerListQueryVariables
) {
  return { query: AccountOwnerListDocument, variables: variables };
}
export const AccountCustomStatusListDocument = gql`
  query AccountCustomStatusList {
    account_module_static(distinct_on: account_status_auto__c) {
      account_status_auto__c
    }
  }
`;

/**
 * __useAccountCustomStatusListQuery__
 *
 * To run a query within a React component, call `useAccountCustomStatusListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountCustomStatusListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountCustomStatusListQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountCustomStatusListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AccountCustomStatusListQuery,
    AccountCustomStatusListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AccountCustomStatusListQuery,
    AccountCustomStatusListQueryVariables
  >(AccountCustomStatusListDocument, options);
}
export function useAccountCustomStatusListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccountCustomStatusListQuery,
    AccountCustomStatusListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AccountCustomStatusListQuery,
    AccountCustomStatusListQueryVariables
  >(AccountCustomStatusListDocument, options);
}
export type AccountCustomStatusListQueryHookResult = ReturnType<
  typeof useAccountCustomStatusListQuery
>;
export type AccountCustomStatusListLazyQueryHookResult = ReturnType<
  typeof useAccountCustomStatusListLazyQuery
>;
export type AccountCustomStatusListQueryResult = Apollo.QueryResult<
  AccountCustomStatusListQuery,
  AccountCustomStatusListQueryVariables
>;
export function refetchAccountCustomStatusListQuery(
  variables?: AccountCustomStatusListQueryVariables
) {
  return { query: AccountCustomStatusListDocument, variables: variables };
}
export const AccountExpandedRowDocument = gql`
  query AccountExpandedRow($account_id: [String!]) {
    account_module_expansion_gql(where: { account_id: { _in: $account_id } }) {
      number_of_contacts
      open_opp_count
      daily_engagement {
        activity_date
        engagement
        effort
      }
      daily_engagement_aggregate(where: { activity_date: { _lte: "now()" } }) {
        aggregate {
          max {
            activity_date
          }
        }
      }
    }
  }
`;

/**
 * __useAccountExpandedRowQuery__
 *
 * To run a query within a React component, call `useAccountExpandedRowQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountExpandedRowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountExpandedRowQuery({
 *   variables: {
 *      account_id: // value for 'account_id'
 *   },
 * });
 */
export function useAccountExpandedRowQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AccountExpandedRowQuery,
    AccountExpandedRowQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AccountExpandedRowQuery,
    AccountExpandedRowQueryVariables
  >(AccountExpandedRowDocument, options);
}
export function useAccountExpandedRowLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccountExpandedRowQuery,
    AccountExpandedRowQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AccountExpandedRowQuery,
    AccountExpandedRowQueryVariables
  >(AccountExpandedRowDocument, options);
}
export type AccountExpandedRowQueryHookResult = ReturnType<
  typeof useAccountExpandedRowQuery
>;
export type AccountExpandedRowLazyQueryHookResult = ReturnType<
  typeof useAccountExpandedRowLazyQuery
>;
export type AccountExpandedRowQueryResult = Apollo.QueryResult<
  AccountExpandedRowQuery,
  AccountExpandedRowQueryVariables
>;
export function refetchAccountExpandedRowQuery(
  variables?: AccountExpandedRowQueryVariables
) {
  return { query: AccountExpandedRowDocument, variables: variables };
}
export const WeeklyLeaderboardDocument = gql`
  query WeeklyLeaderboard {
    weekly_activity_vs_targets_gql(order_by: { weekly_engagement: desc }) {
      call_answered
      call_targets
      calls_out
      conversation_targets
      date_trunc
      email
      email_address
      email_opens
      email_responses
      email_targets
      emails_sent
      id
      inbound_calls
      meetings_booked
      meetings_targets
      name
      name_team_member
      opportunity_create_count
      opportunity_targets
      ownerid
      pipeline_targets
      social
      social_targets
      total_activity_targets
      weekly_effort
      weekly_engagement
      photo_url
      engagement_ratio
    }
  }
`;

/**
 * __useWeeklyLeaderboardQuery__
 *
 * To run a query within a React component, call `useWeeklyLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeeklyLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeeklyLeaderboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useWeeklyLeaderboardQuery(
  baseOptions?: Apollo.QueryHookOptions<
    WeeklyLeaderboardQuery,
    WeeklyLeaderboardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    WeeklyLeaderboardQuery,
    WeeklyLeaderboardQueryVariables
  >(WeeklyLeaderboardDocument, options);
}
export function useWeeklyLeaderboardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WeeklyLeaderboardQuery,
    WeeklyLeaderboardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WeeklyLeaderboardQuery,
    WeeklyLeaderboardQueryVariables
  >(WeeklyLeaderboardDocument, options);
}
export type WeeklyLeaderboardQueryHookResult = ReturnType<
  typeof useWeeklyLeaderboardQuery
>;
export type WeeklyLeaderboardLazyQueryHookResult = ReturnType<
  typeof useWeeklyLeaderboardLazyQuery
>;
export type WeeklyLeaderboardQueryResult = Apollo.QueryResult<
  WeeklyLeaderboardQuery,
  WeeklyLeaderboardQueryVariables
>;
export function refetchWeeklyLeaderboardQuery(
  variables?: WeeklyLeaderboardQueryVariables
) {
  return { query: WeeklyLeaderboardDocument, variables: variables };
}
export const OppDetailDocument = gql`
  query OppDetail {
    opp_detail_gql(order_by: { amount: desc }) {
      account_id
      account_name
      amount
      closedate
      createddate
      email
      forecast_category
      leadsource
      opportunity_id
      opportunity_name
      opportunity_owner
      ownerid
      stage
      created_by
    }
  }
`;

/**
 * __useOppDetailQuery__
 *
 * To run a query within a React component, call `useOppDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useOppDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOppDetailQuery({
 *   variables: {
 *   },
 * });
 */
export function useOppDetailQuery(
  baseOptions?: Apollo.QueryHookOptions<OppDetailQuery, OppDetailQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OppDetailQuery, OppDetailQueryVariables>(
    OppDetailDocument,
    options
  );
}
export function useOppDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OppDetailQuery,
    OppDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<OppDetailQuery, OppDetailQueryVariables>(
    OppDetailDocument,
    options
  );
}
export type OppDetailQueryHookResult = ReturnType<typeof useOppDetailQuery>;
export type OppDetailLazyQueryHookResult = ReturnType<
  typeof useOppDetailLazyQuery
>;
export type OppDetailQueryResult = Apollo.QueryResult<
  OppDetailQuery,
  OppDetailQueryVariables
>;
export function refetchOppDetailQuery(variables?: OppDetailQueryVariables) {
  return { query: OppDetailDocument, variables: variables };
}
export const TeamActivityDocument = gql`
  query TeamActivity {
    team_activity_gql {
      calls_out
      calls_actuals
      calls_target
      emails_sent
      email_actuals
      email_targets
      meetings
      opportunities
      opportunity_targets
      meeting_targets
      opportunity_actuals
      social
      social_actuals
      social_target
    }
  }
`;

/**
 * __useTeamActivityQuery__
 *
 * To run a query within a React component, call `useTeamActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamActivityQuery({
 *   variables: {
 *   },
 * });
 */
export function useTeamActivityQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TeamActivityQuery,
    TeamActivityQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TeamActivityQuery, TeamActivityQueryVariables>(
    TeamActivityDocument,
    options
  );
}
export function useTeamActivityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TeamActivityQuery,
    TeamActivityQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TeamActivityQuery, TeamActivityQueryVariables>(
    TeamActivityDocument,
    options
  );
}
export type TeamActivityQueryHookResult = ReturnType<
  typeof useTeamActivityQuery
>;
export type TeamActivityLazyQueryHookResult = ReturnType<
  typeof useTeamActivityLazyQuery
>;
export type TeamActivityQueryResult = Apollo.QueryResult<
  TeamActivityQuery,
  TeamActivityQueryVariables
>;
export function refetchTeamActivityQuery(
  variables?: TeamActivityQueryVariables
) {
  return { query: TeamActivityDocument, variables: variables };
}
export const IndividualProgressDocument = gql`
  query IndividualProgress {
    actuals_vs_targets_activity {
      ownerid
      name
      emails_sent
      emails
      calls_out
      calls
      social
      social_target
      opportunity_create_count
      opportunities
    }
  }
`;

/**
 * __useIndividualProgressQuery__
 *
 * To run a query within a React component, call `useIndividualProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndividualProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndividualProgressQuery({
 *   variables: {
 *   },
 * });
 */
export function useIndividualProgressQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IndividualProgressQuery,
    IndividualProgressQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    IndividualProgressQuery,
    IndividualProgressQueryVariables
  >(IndividualProgressDocument, options);
}
export function useIndividualProgressLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IndividualProgressQuery,
    IndividualProgressQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    IndividualProgressQuery,
    IndividualProgressQueryVariables
  >(IndividualProgressDocument, options);
}
export type IndividualProgressQueryHookResult = ReturnType<
  typeof useIndividualProgressQuery
>;
export type IndividualProgressLazyQueryHookResult = ReturnType<
  typeof useIndividualProgressLazyQuery
>;
export type IndividualProgressQueryResult = Apollo.QueryResult<
  IndividualProgressQuery,
  IndividualProgressQueryVariables
>;
export function refetchIndividualProgressQuery(
  variables?: IndividualProgressQueryVariables
) {
  return { query: IndividualProgressDocument, variables: variables };
}
export const WeeklyLeaderboardMeetingDetailDocument = gql`
  query WeeklyLeaderboardMeetingDetail {
    first_meetings_leads_accounts_gql {
      account_name
      contact
      title
      subject
      createddate
      activitydate
      meeting_owner
      eventid
    }
  }
`;

/**
 * __useWeeklyLeaderboardMeetingDetailQuery__
 *
 * To run a query within a React component, call `useWeeklyLeaderboardMeetingDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeeklyLeaderboardMeetingDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeeklyLeaderboardMeetingDetailQuery({
 *   variables: {
 *   },
 * });
 */
export function useWeeklyLeaderboardMeetingDetailQuery(
  baseOptions?: Apollo.QueryHookOptions<
    WeeklyLeaderboardMeetingDetailQuery,
    WeeklyLeaderboardMeetingDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    WeeklyLeaderboardMeetingDetailQuery,
    WeeklyLeaderboardMeetingDetailQueryVariables
  >(WeeklyLeaderboardMeetingDetailDocument, options);
}
export function useWeeklyLeaderboardMeetingDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WeeklyLeaderboardMeetingDetailQuery,
    WeeklyLeaderboardMeetingDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WeeklyLeaderboardMeetingDetailQuery,
    WeeklyLeaderboardMeetingDetailQueryVariables
  >(WeeklyLeaderboardMeetingDetailDocument, options);
}
export type WeeklyLeaderboardMeetingDetailQueryHookResult = ReturnType<
  typeof useWeeklyLeaderboardMeetingDetailQuery
>;
export type WeeklyLeaderboardMeetingDetailLazyQueryHookResult = ReturnType<
  typeof useWeeklyLeaderboardMeetingDetailLazyQuery
>;
export type WeeklyLeaderboardMeetingDetailQueryResult = Apollo.QueryResult<
  WeeklyLeaderboardMeetingDetailQuery,
  WeeklyLeaderboardMeetingDetailQueryVariables
>;
export function refetchWeeklyLeaderboardMeetingDetailQuery(
  variables?: WeeklyLeaderboardMeetingDetailQueryVariables
) {
  return {
    query: WeeklyLeaderboardMeetingDetailDocument,
    variables: variables,
  };
}
export const ActivityByUserDocument = gql`
  query ActivityByUser(
    $where: event_bool_exp!
    $where2: opportunity_bool_exp!
    $where3: task_effort_engagement_mapping_bool_exp!
  ) {
    teams(where: { is_deleted: { _eq: false } }) {
      to_members {
        team_id
        to_users {
          id
          email
          avatarUrl
          crm_users {
            id
            name
            revtron_users {
              revtron_team {
                to_teams {
                  team_name: name
                  team_type: type
                }
              }
            }
            meeting_creation(where: $where) {
              id
              ownerid
              subject
              description
              type
              eventsubtype
              createddate
              activitydatetime
              enddatetime
            }
            opp_creation(where: $where2) {
              id
              ownerid
              createdbyid
              name
              stagename
              type
              leadsource
              createddate
              closedate
              amount
            }
            to_effort_engagement_aggregate(where: $where3) {
              accountsTouched: aggregate {
                count(columns: accountid, distinct: true)
              }
              contactsTouched: aggregate {
                count(columns: whoid, distinct: true)
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useActivityByUserQuery__
 *
 * To run a query within a React component, call `useActivityByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityByUserQuery({
 *   variables: {
 *      where: // value for 'where'
 *      where2: // value for 'where2'
 *      where3: // value for 'where3'
 *   },
 * });
 */
export function useActivityByUserQuery(
  baseOptions: Apollo.QueryHookOptions<
    ActivityByUserQuery,
    ActivityByUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ActivityByUserQuery, ActivityByUserQueryVariables>(
    ActivityByUserDocument,
    options
  );
}
export function useActivityByUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActivityByUserQuery,
    ActivityByUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ActivityByUserQuery, ActivityByUserQueryVariables>(
    ActivityByUserDocument,
    options
  );
}
export type ActivityByUserQueryHookResult = ReturnType<
  typeof useActivityByUserQuery
>;
export type ActivityByUserLazyQueryHookResult = ReturnType<
  typeof useActivityByUserLazyQuery
>;
export type ActivityByUserQueryResult = Apollo.QueryResult<
  ActivityByUserQuery,
  ActivityByUserQueryVariables
>;
export function refetchActivityByUserQuery(
  variables: ActivityByUserQueryVariables
) {
  return { query: ActivityByUserDocument, variables: variables };
}
export const CalendarCleanDocument = gql`
  query CalendarClean(
    $offset: Int
    $limit: Int
    $where: calendar_gql_clean_bool_exp!
  ) {
    calendar_gql_clean(offset: $offset, limit: $limit, where: $where) {
      account_name
      amount
      enddatetime
      meeting_key
      meeting_owner
      meeting_owner_id
      opportunity_name
      probability
      stagename
      startdatetime
      subject
    }
    calendar_gql_clean_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

/**
 * __useCalendarCleanQuery__
 *
 * To run a query within a React component, call `useCalendarCleanQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarCleanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarCleanQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCalendarCleanQuery(
  baseOptions: Apollo.QueryHookOptions<
    CalendarCleanQuery,
    CalendarCleanQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CalendarCleanQuery, CalendarCleanQueryVariables>(
    CalendarCleanDocument,
    options
  );
}
export function useCalendarCleanLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CalendarCleanQuery,
    CalendarCleanQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CalendarCleanQuery, CalendarCleanQueryVariables>(
    CalendarCleanDocument,
    options
  );
}
export type CalendarCleanQueryHookResult = ReturnType<
  typeof useCalendarCleanQuery
>;
export type CalendarCleanLazyQueryHookResult = ReturnType<
  typeof useCalendarCleanLazyQuery
>;
export type CalendarCleanQueryResult = Apollo.QueryResult<
  CalendarCleanQuery,
  CalendarCleanQueryVariables
>;
export function refetchCalendarCleanQuery(
  variables: CalendarCleanQueryVariables
) {
  return { query: CalendarCleanDocument, variables: variables };
}
export const CalendarStageNameDocument = gql`
  query CalendarStageName {
    calendar_stagename_gql {
      stagename
    }
  }
`;

/**
 * __useCalendarStageNameQuery__
 *
 * To run a query within a React component, call `useCalendarStageNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarStageNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarStageNameQuery({
 *   variables: {
 *   },
 * });
 */
export function useCalendarStageNameQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CalendarStageNameQuery,
    CalendarStageNameQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CalendarStageNameQuery,
    CalendarStageNameQueryVariables
  >(CalendarStageNameDocument, options);
}
export function useCalendarStageNameLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CalendarStageNameQuery,
    CalendarStageNameQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CalendarStageNameQuery,
    CalendarStageNameQueryVariables
  >(CalendarStageNameDocument, options);
}
export type CalendarStageNameQueryHookResult = ReturnType<
  typeof useCalendarStageNameQuery
>;
export type CalendarStageNameLazyQueryHookResult = ReturnType<
  typeof useCalendarStageNameLazyQuery
>;
export type CalendarStageNameQueryResult = Apollo.QueryResult<
  CalendarStageNameQuery,
  CalendarStageNameQueryVariables
>;
export function refetchCalendarStageNameQuery(
  variables?: CalendarStageNameQueryVariables
) {
  return { query: CalendarStageNameDocument, variables: variables };
}
export const CalendarMeetingOwnerDocument = gql`
  query CalendarMeetingOwner {
    calendar_meeting_owner_gql {
      meeting_owner
    }
  }
`;

/**
 * __useCalendarMeetingOwnerQuery__
 *
 * To run a query within a React component, call `useCalendarMeetingOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarMeetingOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarMeetingOwnerQuery({
 *   variables: {
 *   },
 * });
 */
export function useCalendarMeetingOwnerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CalendarMeetingOwnerQuery,
    CalendarMeetingOwnerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CalendarMeetingOwnerQuery,
    CalendarMeetingOwnerQueryVariables
  >(CalendarMeetingOwnerDocument, options);
}
export function useCalendarMeetingOwnerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CalendarMeetingOwnerQuery,
    CalendarMeetingOwnerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CalendarMeetingOwnerQuery,
    CalendarMeetingOwnerQueryVariables
  >(CalendarMeetingOwnerDocument, options);
}
export type CalendarMeetingOwnerQueryHookResult = ReturnType<
  typeof useCalendarMeetingOwnerQuery
>;
export type CalendarMeetingOwnerLazyQueryHookResult = ReturnType<
  typeof useCalendarMeetingOwnerLazyQuery
>;
export type CalendarMeetingOwnerQueryResult = Apollo.QueryResult<
  CalendarMeetingOwnerQuery,
  CalendarMeetingOwnerQueryVariables
>;
export function refetchCalendarMeetingOwnerQuery(
  variables?: CalendarMeetingOwnerQueryVariables
) {
  return { query: CalendarMeetingOwnerDocument, variables: variables };
}
export const IcpModuleLegacyDocument = gql`
  query IcpModuleLegacy(
    $where: account_bool_exp!
    $orderBy: account_order_by!
    $limit: Int!
  ) {
    account(where: $where, order_by: [$orderBy], limit: $limit) {
      id
      name
      website
      billingcity
      billingstate
      billingcountry
      annualrevenue
      numberofemployees
      to_revtron {
        to_revtron_company {
          ID
          NAME
          INFORMALNAME
          WEBSITE
          DOMAIN
          LINKEDIN
          FOUNDINGYEAR
          SUB_INDUSTRY_CATEGORY_NAME
          MOST_RECENT_EMPLOYEE_COUNT
          CITY
          STATE
          COUNTRY
          COMPANYTYPE
          PARENTCOMPANY
          SPECIALTIES
        }
      }
      account_module_static {
        predct_proba
      }
    }
  }
`;

/**
 * __useIcpModuleLegacyQuery__
 *
 * To run a query within a React component, call `useIcpModuleLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useIcpModuleLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIcpModuleLegacyQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useIcpModuleLegacyQuery(
  baseOptions: Apollo.QueryHookOptions<
    IcpModuleLegacyQuery,
    IcpModuleLegacyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IcpModuleLegacyQuery, IcpModuleLegacyQueryVariables>(
    IcpModuleLegacyDocument,
    options
  );
}
export function useIcpModuleLegacyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IcpModuleLegacyQuery,
    IcpModuleLegacyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    IcpModuleLegacyQuery,
    IcpModuleLegacyQueryVariables
  >(IcpModuleLegacyDocument, options);
}
export type IcpModuleLegacyQueryHookResult = ReturnType<
  typeof useIcpModuleLegacyQuery
>;
export type IcpModuleLegacyLazyQueryHookResult = ReturnType<
  typeof useIcpModuleLegacyLazyQuery
>;
export type IcpModuleLegacyQueryResult = Apollo.QueryResult<
  IcpModuleLegacyQuery,
  IcpModuleLegacyQueryVariables
>;
export function refetchIcpModuleLegacyQuery(
  variables: IcpModuleLegacyQueryVariables
) {
  return { query: IcpModuleLegacyDocument, variables: variables };
}
export const IcpModuleDocument = gql`
  query IcpModule(
    $where: Account_bool_exp!
    $orderBy: Account_order_by!
    $limit: Int!
  ) {
    Account(where: $where, order_by: [$orderBy], limit: $limit) {
      Id
      Name
      Website
      AnnualRevenue
      NumberOfEmployees
      to_revtron {
        revtron_id
        to_revtron_companies {
          ..._revtron_companiesFragment
        }
      }
      account_module_static {
        predict_proba: predct_proba
      }
    }
  }
  ${_revtron_companiesFragmentFragmentDoc}
`;

/**
 * __useIcpModuleQuery__
 *
 * To run a query within a React component, call `useIcpModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useIcpModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIcpModuleQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useIcpModuleQuery(
  baseOptions: Apollo.QueryHookOptions<IcpModuleQuery, IcpModuleQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IcpModuleQuery, IcpModuleQueryVariables>(
    IcpModuleDocument,
    options
  );
}
export function useIcpModuleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IcpModuleQuery,
    IcpModuleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IcpModuleQuery, IcpModuleQueryVariables>(
    IcpModuleDocument,
    options
  );
}
export type IcpModuleQueryHookResult = ReturnType<typeof useIcpModuleQuery>;
export type IcpModuleLazyQueryHookResult = ReturnType<
  typeof useIcpModuleLazyQuery
>;
export type IcpModuleQueryResult = Apollo.QueryResult<
  IcpModuleQuery,
  IcpModuleQueryVariables
>;
export function refetchIcpModuleQuery(variables: IcpModuleQueryVariables) {
  return { query: IcpModuleDocument, variables: variables };
}
export const AccountRecModuleDocument = gql`
  query AccountRecModule(
    $where: ml_icp_last_prediction_bool_exp!
    $orderBy: ml_icp_last_prediction_order_by!
    $limit: Int
    $offset: Int
  ) {
    accountsRec: ml_icp_last_prediction(
      where: $where
      order_by: [$orderBy]
      limit: $limit
      offset: $offset
    ) {
      crm_id
      predict_proba
      revtron_id
      to_revtron_companies {
        name
        natural_name
        website
        phone
        type
        ticker
        founded_year
        address
        city
        state
        zip_code
        country
        employee_counts
        revenue
        linkedin
        naics
        industry
        sub_industry
        tags
      }
    }
    totalRecords: ml_icp_last_prediction_aggregate(where: $where) {
      aggregate {
        count(columns: revtron_id, distinct: true)
      }
    }
  }
`;

/**
 * __useAccountRecModuleQuery__
 *
 * To run a query within a React component, call `useAccountRecModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountRecModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountRecModuleQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useAccountRecModuleQuery(
  baseOptions: Apollo.QueryHookOptions<
    AccountRecModuleQuery,
    AccountRecModuleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AccountRecModuleQuery, AccountRecModuleQueryVariables>(
    AccountRecModuleDocument,
    options
  );
}
export function useAccountRecModuleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccountRecModuleQuery,
    AccountRecModuleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AccountRecModuleQuery,
    AccountRecModuleQueryVariables
  >(AccountRecModuleDocument, options);
}
export type AccountRecModuleQueryHookResult = ReturnType<
  typeof useAccountRecModuleQuery
>;
export type AccountRecModuleLazyQueryHookResult = ReturnType<
  typeof useAccountRecModuleLazyQuery
>;
export type AccountRecModuleQueryResult = Apollo.QueryResult<
  AccountRecModuleQuery,
  AccountRecModuleQueryVariables
>;
export function refetchAccountRecModuleQuery(
  variables: AccountRecModuleQueryVariables
) {
  return { query: AccountRecModuleDocument, variables: variables };
}
export const LoggedinUserDocument = gql`
  query LoggedinUser($userId: uuid!) {
    user(id: $userId) {
      revtron_user_id: id
      crm_users {
        id
      }
    }
  }
`;

/**
 * __useLoggedinUserQuery__
 *
 * To run a query within a React component, call `useLoggedinUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoggedinUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoggedinUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useLoggedinUserQuery(
  baseOptions: Apollo.QueryHookOptions<
    LoggedinUserQuery,
    LoggedinUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LoggedinUserQuery, LoggedinUserQueryVariables>(
    LoggedinUserDocument,
    options
  );
}
export function useLoggedinUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoggedinUserQuery,
    LoggedinUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LoggedinUserQuery, LoggedinUserQueryVariables>(
    LoggedinUserDocument,
    options
  );
}
export type LoggedinUserQueryHookResult = ReturnType<
  typeof useLoggedinUserQuery
>;
export type LoggedinUserLazyQueryHookResult = ReturnType<
  typeof useLoggedinUserLazyQuery
>;
export type LoggedinUserQueryResult = Apollo.QueryResult<
  LoggedinUserQuery,
  LoggedinUserQueryVariables
>;
export function refetchLoggedinUserQuery(
  variables: LoggedinUserQueryVariables
) {
  return { query: LoggedinUserDocument, variables: variables };
}
export const SendDataToCrmEventsDocument = gql`
  mutation SendDataToCrmEvents(
    $crmEventsData: [send_to_crm_events_insert_input!]!
  ) {
    insert_send_to_crm_events(objects: $crmEventsData) {
      returning {
        id
        revtron_user_id
        revtron_company_id
        crm_user_id
        records
      }
    }
  }
`;
export type SendDataToCrmEventsMutationFn = Apollo.MutationFunction<
  SendDataToCrmEventsMutation,
  SendDataToCrmEventsMutationVariables
>;

/**
 * __useSendDataToCrmEventsMutation__
 *
 * To run a mutation, you first call `useSendDataToCrmEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDataToCrmEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDataToCrmEventsMutation, { data, loading, error }] = useSendDataToCrmEventsMutation({
 *   variables: {
 *      crmEventsData: // value for 'crmEventsData'
 *   },
 * });
 */
export function useSendDataToCrmEventsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendDataToCrmEventsMutation,
    SendDataToCrmEventsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendDataToCrmEventsMutation,
    SendDataToCrmEventsMutationVariables
  >(SendDataToCrmEventsDocument, options);
}
export type SendDataToCrmEventsMutationHookResult = ReturnType<
  typeof useSendDataToCrmEventsMutation
>;
export type SendDataToCrmEventsMutationResult =
  Apollo.MutationResult<SendDataToCrmEventsMutation>;
export type SendDataToCrmEventsMutationOptions = Apollo.BaseMutationOptions<
  SendDataToCrmEventsMutation,
  SendDataToCrmEventsMutationVariables
>;
export const MonthlyBookingsDocument = gql`
  query MonthlyBookings {
    monthly_bookings_gql {
      date_trunc
      sum
    }
  }
`;

/**
 * __useMonthlyBookingsQuery__
 *
 * To run a query within a React component, call `useMonthlyBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonthlyBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonthlyBookingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMonthlyBookingsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MonthlyBookingsQuery,
    MonthlyBookingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MonthlyBookingsQuery, MonthlyBookingsQueryVariables>(
    MonthlyBookingsDocument,
    options
  );
}
export function useMonthlyBookingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MonthlyBookingsQuery,
    MonthlyBookingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MonthlyBookingsQuery,
    MonthlyBookingsQueryVariables
  >(MonthlyBookingsDocument, options);
}
export type MonthlyBookingsQueryHookResult = ReturnType<
  typeof useMonthlyBookingsQuery
>;
export type MonthlyBookingsLazyQueryHookResult = ReturnType<
  typeof useMonthlyBookingsLazyQuery
>;
export type MonthlyBookingsQueryResult = Apollo.QueryResult<
  MonthlyBookingsQuery,
  MonthlyBookingsQueryVariables
>;
export function refetchMonthlyBookingsQuery(
  variables?: MonthlyBookingsQueryVariables
) {
  return { query: MonthlyBookingsDocument, variables: variables };
}
export const BookingsByOwnerDocument = gql`
  query BookingsByOwner {
    bookings_by_owner_gql {
      bookings
      team_member
      userid
      photo_url
    }
  }
`;

/**
 * __useBookingsByOwnerQuery__
 *
 * To run a query within a React component, call `useBookingsByOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingsByOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingsByOwnerQuery({
 *   variables: {
 *   },
 * });
 */
export function useBookingsByOwnerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingsByOwnerQuery,
    BookingsByOwnerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BookingsByOwnerQuery, BookingsByOwnerQueryVariables>(
    BookingsByOwnerDocument,
    options
  );
}
export function useBookingsByOwnerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingsByOwnerQuery,
    BookingsByOwnerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingsByOwnerQuery,
    BookingsByOwnerQueryVariables
  >(BookingsByOwnerDocument, options);
}
export type BookingsByOwnerQueryHookResult = ReturnType<
  typeof useBookingsByOwnerQuery
>;
export type BookingsByOwnerLazyQueryHookResult = ReturnType<
  typeof useBookingsByOwnerLazyQuery
>;
export type BookingsByOwnerQueryResult = Apollo.QueryResult<
  BookingsByOwnerQuery,
  BookingsByOwnerQueryVariables
>;
export function refetchBookingsByOwnerQuery(
  variables?: BookingsByOwnerQueryVariables
) {
  return { query: BookingsByOwnerDocument, variables: variables };
}
export const RunningRevenueDocument = gql`
  query RunningRevenue {
    running_revenue_gql {
      day
      revenue
    }
  }
`;

/**
 * __useRunningRevenueQuery__
 *
 * To run a query within a React component, call `useRunningRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunningRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunningRevenueQuery({
 *   variables: {
 *   },
 * });
 */
export function useRunningRevenueQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RunningRevenueQuery,
    RunningRevenueQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RunningRevenueQuery, RunningRevenueQueryVariables>(
    RunningRevenueDocument,
    options
  );
}
export function useRunningRevenueLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RunningRevenueQuery,
    RunningRevenueQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RunningRevenueQuery, RunningRevenueQueryVariables>(
    RunningRevenueDocument,
    options
  );
}
export type RunningRevenueQueryHookResult = ReturnType<
  typeof useRunningRevenueQuery
>;
export type RunningRevenueLazyQueryHookResult = ReturnType<
  typeof useRunningRevenueLazyQuery
>;
export type RunningRevenueQueryResult = Apollo.QueryResult<
  RunningRevenueQuery,
  RunningRevenueQueryVariables
>;
export function refetchRunningRevenueQuery(
  variables?: RunningRevenueQueryVariables
) {
  return { query: RunningRevenueDocument, variables: variables };
}
export const LeaderboardSummaryDocument = gql`
  query LeaderboardSummary {
    leaderboard_summary_gql_aggregate {
      aggregate {
        count(columns: id)
        sum {
          licenses__c
        }
        avg {
          licenses__c
        }
      }
    }
  }
`;

/**
 * __useLeaderboardSummaryQuery__
 *
 * To run a query within a React component, call `useLeaderboardSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeaderboardSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeaderboardSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useLeaderboardSummaryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    LeaderboardSummaryQuery,
    LeaderboardSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LeaderboardSummaryQuery,
    LeaderboardSummaryQueryVariables
  >(LeaderboardSummaryDocument, options);
}
export function useLeaderboardSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LeaderboardSummaryQuery,
    LeaderboardSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LeaderboardSummaryQuery,
    LeaderboardSummaryQueryVariables
  >(LeaderboardSummaryDocument, options);
}
export type LeaderboardSummaryQueryHookResult = ReturnType<
  typeof useLeaderboardSummaryQuery
>;
export type LeaderboardSummaryLazyQueryHookResult = ReturnType<
  typeof useLeaderboardSummaryLazyQuery
>;
export type LeaderboardSummaryQueryResult = Apollo.QueryResult<
  LeaderboardSummaryQuery,
  LeaderboardSummaryQueryVariables
>;
export function refetchLeaderboardSummaryQuery(
  variables?: LeaderboardSummaryQueryVariables
) {
  return { query: LeaderboardSummaryDocument, variables: variables };
}
export const SalesVeloBreakdownDocument = gql`
  query SalesVeloBreakdown {
    revtron_reporting_sales_velocity_details_gql {
      stat
      type
    }
  }
`;

/**
 * __useSalesVeloBreakdownQuery__
 *
 * To run a query within a React component, call `useSalesVeloBreakdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesVeloBreakdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesVeloBreakdownQuery({
 *   variables: {
 *   },
 * });
 */
export function useSalesVeloBreakdownQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SalesVeloBreakdownQuery,
    SalesVeloBreakdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SalesVeloBreakdownQuery,
    SalesVeloBreakdownQueryVariables
  >(SalesVeloBreakdownDocument, options);
}
export function useSalesVeloBreakdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SalesVeloBreakdownQuery,
    SalesVeloBreakdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SalesVeloBreakdownQuery,
    SalesVeloBreakdownQueryVariables
  >(SalesVeloBreakdownDocument, options);
}
export type SalesVeloBreakdownQueryHookResult = ReturnType<
  typeof useSalesVeloBreakdownQuery
>;
export type SalesVeloBreakdownLazyQueryHookResult = ReturnType<
  typeof useSalesVeloBreakdownLazyQuery
>;
export type SalesVeloBreakdownQueryResult = Apollo.QueryResult<
  SalesVeloBreakdownQuery,
  SalesVeloBreakdownQueryVariables
>;
export function refetchSalesVeloBreakdownQuery(
  variables?: SalesVeloBreakdownQueryVariables
) {
  return { query: SalesVeloBreakdownDocument, variables: variables };
}
export const SalesVelocityDataByOwnerDocument = gql`
  query SalesVelocityDataByOwner(
    $oppWhere: Opportunity_bool_exp!
    $pipelineWhere: Opportunity_bool_exp!
    $netNewAvgWhere: Opportunity_bool_exp!
    $winRateWhere: win_rate_totals_bool_exp!
    $individualWinRateWhere: win_rates_individual_gql_bool_exp!
  ) {
    crm_users(where: { to_opportunity: $oppWhere }) {
      id
      name
      email
      to_opp: to_opportunity(where: $oppWhere) {
        Id
        Name
        Type
        StageName
        ForecastCategoryName
        CloseDate
        CreatedDate
        Amount
        LeadSource
        IsClosed
        IsWon
      }
      revtron_users {
        avatarUrl
        revtron_team {
          to_teams {
            name
            type
          }
        }
      }
      avg: to_opportunity_aggregate(where: $oppWhere) {
        aggregate {
          avg {
            avg_deal_size: Amount
          }
          number_of_wins: count(columns: Id, distinct: true)
        }
        nodes {
          CreatedDate
          CloseDate
          Amount
        }
      }
      pipeline: to_opportunity_aggregate(where: $pipelineWhere) {
        aggregate {
          ninety_day_pipeline: count(columns: Id, distinct: true)
        }
      }
      to_win_rates(where: $individualWinRateWhere) {
        type
        wins
        losses
        total_opps
        win_rate
      }
    }
    ninety_days_pipeline: Opportunity_aggregate(where: $pipelineWhere) {
      aggregate {
        count(columns: Id)
      }
    }
    net_new_avg: Opportunity_aggregate(where: $netNewAvgWhere) {
      aggregate {
        avg {
          Amount
        }
      }
      nodes {
        CreatedDate
        CloseDate
      }
    }
    win_rate: win_rate_totals(where: $winRateWhere) {
      type
      win_rate
    }
  }
`;

/**
 * __useSalesVelocityDataByOwnerQuery__
 *
 * To run a query within a React component, call `useSalesVelocityDataByOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesVelocityDataByOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesVelocityDataByOwnerQuery({
 *   variables: {
 *      oppWhere: // value for 'oppWhere'
 *      pipelineWhere: // value for 'pipelineWhere'
 *      netNewAvgWhere: // value for 'netNewAvgWhere'
 *      winRateWhere: // value for 'winRateWhere'
 *      individualWinRateWhere: // value for 'individualWinRateWhere'
 *   },
 * });
 */
export function useSalesVelocityDataByOwnerQuery(
  baseOptions: Apollo.QueryHookOptions<
    SalesVelocityDataByOwnerQuery,
    SalesVelocityDataByOwnerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SalesVelocityDataByOwnerQuery,
    SalesVelocityDataByOwnerQueryVariables
  >(SalesVelocityDataByOwnerDocument, options);
}
export function useSalesVelocityDataByOwnerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SalesVelocityDataByOwnerQuery,
    SalesVelocityDataByOwnerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SalesVelocityDataByOwnerQuery,
    SalesVelocityDataByOwnerQueryVariables
  >(SalesVelocityDataByOwnerDocument, options);
}
export type SalesVelocityDataByOwnerQueryHookResult = ReturnType<
  typeof useSalesVelocityDataByOwnerQuery
>;
export type SalesVelocityDataByOwnerLazyQueryHookResult = ReturnType<
  typeof useSalesVelocityDataByOwnerLazyQuery
>;
export type SalesVelocityDataByOwnerQueryResult = Apollo.QueryResult<
  SalesVelocityDataByOwnerQuery,
  SalesVelocityDataByOwnerQueryVariables
>;
export function refetchSalesVelocityDataByOwnerQuery(
  variables: SalesVelocityDataByOwnerQueryVariables
) {
  return { query: SalesVelocityDataByOwnerDocument, variables: variables };
}
export const MonthlyRevenueDocument = gql`
  query MonthlyRevenue {
    running_revenue_gql {
      day
      revenue
    }
  }
`;

/**
 * __useMonthlyRevenueQuery__
 *
 * To run a query within a React component, call `useMonthlyRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonthlyRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonthlyRevenueQuery({
 *   variables: {
 *   },
 * });
 */
export function useMonthlyRevenueQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MonthlyRevenueQuery,
    MonthlyRevenueQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MonthlyRevenueQuery, MonthlyRevenueQueryVariables>(
    MonthlyRevenueDocument,
    options
  );
}
export function useMonthlyRevenueLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MonthlyRevenueQuery,
    MonthlyRevenueQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MonthlyRevenueQuery, MonthlyRevenueQueryVariables>(
    MonthlyRevenueDocument,
    options
  );
}
export type MonthlyRevenueQueryHookResult = ReturnType<
  typeof useMonthlyRevenueQuery
>;
export type MonthlyRevenueLazyQueryHookResult = ReturnType<
  typeof useMonthlyRevenueLazyQuery
>;
export type MonthlyRevenueQueryResult = Apollo.QueryResult<
  MonthlyRevenueQuery,
  MonthlyRevenueQueryVariables
>;
export function refetchMonthlyRevenueQuery(
  variables?: MonthlyRevenueQueryVariables
) {
  return { query: MonthlyRevenueDocument, variables: variables };
}
export const WeeklyEffortNewDocument = gql`
  query WeeklyEffortNew {
    weekly_effort_breakdown_overview_gql {
      count
      date_trunc
      meeting_key
      task_categorization
      type_category
      type_detail
    }
  }
`;

/**
 * __useWeeklyEffortNewQuery__
 *
 * To run a query within a React component, call `useWeeklyEffortNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeeklyEffortNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeeklyEffortNewQuery({
 *   variables: {
 *   },
 * });
 */
export function useWeeklyEffortNewQuery(
  baseOptions?: Apollo.QueryHookOptions<
    WeeklyEffortNewQuery,
    WeeklyEffortNewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WeeklyEffortNewQuery, WeeklyEffortNewQueryVariables>(
    WeeklyEffortNewDocument,
    options
  );
}
export function useWeeklyEffortNewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WeeklyEffortNewQuery,
    WeeklyEffortNewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WeeklyEffortNewQuery,
    WeeklyEffortNewQueryVariables
  >(WeeklyEffortNewDocument, options);
}
export type WeeklyEffortNewQueryHookResult = ReturnType<
  typeof useWeeklyEffortNewQuery
>;
export type WeeklyEffortNewLazyQueryHookResult = ReturnType<
  typeof useWeeklyEffortNewLazyQuery
>;
export type WeeklyEffortNewQueryResult = Apollo.QueryResult<
  WeeklyEffortNewQuery,
  WeeklyEffortNewQueryVariables
>;
export function refetchWeeklyEffortNewQuery(
  variables?: WeeklyEffortNewQueryVariables
) {
  return { query: WeeklyEffortNewDocument, variables: variables };
}
export const MonthlyEffortNewDocument = gql`
  query MonthlyEffortNew {
    monthly_effort_breakdown_overview_gql {
      count
      date_trunc
      meeting_key
      task_categorization
      type_category
      type_detail
    }
  }
`;

/**
 * __useMonthlyEffortNewQuery__
 *
 * To run a query within a React component, call `useMonthlyEffortNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonthlyEffortNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonthlyEffortNewQuery({
 *   variables: {
 *   },
 * });
 */
export function useMonthlyEffortNewQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MonthlyEffortNewQuery,
    MonthlyEffortNewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MonthlyEffortNewQuery, MonthlyEffortNewQueryVariables>(
    MonthlyEffortNewDocument,
    options
  );
}
export function useMonthlyEffortNewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MonthlyEffortNewQuery,
    MonthlyEffortNewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MonthlyEffortNewQuery,
    MonthlyEffortNewQueryVariables
  >(MonthlyEffortNewDocument, options);
}
export type MonthlyEffortNewQueryHookResult = ReturnType<
  typeof useMonthlyEffortNewQuery
>;
export type MonthlyEffortNewLazyQueryHookResult = ReturnType<
  typeof useMonthlyEffortNewLazyQuery
>;
export type MonthlyEffortNewQueryResult = Apollo.QueryResult<
  MonthlyEffortNewQuery,
  MonthlyEffortNewQueryVariables
>;
export function refetchMonthlyEffortNewQuery(
  variables?: MonthlyEffortNewQueryVariables
) {
  return { query: MonthlyEffortNewDocument, variables: variables };
}
export const WeeklyEngagementNewDocument = gql`
  query WeeklyEngagementNew {
    weekly_engagement_breakdown_overview_gql {
      count
      date_trunc
      meeting_key
      task_categorization
      type_category
      type_detail
    }
  }
`;

/**
 * __useWeeklyEngagementNewQuery__
 *
 * To run a query within a React component, call `useWeeklyEngagementNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeeklyEngagementNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeeklyEngagementNewQuery({
 *   variables: {
 *   },
 * });
 */
export function useWeeklyEngagementNewQuery(
  baseOptions?: Apollo.QueryHookOptions<
    WeeklyEngagementNewQuery,
    WeeklyEngagementNewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    WeeklyEngagementNewQuery,
    WeeklyEngagementNewQueryVariables
  >(WeeklyEngagementNewDocument, options);
}
export function useWeeklyEngagementNewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WeeklyEngagementNewQuery,
    WeeklyEngagementNewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WeeklyEngagementNewQuery,
    WeeklyEngagementNewQueryVariables
  >(WeeklyEngagementNewDocument, options);
}
export type WeeklyEngagementNewQueryHookResult = ReturnType<
  typeof useWeeklyEngagementNewQuery
>;
export type WeeklyEngagementNewLazyQueryHookResult = ReturnType<
  typeof useWeeklyEngagementNewLazyQuery
>;
export type WeeklyEngagementNewQueryResult = Apollo.QueryResult<
  WeeklyEngagementNewQuery,
  WeeklyEngagementNewQueryVariables
>;
export function refetchWeeklyEngagementNewQuery(
  variables?: WeeklyEngagementNewQueryVariables
) {
  return { query: WeeklyEngagementNewDocument, variables: variables };
}
export const MonthlyEngagementNewDocument = gql`
  query MonthlyEngagementNew {
    monthly_engagement_breakdown_overview_gql {
      count
      date_trunc
      meeting_key
      task_categorization
      type_category
      type_detail
    }
  }
`;

/**
 * __useMonthlyEngagementNewQuery__
 *
 * To run a query within a React component, call `useMonthlyEngagementNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonthlyEngagementNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonthlyEngagementNewQuery({
 *   variables: {
 *   },
 * });
 */
export function useMonthlyEngagementNewQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MonthlyEngagementNewQuery,
    MonthlyEngagementNewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MonthlyEngagementNewQuery,
    MonthlyEngagementNewQueryVariables
  >(MonthlyEngagementNewDocument, options);
}
export function useMonthlyEngagementNewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MonthlyEngagementNewQuery,
    MonthlyEngagementNewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MonthlyEngagementNewQuery,
    MonthlyEngagementNewQueryVariables
  >(MonthlyEngagementNewDocument, options);
}
export type MonthlyEngagementNewQueryHookResult = ReturnType<
  typeof useMonthlyEngagementNewQuery
>;
export type MonthlyEngagementNewLazyQueryHookResult = ReturnType<
  typeof useMonthlyEngagementNewLazyQuery
>;
export type MonthlyEngagementNewQueryResult = Apollo.QueryResult<
  MonthlyEngagementNewQuery,
  MonthlyEngagementNewQueryVariables
>;
export function refetchMonthlyEngagementNewQuery(
  variables?: MonthlyEngagementNewQueryVariables
) {
  return { query: MonthlyEngagementNewDocument, variables: variables };
}
export const MonthlyPipelineDocument = gql`
  query MonthlyPipeline {
    monthly_pipeline_gql_new {
      amount
      date_trunc
      lead_source
      opportunity_id
      opportunity_name
      owner_name
      stagename
    }
  }
`;

/**
 * __useMonthlyPipelineQuery__
 *
 * To run a query within a React component, call `useMonthlyPipelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonthlyPipelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonthlyPipelineQuery({
 *   variables: {
 *   },
 * });
 */
export function useMonthlyPipelineQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MonthlyPipelineQuery,
    MonthlyPipelineQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MonthlyPipelineQuery, MonthlyPipelineQueryVariables>(
    MonthlyPipelineDocument,
    options
  );
}
export function useMonthlyPipelineLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MonthlyPipelineQuery,
    MonthlyPipelineQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MonthlyPipelineQuery,
    MonthlyPipelineQueryVariables
  >(MonthlyPipelineDocument, options);
}
export type MonthlyPipelineQueryHookResult = ReturnType<
  typeof useMonthlyPipelineQuery
>;
export type MonthlyPipelineLazyQueryHookResult = ReturnType<
  typeof useMonthlyPipelineLazyQuery
>;
export type MonthlyPipelineQueryResult = Apollo.QueryResult<
  MonthlyPipelineQuery,
  MonthlyPipelineQueryVariables
>;
export function refetchMonthlyPipelineQuery(
  variables?: MonthlyPipelineQueryVariables
) {
  return { query: MonthlyPipelineDocument, variables: variables };
}
export const WeeklyPipelineDocument = gql`
  query WeeklyPipeline {
    weekly_pipeline_gql_new {
      amount
      date_trunc
      lead_source
      opportunity_id
      opportunity_name
      owner_name
      stagename
    }
  }
`;

/**
 * __useWeeklyPipelineQuery__
 *
 * To run a query within a React component, call `useWeeklyPipelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeeklyPipelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeeklyPipelineQuery({
 *   variables: {
 *   },
 * });
 */
export function useWeeklyPipelineQuery(
  baseOptions?: Apollo.QueryHookOptions<
    WeeklyPipelineQuery,
    WeeklyPipelineQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WeeklyPipelineQuery, WeeklyPipelineQueryVariables>(
    WeeklyPipelineDocument,
    options
  );
}
export function useWeeklyPipelineLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WeeklyPipelineQuery,
    WeeklyPipelineQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<WeeklyPipelineQuery, WeeklyPipelineQueryVariables>(
    WeeklyPipelineDocument,
    options
  );
}
export type WeeklyPipelineQueryHookResult = ReturnType<
  typeof useWeeklyPipelineQuery
>;
export type WeeklyPipelineLazyQueryHookResult = ReturnType<
  typeof useWeeklyPipelineLazyQuery
>;
export type WeeklyPipelineQueryResult = Apollo.QueryResult<
  WeeklyPipelineQuery,
  WeeklyPipelineQueryVariables
>;
export function refetchWeeklyPipelineQuery(
  variables?: WeeklyPipelineQueryVariables
) {
  return { query: WeeklyPipelineDocument, variables: variables };
}
export const TofTotalNumbersYoyDocument = gql`
  query TofTotalNumbersYoy {
    revtron_reporting_total_tof_numbers_yoy_gql {
      current_period_opps
      percent_change
      previous_period_count
      type
    }
  }
`;

/**
 * __useTofTotalNumbersYoyQuery__
 *
 * To run a query within a React component, call `useTofTotalNumbersYoyQuery` and pass it any options that fit your needs.
 * When your component renders, `useTofTotalNumbersYoyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTofTotalNumbersYoyQuery({
 *   variables: {
 *   },
 * });
 */
export function useTofTotalNumbersYoyQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TofTotalNumbersYoyQuery,
    TofTotalNumbersYoyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TofTotalNumbersYoyQuery,
    TofTotalNumbersYoyQueryVariables
  >(TofTotalNumbersYoyDocument, options);
}
export function useTofTotalNumbersYoyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TofTotalNumbersYoyQuery,
    TofTotalNumbersYoyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TofTotalNumbersYoyQuery,
    TofTotalNumbersYoyQueryVariables
  >(TofTotalNumbersYoyDocument, options);
}
export type TofTotalNumbersYoyQueryHookResult = ReturnType<
  typeof useTofTotalNumbersYoyQuery
>;
export type TofTotalNumbersYoyLazyQueryHookResult = ReturnType<
  typeof useTofTotalNumbersYoyLazyQuery
>;
export type TofTotalNumbersYoyQueryResult = Apollo.QueryResult<
  TofTotalNumbersYoyQuery,
  TofTotalNumbersYoyQueryVariables
>;
export function refetchTofTotalNumbersYoyQuery(
  variables?: TofTotalNumbersYoyQueryVariables
) {
  return { query: TofTotalNumbersYoyDocument, variables: variables };
}
export const TofNumbersYoyDocument = gql`
  query TofNumbersYoy {
    revtron_reporting_tof_numbers_yoy_gql(
      order_by: { current_period_opps: desc_nulls_last }
    ) {
      current_period_opps
      percent_change
      previous_period_count
      type
    }
  }
`;

/**
 * __useTofNumbersYoyQuery__
 *
 * To run a query within a React component, call `useTofNumbersYoyQuery` and pass it any options that fit your needs.
 * When your component renders, `useTofNumbersYoyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTofNumbersYoyQuery({
 *   variables: {
 *   },
 * });
 */
export function useTofNumbersYoyQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TofNumbersYoyQuery,
    TofNumbersYoyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TofNumbersYoyQuery, TofNumbersYoyQueryVariables>(
    TofNumbersYoyDocument,
    options
  );
}
export function useTofNumbersYoyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TofNumbersYoyQuery,
    TofNumbersYoyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TofNumbersYoyQuery, TofNumbersYoyQueryVariables>(
    TofNumbersYoyDocument,
    options
  );
}
export type TofNumbersYoyQueryHookResult = ReturnType<
  typeof useTofNumbersYoyQuery
>;
export type TofNumbersYoyLazyQueryHookResult = ReturnType<
  typeof useTofNumbersYoyLazyQuery
>;
export type TofNumbersYoyQueryResult = Apollo.QueryResult<
  TofNumbersYoyQuery,
  TofNumbersYoyQueryVariables
>;
export function refetchTofNumbersYoyQuery(
  variables?: TofNumbersYoyQueryVariables
) {
  return { query: TofNumbersYoyDocument, variables: variables };
}
export const TotalBookingsYoyDocument = gql`
  query TotalBookingsYoy {
    revtron_reporting_total_bookings_yoy_gql {
      type
      previous_period_revenue
      percent_change
      current_period_revenue
    }
  }
`;

/**
 * __useTotalBookingsYoyQuery__
 *
 * To run a query within a React component, call `useTotalBookingsYoyQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalBookingsYoyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalBookingsYoyQuery({
 *   variables: {
 *   },
 * });
 */
export function useTotalBookingsYoyQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TotalBookingsYoyQuery,
    TotalBookingsYoyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TotalBookingsYoyQuery, TotalBookingsYoyQueryVariables>(
    TotalBookingsYoyDocument,
    options
  );
}
export function useTotalBookingsYoyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TotalBookingsYoyQuery,
    TotalBookingsYoyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TotalBookingsYoyQuery,
    TotalBookingsYoyQueryVariables
  >(TotalBookingsYoyDocument, options);
}
export type TotalBookingsYoyQueryHookResult = ReturnType<
  typeof useTotalBookingsYoyQuery
>;
export type TotalBookingsYoyLazyQueryHookResult = ReturnType<
  typeof useTotalBookingsYoyLazyQuery
>;
export type TotalBookingsYoyQueryResult = Apollo.QueryResult<
  TotalBookingsYoyQuery,
  TotalBookingsYoyQueryVariables
>;
export function refetchTotalBookingsYoyQuery(
  variables?: TotalBookingsYoyQueryVariables
) {
  return { query: TotalBookingsYoyDocument, variables: variables };
}
export const BookingsYoyDocument = gql`
  query BookingsYoy {
    revtron_reporting_bookings_yoy_gql(
      order_by: { current_period_revenue: desc }
    ) {
      current_period_revenue
      percent_change
      previous_period_revenue
      type
    }
  }
`;

/**
 * __useBookingsYoyQuery__
 *
 * To run a query within a React component, call `useBookingsYoyQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingsYoyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingsYoyQuery({
 *   variables: {
 *   },
 * });
 */
export function useBookingsYoyQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingsYoyQuery,
    BookingsYoyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BookingsYoyQuery, BookingsYoyQueryVariables>(
    BookingsYoyDocument,
    options
  );
}
export function useBookingsYoyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingsYoyQuery,
    BookingsYoyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BookingsYoyQuery, BookingsYoyQueryVariables>(
    BookingsYoyDocument,
    options
  );
}
export type BookingsYoyQueryHookResult = ReturnType<typeof useBookingsYoyQuery>;
export type BookingsYoyLazyQueryHookResult = ReturnType<
  typeof useBookingsYoyLazyQuery
>;
export type BookingsYoyQueryResult = Apollo.QueryResult<
  BookingsYoyQuery,
  BookingsYoyQueryVariables
>;
export function refetchBookingsYoyQuery(variables?: BookingsYoyQueryVariables) {
  return { query: BookingsYoyDocument, variables: variables };
}
export const OppDetailEngagementAllDocument = gql`
  query OppDetailEngagementAll {
    pipeline_opp_detail_ml_gql {
      account_id
      account_name
      amount
      closedate
      coalesce
      createddate
      email
      forecast_category
      leadsource
      opportunity_id
      opportunity_name
      opportunity_owner
      ownerid
      probability
      stage
      services_amount
      opportunity_age
      opportunity_link
      type
      custom_filter_1
    }
  }
`;

/**
 * __useOppDetailEngagementAllQuery__
 *
 * To run a query within a React component, call `useOppDetailEngagementAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useOppDetailEngagementAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOppDetailEngagementAllQuery({
 *   variables: {
 *   },
 * });
 */
export function useOppDetailEngagementAllQuery(
  baseOptions?: Apollo.QueryHookOptions<
    OppDetailEngagementAllQuery,
    OppDetailEngagementAllQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OppDetailEngagementAllQuery,
    OppDetailEngagementAllQueryVariables
  >(OppDetailEngagementAllDocument, options);
}
export function useOppDetailEngagementAllLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OppDetailEngagementAllQuery,
    OppDetailEngagementAllQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OppDetailEngagementAllQuery,
    OppDetailEngagementAllQueryVariables
  >(OppDetailEngagementAllDocument, options);
}
export type OppDetailEngagementAllQueryHookResult = ReturnType<
  typeof useOppDetailEngagementAllQuery
>;
export type OppDetailEngagementAllLazyQueryHookResult = ReturnType<
  typeof useOppDetailEngagementAllLazyQuery
>;
export type OppDetailEngagementAllQueryResult = Apollo.QueryResult<
  OppDetailEngagementAllQuery,
  OppDetailEngagementAllQueryVariables
>;
export function refetchOppDetailEngagementAllQuery(
  variables?: OppDetailEngagementAllQueryVariables
) {
  return { query: OppDetailEngagementAllDocument, variables: variables };
}
export const OppDetailEngagementFilterDocument = gql`
  query OppDetailEngagementFilter(
    $where: pipeline_opp_detail_ml_gql_bool_exp!
  ) {
    pipeline_opp_detail_ml_gql(
      where: $where
      order_by: { coalesce: desc_nulls_last }
    ) {
      account_id
      account_name
      amount
      closedate
      coalesce
      createddate
      email
      forecast_category
      leadsource
      opportunity_id
      opportunity_name
      opportunity_owner
      ownerid
      probability
      stage
      services_amount
      opportunity_age
      opportunity_link
      type
    }
  }
`;

/**
 * __useOppDetailEngagementFilterQuery__
 *
 * To run a query within a React component, call `useOppDetailEngagementFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useOppDetailEngagementFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOppDetailEngagementFilterQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOppDetailEngagementFilterQuery(
  baseOptions: Apollo.QueryHookOptions<
    OppDetailEngagementFilterQuery,
    OppDetailEngagementFilterQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OppDetailEngagementFilterQuery,
    OppDetailEngagementFilterQueryVariables
  >(OppDetailEngagementFilterDocument, options);
}
export function useOppDetailEngagementFilterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OppDetailEngagementFilterQuery,
    OppDetailEngagementFilterQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OppDetailEngagementFilterQuery,
    OppDetailEngagementFilterQueryVariables
  >(OppDetailEngagementFilterDocument, options);
}
export type OppDetailEngagementFilterQueryHookResult = ReturnType<
  typeof useOppDetailEngagementFilterQuery
>;
export type OppDetailEngagementFilterLazyQueryHookResult = ReturnType<
  typeof useOppDetailEngagementFilterLazyQuery
>;
export type OppDetailEngagementFilterQueryResult = Apollo.QueryResult<
  OppDetailEngagementFilterQuery,
  OppDetailEngagementFilterQueryVariables
>;
export function refetchOppDetailEngagementFilterQuery(
  variables: OppDetailEngagementFilterQueryVariables
) {
  return { query: OppDetailEngagementFilterDocument, variables: variables };
}
export const PipelineActivityDrillDownDocument = gql`
  query PipelineActivityDrillDown($account_id: [String!]) {
    pipeline_activity_drill_down_gql(
      where: { account_id: { _in: $account_id } }
    ) {
      account_id
      account_name
      contact_id
      contact_name
      contact_title
      createddate
      description
      subject
      task_id
      tasksubtype
      type
      user_name
    }
  }
`;

/**
 * __usePipelineActivityDrillDownQuery__
 *
 * To run a query within a React component, call `usePipelineActivityDrillDownQuery` and pass it any options that fit your needs.
 * When your component renders, `usePipelineActivityDrillDownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePipelineActivityDrillDownQuery({
 *   variables: {
 *      account_id: // value for 'account_id'
 *   },
 * });
 */
export function usePipelineActivityDrillDownQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PipelineActivityDrillDownQuery,
    PipelineActivityDrillDownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PipelineActivityDrillDownQuery,
    PipelineActivityDrillDownQueryVariables
  >(PipelineActivityDrillDownDocument, options);
}
export function usePipelineActivityDrillDownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PipelineActivityDrillDownQuery,
    PipelineActivityDrillDownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PipelineActivityDrillDownQuery,
    PipelineActivityDrillDownQueryVariables
  >(PipelineActivityDrillDownDocument, options);
}
export type PipelineActivityDrillDownQueryHookResult = ReturnType<
  typeof usePipelineActivityDrillDownQuery
>;
export type PipelineActivityDrillDownLazyQueryHookResult = ReturnType<
  typeof usePipelineActivityDrillDownLazyQuery
>;
export type PipelineActivityDrillDownQueryResult = Apollo.QueryResult<
  PipelineActivityDrillDownQuery,
  PipelineActivityDrillDownQueryVariables
>;
export function refetchPipelineActivityDrillDownQuery(
  variables?: PipelineActivityDrillDownQueryVariables
) {
  return { query: PipelineActivityDrillDownDocument, variables: variables };
}
export const BookedAggregateDocument = gql`
  query BookedAggregate($where: pipeline_opp_detail_ml_gql_bool_exp!) {
    pipeline_opp_detail_ml_gql_aggregate(where: $where) {
      aggregate {
        sum {
          amount
          services_amount
        }
        count
      }
    }
  }
`;

/**
 * __useBookedAggregateQuery__
 *
 * To run a query within a React component, call `useBookedAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookedAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookedAggregateQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useBookedAggregateQuery(
  baseOptions: Apollo.QueryHookOptions<
    BookedAggregateQuery,
    BookedAggregateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BookedAggregateQuery, BookedAggregateQueryVariables>(
    BookedAggregateDocument,
    options
  );
}
export function useBookedAggregateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookedAggregateQuery,
    BookedAggregateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookedAggregateQuery,
    BookedAggregateQueryVariables
  >(BookedAggregateDocument, options);
}
export type BookedAggregateQueryHookResult = ReturnType<
  typeof useBookedAggregateQuery
>;
export type BookedAggregateLazyQueryHookResult = ReturnType<
  typeof useBookedAggregateLazyQuery
>;
export type BookedAggregateQueryResult = Apollo.QueryResult<
  BookedAggregateQuery,
  BookedAggregateQueryVariables
>;
export function refetchBookedAggregateQuery(
  variables: BookedAggregateQueryVariables
) {
  return { query: BookedAggregateDocument, variables: variables };
}
export const PipeAggregateDocument = gql`
  query PipeAggregate($where: pipeline_opp_detail_ml_gql_bool_exp!) {
    pipeline_opp_detail_ml_gql_aggregate(where: $where) {
      aggregate {
        sum {
          amount
          services_amount
        }
        count
      }
    }
  }
`;

/**
 * __usePipeAggregateQuery__
 *
 * To run a query within a React component, call `usePipeAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePipeAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePipeAggregateQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePipeAggregateQuery(
  baseOptions: Apollo.QueryHookOptions<
    PipeAggregateQuery,
    PipeAggregateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PipeAggregateQuery, PipeAggregateQueryVariables>(
    PipeAggregateDocument,
    options
  );
}
export function usePipeAggregateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PipeAggregateQuery,
    PipeAggregateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PipeAggregateQuery, PipeAggregateQueryVariables>(
    PipeAggregateDocument,
    options
  );
}
export type PipeAggregateQueryHookResult = ReturnType<
  typeof usePipeAggregateQuery
>;
export type PipeAggregateLazyQueryHookResult = ReturnType<
  typeof usePipeAggregateLazyQuery
>;
export type PipeAggregateQueryResult = Apollo.QueryResult<
  PipeAggregateQuery,
  PipeAggregateQueryVariables
>;
export function refetchPipeAggregateQuery(
  variables: PipeAggregateQueryVariables
) {
  return { query: PipeAggregateDocument, variables: variables };
}
export const WeightedAggregateDocument = gql`
  query WeightedAggregate($where: weighted_pipeline_ml_gql_bool_exp!) {
    weighted_pipeline_ml_gql_aggregate(where: $where) {
      aggregate {
        sum {
          weighted_arr
          ml_weighted_arr
        }
      }
    }
  }
`;

/**
 * __useWeightedAggregateQuery__
 *
 * To run a query within a React component, call `useWeightedAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeightedAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeightedAggregateQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useWeightedAggregateQuery(
  baseOptions: Apollo.QueryHookOptions<
    WeightedAggregateQuery,
    WeightedAggregateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    WeightedAggregateQuery,
    WeightedAggregateQueryVariables
  >(WeightedAggregateDocument, options);
}
export function useWeightedAggregateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WeightedAggregateQuery,
    WeightedAggregateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WeightedAggregateQuery,
    WeightedAggregateQueryVariables
  >(WeightedAggregateDocument, options);
}
export type WeightedAggregateQueryHookResult = ReturnType<
  typeof useWeightedAggregateQuery
>;
export type WeightedAggregateLazyQueryHookResult = ReturnType<
  typeof useWeightedAggregateLazyQuery
>;
export type WeightedAggregateQueryResult = Apollo.QueryResult<
  WeightedAggregateQuery,
  WeightedAggregateQueryVariables
>;
export function refetchWeightedAggregateQuery(
  variables: WeightedAggregateQueryVariables
) {
  return { query: WeightedAggregateDocument, variables: variables };
}
export const UpdateUserDocument = gql`
  mutation UpdateUser($id: uuid!, $displayName: String!, $metadata: jsonb) {
    updateUser(
      pk_columns: { id: $id }
      _set: { displayName: $displayName, metadata: $metadata }
    ) {
      id
      displayName
      metadata
    }
  }
`;
export type UpdateUserMutationFn = Apollo.MutationFunction<
  UpdateUserMutation,
  UpdateUserMutationVariables
>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      displayName: // value for 'displayName'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useUpdateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserMutation,
    UpdateUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(
    UpdateUserDocument,
    options
  );
}
export type UpdateUserMutationHookResult = ReturnType<
  typeof useUpdateUserMutation
>;
export type UpdateUserMutationResult =
  Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserMutation,
  UpdateUserMutationVariables
>;
export const UpdateUserAvatarDocument = gql`
  mutation UpdateUserAvatar($id: uuid!, $avatarUrl: String = "") {
    updateUser(pk_columns: { id: $id }, _set: { avatarUrl: $avatarUrl }) {
      id
      avatarUrl
    }
  }
`;
export type UpdateUserAvatarMutationFn = Apollo.MutationFunction<
  UpdateUserAvatarMutation,
  UpdateUserAvatarMutationVariables
>;

/**
 * __useUpdateUserAvatarMutation__
 *
 * To run a mutation, you first call `useUpdateUserAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAvatarMutation, { data, loading, error }] = useUpdateUserAvatarMutation({
 *   variables: {
 *      id: // value for 'id'
 *      avatarUrl: // value for 'avatarUrl'
 *   },
 * });
 */
export function useUpdateUserAvatarMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserAvatarMutation,
    UpdateUserAvatarMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateUserAvatarMutation,
    UpdateUserAvatarMutationVariables
  >(UpdateUserAvatarDocument, options);
}
export type UpdateUserAvatarMutationHookResult = ReturnType<
  typeof useUpdateUserAvatarMutation
>;
export type UpdateUserAvatarMutationResult =
  Apollo.MutationResult<UpdateUserAvatarMutation>;
export type UpdateUserAvatarMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserAvatarMutation,
  UpdateUserAvatarMutationVariables
>;
export const ProspectorModuleDocument = gql`
  query ProspectorModule(
    $where: Account_bool_exp!
    $orderBy: Account_order_by!
    $limit: Int
    $offset: Int
  ) {
    prospectors: Account(
      where: $where
      order_by: [$orderBy]
      limit: $limit
      offset: $offset
    ) {
      Id
      Name
      Website
      Phone
      Industry
      NumberOfEmployees
      AnnualRevenue
      Type
      Description
      TickerSymbol
      BillingStreet
      BillingCity
      BillingState
      BillingPostalCode
      BillingCountry
      account_module_static {
        predict_proba: predct_proba
      }
    }
    totalRecords: Account_aggregate(where: $where) {
      aggregate {
        count(columns: Id, distinct: true)
      }
    }
  }
`;

/**
 * __useProspectorModuleQuery__
 *
 * To run a query within a React component, call `useProspectorModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectorModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectorModuleQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useProspectorModuleQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProspectorModuleQuery,
    ProspectorModuleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ProspectorModuleQuery, ProspectorModuleQueryVariables>(
    ProspectorModuleDocument,
    options
  );
}
export function useProspectorModuleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProspectorModuleQuery,
    ProspectorModuleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ProspectorModuleQuery,
    ProspectorModuleQueryVariables
  >(ProspectorModuleDocument, options);
}
export type ProspectorModuleQueryHookResult = ReturnType<
  typeof useProspectorModuleQuery
>;
export type ProspectorModuleLazyQueryHookResult = ReturnType<
  typeof useProspectorModuleLazyQuery
>;
export type ProspectorModuleQueryResult = Apollo.QueryResult<
  ProspectorModuleQuery,
  ProspectorModuleQueryVariables
>;
export function refetchProspectorModuleQuery(
  variables: ProspectorModuleQueryVariables
) {
  return { query: ProspectorModuleDocument, variables: variables };
}
export const SavePeopleDataDocument = gql`
  mutation SavePeopleData($people: [pdl_people_data_insert_input!]!) {
    insert_pdl_people_data(
      objects: $people
      on_conflict: {
        constraint: pdl_people_data_pkey
        update_columns: [
          birth_date
          birth_year
          countries
          crm_account_id
          education
          emails
          experience
          facebook_id
          facebook_url
          facebook_username
          first_name
          full_name
          gender
          github_url
          github_username
          id
          industry
          interests
          job_company_facebook_url
          job_company_founded
          job_company_id
          job_company_industry
          job_company_linkedin_id
          job_company_linkedin_url
          job_company_location_address_line_2
          job_company_location_continent
          job_company_location_country
          job_company_location_geo
          job_company_location_locality
          job_company_location_metro
          job_company_location_name
          job_company_location_postal_code
          job_company_location_region
          job_company_location_street_address
          job_company_name
          job_company_size
          job_company_twitter_url
          job_company_website
          job_last_updated
          job_start_date
          job_title
          job_title_levels
          job_title_role
          job_title_sub_role
          last_initial
          last_name
          linkedin_id
          linkedin_url
          linkedin_username
          location_address_line_2
          location_continent
          location_country
          location_geo
          location_last_updated
          location_locality
          location_metro
          location_name
          location_names
          location_postal_code
          location_region
          location_street_address
          middle_initial
          middle_name
          mobile_phone
          personal_emails
          phone_numbers
          profiles
          recommended_personal_email
          regions
          revtron_user_id
          skills
          street_addresses
          twitter_url
          twitter_username
          version_status
          work_email
        ]
      }
    ) {
      returning {
        id
      }
    }
  }
`;
export type SavePeopleDataMutationFn = Apollo.MutationFunction<
  SavePeopleDataMutation,
  SavePeopleDataMutationVariables
>;

/**
 * __useSavePeopleDataMutation__
 *
 * To run a mutation, you first call `useSavePeopleDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePeopleDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePeopleDataMutation, { data, loading, error }] = useSavePeopleDataMutation({
 *   variables: {
 *      people: // value for 'people'
 *   },
 * });
 */
export function useSavePeopleDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SavePeopleDataMutation,
    SavePeopleDataMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SavePeopleDataMutation,
    SavePeopleDataMutationVariables
  >(SavePeopleDataDocument, options);
}
export type SavePeopleDataMutationHookResult = ReturnType<
  typeof useSavePeopleDataMutation
>;
export type SavePeopleDataMutationResult =
  Apollo.MutationResult<SavePeopleDataMutation>;
export type SavePeopleDataMutationOptions = Apollo.BaseMutationOptions<
  SavePeopleDataMutation,
  SavePeopleDataMutationVariables
>;
export const SavePeoplePreviewDataDocument = gql`
  mutation SavePeoplePreviewData($people: [pdl_people_preview_insert_input!]!) {
    insert_pdl_people_preview(
      objects: $people
      on_conflict: {
        constraint: pdl_people_preview_pkey
        update_columns: [
          birth_date
          birth_year
          countries
          crm_account_id
          education
          emails
          experience
          facebook_id
          facebook_url
          facebook_username
          first_name
          full_name
          gender
          github_url
          github_username
          id
          industry
          interests
          job_company_facebook_url
          job_company_founded
          job_company_id
          job_company_industry
          job_company_linkedin_id
          job_company_linkedin_url
          job_company_location_address_line_2
          job_company_location_continent
          job_company_location_country
          job_company_location_geo
          job_company_location_locality
          job_company_location_metro
          job_company_location_name
          job_company_location_postal_code
          job_company_location_region
          job_company_location_street_address
          job_company_name
          job_company_size
          job_company_twitter_url
          job_company_website
          job_last_updated
          job_start_date
          job_title
          job_title_levels
          job_title_role
          job_title_sub_role
          last_initial
          last_name
          linkedin_id
          linkedin_url
          linkedin_username
          location_address_line_2
          location_continent
          location_country
          location_geo
          location_last_updated
          location_locality
          location_metro
          location_name
          location_names
          location_postal_code
          location_region
          location_street_address
          middle_initial
          middle_name
          mobile_phone
          personal_emails
          phone_numbers
          profiles
          regions
          revtron_user_id
          skills
          street_addresses
          twitter_url
          twitter_username
          version_status
          work_email
        ]
      }
    ) {
      returning {
        id
      }
    }
  }
`;
export type SavePeoplePreviewDataMutationFn = Apollo.MutationFunction<
  SavePeoplePreviewDataMutation,
  SavePeoplePreviewDataMutationVariables
>;

/**
 * __useSavePeoplePreviewDataMutation__
 *
 * To run a mutation, you first call `useSavePeoplePreviewDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePeoplePreviewDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePeoplePreviewDataMutation, { data, loading, error }] = useSavePeoplePreviewDataMutation({
 *   variables: {
 *      people: // value for 'people'
 *   },
 * });
 */
export function useSavePeoplePreviewDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SavePeoplePreviewDataMutation,
    SavePeoplePreviewDataMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SavePeoplePreviewDataMutation,
    SavePeoplePreviewDataMutationVariables
  >(SavePeoplePreviewDataDocument, options);
}
export type SavePeoplePreviewDataMutationHookResult = ReturnType<
  typeof useSavePeoplePreviewDataMutation
>;
export type SavePeoplePreviewDataMutationResult =
  Apollo.MutationResult<SavePeoplePreviewDataMutation>;
export type SavePeoplePreviewDataMutationOptions = Apollo.BaseMutationOptions<
  SavePeoplePreviewDataMutation,
  SavePeoplePreviewDataMutationVariables
>;
export const UserListDocument = gql`
  query UserList {
    users(
      where: {
        crm_users: { email: { _is_null: false } }
        disabled: { _eq: false }
      }
    ) {
      avatarUrl
      disabled
      defaultRole
      email
      displayName
      id
      crm_users {
        title
        name
        email
        isactive
      }
    }
  }
`;

/**
 * __useUserListQuery__
 *
 * To run a query within a React component, call `useUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserListQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserListQuery(
  baseOptions?: Apollo.QueryHookOptions<UserListQuery, UserListQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserListQuery, UserListQueryVariables>(
    UserListDocument,
    options
  );
}
export function useUserListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserListQuery,
    UserListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserListQuery, UserListQueryVariables>(
    UserListDocument,
    options
  );
}
export type UserListQueryHookResult = ReturnType<typeof useUserListQuery>;
export type UserListLazyQueryHookResult = ReturnType<
  typeof useUserListLazyQuery
>;
export type UserListQueryResult = Apollo.QueryResult<
  UserListQuery,
  UserListQueryVariables
>;
export function refetchUserListQuery(variables?: UserListQueryVariables) {
  return { query: UserListDocument, variables: variables };
}
export const TeamListDocument = gql`
  subscription TeamList {
    teams(where: { is_deleted: { _eq: false } }) {
      id
      name
      type
      opportunity_target
      email_target
      call_target
      social_target
      to_members {
        user_id
        to_users {
          displayName
          avatarUrl
        }
        id
      }
    }
  }
`;

/**
 * __useTeamListSubscription__
 *
 * To run a query within a React component, call `useTeamListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTeamListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamListSubscription({
 *   variables: {
 *   },
 * });
 */
export function useTeamListSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    TeamListSubscription,
    TeamListSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    TeamListSubscription,
    TeamListSubscriptionVariables
  >(TeamListDocument, options);
}
export type TeamListSubscriptionHookResult = ReturnType<
  typeof useTeamListSubscription
>;
export type TeamListSubscriptionResult =
  Apollo.SubscriptionResult<TeamListSubscription>;
export const CreateTeamDocument = gql`
  mutation CreateTeam(
    $name: String = ""
    $type: String = ""
    $opportunity_target: bigint = ""
    $email_target: bigint = ""
    $call_target: bigint = ""
    $social_target: bigint = ""
  ) {
    insert_teams(
      objects: {
        call_target: $call_target
        email_target: $email_target
        name: $name
        opportunity_target: $opportunity_target
        social_target: $social_target
        type: $type
        is_deleted: false
      }
    ) {
      affected_rows
    }
  }
`;
export type CreateTeamMutationFn = Apollo.MutationFunction<
  CreateTeamMutation,
  CreateTeamMutationVariables
>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      name: // value for 'name'
 *      type: // value for 'type'
 *      opportunity_target: // value for 'opportunity_target'
 *      email_target: // value for 'email_target'
 *      call_target: // value for 'call_target'
 *      social_target: // value for 'social_target'
 *   },
 * });
 */
export function useCreateTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTeamMutation,
    CreateTeamMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(
    CreateTeamDocument,
    options
  );
}
export type CreateTeamMutationHookResult = ReturnType<
  typeof useCreateTeamMutation
>;
export type CreateTeamMutationResult =
  Apollo.MutationResult<CreateTeamMutation>;
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<
  CreateTeamMutation,
  CreateTeamMutationVariables
>;
export const RemoveTeamDocument = gql`
  mutation RemoveTeam($id: bigint = "") {
    update_teams_by_pk(pk_columns: { id: $id }, _set: { is_deleted: true }) {
      is_deleted
    }
  }
`;
export type RemoveTeamMutationFn = Apollo.MutationFunction<
  RemoveTeamMutation,
  RemoveTeamMutationVariables
>;

/**
 * __useRemoveTeamMutation__
 *
 * To run a mutation, you first call `useRemoveTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTeamMutation, { data, loading, error }] = useRemoveTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveTeamMutation,
    RemoveTeamMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveTeamMutation, RemoveTeamMutationVariables>(
    RemoveTeamDocument,
    options
  );
}
export type RemoveTeamMutationHookResult = ReturnType<
  typeof useRemoveTeamMutation
>;
export type RemoveTeamMutationResult =
  Apollo.MutationResult<RemoveTeamMutation>;
export type RemoveTeamMutationOptions = Apollo.BaseMutationOptions<
  RemoveTeamMutation,
  RemoveTeamMutationVariables
>;
export const UpdateTeamDocument = gql`
  mutation UpdateTeam(
    $id: bigint = ""
    $name: String = ""
    $type: String = ""
    $opportunity_target: bigint = ""
    $email_target: bigint = ""
    $call_target: bigint = ""
    $social_target: bigint = ""
  ) {
    update_teams_by_pk(
      pk_columns: { id: $id }
      _set: {
        name: $name
        type: $type
        opportunity_target: $opportunity_target
        email_target: $email_target
        call_target: $call_target
        social_target: $social_target
      }
    ) {
      id
      name
    }
  }
`;
export type UpdateTeamMutationFn = Apollo.MutationFunction<
  UpdateTeamMutation,
  UpdateTeamMutationVariables
>;

/**
 * __useUpdateTeamMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMutation, { data, loading, error }] = useUpdateTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      type: // value for 'type'
 *      opportunity_target: // value for 'opportunity_target'
 *      email_target: // value for 'email_target'
 *      call_target: // value for 'call_target'
 *      social_target: // value for 'social_target'
 *   },
 * });
 */
export function useUpdateTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTeamMutation,
    UpdateTeamMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateTeamMutation, UpdateTeamMutationVariables>(
    UpdateTeamDocument,
    options
  );
}
export type UpdateTeamMutationHookResult = ReturnType<
  typeof useUpdateTeamMutation
>;
export type UpdateTeamMutationResult =
  Apollo.MutationResult<UpdateTeamMutation>;
export type UpdateTeamMutationOptions = Apollo.BaseMutationOptions<
  UpdateTeamMutation,
  UpdateTeamMutationVariables
>;
export const InsertTeamMemberDocument = gql`
  mutation InsertTeamMember($team_id: bigint = "", $user_id: uuid = "") {
    insert_team_members_one(object: { team_id: $team_id, user_id: $user_id }) {
      team_id
      user_id
    }
  }
`;
export type InsertTeamMemberMutationFn = Apollo.MutationFunction<
  InsertTeamMemberMutation,
  InsertTeamMemberMutationVariables
>;

/**
 * __useInsertTeamMemberMutation__
 *
 * To run a mutation, you first call `useInsertTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertTeamMemberMutation, { data, loading, error }] = useInsertTeamMemberMutation({
 *   variables: {
 *      team_id: // value for 'team_id'
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useInsertTeamMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InsertTeamMemberMutation,
    InsertTeamMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    InsertTeamMemberMutation,
    InsertTeamMemberMutationVariables
  >(InsertTeamMemberDocument, options);
}
export type InsertTeamMemberMutationHookResult = ReturnType<
  typeof useInsertTeamMemberMutation
>;
export type InsertTeamMemberMutationResult =
  Apollo.MutationResult<InsertTeamMemberMutation>;
export type InsertTeamMemberMutationOptions = Apollo.BaseMutationOptions<
  InsertTeamMemberMutation,
  InsertTeamMemberMutationVariables
>;
export const RemoveTeamMemberDocument = gql`
  mutation RemoveTeamMember($id: bigint = "") {
    delete_team_members_by_pk(id: $id) {
      id
      user_id
    }
  }
`;
export type RemoveTeamMemberMutationFn = Apollo.MutationFunction<
  RemoveTeamMemberMutation,
  RemoveTeamMemberMutationVariables
>;

/**
 * __useRemoveTeamMemberMutation__
 *
 * To run a mutation, you first call `useRemoveTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTeamMemberMutation, { data, loading, error }] = useRemoveTeamMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveTeamMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveTeamMemberMutation,
    RemoveTeamMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveTeamMemberMutation,
    RemoveTeamMemberMutationVariables
  >(RemoveTeamMemberDocument, options);
}
export type RemoveTeamMemberMutationHookResult = ReturnType<
  typeof useRemoveTeamMemberMutation
>;
export type RemoveTeamMemberMutationResult =
  Apollo.MutationResult<RemoveTeamMemberMutation>;
export type RemoveTeamMemberMutationOptions = Apollo.BaseMutationOptions<
  RemoveTeamMemberMutation,
  RemoveTeamMemberMutationVariables
>;
export const AllCrmUsersDocument = gql`
  subscription AllCrmUsers {
    crm_users(
      where: {
        isactive: { _eq: true }
        revtron_users: { id: { _is_null: false } }
      }
    ) {
      firstname
      lastname
      name
      email
      title
      revtron_users {
        id
        avatarUrl
      }
    }
  }
`;

/**
 * __useAllCrmUsersSubscription__
 *
 * To run a query within a React component, call `useAllCrmUsersSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAllCrmUsersSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCrmUsersSubscription({
 *   variables: {
 *   },
 * });
 */
export function useAllCrmUsersSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    AllCrmUsersSubscription,
    AllCrmUsersSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    AllCrmUsersSubscription,
    AllCrmUsersSubscriptionVariables
  >(AllCrmUsersDocument, options);
}
export type AllCrmUsersSubscriptionHookResult = ReturnType<
  typeof useAllCrmUsersSubscription
>;
export type AllCrmUsersSubscriptionResult =
  Apollo.SubscriptionResult<AllCrmUsersSubscription>;
export const CreateInviteDocument = gql`
  mutation CreateInvite($invitee_email: citext = "", $inviter_id: String = "") {
    insert_invites(
      objects: { invitee_email: $invitee_email, inviter_id: $inviter_id }
    ) {
      returning {
        invitee_email
      }
    }
  }
`;
export type CreateInviteMutationFn = Apollo.MutationFunction<
  CreateInviteMutation,
  CreateInviteMutationVariables
>;

/**
 * __useCreateInviteMutation__
 *
 * To run a mutation, you first call `useCreateInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInviteMutation, { data, loading, error }] = useCreateInviteMutation({
 *   variables: {
 *      invitee_email: // value for 'invitee_email'
 *      inviter_id: // value for 'inviter_id'
 *   },
 * });
 */
export function useCreateInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateInviteMutation,
    CreateInviteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateInviteMutation,
    CreateInviteMutationVariables
  >(CreateInviteDocument, options);
}
export type CreateInviteMutationHookResult = ReturnType<
  typeof useCreateInviteMutation
>;
export type CreateInviteMutationResult =
  Apollo.MutationResult<CreateInviteMutation>;
export type CreateInviteMutationOptions = Apollo.BaseMutationOptions<
  CreateInviteMutation,
  CreateInviteMutationVariables
>;
export const RemoveUserDocument = gql`
  mutation RemoveUser($id: uuid = "") {
    updateUser(pk_columns: { id: $id }, _set: { disabled: true }) {
      disabled
    }
  }
`;
export type RemoveUserMutationFn = Apollo.MutationFunction<
  RemoveUserMutation,
  RemoveUserMutationVariables
>;

/**
 * __useRemoveUserMutation__
 *
 * To run a mutation, you first call `useRemoveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserMutation, { data, loading, error }] = useRemoveUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveUserMutation,
    RemoveUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveUserMutation, RemoveUserMutationVariables>(
    RemoveUserDocument,
    options
  );
}
export type RemoveUserMutationHookResult = ReturnType<
  typeof useRemoveUserMutation
>;
export type RemoveUserMutationResult =
  Apollo.MutationResult<RemoveUserMutation>;
export type RemoveUserMutationOptions = Apollo.BaseMutationOptions<
  RemoveUserMutation,
  RemoveUserMutationVariables
>;
export const CrmAccountFieldsDocument = gql`
  query CrmAccountFields {
    account: __type(name: "Account") {
      fields {
        name
        type {
          name
          kind
        }
      }
    }
    revtronCompanies: __type(name: "revtron_companies") {
      fields {
        name
        type {
          name
          kind
        }
      }
    }
  }
`;

/**
 * __useCrmAccountFieldsQuery__
 *
 * To run a query within a React component, call `useCrmAccountFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmAccountFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmAccountFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCrmAccountFieldsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CrmAccountFieldsQuery,
    CrmAccountFieldsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CrmAccountFieldsQuery, CrmAccountFieldsQueryVariables>(
    CrmAccountFieldsDocument,
    options
  );
}
export function useCrmAccountFieldsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CrmAccountFieldsQuery,
    CrmAccountFieldsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CrmAccountFieldsQuery,
    CrmAccountFieldsQueryVariables
  >(CrmAccountFieldsDocument, options);
}
export type CrmAccountFieldsQueryHookResult = ReturnType<
  typeof useCrmAccountFieldsQuery
>;
export type CrmAccountFieldsLazyQueryHookResult = ReturnType<
  typeof useCrmAccountFieldsLazyQuery
>;
export type CrmAccountFieldsQueryResult = Apollo.QueryResult<
  CrmAccountFieldsQuery,
  CrmAccountFieldsQueryVariables
>;
export function refetchCrmAccountFieldsQuery(
  variables?: CrmAccountFieldsQueryVariables
) {
  return { query: CrmAccountFieldsDocument, variables: variables };
}
export const CrmContactFieldsDocument = gql`
  query CrmContactFields {
    contact: __type(name: "Contact") {
      fields {
        name
        type {
          name
          kind
        }
      }
    }
    pdlPeopleData: __type(name: "pdl_people_data") {
      fields {
        name
        type {
          name
          kind
        }
      }
    }
  }
`;

/**
 * __useCrmContactFieldsQuery__
 *
 * To run a query within a React component, call `useCrmContactFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmContactFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmContactFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCrmContactFieldsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CrmContactFieldsQuery,
    CrmContactFieldsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CrmContactFieldsQuery, CrmContactFieldsQueryVariables>(
    CrmContactFieldsDocument,
    options
  );
}
export function useCrmContactFieldsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CrmContactFieldsQuery,
    CrmContactFieldsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CrmContactFieldsQuery,
    CrmContactFieldsQueryVariables
  >(CrmContactFieldsDocument, options);
}
export type CrmContactFieldsQueryHookResult = ReturnType<
  typeof useCrmContactFieldsQuery
>;
export type CrmContactFieldsLazyQueryHookResult = ReturnType<
  typeof useCrmContactFieldsLazyQuery
>;
export type CrmContactFieldsQueryResult = Apollo.QueryResult<
  CrmContactFieldsQuery,
  CrmContactFieldsQueryVariables
>;
export function refetchCrmContactFieldsQuery(
  variables?: CrmContactFieldsQueryVariables
) {
  return { query: CrmContactFieldsDocument, variables: variables };
}
export const CrmAccountMappingsDocument = gql`
  query CrmAccountMappings {
    crm_account_mappings(order_by: { id: asc }) {
      id
      crm_field
      revtron_field
      is_active
      method
    }
  }
`;

/**
 * __useCrmAccountMappingsQuery__
 *
 * To run a query within a React component, call `useCrmAccountMappingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmAccountMappingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmAccountMappingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCrmAccountMappingsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CrmAccountMappingsQuery,
    CrmAccountMappingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CrmAccountMappingsQuery,
    CrmAccountMappingsQueryVariables
  >(CrmAccountMappingsDocument, options);
}
export function useCrmAccountMappingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CrmAccountMappingsQuery,
    CrmAccountMappingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CrmAccountMappingsQuery,
    CrmAccountMappingsQueryVariables
  >(CrmAccountMappingsDocument, options);
}
export type CrmAccountMappingsQueryHookResult = ReturnType<
  typeof useCrmAccountMappingsQuery
>;
export type CrmAccountMappingsLazyQueryHookResult = ReturnType<
  typeof useCrmAccountMappingsLazyQuery
>;
export type CrmAccountMappingsQueryResult = Apollo.QueryResult<
  CrmAccountMappingsQuery,
  CrmAccountMappingsQueryVariables
>;
export function refetchCrmAccountMappingsQuery(
  variables?: CrmAccountMappingsQueryVariables
) {
  return { query: CrmAccountMappingsDocument, variables: variables };
}
export const CrmContactMappingsDocument = gql`
  query CrmContactMappings {
    crm_contact_mappings(order_by: { id: asc }) {
      id
      crm_field
      revtron_field
      is_active
      method
    }
  }
`;

/**
 * __useCrmContactMappingsQuery__
 *
 * To run a query within a React component, call `useCrmContactMappingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmContactMappingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmContactMappingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCrmContactMappingsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CrmContactMappingsQuery,
    CrmContactMappingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CrmContactMappingsQuery,
    CrmContactMappingsQueryVariables
  >(CrmContactMappingsDocument, options);
}
export function useCrmContactMappingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CrmContactMappingsQuery,
    CrmContactMappingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CrmContactMappingsQuery,
    CrmContactMappingsQueryVariables
  >(CrmContactMappingsDocument, options);
}
export type CrmContactMappingsQueryHookResult = ReturnType<
  typeof useCrmContactMappingsQuery
>;
export type CrmContactMappingsLazyQueryHookResult = ReturnType<
  typeof useCrmContactMappingsLazyQuery
>;
export type CrmContactMappingsQueryResult = Apollo.QueryResult<
  CrmContactMappingsQuery,
  CrmContactMappingsQueryVariables
>;
export function refetchCrmContactMappingsQuery(
  variables?: CrmContactMappingsQueryVariables
) {
  return { query: CrmContactMappingsDocument, variables: variables };
}
export const UpdateAccountMappingsDocument = gql`
  mutation UpdateAccountMappings(
    $mappings: [crm_account_mappings_insert_input!]!
    $removeIds: [bigint!]
  ) {
    insert_crm_account_mappings(
      objects: $mappings
      on_conflict: {
        constraint: crm_account_mappings_pkey
        update_columns: [crm_field, revtron_field, is_active, method]
      }
    ) {
      returning {
        id
        crm_field
        revtron_field
        is_active
        method
      }
    }
    delete_crm_account_mappings(where: { id: { _in: $removeIds } }) {
      affected_rows
    }
  }
`;
export type UpdateAccountMappingsMutationFn = Apollo.MutationFunction<
  UpdateAccountMappingsMutation,
  UpdateAccountMappingsMutationVariables
>;

/**
 * __useUpdateAccountMappingsMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMappingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMappingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountMappingsMutation, { data, loading, error }] = useUpdateAccountMappingsMutation({
 *   variables: {
 *      mappings: // value for 'mappings'
 *      removeIds: // value for 'removeIds'
 *   },
 * });
 */
export function useUpdateAccountMappingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAccountMappingsMutation,
    UpdateAccountMappingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAccountMappingsMutation,
    UpdateAccountMappingsMutationVariables
  >(UpdateAccountMappingsDocument, options);
}
export type UpdateAccountMappingsMutationHookResult = ReturnType<
  typeof useUpdateAccountMappingsMutation
>;
export type UpdateAccountMappingsMutationResult =
  Apollo.MutationResult<UpdateAccountMappingsMutation>;
export type UpdateAccountMappingsMutationOptions = Apollo.BaseMutationOptions<
  UpdateAccountMappingsMutation,
  UpdateAccountMappingsMutationVariables
>;
export const UpdateContactMappingsDocument = gql`
  mutation UpdateContactMappings(
    $mappings: [crm_contact_mappings_insert_input!]!
    $removeIds: [bigint!]
  ) {
    insert_crm_contact_mappings(
      objects: $mappings
      on_conflict: {
        constraint: crm_contact_mappings_pkey
        update_columns: [crm_field, revtron_field, is_active, method]
      }
    ) {
      returning {
        id
        crm_field
        revtron_field
        is_active
        method
      }
    }
    delete_crm_contact_mappings(where: { id: { _in: $removeIds } }) {
      affected_rows
    }
  }
`;
export type UpdateContactMappingsMutationFn = Apollo.MutationFunction<
  UpdateContactMappingsMutation,
  UpdateContactMappingsMutationVariables
>;

/**
 * __useUpdateContactMappingsMutation__
 *
 * To run a mutation, you first call `useUpdateContactMappingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactMappingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactMappingsMutation, { data, loading, error }] = useUpdateContactMappingsMutation({
 *   variables: {
 *      mappings: // value for 'mappings'
 *      removeIds: // value for 'removeIds'
 *   },
 * });
 */
export function useUpdateContactMappingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateContactMappingsMutation,
    UpdateContactMappingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateContactMappingsMutation,
    UpdateContactMappingsMutationVariables
  >(UpdateContactMappingsDocument, options);
}
export type UpdateContactMappingsMutationHookResult = ReturnType<
  typeof useUpdateContactMappingsMutation
>;
export type UpdateContactMappingsMutationResult =
  Apollo.MutationResult<UpdateContactMappingsMutation>;
export type UpdateContactMappingsMutationOptions = Apollo.BaseMutationOptions<
  UpdateContactMappingsMutation,
  UpdateContactMappingsMutationVariables
>;
